const allStandardLegalPokemon = [
  {
    id: "sv10-60",
    name: "Abomasnow",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "Snover",
    attacks: [
      {
        name: "Lunge Out",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
      {
        name: "Frozen Wood",
        cost: ["Water", "Water", "Water", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120+",
        text: "If this Pokémon has 2 or more Grass Energy attached, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "60",
    nationalPokedexNumbers: [460],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/60.png",
      large: "https://images.pokemontcg.io/sv10/60_hires.png",
    },
    altArts: [
      {
        id: "sv10-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv10/60.png",
          large: "https://images.pokemontcg.io/sv10/60_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-54",
    name: "Abra",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    evolvesTo: ["Kadabra"],
    attacks: [
      {
        name: "Teleportation Attack",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "54",
    nationalPokedexNumbers: [63],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/54.png",
      large: "https://images.pokemontcg.io/me1/54_hires.png",
    },
    altArts: [
      {
        id: "me1-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/me1/54.png",
          large: "https://images.pokemontcg.io/me1/54_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-80",
    name: "Abra",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Psychic"],
    evolvesTo: ["Kadabra"],
    abilities: [
      {
        name: "Teleporter",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may shuffle it and all attached cards into your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Beam",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "80",
    flavorText:
      "This Pokémon uses its psychic powers while it sleeps. The contents of Abra's dreams affect the powers that the Pokémon wields.",
    nationalPokedexNumbers: [63],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/80.png",
      large: "https://images.pokemontcg.io/sv6/80_hires.png",
    },
    altArts: [
      {
        id: "sv6-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv6/80.png",
          large: "https://images.pokemontcg.io/sv6/80_hires.png",
        },
        flavorText:
          "This Pokémon uses its psychic powers while it sleeps. The contents of Abra's dreams affect the powers that the Pokémon wields.",
      },
    ],
  },
  {
    id: "me2-63",
    name: "Absol",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Darkness"],
    attacks: [
      {
        name: "Allure",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Dark Cutter",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    flavorText:
      "Because of this Pokémon's ability to detect danger, people mistook Absol as a bringer of doom.",
    nationalPokedexNumbers: [359],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/63.png",
      large: "https://images.pokemontcg.io/me2/63_hires.png",
    },
    altArts: [
      {
        id: "me2-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/me2/63.png",
          large: "https://images.pokemontcg.io/me2/63_hires.png",
        },
        flavorText:
          "Because of this Pokémon's ability to detect danger, people mistook Absol as a bringer of doom.",
      },
    ],
  },
  {
    id: "sv6pt5-30",
    name: "Absol",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Darkness"],
    attacks: [
      {
        name: "Darkfall",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If you have at least 3 Darkness Energy in play, this attack does 50 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "30",
    nationalPokedexNumbers: [359],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/30.png",
      large: "https://images.pokemontcg.io/sv6pt5/30_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/30.png",
          large: "https://images.pokemontcg.io/sv6pt5/30_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-9",
    name: "Accelgor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Shelmet",
    attacks: [
      {
        name: "Acid Spray",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    flavorText:
      "When its body dries out, it weakens. So, to prevent dehydration, it wraps itself in many layers of thin membrane.",
    nationalPokedexNumbers: [617],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/9.png",
      large: "https://images.pokemontcg.io/rsv10pt5/9_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/9.png",
          large: "https://images.pokemontcg.io/rsv10pt5/9_hires.png",
        },
        flavorText:
          "When its body dries out, it weakens. So, to prevent dehydration, it wraps itself in many layers of thin membrane.",
      },
      {
        id: "rsv10pt5-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/94.png",
          large: "https://images.pokemontcg.io/rsv10pt5/94_hires.png",
        },
        flavorText:
          "When its body dries out, it weakens. So, to prevent dehydration, it wraps itself in many layers of thin membrane.",
      },
    ],
  },
  {
    id: "sv9-13",
    name: "Accelgor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Shelmet",
    attacks: [
      {
        name: "Poisonous Ploy",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "Your opponent's Active Pokémon is now Confused and Poisoned. Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "13",
    nationalPokedexNumbers: [617],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/13.png",
      large: "https://images.pokemontcg.io/sv9/13_hires.png",
    },
    altArts: [
      {
        id: "sv9-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/sv9/13.png",
          large: "https://images.pokemontcg.io/sv9/13_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-58",
    name: "Aegislash",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Metal"],
    evolvesFrom: "Doublade",
    attacks: [
      {
        name: "Slash",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
      {
        name: "Metal Slash",
        cost: ["Metal", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "230",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "58",
    nationalPokedexNumbers: [681],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-58/small",
      large: "https://images.scrydex.com/pokemon/me3-58/large",
    },
    altArts: [
      {
        id: "me3-58",
        number: "58",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-58/small",
          large: "https://images.scrydex.com/pokemon/me3-58/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-122",
    name: "Aggron",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Metal"],
    evolvesFrom: "Lairon",
    attacks: [
      {
        name: "Angry Slam",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "This attack does 50 damage for each of your Pokémon that has any damage counters on it.",
      },
      {
        name: "Guard Claw",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your opponent's next turn, this Pokémon takes 50 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "122",
    flavorText:
      "Aggron has a horn sharp enough to perforate thick iron sheets. It brings down its opponents by ramming into them horn first.",
    nationalPokedexNumbers: [306],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/122.png",
      large: "https://images.pokemontcg.io/sv6/122_hires.png",
    },
    altArts: [
      {
        id: "sv6-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/sv6/122.png",
          large: "https://images.pokemontcg.io/sv6/122_hires.png",
        },
        flavorText:
          "Aggron has a horn sharp enough to perforate thick iron sheets. It brings down its opponents by ramming into them horn first.",
      },
    ],
  },
  {
    id: "me2-78",
    name: "Aipom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Ambipom"],
    attacks: [
      {
        name: "Astonish",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Choose a random card from your opponent's hand, and your opponent reveals that card and shuffles it into their deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    flavorText:
      "It lives atop tall trees. When leaping from branch to branch, it deftly uses its tail for balance.",
    nationalPokedexNumbers: [190],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/78.png",
      large: "https://images.pokemontcg.io/me2/78_hires.png",
    },
    altArts: [
      {
        id: "me2-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/me2/78.png",
          large: "https://images.pokemontcg.io/me2/78_hires.png",
        },
        flavorText:
          "It lives atop tall trees. When leaping from branch to branch, it deftly uses its tail for balance.",
      },
    ],
  },
  {
    id: "sv6-137",
    name: "Aipom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Ambipom"],
    attacks: [
      {
        name: "Hang Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Playful Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "137",
    flavorText:
      "Its tail moves with greater dexterity than its hands. Making deft use of this tail, Aipom lives high among the treetops.",
    nationalPokedexNumbers: [190],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/137.png",
      large: "https://images.pokemontcg.io/sv6/137_hires.png",
    },
    altArts: [
      {
        id: "sv6-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/sv6/137.png",
          large: "https://images.pokemontcg.io/sv6/137_hires.png",
        },
        flavorText:
          "Its tail moves with greater dexterity than its hands. Making deft use of this tail, Aipom lives high among the treetops.",
      },
    ],
  },
  {
    id: "me1-56",
    name: "Alakazam",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Kadabra",
    abilities: [
      {
        name: "Psychic Draw",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Draw 3 cards.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Powerful Hand",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Place 2 damage counters on your opponent's Active Pokémon for each card in your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "56",
    nationalPokedexNumbers: [65],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/56.png",
      large: "https://images.pokemontcg.io/me1/56_hires.png",
    },
    altArts: [
      {
        id: "me1-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/me1/56.png",
          large: "https://images.pokemontcg.io/me1/56_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-82",
    name: "Alakazam",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Kadabra",
    attacks: [
      {
        name: "Strange Hacking",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Confused. You may move any number of damage counters from your opponent's Pokémon to their other Pokémon in any way you like.",
      },
      {
        name: "Psychic",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "This attack does 50 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "82",
    flavorText:
      "It has an incredibly high level of intelligence. Some say that Alakazam remembers everything that ever happens to it, from birth till death.",
    nationalPokedexNumbers: [65],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/82.png",
      large: "https://images.pokemontcg.io/sv6/82_hires.png",
    },
    altArts: [
      {
        id: "sv6-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv6/82.png",
          large: "https://images.pokemontcg.io/sv6/82_hires.png",
        },
        flavorText:
          "It has an incredibly high level of intelligence. Some say that Alakazam remembers everything that ever happens to it, from birth till death.",
      },
    ],
  },
  {
    id: "me2-44",
    name: "Alcremie",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Milcery",
    attacks: [
      {
        name: "Sweet Circle",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each of your Pokémon in play.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    flavorText:
      "Desserts that Alcremie have decorated with their cream have a rich, sweet flavor and bring happiness to all who eat them.",
    nationalPokedexNumbers: [869],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/44.png",
      large: "https://images.pokemontcg.io/me2/44_hires.png",
    },
    altArts: [
      {
        id: "me2-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/me2/44.png",
          large: "https://images.pokemontcg.io/me2/44_hires.png",
        },
        flavorText:
          "Desserts that Alcremie have decorated with their cream have a rich, sweet flavor and bring happiness to all who eat them.",
      },
    ],
  },
  {
    id: "sv7-65",
    name: "Alcremie",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Psychic"],
    evolvesFrom: "Milcery",
    attacks: [
      {
        name: "Colorful Confection",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 5 Pokémon that are the same type as any Basic Energy attached to this Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "65",
    nationalPokedexNumbers: [869],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/65.png",
      large: "https://images.pokemontcg.io/sv7/65_hires.png",
    },
    altArts: [
      {
        id: "sv7-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv7/65.png",
          large: "https://images.pokemontcg.io/sv7/65_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-75",
    name: "Alcremie ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "250",
    types: ["Psychic"],
    evolvesFrom: "Milcery",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Confectionary Gift",
        text: "Once during your turn, you may heal 30 damage from 1 of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Whipped Shot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "75",
    nationalPokedexNumbers: [869],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/75.png",
      large: "https://images.pokemontcg.io/sv9/75_hires.png",
    },
    altArts: [
      {
        id: "sv9-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv9/75.png",
          large: "https://images.pokemontcg.io/sv9/75_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-122",
    name: "Alolan Diglett",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Metal"],
    evolvesTo: ["Dugtrio"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: [],
        convertedEnergyCost: 0,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "122",
    nationalPokedexNumbers: [50],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/122.png",
      large: "https://images.pokemontcg.io/sv8/122_hires.png",
    },
    altArts: [
      {
        id: "sv8-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/sv8/122.png",
          large: "https://images.pokemontcg.io/sv8/122_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-123",
    name: "Alolan Dugtrio",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Metal"],
    evolvesFrom: "Alolan Diglett",
    attacks: [
      {
        name: "Trio-Cheehoo",
        cost: [],
        convertedEnergyCost: 0,
        damage: "120",
        text: "If you don't have exactly 3 cards in your hand, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "123",
    nationalPokedexNumbers: [51],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/123.png",
      large: "https://images.pokemontcg.io/sv8/123_hires.png",
    },
    altArts: [
      {
        id: "sv8-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/sv8/123.png",
          large: "https://images.pokemontcg.io/sv8/123_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-208",
        number: "208",
        images: {
          small: "https://images.pokemontcg.io/sv8/208.png",
          large: "https://images.pokemontcg.io/sv8/208_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-2",
    name: "Alolan Exeggutor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Exeggcute",
    abilities: [
      {
        name: "Scale Up",
        text: "If this Pokémon has 6 or more Grass Energy attached, it gets +250 HP.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mega Drain",
        cost: ["Grass", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "Heal 50 damage from this Pokémon",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "2",
    nationalPokedexNumbers: [103],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-2/small",
      large: "https://images.scrydex.com/pokemon/me55-2/large",
    },
    altArts: [
      {
        id: "me55-2",
        number: "2",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-2/small",
          large: "https://images.scrydex.com/pokemon/me55-2/large",
        },
        flavorText: "",
      },
      {
        id: "me55-129",
        number: "129",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-129/small",
          large: "https://images.scrydex.com/pokemon/me55-129/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-133",
    name: "Alolan Exeggutor ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "300",
    types: ["Dragon"],
    evolvesFrom: "Exeggcute",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Tropical Frenzy",
        cost: ["Grass", "Water"],
        convertedEnergyCost: 2,
        damage: "150",
        text: "You may attach any number of Basic Energy cards from your hand to your Pokémon in any way you like.",
      },
      {
        name: "Swinging Sphene",
        cost: ["Grass", "Water", "Fighting"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Flip a coin. If heads, Knock Out your opponent's Active Basic Pokémon. If tails, Knock Out 1 of your opponent's Benched Basic Pokémon.",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "133",
    nationalPokedexNumbers: [103],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/133.png",
      large: "https://images.pokemontcg.io/sv8/133_hires.png",
    },
    altArts: [
      {
        id: "sv8-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/sv8/133.png",
          large: "https://images.pokemontcg.io/sv8/133_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-225",
        number: "225",
        images: {
          small: "https://images.pokemontcg.io/sv8/225.png",
          large: "https://images.pokemontcg.io/sv8/225_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-242",
        number: "242",
        images: {
          small: "https://images.pokemontcg.io/sv8/242.png",
          large: "https://images.pokemontcg.io/sv8/242_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-248",
        number: "248",
        images: {
          small: "https://images.pokemontcg.io/sv8/248.png",
          large: "https://images.pokemontcg.io/sv8/248_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-44",
    name: "Alolan Geodude",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Graveler"],
    attacks: [
      {
        name: "Knuckle Punch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Tiny Charge",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "44",
    nationalPokedexNumbers: [74],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/44.png",
      large: "https://images.pokemontcg.io/sv9/44_hires.png",
    },
    altArts: [
      {
        id: "sv9-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv9/44.png",
          large: "https://images.pokemontcg.io/sv9/44_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-46",
    name: "Alolan Golem",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Lightning"],
    evolvesFrom: "Alolan Graveler",
    attacks: [
      {
        name: "Electromagnetic Catapult",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "70×",
        text: "Flip a coin until you get tails. This attack does 70 damage for each heads.",
      },
      {
        name: "Megaton Fall",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "This Pokémon also does 40 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "46",
    nationalPokedexNumbers: [76],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/46.png",
      large: "https://images.pokemontcg.io/sv9/46_hires.png",
    },
    altArts: [
      {
        id: "sv9-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv9/46.png",
          large: "https://images.pokemontcg.io/sv9/46_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-45",
    name: "Alolan Graveler",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Lightning"],
    evolvesFrom: "Alolan Geodude",
    evolvesTo: ["Golem"],
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Electric Punch",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "45",
    nationalPokedexNumbers: [75],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/45.png",
      large: "https://images.pokemontcg.io/sv9/45_hires.png",
    },
    altArts: [
      {
        id: "sv9-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv9/45.png",
          large: "https://images.pokemontcg.io/sv9/45_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-57",
    name: "Alolan Marowak",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Cubone",
    attacks: [
      {
        name: "Retaliate",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 90 more damage.",
      },
      {
        name: "Will-O-Wisp",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "57",
    nationalPokedexNumbers: [105],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/57.png",
      large: "https://images.pokemontcg.io/sv9/57_hires.png",
    },
    altArts: [
      {
        id: "sv9-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv9/57.png",
          large: "https://images.pokemontcg.io/sv9/57_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-89",
    name: "Alolan Meowth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    attacks: [
      {
        name: "Pay Day",
        cost: [],
        convertedEnergyCost: 0,
        damage: "10",
        text: "Draw a card.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "89",
    nationalPokedexNumbers: [52],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-89/small",
      large: "https://images.scrydex.com/pokemon/me55-89/large",
    },
    altArts: [
      {
        id: "me55-89",
        number: "89",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-89/small",
          large: "https://images.scrydex.com/pokemon/me55-89/large",
        },
        flavorText: "",
      },
      {
        id: "me55-139",
        number: "139",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-139/small",
          large: "https://images.scrydex.com/pokemon/me55-139/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-24",
    name: "Alomomola",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    abilities: [
      {
        name: "Gentle Fin",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may put a Basic Pokémon with 70 HP or less from your discard pile onto your Bench.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Waterfall",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    flavorText:
      "The special membrane enveloping Alomomola has the ability to heal wounds.",
    nationalPokedexNumbers: [594],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/24.png",
      large: "https://images.pokemontcg.io/zsv10pt5/24_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/24.png",
          large: "https://images.pokemontcg.io/zsv10pt5/24_hires.png",
        },
        flavorText:
          "The special membrane enveloping Alomomola has the ability to heal wounds.",
      },
      {
        id: "zsv10pt5-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/108.png",
          large: "https://images.pokemontcg.io/zsv10pt5/108_hires.png",
        },
        flavorText:
          "The special membrane enveloping Alomomola has the ability to heal wounds.",
      },
    ],
  },
  {
    id: "sv8-134",
    name: "Altaria",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Dragon"],
    evolvesFrom: "Swablu",
    attacks: [
      {
        name: "Humming Charge",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards and attach them to your Pokémon in any way you like. Then, shuffle your deck.",
      },
      {
        name: "Cotton Wings",
        cost: ["Water", "Metal"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage done to this Pokémon by attacks.",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "134",
    nationalPokedexNumbers: [334],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/134.png",
      large: "https://images.pokemontcg.io/sv8/134_hires.png",
    },
    altArts: [
      {
        id: "sv8-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/sv8/134.png",
          large: "https://images.pokemontcg.io/sv8/134_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-23",
    name: "Amaura",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Antique Sail Fossil",
    attacks: [
      {
        name: "Icy Wind",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "23",
    nationalPokedexNumbers: [698],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-23/small",
      large: "https://images.scrydex.com/pokemon/me3-23/large",
    },
    altArts: [
      {
        id: "me3-23",
        number: "23",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-23/small",
          large: "https://images.scrydex.com/pokemon/me3-23/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-79",
    name: "Ambipom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Aipom",
    attacks: [
      {
        name: "Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Dual Tail",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard 2 Energy from this Pokémon, and this attack does 60 damage to each of 2 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "79",
    flavorText:
      "They live on large trees. They are said to communicate by connecting their tails to those of others.",
    nationalPokedexNumbers: [424],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/79.png",
      large: "https://images.pokemontcg.io/me2/79_hires.png",
    },
    altArts: [
      {
        id: "me2-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/me2/79.png",
          large: "https://images.pokemontcg.io/me2/79_hires.png",
        },
        flavorText:
          "They live on large trees. They are said to communicate by connecting their tails to those of others.",
      },
      {
        id: "me2-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/me2/107.png",
          large: "https://images.pokemontcg.io/me2/107_hires.png",
        },
        flavorText:
          "They live on large trees. They are said to communicate by connecting their tails to those of others.",
      },
    ],
  },
  {
    id: "sv6-138",
    name: "Ambipom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Aipom",
    abilities: [
      {
        name: "Wicked Tail",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may flip 2 coins. For each heads, choose a random card from your opponent's hand. Your opponent reveals those cards and shuffles them into their deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "138",
    flavorText:
      "Split into two, the tails are so adept at handling and doing things that Ambipom rarely uses its hands.",
    nationalPokedexNumbers: [424],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/138.png",
      large: "https://images.pokemontcg.io/sv6/138_hires.png",
    },
    altArts: [
      {
        id: "sv6-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/sv6/138.png",
          large: "https://images.pokemontcg.io/sv6/138_hires.png",
        },
        flavorText:
          "Split into two, the tails are so adept at handling and doing things that Ambipom rarely uses its hands.",
      },
    ],
  },
  {
    id: "zsv10pt5-11",
    name: "Amoonguss",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Foongus",
    attacks: [
      {
        name: "Dangerous Reaction",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your opponent's Active Pokémon is affected by a Special Condition, this attack does 120 more damage.",
      },
      {
        name: "Seed Bomb",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "11",
    flavorText:
      "It lures prey close by dancing and waving its arm caps, which resemble Poké Balls, in a swaying motion.",
    nationalPokedexNumbers: [591],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/11.png",
      large: "https://images.pokemontcg.io/zsv10pt5/11_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/11.png",
          large: "https://images.pokemontcg.io/zsv10pt5/11_hires.png",
        },
        flavorText:
          "It lures prey close by dancing and waving its arm caps, which resemble Poké Balls, in a swaying motion.",
      },
      {
        id: "zsv10pt5-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/96.png",
          large: "https://images.pokemontcg.io/zsv10pt5/96_hires.png",
        },
        flavorText:
          "It lures prey close by dancing and waving its arm caps, which resemble Poké Balls, in a swaying motion.",
      },
    ],
  },
  {
    id: "sv9-11",
    name: "Amoonguss ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Grass"],
    evolvesFrom: "Foongus",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Spore Ball",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
      {
        name: "Champignon's Swing",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100+",
        text: "Flip a coin. If heads, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "11",
    nationalPokedexNumbers: [591],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/11.png",
      large: "https://images.pokemontcg.io/sv9/11_hires.png",
    },
    altArts: [
      {
        id: "sv9-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv9/11.png",
          large: "https://images.pokemontcg.io/sv9/11_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-29",
    name: "Ampharos",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Lightning"],
    evolvesFrom: "Flaaffy",
    abilities: [
      {
        name: "Synchro Pulse",
        text: "If you have the same number of cards in your hand as your opponent, attacks used by this Pokémon do 80 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Flashing Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "140",
        text: "During your next turn, this Pokémon can't use Flashing Bolt.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "29",
    flavorText:
      "The tail's tip shines brightly and can be seen from far away. It acts as a beacon for lost people.",
    nationalPokedexNumbers: [181],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-29/small",
      large: "https://images.scrydex.com/pokemon/me4-29/large",
    },
    altArts: [
      {
        id: "me4-29",
        number: "29",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-29/small",
          large: "https://images.scrydex.com/pokemon/me4-29/large",
        },
        flavorText:
          "The tail's tip shines brightly and can be seen from far away. It acts as a beacon for lost people.",
      },
      {
        id: "me4-90",
        number: "90",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-90/small",
          large: "https://images.scrydex.com/pokemon/me4-90/large",
        },
        flavorText:
          "The tail's tip shines brightly and can be seen from far away. It acts as a beacon for lost people.",
      },
    ],
  },
  {
    id: "svp-109",
    name: "Ampharos",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Lightning"],
    evolvesFrom: "Flaaffy",
    attacks: [
      {
        name: "Electric Ball",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "109",
    nationalPokedexNumbers: [181],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/109.png",
      large: "https://images.pokemontcg.io/svp/109_hires.png",
    },
    altArts: [
      {
        id: "svp-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/svp/109.png",
          large: "https://images.pokemontcg.io/svp/109_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-41",
    name: "Annihilape",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Psychic"],
    evolvesFrom: "Primeape",
    abilities: [
      {
        name: "Durable Body",
        text: "If this Pokémon would be Knocked Out by damage from an attack, flip a coin. If heads, this Pokémon is not Knocked Out, and its remaining HP becomes 10.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Ghostly Blow",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "Place 5 damage counters on 1 of your opponent's Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "41",
    flavorText:
      "It imbues its fists with the power of the rage that it kept hidden in its heart. Opponents struck by these imbued fists will be shattered to their core.",
    nationalPokedexNumbers: [979],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-41/small",
      large: "https://images.scrydex.com/pokemon/me5-41/large",
    },
    altArts: [
      {
        id: "me5-41",
        number: "41",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-41/small",
          large: "https://images.scrydex.com/pokemon/me5-41/large",
        },
        flavorText:
          "It imbues its fists with the power of the rage that it kept hidden in its heart. Opponents struck by these imbued fists will be shattered to their core.",
      },
    ],
  },
  {
    id: "sv10-92",
    name: "Annihilape",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Primeape",
    abilities: [
      {
        name: "Lose Cool",
        text: "If this Pokémon has 2 or more damage counters on it, attacks used by this Pokémon do 120 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Impact Blow",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "During your next turn, this Pokémon can't use Impact Blow.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "92",
    nationalPokedexNumbers: [979],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/92.png",
      large: "https://images.pokemontcg.io/sv10/92_hires.png",
    },
    altArts: [
      {
        id: "sv10-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv10/92.png",
          large: "https://images.pokemontcg.io/sv10/92_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-100",
    name: "Annihilape",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Primeape",
    attacks: [
      {
        name: "Tantrum",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "130",
        text: "This Pokémon is now Confused.",
      },
      {
        name: "Destined Fight",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Both Active Pokémon are Knocked Out.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "100",
    nationalPokedexNumbers: [979],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/100.png",
      large: "https://images.pokemontcg.io/sv8/100_hires.png",
    },
    altArts: [
      {
        id: "sv8-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/sv8/100.png",
          large: "https://images.pokemontcg.io/sv8/100_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-140",
    name: "Appletun",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Dragon"],
    evolvesFrom: "Applin",
    attacks: [
      {
        name: "Melting Sweetness",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "During your opponent's next turn, the Defending Pokémon can't attack.",
      },
      {
        name: "Wild Tackle",
        cost: ["Grass", "Fire"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "140",
    nationalPokedexNumbers: [842],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/140.png",
      large: "https://images.pokemontcg.io/sv8/140_hires.png",
    },
    altArts: [
      {
        id: "sv8-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/sv8/140.png",
          large: "https://images.pokemontcg.io/sv8/140_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-211",
        number: "211",
        images: {
          small: "https://images.pokemontcg.io/sv8/211.png",
          large: "https://images.pokemontcg.io/sv8/211_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-16",
    name: "Applin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    evolvesTo: ["Flapple"],
    attacks: [
      {
        name: "Mini Drain",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Heal 10 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    nationalPokedexNumbers: [840],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/16.png",
      large: "https://images.pokemontcg.io/sv10/16_hires.png",
    },
    altArts: [
      {
        id: "sv10-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv10/16.png",
          large: "https://images.pokemontcg.io/sv10/16_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-17",
    name: "Applin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    evolvesTo: ["Flapple"],
    attacks: [
      {
        name: "Tumbling Attack",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "17",
    flavorText:
      "Applin lives inside an apple. When an Applin is separated from its apple, its body loses moisture and the Pokémon grows weak.",
    nationalPokedexNumbers: [840],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/17.png",
      large: "https://images.pokemontcg.io/sv6/17_hires.png",
    },
    altArts: [
      {
        id: "sv6-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv6/17.png",
          large: "https://images.pokemontcg.io/sv6/17_hires.png",
        },
        flavorText:
          "Applin lives inside an apple. When an Applin is separated from its apple, its body loses moisture and the Pokémon grows weak.",
      },
    ],
  },
  {
    id: "sv6-126",
    name: "Applin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Dragon"],
    evolvesTo: ["Flapple"],
    attacks: [
      {
        name: "Find a Friend",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Rolling Tackle",
        cost: ["Grass", "Fire"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "126",
    flavorText:
      "Applin lives inside an apple. When an Applin is separated from its apple, its body loses moisture and the Pokémon grows weak.",
    nationalPokedexNumbers: [840],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/126.png",
      large: "https://images.pokemontcg.io/sv6/126_hires.png",
    },
    altArts: [
      {
        id: "sv6-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/sv6/126.png",
          large: "https://images.pokemontcg.io/sv6/126_hires.png",
        },
        flavorText:
          "Applin lives inside an apple. When an Applin is separated from its apple, its body loses moisture and the Pokémon grows weak.",
      },
      {
        id: "sv6-185",
        number: "185",
        images: {
          small: "https://images.pokemontcg.io/sv6/185.png",
          large: "https://images.pokemontcg.io/sv6/185_hires.png",
        },
        flavorText:
          "Applin lives inside an apple. When an Applin is separated from its apple, its body loses moisture and the Pokémon grows weak.",
      },
    ],
  },
  {
    id: "sv7-12",
    name: "Applin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    evolvesTo: ["Flapple"],
    attacks: [
      {
        name: "Spray Fluid",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "12",
    nationalPokedexNumbers: [840],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/12.png",
      large: "https://images.pokemontcg.io/sv7/12_hires.png",
    },
    altArts: [
      {
        id: "sv7-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv7/12.png",
          large: "https://images.pokemontcg.io/sv7/12_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/9.png",
          large: "https://images.pokemontcg.io/sv8pt5/9_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-138",
    name: "Applin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Dragon"],
    evolvesTo: ["Flapple"],
    attacks: [
      {
        name: "Nutrients",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 30 damage from 1 of your Pokémon.",
      },
      {
        name: "Trip Over",
        cost: ["Grass", "Fire"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 30 more damage.",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "138",
    nationalPokedexNumbers: [840],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/138.png",
      large: "https://images.pokemontcg.io/sv8/138_hires.png",
    },
    altArts: [
      {
        id: "sv8-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/sv8/138.png",
          large: "https://images.pokemontcg.io/sv8/138_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-101",
    name: "Arbok",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Ekans",
    attacks: [
      {
        name: "Panic Poison",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned, Confused, and Poisoned.",
      },
      {
        name: "Darkness Fang",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "101",
    flavorText:
      "The pattern on its belly appears to be a frightening face. Weak foes will flee just at the sight of the pattern.",
    nationalPokedexNumbers: [24],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/101.png",
      large: "https://images.pokemontcg.io/sv5/101_hires.png",
    },
    altArts: [
      {
        id: "sv5-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/sv5/101.png",
          large: "https://images.pokemontcg.io/sv5/101_hires.png",
        },
        flavorText:
          "The pattern on its belly appears to be a frightening face. Weak foes will flee just at the sight of the pattern.",
      },
      {
        id: "sv5-176",
        number: "176",
        images: {
          small: "https://images.pokemontcg.io/sv5/176.png",
          large: "https://images.pokemontcg.io/sv5/176_hires.png",
        },
        flavorText:
          "The pattern on its belly appears to be a frightening face. Weak foes will flee just at the sight of the pattern.",
      },
    ],
  },
  {
    id: "sv10-23",
    name: "Arboliva ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "310",
    types: ["Grass"],
    evolvesFrom: "Dolliv",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Oil Salvo",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Choose 1 of your opponent's Pokémon 6 times. (You can choose the same Pokémon more than once.) For each time you chose a Pokémon, do 20 damage to it. This damage isn't affected by Weakness or Resistance.",
      },
      {
        name: "Aroma Shot",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "This Pokémon recovers from all Special Conditions.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    nationalPokedexNumbers: [930],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/23.png",
      large: "https://images.pokemontcg.io/sv10/23_hires.png",
    },
    altArts: [
      {
        id: "sv10-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv10/23.png",
          large: "https://images.pokemontcg.io/sv10/23_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-207",
        number: "207",
        images: {
          small: "https://images.pokemontcg.io/sv10/207.png",
          large: "https://images.pokemontcg.io/sv10/207_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-28",
    name: "Arcanine",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Growlithe",
    attacks: [
      {
        name: "Flare",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Punishing Fang",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If your opponent's Active Pokémon is a Darkness Pokémon, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "28",
    nationalPokedexNumbers: [59],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/28.png",
      large: "https://images.pokemontcg.io/sv10/28_hires.png",
    },
    altArts: [
      {
        id: "sv10-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv10/28.png",
          large: "https://images.pokemontcg.io/sv10/28_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-123",
    name: "Arceus VSTAR",
    supertype: "Pokémon",
    subtypes: ["VSTAR"],
    hp: "280",
    types: ["Colorless"],
    evolvesFrom: "Arceus V",
    rules: [
      "When your Pokémon VSTAR is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Starbirth",
        text: "During your turn, you may search your deck for up to 2 cards and put them into your hand. Then, shuffle your deck. (You can't use more than 1 VSTAR Power in a game.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Trinity Nova",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Search your deck for up to 3 basic Energy cards and attach them to your Pokémon V in any way you like. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "123",
    nationalPokedexNumbers: [493],
    regulationMark: "F",
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-123/small",
      large: "https://images.scrydex.com/pokemon/me55c-123/large",
    },
    altArts: [
      {
        id: "me55c-123",
        number: "123",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-123/small",
          large: "https://images.scrydex.com/pokemon/me55c-123/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-75",
    name: "Archaludon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "180",
    types: ["Metal"],
    evolvesFrom: "Duraludon",
    attacks: [
      {
        name: "Coated Attack",
        cost: ["Metal", "Metal", "Metal"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Basic Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "75",
    flavorText:
      "It gathers static electricity from its surroundings. The beams it launches when down on all fours are tremendously powerful.",
    nationalPokedexNumbers: [1018],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/75.png",
      large: "https://images.pokemontcg.io/me2/75_hires.png",
    },
    altArts: [
      {
        id: "me2-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/me2/75.png",
          large: "https://images.pokemontcg.io/me2/75_hires.png",
        },
        flavorText:
          "It gathers static electricity from its surroundings. The beams it launches when down on all fours are tremendously powerful.",
      },
    ],
  },
  {
    id: "sv7-107",
    name: "Archaludon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "180",
    types: ["Metal"],
    evolvesFrom: "Duraludon",
    abilities: [
      {
        name: "Metal Bridge",
        text: "All of your Pokémon that have Metal Energy attached have no Retreat Cost.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Iron Blaster",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "107",
    nationalPokedexNumbers: [1018],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/107.png",
      large: "https://images.pokemontcg.io/sv7/107_hires.png",
    },
    altArts: [
      {
        id: "sv7-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/sv7/107.png",
          large: "https://images.pokemontcg.io/sv7/107_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/sv7/155.png",
          large: "https://images.pokemontcg.io/sv7/155_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/70.png",
          large: "https://images.pokemontcg.io/sv8pt5/70_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-130",
    name: "Archaludon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "300",
    types: ["Metal"],
    evolvesFrom: "Duraludon",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Assemble Alloy",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may attach up to 2 Basic Metal Energy cards from your discard pile to your Metal Pokémon in any way you like.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Metal Defender",
        cost: ["Metal", "Metal", "Metal"],
        convertedEnergyCost: 3,
        damage: "220",
        text: "During your opponent's next turn, this Pokémon has no Weakness.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "130",
    nationalPokedexNumbers: [1018],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/130.png",
      large: "https://images.pokemontcg.io/sv8/130_hires.png",
    },
    altArts: [
      {
        id: "sv8-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/sv8/130.png",
          large: "https://images.pokemontcg.io/sv8/130_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-224",
        number: "224",
        images: {
          small: "https://images.pokemontcg.io/sv8/224.png",
          large: "https://images.pokemontcg.io/sv8/224_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-241",
        number: "241",
        images: {
          small: "https://images.pokemontcg.io/sv8/241.png",
          large: "https://images.pokemontcg.io/sv8/241_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-50",
    name: "Archen",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Fighting"],
    evolvesFrom: "Antiuqe Plume Fossil",
    evolvesTo: ["Archeops"],
    attacks: [
      {
        name: "Acrobatics",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "Flip 2 coins. This attack does 30 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    flavorText:
      "Said to be an ancestor of bird Pokémon, they were unable to fly and moved about by hopping from one branch to another.",
    nationalPokedexNumbers: [566],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/50.png",
      large: "https://images.pokemontcg.io/rsv10pt5/50_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/50.png",
          large: "https://images.pokemontcg.io/rsv10pt5/50_hires.png",
        },
        flavorText:
          "Said to be an ancestor of bird Pokémon, they were unable to fly and moved about by hopping from one branch to another.",
      },
      {
        id: "rsv10pt5-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/131.png",
          large: "https://images.pokemontcg.io/rsv10pt5/131_hires.png",
        },
        flavorText:
          "Said to be an ancestor of bird Pokémon, they were unable to fly and moved about by hopping from one branch to another.",
      },
    ],
  },
  {
    id: "rsv10pt5-51",
    name: "Archeops",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Archen",
    abilities: [
      {
        name: "Ancient Wing",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may devolve 1 of your opponent's evolved Pokémon by putting the highest Stage Evolution card on it into your opponent's hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rock Throw",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    flavorText:
      "They are intelligent and will cooperate to catch prey. From the ground, they use a running start to take flight.",
    nationalPokedexNumbers: [567],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/51.png",
      large: "https://images.pokemontcg.io/rsv10pt5/51_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/51.png",
          large: "https://images.pokemontcg.io/rsv10pt5/51_hires.png",
        },
        flavorText:
          "They are intelligent and will cooperate to catch prey. From the ground, they use a running start to take flight.",
      },
      {
        id: "rsv10pt5-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/132.png",
          large: "https://images.pokemontcg.io/rsv10pt5/132_hires.png",
        },
        flavorText:
          "They are intelligent and will cooperate to catch prey. From the ground, they use a running start to take flight.",
      },
    ],
  },
  {
    id: "me3-2",
    name: "Ariados",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Grass"],
    evolvesFrom: "Spinarak",
    attacks: [
      {
        name: "Poison Ring",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Your opponent's Active Pokémon is now Poisoned. During your opponent's next turn, that Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    nationalPokedexNumbers: [168],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-2/small",
      large: "https://images.scrydex.com/pokemon/me3-2/large",
    },
    altArts: [
      {
        id: "me3-2",
        number: "2",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-2/small",
          large: "https://images.scrydex.com/pokemon/me3-2/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-5",
    name: "Ariados",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Spinarak",
    abilities: [
      {
        name: "Big Net",
        text: "Your opponent's Active Evolution Pokémon's Retreat Cost is Colorless more.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "String Bind",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "This attack does 30 more damage for each Colorless in your opponent's Active Pokémon's Retreat Cost.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "5",
    flavorText:
      "It wanders in search of food after darkness falls, never nesting in a specific place.",
    nationalPokedexNumbers: [168],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/5.png",
      large: "https://images.pokemontcg.io/sv6/5_hires.png",
    },
    altArts: [
      {
        id: "sv6-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv6/5.png",
          large: "https://images.pokemontcg.io/sv6/5_hires.png",
        },
        flavorText:
          "It wanders in search of food after darkness falls, never nesting in a specific place.",
      },
    ],
  },
  {
    id: "me5-12",
    name: "Armarouge",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Charcadet",
    attacks: [
      {
        name: "Flame Legion",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "40+",
        text: "This attack does 40 more damage for each of your Benched Pokémon that has any Fire Energy attached.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "12",
    flavorText:
      "This Pokémon clads itself in armor that has been fortified by psychic and fire energy, and it shoots blazing fireballs.",
    nationalPokedexNumbers: [936],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-12/small",
      large: "https://images.scrydex.com/pokemon/me5-12/large",
    },
    altArts: [
      {
        id: "me5-12",
        number: "12",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-12/small",
          large: "https://images.scrydex.com/pokemon/me5-12/large",
        },
        flavorText:
          "This Pokémon clads itself in armor that has been fortified by psychic and fire energy, and it shoots blazing fireballs.",
      },
      {
        id: "me5-86",
        number: "86",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-86/small",
          large: "https://images.scrydex.com/pokemon/me5-86/large",
        },
        flavorText:
          "This Pokémon clads itself in armor that has been fortified by psychic and fire energy, and it shoots blazing fireballs.",
      },
    ],
  },
  {
    id: "sv8-34",
    name: "Armarouge",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Charcadet",
    attacks: [
      {
        name: "Combustion",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Crimson Blaster",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Fire Energy from this Pokémon, and this attack does 180 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    nationalPokedexNumbers: [936],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/34.png",
      large: "https://images.pokemontcg.io/sv8/34_hires.png",
    },
    altArts: [
      {
        id: "sv8-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv8/34.png",
          large: "https://images.pokemontcg.io/sv8/34_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-105",
    name: "Armarouge ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Fire"],
    evolvesFrom: "Charcadet",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Armor Cannon",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Discard a Fire Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "105",
    nationalPokedexNumbers: [936],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/105.png",
      large: "https://images.pokemontcg.io/svp/105_hires.png",
    },
    altArts: [
      {
        id: "svp-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/svp/105.png",
          large: "https://images.pokemontcg.io/svp/105_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-36",
    name: "Aromatisse",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Spritzee",
    abilities: [
      {
        name: "Scent Collection",
        text: "Once during your turn, you may use this Ability. Search your deck for up to 2 Basic Psychic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Draining Kiss",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    nationalPokedexNumbers: [683],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-36/small",
      large: "https://images.scrydex.com/pokemon/me3-36/large",
    },
    altArts: [
      {
        id: "me3-36",
        number: "36",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-36/small",
          large: "https://images.scrydex.com/pokemon/me3-36/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-39",
    name: "Aromatisse",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Spritzee",
    attacks: [
      {
        name: "Perfume Press",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    nationalPokedexNumbers: [683],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/39.png",
      large: "https://images.pokemontcg.io/sv8pt5/39_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/39.png",
          large: "https://images.pokemontcg.io/sv8pt5/39_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-120",
    name: "Aron",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    evolvesTo: ["Lairon"],
    attacks: [
      {
        name: "Double-Edge",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "120",
    flavorText:
      "It eats iron ore—and sometimes railroad tracks— to build up the steel armor that protects its body.",
    nationalPokedexNumbers: [304],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/120.png",
      large: "https://images.pokemontcg.io/sv6/120_hires.png",
    },
    altArts: [
      {
        id: "sv6-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/sv6/120.png",
          large: "https://images.pokemontcg.io/sv6/120_hires.png",
        },
        flavorText:
          "It eats iron ore—and sometimes railroad tracks— to build up the steel armor that protects its body.",
      },
    ],
  },
  {
    id: "sv10-62",
    name: "Arrokuda",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Barraskewda"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    nationalPokedexNumbers: [846],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/62.png",
      large: "https://images.pokemontcg.io/sv10/62_hires.png",
    },
    altArts: [
      {
        id: "sv10-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/sv10/62.png",
          large: "https://images.pokemontcg.io/sv10/62_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-18",
    name: "Articuno",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Water"],
    abilities: [
      {
        name: "Frosty Flapping",
        text: "Once during your turn, if you have Moltres and Zapdos in play, you may use this Ability. Attach a Basic Water Energy card from your hand to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hail",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        text: "This attack does 30 damage to each of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    nationalPokedexNumbers: [144],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-18/small",
      large: "https://images.scrydex.com/pokemon/me55-18/large",
    },
    altArts: [
      {
        id: "me55-18",
        number: "18",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-18/small",
          large: "https://images.scrydex.com/pokemon/me55-18/large",
        },
        flavorText: "",
      },
      {
        id: "me55-132",
        number: "132",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-132/small",
          large: "https://images.scrydex.com/pokemon/me55-132/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-32",
    name: "Articuno",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Frigid Fluttering",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Water Energy cards and attach them to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Ice Blast",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    nationalPokedexNumbers: [144],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/32.png",
      large: "https://images.pokemontcg.io/sv9/32_hires.png",
    },
    altArts: [
      {
        id: "sv9-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv9/32.png",
          large: "https://images.pokemontcg.io/sv9/32_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/sv9/161.png",
          large: "https://images.pokemontcg.io/sv9/161_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-159",
    name: "Arven's Greedent",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Arven's Skwovet",
    abilities: [
      {
        name: "Greedy Order",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may put up to 2 Arven's Sandwich cards from your discard pile into your hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "159",
    nationalPokedexNumbers: [820],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/159.png",
      large: "https://images.pokemontcg.io/sv10/159_hires.png",
    },
    altArts: [
      {
        id: "sv10-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/sv10/159.png",
          large: "https://images.pokemontcg.io/sv10/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-205",
        number: "205",
        images: {
          small: "https://images.pokemontcg.io/sv10/205.png",
          large: "https://images.pokemontcg.io/sv10/205_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-139",
    name: "Arven's Mabosstiff ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Darkness"],
    evolvesFrom: "Arven's Maschiff",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Vigorous Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If this Pokémon has no damage counters on it, this attack does 120 more damage.",
      },
      {
        name: "Boss Headbutt",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "During your next turn, this Pokémon can't use Boss Headbutt.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "139",
    nationalPokedexNumbers: [943],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/139.png",
      large: "https://images.pokemontcg.io/sv10/139_hires.png",
    },
    altArts: [
      {
        id: "sv10-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/sv10/139.png",
          large: "https://images.pokemontcg.io/sv10/139_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-218",
        number: "218",
        images: {
          small: "https://images.pokemontcg.io/sv10/218.png",
          large: "https://images.pokemontcg.io/sv10/218_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-235",
        number: "235",
        images: {
          small: "https://images.pokemontcg.io/sv10/235.png",
          large: "https://images.pokemontcg.io/sv10/235_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-138",
    name: "Arven's Maschiff",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Confront",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "138",
    nationalPokedexNumbers: [942],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/138.png",
      large: "https://images.pokemontcg.io/sv10/138_hires.png",
    },
    altArts: [
      {
        id: "sv10-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/sv10/138.png",
          large: "https://images.pokemontcg.io/sv10/138_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-158",
    name: "Arven's Skwovet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Greedent"],
    attacks: [
      {
        name: "Gnaw Through",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "158",
    nationalPokedexNumbers: [819],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/158.png",
      large: "https://images.pokemontcg.io/sv10/158_hires.png",
    },
    altArts: [
      {
        id: "sv10-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/sv10/158.png",
          large: "https://images.pokemontcg.io/sv10/158_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-109",
    name: "Arven's Toedscool",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Slight Intrusion",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "109",
    nationalPokedexNumbers: [948],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/109.png",
      large: "https://images.pokemontcg.io/sv10/109_hires.png",
    },
    altArts: [
      {
        id: "sv10-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/sv10/109.png",
          large: "https://images.pokemontcg.io/sv10/109_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-110",
    name: "Arven's Toedscruel",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Arven's Toedscool",
    attacks: [
      {
        name: "Pull",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
      },
      {
        name: "Reckless Charge",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "110",
    nationalPokedexNumbers: [949],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/110.png",
      large: "https://images.pokemontcg.io/sv10/110_hires.png",
    },
    altArts: [
      {
        id: "sv10-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/sv10/110.png",
          large: "https://images.pokemontcg.io/sv10/110_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-74",
    name: "Audino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Colorless"],
    attacks: [
      {
        name: "Return",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "You may draw cards until you have 6 cards in your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "74",
    flavorText:
      "It touches others with the feelers on its ears, using the sound of their heartbeats to tell how they are feeling.",
    nationalPokedexNumbers: [531],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/74.png",
      large: "https://images.pokemontcg.io/zsv10pt5/74_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/74.png",
          large: "https://images.pokemontcg.io/zsv10pt5/74_hires.png",
        },
        flavorText:
          "It touches others with the feelers on its ears, using the sound of their heartbeats to tell how they are feeling.",
      },
      {
        id: "zsv10pt5-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/151.png",
          large: "https://images.pokemontcg.io/zsv10pt5/151_hires.png",
        },
        flavorText:
          "It touches others with the feelers on its ears, using the sound of their heartbeats to tell how they are feeling.",
      },
    ],
  },
  {
    id: "sv9-124",
    name: "Audino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Colorless"],
    attacks: [
      {
        name: "Beckon",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put a Supporter card from your discard pile into your hand.",
      },
      {
        name: "Zen Headbutt",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "124",
    nationalPokedexNumbers: [531],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/124.png",
      large: "https://images.pokemontcg.io/sv9/124_hires.png",
    },
    altArts: [
      {
        id: "sv9-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/sv9/124.png",
          large: "https://images.pokemontcg.io/sv9/124_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-24",
    name: "Aurorus",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Water"],
    evolvesFrom: "Amaura",
    abilities: [
      {
        name: "Tundra Wall",
        text: "All of your Pokémon that have any Water Energy attached take 50 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance). The effect of Tundra Wall doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Freezing Chill",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "During your opponent's next turn, the Defending Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "24",
    nationalPokedexNumbers: [699],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-24/small",
      large: "https://images.scrydex.com/pokemon/me3-24/large",
    },
    altArts: [
      {
        id: "me3-24",
        number: "24",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-24/small",
          large: "https://images.scrydex.com/pokemon/me3-24/large",
        },
        flavorText: "",
      },
      {
        id: "me3-92",
        number: "92",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-92/small",
          large: "https://images.scrydex.com/pokemon/me3-92/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-24",
    name: "Avalugg",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "160",
    types: ["Water"],
    evolvesFrom: "Bergmite",
    attacks: [
      {
        name: "Iceberg Breaker",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "60×",
        text: "Discard the top 6 cards of your deck, and this attack does 60 damage for each Basic Water Energy card you discarded in this way.",
      },
      {
        name: "Frost Stamp",
        cost: ["Water", "Water", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "24",
    flavorText:
      "Its ice-covered body is as hard as steel. Its enormous frame crushes anything that stands in its way.",
    nationalPokedexNumbers: [713],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-24/small",
      large: "https://images.scrydex.com/pokemon/me4-24/large",
    },
    altArts: [
      {
        id: "me4-24",
        number: "24",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-24/small",
          large: "https://images.scrydex.com/pokemon/me4-24/large",
        },
        flavorText:
          "Its ice-covered body is as hard as steel. Its enormous frame crushes anything that stands in its way.",
      },
    ],
  },
  {
    id: "zsv10pt5-68",
    name: "Axew",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Dragon"],
    evolvesTo: ["Fraxure"],
    attacks: [
      {
        name: "Gather Strength",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "68",
    flavorText:
      "They use their tusks to crush the berries they eat. Repeated regrowth makes their tusks strong and sharp.",
    nationalPokedexNumbers: [610],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/68.png",
      large: "https://images.pokemontcg.io/zsv10pt5/68_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/68.png",
          large: "https://images.pokemontcg.io/zsv10pt5/68_hires.png",
        },
        flavorText:
          "They use their tusks to crush the berries they eat. Repeated regrowth makes their tusks strong and sharp.",
      },
      {
        id: "zsv10pt5-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/145.png",
          large: "https://images.pokemontcg.io/zsv10pt5/145_hires.png",
        },
        flavorText:
          "They use their tusks to crush the berries they eat. Repeated regrowth makes their tusks strong and sharp.",
      },
    ],
  },
  {
    id: "sv6pt5-44",
    name: "Axew",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Dragon"],
    evolvesTo: ["Fraxure"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Sharp Fang",
        cost: ["Fighting", "Metal"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "44",
    nationalPokedexNumbers: [610],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/44.png",
      large: "https://images.pokemontcg.io/sv6pt5/44_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/44.png",
          large: "https://images.pokemontcg.io/sv6pt5/44_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-80",
    name: "Azelf",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Neurokinesis",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "10+",
        text: "This attack does 10 more damage for each damage counter on all of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "80",
    nationalPokedexNumbers: [482],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/80.png",
      large: "https://images.pokemontcg.io/sv8/80_hires.png",
    },
    altArts: [
      {
        id: "sv8-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv8/80.png",
          large: "https://images.pokemontcg.io/sv8/80_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-68",
    name: "Azumarill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Marill",
    attacks: [
      {
        name: "Body Slam",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "68",
    nationalPokedexNumbers: [184],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-68/small",
      large: "https://images.scrydex.com/pokemon/me55-68/large",
    },
    altArts: [
      {
        id: "me55-68",
        number: "68",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-68/small",
          large: "https://images.scrydex.com/pokemon/me55-68/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-65",
    name: "Azumarill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Marill",
    attacks: [
      {
        name: "Play Rough",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "Flip a coin. If heads, this attack does 30 more damage.",
      },
      {
        name: "Power Tackle",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "65",
    flavorText:
      "Its long ears are superb sensors. It can distinguish the movements of things in water and tell what they are.",
    nationalPokedexNumbers: [184],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/65.png",
      large: "https://images.pokemontcg.io/sv5/65_hires.png",
    },
    altArts: [
      {
        id: "sv5-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv5/65.png",
          large: "https://images.pokemontcg.io/sv5/65_hires.png",
        },
        flavorText:
          "Its long ears are superb sensors. It can distinguish the movements of things in water and tell what they are.",
      },
    ],
  },
  {
    id: "sv7-34",
    name: "Azumarill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Marill",
    attacks: [
      {
        name: "Bubble Beam",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    nationalPokedexNumbers: [184],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/34.png",
      large: "https://images.pokemontcg.io/sv7/34_hires.png",
    },
    altArts: [
      {
        id: "sv7-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv7/34.png",
          large: "https://images.pokemontcg.io/sv7/34_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-74",
    name: "Azumarill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Marill",
    abilities: [
      {
        name: "Glistening Bubbles",
        text: "If you have any Tera Pokémon in play, this Pokémon can use the Double-Edge attack for Psychic.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Double-Edge",
        cost: ["Psychic", "Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 4,
        damage: "230",
        text: "This Pokémon also does 50 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "74",
    nationalPokedexNumbers: [184],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/74.png",
      large: "https://images.pokemontcg.io/sv8/74_hires.png",
    },
    altArts: [
      {
        id: "sv8-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv8/74.png",
          large: "https://images.pokemontcg.io/sv8/74_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-84",
    name: "Azumarill ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Psychic"],
    evolvesFrom: "Marill",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Bubble Gathering",
        text: "As often as you like during your turn, you may use this Ability. Move an Energy from 1 of your other Pokémon to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Energized Balloon",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60+",
        text: "This attack does 40 more damage for each Psychic Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "84",
    nationalPokedexNumbers: [183],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-84/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-84/large",
    },
    altArts: [
      {
        id: "me2pt5-84",
        number: "84",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-84/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-84/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-112",
    name: "Bagon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Dragon"],
    evolvesTo: ["Shelgon"],
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Reckless Charge",
        cost: ["Fire", "Water"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "112",
    nationalPokedexNumbers: [371],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/112.png",
      large: "https://images.pokemontcg.io/sv9/112_hires.png",
    },
    altArts: [
      {
        id: "sv9-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/sv9/112.png",
          large: "https://images.pokemontcg.io/sv9/112_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-46",
    name: "Baltoy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Continuous Spin",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "Flip a coin until you get tails. This attack does 30 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    flavorText:
      "It moves while spinning around on its single foot. Some Baltoy have been seen spinning on their heads.",
    nationalPokedexNumbers: [343],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-46/small",
      large: "https://images.scrydex.com/pokemon/me4-46/large",
    },
    altArts: [
      {
        id: "me4-46",
        number: "46",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-46/small",
          large: "https://images.scrydex.com/pokemon/me4-46/large",
        },
        flavorText:
          "It moves while spinning around on its single foot. Some Baltoy have been seen spinning on their heads.",
      },
    ],
  },
  {
    id: "me2pt5-91",
    name: "Banette",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Shuppet",
    attacks: [
      {
        name: "Cursed Words",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent chooses 3 cards from their hand and shuffles those cards into their deck.",
      },
      {
        name: "Spooky Shot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "91",
    flavorText:
      "This Pokémon developed from an abandoned doll that amassed a grudge. It is seen in dark alleys.",
    nationalPokedexNumbers: [354],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-91/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-91/large",
    },
    altArts: [
      {
        id: "me2pt5-91",
        number: "91",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-91/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-91/large",
        },
        flavorText:
          "This Pokémon developed from an abandoned doll that amassed a grudge. It is seen in dark alleys.",
      },
      {
        id: "me2pt5-234",
        number: "234",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-234/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-234/large",
        },
        flavorText:
          "This Pokémon developed from an abandoned doll that amassed a grudge. It is seen in dark alleys.",
      },
      {
        id: "sv9-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv9/60.png",
          large: "https://images.pokemontcg.io/sv9/60_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-34",
    name: "Banette",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Psychic"],
    evolvesFrom: "Shuppet",
    abilities: [
      {
        name: "Hide 'n' Sneak",
        text: "Prevent all effects of your opponent's Pokémon's attacks and Abilities done to this Pokémon. (Damage is not an effect.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Puppet Pull",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "80",
        text: "You may search your deck for a card and put it into your hand. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "34",
    flavorText:
      "A doll bore a grudge over being junked, and it became a Pokémon. It seeks the child that disowned it.",
    nationalPokedexNumbers: [354],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-34/small",
      large: "https://images.scrydex.com/pokemon/me5-34/large",
    },
    altArts: [
      {
        id: "me5-34",
        number: "34",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-34/small",
          large: "https://images.scrydex.com/pokemon/me5-34/large",
        },
        flavorText:
          "A doll bore a grudge over being junked, and it became a Pokémon. It seeks the child that disowned it.",
      },
    ],
  },
  {
    id: "me3-43",
    name: "Barbaracle",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Binacle",
    abilities: [
      {
        name: "Stone Arms",
        text: "Once during your turn, you may use this Ability. Attach a Basic Fighting Energy card from your hand to 1 of your Fighting Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    nationalPokedexNumbers: [689],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-43/small",
      large: "https://images.scrydex.com/pokemon/me3-43/large",
    },
    altArts: [
      {
        id: "me3-43",
        number: "43",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-43/small",
          large: "https://images.scrydex.com/pokemon/me3-43/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-63",
    name: "Barraskewda",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Water"],
    evolvesFrom: "Arrokuda",
    attacks: [
      {
        name: "Sharp Fin",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Dive",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    nationalPokedexNumbers: [847],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/63.png",
      large: "https://images.pokemontcg.io/sv10/63_hires.png",
    },
    altArts: [
      {
        id: "sv10-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv10/63.png",
          large: "https://images.pokemontcg.io/sv10/63_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-24",
    name: "Basculin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Water"],
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Bared Fangs",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "If your opponent's Active Pokémon has no damage counters on it before this attack does damage, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    flavorText:
      "Red and blue Basculin get along so poorly, they'll start fighting instantly. These Pokémon are very hostile.",
    nationalPokedexNumbers: [550],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/24.png",
      large: "https://images.pokemontcg.io/rsv10pt5/24_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/24.png",
          large: "https://images.pokemontcg.io/rsv10pt5/24_hires.png",
        },
        flavorText:
          "Red and blue Basculin get along so poorly, they'll start fighting instantly. These Pokémon are very hostile.",
      },
      {
        id: "rsv10pt5-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/108.png",
          large: "https://images.pokemontcg.io/rsv10pt5/108_hires.png",
        },
        flavorText:
          "Red and blue Basculin get along so poorly, they'll start fighting instantly. These Pokémon are very hostile.",
      },
    ],
  },
  {
    id: "me5-62",
    name: "Bastiodon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Metal"],
    evolvesFrom: "Shieldon",
    abilities: [
      {
        name: "Ancient Bulwark",
        text: "As long as this Pokémon is on your Bench, prevent all damage done to each of your Pokémon by attacks from your opponent's Pokémon that have 2 or less Energy attached.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "62",
    flavorText:
      "Bastiodon live in herds. When assaulted by enemies, they line up side by side and use their hard faces to block attacks.",
    nationalPokedexNumbers: [411],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-62/small",
      large: "https://images.scrydex.com/pokemon/me5-62/large",
    },
    altArts: [
      {
        id: "me5-62",
        number: "62",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-62/small",
          large: "https://images.scrydex.com/pokemon/me5-62/large",
        },
        flavorText:
          "Bastiodon live in herds. When assaulted by enemies, they line up side by side and use their hard faces to block attacks.",
      },
      {
        id: "me5-93",
        number: "93",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-93/small",
          large: "https://images.scrydex.com/pokemon/me5-93/large",
        },
        flavorText:
          "Bastiodon live in herds. When assaulted by enemies, they line up side by side and use their hard faces to block attacks.",
      },
    ],
  },
  {
    id: "me1-9",
    name: "Bayleef",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Grass"],
    evolvesFrom: "Chikorita",
    evolvesTo: ["Meganium"],
    attacks: [
      {
        name: "Push Down",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "9",
    nationalPokedexNumbers: [153],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/9.png",
      large: "https://images.pokemontcg.io/me1/9_hires.png",
    },
    altArts: [
      {
        id: "me1-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/me1/9.png",
          large: "https://images.pokemontcg.io/me1/9_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-9",
    name: "Bayleef",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Chikorita",
    attacks: [
      {
        name: "Leaf Step",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "9",
    nationalPokedexNumbers: [153],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-9/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-9/large",
    },
    altArts: [
      {
        id: "me2pt5-9",
        number: "9",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-9/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-9/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-26",
    name: "Beartic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "Cubchoo",
    attacks: [
      {
        name: "Continuous Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "Flip a coin until you get tails. This attack does 50 damage for each heads.",
      },
      {
        name: "Sheer Cold",
        cost: ["Water", "Water", "Water", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "During your opponent's next turn, the Defending Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "26",
    flavorText:
      "It can make its breath freeze at will. Very able in the water, it swims around in northern seas and catches prey.",
    nationalPokedexNumbers: [614],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/26.png",
      large: "https://images.pokemontcg.io/zsv10pt5/26_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/26.png",
          large: "https://images.pokemontcg.io/zsv10pt5/26_hires.png",
        },
        flavorText:
          "It can make its breath freeze at will. Very able in the water, it swims around in northern seas and catches prey.",
      },
      {
        id: "zsv10pt5-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/110.png",
          large: "https://images.pokemontcg.io/zsv10pt5/110_hires.png",
        },
        flavorText:
          "It can make its breath freeze at will. Very able in the water, it swims around in northern seas and catches prey.",
      },
    ],
  },
  {
    id: "me2pt5-13",
    name: "Beautifly",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Silcoon",
    attacks: [
      {
        name: "Stun Spore",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Energy Straw",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "80×",
        text: "Your opponent reveals their hand, and this attack does 80 damage for each Energy card you find there.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "13",
    flavorText:
      "Vibrantly patterned wings are its prominent feature. It sucks sweet flower nectar with its long mouth.",
    nationalPokedexNumbers: [267],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-13/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-13/large",
    },
    altArts: [
      {
        id: "me2pt5-13",
        number: "13",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-13/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-13/large",
        },
        flavorText:
          "Vibrantly patterned wings are its prominent feature. It sucks sweet flower nectar with its long mouth.",
      },
      {
        id: "me2pt5-219",
        number: "219",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-219/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-219/large",
        },
        flavorText:
          "Vibrantly patterned wings are its prominent feature. It sucks sweet flower nectar with its long mouth.",
      },
    ],
  },
  {
    id: "me4-3",
    name: "Beedrill ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "310",
    types: ["Grass"],
    evolvesFrom: "Kakuna",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Rumbling Bees",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "110×",
        text: "This attack does 110 damage for each of your Beedrill and Beedrill ex in play.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    nationalPokedexNumbers: [15],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-3/small",
      large: "https://images.scrydex.com/pokemon/me4-3/large",
    },
    altArts: [
      {
        id: "me4-3",
        number: "3",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-3/small",
          large: "https://images.scrydex.com/pokemon/me4-3/large",
        },
        flavorText: "",
      },
      {
        id: "me4-98",
        number: "98",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-98/small",
          large: "https://images.scrydex.com/pokemon/me4-98/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-41",
    name: "Beheeyem",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Elgyem",
    attacks: [
      {
        name: "Calm Mind",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 40 damage from this Pokémon.",
      },
      {
        name: "Psychic",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "This attack does 30 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    flavorText:
      "It can manipulate an opponent's memory. Apparently, it communicates by flashing its three different-colored fingers.",
    nationalPokedexNumbers: [606],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/41.png",
      large: "https://images.pokemontcg.io/zsv10pt5/41_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/41.png",
          large: "https://images.pokemontcg.io/zsv10pt5/41_hires.png",
        },
        flavorText:
          "It can manipulate an opponent's memory. Apparently, it communicates by flashing its three different-colored fingers.",
      },
      {
        id: "zsv10pt5-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/121.png",
          large: "https://images.pokemontcg.io/zsv10pt5/121_hires.png",
        },
        flavorText:
          "It can manipulate an opponent's memory. Apparently, it communicates by flashing its three different-colored fingers.",
      },
    ],
  },
  {
    id: "sv5-74",
    name: "Beheeyem",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Psychic"],
    evolvesFrom: "Elgyem",
    attacks: [
      {
        name: "Cosmic Beatdown",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each of your Pokémon in play.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "74",
    flavorText:
      "Whenever a Beheeyem visits a farm, a Dubwool mysteriously disappears.",
    nationalPokedexNumbers: [606],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/74.png",
      large: "https://images.pokemontcg.io/sv5/74_hires.png",
    },
    altArts: [
      {
        id: "sv5-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv5/74.png",
          large: "https://images.pokemontcg.io/sv5/74_hires.png",
        },
        flavorText:
          "Whenever a Beheeyem visits a farm, a Dubwool mysteriously disappears.",
      },
    ],
  },
  {
    id: "me4-59",
    name: "Beldum",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Beam",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    flavorText:
      "They communicate with one another by using magnetic pulses. In a swarm, they move in perfect unison.",
    nationalPokedexNumbers: [374],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-59/small",
      large: "https://images.scrydex.com/pokemon/me4-59/large",
    },
    altArts: [
      {
        id: "me4-59",
        number: "59",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-59/small",
          large: "https://images.scrydex.com/pokemon/me4-59/large",
        },
        flavorText:
          "They communicate with one another by using magnetic pulses. In a swarm, they move in perfect unison.",
      },
    ],
  },
  {
    id: "sv5-113",
    name: "Beldum",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    evolvesTo: ["Metang"],
    attacks: [
      {
        name: "Dig Claws",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Iron Tackle",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "113",
    flavorText:
      "From its rear, Beldum emits a magnetic force that rapidly pulls opponents in. They get skewered on Beldum's sharp claws.",
    nationalPokedexNumbers: [374],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/113.png",
      large: "https://images.pokemontcg.io/sv5/113_hires.png",
    },
    altArts: [
      {
        id: "sv5-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/sv5/113.png",
          large: "https://images.pokemontcg.io/sv5/113_hires.png",
        },
        flavorText:
          "From its rear, Beldum emits a magnetic force that rapidly pulls opponents in. They get skewered on Beldum's sharp claws.",
      },
    ],
  },
  {
    id: "sv9-61",
    name: "Beldum",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Metang"],
    attacks: [
      {
        name: "Spinning Attack",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Beam",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "61",
    nationalPokedexNumbers: [374],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/61.png",
      large: "https://images.pokemontcg.io/sv9/61_hires.png",
    },
    altArts: [
      {
        id: "sv9-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv9/61.png",
          large: "https://images.pokemontcg.io/sv9/61_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-74",
    name: "Bellibolt",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Lightning"],
    evolvesFrom: "Tadbulb",
    attacks: [
      {
        name: "Thunder Shock",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Electric Ball",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "74",
    flavorText:
      "What appear to be eyeballs are actually organs for discharging the electricity generated by Bellibolt's belly-button dynamo.",
    nationalPokedexNumbers: [939],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/74.png",
      large: "https://images.pokemontcg.io/sv6/74_hires.png",
    },
    altArts: [
      {
        id: "sv6-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv6/74.png",
          large: "https://images.pokemontcg.io/sv6/74_hires.png",
        },
        flavorText:
          "What appear to be eyeballs are actually organs for discharging the electricity generated by Bellibolt's belly-button dynamo.",
      },
    ],
  },
  {
    id: "me4-23",
    name: "Bergmite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    attacks: [
      {
        name: "Chilly",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Frost Breath",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    flavorText:
      "It blocks opponents' attacks with the ice that shields its body. If the ice breaks, this Pokémon uses cold air to quickly create new ice.",
    nationalPokedexNumbers: [712],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-23/small",
      large: "https://images.scrydex.com/pokemon/me4-23/large",
    },
    altArts: [
      {
        id: "me4-23",
        number: "23",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-23/small",
          large: "https://images.scrydex.com/pokemon/me4-23/large",
        },
        flavorText:
          "It blocks opponents' attacks with the ice that shields its body. If the ice breaks, this Pokémon uses cold air to quickly create new ice.",
      },
    ],
  },
  {
    id: "me1-112",
    name: "Bewear",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Colorless"],
    evolvesFrom: "Stufful",
    attacks: [
      {
        name: "Knuckle Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Hyper Lariat",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "Flip 2 coins. If both of them are heads, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "112",
    nationalPokedexNumbers: [760],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/112.png",
      large: "https://images.pokemontcg.io/me1/112_hires.png",
    },
    altArts: [
      {
        id: "me1-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/me1/112.png",
          large: "https://images.pokemontcg.io/me1/112_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-53",
    name: "Bewear",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Colorless"],
    evolvesFrom: "Stufful",
    attacks: [
      {
        name: "Power Charger",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Search your deck for a Basic Energy card and attach it to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Hammer In",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "53",
    nationalPokedexNumbers: [760],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/53.png",
      large: "https://images.pokemontcg.io/sv6pt5/53_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/53.png",
          large: "https://images.pokemontcg.io/sv6pt5/53_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/79.png",
          large: "https://images.pokemontcg.io/sv6pt5/79_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-42",
    name: "Binacle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    attacks: [
      {
        name: "Double Draw",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Scratch",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "42",
    nationalPokedexNumbers: [688],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-42/small",
      large: "https://images.scrydex.com/pokemon/me3-42/large",
    },
    altArts: [
      {
        id: "me3-42",
        number: "42",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-42/small",
          large: "https://images.scrydex.com/pokemon/me3-42/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-65",
    name: "Bisharp",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Metal"],
    evolvesFrom: "Pawniard",
    attacks: [
      {
        name: "Cut Up",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Finishing Blow",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "65",
    flavorText:
      "It leads a group of Pawniard. It battles to become the boss, but will be driven from the group if it loses.",
    nationalPokedexNumbers: [625],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/65.png",
      large: "https://images.pokemontcg.io/zsv10pt5/65_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/65.png",
          large: "https://images.pokemontcg.io/zsv10pt5/65_hires.png",
        },
        flavorText:
          "It leads a group of Pawniard. It battles to become the boss, but will be driven from the group if it loses.",
      },
      {
        id: "zsv10pt5-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/143.png",
          large: "https://images.pokemontcg.io/zsv10pt5/143_hires.png",
        },
        flavorText:
          "It leads a group of Pawniard. It battles to become the boss, but will be driven from the group if it loses.",
      },
    ],
  },
  {
    id: "me2pt5-147",
    name: "Bisharp",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Metal"],
    evolvesFrom: "Pawniard",
    attacks: [
      {
        name: "Rapid Draw",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Draw 2 cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "147",
    flavorText:
      "Bisharp mercilessly cuts its opponents to pieces with the sharp blades covering its body. It will do anything to win.",
    nationalPokedexNumbers: [625],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-147/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-147/large",
    },
    altArts: [
      {
        id: "me2pt5-147",
        number: "147",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-147/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-147/large",
        },
        flavorText:
          "Bisharp mercilessly cuts its opponents to pieces with the sharp blades covering its body. It will do anything to win.",
      },
    ],
  },
  {
    id: "svp-112",
    name: "Bisharp",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Pawniard",
    attacks: [
      {
        name: "Cut",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "112",
    nationalPokedexNumbers: [625],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/112.png",
      large: "https://images.pokemontcg.io/svp/112_hires.png",
    },
    altArts: [
      {
        id: "svp-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/svp/112.png",
          large: "https://images.pokemontcg.io/svp/112_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-48",
    name: "Black Kyurem ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Ice Age",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "If your opponent's Active Pokémon is a Dragon Pokémon, it is now Paralyzed.",
      },
      {
        name: "Black Frost",
        cost: ["Water", "Water", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "250",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "48",
    nationalPokedexNumbers: [646],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/48.png",
      large: "https://images.pokemontcg.io/sv8/48_hires.png",
    },
    altArts: [
      {
        id: "sv8-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv8/48.png",
          large: "https://images.pokemontcg.io/sv8/48_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-218",
        number: "218",
        images: {
          small: "https://images.pokemontcg.io/sv8/218.png",
          large: "https://images.pokemontcg.io/sv8/218_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-42",
    name: "Blaziken",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Fire"],
    evolvesFrom: "Combusken",
    attacks: [
      {
        name: "Heat Blast",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
      {
        name: "Inferno Kick Flurry",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Discard 2 Energy from this Pokémon. This attack also does 120 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "42",
    nationalPokedexNumbers: [257],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/42.png",
      large: "https://images.pokemontcg.io/sv10/42_hires.png",
    },
    altArts: [
      {
        id: "sv10-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/sv10/42.png",
          large: "https://images.pokemontcg.io/sv10/42_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-192",
        number: "192",
        images: {
          small: "https://images.pokemontcg.io/sv10/192.png",
          large: "https://images.pokemontcg.io/sv10/192_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-24",
    name: "Blaziken ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Fire"],
    evolvesFrom: "Combusken",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Seething Spirit",
        text: "Once during your turn, you may attach a Basic Energy card from your discard pile to 1 of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Smolder-sault",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "200",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "24",
    nationalPokedexNumbers: [257],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/24.png",
      large: "https://images.pokemontcg.io/sv9/24_hires.png",
    },
    altArts: [
      {
        id: "sv9-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv9/24.png",
          large: "https://images.pokemontcg.io/sv9/24_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-134",
    name: "Blissey ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "300",
    types: ["Colorless"],
    evolvesFrom: "Chansey",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Happy Switch",
        text: "Once during your turn, you may move a Basic Energy from 1 of your Pokémon to another of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Return",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "You may draw cards until you have 6 cards in your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "134",
    nationalPokedexNumbers: [242],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/134.png",
      large: "https://images.pokemontcg.io/sv6/134_hires.png",
    },
    altArts: [
      {
        id: "sv6-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/sv6/134.png",
          large: "https://images.pokemontcg.io/sv6/134_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-201",
        number: "201",
        images: {
          small: "https://images.pokemontcg.io/sv6/201.png",
          large: "https://images.pokemontcg.io/sv6/201_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-31",
    name: "Blitzle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Zebstrika"],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Zap Kick",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    flavorText:
      "Its mane shines when it discharges electricity. They use their flashing manes to communicate with one another.",
    nationalPokedexNumbers: [522],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/31.png",
      large: "https://images.pokemontcg.io/rsv10pt5/31_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/31.png",
          large: "https://images.pokemontcg.io/rsv10pt5/31_hires.png",
        },
        flavorText:
          "Its mane shines when it discharges electricity. They use their flashing manes to communicate with one another.",
      },
      {
        id: "rsv10pt5-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/114.png",
          large: "https://images.pokemontcg.io/rsv10pt5/114_hires.png",
        },
        flavorText:
          "Its mane shines when it discharges electricity. They use their flashing manes to communicate with one another.",
      },
    ],
  },
  {
    id: "sv8-62",
    name: "Blitzle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Zebstrika"],
    attacks: [
      {
        name: "Add On",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Static Shock",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    nationalPokedexNumbers: [522],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/62.png",
      large: "https://images.pokemontcg.io/sv8/62_hires.png",
    },
    altArts: [
      {
        id: "sv8-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/sv8/62.png",
          large: "https://images.pokemontcg.io/sv8/62_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-25",
    name: "Bloodmoon Ursaluna",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "150",
    types: ["Fighting"],
    abilities: [
      {
        name: "Battle-Hardened",
        text: "When you play this Pokémon from your hand onto your Bench during your turn, you may attach up to 2 Basic Fighting Energy cards from your hand to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mad Bite",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "This attack does 30 more damage for each damage counter on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "25",
    nationalPokedexNumbers: [901],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/25.png",
      large: "https://images.pokemontcg.io/sv6pt5/25_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/25.png",
          large: "https://images.pokemontcg.io/sv6pt5/25_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/54.png",
          large: "https://images.pokemontcg.io/sv8pt5/54_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-141",
    name: "Bloodmoon Ursaluna ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "260",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Seasoned Skill",
        text: "Blood Moon used by this Pokémon costs Colorless less for each Prize card your opponent has taken.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Blood Moon",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 5,
        damage: "240",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "141",
    nationalPokedexNumbers: [901],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/141.png",
      large: "https://images.pokemontcg.io/sv6/141_hires.png",
    },
    altArts: [
      {
        id: "sv6-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/sv6/141.png",
          large: "https://images.pokemontcg.io/sv6/141_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-202",
        number: "202",
        images: {
          small: "https://images.pokemontcg.io/sv6/202.png",
          large: "https://images.pokemontcg.io/sv6/202_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-216",
        number: "216",
        images: {
          small: "https://images.pokemontcg.io/sv6/216.png",
          large: "https://images.pokemontcg.io/sv6/216_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-222",
        number: "222",
        images: {
          small: "https://images.pokemontcg.io/sv6/222.png",
          large: "https://images.pokemontcg.io/sv6/222_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/168.png",
          large: "https://images.pokemontcg.io/sv8pt5/168_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-47",
    name: "Boldore",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Roggenrola",
    evolvesTo: ["Gigalith"],
    attacks: [
      {
        name: "Smack Down",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your opponent's Active Pokémon has Fighting Resistance, this attack does 50 more damage.",
      },
      {
        name: "Power Gem",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "47",
    flavorText:
      "When it overflows with power, the orange crystal on its body glows. It looks for underground water in caves.",
    nationalPokedexNumbers: [525],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/47.png",
      large: "https://images.pokemontcg.io/rsv10pt5/47_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/47.png",
          large: "https://images.pokemontcg.io/rsv10pt5/47_hires.png",
        },
        flavorText:
          "When it overflows with power, the orange crystal on its body glows. It looks for underground water in caves.",
      },
      {
        id: "rsv10pt5-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/128.png",
          large: "https://images.pokemontcg.io/rsv10pt5/128_hires.png",
        },
        flavorText:
          "When it overflows with power, the orange crystal on its body glows. It looks for underground water in caves.",
      },
    ],
  },
  {
    id: "me2-31",
    name: "Boltund",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Lightning"],
    evolvesFrom: "Yamper",
    attacks: [
      {
        name: "Electric Run",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70+",
        text: "Flip a coin. If heads, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    flavorText:
      "It sends electricity through its legs to boost their strength. Running at top speed, it easily breaks 50 mph.",
    nationalPokedexNumbers: [836],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/31.png",
      large: "https://images.pokemontcg.io/me2/31_hires.png",
    },
    altArts: [
      {
        id: "me2-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/me2/31.png",
          large: "https://images.pokemontcg.io/me2/31_hires.png",
        },
        flavorText:
          "It sends electricity through its legs to boost their strength. Running at top speed, it easily breaks 50 mph.",
      },
    ],
  },
  {
    id: "sv5-59",
    name: "Boltund",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Yamper",
    attacks: [
      {
        name: "Electrifying Dash",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Search your deck for up to 2 Basic Lightning Energy cards and attach them to your Benched Pokémon in any way you like. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    flavorText:
      "This Pokémon generates electricity and channels it into its legs to keep them going strong. Boltund can run nonstop for three full days.",
    nationalPokedexNumbers: [836],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/59.png",
      large: "https://images.pokemontcg.io/sv5/59_hires.png",
    },
    altArts: [
      {
        id: "sv5-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/sv5/59.png",
          large: "https://images.pokemontcg.io/sv5/59_hires.png",
        },
        flavorText:
          "This Pokémon generates electricity and channels it into its legs to keep them going strong. Boltund can run nonstop for three full days.",
      },
    ],
  },
  {
    id: "me5-71",
    name: "Bombirdier",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Colorless"],
    attacks: [
      {
        name: "Challenging Delivery",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Flip 2 coins. If both of them are heads, search your deck for a Pokémon and put it onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Speed Wing",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "71",
    flavorText:
      "Bombirdier uses the apron on its chest to bundle up food, which it carries back to its nest. It enjoys dropping things that make loud noises.",
    nationalPokedexNumbers: [962],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-71/small",
      large: "https://images.scrydex.com/pokemon/me5-71/large",
    },
    altArts: [
      {
        id: "me5-71",
        number: "71",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-71/small",
          large: "https://images.scrydex.com/pokemon/me5-71/large",
        },
        flavorText:
          "Bombirdier uses the apron on its chest to bundle up food, which it carries back to its nest. It enjoys dropping things that make loud noises.",
      },
    ],
  },
  {
    id: "sv7-97",
    name: "Bombirdier",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Darkness"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "97",
    nationalPokedexNumbers: [962],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/97.png",
      large: "https://images.pokemontcg.io/sv7/97_hires.png",
    },
    altArts: [
      {
        id: "sv7-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv7/97.png",
          large: "https://images.pokemontcg.io/sv7/97_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-101",
    name: "Bombirdier",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Darkness"],
    attacks: [
      {
        name: "Glide",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Drop Shot",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Energy from this Pokémon, and this attack does 120 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "101",
    nationalPokedexNumbers: [962],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/101.png",
      large: "https://images.pokemontcg.io/sv9/101_hires.png",
    },
    altArts: [
      {
        id: "sv9-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/sv9/101.png",
          large: "https://images.pokemontcg.io/sv9/101_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-119",
    name: "Bouffalant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Colorless"],
    abilities: [
      {
        name: "Curly Wall",
        text: "As long as you have at least 1 other Bouffalant in play, all of your Basic Colorless Pokémon take 60 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance). The effect of Curly Wall doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Boundless Power",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "119",
    nationalPokedexNumbers: [626],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/119.png",
      large: "https://images.pokemontcg.io/sv7/119_hires.png",
    },
    altArts: [
      {
        id: "sv7-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/sv7/119.png",
          large: "https://images.pokemontcg.io/sv7/119_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/svp/136.png",
          large: "https://images.pokemontcg.io/svp/136_hires.png",
        },
        flavorText:
          "These Pokémon can crush a car with no more than a headbutt. Bouffalant with more hair on their heads hold higher positions within the herd.",
      },
    ],
  },
  {
    id: "sv8-151",
    name: "Bouffalant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Colorless"],
    attacks: [
      {
        name: "Ready to Ram",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "During your opponent's next turn, if this Pokémon is damaged by an attack (even if this Pokémon is Knocked Out), put 6 damage counters on the Attacking Pokémon.",
      },
      {
        name: "Smashing Headbutt",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "151",
    nationalPokedexNumbers: [626],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/151.png",
      large: "https://images.pokemontcg.io/sv8/151_hires.png",
    },
    altArts: [
      {
        id: "sv8-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/sv8/151.png",
          large: "https://images.pokemontcg.io/sv8/151_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-77",
    name: "Bouffalant ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "220",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Bouffer",
        text: "This Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Gold Breaker",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "77",
    nationalPokedexNumbers: [626],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/77.png",
      large: "https://images.pokemontcg.io/rsv10pt5/77_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/77.png",
          large: "https://images.pokemontcg.io/rsv10pt5/77_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/162.png",
          large: "https://images.pokemontcg.io/rsv10pt5/162_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/170.png",
          large: "https://images.pokemontcg.io/rsv10pt5/170_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-12",
    name: "Braixen",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fire"],
    evolvesFrom: "Fennekin",
    attacks: [
      {
        name: "Flamethrower",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "12",
    flavorText:
      "It keeps a twig in its tail. Using friction from its tail fur, it sets the twig on fire and launches into battle.",
    nationalPokedexNumbers: [654],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-12/small",
      large: "https://images.scrydex.com/pokemon/me4-12/large",
    },
    altArts: [
      {
        id: "me4-12",
        number: "12",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-12/small",
          large: "https://images.scrydex.com/pokemon/me4-12/large",
        },
        flavorText:
          "It keeps a twig in its tail. Using friction from its tail fur, it sets the twig on fire and launches into battle.",
      },
    ],
  },
  {
    id: "me2-47",
    name: "Brambleghast",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Psychic"],
    evolvesFrom: "Bramblin",
    abilities: [
      {
        name: "Prison Panic",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Make your opponent's Active Pokémon Confused.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Psychic Sphere",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "47",
    flavorText:
      "It will open the branches of its head to envelop its prey. Once it absorbs all the life energy it needs, it expels the prey and discards it.",
    nationalPokedexNumbers: [947],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/47.png",
      large: "https://images.pokemontcg.io/me2/47_hires.png",
    },
    altArts: [
      {
        id: "me2-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/me2/47.png",
          large: "https://images.pokemontcg.io/me2/47_hires.png",
        },
        flavorText:
          "It will open the branches of its head to envelop its prey. Once it absorbs all the life energy it needs, it expels the prey and discards it.",
      },
    ],
  },
  {
    id: "sv5-21",
    name: "Brambleghast",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Bramblin",
    abilities: [
      {
        name: "Resilient Soul",
        text: "This Pokémon gets +50 HP for each Prize card your opponent has taken.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Powerful Needles",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80×",
        text: "Flip a coin for each Energy attached to this Pokémon. This attack does 80 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "21",
    flavorText:
      "Brambleghast wanders around arid regions. On rare occasions, mass outbreaks of these Pokémon will bury an entire town.",
    nationalPokedexNumbers: [947],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/21.png",
      large: "https://images.pokemontcg.io/sv5/21_hires.png",
    },
    altArts: [
      {
        id: "sv5-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/sv5/21.png",
          large: "https://images.pokemontcg.io/sv5/21_hires.png",
        },
        flavorText:
          "Brambleghast wanders around arid regions. On rare occasions, mass outbreaks of these Pokémon will bury an entire town.",
      },
    ],
  },
  {
    id: "me2-46",
    name: "Bramblin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    attacks: [
      {
        name: "Sneaky Placement",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Place 1 damage counter on 1 of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "46",
    flavorText:
      "A soul unable to move on to the afterlife was blown around by the wind until it got tangled up with dried grass and became a Pokémon.",
    nationalPokedexNumbers: [946],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/46.png",
      large: "https://images.pokemontcg.io/me2/46_hires.png",
    },
    altArts: [
      {
        id: "me2-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/me2/46.png",
          large: "https://images.pokemontcg.io/me2/46_hires.png",
        },
        flavorText:
          "A soul unable to move on to the afterlife was blown around by the wind until it got tangled up with dried grass and became a Pokémon.",
      },
    ],
  },
  {
    id: "sv5-20",
    name: "Bramblin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    attacks: [
      {
        name: "Spike Sting",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "20",
    flavorText:
      "Not even Bramblin knows where it is headed as it tumbles across the wilderness, blown by the wind. It loathes getting wet.",
    nationalPokedexNumbers: [946],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/20.png",
      large: "https://images.pokemontcg.io/sv5/20_hires.png",
    },
    altArts: [
      {
        id: "sv5-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv5/20.png",
          large: "https://images.pokemontcg.io/sv5/20_hires.png",
        },
        flavorText:
          "Not even Bramblin knows where it is headed as it tumbles across the wilderness, blown by the wind. It loathes getting wet.",
      },
    ],
  },
  {
    id: "zsv10pt5-78",
    name: "Braviary",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Colorless"],
    evolvesFrom: "Rufflet",
    attacks: [
      {
        name: "Aerial Ace",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40+",
        text: "Flip a coin. If heads, this attack does 40 more damage.",
      },
      {
        name: "Speed Wing",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    flavorText:
      "They fight for their friends without any thought about danger to themselves. One can carry a car while flying.",
    nationalPokedexNumbers: [628],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/78.png",
      large: "https://images.pokemontcg.io/zsv10pt5/78_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/78.png",
          large: "https://images.pokemontcg.io/zsv10pt5/78_hires.png",
        },
        flavorText:
          "They fight for their friends without any thought about danger to themselves. One can carry a car while flying.",
      },
      {
        id: "zsv10pt5-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/155.png",
          large: "https://images.pokemontcg.io/zsv10pt5/155_hires.png",
        },
        flavorText:
          "They fight for their friends without any thought about danger to themselves. One can carry a car while flying.",
      },
    ],
  },
  {
    id: "sv8-153",
    name: "Braviary",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Colorless"],
    evolvesFrom: "Rufflet",
    attacks: [
      {
        name: "Drag Off",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot. This attack does 40 damage to the new Active Pokémon.",
      },
      {
        name: "Blasting Wind",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "153",
    nationalPokedexNumbers: [628],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/153.png",
      large: "https://images.pokemontcg.io/sv8/153_hires.png",
    },
    altArts: [
      {
        id: "sv8-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/sv8/153.png",
          large: "https://images.pokemontcg.io/sv8/153_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-214",
        number: "214",
        images: {
          small: "https://images.pokemontcg.io/sv8/214.png",
          large: "https://images.pokemontcg.io/sv8/214_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-6",
    name: "Breloom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Shroomish",
    attacks: [
      {
        name: "Damage Rush",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "Flip a coin until you get tails. This attack does 50 more damage for each heads.",
      },
      {
        name: "Mega Drain",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "6",
    nationalPokedexNumbers: [286],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/6.png",
      large: "https://images.pokemontcg.io/sv10/6_hires.png",
    },
    altArts: [
      {
        id: "sv10-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv10/6.png",
          large: "https://images.pokemontcg.io/sv10/6_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-7",
    name: "Breloom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Shroomish",
    attacks: [
      {
        name: "Punch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Knuckle Impact",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    flavorText:
      "The seeds on its tail are made of toxic spores. It knocks out foes with quick, virtually invisible punches.",
    nationalPokedexNumbers: [286],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/7.png",
      large: "https://images.pokemontcg.io/sv5/7_hires.png",
    },
    altArts: [
      {
        id: "sv5-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv5/7.png",
          large: "https://images.pokemontcg.io/sv5/7_hires.png",
        },
        flavorText:
          "The seeds on its tail are made of toxic spores. It knocks out foes with quick, virtually invisible punches.",
      },
    ],
  },
  {
    id: "me5-19",
    name: "Brionne",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Popplio",
    attacks: [
      {
        name: "Hyper Voice",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    flavorText:
      "It cares deeply for its companions. When its Trainer is feeling down, it performs a cheery dance to try to help.",
    nationalPokedexNumbers: [729],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-19/small",
      large: "https://images.scrydex.com/pokemon/me5-19/large",
    },
    altArts: [
      {
        id: "me5-19",
        number: "19",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-19/small",
          large: "https://images.scrydex.com/pokemon/me5-19/large",
        },
        flavorText:
          "It cares deeply for its companions. When its Trainer is feeling down, it performs a cheery dance to try to help.",
      },
    ],
  },
  {
    id: "me2-72",
    name: "Bronzong",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Metal"],
    evolvesFrom: "Bronzor",
    attacks: [
      {
        name: "Triple Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 3 cards.",
      },
      {
        name: "Tool Drop",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40×",
        text: "This attack does 40 damage for each Pokémon Tool attached to all Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "72",
    flavorText:
      "In ages past, this Pokémon was revered as a bringer of rain. It was found buried in the ground.",
    nationalPokedexNumbers: [437],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/72.png",
      large: "https://images.pokemontcg.io/me2/72_hires.png",
    },
    altArts: [
      {
        id: "me2-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/me2/72.png",
          large: "https://images.pokemontcg.io/me2/72_hires.png",
        },
        flavorText:
          "In ages past, this Pokémon was revered as a bringer of rain. It was found buried in the ground.",
      },
    ],
  },
  {
    id: "me5-64",
    name: "Bronzong",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Bronzor",
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Metal Block",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your opponent's next turn, this Pokémon takes 100 less damage from attacks from Evolution Pokémon (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "64",
    flavorText:
      "It brought rains by opening portals to another world. It was revered as a bringer of plentiful harvests.",
    nationalPokedexNumbers: [437],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-64/small",
      large: "https://images.scrydex.com/pokemon/me5-64/large",
    },
    altArts: [
      {
        id: "me5-64",
        number: "64",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-64/small",
          large: "https://images.scrydex.com/pokemon/me5-64/large",
        },
        flavorText:
          "It brought rains by opening portals to another world. It was revered as a bringer of plentiful harvests.",
      },
    ],
  },
  {
    id: "sv5-69",
    name: "Bronzong",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Psychic"],
    evolvesFrom: "Bronzor",
    attacks: [
      {
        name: "Evolution Jammer",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your opponent's next turn, they can't play any Pokémon from their hand to evolve their Pokémon.",
      },
      {
        name: "Super Psy Bolt",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "69",
    flavorText:
      "In ages past, this Pokémon was revered as a bringer of rain. It was found buried in the ground.",
    nationalPokedexNumbers: [437],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/69.png",
      large: "https://images.pokemontcg.io/sv5/69_hires.png",
    },
    altArts: [
      {
        id: "sv5-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv5/69.png",
          large: "https://images.pokemontcg.io/sv5/69_hires.png",
        },
        flavorText:
          "In ages past, this Pokémon was revered as a bringer of rain. It was found buried in the ground.",
      },
    ],
  },
  {
    id: "sv8-127",
    name: "Bronzong",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Bronzor",
    attacks: [
      {
        name: "Spinning Attack",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Double Impact",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100×",
        text: "Flip 2 coins. This attack does 100 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "127",
    nationalPokedexNumbers: [437],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/127.png",
      large: "https://images.pokemontcg.io/sv8/127_hires.png",
    },
    altArts: [
      {
        id: "sv8-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/sv8/127.png",
          large: "https://images.pokemontcg.io/sv8/127_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-67",
    name: "Bronzong",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Bronzor",
    abilities: [
      {
        name: "Protective Bell",
        text: "All of your Pokémon take 10 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Heavy Impact",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "67",
    nationalPokedexNumbers: [437],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/67.png",
      large: "https://images.pokemontcg.io/sv8pt5/67_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/67.png",
          large: "https://images.pokemontcg.io/sv8pt5/67_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-71",
    name: "Bronzor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Metal"],
    evolvesTo: ["Bronzong"],
    attacks: [
      {
        name: "Iron Defense",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage done to this Pokémon by attacks.",
      },
      {
        name: "Rollout",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "71",
    flavorText:
      "Ancient people believed that the pattern on Bronzor's back contained a mysterious power.",
    nationalPokedexNumbers: [436],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/71.png",
      large: "https://images.pokemontcg.io/me2/71_hires.png",
    },
    altArts: [
      {
        id: "me2-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/me2/71.png",
          large: "https://images.pokemontcg.io/me2/71_hires.png",
        },
        flavorText:
          "Ancient people believed that the pattern on Bronzor's back contained a mysterious power.",
      },
    ],
  },
  {
    id: "me5-63",
    name: "Bronzor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Metal"],
    attacks: [
      {
        name: "Mirror Attack",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If your opponent's Active Pokémon is a Metal Pokémon, this attack does 30 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "63",
    flavorText:
      "They are found in ancient tombs. The patterns on their backs are said to be imbued with mysterious power.",
    nationalPokedexNumbers: [436],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-63/small",
      large: "https://images.scrydex.com/pokemon/me5-63/large",
    },
    altArts: [
      {
        id: "me5-63",
        number: "63",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-63/small",
          large: "https://images.scrydex.com/pokemon/me5-63/large",
        },
        flavorText:
          "They are found in ancient tombs. The patterns on their backs are said to be imbued with mysterious power.",
      },
    ],
  },
  {
    id: "sv5-68",
    name: "Bronzor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    evolvesTo: ["Bronzong"],
    attacks: [
      {
        name: "Mirror Attack",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If your opponent's Active Pokémon is a Psychic Pokémon, this attack does 30 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "68",
    flavorText:
      "Ancient people believed that the pattern on Bronzor's back contained a mysterious power.",
    nationalPokedexNumbers: [436],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/68.png",
      large: "https://images.pokemontcg.io/sv5/68_hires.png",
    },
    altArts: [
      {
        id: "sv5-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv5/68.png",
          large: "https://images.pokemontcg.io/sv5/68_hires.png",
        },
        flavorText:
          "Ancient people believed that the pattern on Bronzor's back contained a mysterious power.",
      },
      {
        id: "sv5-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/sv5/170.png",
          large: "https://images.pokemontcg.io/sv5/170_hires.png",
        },
        flavorText:
          "Ancient people believed that the pattern on Bronzor's back contained a mysterious power.",
      },
    ],
  },
  {
    id: "sv8-126",
    name: "Bronzor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Metal"],
    evolvesTo: ["Bronzong"],
    attacks: [
      {
        name: "Shield Attack",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "126",
    nationalPokedexNumbers: [436],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/126.png",
      large: "https://images.pokemontcg.io/sv8/126_hires.png",
    },
    altArts: [
      {
        id: "sv8-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/sv8/126.png",
          large: "https://images.pokemontcg.io/sv8/126_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-66",
    name: "Bronzor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    evolvesTo: ["Bronzong"],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "66",
    nationalPokedexNumbers: [436],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/66.png",
      large: "https://images.pokemontcg.io/sv8pt5/66_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/66.png",
          large: "https://images.pokemontcg.io/sv8pt5/66_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-118",
    name: "Brute Bonnet",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "120",
    types: ["Darkness"],
    attacks: [
      {
        name: "Poison Spray",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
      {
        name: "Relentless Punches",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "50+",
        text: "This attack does 50 more damage for each damage counter on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "118",
    flavorText:
      "It is possible that the creature listed as Brute Bonnet in a certain book could actually be this Pokémon.",
    nationalPokedexNumbers: [986],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/118.png",
      large: "https://images.pokemontcg.io/sv6/118_hires.png",
    },
    altArts: [
      {
        id: "sv6-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/sv6/118.png",
          large: "https://images.pokemontcg.io/sv6/118_hires.png",
        },
        flavorText:
          "It is possible that the creature listed as Brute Bonnet in a certain book could actually be this Pokémon.",
      },
    ],
  },
  {
    id: "sv8-49",
    name: "Bruxish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    abilities: [
      {
        name: "Counterattack",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), put 3 damage counters on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Big Bite",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    nationalPokedexNumbers: [779],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/49.png",
      large: "https://images.pokemontcg.io/sv8/49_hires.png",
    },
    altArts: [
      {
        id: "sv8-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/sv8/49.png",
          large: "https://images.pokemontcg.io/sv8/49_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-200",
        number: "200",
        images: {
          small: "https://images.pokemontcg.io/sv8/200.png",
          large: "https://images.pokemontcg.io/sv8/200_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-16",
    name: "Budew",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Grass"],
    attacks: [
      {
        name: "Itchy Pollen",
        cost: [],
        convertedEnergyCost: 0,
        damage: "10",
        text: "During your opponent's next turn, they can't play any Item cards from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "16",
    flavorText:
      "The pollen it releases contains poison. If this Pokémon is raised on clean water, the poison’s toxicity is increased.",
    nationalPokedexNumbers: [406],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-16/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-16/large",
    },
    altArts: [
      {
        id: "me2pt5-16",
        number: "16",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-16/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-16/large",
        },
        flavorText:
          "The pollen it releases contains poison. If this Pokémon is raised on clean water, the poison’s toxicity is increased.",
      },
      {
        id: "me2pt5-221",
        number: "221",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-221/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-221/large",
        },
        flavorText:
          "The pollen it releases contains poison. If this Pokémon is raised on clean water, the poison’s toxicity is increased.",
      },
    ],
  },
  {
    id: "sv8pt5-4",
    name: "Budew",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Grass"],
    evolvesTo: ["Roselia"],
    attacks: [
      {
        name: "Itchy Pollen",
        cost: ["Free"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, they can't play any Item cards from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "4",
    nationalPokedexNumbers: [406],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/4.png",
      large: "https://images.pokemontcg.io/sv8pt5/4_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/4.png",
          large: "https://images.pokemontcg.io/sv8pt5/4_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-57",
    name: "Buizel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Floatzel"],
    attacks: [
      {
        name: "Tail Whap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Wave Splash",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    nationalPokedexNumbers: [418],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/57.png",
      large: "https://images.pokemontcg.io/sv10/57_hires.png",
    },
    altArts: [
      {
        id: "sv10-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv10/57.png",
          large: "https://images.pokemontcg.io/sv10/57_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-1",
    name: "Bulbasaur",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    evolvesTo: ["Ivysaur"],
    attacks: [
      {
        name: "Bind Down",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "1",
    nationalPokedexNumbers: [1],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/1.png",
      large: "https://images.pokemontcg.io/me1/1_hires.png",
    },
    altArts: [
      {
        id: "me1-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/me1/1.png",
          large: "https://images.pokemontcg.io/me1/1_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/me1/133.png",
          large: "https://images.pokemontcg.io/me1/133_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-107",
    name: "Buneary",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Lopunny"],
    attacks: [
      {
        name: "Charm",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 20 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Skip",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "107",
    nationalPokedexNumbers: [427],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/107.png",
      large: "https://images.pokemontcg.io/me1/107_hires.png",
    },
    altArts: [
      {
        id: "me1-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/me1/107.png",
          large: "https://images.pokemontcg.io/me1/107_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-83",
    name: "Buneary",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Lopunny"],
    attacks: [
      {
        name: "Run Around",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    flavorText:
      "Buneary can attack by rolling up their ears and then striking with the force created by unrolling them. This attack becomes stronger with training.",
    nationalPokedexNumbers: [427],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/83.png",
      large: "https://images.pokemontcg.io/me2/83_hires.png",
    },
    altArts: [
      {
        id: "me2-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/me2/83.png",
          large: "https://images.pokemontcg.io/me2/83_hires.png",
        },
        flavorText:
          "Buneary can attack by rolling up their ears and then striking with the force created by unrolling them. This attack becomes stronger with training.",
      },
    ],
  },
  {
    id: "sv8pt5-83",
    name: "Buneary",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Lopunny"],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    nationalPokedexNumbers: [427],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/83.png",
      large: "https://images.pokemontcg.io/sv8pt5/83_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/83.png",
          large: "https://images.pokemontcg.io/sv8pt5/83_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-64",
    name: "Bunnelby",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    nationalPokedexNumbers: [659],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-64/small",
      large: "https://images.scrydex.com/pokemon/me3-64/large",
    },
    altArts: [
      {
        id: "me3-64",
        number: "64",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-64/small",
          large: "https://images.scrydex.com/pokemon/me3-64/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-3",
    name: "Butterfree",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Metapod",
    attacks: [
      {
        name: "Scale Hurricane",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "60×",
        text: "Flip 4 coins. This attack does 60 damage for each heads. If at least 2 of them are heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    nationalPokedexNumbers: [12],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/3.png",
      large: "https://images.pokemontcg.io/sv9/3_hires.png",
    },
    altArts: [
      {
        id: "sv9-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv9/3.png",
          large: "https://images.pokemontcg.io/sv9/3_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-57",
    name: "Buzzwole-GX",
    supertype: "Pokémon",
    subtypes: ["Basic", "GX"],
    hp: "190",
    types: ["Fighting"],
    rules: [
      "When your Pokémon-GX is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Jet Punch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This attack does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Knuckle Impact",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "This Pokémon can't attack during your next turn.",
      },
      {
        name: "Absorption-GX",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "40×",
        text: "This attack does 40 damage for each of your remaining Prize cards. (You can't use more than 1 GX attack in a game.)",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "57",
    nationalPokedexNumbers: [794],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-57/small",
      large: "https://images.scrydex.com/pokemon/me55c-57/large",
    },
    altArts: [
      {
        id: "me55c-57",
        number: "57",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-57/small",
          large: "https://images.scrydex.com/pokemon/me55c-57/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-28",
    name: "Camerupt",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Numel",
    attacks: [
      {
        name: "Roasting Burn",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "110",
        text: "If your opponent's Active Pokémon isn't Burned, this attack does nothing.",
      },
      {
        name: "Power Stomp",
        cost: ["Fire", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "170",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "28",
    flavorText:
      "The volcanoes on its back have a major eruption every 10 years--or whenever it becomes really angry.",
    nationalPokedexNumbers: [323],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-28/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-28/large",
    },
    altArts: [
      {
        id: "me2pt5-28",
        number: "28",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-28/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-28/large",
        },
        flavorText:
          "The volcanoes on its back have a major eruption every 10 years--or whenever it becomes really angry.",
      },
    ],
  },
  {
    id: "sv8-12",
    name: "Capsakid",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Headbutt Bounce",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "12",
    nationalPokedexNumbers: [951],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/12.png",
      large: "https://images.pokemontcg.io/sv8/12_hires.png",
    },
    altArts: [
      {
        id: "sv8-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv8/12.png",
          large: "https://images.pokemontcg.io/sv8/12_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-117",
    name: "Carbink",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    abilities: [
      {
        name: "Double Type",
        text: "As long as this Pokémon is in play, it is Fighting and Psychic type.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Counter Jewel",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70+",
        text: "If your opponent has 2 or fewer Prize cards remaining, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "117",
    nationalPokedexNumbers: [703],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-117/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-117/large",
    },
    altArts: [
      {
        id: "me2pt5-117",
        number: "117",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-117/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-117/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-242",
        number: "242",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-242/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-242/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-119",
    name: "Carkol",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Rolycoly",
    attacks: [
      {
        name: "Guard Press",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your opponent's next turn, this Pokémon takes 20 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Power Gem",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "119",
    flavorText:
      "Due to the coal tar created inside it, the heap of coal on Carkol’s back never falls apart, even when the Pokémon rolls around at high speeds.",
    nationalPokedexNumbers: [838],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-119/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-119/large",
    },
    altArts: [
      {
        id: "me2pt5-119",
        number: "119",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-119/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-119/large",
        },
        flavorText:
          "Due to the coal tar created inside it, the heap of coal on Carkol’s back never falls apart, even when the Pokémon rolls around at high speeds.",
      },
    ],
  },
  {
    id: "sv5-94",
    name: "Carkol",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Rolycoly",
    evolvesTo: ["Coalossal"],
    attacks: [
      {
        name: "Knock Away",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 40 more damage.",
      },
      {
        name: "Boulder Crush",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "94",
    flavorText:
      "The temperature inside its body increases when it experiences strong emotions. It rolls around frantically while spewing flames.",
    nationalPokedexNumbers: [838],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/94.png",
      large: "https://images.pokemontcg.io/sv5/94_hires.png",
    },
    altArts: [
      {
        id: "sv5-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv5/94.png",
          large: "https://images.pokemontcg.io/sv5/94_hires.png",
        },
        flavorText:
          "The temperature inside its body increases when it experiences strong emotions. It rolls around frantically while spewing flames.",
      },
    ],
  },
  {
    id: "me4-4",
    name: "Carnivine",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Grass"],
    attacks: [
      {
        name: "Chomp Whole",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If your opponent's Active Pokémon has no Retreat Cost, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "4",
    flavorText:
      "It attracts prey with its sweet-smelling saliva, then chomps down. It takes a whole day to eat prey.",
    nationalPokedexNumbers: [455],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-4/small",
      large: "https://images.scrydex.com/pokemon/me4-4/large",
    },
    altArts: [
      {
        id: "me4-4",
        number: "4",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-4/small",
          large: "https://images.scrydex.com/pokemon/me4-4/large",
        },
        flavorText:
          "It attracts prey with its sweet-smelling saliva, then chomps down. It takes a whole day to eat prey.",
      },
    ],
  },
  {
    id: "sv7-7",
    name: "Carnivine",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Grass"],
    attacks: [
      {
        name: "Nosh",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 40 damage from this Pokémon.",
      },
      {
        name: "Loom Over",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130-",
        text: "This attack does 10 less damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "7",
    nationalPokedexNumbers: [455],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/7.png",
      large: "https://images.pokemontcg.io/sv7/7_hires.png",
    },
    altArts: [
      {
        id: "sv7-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv7/7.png",
          large: "https://images.pokemontcg.io/sv7/7_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-23",
    name: "Carracosta",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Water"],
    evolvesFrom: "Tirtouga",
    abilities: [
      {
        name: "Mighty Shell",
        text: "Prevent all damage from and effects of attacks done to this Pokémon by your opponent's Pokémon that have any Special Energy attached.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Big Bite",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "23",
    flavorText:
      "They can live both in the ocean and on land. A slap from one of them is enough to open a hole in the bottom of a tanker.",
    nationalPokedexNumbers: [565],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/23.png",
      large: "https://images.pokemontcg.io/zsv10pt5/23_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/23.png",
          large: "https://images.pokemontcg.io/zsv10pt5/23_hires.png",
        },
        flavorText:
          "They can live both in the ocean and on land. A slap from one of them is enough to open a hole in the bottom of a tanker.",
      },
      {
        id: "zsv10pt5-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/107.png",
          large: "https://images.pokemontcg.io/zsv10pt5/107_hires.png",
        },
        flavorText:
          "They can live both in the ocean and on land. A slap from one of them is enough to open a hole in the bottom of a tanker.",
      },
    ],
  },
  {
    id: "sv7-38",
    name: "Carracosta",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Water"],
    evolvesFrom: "Tirtouga",
    abilities: [
      {
        name: "Primal Knowledge",
        text: "Attacks used by your Pokémon do 30 more damage to your opponent's Active Evolution Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Tidal Wave",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "150",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "38",
    nationalPokedexNumbers: [565],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/38.png",
      large: "https://images.pokemontcg.io/sv7/38_hires.png",
    },
    altArts: [
      {
        id: "sv7-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv7/38.png",
          large: "https://images.pokemontcg.io/sv7/38_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-60",
    name: "Carvanha",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Sharpedo"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "60",
    flavorText:
      "These Pokémon have sharp fangs and powerful jaws. Sailors avoid Carvanha dens at all costs.",
    nationalPokedexNumbers: [318],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/60.png",
      large: "https://images.pokemontcg.io/me2/60_hires.png",
    },
    altArts: [
      {
        id: "me2-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/me2/60.png",
          large: "https://images.pokemontcg.io/me2/60_hires.png",
        },
        flavorText:
          "These Pokémon have sharp fangs and powerful jaws. Sailors avoid Carvanha dens at all costs.",
      },
    ],
  },
  {
    id: "sv5-42",
    name: "Carvanha",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Water"],
    evolvesTo: ["Sharpedo"],
    attacks: [
      {
        name: "Wave Splash",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "42",
    flavorText:
      "It won't attack while it's alone—not even if it spots prey. Instead, it waits for other Carvanha to join it, and then the Pokémon attack as a group.",
    nationalPokedexNumbers: [318],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/42.png",
      large: "https://images.pokemontcg.io/sv5/42_hires.png",
    },
    altArts: [
      {
        id: "sv5-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/sv5/42.png",
          large: "https://images.pokemontcg.io/sv5/42_hires.png",
        },
        flavorText:
          "It won't attack while it's alone—not even if it spots prey. Instead, it waits for other Carvanha to join it, and then the Pokémon attack as a group.",
      },
    ],
  },
  {
    id: "me2pt5-14",
    name: "Cascoon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Wurmple",
    attacks: [
      {
        name: "Trading Places",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "14",
    flavorText:
      "Its body, which is made of soft silk, hardens over time. When cracks appear, evolution is near.",
    nationalPokedexNumbers: [268],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-14/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-14/large",
    },
    altArts: [
      {
        id: "me2pt5-14",
        number: "14",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-14/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-14/large",
        },
        flavorText:
          "Its body, which is made of soft silk, hardens over time. When cracks appear, evolution is near.",
      },
    ],
  },
  {
    id: "sv8-20",
    name: "Castform Sunny Form",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Sunny Assist",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Move all Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    number: "20",
    nationalPokedexNumbers: [351],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/20.png",
      large: "https://images.pokemontcg.io/sv8/20_hires.png",
    },
    altArts: [
      {
        id: "sv8-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv8/20.png",
          large: "https://images.pokemontcg.io/sv8/20_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-195",
        number: "195",
        images: {
          small: "https://images.pokemontcg.io/sv8/195.png",
          large: "https://images.pokemontcg.io/sv8/195_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-1",
    name: "Caterpie",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Metapod"],
    attacks: [
      {
        name: "Bug Bite",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    nationalPokedexNumbers: [10],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/1.png",
      large: "https://images.pokemontcg.io/sv9/1_hires.png",
    },
    altArts: [
      {
        id: "sv9-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/sv9/1.png",
          large: "https://images.pokemontcg.io/sv9/1_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-12",
    name: "Celebi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    attacks: [
      {
        name: "Traverse Time",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 in any combination of Grass Pokémon and Stadium cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Solar Cutter",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "12",
    nationalPokedexNumbers: [251],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/12.png",
      large: "https://images.pokemontcg.io/me1/12_hires.png",
    },
    altArts: [
      {
        id: "me1-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/me1/12.png",
          large: "https://images.pokemontcg.io/me1/12_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-4",
    name: "Celebi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Leaf Step",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    nationalPokedexNumbers: [251],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/4.png",
      large: "https://images.pokemontcg.io/sv7/4_hires.png",
    },
    altArts: [
      {
        id: "sv7-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv7/4.png",
          large: "https://images.pokemontcg.io/sv7/4_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-30",
    name: "Centiskorch",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Sizzlipede",
    attacks: [
      {
        name: "Coiling Crush",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip 2 coins. For each heads, discard an Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Heat Crawler",
        cost: ["Fire", "Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "30",
    nationalPokedexNumbers: [851],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/30.png",
      large: "https://images.pokemontcg.io/me1/30_hires.png",
    },
    altArts: [
      {
        id: "me1-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/me1/30.png",
          large: "https://images.pokemontcg.io/me1/30_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-10",
    name: "Centiskorch",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Sizzlipede",
    attacks: [
      {
        name: "Controlled Burn",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard the top 2 cards of your opponent's deck.",
      },
      {
        name: "Heat Tackle",
        cost: ["Fire", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "10",
    flavorText:
      "When it heats up, its body temperature reaches about 1,500 degrees Fahrenheit. It lashes its body like a whip and launches itself at enemies.",
    nationalPokedexNumbers: [851],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-10/small",
      large: "https://images.scrydex.com/pokemon/me5-10/large",
    },
    altArts: [
      {
        id: "me5-10",
        number: "10",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-10/small",
          large: "https://images.scrydex.com/pokemon/me5-10/large",
        },
        flavorText:
          "When it heats up, its body temperature reaches about 1,500 degrees Fahrenheit. It lashes its body like a whip and launches itself at enemies.",
      },
    ],
  },
  {
    id: "sv5-37",
    name: "Centiskorch",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Sizzlipede",
    attacks: [
      {
        name: "Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Charring Breath",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "180",
        text: "If your opponent's Active Pokémon isn't Burned, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "37",
    flavorText:
      "When it heats up, its body temperature reaches about 1,500 degrees Fahrenheit. It lashes its body like a whip and launches itself at enemies.",
    nationalPokedexNumbers: [851],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/37.png",
      large: "https://images.pokemontcg.io/sv5/37_hires.png",
    },
    altArts: [
      {
        id: "sv5-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv5/37.png",
          large: "https://images.pokemontcg.io/sv5/37_hires.png",
        },
        flavorText:
          "When it heats up, its body temperature reaches about 1,500 degrees Fahrenheit. It lashes its body like a whip and launches itself at enemies.",
      },
    ],
  },
  {
    id: "sv8-28",
    name: "Centiskorch",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fire"],
    evolvesFrom: "Sizzlipede",
    attacks: [
      {
        name: "Billowing Heat Wave",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "130",
        text: "This attack also does 30 damage to each of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Heat Blast",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "28",
    nationalPokedexNumbers: [851],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/28.png",
      large: "https://images.pokemontcg.io/sv8/28_hires.png",
    },
    altArts: [
      {
        id: "sv8-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv8/28.png",
          large: "https://images.pokemontcg.io/sv8/28_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-20",
    name: "Ceruledge",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Charcadet",
    attacks: [
      {
        name: "Infernal Slash",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "220",
        text: "Discard 4 Basic Fire Energy cards from your hand. If you can't discard 4 cards in this way, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "20",
    flavorText:
      "The fiery blades on its arms burn fiercely with the lingering resentment of a sword wielder who fell before accomplishing their goal.",
    nationalPokedexNumbers: [937],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/20.png",
      large: "https://images.pokemontcg.io/me2/20_hires.png",
    },
    altArts: [
      {
        id: "me2-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/me2/20.png",
          large: "https://images.pokemontcg.io/me2/20_hires.png",
        },
        flavorText:
          "The fiery blades on its arms burn fiercely with the lingering resentment of a sword wielder who fell before accomplishing their goal.",
      },
    ],
  },
  {
    id: "sv8-35",
    name: "Ceruledge",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Charcadet",
    attacks: [
      {
        name: "Cursed Edge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard all Special Energy from all of your opponent's Pokémon.",
      },
      {
        name: "Black Blaze Slash",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "35",
    nationalPokedexNumbers: [937],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/35.png",
      large: "https://images.pokemontcg.io/sv8/35_hires.png",
    },
    altArts: [
      {
        id: "sv8-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv8/35.png",
          large: "https://images.pokemontcg.io/sv8/35_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-197",
        number: "197",
        images: {
          small: "https://images.pokemontcg.io/sv8/197.png",
          large: "https://images.pokemontcg.io/sv8/197_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-36",
    name: "Ceruledge ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "270",
    types: ["Fire"],
    evolvesFrom: "Charcadet",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Abyssal Flames",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "This attack does 20 more damage for each Energy card in your discard pile.",
      },
      {
        name: "Raging Amethyst",
        cost: ["Fire", "Psychic", "Metal"],
        convertedEnergyCost: 3,
        damage: "280",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "36",
    nationalPokedexNumbers: [937],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/36.png",
      large: "https://images.pokemontcg.io/sv8/36_hires.png",
    },
    altArts: [
      {
        id: "sv8-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv8/36.png",
          large: "https://images.pokemontcg.io/sv8/36_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/147.png",
          large: "https://images.pokemontcg.io/sv8pt5/147_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-54",
    name: "Cetitan",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "180",
    types: ["Water"],
    evolvesFrom: "Cetoddle",
    abilities: [
      {
        name: "Solid Body",
        text: "This Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dangerous Mouth",
        cost: ["Water", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "54",
    nationalPokedexNumbers: [975],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/54.png",
      large: "https://images.pokemontcg.io/sv8/54_hires.png",
    },
    altArts: [
      {
        id: "sv8-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv8/54.png",
          large: "https://images.pokemontcg.io/sv8/54_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-201",
        number: "201",
        images: {
          small: "https://images.pokemontcg.io/sv8/201.png",
          large: "https://images.pokemontcg.io/sv8/201_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-65",
    name: "Cetitan ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "300",
    types: ["Water"],
    evolvesFrom: "Cetoddle",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Snow Camouflage",
        text: "Whenever your opponent plays an Item or Supporter card from their hand, prevent all effects of that card done to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Crushing Press",
        cost: ["Water", "Water", "Water", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140+",
        text: "You may discard a Stadium in play. If you do, this attack does 140 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "65",
    nationalPokedexNumbers: [975],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/65.png",
      large: "https://images.pokemontcg.io/sv10/65_hires.png",
    },
    altArts: [
      {
        id: "sv10-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv10/65.png",
          large: "https://images.pokemontcg.io/sv10/65_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-210",
        number: "210",
        images: {
          small: "https://images.pokemontcg.io/sv10/210.png",
          large: "https://images.pokemontcg.io/sv10/210_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-64",
    name: "Cetoddle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Water"],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Frost Smash",
        cost: ["Water", "Water", "Water", "Colorless"],
        convertedEnergyCost: 4,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "64",
    nationalPokedexNumbers: [974],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/64.png",
      large: "https://images.pokemontcg.io/sv10/64_hires.png",
    },
    altArts: [
      {
        id: "sv10-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv10/64.png",
          large: "https://images.pokemontcg.io/sv10/64_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-53",
    name: "Cetoddle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Water"],
    attacks: [
      {
        name: "Draining Fin",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Heal 20 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "53",
    nationalPokedexNumbers: [974],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/53.png",
      large: "https://images.pokemontcg.io/sv8/53_hires.png",
    },
    altArts: [
      {
        id: "sv8-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv8/53.png",
          large: "https://images.pokemontcg.io/sv8/53_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-18",
    name: "Chandelure",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Fire"],
    evolvesFrom: "Lampent",
    attacks: [
      {
        name: "Incendiary Pillar",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "50+",
        text: "If you have 10 or more Basic Fire Energy cards in your discard pile, this attack does 100 more damage.",
      },
      {
        name: "Burn It All Up",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "180",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "18",
    flavorText:
      "It absorbs a spirit, which it then burns. By waving the flames on its arms, it puts its foes into a hypnotic trance.",
    nationalPokedexNumbers: [609],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/18.png",
      large: "https://images.pokemontcg.io/rsv10pt5/18_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/18.png",
          large: "https://images.pokemontcg.io/rsv10pt5/18_hires.png",
        },
        flavorText:
          "It absorbs a spirit, which it then burns. By waving the flames on its arms, it puts its foes into a hypnotic trance.",
      },
      {
        id: "rsv10pt5-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/103.png",
          large: "https://images.pokemontcg.io/rsv10pt5/103_hires.png",
        },
        flavorText:
          "It absorbs a spirit, which it then burns. By waving the flames on its arms, it puts its foes into a hypnotic trance.",
      },
    ],
  },
  {
    id: "me55-75",
    name: "Chandelure",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Lampent",
    attacks: [
      {
        name: "Eerie Glow",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "Your opponent's Active Pokémon is now Burned and Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "75",
    nationalPokedexNumbers: [609],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-75/small",
      large: "https://images.scrydex.com/pokemon/me55-75/large",
    },
    altArts: [
      {
        id: "me55-75",
        number: "75",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-75/small",
          large: "https://images.scrydex.com/pokemon/me55-75/large",
        },
        flavorText: "",
      },
      {
        id: "me55-137",
        number: "137",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-137/small",
          large: "https://images.scrydex.com/pokemon/me55-137/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-38",
    name: "Chandelure",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Fire"],
    evolvesFrom: "Lampent",
    abilities: [
      {
        name: "Alluring Light",
        text: "Once during your turn, you may have each player draw a card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mind Ruler",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each card in your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    flavorText:
      "It absorbs spirits, which it then burns. By waving the flames on its arms, it puts its foes into a hypnotic trance.",
    nationalPokedexNumbers: [609],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/38.png",
      large: "https://images.pokemontcg.io/sv6/38_hires.png",
    },
    altArts: [
      {
        id: "sv6-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv6/38.png",
          large: "https://images.pokemontcg.io/sv6/38_hires.png",
        },
        flavorText:
          "It absorbs spirits, which it then burns. By waving the flames on its arms, it puts its foes into a hypnotic trance.",
      },
    ],
  },
  {
    id: "sv6-133",
    name: "Chansey",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    evolvesTo: ["Blissey"],
    attacks: [
      {
        name: "Lucky Attachment",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach a Basic Energy card from your hand to 1 of your Pokémon.",
      },
      {
        name: "Boundless Power",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "133",
    flavorText:
      "It walks carefully to prevent its egg from breaking. However, it is extremely fast at running away.",
    nationalPokedexNumbers: [113],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/133.png",
      large: "https://images.pokemontcg.io/sv6/133_hires.png",
    },
    altArts: [
      {
        id: "sv6-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/sv6/133.png",
          large: "https://images.pokemontcg.io/sv6/133_hires.png",
        },
        flavorText:
          "It walks carefully to prevent its egg from breaking. However, it is extremely fast at running away.",
      },
      {
        id: "sv6-187",
        number: "187",
        images: {
          small: "https://images.pokemontcg.io/sv6/187.png",
          large: "https://images.pokemontcg.io/sv6/187_hires.png",
        },
        flavorText:
          "It walks carefully to prevent its egg from breaking. However, it is extremely fast at running away.",
      },
    ],
  },
  {
    id: "me2-19",
    name: "Charcadet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Gather Strength",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Chop",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    flavorText:
      "Burnt charcoal came to life and became a Pokémon. Possessing a fiery fighting spirit, Charcadet will battle even tough opponents.",
    nationalPokedexNumbers: [935],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/19.png",
      large: "https://images.pokemontcg.io/me2/19_hires.png",
    },
    altArts: [
      {
        id: "me2-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/me2/19.png",
          large: "https://images.pokemontcg.io/me2/19_hires.png",
        },
        flavorText:
          "Burnt charcoal came to life and became a Pokémon. Possessing a fiery fighting spirit, Charcadet will battle even tough opponents.",
      },
    ],
  },
  {
    id: "me5-11",
    name: "Charcadet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Best Punch",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "11",
    flavorText:
      "Its firepower increases when it fights, reaching over 1,800 degrees Fahrenheit. It likes berries that are rich in fat.",
    nationalPokedexNumbers: [935],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-11/small",
      large: "https://images.scrydex.com/pokemon/me5-11/large",
    },
    altArts: [
      {
        id: "me5-11",
        number: "11",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-11/small",
          large: "https://images.scrydex.com/pokemon/me5-11/large",
        },
        flavorText:
          "Its firepower increases when it fights, reaching over 1,800 degrees Fahrenheit. It likes berries that are rich in fat.",
      },
    ],
  },
  {
    id: "sv7-29",
    name: "Charcadet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Flare",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "29",
    nationalPokedexNumbers: [935],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/29.png",
      large: "https://images.pokemontcg.io/sv7/29_hires.png",
    },
    altArts: [
      {
        id: "sv7-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/sv7/29.png",
          large: "https://images.pokemontcg.io/sv7/29_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-32",
    name: "Charcadet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Will-O-Wisp",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    nationalPokedexNumbers: [935],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/32.png",
      large: "https://images.pokemontcg.io/sv8/32_hires.png",
    },
    altArts: [
      {
        id: "sv8-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv8/32.png",
          large: "https://images.pokemontcg.io/sv8/32_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-33",
    name: "Charcadet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Light Punch",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Flamethrower",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "33",
    nationalPokedexNumbers: [935],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/33.png",
      large: "https://images.pokemontcg.io/sv8/33_hires.png",
    },
    altArts: [
      {
        id: "sv8-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/sv8/33.png",
          large: "https://images.pokemontcg.io/sv8/33_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-4",
    name: "Charizard",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Charmeleon",
    abilities: [
      {
        name: "Energy Burn",
        text: "As often as you like during your turn (before your attack), you may turn all Energy attached to Charizard into Fire Energy for the rest of the turn. This power can't be used if Charizard is Asleep, Confused, or Paralyzed.",
        type: "Pokémon Power",
      },
    ],
    attacks: [
      {
        name: "Fire Spin",
        cost: ["Fire", "Fire", "Fire", "Fire"],
        convertedEnergyCost: 4,
        damage: "100",
        text: "Discard 2 Energy cards attached to Charizard in order to use this attack.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "4",
    nationalPokedexNumbers: [6],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-4/small",
      large: "https://images.scrydex.com/pokemon/me55c-4/large",
    },
    altArts: [
      {
        id: "me55c-4",
        number: "4",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-4/small",
          large: "https://images.scrydex.com/pokemon/me55c-4/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-65",
    name: "Charjabug",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Lightning"],
    evolvesFrom: "Grubbin",
    attacks: [
      {
        name: "Static Shock",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "65",
    flavorText:
      "While its durable shell protects it from attacks, Charjabug strikes at enemies with jolts of electricity discharged from the tips of its jaws.",
    nationalPokedexNumbers: [737],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-65/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-65/large",
    },
    altArts: [
      {
        id: "me2pt5-65",
        number: "65",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-65/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-65/large",
        },
        flavorText:
          "While its durable shell protects it from attacks, Charjabug strikes at enemies with jolts of electricity discharged from the tips of its jaws.",
      },
      {
        id: "sv5-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv5/55.png",
          large: "https://images.pokemontcg.io/sv5/55_hires.png",
        },
        flavorText:
          "While its durable shell protects it from attacks, Charjabug strikes at enemies with jolts of electricity discharged from the tips of its jaws.",
      },
      {
        id: "sv5-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/sv5/169.png",
          large: "https://images.pokemontcg.io/sv5/169_hires.png",
        },
        flavorText:
          "While its durable shell protects it from attacks, Charjabug strikes at enemies with jolts of electricity discharged from the tips of its jaws.",
      },
    ],
  },
  {
    id: "me5-25",
    name: "Charjabug",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Lightning"],
    evolvesFrom: "Grubbin",
    attacks: [
      {
        name: "Vise Grip",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Ram",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "25",
    flavorText:
      "As it digests fallen leaves, it generates and stores electricity, which it can discharge from the tips of its jaws.",
    nationalPokedexNumbers: [737],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-25/small",
      large: "https://images.scrydex.com/pokemon/me5-25/large",
    },
    altArts: [
      {
        id: "me5-25",
        number: "25",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-25/small",
          large: "https://images.scrydex.com/pokemon/me5-25/large",
        },
        flavorText:
          "As it digests fallen leaves, it generates and stores electricity, which it can discharge from the tips of its jaws.",
      },
    ],
  },
  {
    id: "sv7-52",
    name: "Charjabug",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Lightning"],
    evolvesFrom: "Grubbin",
    evolvesTo: ["Vikavolt"],
    attacks: [
      {
        name: "Parallel Placement",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Charjabug and put them onto your Bench. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "52",
    nationalPokedexNumbers: [737],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/52.png",
      large: "https://images.pokemontcg.io/sv7/52_hires.png",
    },
    altArts: [
      {
        id: "sv7-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv7/52.png",
          large: "https://images.pokemontcg.io/sv7/52_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-11",
    name: "Charmander",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Charmeleon"],
    abilities: [
      {
        name: "Agile",
        text: "If this Pokémon has no Energy attached, it has no Retreat Cost.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Live Coal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "11",
    flavorText:
      "The flame on its tail shows the strength of its life-force. If Charmander is weak, the flame also burns weakly.",
    nationalPokedexNumbers: [4],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/11.png",
      large: "https://images.pokemontcg.io/me2/11_hires.png",
    },
    altArts: [
      {
        id: "me2-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/me2/11.png",
          large: "https://images.pokemontcg.io/me2/11_hires.png",
        },
        flavorText:
          "The flame on its tail shows the strength of its life-force. If Charmander is weak, the flame also burns weakly.",
      },
    ],
  },
  {
    id: "me2pt5-20",
    name: "Charmander",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Fire Claws",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "20",
    flavorText:
      "The flame on its tail indicates Charmander’s life force. If it is healthy, the flame burns brightly.",
    nationalPokedexNumbers: [4],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-20/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-20/large",
    },
    altArts: [
      {
        id: "me2pt5-20",
        number: "20",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-20/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-20/large",
        },
        flavorText:
          "The flame on its tail indicates Charmander’s life force. If it is healthy, the flame burns brightly.",
      },
    ],
  },
  {
    id: "me2-12",
    name: "Charmeleon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fire"],
    evolvesFrom: "Charmander",
    evolvesTo: ["Charizard"],
    attacks: [
      {
        name: "Steady Firebreathing",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "12",
    flavorText:
      "When it swings its burning tail, the temperature around it rises higher and higher, tormenting its opponents.",
    nationalPokedexNumbers: [5],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/12.png",
      large: "https://images.pokemontcg.io/me2/12_hires.png",
    },
    altArts: [
      {
        id: "me2-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/me2/12.png",
          large: "https://images.pokemontcg.io/me2/12_hires.png",
        },
        flavorText:
          "When it swings its burning tail, the temperature around it rises higher and higher, tormenting its opponents.",
      },
    ],
  },
  {
    id: "me2pt5-21",
    name: "Charmeleon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fire"],
    evolvesFrom: "Charmander",
    attacks: [
      {
        name: "Heat Blast",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    flavorText:
      "It lashes about with its tail to knock down its foe. It then tears up the fallen opponent with sharp claws.",
    nationalPokedexNumbers: [5],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-21/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-21/large",
    },
    altArts: [
      {
        id: "me2pt5-21",
        number: "21",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-21/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-21/large",
        },
        flavorText:
          "It lashes about with its tail to knock down its foe. It then tears up the fallen opponent with sharp claws.",
      },
    ],
  },
  {
    id: "sv5-132",
    name: "Chatot",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "A Cappella",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Gust",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "132",
    flavorText:
      "It mimics the cries of other Pokémon to trick them into thinking it's one of them. This way they won't attack it.",
    nationalPokedexNumbers: [441],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/132.png",
      large: "https://images.pokemontcg.io/sv5/132_hires.png",
    },
    altArts: [
      {
        id: "sv5-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/sv5/132.png",
          large: "https://images.pokemontcg.io/sv5/132_hires.png",
        },
        flavorText:
          "It mimics the cries of other Pokémon to trick them into thinking it's one of them. This way they won't attack it.",
      },
      {
        id: "sv5-181",
        number: "181",
        images: {
          small: "https://images.pokemontcg.io/sv5/181.png",
          large: "https://images.pokemontcg.io/sv5/181_hires.png",
        },
        flavorText:
          "It mimics the cries of other Pokémon to trick them into thinking it's one of them. This way they won't attack it.",
      },
    ],
  },
  {
    id: "me55-7",
    name: "Cherrim",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Grass"],
    evolvesFrom: "Cherubi",
    attacks: [
      {
        name: "Energy Gift",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Search your deck for up to 2 Basic Energy cards and attach them to your Pokémon in any way you like. Then, shuffle your deck.",
      },
      {
        name: "Leafage",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    nationalPokedexNumbers: [421],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-7/small",
      large: "https://images.scrydex.com/pokemon/me55-7/large",
    },
    altArts: [
      {
        id: "me55-7",
        number: "7",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-7/small",
          large: "https://images.scrydex.com/pokemon/me55-7/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-6",
    name: "Cherubi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    attacks: [
      {
        name: "Hide",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
      {
        name: "Flop",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    nationalPokedexNumbers: [420],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-6/small",
      large: "https://images.scrydex.com/pokemon/me55-6/large",
    },
    altArts: [
      {
        id: "me55-6",
        number: "6",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-6/small",
          large: "https://images.scrydex.com/pokemon/me55-6/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-7",
    name: "Chesnaught",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Grass"],
    evolvesFrom: "Quilladin",
    abilities: [
      {
        name: "Needly Armor",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), place 3 damage counters on the Attacking Pokémon for each Grass Energy attached to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Impound",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "7",
    flavorText:
      "Its tackle is forceful enough to flip a 50-ton tank. It shields its allies from danger with its own body.",
    nationalPokedexNumbers: [652],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-7/small",
      large: "https://images.scrydex.com/pokemon/me4-7/large",
    },
    altArts: [
      {
        id: "me4-7",
        number: "7",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-7/small",
          large: "https://images.scrydex.com/pokemon/me4-7/large",
        },
        flavorText:
          "Its tackle is forceful enough to flip a 50-ton tank. It shields its allies from danger with its own body.",
      },
    ],
  },
  {
    id: "me4-5",
    name: "Chespin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Beat",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Spike Sting",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    flavorText:
      "The quills on its head are usually soft. When it flexes them, the points become so hard and sharp that they can pierce rock.",
    nationalPokedexNumbers: [650],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-5/small",
      large: "https://images.scrydex.com/pokemon/me4-5/large",
    },
    altArts: [
      {
        id: "me4-5",
        number: "5",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-5/small",
          large: "https://images.scrydex.com/pokemon/me4-5/large",
        },
        flavorText:
          "The quills on its head are usually soft. When it flexes them, the points become so hard and sharp that they can pierce rock.",
      },
      {
        id: "me4-87",
        number: "87",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-87/small",
          large: "https://images.scrydex.com/pokemon/me4-87/large",
        },
        flavorText:
          "The quills on its head are usually soft. When it flexes them, the points become so hard and sharp that they can pierce rock.",
      },
    ],
  },
  {
    id: "sv7-43",
    name: "Chewtle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    evolvesTo: ["Drednaw"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    nationalPokedexNumbers: [833],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/43.png",
      large: "https://images.pokemontcg.io/sv7/43_hires.png",
    },
    altArts: [
      {
        id: "sv7-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv7/43.png",
          large: "https://images.pokemontcg.io/sv7/43_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-31",
    name: "Chi-Yu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fire"],
    attacks: [
      {
        name: "Scorching Earth",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "If your opponent has a Stadium in play, discard it. If you do, your opponent can't play any Stadium cards from their hand during their next turn.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    nationalPokedexNumbers: [1004],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/31.png",
      large: "https://images.pokemontcg.io/me1/31_hires.png",
    },
    altArts: [
      {
        id: "me1-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/me1/31.png",
          large: "https://images.pokemontcg.io/me1/31_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-59",
    name: "Chi-Yu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Darkness"],
    attacks: [
      {
        name: "Whirling Envy",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If this Pokémon has 2 or more damage counters on it, this attack does 90 more damage. This attack's damage isn't affected by Weakness.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    flavorText:
      "The envy accumulated within curved beads that sparked multiple conflicts has clad itself in fire and become a Pokémon.",
    nationalPokedexNumbers: [1004],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-59/small",
      large: "https://images.scrydex.com/pokemon/me5-59/large",
    },
    altArts: [
      {
        id: "me5-59",
        number: "59",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-59/small",
          large: "https://images.scrydex.com/pokemon/me5-59/large",
        },
        flavorText:
          "The envy accumulated within curved beads that sparked multiple conflicts has clad itself in fire and become a Pokémon.",
      },
    ],
  },
  {
    id: "sv6-39",
    name: "Chi-Yu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fire"],
    attacks: [
      {
        name: "Allure",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Ground Melter",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "If a Stadium is in play, this attack does 60 more damage. Then, discard that Stadium.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    flavorText:
      "The envy accumulated within curved beads that sparked multiple conflicts has clad itself in fire and become a Pokémon.",
    nationalPokedexNumbers: [1004],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/39.png",
      large: "https://images.pokemontcg.io/sv6/39_hires.png",
    },
    altArts: [
      {
        id: "sv6-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv6/39.png",
          large: "https://images.pokemontcg.io/sv6/39_hires.png",
        },
        flavorText:
          "The envy accumulated within curved beads that sparked multiple conflicts has clad itself in fire and become a Pokémon.",
      },
    ],
  },
  {
    id: "me3-54",
    name: "Chien-Pao",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Darkness"],
    attacks: [
      {
        name: "Strafe",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Rising Blade",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "54",
    nationalPokedexNumbers: [1002],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-54/small",
      large: "https://images.scrydex.com/pokemon/me3-54/large",
    },
    altArts: [
      {
        id: "me3-54",
        number: "54",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-54/small",
          large: "https://images.scrydex.com/pokemon/me3-54/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-56",
    name: "Chien-Pao",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Water"],
    abilities: [
      {
        name: "Snow Sink",
        text: "When you play this Pokémon from your hand onto your Bench during your turn, you may discard a Stadium in play.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Icicle Loop",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Put an Energy attached to this Pokémon into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "56",
    nationalPokedexNumbers: [1002],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/56.png",
      large: "https://images.pokemontcg.io/sv8/56_hires.png",
    },
    altArts: [
      {
        id: "sv8-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/sv8/56.png",
          large: "https://images.pokemontcg.io/sv8/56_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/svp/152.png",
          large: "https://images.pokemontcg.io/svp/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-8",
    name: "Chikorita",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Bayleef"],
    attacks: [
      {
        name: "Razor Leaf",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    nationalPokedexNumbers: [152],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/8.png",
      large: "https://images.pokemontcg.io/me1/8_hires.png",
    },
    altArts: [
      {
        id: "me1-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/me1/8.png",
          large: "https://images.pokemontcg.io/me1/8_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-8",
    name: "Chikorita",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Growl",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 20 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Seed Bomb",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    flavorText:
      "A sweet aroma gently wafts from the leaf on its head. It is docile and loves to soak up sun rays.",
    nationalPokedexNumbers: [152],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-8/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-8/large",
    },
    altArts: [
      {
        id: "me2pt5-8",
        number: "8",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-8/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-8/large",
        },
        flavorText:
          "A sweet aroma gently wafts from the leaf on its head. It is docile and loves to soak up sun rays.",
      },
    ],
  },
  {
    id: "sv6-31",
    name: "Chimchar",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fire"],
    evolvesTo: ["Monferno"],
    attacks: [
      {
        name: "Firebreathing",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    flavorText:
      "Its fiery rear end is fueled by gas made in its belly. Even rain can't extinguish the fire.",
    nationalPokedexNumbers: [390],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/31.png",
      large: "https://images.pokemontcg.io/sv6/31_hires.png",
    },
    altArts: [
      {
        id: "sv6-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/sv6/31.png",
          large: "https://images.pokemontcg.io/sv6/31_hires.png",
        },
        flavorText:
          "Its fiery rear end is fueled by gas made in its belly. Even rain can't extinguish the fire.",
      },
    ],
  },
  {
    id: "sv6-85",
    name: "Chimecho",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Hyper Voice",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Homeward Chime",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Shuffle 1 of your Benched Pokémon and all attached cards into your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "85",
    flavorText:
      "Its cries echo inside its hollow body to emerge as beautiful notes for startling and repelling foes.",
    nationalPokedexNumbers: [358],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/85.png",
      large: "https://images.pokemontcg.io/sv6/85_hires.png",
    },
    altArts: [
      {
        id: "sv6-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv6/85.png",
          large: "https://images.pokemontcg.io/sv6/85_hires.png",
        },
        flavorText:
          "Its cries echo inside its hollow body to emerge as beautiful notes for startling and repelling foes.",
      },
      {
        id: "sv6-179",
        number: "179",
        images: {
          small: "https://images.pokemontcg.io/sv6/179.png",
          large: "https://images.pokemontcg.io/sv6/179_hires.png",
        },
        flavorText:
          "Its cries echo inside its hollow body to emerge as beautiful notes for startling and repelling foes.",
      },
    ],
  },
  {
    id: "sv7-48",
    name: "Chinchou",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Lanturn"],
    attacks: [
      {
        name: "Double Voltage",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "Flip 2 coins. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "48",
    nationalPokedexNumbers: [170],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/48.png",
      large: "https://images.pokemontcg.io/sv7/48_hires.png",
    },
    altArts: [
      {
        id: "sv7-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv7/48.png",
          large: "https://images.pokemontcg.io/sv7/48_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-76",
    name: "Cinccino",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Minccino",
    attacks: [
      {
        name: "Do the Wave",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "This attack does 20 more damage for each of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "76",
    flavorText:
      "Their white fur is coated in a special oil that makes it easy for them to deflect attacks.",
    nationalPokedexNumbers: [573],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/76.png",
      large: "https://images.pokemontcg.io/zsv10pt5/76_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/76.png",
          large: "https://images.pokemontcg.io/zsv10pt5/76_hires.png",
        },
        flavorText:
          "Their white fur is coated in a special oil that makes it easy for them to deflect attacks.",
      },
      {
        id: "zsv10pt5-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/153.png",
          large: "https://images.pokemontcg.io/zsv10pt5/153_hires.png",
        },
        flavorText:
          "Their white fur is coated in a special oil that makes it easy for them to deflect attacks.",
      },
    ],
  },
  {
    id: "sv5-137",
    name: "Cinccino",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Minccino",
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Special Roll",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70×",
        text: "This attack does 70 damage for each Special Energy card attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "137",
    flavorText:
      "Its body secretes oil that this Pokémon spreads over its nest as a coating to protect it from dust. Cinccino won't tolerate even a speck of the stuff.",
    nationalPokedexNumbers: [573],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/137.png",
      large: "https://images.pokemontcg.io/sv5/137_hires.png",
    },
    altArts: [
      {
        id: "sv5-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/sv5/137.png",
          large: "https://images.pokemontcg.io/sv5/137_hires.png",
        },
        flavorText:
          "Its body secretes oil that this Pokémon spreads over its nest as a coating to protect it from dust. Cinccino won't tolerate even a speck of the stuff.",
      },
      {
        id: "sv5-183",
        number: "183",
        images: {
          small: "https://images.pokemontcg.io/sv5/183.png",
          large: "https://images.pokemontcg.io/sv5/183_hires.png",
        },
        flavorText:
          "Its body secretes oil that this Pokémon spreads over its nest as a coating to protect it from dust. Cinccino won't tolerate even a speck of the stuff.",
      },
    ],
  },
  {
    id: "sv9-126",
    name: "Cinccino",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Minccino",
    attacks: [
      {
        name: "Tail Smack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "126",
    nationalPokedexNumbers: [573],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/126.png",
      large: "https://images.pokemontcg.io/sv9/126_hires.png",
    },
    altArts: [
      {
        id: "sv9-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/sv9/126.png",
          large: "https://images.pokemontcg.io/sv9/126_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-73",
    name: "Cinccino ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "240",
    types: ["Colorless"],
    evolvesFrom: "Minccino",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Smooth Coat",
        text: "If any damage is done to this Pokémon by attacks, flip a coin. If heads, prevent that damage.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Energized Slap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40×",
        text: "This attack does 40 damage for each Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    nationalPokedexNumbers: [573],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-73/small",
      large: "https://images.scrydex.com/pokemon/me4-73/large",
    },
    altArts: [
      {
        id: "me4-73",
        number: "73",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-73/small",
          large: "https://images.scrydex.com/pokemon/me4-73/large",
        },
        flavorText: "",
      },
      {
        id: "me4-105",
        number: "105",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-105/small",
          large: "https://images.scrydex.com/pokemon/me4-105/large",
        },
        flavorText: "",
      },
      {
        id: "me4-119",
        number: "119",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-119/small",
          large: "https://images.scrydex.com/pokemon/me4-119/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-28",
    name: "Cinderace",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Fire"],
    evolvesFrom: "Raboot",
    abilities: [
      {
        name: "Explosiveness",
        text: "If this Pokémon is in your hand when you are setting up to play, you may put it face down in the Active Spot.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Turbo Flare",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Search your deck for up to 3 Basic Energy cards and attach them to your Benched Pokémon in any way you like. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    number: "28",
    nationalPokedexNumbers: [815],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/28.png",
      large: "https://images.pokemontcg.io/me1/28_hires.png",
    },
    altArts: [
      {
        id: "me1-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/me1/28.png",
          large: "https://images.pokemontcg.io/me1/28_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-38",
    name: "Cinderace ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "Tera", "ex"],
    hp: "320",
    types: ["Fire"],
    evolvesFrom: "Raboot",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent’s).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Flare Strike",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "280",
        text: "During your next turn, this Pokémon can't use Flare Strike.",
      },
      {
        name: "Garnet Volley",
        cost: ["Fire", "Fighting", "Darkness"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 180 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    number: "38",
    nationalPokedexNumbers: [815],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-38/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-38/large",
    },
    altArts: [
      {
        id: "me2pt5-38",
        number: "38",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-38/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-38/large",
        },
        flavorText: "",
      },
      {
        id: "sv7-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv7/28.png",
          large: "https://images.pokemontcg.io/sv7/28_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/sv7/157.png",
          large: "https://images.pokemontcg.io/sv7/157_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/svp/163.png",
          large: "https://images.pokemontcg.io/svp/163_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-54",
    name: "Clamperl",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Huntail", "Gorebyss"],
    attacks: [
      {
        name: "Shell Press",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, this Pokémon takes 10 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "54",
    nationalPokedexNumbers: [366],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/54.png",
      large: "https://images.pokemontcg.io/sv10/54_hires.png",
    },
    altArts: [
      {
        id: "sv10-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv10/54.png",
          large: "https://images.pokemontcg.io/sv10/54_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-195",
        number: "195",
        images: {
          small: "https://images.pokemontcg.io/sv10/195.png",
          large: "https://images.pokemontcg.io/sv10/195_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-37",
    name: "Clauncher",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    evolvesTo: ["Clawitzer"],
    attacks: [
      {
        name: "Wave Splash",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "37",
    nationalPokedexNumbers: [692],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/37.png",
      large: "https://images.pokemontcg.io/me1/37_hires.png",
    },
    altArts: [
      {
        id: "me1-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/me1/37.png",
          large: "https://images.pokemontcg.io/me1/37_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-38",
    name: "Clawitzer",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Water"],
    evolvesFrom: "Clauncher",
    abilities: [
      {
        name: "Fall Back to Reload",
        text: "Once during your turn, when this Pokémon moves from the Active Spot to your Bench, you may use this Ability. Attach up to 2 Basic Water Energy cards from your hand to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Aqua Launcher",
        cost: ["Water", "Water", "Water"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    nationalPokedexNumbers: [693],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/38.png",
      large: "https://images.pokemontcg.io/me1/38_hires.png",
    },
    altArts: [
      {
        id: "me1-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/me1/38.png",
          large: "https://images.pokemontcg.io/me1/38_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/me1/141.png",
          large: "https://images.pokemontcg.io/me1/141_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-47",
    name: "Claydol",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Baltoy",
    attacks: [
      {
        name: "Devolution Ray",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "If your opponent's Active Pokémon is an evolved Pokémon, devolve it by putting the highest Stage Evolution card on it into your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "47",
    flavorText:
      "This mysterious Pokémon started life as an ancient clay figurine made over 20,000 years ago.",
    nationalPokedexNumbers: [344],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-47/small",
      large: "https://images.scrydex.com/pokemon/me4-47/large",
    },
    altArts: [
      {
        id: "me4-47",
        number: "47",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-47/small",
          large: "https://images.scrydex.com/pokemon/me4-47/large",
        },
        flavorText:
          "This mysterious Pokémon started life as an ancient clay figurine made over 20,000 years ago.",
      },
      {
        id: "me4-92",
        number: "92",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-92/small",
          large: "https://images.scrydex.com/pokemon/me4-92/large",
        },
        flavorText:
          "This mysterious Pokémon started life as an ancient clay figurine made over 20,000 years ago.",
      },
    ],
  },
  {
    id: "me2pt5-75",
    name: "Clefable",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Clefairy",
    attacks: [
      {
        name: "Metronome",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Choose 1 of your opponent's Active Pokémon's attacks and use it as this attack.",
      },
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "75",
    flavorText:
      "It has an acute sense of hearing. It can easily hear a pin being dropped nearly 1,100 yards away.",
    nationalPokedexNumbers: [36],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-75/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-75/large",
    },
    altArts: [
      {
        id: "me2pt5-75",
        number: "75",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-75/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-75/large",
        },
        flavorText:
          "It has an acute sense of hearing. It can easily hear a pin being dropped nearly 1,100 yards away.",
      },
      {
        id: "sv6-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv6/79.png",
          large: "https://images.pokemontcg.io/sv6/79_hires.png",
        },
        flavorText:
          "It has an acute sense of hearing. It can easily hear a pin being dropped nearly 1,100 yards away.",
      },
    ],
  },
  {
    id: "me2pt5-74",
    name: "Clefairy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Moon Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "74",
    flavorText:
      "On nights with a full moon, they gather together and dance. The surrounding area is enveloped in an abnormal magnetic field.",
    nationalPokedexNumbers: [35],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-74/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-74/large",
    },
    altArts: [
      {
        id: "me2pt5-74",
        number: "74",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-74/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-74/large",
        },
        flavorText:
          "On nights with a full moon, they gather together and dance. The surrounding area is enveloped in an abnormal magnetic field.",
      },
      {
        id: "sv6-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv6/78.png",
          large: "https://images.pokemontcg.io/sv6/78_hires.png",
        },
        flavorText:
          "On nights with a full moon, they gather together and dance. The surrounding area is enveloped in an abnormal magnetic field.",
      },
    ],
  },
  {
    id: "me3-30",
    name: "Clefairy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Follow Me",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
      },
      {
        name: "Flop",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "30",
    nationalPokedexNumbers: [35],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-30/small",
      large: "https://images.scrydex.com/pokemon/me3-30/large",
    },
    altArts: [
      {
        id: "me3-30",
        number: "30",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-30/small",
          large: "https://images.scrydex.com/pokemon/me3-30/large",
        },
        flavorText: "",
      },
      {
        id: "me3-94",
        number: "94",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-94/small",
          large: "https://images.scrydex.com/pokemon/me3-94/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-112",
    name: "Clobbopus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Grapploct"],
    attacks: [
      {
        name: "Slight Intrusion",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "112",
    nationalPokedexNumbers: [852],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/112.png",
      large: "https://images.pokemontcg.io/sv8/112_hires.png",
    },
    altArts: [
      {
        id: "sv8-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/sv8/112.png",
          large: "https://images.pokemontcg.io/sv8/112_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-207",
        number: "207",
        images: {
          small: "https://images.pokemontcg.io/sv8/207.png",
          large: "https://images.pokemontcg.io/sv8/207_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-120",
    name: "Coalossal",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fighting"],
    evolvesFrom: "Carkol",
    attacks: [
      {
        name: "Tar Cannon",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 140 damage to 1 of your opponent's Pokémon. If you don't have 10 or more Basic Fighting Energy cards in your discard pile, this attack does nothing. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Bulky Bump",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "220",
        text: "Discard 3 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "120",
    flavorText:
      "It’s gentle usually but fearsome when angered. With a body that burns at over 2,700 degrees Fahrenheit, it crushes foes and turns them to ash.",
    nationalPokedexNumbers: [839],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-120/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-120/large",
    },
    altArts: [
      {
        id: "me2pt5-120",
        number: "120",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-120/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-120/large",
        },
        flavorText:
          "It’s gentle usually but fearsome when angered. With a body that burns at over 2,700 degrees Fahrenheit, it crushes foes and turns them to ash.",
      },
    ],
  },
  {
    id: "sv5-95",
    name: "Coalossal",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fighting"],
    evolvesFrom: "Carkol",
    attacks: [
      {
        name: "Gatling Tar",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40+",
        text: "This attack does 80 more damage for each Fire Energy attached to this Pokémon.",
      },
      {
        name: "Cragalanche",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "Discard the top 2 cards of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "95",
    flavorText:
      "To intimidate its opponents, Coalossal will vigorously shake its body, scattering coal from its smoldering back.",
    nationalPokedexNumbers: [839],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/95.png",
      large: "https://images.pokemontcg.io/sv5/95_hires.png",
    },
    altArts: [
      {
        id: "sv5-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv5/95.png",
          large: "https://images.pokemontcg.io/sv5/95_hires.png",
        },
        flavorText:
          "To intimidate its opponents, Coalossal will vigorously shake its body, scattering coal from its smoldering back.",
      },
    ],
  },
  {
    id: "zsv10pt5-66",
    name: "Cobalion",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Metal"],
    attacks: [
      {
        name: "Righteous Edge",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Discard a Special Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Metal Arms",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If this Pokémon has a Pokémon Tool attached, this attack does 40 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "66",
    flavorText:
      "This legendary Pokémon battled against humans to protect Pokémon. Its personality is calm and composed.",
    nationalPokedexNumbers: [638],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/66.png",
      large: "https://images.pokemontcg.io/zsv10pt5/66_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/66.png",
          large: "https://images.pokemontcg.io/zsv10pt5/66_hires.png",
        },
        flavorText:
          "This legendary Pokémon battled against humans to protect Pokémon. Its personality is calm and composed.",
      },
      {
        id: "zsv10pt5-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/144.png",
          large: "https://images.pokemontcg.io/zsv10pt5/144_hires.png",
        },
        flavorText:
          "This legendary Pokémon battled against humans to protect Pokémon. Its personality is calm and composed.",
      },
    ],
  },
  {
    id: "me4-64",
    name: "Cobalion ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Metal"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Metal Road",
        text: "Once during your turn, when this Pokémon moves from your Bench to the Active Spot, you may use this Ability. Move any amount of Metal Energy from your other Pokémon to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Power Tackle",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "64",
    nationalPokedexNumbers: [638],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-64/small",
      large: "https://images.scrydex.com/pokemon/me4-64/large",
    },
    altArts: [
      {
        id: "me4-64",
        number: "64",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-64/small",
          large: "https://images.scrydex.com/pokemon/me4-64/large",
        },
        flavorText: "",
      },
      {
        id: "me4-103",
        number: "103",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-103/small",
          large: "https://images.scrydex.com/pokemon/me4-103/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-40",
    name: "Cofagrigus",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Yamask",
    attacks: [
      {
        name: "Extended Damagriiigus",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Move all damage counters from 1 of your Benched Pokémon to 1 of your opponent's Pokémon.",
      },
      {
        name: "Perplex",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "40",
    flavorText:
      "It has been said that they swallow those who get too close and turn them into mummies. They like to eat gold nuggets.",
    nationalPokedexNumbers: [563],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/40.png",
      large: "https://images.pokemontcg.io/rsv10pt5/40_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/40.png",
          large: "https://images.pokemontcg.io/rsv10pt5/40_hires.png",
        },
        flavorText:
          "It has been said that they swallow those who get too close and turn them into mummies. They like to eat gold nuggets.",
      },
      {
        id: "rsv10pt5-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/123.png",
          large: "https://images.pokemontcg.io/rsv10pt5/123_hires.png",
        },
        flavorText:
          "It has been said that they swallow those who get too close and turn them into mummies. They like to eat gold nuggets.",
      },
    ],
  },
  {
    id: "sv8-83",
    name: "Cofagrigus",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Yamask",
    attacks: [
      {
        name: "Law of the Underworld",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put 6 damage counters on each Pokémon that has an Ability (both yours and your opponent's).",
      },
      {
        name: "Spooky Shot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "83",
    nationalPokedexNumbers: [563],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/83.png",
      large: "https://images.pokemontcg.io/sv8/83_hires.png",
    },
    altArts: [
      {
        id: "sv8-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv8/83.png",
          large: "https://images.pokemontcg.io/sv8/83_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-41",
    name: "Combusken",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fire"],
    evolvesFrom: "Torchic",
    evolvesTo: ["Blaziken"],
    attacks: [
      {
        name: "Combustion",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Double Kick",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "Flip 2 coins. This attack does 40 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "41",
    nationalPokedexNumbers: [256],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/41.png",
      large: "https://images.pokemontcg.io/sv10/41_hires.png",
    },
    altArts: [
      {
        id: "sv10-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv10/41.png",
          large: "https://images.pokemontcg.io/sv10/41_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-23",
    name: "Combusken",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fire"],
    evolvesFrom: "Torchic",
    evolvesTo: ["Blaziken"],
    attacks: [
      {
        name: "Slash",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    nationalPokedexNumbers: [256],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/23.png",
      large: "https://images.pokemontcg.io/sv9/23_hires.png",
    },
    altArts: [
      {
        id: "sv9-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv9/23.png",
          large: "https://images.pokemontcg.io/sv9/23_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-77",
    name: "Comfey",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Comforting Aroma",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Heal 80 damage from 1 of your Benched Pokémon.",
      },
      {
        name: "Magical Shot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "77",
    nationalPokedexNumbers: [764],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-77/small",
      large: "https://images.scrydex.com/pokemon/me55-77/large",
    },
    altArts: [
      {
        id: "me55-77",
        number: "77",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-77/small",
          large: "https://images.scrydex.com/pokemon/me55-77/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-63",
    name: "Comfey",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Flower Shower",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Each player draws 3 cards.",
      },
      {
        name: "Play Rough",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    nationalPokedexNumbers: [764],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/63.png",
      large: "https://images.pokemontcg.io/sv7/63_hires.png",
    },
    altArts: [
      {
        id: "sv7-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv7/63.png",
          large: "https://images.pokemontcg.io/sv7/63_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-49",
    name: "Conkeldurr",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Gurdurr",
    abilities: [
      {
        name: "Craftsmanship",
        text: "This Pokémon gets +40 HP for each Fighting Energy attached to it.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Swing Around",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100+",
        text: "Flip 2 coins. This attack does 50 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "49",
    flavorText:
      "It is thought that Conkeldurr taught humans how to make concrete more than 2,000 years ago.",
    nationalPokedexNumbers: [534],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/49.png",
      large: "https://images.pokemontcg.io/zsv10pt5/49_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/49.png",
          large: "https://images.pokemontcg.io/zsv10pt5/49_hires.png",
        },
        flavorText:
          "It is thought that Conkeldurr taught humans how to make concrete more than 2,000 years ago.",
      },
      {
        id: "zsv10pt5-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/127.png",
          large: "https://images.pokemontcg.io/zsv10pt5/127_hires.png",
        },
        flavorText:
          "It is thought that Conkeldurr taught humans how to make concrete more than 2,000 years ago.",
      },
    ],
  },
  {
    id: "sv6-105",
    name: "Conkeldurr",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fighting"],
    evolvesFrom: "Gurdurr",
    attacks: [
      {
        name: "Tantrum",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "80",
        text: "This Pokémon is now Confused.",
      },
      {
        name: "Gutsy Swing",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "250",
        text: "If this Pokémon is affected by a Special Condition, ignore all Energy in this attack's cost.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "105",
    flavorText:
      "Rather than rely on their strength, they master moves that make good use of centrifugal force to swing around concrete.",
    nationalPokedexNumbers: [534],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/105.png",
      large: "https://images.pokemontcg.io/sv6/105_hires.png",
    },
    altArts: [
      {
        id: "sv6-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/sv6/105.png",
          large: "https://images.pokemontcg.io/sv6/105_hires.png",
        },
        flavorText:
          "Rather than rely on their strength, they master moves that make good use of centrifugal force to swing around concrete.",
      },
    ],
  },
  {
    id: "sv6pt5-42",
    name: "Copperajah",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "200",
    types: ["Metal"],
    evolvesFrom: "Cufant",
    abilities: [
      {
        name: "Massive Body",
        text: "As long as this Pokémon is in the Active Spot, your opponent can't play any Stadium cards from their hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Nasal Lariat",
        cost: ["Metal", "Metal", "Metal", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130+",
        text: "You may do 100 more damage. If you do, during your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "42",
    nationalPokedexNumbers: [879],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/42.png",
      large: "https://images.pokemontcg.io/sv6pt5/42_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/42.png",
          large: "https://images.pokemontcg.io/sv6pt5/42_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-110",
    name: "Copperajah",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "190",
    types: ["Metal"],
    evolvesFrom: "Cufant",
    attacks: [
      {
        name: "Ram",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
      {
        name: "Mega Impact",
        cost: ["Metal", "Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "110",
    nationalPokedexNumbers: [879],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/110.png",
      large: "https://images.pokemontcg.io/sv9/110_hires.png",
    },
    altArts: [
      {
        id: "sv9-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/sv9/110.png",
          large: "https://images.pokemontcg.io/sv9/110_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-111",
    name: "Cornerstone Mask Ogerpon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Rock Kagura",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Fighting Energy card and attach it to 1 of your Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Mountain Ramming",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "111",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/111.png",
      large: "https://images.pokemontcg.io/sv10/111_hires.png",
    },
    altArts: [
      {
        id: "sv10-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/sv10/111.png",
          large: "https://images.pokemontcg.io/sv10/111_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-112",
    name: "Cornerstone Mask Ogerpon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "210",
    types: ["Fighting"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    abilities: [
      {
        name: "Cornerstone Stance",
        text: "Prevent all damage from attacks done to this Pokémon by your opponent's Pokémon that have an Ability.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Demolish",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "This attack's damage isn't affected by Weakness or Resistance, or by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "112",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/112.png",
      large: "https://images.pokemontcg.io/sv6/112_hires.png",
    },
    altArts: [
      {
        id: "sv6-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/sv6/112.png",
          large: "https://images.pokemontcg.io/sv6/112_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-199",
        number: "199",
        images: {
          small: "https://images.pokemontcg.io/sv6/199.png",
          large: "https://images.pokemontcg.io/sv6/199_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-215",
        number: "215",
        images: {
          small: "https://images.pokemontcg.io/sv6/215.png",
          large: "https://images.pokemontcg.io/sv6/215_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/58.png",
          large: "https://images.pokemontcg.io/sv8pt5/58_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/160.png",
          large: "https://images.pokemontcg.io/sv8pt5/160_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-33",
    name: "Corphish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    evolvesTo: ["Crawdaunt"],
    attacks: [
      {
        name: "Vise Grip",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Take Down",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "33",
    nationalPokedexNumbers: [341],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/33.png",
      large: "https://images.pokemontcg.io/me1/33_hires.png",
    },
    altArts: [
      {
        id: "me1-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/me1/33.png",
          large: "https://images.pokemontcg.io/me1/33_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-47",
    name: "Corphish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    evolvesTo: ["Crawdaunt"],
    attacks: [
      {
        name: "Vise Grip",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "47",
    flavorText:
      "It can live in impure water, where it doesn't need to compete with other water Pokémon for food, so its numbers have steadily increased.",
    nationalPokedexNumbers: [341],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/47.png",
      large: "https://images.pokemontcg.io/sv6/47_hires.png",
    },
    altArts: [
      {
        id: "sv6-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv6/47.png",
          large: "https://images.pokemontcg.io/sv6/47_hires.png",
        },
        flavorText:
          "It can live in impure water, where it doesn't need to compete with other water Pokémon for food, so its numbers have steadily increased.",
      },
    ],
  },
  {
    id: "me55-79",
    name: "Cosmoem",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Psychic"],
    evolvesFrom: "Cosmog",
    attacks: [
      {
        name: "Stiffen",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        text: "During your opponent's next turn, this Pokémon takes 60 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "79",
    nationalPokedexNumbers: [790],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-79/small",
      large: "https://images.scrydex.com/pokemon/me55-79/large",
    },
    altArts: [
      {
        id: "me55-79",
        number: "79",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-79/small",
          large: "https://images.scrydex.com/pokemon/me55-79/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-78",
    name: "Cosmog",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Splash",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    nationalPokedexNumbers: [789],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-78/small",
      large: "https://images.scrydex.com/pokemon/me55-78/large",
    },
    altArts: [
      {
        id: "me55-78",
        number: "78",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-78/small",
          large: "https://images.scrydex.com/pokemon/me55-78/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-4",
    name: "Cottonee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Whimsicott"],
    attacks: [
      {
        name: "Absorb",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Heal 10 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    flavorText:
      "When attacked, it escapes by shooting cotton from its body. The cotton serves as a decoy to distract the attacker.",
    nationalPokedexNumbers: [546],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/4.png",
      large: "https://images.pokemontcg.io/rsv10pt5/4_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/4.png",
          large: "https://images.pokemontcg.io/rsv10pt5/4_hires.png",
        },
        flavorText:
          "When attacked, it escapes by shooting cotton from its body. The cotton serves as a decoy to distract the attacker.",
      },
      {
        id: "rsv10pt5-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/90.png",
          large: "https://images.pokemontcg.io/rsv10pt5/90_hires.png",
        },
        flavorText:
          "When attacked, it escapes by shooting cotton from its body. The cotton serves as a decoy to distract the attacker.",
      },
    ],
  },
  {
    id: "sv5-14",
    name: "Cottonee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Whimsicott"],
    attacks: [
      {
        name: "Triple Spin",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 3 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    flavorText:
      "It shoots cotton from its body to protect itself. If it gets caught up in hurricane-strength winds, it can get sent to the other side of the Earth.",
    nationalPokedexNumbers: [546],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/14.png",
      large: "https://images.pokemontcg.io/sv5/14_hires.png",
    },
    altArts: [
      {
        id: "sv5-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv5/14.png",
          large: "https://images.pokemontcg.io/sv5/14_hires.png",
        },
        flavorText:
          "It shoots cotton from its body to protect itself. If it gets caught up in hurricane-strength winds, it can get sent to the other side of the Earth.",
      },
      {
        id: "sv8pt5-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/7.png",
          large: "https://images.pokemontcg.io/sv8pt5/7_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-42",
    name: "Crabominable",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "160",
    types: ["Water"],
    evolvesFrom: "Crabrawler",
    abilities: [
      {
        name: "Food Prep",
        text: "Attacks used by this Pokémon cost Colorless less for each Kofu card in your discard pile.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Haymaker",
        cost: ["Water", "Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 5,
        damage: "250",
        text: "During your next turn, this Pokémon can't use Haymaker.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "42",
    nationalPokedexNumbers: [740],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/42.png",
      large: "https://images.pokemontcg.io/sv7/42_hires.png",
    },
    altArts: [
      {
        id: "sv7-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/sv7/42.png",
          large: "https://images.pokemontcg.io/sv7/42_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/sv7/149.png",
          large: "https://images.pokemontcg.io/sv7/149_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/svp/134.png",
          large: "https://images.pokemontcg.io/svp/134_hires.png",
        },
        flavorText:
          "Though its punches are powerful, this Pokémon's movements are sluggish. It blows icy bubbles from its mouth to immobilize its opponents.",
      },
    ],
  },
  {
    id: "sv7-87",
    name: "Crabrawler",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    evolvesTo: ["Crabominable"],
    attacks: [
      {
        name: "Vise Grip",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
      {
        name: "Crabhammer",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "87",
    nationalPokedexNumbers: [739],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/87.png",
      large: "https://images.pokemontcg.io/sv7/87_hires.png",
    },
    altArts: [
      {
        id: "sv7-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv7/87.png",
          large: "https://images.pokemontcg.io/sv7/87_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-6",
    name: "Cradily",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Lileep",
    abilities: [
      {
        name: "Selective Slime",
        text: "Once during your turn, you may flip a coin. If heads, choose Burned, Confused, or Poisoned. Your opponent's Active Pokémon is now affected by that Special Condition.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Miasma Wind",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "100×",
        text: "This attack does 100 damage for each Special Condition affecting your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "6",
    nationalPokedexNumbers: [346],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/6.png",
      large: "https://images.pokemontcg.io/sv7/6_hires.png",
    },
    altArts: [
      {
        id: "sv7-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv7/6.png",
          large: "https://images.pokemontcg.io/sv7/6_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-58",
    name: "Cramorant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Water Gun",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Spit Shot",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Energy from this Pokémon. This attack does 120 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    flavorText:
      "It's an incredibly poor learner because it uses the bare minimum amount of energy for its brain. It focuses on battling instead.",
    nationalPokedexNumbers: [845],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/58.png",
      large: "https://images.pokemontcg.io/sv6/58_hires.png",
    },
    altArts: [
      {
        id: "sv6-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv6/58.png",
          large: "https://images.pokemontcg.io/sv6/58_hires.png",
        },
        flavorText:
          "It's an incredibly poor learner because it uses the bare minimum amount of energy for its brain. It focuses on battling instead.",
      },
      {
        id: "sv6-176",
        number: "176",
        images: {
          small: "https://images.pokemontcg.io/sv6/176.png",
          large: "https://images.pokemontcg.io/sv6/176_hires.png",
        },
        flavorText:
          "It's an incredibly poor learner because it uses the bare minimum amount of energy for its brain. It focuses on battling instead.",
      },
    ],
  },
  {
    id: "sv9-137",
    name: "Cramorant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Colorless"],
    attacks: [
      {
        name: "Ceaseless Spitting",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50×",
        text: "Flip a coin until you get tails. This attack does 50 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "137",
    nationalPokedexNumbers: [845],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/137.png",
      large: "https://images.pokemontcg.io/sv9/137_hires.png",
    },
    altArts: [
      {
        id: "sv9-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/sv9/137.png",
          large: "https://images.pokemontcg.io/sv9/137_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-44",
    name: "Cranidos",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Antique Skull Fossil",
    attacks: [
      {
        name: "Push Down",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "44",
    flavorText:
      "Cranidos toughen up their already sturdy heads by headbutting one another.",
    nationalPokedexNumbers: [408],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-44/small",
      large: "https://images.scrydex.com/pokemon/me5-44/large",
    },
    altArts: [
      {
        id: "me5-44",
        number: "44",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-44/small",
          large: "https://images.scrydex.com/pokemon/me5-44/large",
        },
        flavorText:
          "Cranidos toughen up their already sturdy heads by headbutting one another.",
      },
    ],
  },
  {
    id: "me1-85",
    name: "Crawdaunt",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Corphish",
    attacks: [
      {
        name: "Vise Grip",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Cutting Riposte",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "If this Pokémon has any damage counters on it, this attack can be used for Darkness.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "85",
    nationalPokedexNumbers: [342],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/85.png",
      large: "https://images.pokemontcg.io/me1/85_hires.png",
    },
    altArts: [
      {
        id: "me1-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/me1/85.png",
          large: "https://images.pokemontcg.io/me1/85_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-48",
    name: "Crawdaunt",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Water"],
    evolvesFrom: "Corphish",
    attacks: [
      {
        name: "Snip Snip",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "Flip 2 coins. For each heads, discard the top card of your opponent's deck.",
      },
      {
        name: "Rampaging Hammer",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "48",
    flavorText:
      "A rough customer that wildly flails its giant claws. It is said to be extremely hard to raise.",
    nationalPokedexNumbers: [342],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/48.png",
      large: "https://images.pokemontcg.io/sv6/48_hires.png",
    },
    altArts: [
      {
        id: "sv6-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv6/48.png",
          large: "https://images.pokemontcg.io/sv6/48_hires.png",
        },
        flavorText:
          "A rough customer that wildly flails its giant claws. It is said to be extremely hard to raise.",
      },
    ],
  },
  {
    id: "me2-39",
    name: "Cresselia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Swelling Light",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Psychic Energy cards and attach them to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Aurora Beam",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    flavorText:
      "Shiny particles are released from its wings like a veil. It is said to represent the crescent moon.",
    nationalPokedexNumbers: [488],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/39.png",
      large: "https://images.pokemontcg.io/me2/39_hires.png",
    },
    altArts: [
      {
        id: "me2-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/me2/39.png",
          large: "https://images.pokemontcg.io/me2/39_hires.png",
        },
        flavorText:
          "Shiny particles are released from its wings like a veil. It is said to represent the crescent moon.",
      },
    ],
  },
  {
    id: "me55-74",
    name: "Cresselia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Aurora Gain",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
      {
        name: "Lunar Blast",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "74",
    nationalPokedexNumbers: [488],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-74/small",
      large: "https://images.scrydex.com/pokemon/me55-74/large",
    },
    altArts: [
      {
        id: "me55-74",
        number: "74",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-74/small",
          large: "https://images.scrydex.com/pokemon/me55-74/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-21",
    name: "Cresselia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Healing Pirouette",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 20 damage from each of your Pokémon.",
      },
      {
        name: "Crescent Purge",
        cost: ["Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "You may turn 1 of your face-down Prize cards face up. If you do, this attack does 80 more damage. (That Prize card remains face up for the rest of the game.)",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    nationalPokedexNumbers: [488],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/21.png",
      large: "https://images.pokemontcg.io/sv6pt5/21_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/21.png",
          large: "https://images.pokemontcg.io/sv6pt5/21_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/71.png",
          large: "https://images.pokemontcg.io/sv6pt5/71_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-78",
    name: "Croagunk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Toxicroak"],
    attacks: [
      {
        name: "Smack",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    nationalPokedexNumbers: [453],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/78.png",
      large: "https://images.pokemontcg.io/me1/78_hires.png",
    },
    altArts: [
      {
        id: "me1-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/me1/78.png",
          large: "https://images.pokemontcg.io/me1/78_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-23",
    name: "Croagunk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Toxicroak"],
    attacks: [
      {
        name: "Light Punch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Frog Hop",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "23",
    nationalPokedexNumbers: [453],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/23.png",
      large: "https://images.pokemontcg.io/sv6pt5/23_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/23.png",
          large: "https://images.pokemontcg.io/sv6pt5/23_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-51",
    name: "Crobat",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Golbat",
    abilities: [
      {
        name: "Nighttime Maneuvers",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may use this Ability. Search your deck for a card. Shuffle your deck, then put that card on top of it.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Poison Sound Wave",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "80",
        text: "Your opponent's Active Pokémon is now Confused and Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    flavorText:
      "Both of its legs have turned into wings. Without a sound, Crobat flies swiftly toward its prey and sinks its fangs into the nape of its target's neck.",
    nationalPokedexNumbers: [169],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-51/small",
      large: "https://images.scrydex.com/pokemon/me4-51/large",
    },
    altArts: [
      {
        id: "me4-51",
        number: "51",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-51/small",
          large: "https://images.scrydex.com/pokemon/me4-51/large",
        },
        flavorText:
          "Both of its legs have turned into wings. Without a sound, Crobat flies swiftly toward its prey and sinks its fangs into the nape of its target's neck.",
      },
      {
        id: "me4-93",
        number: "93",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-93/small",
          large: "https://images.scrydex.com/pokemon/me4-93/large",
        },
        flavorText:
          "Both of its legs have turned into wings. Without a sound, Crobat flies swiftly toward its prey and sinks its fangs into the nape of its target's neck.",
      },
    ],
  },
  {
    id: "sv6pt5-29",
    name: "Crobat",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Golbat",
    abilities: [
      {
        name: "Shadowy Envoy",
        text: "Once during your turn, if you played Janine's Secret Art from your hand this turn, you may draw cards until you have 8 cards in your hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Poison Fang",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "Your opponent's Active Pokémon is now Poisoned. During Pokémon Checkup, put 2 damage counters on that Pokémon instead of 1.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "29",
    nationalPokedexNumbers: [169],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/29.png",
      large: "https://images.pokemontcg.io/sv6pt5/29_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/29.png",
          large: "https://images.pokemontcg.io/sv6pt5/29_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-47",
    name: "Crobat G",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    abilities: [
      {
        name: "Flash Bite",
        text: "Once during your turn, when you put Crobat G from your hand onto your Bench, you may put 1 damage counter on 1 of your opponent's Pokémon.",
        type: "Poké-POWER",
      },
    ],
    attacks: [
      {
        name: "Toxic Fang",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        text: "The Defending Pokémon is now Poisoned. Put 2 damage counters instead of 1 on the Defending Pokémon between turns.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-20",
      },
    ],
    number: "47",
    nationalPokedexNumbers: [169],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-47/small",
      large: "https://images.scrydex.com/pokemon/me55c-47/large",
    },
    altArts: [
      {
        id: "me55c-47",
        number: "47",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-47/small",
          large: "https://images.scrydex.com/pokemon/me55c-47/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-30",
    name: "Crocalor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fire"],
    evolvesFrom: "Fuecoco",
    attacks: [
      {
        name: "Heat Breath",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "Flip a coin. If heads, this attack does 50 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "30",
    nationalPokedexNumbers: [910],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/30.png",
      large: "https://images.pokemontcg.io/sv8/30_hires.png",
    },
    altArts: [
      {
        id: "sv8-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/sv8/30.png",
          large: "https://images.pokemontcg.io/sv8/30_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-42",
    name: "Croconaw",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Totodile",
    attacks: [
      {
        name: "Crunch",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "42",
    flavorText:
      "If it loses a fang, a new one grows back in its place. There are always 48 fangs lining its mouth.",
    nationalPokedexNumbers: [159],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-42/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-42/large",
    },
    altArts: [
      {
        id: "me2pt5-42",
        number: "42",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-42/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-42/large",
        },
        flavorText:
          "If it loses a fang, a new one grows back in its place. There are always 48 fangs lining its mouth.",
      },
    ],
  },
  {
    id: "sv5-40",
    name: "Croconaw",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Totodile",
    evolvesTo: ["Feraligatr"],
    attacks: [
      {
        name: "Reverse Thrust",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "40",
    flavorText:
      "If it loses a fang, a new one grows back in its place. There are always 48 fangs lining its mouth.",
    nationalPokedexNumbers: [159],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/40.png",
      large: "https://images.pokemontcg.io/sv5/40_hires.png",
    },
    altArts: [
      {
        id: "sv5-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv5/40.png",
          large: "https://images.pokemontcg.io/sv5/40_hires.png",
        },
        flavorText:
          "If it loses a fang, a new one grows back in its place. There are always 48 fangs lining its mouth.",
      },
    ],
  },
  {
    id: "zsv10pt5-52",
    name: "Crustle",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Dwebble",
    abilities: [
      {
        name: "Sturdy",
        text: "If this Pokémon has full HP and would be Knocked Out by damage from an attack, it is not Knocked Out, and its remaining HP becomes 10.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Stone Edge",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "Flip a coin. If heads, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "52",
    flavorText:
      "Competing for territory, Crustle fight viciously. The one whose boulder is broken is the loser of the battle.",
    nationalPokedexNumbers: [558],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/52.png",
      large: "https://images.pokemontcg.io/zsv10pt5/52_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/52.png",
          large: "https://images.pokemontcg.io/zsv10pt5/52_hires.png",
        },
        flavorText:
          "Competing for territory, Crustle fight viciously. The one whose boulder is broken is the loser of the battle.",
      },
      {
        id: "zsv10pt5-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/130.png",
          large: "https://images.pokemontcg.io/zsv10pt5/130_hires.png",
        },
        flavorText:
          "Competing for territory, Crustle fight viciously. The one whose boulder is broken is the loser of the battle.",
      },
    ],
  },
  {
    id: "sv10-12",
    name: "Crustle",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Dwebble",
    abilities: [
      {
        name: "Mysterious Rock Inn",
        text: "Prevent all damage done to this Pokémon by attacks from your opponent's Pokémon ex.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Superb Scissors",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "12",
    nationalPokedexNumbers: [558],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/12.png",
      large: "https://images.pokemontcg.io/sv10/12_hires.png",
    },
    altArts: [
      {
        id: "sv10-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv10/12.png",
          large: "https://images.pokemontcg.io/sv10/12_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-186",
        number: "186",
        images: {
          small: "https://images.pokemontcg.io/sv10/186.png",
          large: "https://images.pokemontcg.io/sv10/186_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-27",
    name: "Cryogonal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Water"],
    attacks: [
      {
        name: "Drag Off",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot. This attack does 20 damage to the new Active Pokémon.",
      },
      {
        name: "Icicle",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "27",
    flavorText:
      "When its body temperature goes up, it turns into steam and vanishes. When its temperature lowers, it returns to ice.",
    nationalPokedexNumbers: [615],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/27.png",
      large: "https://images.pokemontcg.io/zsv10pt5/27_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/27.png",
          large: "https://images.pokemontcg.io/zsv10pt5/27_hires.png",
        },
        flavorText:
          "When its body temperature goes up, it turns into steam and vanishes. When its temperature lowers, it returns to ice.",
      },
      {
        id: "zsv10pt5-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/111.png",
          large: "https://images.pokemontcg.io/zsv10pt5/111_hires.png",
        },
        flavorText:
          "When its body temperature goes up, it turns into steam and vanishes. When its temperature lowers, it returns to ice.",
      },
    ],
  },
  {
    id: "sv8-47",
    name: "Cryogonal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Water"],
    attacks: [
      {
        name: "Call Sign",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Ice Beam",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "47",
    nationalPokedexNumbers: [615],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/47.png",
      large: "https://images.pokemontcg.io/sv8/47_hires.png",
    },
    altArts: [
      {
        id: "sv8-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv8/47.png",
          large: "https://images.pokemontcg.io/sv8/47_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-25",
    name: "Cubchoo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Beartic"],
    attacks: [
      {
        name: "Snotted Up",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, the Defending Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "25",
    flavorText:
      "When it is not feeling well, its mucus gets watery and the power of its Ice-type moves decreases.",
    nationalPokedexNumbers: [613],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/25.png",
      large: "https://images.pokemontcg.io/zsv10pt5/25_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/25.png",
          large: "https://images.pokemontcg.io/zsv10pt5/25_hires.png",
        },
        flavorText:
          "When it is not feeling well, its mucus gets watery and the power of its Ice-type moves decreases.",
      },
      {
        id: "zsv10pt5-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/109.png",
          large: "https://images.pokemontcg.io/zsv10pt5/109_hires.png",
        },
        flavorText:
          "When it is not feeling well, its mucus gets watery and the power of its Ice-type moves decreases.",
      },
    ],
  },
  {
    id: "sv7-72",
    name: "Cubone",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Marowak"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    nationalPokedexNumbers: [104],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/72.png",
      large: "https://images.pokemontcg.io/sv7/72_hires.png",
    },
    altArts: [
      {
        id: "sv7-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv7/72.png",
          large: "https://images.pokemontcg.io/sv7/72_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-76",
    name: "Cubone",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Marowak"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Light Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "76",
    nationalPokedexNumbers: [104],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/76.png",
      large: "https://images.pokemontcg.io/sv9/76_hires.png",
    },
    altArts: [
      {
        id: "sv9-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv9/76.png",
          large: "https://images.pokemontcg.io/sv9/76_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-41",
    name: "Cufant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Metal"],
    evolvesTo: ["Copperajah"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Confront",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "41",
    nationalPokedexNumbers: [878],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/41.png",
      large: "https://images.pokemontcg.io/sv6pt5/41_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/41.png",
          large: "https://images.pokemontcg.io/sv6pt5/41_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/76.png",
          large: "https://images.pokemontcg.io/sv6pt5/76_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-109",
    name: "Cufant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Metal"],
    evolvesTo: ["Copperajah"],
    attacks: [
      {
        name: "Rollout",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "109",
    nationalPokedexNumbers: [878],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/109.png",
      large: "https://images.pokemontcg.io/sv9/109_hires.png",
    },
    altArts: [
      {
        id: "sv9-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/sv9/109.png",
          large: "https://images.pokemontcg.io/sv9/109_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-75",
    name: "Cutiefly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Psychic"],
    evolvesTo: ["Ribombee"],
    attacks: [
      {
        name: "Mini Drain",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Heal 10 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "75",
    flavorText:
      "Nectar and pollen are its favorite fare. You can find Cutiefly hovering around Gossifleur, trying to get some of Gossifleur's pollen.",
    nationalPokedexNumbers: [742],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/75.png",
      large: "https://images.pokemontcg.io/sv5/75_hires.png",
    },
    altArts: [
      {
        id: "sv5-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv5/75.png",
          large: "https://images.pokemontcg.io/sv5/75_hires.png",
        },
        flavorText:
          "Nectar and pollen are its favorite fare. You can find Cutiefly hovering around Gossifleur, trying to get some of Gossifleur's pollen.",
      },
      {
        id: "sv5-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/sv5/172.png",
          large: "https://images.pokemontcg.io/sv5/172_hires.png",
        },
        flavorText:
          "Nectar and pollen are its favorite fare. You can find Cutiefly hovering around Gossifleur, trying to get some of Gossifleur's pollen.",
      },
    ],
  },
  {
    id: "sv7-127",
    name: "Cyclizar",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Colorless"],
    attacks: [
      {
        name: "Tail Snap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Speed Attack",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "127",
    nationalPokedexNumbers: [967],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/127.png",
      large: "https://images.pokemontcg.io/sv7/127_hires.png",
    },
    altArts: [
      {
        id: "sv7-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/sv7/127.png",
          large: "https://images.pokemontcg.io/sv7/127_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-159",
    name: "Cyclizar ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "210",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Break Through",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Zircon Road",
        cost: ["Grass", "Fire", "Psychic"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "You may draw 5 cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "159",
    nationalPokedexNumbers: [967],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/159.png",
      large: "https://images.pokemontcg.io/sv8/159_hires.png",
    },
    altArts: [
      {
        id: "sv8-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/sv8/159.png",
          large: "https://images.pokemontcg.io/sv8/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-228",
        number: "228",
        images: {
          small: "https://images.pokemontcg.io/sv8/228.png",
          large: "https://images.pokemontcg.io/sv8/228_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-52",
    name: "Cynthia's Feebas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Water"],
    evolvesTo: ["Milotic"],
    attacks: [
      {
        name: "Undulate",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    nationalPokedexNumbers: [349],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/52.png",
      large: "https://images.pokemontcg.io/sv10/52_hires.png",
    },
    altArts: [
      {
        id: "sv10-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv10/52.png",
          large: "https://images.pokemontcg.io/sv10/52_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-110",
    name: "Cynthia's Gabite",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Cynthia's Gible",
    abilities: [
      {
        name: "Champion's Call",
        text: "Once during your turn, you may search your deck for a Cynthia's Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dragonslice",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "110",
    flavorText:
      "In rare cases, it molts and sheds its scales. Medicine containing its scales as an ingredient will make a weary body feel invigorated.",
    nationalPokedexNumbers: [444],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-110/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-110/large",
    },
    altArts: [
      {
        id: "me2pt5-110",
        number: "110",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-110/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-110/large",
        },
        flavorText:
          "In rare cases, it molts and sheds its scales. Medicine containing its scales as an ingredient will make a weary body feel invigorated.",
      },
      {
        id: "sv10-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/sv10/103.png",
          large: "https://images.pokemontcg.io/sv10/103_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-111",
    name: "Cynthia's Garchomp ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "330",
    types: ["Fighting"],
    evolvesFrom: "Cynthia's Gabite",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Corkscrew Dive",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "100",
        text: "You may draw cards until you have 6 cards in your hand.",
      },
      {
        name: "Draconic Buster",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "260",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    number: "111",
    nationalPokedexNumbers: [445],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-111/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-111/large",
    },
    altArts: [
      {
        id: "me2pt5-111",
        number: "111",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-111/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-111/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/sv10/104.png",
          large: "https://images.pokemontcg.io/sv10/104_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-215",
        number: "215",
        images: {
          small: "https://images.pokemontcg.io/sv10/215.png",
          large: "https://images.pokemontcg.io/sv10/215_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-232",
        number: "232",
        images: {
          small: "https://images.pokemontcg.io/sv10/232.png",
          large: "https://images.pokemontcg.io/sv10/232_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-241",
        number: "241",
        images: {
          small: "https://images.pokemontcg.io/sv10/241.png",
          large: "https://images.pokemontcg.io/sv10/241_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-109",
    name: "Cynthia's Gible",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Rock Hurl",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "109",
    flavorText:
      "It skulks in caves, and when prey or an enemy passes by, it leaps out and chomps them. The force of its attack sometimes chips its teeth.",
    nationalPokedexNumbers: [443],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-109/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-109/large",
    },
    altArts: [
      {
        id: "me2pt5-109",
        number: "109",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-109/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-109/large",
        },
        flavorText:
          "It skulks in caves, and when prey or an enemy passes by, it leaps out and chomps them. The force of its attack sometimes chips its teeth.",
      },
      {
        id: "sv10-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/sv10/102.png",
          large: "https://images.pokemontcg.io/sv10/102_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-53",
    name: "Cynthia's Milotic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Water"],
    evolvesFrom: "Cynthia's Feebas",
    attacks: [
      {
        name: "Aqua Split",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "This attack also does 30 damage to 2 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "53",
    nationalPokedexNumbers: [350],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/53.png",
      large: "https://images.pokemontcg.io/sv10/53_hires.png",
    },
    altArts: [
      {
        id: "sv10-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv10/53.png",
          large: "https://images.pokemontcg.io/sv10/53_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-7",
    name: "Cynthia's Roselia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Roserade"],
    attacks: [
      {
        name: "Spike Sting",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    nationalPokedexNumbers: [315],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/7.png",
      large: "https://images.pokemontcg.io/sv10/7_hires.png",
    },
    altArts: [
      {
        id: "sv10-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv10/7.png",
          large: "https://images.pokemontcg.io/sv10/7_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-8",
    name: "Cynthia's Roserade",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Cynthia's Roselia",
    abilities: [
      {
        name: "Cheer On to Glory",
        text: "Attacks used by your Cynthia's Pokémon do 30 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Leaf Step",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    nationalPokedexNumbers: [407],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/8.png",
      large: "https://images.pokemontcg.io/sv10/8_hires.png",
    },
    altArts: [
      {
        id: "sv10-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv10/8.png",
          large: "https://images.pokemontcg.io/sv10/8_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-184",
        number: "184",
        images: {
          small: "https://images.pokemontcg.io/sv10/184.png",
          large: "https://images.pokemontcg.io/sv10/184_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-133",
    name: "Cynthia's Spiritomb",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Raging Curse",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "This attack does 10 damage for each damage counter on all of your Benched Cynthia's Pokémon. This attack's damage isn't affected by Weakness.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "133",
    flavorText:
      "Its constant mischief and misdeeds resulted in it being bound to an Odd Keystone by a mysterious spell.",
    nationalPokedexNumbers: [442],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-133/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-133/large",
    },
    altArts: [
      {
        id: "me2pt5-133",
        number: "133",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-133/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-133/large",
        },
        flavorText:
          "Its constant mischief and misdeeds resulted in it being bound to an Odd Keystone by a mysterious spell.",
      },
      {
        id: "me2pt5-244",
        number: "244",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-244/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-244/large",
        },
        flavorText:
          "Its constant mischief and misdeeds resulted in it being bound to an Odd Keystone by a mysterious spell.",
      },
      {
        id: "sv10-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/sv10/129.png",
          large: "https://images.pokemontcg.io/sv10/129_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-67",
    name: "Dachsbun ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "250",
    types: ["Psychic"],
    evolvesFrom: "Fidough",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Time to Chow Down",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may heal all damage from each of your Evolution Pokémon. If you healed any damage in this way, discard all Energy from those Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Wonder Shine",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "67",
    nationalPokedexNumbers: [927],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/67.png",
      large: "https://images.pokemontcg.io/sv7/67_hires.png",
    },
    altArts: [
      {
        id: "sv7-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv7/67.png",
          large: "https://images.pokemontcg.io/sv7/67_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/sv7/160.png",
          large: "https://images.pokemontcg.io/sv7/160_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/sv7/169.png",
          large: "https://images.pokemontcg.io/sv7/169_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-19",
    name: "Dark Tyranitar",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Dark Pupitar",
    attacks: [
      {
        name: "Grind",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Does 10 damage plus 10 more damage for each Energy attached to Dark Tyranitar.",
      },
      {
        name: "Spinning Tail",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        text: "Does 20 damage to each of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Bite Off",
        cost: ["Darkness", "Darkness", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 5,
        damage: "70+",
        text: "If the Defending Pokémon is Pokémon-ex, this attack does 70 damage plus 50 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Psychic",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    nationalPokedexNumbers: [248],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-19/small",
      large: "https://images.scrydex.com/pokemon/me55c-19/large",
    },
    altArts: [
      {
        id: "me55c-19",
        number: "19",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-19/small",
          large: "https://images.scrydex.com/pokemon/me55c-19/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-99",
    name: "Darkrai & Cresselia LEGEND",
    supertype: "Pokémon",
    subtypes: ["LEGEND"],
    hp: "150",
    types: ["Darkness", "Psychic"],
    rules: [
      "Put this card from your hand onto your Bench only with the other half of Darkrai & Cresselia LEGEND.",
      "When this Pokémon has been Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Lost Crisis",
        cost: ["Darkness", "Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100",
        text: "Choose 2 Energy attached to Darkrai & Cresselia LEGEND and put them in the Lost Zone. If any of your opponent's Pokémon would be Knocked Out by damage from this attack, put that Pokémon and all cards attached to it in the Lost Zone instead of discarding it.",
      },
      {
        name: "Moon's Invite",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        text: "Move as many damage counters on your opponent's Pokémon as you like to any of your opponent's other Pokémon in any way you like.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "99",
    nationalPokedexNumbers: [488],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-99/small",
      large: "https://images.scrydex.com/pokemon/me55c-99/large",
    },
    altArts: [
      {
        id: "me55c-99",
        number: "99",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-99/small",
          large: "https://images.scrydex.com/pokemon/me55c-99/large",
        },
        flavorText: "",
      },
      {
        id: "me55c-100",
        number: "100",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-100/small",
          large: "https://images.scrydex.com/pokemon/me55c-100/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-110",
    name: "Darkrai ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Darkness"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Wind of Darkness",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
      {
        name: "Night Impact",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "110",
    nationalPokedexNumbers: [491],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/110.png",
      large: "https://images.pokemontcg.io/svp/110_hires.png",
    },
    altArts: [
      {
        id: "svp-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/svp/110.png",
          large: "https://images.pokemontcg.io/svp/110_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-14",
    name: "Darmanitan",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Darumaka",
    attacks: [
      {
        name: "Searing Flame",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Smashing Headbutt",
        cost: ["Fire", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "180",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "14",
    flavorText:
      "Its internal fire burns at 2,500° F, making enough power that it can destroy a dump truck with one punch.",
    nationalPokedexNumbers: [555],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/14.png",
      large: "https://images.pokemontcg.io/zsv10pt5/14_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/14.png",
          large: "https://images.pokemontcg.io/zsv10pt5/14_hires.png",
        },
        flavorText:
          "Its internal fire burns at 2,500° F, making enough power that it can destroy a dump truck with one punch.",
      },
      {
        id: "zsv10pt5-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/98.png",
          large: "https://images.pokemontcg.io/zsv10pt5/98_hires.png",
        },
        flavorText:
          "Its internal fire burns at 2,500° F, making enough power that it can destroy a dump truck with one punch.",
      },
    ],
  },
  {
    id: "me2-16",
    name: "Darmanitan",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fire"],
    evolvesFrom: "Darumaka",
    attacks: [
      {
        name: "Blaze Ball",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "40+",
        text: "This attack does 40 more damage for each Fire Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "16",
    flavorText:
      "This Pokémon's power level rises along with the temperature of its fire, which can reach 2,500 degrees Fahrenheit.",
    nationalPokedexNumbers: [555],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/16.png",
      large: "https://images.pokemontcg.io/me2/16_hires.png",
    },
    altArts: [
      {
        id: "me2-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/me2/16.png",
          large: "https://images.pokemontcg.io/me2/16_hires.png",
        },
        flavorText:
          "This Pokémon's power level rises along with the temperature of its fire, which can reach 2,500 degrees Fahrenheit.",
      },
    ],
  },
  {
    id: "sv6-35",
    name: "Darmanitan",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Darumaka",
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
      {
        name: "Inferno Onrush",
        cost: ["Fire", "Fire", "Fire"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "This Pokémon also does 70 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "35",
    flavorText:
      "The thick arms of this hot-blooded Pokémon can deliver punches capable of obliterating a dump truck.",
    nationalPokedexNumbers: [555],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/35.png",
      large: "https://images.pokemontcg.io/sv6/35_hires.png",
    },
    altArts: [
      {
        id: "sv6-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv6/35.png",
          large: "https://images.pokemontcg.io/sv6/35_hires.png",
        },
        flavorText:
          "The thick arms of this hot-blooded Pokémon can deliver punches capable of obliterating a dump truck.",
      },
    ],
  },
  {
    id: "me3-11",
    name: "Dartrix",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Rowlet",
    attacks: [
      {
        name: "Leafage",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Feather Shot",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Energy from this Pokémon, and this attack does 90 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "11",
    nationalPokedexNumbers: [723],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-11/small",
      large: "https://images.scrydex.com/pokemon/me3-11/large",
    },
    altArts: [
      {
        id: "me3-11",
        number: "11",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-11/small",
          large: "https://images.scrydex.com/pokemon/me3-11/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-4",
    name: "Dartrix",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Rowlet",
    evolvesTo: ["Decidueye"],
    attacks: [
      {
        name: "United Wings",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each Pokémon in your discard pile that has the United Wings attack.",
      },
      {
        name: "Cutting Wind",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    nationalPokedexNumbers: [723],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/4.png",
      large: "https://images.pokemontcg.io/sv6pt5/4_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/4.png",
          large: "https://images.pokemontcg.io/sv6pt5/4_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-13",
    name: "Darumaka",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Darmanitan"],
    attacks: [
      {
        name: "Will-O-Wisp",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "13",
    flavorText:
      "When its internal fire is burning, it cannot calm down and it runs around. When the fire diminishes, it falls asleep.",
    nationalPokedexNumbers: [554],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/13.png",
      large: "https://images.pokemontcg.io/zsv10pt5/13_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/13.png",
          large: "https://images.pokemontcg.io/zsv10pt5/13_hires.png",
        },
        flavorText:
          "When its internal fire is burning, it cannot calm down and it runs around. When the fire diminishes, it falls asleep.",
      },
      {
        id: "zsv10pt5-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/97.png",
          large: "https://images.pokemontcg.io/zsv10pt5/97_hires.png",
        },
        flavorText:
          "When its internal fire is burning, it cannot calm down and it runs around. When the fire diminishes, it falls asleep.",
      },
    ],
  },
  {
    id: "me2-15",
    name: "Darumaka",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Darmanitan"],
    attacks: [
      {
        name: "Blaze Ball",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "10+",
        text: "This attack does 20 more damage for each Fire Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "15",
    flavorText:
      "This popular symbol of good fortune will never fall over in its sleep, no matter how it's pushed or pulled.",
    nationalPokedexNumbers: [554],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/15.png",
      large: "https://images.pokemontcg.io/me2/15_hires.png",
    },
    altArts: [
      {
        id: "me2-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/me2/15.png",
          large: "https://images.pokemontcg.io/me2/15_hires.png",
        },
        flavorText:
          "This popular symbol of good fortune will never fall over in its sleep, no matter how it's pushed or pulled.",
      },
    ],
  },
  {
    id: "sv6-34",
    name: "Darumaka",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Darmanitan"],
    attacks: [
      {
        name: "Strength",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Fire Tackle",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    flavorText:
      "It derives its power from fire burning inside its body. If the fire dwindles, this Pokémon will immediately fall asleep.",
    nationalPokedexNumbers: [554],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/34.png",
      large: "https://images.pokemontcg.io/sv6/34_hires.png",
    },
    altArts: [
      {
        id: "sv6-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv6/34.png",
          large: "https://images.pokemontcg.io/sv6/34_hires.png",
        },
        flavorText:
          "It derives its power from fire burning inside its body. If the fire dwindles, this Pokémon will immediately fall asleep.",
      },
    ],
  },
  {
    id: "sv6pt5-5",
    name: "Decidueye",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Dartrix",
    attacks: [
      {
        name: "Stock Up on Feathers",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw cards until you have 7 cards in your hand.",
      },
      {
        name: "Power Shot",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "170",
        text: "Discard a Basic Grass Energy card from your hand. If you can't, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    nationalPokedexNumbers: [724],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/5.png",
      large: "https://images.pokemontcg.io/sv6pt5/5_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/5.png",
          large: "https://images.pokemontcg.io/sv6pt5/5_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-12",
    name: "Decidueye ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Grass"],
    evolvesFrom: "Dartrix",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Sniper's Eye",
        text: "If your opponent has exactly 4 cards in their hand, ignore all Colorless Energy in the costs of attacks used by this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Crushing Arrow",
        cost: ["Grass", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "240",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "12",
    nationalPokedexNumbers: [724],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-12/small",
      large: "https://images.scrydex.com/pokemon/me3-12/large",
    },
    altArts: [
      {
        id: "me3-12",
        number: "12",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-12/small",
          large: "https://images.scrydex.com/pokemon/me3-12/large",
        },
        flavorText: "",
      },
      {
        id: "me3-100",
        number: "100",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-100/small",
          large: "https://images.scrydex.com/pokemon/me3-100/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-29",
    name: "Dedenne",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Tail Generator",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Choose Basic Lightning Energy cards from your discard pile up to the amount of Energy attached to all of your opponent's Pokémon and attach them to your Lightning Pokémon in any way you like.",
      },
      {
        name: "Thunder Shock",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "29",
    nationalPokedexNumbers: [702],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-29/small",
      large: "https://images.scrydex.com/pokemon/me3-29/large",
    },
    altArts: [
      {
        id: "me3-29",
        number: "29",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-29/small",
          large: "https://images.scrydex.com/pokemon/me3-29/large",
        },
        flavorText: "",
      },
      {
        id: "me3-93",
        number: "93",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-93/small",
          large: "https://images.scrydex.com/pokemon/me3-93/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-87",
    name: "Dedenne",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Electromagnetic Sonar",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put a Trainer card from your discard pile into your hand.",
      },
      {
        name: "Gnaw",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "87",
    nationalPokedexNumbers: [702],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/87.png",
      large: "https://images.pokemontcg.io/sv8/87_hires.png",
    },
    altArts: [
      {
        id: "sv8-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv8/87.png",
          large: "https://images.pokemontcg.io/sv8/87_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-6",
    name: "Deerling",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Sawsbuck"],
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    flavorText:
      "The color and scent of their fur changes to match the mountain grass. When they sense hostility, they hide in the grass.",
    nationalPokedexNumbers: [585],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/6.png",
      large: "https://images.pokemontcg.io/rsv10pt5/6_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/6.png",
          large: "https://images.pokemontcg.io/rsv10pt5/6_hires.png",
        },
        flavorText:
          "The color and scent of their fur changes to match the mountain grass. When they sense hostility, they hide in the grass.",
      },
      {
        id: "rsv10pt5-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/91.png",
          large: "https://images.pokemontcg.io/rsv10pt5/91_hires.png",
        },
        flavorText:
          "The color and scent of their fur changes to match the mountain grass. When they sense hostility, they hide in the grass.",
      },
    ],
  },
  {
    id: "sv5-16",
    name: "Deerling",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Sawsbuck"],
    attacks: [
      {
        name: "Flop",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Leaf Litter Tackle",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "Discard a Grass Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    flavorText:
      "Deerling have different scents depending on the season. In this form, Deerling have a softly sweet scent that lingers in the nose.",
    nationalPokedexNumbers: [585],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/16.png",
      large: "https://images.pokemontcg.io/sv5/16_hires.png",
    },
    altArts: [
      {
        id: "sv5-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv5/16.png",
          large: "https://images.pokemontcg.io/sv5/16_hires.png",
        },
        flavorText:
          "Deerling have different scents depending on the season. In this form, Deerling have a softly sweet scent that lingers in the nose.",
      },
      {
        id: "sv5-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/sv5/165.png",
          large: "https://images.pokemontcg.io/sv5/165_hires.png",
        },
        flavorText:
          "Deerling have different scents depending on the season. In this form, Deerling have a softly sweet scent that lingers in the nose.",
      },
    ],
  },
  {
    id: "rsv10pt5-65",
    name: "Deino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    evolvesTo: ["Zweilous"],
    attacks: [
      {
        name: "Body Slam",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Darkness Fang",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "65",
    flavorText:
      "It tends to bite everything, and it is not a picky eater. Approaching it carelessly is dangerous.",
    nationalPokedexNumbers: [633],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/65.png",
      large: "https://images.pokemontcg.io/rsv10pt5/65_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/65.png",
          large: "https://images.pokemontcg.io/rsv10pt5/65_hires.png",
        },
        flavorText:
          "It tends to bite everything, and it is not a picky eater. Approaching it carelessly is dangerous.",
      },
      {
        id: "rsv10pt5-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/146.png",
          large: "https://images.pokemontcg.io/rsv10pt5/146_hires.png",
        },
        flavorText:
          "It tends to bite everything, and it is not a picky eater. Approaching it carelessly is dangerous.",
      },
    ],
  },
  {
    id: "me55-97",
    name: "Deino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
      },
      {
        name: "Headbutt",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "97",
    nationalPokedexNumbers: [633],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-97/small",
      large: "https://images.scrydex.com/pokemon/me55-97/large",
    },
    altArts: [
      {
        id: "me55-97",
        number: "97",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-97/small",
          large: "https://images.scrydex.com/pokemon/me55-97/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-117",
    name: "Deino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Zweilous"],
    attacks: [
      {
        name: "Stomp Off",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard the top card of your opponent's deck.",
      },
      {
        name: "Bite",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "117",
    nationalPokedexNumbers: [633],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/117.png",
      large: "https://images.pokemontcg.io/sv8/117_hires.png",
    },
    altArts: [
      {
        id: "sv8-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/sv8/117.png",
          large: "https://images.pokemontcg.io/sv8/117_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-166",
    name: "Delcatty",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Skitty",
    attacks: [
      {
        name: "Cat Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Energy Crush",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "This attack does 40 damage for each Energy attached to all of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "166",
    flavorText:
      "It dislikes dirty places. It often searches for a comfortable place in which to groom itself.",
    nationalPokedexNumbers: [301],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-166/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-166/large",
    },
    altArts: [
      {
        id: "me2pt5-166",
        number: "166",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-166/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-166/large",
        },
        flavorText:
          "It dislikes dirty places. It often searches for a comfortable place in which to groom itself.",
      },
    ],
  },
  {
    id: "me55c-5",
    name: "Delcatty",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Colorless"],
    evolvesFrom: "Skitty",
    abilities: [
      {
        name: "Energy Draw",
        text: "Once during your turn (before your attack), you may discard 1 Energy card from your hand. Then draw up to 3 cards from your deck. This power can't be used if Delcatty is affected by a Special Condition.",
        type: "Poké-POWER",
      },
    ],
    attacks: [
      {
        name: "Max Energy Source",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Does 10 damage times the amount of Energy attached to all of your Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "5",
    nationalPokedexNumbers: [301],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-5/small",
      large: "https://images.scrydex.com/pokemon/me55c-5/large",
    },
    altArts: [
      {
        id: "me55c-5",
        number: "5",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-5/small",
          large: "https://images.scrydex.com/pokemon/me55c-5/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-131",
    name: "Delcatty",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Skitty",
    attacks: [
      {
        name: "Tail Trickery",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Energy Blender",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "You may move any amount of Energy from your Pokémon to your other Pokémon in any way you like.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "131",
    flavorText:
      "It dislikes dirty places. It often searches for a comfortable place in which to groom itself.",
    nationalPokedexNumbers: [301],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/131.png",
      large: "https://images.pokemontcg.io/sv5/131_hires.png",
    },
    altArts: [
      {
        id: "sv5-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/sv5/131.png",
          large: "https://images.pokemontcg.io/sv5/131_hires.png",
        },
        flavorText:
          "It dislikes dirty places. It often searches for a comfortable place in which to groom itself.",
      },
    ],
  },
  {
    id: "me1-105",
    name: "Delibird",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Colorless"],
    attacks: [
      {
        name: "Quick Gift",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "If you go first, you can use this attack during your first turn. Search your deck for a card and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "105",
    nationalPokedexNumbers: [225],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/105.png",
      large: "https://images.pokemontcg.io/me1/105_hires.png",
    },
    altArts: [
      {
        id: "me1-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/me1/105.png",
          large: "https://images.pokemontcg.io/me1/105_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/me1/152.png",
          large: "https://images.pokemontcg.io/me1/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-18",
    name: "Delibird",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Water"],
    attacks: [
      {
        name: "Pleasing Present",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Each player may attach up to 3 Basic Energy cards from their hand to their Pokémon in any way they like. Your opponent does this first.",
      },
      {
        name: "Flap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    flavorText:
      "It carries food rolled up in its tail. It has a habit of sharing food with people lost in the mountains.",
    nationalPokedexNumbers: [225],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-18/small",
      large: "https://images.scrydex.com/pokemon/me4-18/large",
    },
    altArts: [
      {
        id: "me4-18",
        number: "18",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-18/small",
          large: "https://images.scrydex.com/pokemon/me4-18/large",
        },
        flavorText:
          "It carries food rolled up in its tail. It has a habit of sharing food with people lost in the mountains.",
      },
    ],
  },
  {
    id: "me4-13",
    name: "Delphox",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Fire"],
    evolvesFrom: "Braixen",
    abilities: [
      {
        name: "Flaring Magic",
        text: "Once during your turn, you may discard a Basic Fire Energy card from your hand in order to use this Ability. Draw cards until you have 7 cards in your hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Energized Storm",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each Energy attached to all Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "13",
    flavorText:
      "Using psychic power, it generates a fiery vortex of 5,400 degrees Fahrenheit, incinerating foes swept into this whirl of flame.",
    nationalPokedexNumbers: [655],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-13/small",
      large: "https://images.scrydex.com/pokemon/me4-13/large",
    },
    altArts: [
      {
        id: "me4-13",
        number: "13",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-13/small",
          large: "https://images.scrydex.com/pokemon/me4-13/large",
        },
        flavorText:
          "Using psychic power, it generates a fiery vortex of 5,400 degrees Fahrenheit, incinerating foes swept into this whirl of flame.",
      },
    ],
  },
  {
    id: "me4-31",
    name: "Deoxys",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Genome Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Psychic Energy cards and attach them to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Psychic",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "This attack does 20 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    flavorText:
      "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
    nationalPokedexNumbers: [386],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-31/small",
      large: "https://images.scrydex.com/pokemon/me4-31/large",
    },
    altArts: [
      {
        id: "me4-31",
        number: "31",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-31/small",
          large: "https://images.scrydex.com/pokemon/me4-31/large",
        },
        flavorText:
          "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
      },
    ],
  },
  {
    id: "me4-32",
    name: "Deoxys",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Psyspear",
        cost: ["Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "If this Pokémon has at least 2 extra Energy attached (in addition to this attack's cost), this attack also does 120 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "32",
    flavorText:
      "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
    nationalPokedexNumbers: [386],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-32/small",
      large: "https://images.scrydex.com/pokemon/me4-32/large",
    },
    altArts: [
      {
        id: "me4-32",
        number: "32",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-32/small",
          large: "https://images.scrydex.com/pokemon/me4-32/large",
        },
        flavorText:
          "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
      },
    ],
  },
  {
    id: "me4-33",
    name: "Deoxys",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Psy Protection",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Pokémon that have an Ability.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "33",
    flavorText:
      "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
    nationalPokedexNumbers: [386],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-33/small",
      large: "https://images.scrydex.com/pokemon/me4-33/large",
    },
    altArts: [
      {
        id: "me4-33",
        number: "33",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-33/small",
          large: "https://images.scrydex.com/pokemon/me4-33/large",
        },
        flavorText:
          "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
      },
    ],
  },
  {
    id: "me4-34",
    name: "Deoxys",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Psychic"],
    attacks: [
      {
        name: "Psyspeed",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "You may draw cards until you have 5 cards in your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "34",
    flavorText:
      "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
    nationalPokedexNumbers: [386],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-34/small",
      large: "https://images.scrydex.com/pokemon/me4-34/large",
    },
    altArts: [
      {
        id: "me4-34",
        number: "34",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-34/small",
          large: "https://images.scrydex.com/pokemon/me4-34/large",
        },
        flavorText:
          "An alien virus that fell to earth on a meteor underwent a DNA mutation to become this Pokémon.",
      },
    ],
  },
  {
    id: "me2-22",
    name: "Dewgong",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Water"],
    evolvesFrom: "Seel",
    abilities: [
      {
        name: "Thick Fat",
        text: "This Pokémon takes 30 less damage from attacks from your opponent's Fire or Water Pokémon (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Slam",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70×",
        text: "Flip 2 coins. This attack does 70 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "22",
    flavorText:
      "It sleeps under shallow ocean waters during the day, then looks for food at night when it's colder.",
    nationalPokedexNumbers: [87],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/22.png",
      large: "https://images.pokemontcg.io/me2/22_hires.png",
    },
    altArts: [
      {
        id: "me2-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/me2/22.png",
          large: "https://images.pokemontcg.io/me2/22_hires.png",
        },
        flavorText:
          "It sleeps under shallow ocean waters during the day, then looks for food at night when it's colder.",
      },
      {
        id: "me2-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/me2/97.png",
          large: "https://images.pokemontcg.io/me2/97_hires.png",
        },
        flavorText:
          "It sleeps under shallow ocean waters during the day, then looks for food at night when it's colder.",
      },
    ],
  },
  {
    id: "me3-19",
    name: "Dewgong",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Water"],
    evolvesFrom: "Seel",
    abilities: [
      {
        name: "Wash Out",
        text: "As often as you like during your turn, you may use this Ability. Move a Water Energy from 1 of your Benched Pokémon to your Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Wave Splash",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    nationalPokedexNumbers: [87],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-19/small",
      large: "https://images.scrydex.com/pokemon/me3-19/large",
    },
    altArts: [
      {
        id: "me3-19",
        number: "19",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-19/small",
          large: "https://images.scrydex.com/pokemon/me3-19/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-22",
    name: "Dewott",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Oshawott",
    evolvesTo: ["Samurott"],
    attacks: [
      {
        name: "Energized Shell",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    flavorText:
      "Strict training is how it learns its flowing double-scalchop technique.",
    nationalPokedexNumbers: [502],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/22.png",
      large: "https://images.pokemontcg.io/rsv10pt5/22_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/22.png",
          large: "https://images.pokemontcg.io/rsv10pt5/22_hires.png",
        },
        flavorText:
          "Strict training is how it learns its flowing double-scalchop technique.",
      },
      {
        id: "rsv10pt5-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/106.png",
          large: "https://images.pokemontcg.io/rsv10pt5/106_hires.png",
        },
        flavorText:
          "Strict training is how it learns its flowing double-scalchop technique.",
      },
    ],
  },
  {
    id: "me1-18",
    name: "Dhelmise",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Earthen Power",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If you have a Stadium in play, this attack does 50 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "18",
    nationalPokedexNumbers: [781],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/18.png",
      large: "https://images.pokemontcg.io/me1/18_hires.png",
    },
    altArts: [
      {
        id: "me1-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/me1/18.png",
          large: "https://images.pokemontcg.io/me1/18_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-39",
    name: "Dhelmise",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Psychic"],
    attacks: [
      {
        name: "Vengeful Anchor",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If you have 4 or more Pokémon that have the Hide 'n' Sneak Ability in your discard pile, this attack does 140 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "39",
    flavorText:
      "After a piece of seaweed merged with debris from a sunken ship, it was reborn as this ghost Pokémon.",
    nationalPokedexNumbers: [781],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-39/small",
      large: "https://images.scrydex.com/pokemon/me5-39/large",
    },
    altArts: [
      {
        id: "me5-39",
        number: "39",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-39/small",
          large: "https://images.scrydex.com/pokemon/me5-39/large",
        },
        flavorText:
          "After a piece of seaweed merged with debris from a sunken ship, it was reborn as this ghost Pokémon.",
      },
      {
        id: "me5-91",
        number: "91",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-91/small",
          large: "https://images.scrydex.com/pokemon/me5-91/large",
        },
        flavorText:
          'After a piece of seaweed merged with debris from a "sunken ship, it was reborn as this ghost Pokémon.',
      },
    ],
  },
  {
    id: "sv5-19",
    name: "Dhelmise",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Grass"],
    attacks: [
      {
        name: "Spinning Attack",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Steel Anchor",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If you have any Metal Pokémon on your Bench, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "19",
    flavorText:
      "After a piece of seaweed merged with debris from a sunken ship, it was reborn as this ghost Pokémon.",
    nationalPokedexNumbers: [781],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/19.png",
      large: "https://images.pokemontcg.io/sv5/19_hires.png",
    },
    altArts: [
      {
        id: "sv5-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv5/19.png",
          large: "https://images.pokemontcg.io/sv5/19_hires.png",
        },
        flavorText:
          "After a piece of seaweed merged with debris from a sunken ship, it was reborn as this ghost Pokémon.",
      },
    ],
  },
  {
    id: "sv8-10",
    name: "Dhelmise",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Grass"],
    attacks: [
      {
        name: "Rescue Kedge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put up to 2 Pokémon from your discard pile into your hand.",
      },
      {
        name: "Annihilating Anchor",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "10",
    nationalPokedexNumbers: [781],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/10.png",
      large: "https://images.pokemontcg.io/sv8/10_hires.png",
    },
    altArts: [
      {
        id: "sv8-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv8/10.png",
          large: "https://images.pokemontcg.io/sv8/10_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-70",
    name: "Dhelmise",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Bind Down",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Anchor Smash",
        cost: ["Psychic", "Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "70",
    nationalPokedexNumbers: [781],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/70.png",
      large: "https://images.pokemontcg.io/sv9/70_hires.png",
    },
    altArts: [
      {
        id: "sv9-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv9/70.png",
          large: "https://images.pokemontcg.io/sv9/70_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-95",
    name: "Dialga",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Metal"],
    attacks: [
      {
        name: "Beam",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Chrono Burst",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "You may shuffle all Energy attached to this Pokémon into your deck and have this attack do 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "95",
    nationalPokedexNumbers: [483],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/95.png",
      large: "https://images.pokemontcg.io/me1/95_hires.png",
    },
    altArts: [
      {
        id: "me1-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/me1/95.png",
          large: "https://images.pokemontcg.io/me1/95_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-103",
    name: "Dialga",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Reversed Clock",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Shuffle up to 3 in any combination of Pokémon and Basic Energy cards from your discard pile into your deck.",
      },
      {
        name: "Heavy Impact",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "103",
    nationalPokedexNumbers: [483],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-103/small",
      large: "https://images.scrydex.com/pokemon/me55-103/large",
    },
    altArts: [
      {
        id: "me55-103",
        number: "103",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-103/small",
          large: "https://images.scrydex.com/pokemon/me55-103/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-135",
    name: "Dialga",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Dragon"],
    attacks: [
      {
        name: "Time Manipulation",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for 2 cards, shuffle your deck, then put those cards on top of it in any order.",
      },
      {
        name: "Buster Tail",
        cost: ["Psychic", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "135",
    nationalPokedexNumbers: [483],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/135.png",
      large: "https://images.pokemontcg.io/sv8/135_hires.png",
    },
    altArts: [
      {
        id: "sv8-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/sv8/135.png",
          large: "https://images.pokemontcg.io/sv8/135_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-86",
    name: "Diancie",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Diffuse Reflection",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40×",
        text: "This attack does 40 damage for each Special Energy attached to all of your opponent's Pokémon.",
      },
      {
        name: "Power Gem",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "86",
    nationalPokedexNumbers: [719],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/86.png",
      large: "https://images.pokemontcg.io/sv7/86_hires.png",
    },
    altArts: [
      {
        id: "sv7-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv7/86.png",
          large: "https://images.pokemontcg.io/sv7/86_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-65",
    name: "Diggersby",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Colorless"],
    evolvesFrom: "Bunnelby",
    attacks: [
      {
        name: "Earthquake",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "140",
        text: "This attack also does 30 damage to each of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Whap Down",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "65",
    nationalPokedexNumbers: [660],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-65/small",
      large: "https://images.scrydex.com/pokemon/me3-65/large",
    },
    altArts: [
      {
        id: "me3-65",
        number: "65",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-65/small",
          large: "https://images.scrydex.com/pokemon/me3-65/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-17",
    name: "Dipplin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Applin",
    attacks: [
      {
        name: "Energy Loop",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Put an Energy attached to this Pokémon into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "17",
    nationalPokedexNumbers: [1011],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/17.png",
      large: "https://images.pokemontcg.io/sv10/17_hires.png",
    },
    altArts: [
      {
        id: "sv10-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv10/17.png",
          large: "https://images.pokemontcg.io/sv10/17_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-18",
    name: "Dipplin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Grass"],
    evolvesFrom: "Applin",
    abilities: [
      {
        name: "Festival Lead",
        text: "If Festival Grounds is in play, this Pokémon may use an attack it has twice. If the first attack Knocks Out your opponent's Active Pokémon, you may attack again after your opponent chooses a new Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Do the Wave",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "18",
    nationalPokedexNumbers: [1011],
    flavorText:
      "The head sticking out belongs to the fore-wyrm, while the tail belongs to the core-wyrm. The two share one apple and help each other out.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/18.png",
      large: "https://images.pokemontcg.io/sv6/18_hires.png",
    },
    altArts: [
      {
        id: "sv6-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv6/18.png",
          large: "https://images.pokemontcg.io/sv6/18_hires.png",
        },
        flavorText:
          "The head sticking out belongs to the fore-wyrm, while the tail belongs to the core-wyrm. The two share one apple and help each other out.",
      },
      {
        id: "sv6-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/sv6/170.png",
          large: "https://images.pokemontcg.io/sv6/170_hires.png",
        },
        flavorText:
          "The head sticking out belongs to the fore-wyrm, while the tail belongs to the core-wyrm. The two share one apple and help each other out.",
      },
      {
        id: "sv8pt5-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/10.png",
          large: "https://images.pokemontcg.io/sv8pt5/10_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-127",
    name: "Dipplin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Dragon"],
    evolvesFrom: "Applin",
    attacks: [
      {
        name: "Syrup Catcher",
        cost: ["Grass", "Fire"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot. This attack does 70 damage to the new Active Pokémon.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "127",
    nationalPokedexNumbers: [1011],
    flavorText:
      "The head sticking out belongs to the fore-wyrm, while the tail belongs to the core-wyrm. The two share one apple and help each other out.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/127.png",
      large: "https://images.pokemontcg.io/sv6/127_hires.png",
    },
    altArts: [
      {
        id: "sv6-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/sv6/127.png",
          large: "https://images.pokemontcg.io/sv6/127_hires.png",
        },
        flavorText:
          "The head sticking out belongs to the fore-wyrm, while the tail belongs to the core-wyrm. The two share one apple and help each other out.",
      },
    ],
  },
  {
    id: "sv7-13",
    name: "Dipplin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Applin",
    attacks: [
      {
        name: "Coated Attack",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Basic Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "13",
    nationalPokedexNumbers: [1011],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/13.png",
      large: "https://images.pokemontcg.io/sv7/13_hires.png",
    },
    altArts: [
      {
        id: "sv7-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/sv7/13.png",
          large: "https://images.pokemontcg.io/sv7/13_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-115",
    name: "Ditto",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Surprisingly Transform",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        text: "Flip a coin. If heads, search your deck for a Pokémon and switch it with this Pokémon. Any attached cards, damage counters, Special Conditions, turns in play, and any other effects remain on the new Pokémon. If you switched a Pokémon in this way, put this card into your deck. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "115",
    nationalPokedexNumbers: [132],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-115/small",
      large: "https://images.scrydex.com/pokemon/me55-115/large",
    },
    altArts: [
      {
        id: "me55-115",
        number: "115",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-115/small",
          large: "https://images.scrydex.com/pokemon/me55-115/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-22",
    name: "Dolliv",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Smoliv",
    attacks: [
      {
        name: "Nutrients",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 40 damage from 1 of your Pokémon.",
      },
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [929],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/22.png",
      large: "https://images.pokemontcg.io/sv10/22_hires.png",
    },
    altArts: [
      {
        id: "sv10-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/sv10/22.png",
          large: "https://images.pokemontcg.io/sv10/22_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-66",
    name: "Dondozo ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "260",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Avenging Billow",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "This attack does 10 more damage for each damage counter on this Pokémon.",
      },
      {
        name: "Dynamic Dive",
        cost: ["Water", "Water", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120+",
        text: "You may do 120 more damage. If you do, this Pokémon also does 50 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "66",
    nationalPokedexNumbers: [977],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/66.png",
      large: "https://images.pokemontcg.io/sv10/66_hires.png",
    },
    altArts: [
      {
        id: "sv10-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv10/66.png",
          large: "https://images.pokemontcg.io/sv10/66_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-211",
        number: "211",
        images: {
          small: "https://images.pokemontcg.io/sv10/211.png",
          large: "https://images.pokemontcg.io/sv10/211_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-45",
    name: "Donphan",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Phanpy",
    attacks: [
      {
        name: "No Reprieve",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your next turn, attacks used by this Pokémon do 120 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      },
      {
        name: "Smashing Headbutt",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "180",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "45",
    flavorText:
      "Donphan is normally a calm Pokemon, but once it is enraged, it will curl its body into a ball and charge at you while rolling.",
    nationalPokedexNumbers: [232],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-45/small",
      large: "https://images.scrydex.com/pokemon/me4-45/large",
    },
    altArts: [
      {
        id: "me4-45",
        number: "45",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-45/small",
          large: "https://images.scrydex.com/pokemon/me4-45/large",
        },
        flavorText:
          "Donphan is normally a calm Pokemon, but once it is enraged, it will curl its body into a ball and charge at you while rolling.",
      },
    ],
  },
  {
    id: "sv8-103",
    name: "Donphan",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Phanpy",
    attacks: [
      {
        name: "Knock Flat",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
      {
        name: "Guarded Rolling",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Discard 2 Energy from this Pokémon. During your opponent's next turn, this Pokémon takes 100 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "103",
    nationalPokedexNumbers: [232],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/103.png",
      large: "https://images.pokemontcg.io/sv8/103_hires.png",
    },
    altArts: [
      {
        id: "sv8-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/sv8/103.png",
          large: "https://images.pokemontcg.io/sv8/103_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-57",
    name: "Doublade",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Metal"],
    evolvesFrom: "Honedge",
    attacks: [
      {
        name: "Weaponized Swords",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: "Reveal any number of Honedge, Doublade, and Aegislash from your hand, and this attack does 60 damage for each card you revealed in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "57",
    nationalPokedexNumbers: [680],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-57/small",
      large: "https://images.scrydex.com/pokemon/me3-57/large",
    },
    altArts: [
      {
        id: "me3-57",
        number: "57",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-57/small",
          large: "https://images.scrydex.com/pokemon/me3-57/large",
        },
        flavorText: "",
      },
      {
        id: "me3-98",
        number: "98",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-98/small",
          large: "https://images.scrydex.com/pokemon/me3-98/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-160",
    name: "Dragapult ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "Tera", "ex"],
    hp: "320",
    types: ["Dragon"],
    evolvesFrom: "Drakloak",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent’s).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Jet Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "70",
        text: "",
      },
      {
        name: "Phantom Dive",
        cost: ["Fire", "Psychic"],
        convertedEnergyCost: 2,
        damage: "200",
        text: "Put 6 damage counters on your opponent's Benched Pokémon in any way you like.",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "160",
    nationalPokedexNumbers: [887],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-160/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-160/large",
    },
    altArts: [
      {
        id: "me2pt5-160",
        number: "160",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-160/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-160/large",
        },
        flavorText: "",
      },
      {
        id: "sv6-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/sv6/130.png",
          large: "https://images.pokemontcg.io/sv6/130_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-200",
        number: "200",
        images: {
          small: "https://images.pokemontcg.io/sv6/200.png",
          large: "https://images.pokemontcg.io/sv6/200_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/73.png",
          large: "https://images.pokemontcg.io/sv8pt5/73_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/165.png",
          large: "https://images.pokemontcg.io/sv8pt5/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-151",
    name: "Dragonair",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Dragon"],
    evolvesFrom: "Dratini",
    abilities: [
      {
        name: "Evolutionary Guidance",
        text: "Once during your turn, if this Pokémon has any Energy attached, you may use this Ability. Search your deck for an Evolution Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Tail Snap",
        cost: ["Water", "Lightning"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "151",
    flavorText:
      "Its crystalline orbs appear to give this Pokémon the power to freely control the weather.",
    nationalPokedexNumbers: [148],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-151/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-151/large",
    },
    altArts: [
      {
        id: "me2pt5-151",
        number: "151",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-151/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-151/large",
        },
        flavorText:
          "Its crystalline orbs appear to give this Pokémon the power to freely control the weather.",
      },
    ],
  },
  {
    id: "me2pt5-159",
    name: "Drakloak",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Dragon"],
    evolvesFrom: "Dreepy",
    abilities: [
      {
        name: "Recon Directive",
        text: "Once during your turn, you may look at the top 2 cards of your deck and put 1 of them into your hand. Put the other card on the bottom of your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dragon Headbutt",
        cost: ["Fire", "Psychic"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "159",
    flavorText:
      "This Pokémon stores up energy in its lungs, then shoots it out. It takes care of Dreepy and battles alongside them until they’re all grown up.",
    nationalPokedexNumbers: [886],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-159/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-159/large",
    },
    altArts: [
      {
        id: "me2pt5-159",
        number: "159",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-159/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-159/large",
        },
        flavorText:
          "This Pokémon stores up energy in its lungs, then shoots it out. It takes care of Dreepy and battles alongside them until they’re all grown up.",
      },
      {
        id: "me2pt5-248",
        number: "248",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-248/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-248/large",
        },
        flavorText:
          "This Pokémon stores up energy in its lungs, then shoots it out. It takes care of Dreepy and battles alongside them until they’re all grown up.",
      },
      {
        id: "sv6-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/sv6/129.png",
          large: "https://images.pokemontcg.io/sv6/129_hires.png",
        },
        flavorText:
          "This Pokémon stores up energy in its lungs, then shoots it out. It takes care of Dreepy and battles alongside them until they're all grown up.",
      },
      {
        id: "sv8pt5-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/72.png",
          large: "https://images.pokemontcg.io/sv8pt5/72_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-176",
    name: "Drampa",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Colorless"],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Dragon Strike",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your next turn, this Pokémon can't use Dragon Strike.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "176",
    flavorText:
      "It has a compassionate personality, but if it is angered, it completely destroys its surroundings with its intense breath.",
    nationalPokedexNumbers: [780],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-176/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-176/large",
    },
    altArts: [
      {
        id: "me2pt5-176",
        number: "176",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-176/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-176/large",
        },
        flavorText:
          "It has a compassionate personality, but if it is angered, it completely destroys its surroundings with its intense breath.",
      },
    ],
  },
  {
    id: "sv5-138",
    name: "Drampa",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Raging Cannon",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If all of your Benched Pokémon have at least 1 damage counter on them, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "138",
    flavorText:
      "The mountains it calls home are nearly two miles in height. On rare occasions, it descends to play with the children living in the towns below.",
    nationalPokedexNumbers: [780],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/138.png",
      large: "https://images.pokemontcg.io/sv5/138_hires.png",
    },
    altArts: [
      {
        id: "sv5-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/sv5/138.png",
          large: "https://images.pokemontcg.io/sv5/138_hires.png",
        },
        flavorText:
          "The mountains it calls home are nearly two miles in height. On rare occasions, it descends to play with the children living in the towns below.",
      },
      {
        id: "sv5-184",
        number: "184",
        images: {
          small: "https://images.pokemontcg.io/sv5/184.png",
          large: "https://images.pokemontcg.io/sv5/184_hires.png",
        },
        flavorText:
          "The mountains it calls home are nearly two miles in height. On rare occasions, it descends to play with the children living in the towns below.",
      },
    ],
  },
  {
    id: "sv9-130",
    name: "Drampa",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Dragon Claw",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "130",
    nationalPokedexNumbers: [780],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/130.png",
      large: "https://images.pokemontcg.io/sv9/130_hires.png",
    },
    altArts: [
      {
        id: "sv9-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/sv9/130.png",
          large: "https://images.pokemontcg.io/sv9/130_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-52",
    name: "Drapion",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Skorupi",
    attacks: [
      {
        name: "Wrack Down",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
      {
        name: "Hazardous Tail",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "This Pokémon also does 70 damage to itself. Your opponent's Active Pokémon is now Paralyzed and Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "52",
    nationalPokedexNumbers: [452],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-52/small",
      large: "https://images.scrydex.com/pokemon/me3-52/large",
    },
    altArts: [
      {
        id: "me3-52",
        number: "52",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-52/small",
          large: "https://images.scrydex.com/pokemon/me3-52/large",
        },
        flavorText: "",
      },
      {
        id: "me3-97",
        number: "97",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-97/small",
          large: "https://images.scrydex.com/pokemon/me3-97/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-150",
    name: "Dratini",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Dragon"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Water", "Lightning"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "150",
    flavorText:
      "This Pokémon is full of life energy. It continually sheds its skin and grows steadily larger.",
    nationalPokedexNumbers: [147],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-150/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-150/large",
    },
    altArts: [
      {
        id: "me2pt5-150",
        number: "150",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-150/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-150/large",
        },
        flavorText:
          "This Pokémon is full of life energy. It continually sheds its skin and grows steadily larger.",
      },
    ],
  },
  {
    id: "sv7-44",
    name: "Drednaw",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Water"],
    evolvesFrom: "Chewtle",
    abilities: [
      {
        name: "Impervious Shell",
        text: "Prevent all damage done to this Pokémon by attacks from your opponent's Pokémon if that damage is 200 or more.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hard Crunch",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "44",
    nationalPokedexNumbers: [834],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/44.png",
      large: "https://images.pokemontcg.io/sv7/44_hires.png",
    },
    altArts: [
      {
        id: "sv7-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv7/44.png",
          large: "https://images.pokemontcg.io/sv7/44_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-158",
    name: "Dreepy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Dragon"],
    attacks: [
      {
        name: "Petty Grudge",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Bite",
        cost: ["Fire", "Psychic"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "158",
    flavorText:
      "It has a habit of biting at Clauncher even though it doesn’t feed on them. This is said to be vestigial behavior from when Dreepy was alive.",
    nationalPokedexNumbers: [885],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-158/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-158/large",
    },
    altArts: [
      {
        id: "me2pt5-158",
        number: "158",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-158/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-158/large",
        },
        flavorText:
          "It has a habit of biting at Clauncher even though it doesn’t feed on them. This is said to be vestigial behavior from when Dreepy was alive.",
      },
      {
        id: "me2pt5-247",
        number: "247",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-247/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-247/large",
        },
        flavorText:
          "It has a habit of biting at Clauncher even though it doesn’t feed on them. This is said to be vestigial behavior from when Dreepy was alive.",
      },
      {
        id: "sv6-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/sv6/128.png",
          large: "https://images.pokemontcg.io/sv6/128_hires.png",
        },
        flavorText:
          "It has a habit of biting at Clauncher even though it doesn't feed on them. This is said to be vestigial behavior from when Dreepy was alive.",
      },
      {
        id: "sv8pt5-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/71.png",
          large: "https://images.pokemontcg.io/sv8pt5/71_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-61",
    name: "Drifblim",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Drifloon",
    attacks: [
      {
        name: "Everyone Explode Now",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "This attack does 50 damage for each of your Drifloon and Drifblim in play. This attack also does 30 damage to each of your Drifloon and Drifblim. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "61",
    nationalPokedexNumbers: [426],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/61.png",
      large: "https://images.pokemontcg.io/sv7/61_hires.png",
    },
    altArts: [
      {
        id: "sv7-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv7/61.png",
          large: "https://images.pokemontcg.io/sv7/61_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/svp/135.png",
          large: "https://images.pokemontcg.io/svp/135_hires.png",
        },
        flavorText:
          "They carry people and Pokémon, but the wind can catch them, so there can't be a fixed destination.",
      },
    ],
  },
  {
    id: "me55-73",
    name: "Drifloon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Float Up",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may shuffle this Pokémon and all attached cards into your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    nationalPokedexNumbers: [425],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-73/small",
      large: "https://images.scrydex.com/pokemon/me55-73/large",
    },
    altArts: [
      {
        id: "me55-73",
        number: "73",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-73/small",
          large: "https://images.scrydex.com/pokemon/me55-73/large",
        },
        flavorText: "",
      },
      {
        id: "me55-136",
        number: "136",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-136/small",
          large: "https://images.scrydex.com/pokemon/me55-136/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-60",
    name: "Drifloon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Drifblim"],
    attacks: [
      {
        name: "Expand",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, this Pokémon takes 10 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "60",
    nationalPokedexNumbers: [425],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/60.png",
      large: "https://images.pokemontcg.io/sv7/60_hires.png",
    },
    altArts: [
      {
        id: "sv7-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv7/60.png",
          large: "https://images.pokemontcg.io/sv7/60_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-45",
    name: "Drilbur",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Excadrill"],
    attacks: [
      {
        name: "Mud-Slap",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Corkscrew Punch",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "45",
    flavorText:
      "It can dig through the ground at a speed of 30 mph. It could give a car running aboveground a good race.",
    nationalPokedexNumbers: [529],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/45.png",
      large: "https://images.pokemontcg.io/zsv10pt5/45_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/45.png",
          large: "https://images.pokemontcg.io/zsv10pt5/45_hires.png",
        },
        flavorText:
          "It can dig through the ground at a speed of 30 mph. It could give a car running aboveground a good race.",
      },
      {
        id: "zsv10pt5-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/124.png",
          large: "https://images.pokemontcg.io/zsv10pt5/124_hires.png",
        },
        flavorText:
          "It can dig through the ground at a speed of 30 mph. It could give a car running aboveground a good race.",
      },
    ],
  },
  {
    id: "me5-46",
    name: "Drilbur",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Dig Claws",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    nationalPokedexNumbers: [529],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-46/small",
      large: "https://images.scrydex.com/pokemon/me5-46/large",
    },
    altArts: [
      {
        id: "me5-46",
        number: "46",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-46/small",
          large: "https://images.scrydex.com/pokemon/me5-46/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-85",
    name: "Drilbur",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Excadrill"],
    abilities: [
      {
        name: "Dig Dig Dig",
        text: "When you play this Pokémon from your hand onto your Bench during your turn, you may search your deck for up to 3 Basic Fighting Energy cards and discard them. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Sand Spray",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "85",
    flavorText:
      "It brings its claws together and whirls around at high speed before rushing toward its prey.",
    nationalPokedexNumbers: [529],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/85.png",
      large: "https://images.pokemontcg.io/sv5/85_hires.png",
    },
    altArts: [
      {
        id: "sv5-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv5/85.png",
          large: "https://images.pokemontcg.io/sv5/85_hires.png",
        },
        flavorText:
          "It brings its claws together and whirls around at high speed before rushing toward its prey.",
      },
    ],
  },
  {
    id: "sv8-108",
    name: "Drilbur",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Excadrill"],
    attacks: [
      {
        name: "Burrow",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard the top card of your opponent's deck.",
      },
      {
        name: "Mud-Slap",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "108",
    nationalPokedexNumbers: [529],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/108.png",
      large: "https://images.pokemontcg.io/sv8/108_hires.png",
    },
    altArts: [
      {
        id: "sv8-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/sv8/108.png",
          large: "https://images.pokemontcg.io/sv8/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-40",
    name: "Drizzile",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Sobble",
    evolvesTo: ["Inteleon"],
    attacks: [
      {
        name: "Double Stab",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "Flip 2 coins. This attack does 30 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    nationalPokedexNumbers: [817],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/40.png",
      large: "https://images.pokemontcg.io/me1/40_hires.png",
    },
    altArts: [
      {
        id: "me1-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/me1/40.png",
          large: "https://images.pokemontcg.io/me1/40_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-16",
    name: "Drowzee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Hypno"],
    attacks: [
      {
        name: "Eerie Gaze",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent reveals their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "16",
    nationalPokedexNumbers: [96],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/16.png",
      large: "https://images.pokemontcg.io/sv6pt5/16_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/16.png",
          large: "https://images.pokemontcg.io/sv6pt5/16_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-71",
    name: "Druddigon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Dragon"],
    attacks: [
      {
        name: "Shred",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
      {
        name: "Ambush",
        cost: ["Fire", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90+",
        text: "Flip a coin. If heads, this attack does 60 more damage.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "71",
    flavorText:
      "It warms its body by absorbing sunlight with its wings. When its body temperature falls, it can no longer move.",
    nationalPokedexNumbers: [621],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/71.png",
      large: "https://images.pokemontcg.io/rsv10pt5/71_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/71.png",
          large: "https://images.pokemontcg.io/rsv10pt5/71_hires.png",
        },
        flavorText:
          "It warms its body by absorbing sunlight with its wings. When its body temperature falls, it can no longer move.",
      },
      {
        id: "rsv10pt5-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/151.png",
          large: "https://images.pokemontcg.io/rsv10pt5/151_hires.png",
        },
        flavorText:
          "It warms its body by absorbing sunlight with its wings. When its body temperature falls, it can no longer move.",
      },
    ],
  },
  {
    id: "sv9-115",
    name: "Druddigon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Dragon"],
    attacks: [
      {
        name: "Dragon's Fury",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Attach a Basic Fire Energy card from your discard pile to 1 of your Dragon Pokémon.",
      },
      {
        name: "Slashing Claw",
        cost: ["Fire", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "115",
    nationalPokedexNumbers: [621],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/115.png",
      large: "https://images.pokemontcg.io/sv9/115_hires.png",
    },
    altArts: [
      {
        id: "sv9-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/sv9/115.png",
          large: "https://images.pokemontcg.io/sv9/115_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-125",
    name: "Dubwool",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Colorless"],
    evolvesFrom: "Wooloo",
    abilities: [
      {
        name: "Soft Wool",
        text: "This Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Knock Over",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "You may discard a Stadium in play.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "125",
    nationalPokedexNumbers: [832],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/125.png",
      large: "https://images.pokemontcg.io/sv7/125_hires.png",
    },
    altArts: [
      {
        id: "sv7-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/sv7/125.png",
          large: "https://images.pokemontcg.io/sv7/125_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-25",
    name: "Ducklett",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Swanna"],
    attacks: [
      {
        name: "Firefighting",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard a Fire Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Wing Attack",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "25",
    flavorText:
      "These bird Pokémon are excellent divers. They swim around in the water eating their favorite food--peat moss.",
    nationalPokedexNumbers: [580],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/25.png",
      large: "https://images.pokemontcg.io/rsv10pt5/25_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/25.png",
          large: "https://images.pokemontcg.io/rsv10pt5/25_hires.png",
        },
        flavorText:
          "These bird Pokémon are excellent divers. They swim around in the water eating their favorite food--peat moss.",
      },
      {
        id: "rsv10pt5-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/109.png",
          large: "https://images.pokemontcg.io/rsv10pt5/109_hires.png",
        },
        flavorText:
          "These bird Pokémon are excellent divers. They swim around in the water eating their favorite food--peat moss.",
      },
    ],
  },
  {
    id: "sv6-139",
    name: "Ducklett",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Swanna"],
    attacks: [
      {
        name: "Double Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Razor Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "139",
    flavorText:
      "It strengthens its body by diving into the depths of ponds, swimming around while looking for bog moss to eat.",
    nationalPokedexNumbers: [580],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/139.png",
      large: "https://images.pokemontcg.io/sv6/139_hires.png",
    },
    altArts: [
      {
        id: "sv6-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/sv6/139.png",
          large: "https://images.pokemontcg.io/sv6/139_hires.png",
        },
        flavorText:
          "It strengthens its body by diving into the depths of ponds, swimming around while looking for bog moss to eat.",
      },
    ],
  },
  {
    id: "sv5-129",
    name: "Dudunsparce",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Colorless"],
    evolvesFrom: "Dunsparce",
    abilities: [
      {
        name: "Run Away Draw",
        text: "Once during your turn, you may draw 3 cards. If you drew any cards in this way, shuffle this Pokémon and all attached cards into your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Land Crush",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "129",
    flavorText:
      "This Pokémon uses its hard tail to make its nest by boring holes into bedrock deep underground. The nest can reach lengths of over six miles.",
    nationalPokedexNumbers: [982],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/129.png",
      large: "https://images.pokemontcg.io/sv5/129_hires.png",
    },
    altArts: [
      {
        id: "sv5-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/sv5/129.png",
          large: "https://images.pokemontcg.io/sv5/129_hires.png",
        },
        flavorText:
          "This Pokémon uses its hard tail to make its nest by boring holes into bedrock deep underground. The nest can reach lengths of over six miles.",
      },
      {
        id: "sv8pt5-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/80.png",
          large: "https://images.pokemontcg.io/sv8pt5/80_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-121",
    name: "Dudunsparce ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Colorless"],
    evolvesFrom: "Dunsparce",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Tenacious Tail",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "60×",
        text: "This attack does 60 damage for each of your opponent's Pokémon ex in play.",
      },
      {
        name: "Destructive Drill",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "121",
    nationalPokedexNumbers: [982],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/121.png",
      large: "https://images.pokemontcg.io/sv9/121_hires.png",
    },
    altArts: [
      {
        id: "sv9-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/sv9/121.png",
          large: "https://images.pokemontcg.io/sv9/121_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-178",
        number: "178",
        images: {
          small: "https://images.pokemontcg.io/sv9/178.png",
          large: "https://images.pokemontcg.io/sv9/178_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-128",
    name: "Dunsparce",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Dig",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "128",
    flavorText:
      "It creates mazes in dark locations. When spotted, it flees into the ground by digging with its tail.",
    nationalPokedexNumbers: [206],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/128.png",
      large: "https://images.pokemontcg.io/sv5/128_hires.png",
    },
    altArts: [
      {
        id: "sv5-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/sv5/128.png",
          large: "https://images.pokemontcg.io/sv5/128_hires.png",
        },
        flavorText:
          "It creates mazes in dark locations. When spotted, it flees into the ground by digging with its tail.",
      },
      {
        id: "sv8pt5-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/79.png",
          large: "https://images.pokemontcg.io/sv8pt5/79_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-120",
    name: "Dunsparce",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Trading Places",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Ram",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "120",
    nationalPokedexNumbers: [206],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/120.png",
      large: "https://images.pokemontcg.io/sv9/120_hires.png",
    },
    altArts: [
      {
        id: "sv9-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/sv9/120.png",
          large: "https://images.pokemontcg.io/sv9/120_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-38",
    name: "Duosion",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Psychic"],
    evolvesFrom: "Solosis",
    evolvesTo: ["Reuniclus"],
    attacks: [
      {
        name: "Cellular Evolution",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a card that evolves from 1 of your Pokémon and put it onto that Pokémon to evolve it. Then, shuffle your deck.",
      },
      {
        name: "Spray Fluid",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "38",
    flavorText:
      "Since they have two divided brains, at times they suddenly try to take two different actions at once.",
    nationalPokedexNumbers: [578],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/38.png",
      large: "https://images.pokemontcg.io/zsv10pt5/38_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/38.png",
          large: "https://images.pokemontcg.io/zsv10pt5/38_hires.png",
        },
        flavorText:
          "Since they have two divided brains, at times they suddenly try to take two different actions at once.",
      },
      {
        id: "zsv10pt5-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/119.png",
          large: "https://images.pokemontcg.io/zsv10pt5/119_hires.png",
        },
        flavorText:
          "Since they have two divided brains, at times they suddenly try to take two different actions at once.",
      },
    ],
  },
  {
    id: "sv5-71",
    name: "Duosion",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Psychic"],
    evolvesFrom: "Solosis",
    evolvesTo: ["Reuniclus"],
    attacks: [
      {
        name: "Double Trick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "Flip 2 coins. This attack does 30 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "71",
    flavorText:
      "Its psychic power can supposedly cover a range of more than half a mile—but only if its two brains can agree with each other.",
    nationalPokedexNumbers: [578],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/71.png",
      large: "https://images.pokemontcg.io/sv5/71_hires.png",
    },
    altArts: [
      {
        id: "sv5-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv5/71.png",
          large: "https://images.pokemontcg.io/sv5/71_hires.png",
        },
        flavorText:
          "Its psychic power can supposedly cover a range of more than half a mile—but only if its two brains can agree with each other.",
      },
    ],
  },
  {
    id: "me2-74",
    name: "Duraludon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Hyper Beam",
        cost: ["Metal", "Metal", "Metal"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "74",
    flavorText:
      "Duraludon's body is comprised of a special metal that's lightweight and scratch resistant. It's also smooth, as though it was given a mirror finish.",
    nationalPokedexNumbers: [884],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/74.png",
      large: "https://images.pokemontcg.io/me2/74_hires.png",
    },
    altArts: [
      {
        id: "me2-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/me2/74.png",
          large: "https://images.pokemontcg.io/me2/74_hires.png",
        },
        flavorText:
          "Duraludon's body is comprised of a special metal that's lightweight and scratch resistant. It's also smooth, as though it was given a mirror finish.",
      },
    ],
  },
  {
    id: "sv7-106",
    name: "Duraludon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Raging Hammer",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "This attack does 10 more damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "106",
    nationalPokedexNumbers: [884],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/106.png",
      large: "https://images.pokemontcg.io/sv7/106_hires.png",
    },
    altArts: [
      {
        id: "sv7-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/sv7/106.png",
          large: "https://images.pokemontcg.io/sv7/106_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/69.png",
          large: "https://images.pokemontcg.io/sv8pt5/69_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-129",
    name: "Duraludon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Confront",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Duralubeam",
        cost: ["Metal", "Metal", "Metal"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "129",
    nationalPokedexNumbers: [884],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/129.png",
      large: "https://images.pokemontcg.io/sv8/129_hires.png",
    },
    altArts: [
      {
        id: "sv8-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/sv8/129.png",
          large: "https://images.pokemontcg.io/sv8/129_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-70",
    name: "Durant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Metal"],
    attacks: [
      {
        name: "Bite Together",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If Durant is on your Bench, this attack does 20 more damage.",
      },
      {
        name: "Vise Grip",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "70",
    flavorText:
      "They attack in groups, covering themselves in steel armor to protect themselves from Heatmor.",
    nationalPokedexNumbers: [632],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/70.png",
      large: "https://images.pokemontcg.io/rsv10pt5/70_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/70.png",
          large: "https://images.pokemontcg.io/rsv10pt5/70_hires.png",
        },
        flavorText:
          "They attack in groups, covering themselves in steel armor to protect themselves from Heatmor.",
      },
      {
        id: "rsv10pt5-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/150.png",
          large: "https://images.pokemontcg.io/rsv10pt5/150_hires.png",
        },
        flavorText:
          "They attack in groups, covering themselves in steel armor to protect themselves from Heatmor.",
      },
    ],
  },
  {
    id: "sv9-14",
    name: "Durant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Grass"],
    attacks: [
      {
        name: "Crunch",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    nationalPokedexNumbers: [632],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/14.png",
      large: "https://images.pokemontcg.io/sv9/14_hires.png",
    },
    altArts: [
      {
        id: "sv9-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv9/14.png",
          large: "https://images.pokemontcg.io/sv9/14_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-4",
    name: "Durant ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Grass"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Sudden Shearing",
        text: "When you play this Pokémon from your hand onto your Bench during your turn, you may discard the top card of your opponent's deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Vengeful Crush",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: "This attack does 30 more damage for each Prize card your opponent has taken.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "4",
    nationalPokedexNumbers: [632],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/4.png",
      large: "https://images.pokemontcg.io/sv8/4_hires.png",
    },
    altArts: [
      {
        id: "sv8-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv8/4.png",
          large: "https://images.pokemontcg.io/sv8/4_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-215",
        number: "215",
        images: {
          small: "https://images.pokemontcg.io/sv8/215.png",
          large: "https://images.pokemontcg.io/sv8/215_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-236",
        number: "236",
        images: {
          small: "https://images.pokemontcg.io/sv8/236.png",
          large: "https://images.pokemontcg.io/sv8/236_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-19",
    name: "Dusclops",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Duskull",
    evolvesTo: ["Dusknoir"],
    abilities: [
      {
        name: "Cursed Blast",
        text: "Once during your turn, you may put 5 damage counters on 1 of your opponent's Pokémon. If you use this Ability, this Pokémon is Knocked Out.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Will-O-Wisp",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    nationalPokedexNumbers: [356],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/19.png",
      large: "https://images.pokemontcg.io/sv6pt5/19_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/19.png",
          large: "https://images.pokemontcg.io/sv6pt5/19_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/69.png",
          large: "https://images.pokemontcg.io/sv6pt5/69_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/36.png",
          large: "https://images.pokemontcg.io/sv8pt5/36_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-20",
    name: "Dusknoir",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Psychic"],
    evolvesFrom: "Dusclops",
    abilities: [
      {
        name: "Cursed Blast",
        text: "Once during your turn, you may put 13 damage counters on 1 of your opponent's Pokémon. If you use this Ability, this Pokémon is Knocked Out.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Shadow Bind",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "20",
    nationalPokedexNumbers: [477],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/20.png",
      large: "https://images.pokemontcg.io/sv6pt5/20_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/20.png",
          large: "https://images.pokemontcg.io/sv6pt5/20_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/70.png",
          large: "https://images.pokemontcg.io/sv6pt5/70_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/37.png",
          large: "https://images.pokemontcg.io/sv8pt5/37_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-18",
    name: "Duskull",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Dusclops"],
    attacks: [
      {
        name: "Come and Get You",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put up to 3 Duskull from your discard pile onto your Bench.",
      },
      {
        name: "Mumble",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    nationalPokedexNumbers: [355],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/18.png",
      large: "https://images.pokemontcg.io/sv6pt5/18_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/18.png",
          large: "https://images.pokemontcg.io/sv6pt5/18_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/68.png",
          large: "https://images.pokemontcg.io/sv6pt5/68_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/35.png",
          large: "https://images.pokemontcg.io/sv8pt5/35_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-15",
    name: "Dustox",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Grass"],
    evolvesFrom: "Cascoon",
    abilities: [
      {
        name: "Boisterous Wind",
        text: "Once during your turn, you may use this Ability. Flip a coin. If heads, put an Energy attached to your opponent's Active Pokémon into their hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Twilight Poison",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "Your opponent's Active Pokémon is now Asleep and Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    flavorText:
      "A nocturnal Pokémon. Drawn by streetlights, they messily eat the leaves of trees lining boulevards.",
    nationalPokedexNumbers: [269],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-15/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-15/large",
    },
    altArts: [
      {
        id: "me2pt5-15",
        number: "15",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-15/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-15/large",
        },
        flavorText:
          "A nocturnal Pokémon. Drawn by streetlights, they messily eat the leaves of trees lining boulevards.",
      },
      {
        id: "me2pt5-220",
        number: "220",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-220/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-220/large",
        },
        flavorText:
          "A nocturnal Pokémon. Drawn by streetlights, they messily eat the leaves of trees lining boulevards.",
      },
    ],
  },
  {
    id: "zsv10pt5-51",
    name: "Dwebble",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Crustle"],
    attacks: [
      {
        name: "Flail",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "This attack does 10 damage for each damage counter on this Pokémon.",
      },
      {
        name: "Dig Claws",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "51",
    flavorText:
      "This Pokémon can easily melt holes in hard rocks with a liquid secreted from its mouth.",
    nationalPokedexNumbers: [557],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/51.png",
      large: "https://images.pokemontcg.io/zsv10pt5/51_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/51.png",
          large: "https://images.pokemontcg.io/zsv10pt5/51_hires.png",
        },
        flavorText:
          "This Pokémon can easily melt holes in hard rocks with a liquid secreted from its mouth.",
      },
      {
        id: "zsv10pt5-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/129.png",
          large: "https://images.pokemontcg.io/zsv10pt5/129_hires.png",
        },
        flavorText:
          "This Pokémon can easily melt holes in hard rocks with a liquid secreted from its mouth.",
      },
    ],
  },
  {
    id: "sv10-11",
    name: "Dwebble",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Crustle"],
    attacks: [
      {
        name: "Ascension",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a card that evolves from this Pokémon and put it onto this Pokémon to evolve it. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "11",
    nationalPokedexNumbers: [557],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/11.png",
      large: "https://images.pokemontcg.io/sv10/11_hires.png",
    },
    altArts: [
      {
        id: "sv10-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv10/11.png",
          large: "https://images.pokemontcg.io/sv10/11_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-31",
    name: "Eelektrik",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Tynamo",
    evolvesTo: ["Eelektross"],
    abilities: [
      {
        name: "Dynamotor",
        text: "Once during your turn, you may attach a Basic Lightning Energy card from your discard pile to 1 of your Benched Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Electric Ball",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "31",
    flavorText:
      "They coil around foes and shock them with electricity-generating organs that seem simply to be circular patterns.",
    nationalPokedexNumbers: [603],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/31.png",
      large: "https://images.pokemontcg.io/zsv10pt5/31_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/31.png",
          large: "https://images.pokemontcg.io/zsv10pt5/31_hires.png",
        },
        flavorText:
          "They coil around foes and shock them with electricity-generating organs that seem simply to be circular patterns.",
      },
      {
        id: "zsv10pt5-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/114.png",
          large: "https://images.pokemontcg.io/zsv10pt5/114_hires.png",
        },
        flavorText:
          "They coil around foes and shock them with electricity-generating organs that seem simply to be circular patterns.",
      },
      {
        id: "me2pt5-60",
        number: "60",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-60/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-60/large",
        },
        flavorText:
          "They coil around foes and shock them with electricity-generating organs that seem simply to be circular patterns.",
      },
    ],
  },
  {
    id: "zsv10pt5-32",
    name: "Eelektross",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Lightning"],
    evolvesFrom: "Eelektrik",
    attacks: [
      {
        name: "Thunder Fang",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Buzz Flip",
        cost: ["Lightning", "Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100×",
        text: "Flip 4 coins. This attack does 100 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "32",
    flavorText:
      "They crawl out of the ocean using their arms. They will attack prey on shore and immediately drag it into the ocean.",
    nationalPokedexNumbers: [604],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/32.png",
      large: "https://images.pokemontcg.io/zsv10pt5/32_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/32.png",
          large: "https://images.pokemontcg.io/zsv10pt5/32_hires.png",
        },
        flavorText:
          "They crawl out of the ocean using their arms. They will attack prey on shore and immediately drag it into the ocean.",
      },
      {
        id: "zsv10pt5-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/115.png",
          large: "https://images.pokemontcg.io/zsv10pt5/115_hires.png",
        },
        flavorText:
          "They crawl out of the ocean using their arms. They will attack prey on shore and immediately drag it into the ocean.",
      },
    ],
  },
  {
    id: "me55-116",
    name: "Eevee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Fetch and Hide",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Your opponent reveals their hand, and you put an Item card you find there on the bottom of your opponent's deck.",
      },
      {
        name: "Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "116",
    nationalPokedexNumbers: [133],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-116/small",
      large: "https://images.scrydex.com/pokemon/me55-116/large",
    },
    altArts: [
      {
        id: "me55-116",
        number: "116",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-116/small",
          large: "https://images.scrydex.com/pokemon/me55-116/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-117",
    name: "Eevee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Quick Attack",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "117",
    nationalPokedexNumbers: [133],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-117/small",
      large: "https://images.scrydex.com/pokemon/me55-117/large",
    },
    altArts: [
      {
        id: "me55-117",
        number: "117",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-117/small",
          large: "https://images.scrydex.com/pokemon/me55-117/large",
        },
        flavorText: "",
      },
      {
        id: "me55-118",
        number: "118",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-118/small",
          large: "https://images.scrydex.com/pokemon/me55-118/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-135",
    name: "Eevee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Colorless"],
    evolvesTo: [
      "Vaporeon",
      "Jolteon",
      "Flareon",
      "Sylveon",
      "Espeon",
      "Umbreon",
      "Leafeon",
      "Glaceon",
    ],
    attacks: [
      {
        name: "Ascension",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a card that evolves from this Pokémon and put it onto this Pokémon to evolve it. Then, shuffle your deck.",
      },
      {
        name: "Quick Attack",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "135",
    flavorText:
      "Its genetic code is irregular. It may mutate if it is exposed to radiation from element stones.",
    nationalPokedexNumbers: [133],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/135.png",
      large: "https://images.pokemontcg.io/sv6/135_hires.png",
    },
    altArts: [
      {
        id: "sv6-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/sv6/135.png",
          large: "https://images.pokemontcg.io/sv6/135_hires.png",
        },
        flavorText:
          "Its genetic code is irregular. It may mutate if it is exposed to radiation from element stones.",
      },
      {
        id: "sv6-188",
        number: "188",
        images: {
          small: "https://images.pokemontcg.io/sv6/188.png",
          large: "https://images.pokemontcg.io/sv6/188_hires.png",
        },
        flavorText:
          "Its genetic code is irregular. It may mutate if it is exposed to radiation from element stones.",
      },
    ],
  },
  {
    id: "sv6pt5-50",
    name: "Eevee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: [
      "Vaporeon",
      "Jolteon",
      "Flareon",
      "Sylveon",
      "Espeon",
      "Umbreon",
      "Leafeon",
      "Glaceon",
    ],
    attacks: [
      {
        name: "Colorful Catch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Basic Energy cards of different types, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Headbutt",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [133],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/50.png",
      large: "https://images.pokemontcg.io/sv6pt5/50_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/50.png",
          large: "https://images.pokemontcg.io/sv6pt5/50_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-113",
    name: "Eevee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: [
      "Vaporeon",
      "Jolteon",
      "Flareon",
      "Sylveon",
      "Espeon",
      "Umbreon",
      "Leafeon",
      "Glaceon",
    ],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Pokémon and put it onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Gnaw",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "113",
    nationalPokedexNumbers: [133],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/113.png",
      large: "https://images.pokemontcg.io/sv7/113_hires.png",
    },
    altArts: [
      {
        id: "sv7-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/sv7/113.png",
          large: "https://images.pokemontcg.io/sv7/113_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-143",
    name: "Eevee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Colorless"],
    evolvesTo: [
      "Vaporeon",
      "Jolteon",
      "Flareon",
      "Sylveon",
      "Espeon",
      "Umbreon",
      "Leafeon",
      "Glaceon",
    ],
    abilities: [
      {
        name: "Boosted Evolution",
        text: "As long as this Pokémon is in the Active Spot, it can evolve during your first turn or the turn you play it.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "143",
    nationalPokedexNumbers: [133],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/143.png",
      large: "https://images.pokemontcg.io/sv8/143_hires.png",
    },
    altArts: [
      {
        id: "sv8-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/sv8/143.png",
          large: "https://images.pokemontcg.io/sv8/143_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/74.png",
          large: "https://images.pokemontcg.io/sv8pt5/74_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-75",
    name: "Eevee ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "200",
    types: ["Colorless"],
    evolvesTo: [
      "Vaporeon",
      "Jolteon",
      "Flareon",
      "Sylveon",
      "Espeon",
      "Umbreon",
      "Leafeon",
      "Glaceon",
    ],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Rainbow DNA",
        text: "This Pokémon can evolve into any Pokémon ex that evolves from Eevee if you play it from your hand onto this Pokémon. (This Pokémon can't evolve during your first turn or the turn you play it.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Coruscating Quartz",
        cost: ["Fire", "Water", "Lightning"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "75",
    nationalPokedexNumbers: [133],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/75.png",
      large: "https://images.pokemontcg.io/sv8pt5/75_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/75.png",
          large: "https://images.pokemontcg.io/sv8pt5/75_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/167.png",
          large: "https://images.pokemontcg.io/sv8pt5/167_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-44",
    name: "Eiscue",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Freezing Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Tackle",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    nationalPokedexNumbers: [875],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/44.png",
      large: "https://images.pokemontcg.io/me1/44_hires.png",
    },
    altArts: [
      {
        id: "me1-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/me1/44.png",
          large: "https://images.pokemontcg.io/me1/44_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-100",
    name: "Ekans",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Arbok"],
    attacks: [
      {
        name: "Poison Blend",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Confused and Poisoned.",
      },
      {
        name: "Bite",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "100",
    flavorText:
      "The older it gets, the longer it grows. At night, it wraps its long body around tree branches to rest.",
    nationalPokedexNumbers: [23],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/100.png",
      large: "https://images.pokemontcg.io/sv5/100_hires.png",
    },
    altArts: [
      {
        id: "sv5-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/sv5/100.png",
          large: "https://images.pokemontcg.io/sv5/100_hires.png",
        },
        flavorText:
          "The older it gets, the longer it grows. At night, it wraps its long body around tree branches to rest.",
      },
    ],
  },
  {
    id: "sv7-11",
    name: "Eldegoss",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Gossifleur",
    attacks: [
      {
        name: "Breezy Gift",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put this Pokémon and all attached cards into your deck. If you do, search your deck for up to 3 cards and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Leafage",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    nationalPokedexNumbers: [830],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/11.png",
      large: "https://images.pokemontcg.io/sv7/11_hires.png",
    },
    altArts: [
      {
        id: "sv7-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv7/11.png",
          large: "https://images.pokemontcg.io/sv7/11_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-68",
    name: "Electabuzz",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Lightning"],
    evolvesTo: ["Electivire"],
    attacks: [
      {
        name: "Electroslug",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "68",
    nationalPokedexNumbers: [125],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/68.png",
      large: "https://images.pokemontcg.io/sv10/68_hires.png",
    },
    altArts: [
      {
        id: "sv10-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv10/68.png",
          large: "https://images.pokemontcg.io/sv10/68_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-53",
    name: "Electabuzz",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Lightning"],
    evolvesTo: ["Electivire"],
    attacks: [
      {
        name: "Chop",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Electric Punch",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "53",
    flavorText:
      "Many power plants keep Ground-type Pokémon around as a defense against Electabuzz that come seeking electricity.",
    nationalPokedexNumbers: [125],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/53.png",
      large: "https://images.pokemontcg.io/sv5/53_hires.png",
    },
    altArts: [
      {
        id: "sv5-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv5/53.png",
          large: "https://images.pokemontcg.io/sv5/53_hires.png",
        },
        flavorText:
          "Many power plants keep Ground-type Pokémon around as a defense against Electabuzz that come seeking electricity.",
      },
    ],
  },
  {
    id: "sv7-46",
    name: "Electabuzz",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Lightning"],
    evolvesTo: ["Electivire"],
    attacks: [
      {
        name: "Collect",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Magnum Punch",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    nationalPokedexNumbers: [125],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/46.png",
      large: "https://images.pokemontcg.io/sv7/46_hires.png",
    },
    altArts: [
      {
        id: "sv7-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv7/46.png",
          large: "https://images.pokemontcg.io/sv7/46_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-54",
    name: "Electivire",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Lightning"],
    evolvesFrom: "Electabuzz",
    attacks: [
      {
        name: "Short-Circuit Knuckle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40+",
        text: "If your opponent has any Water Pokémon in play, this attack does 120 more damage.",
      },
      {
        name: "Electroslug",
        cost: ["Lightning", "Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "54",
    flavorText:
      "The amount of electrical energy this Pokémon produces is proportional to the rate of its pulse. The voltage jumps while Electivire is battling.",
    nationalPokedexNumbers: [466],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/54.png",
      large: "https://images.pokemontcg.io/sv5/54_hires.png",
    },
    altArts: [
      {
        id: "sv5-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv5/54.png",
          large: "https://images.pokemontcg.io/sv5/54_hires.png",
        },
        flavorText:
          "The amount of electrical energy this Pokémon produces is proportional to the rate of its pulse. The voltage jumps while Electivire is battling.",
      },
    ],
  },
  {
    id: "sv7-47",
    name: "Electivire",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Lightning"],
    evolvesFrom: "Electabuzz",
    attacks: [
      {
        name: "Electroslug",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Unleash Lightning",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "220",
        text: "During your next turn, your Pokémon can't attack. (This includes new Pokémon that come into play.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "47",
    nationalPokedexNumbers: [466],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/47.png",
      large: "https://images.pokemontcg.io/sv7/47_hires.png",
    },
    altArts: [
      {
        id: "sv7-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv7/47.png",
          large: "https://images.pokemontcg.io/sv7/47_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-69",
    name: "Electivire ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "280",
    types: ["Lightning"],
    evolvesFrom: "Electabuzz",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Dual Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 50 damage to 2 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "High-Voltage Press",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180+",
        text: "If this Pokémon has at least 2 extra Energy attached (in addition to this attack's cost), this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "69",
    nationalPokedexNumbers: [466],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/69.png",
      large: "https://images.pokemontcg.io/sv10/69_hires.png",
    },
    altArts: [
      {
        id: "sv10-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv10/69.png",
          large: "https://images.pokemontcg.io/sv10/69_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-212",
        number: "212",
        images: {
          small: "https://images.pokemontcg.io/sv10/212.png",
          large: "https://images.pokemontcg.io/sv10/212_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-49",
    name: "Electrike",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Manectric"],
    attacks: [
      {
        name: "Thunder Jolt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    nationalPokedexNumbers: [309],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/49.png",
      large: "https://images.pokemontcg.io/me1/49_hires.png",
    },
    altArts: [
      {
        id: "me1-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/me1/49.png",
          large: "https://images.pokemontcg.io/me1/49_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-23",
    name: "Electrike",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Collect",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Tackle",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "23",
    flavorText:
      "It stores static electricity in its fur for discharging. This Pokémon's whole body gives off sparks if a storm approaches.",
    nationalPokedexNumbers: [309],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-23/small",
      large: "https://images.scrydex.com/pokemon/me5-23/large",
    },
    altArts: [
      {
        id: "me5-23",
        number: "23",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-23/small",
          large: "https://images.scrydex.com/pokemon/me5-23/large",
        },
        flavorText:
          "It stores static electricity in its fur for discharging. This Pokémon's whole body gives off sparks if a storm approaches.",
      },
    ],
  },
  {
    id: "sv10-75",
    name: "Electrike",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Manectric"],
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Tiny Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "75",
    nationalPokedexNumbers: [309],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/75.png",
      large: "https://images.pokemontcg.io/sv10/75_hires.png",
    },
    altArts: [
      {
        id: "sv10-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv10/75.png",
          large: "https://images.pokemontcg.io/sv10/75_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-196",
        number: "196",
        images: {
          small: "https://images.pokemontcg.io/sv10/196.png",
          large: "https://images.pokemontcg.io/sv10/196_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-40",
    name: "Elgyem",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Beheeyem"],
    attacks: [
      {
        name: "Slight Shift",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Move an Energy from 1 of your opponent's Pokémon to another of their Pokémon.",
      },
      {
        name: "Beam",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    flavorText:
      "It uses its strong psychic power to squeeze its opponent's brain, causing unendurable headaches.",
    nationalPokedexNumbers: [605],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/40.png",
      large: "https://images.pokemontcg.io/zsv10pt5/40_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/40.png",
          large: "https://images.pokemontcg.io/zsv10pt5/40_hires.png",
        },
        flavorText:
          "It uses its strong psychic power to squeeze its opponent's brain, causing unendurable headaches.",
      },
      {
        id: "zsv10pt5-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/120.png",
          large: "https://images.pokemontcg.io/zsv10pt5/120_hires.png",
        },
        flavorText:
          "It uses its strong psychic power to squeeze its opponent's brain, causing unendurable headaches.",
      },
    ],
  },
  {
    id: "sv5-73",
    name: "Elgyem",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Beheeyem"],
    attacks: [
      {
        name: "Hide",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    flavorText:
      "If this Pokémon stands near a TV, strange scenery will appear on the screen. That scenery is said to be from its home.",
    nationalPokedexNumbers: [605],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/73.png",
      large: "https://images.pokemontcg.io/sv5/73_hires.png",
    },
    altArts: [
      {
        id: "sv5-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv5/73.png",
          large: "https://images.pokemontcg.io/sv5/73_hires.png",
        },
        flavorText:
          "If this Pokémon stands near a TV, strange scenery will appear on the screen. That scenery is said to be from its home.",
      },
    ],
  },
  {
    id: "rsv10pt5-13",
    name: "Emboar",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fire"],
    evolvesFrom: "Pignite",
    abilities: [
      {
        name: "Inferno Fandango",
        text: "As often as you like during your turn, you may attach a Basic Fire Energy card from your hand to 1 of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Heat Crash",
        cost: ["Fire", "Fire", "Fire", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "13",
    flavorText:
      "It can throw a fire punch by setting its fists on fire with its fiery chin. It cares deeply about its friends.",
    nationalPokedexNumbers: [500],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/13.png",
      large: "https://images.pokemontcg.io/rsv10pt5/13_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/13.png",
          large: "https://images.pokemontcg.io/rsv10pt5/13_hires.png",
        },
        flavorText:
          "It can throw a fire punch by setting its fists on fire with its fiery chin. It cares deeply about its friends.",
      },
      {
        id: "rsv10pt5-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/98.png",
          large: "https://images.pokemontcg.io/rsv10pt5/98_hires.png",
        },
        flavorText:
          "It can throw a fire punch by setting its fists on fire with its fiery chin. It cares deeply about its friends.",
      },
    ],
  },
  {
    id: "zsv10pt5-29",
    name: "Emolga",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Static Shock",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "29",
    flavorText:
      "The energy made in its cheeks' electric pouches is stored inside its membrane and released while it is gliding.",
    nationalPokedexNumbers: [587],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/29.png",
      large: "https://images.pokemontcg.io/zsv10pt5/29_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/29.png",
          large: "https://images.pokemontcg.io/zsv10pt5/29_hires.png",
        },
        flavorText:
          "The energy made in its cheeks' electric pouches is stored inside its membrane and released while it is gliding.",
      },
      {
        id: "zsv10pt5-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/112.png",
          large: "https://images.pokemontcg.io/zsv10pt5/112_hires.png",
        },
        flavorText:
          "The energy made in its cheeks' electric pouches is stored inside its membrane and released while it is gliding.",
      },
    ],
  },
  {
    id: "me4-30",
    name: "Emolga",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Minor Errand-Running",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Sky Return",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Put this Pokémon and all attached cards into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "30",
    flavorText:
      "The energy made in its cheeks' electric pouches is stored inside its patagial membranes and released while it is gliding.",
    nationalPokedexNumbers: [587],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-30/small",
      large: "https://images.scrydex.com/pokemon/me4-30/large",
    },
    altArts: [
      {
        id: "me4-30",
        number: "30",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-30/small",
          large: "https://images.scrydex.com/pokemon/me4-30/large",
        },
        flavorText:
          "The energy made in its cheeks' electric pouches is stored inside its patagial membranes and released while it is gliding.",
      },
    ],
  },
  {
    id: "sv6-69",
    name: "Emolga",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Sky Wave",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "This attack also does 10 damage to each Benched Pokémon (both yours and your opponent's). (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "69",
    flavorText:
      "As Emolga flutters through the air, it crackles with electricity. This Pokémon is cute, but it can cause a lot of trouble.",
    nationalPokedexNumbers: [587],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/69.png",
      large: "https://images.pokemontcg.io/sv6/69_hires.png",
    },
    altArts: [
      {
        id: "sv6-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv6/69.png",
          large: "https://images.pokemontcg.io/sv6/69_hires.png",
        },
        flavorText:
          "As Emolga flutters through the air, it crackles with electricity. This Pokémon is cute, but it can cause a lot of trouble.",
      },
    ],
  },
  {
    id: "me2-70",
    name: "Empoleon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Metal"],
    evolvesFrom: "Prinplup",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Emperor's Stance",
        text: "Prevent all effects of attacks used by your opponent's Pokémon done to this Pokémon. (Damage is not an effect.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Iron Feathers",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "During your opponent's next turn, this Pokémon takes 60 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "70",
    nationalPokedexNumbers: [395],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/70.png",
      large: "https://images.pokemontcg.io/me2/70_hires.png",
    },
    altArts: [
      {
        id: "me2-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/me2/70.png",
          large: "https://images.pokemontcg.io/me2/70_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/me2/114.png",
          large: "https://images.pokemontcg.io/me2/114_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-93",
    name: "Enamorus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Heart Sign",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Love Resonance",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If any of your Pokémon in play are the same type as any of your opponent's Pokémon in play, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "93",
    flavorText:
      "When it flies to this land from across the sea, the bitter winter comes to an end. According to legend, this Pokémon's love gives rise to the budding of fresh life across Hisui.",
    nationalPokedexNumbers: [905],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/93.png",
      large: "https://images.pokemontcg.io/sv6/93_hires.png",
    },
    altArts: [
      {
        id: "sv6-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv6/93.png",
          large: "https://images.pokemontcg.io/sv6/93_hires.png",
        },
        flavorText:
          "When it flies to this land from across the sea, the bitter winter comes to an end. According to legend, this Pokémon's love gives rise to the budding of fresh life across Hisui.",
      },
      {
        id: "sv6-180",
        number: "180",
        images: {
          small: "https://images.pokemontcg.io/sv6/180.png",
          large: "https://images.pokemontcg.io/sv6/180_hires.png",
        },
        flavorText:
          "When it flies to this land from across the sea, the bitter winter comes to an end. According to legend, this Pokémon's love gives rise to the budding of fresh life across Hisui.",
      },
    ],
  },
  {
    id: "me2pt5-25",
    name: "Entei",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Fire"],
    attacks: [
      {
        name: "Flare Fall",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If you have at least 4 Fire Energy in play, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "25",
    flavorText:
      "A Pokémon that races across the land. It is said that one is born every time a new volcano appears.",
    nationalPokedexNumbers: [244],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-25/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-25/large",
    },
    altArts: [
      {
        id: "me2pt5-25",
        number: "25",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-25/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-25/large",
        },
        flavorText:
          "A Pokémon that races across the land. It is said that one is born every time a new volcano appears.",
      },
    ],
  },
  {
    id: "me2pt5-4",
    name: "Erika's Bellsprout",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Vine Slap",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    flavorText:
      "Even though its body is extremely skinny, it is blindingly fast when catching its prey.",
    nationalPokedexNumbers: [69],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-4/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-4/large",
    },
    altArts: [
      {
        id: "me2pt5-4",
        number: "4",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-4/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-4/large",
        },
        flavorText:
          "Even though its body is extremely skinny, it is blindingly fast when catching its prey.",
      },
    ],
  },
  {
    id: "me2pt5-2",
    name: "Erika's Gloom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Erika's Oddish",
    attacks: [
      {
        name: "Poison Spray",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    flavorText:
      "It secretes a sticky, drool-like nectar. Though sweet, it smells too repulsive to get very close.",
    nationalPokedexNumbers: [44],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-2/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-2/large",
    },
    altArts: [
      {
        id: "me2pt5-2",
        number: "2",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-2/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-2/large",
        },
        flavorText:
          "It secretes a sticky, drool-like nectar. Though sweet, it smells too repulsive to get very close.",
      },
    ],
  },
  {
    id: "me2pt5-1",
    name: "Erika's Oddish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    flavorText:
      "When it is woken by moonlight, it wanders about. But during the day, it stays still underground.",
    nationalPokedexNumbers: [43],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-1/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-1/large",
    },
    altArts: [
      {
        id: "me2pt5-1",
        number: "1",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-1/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-1/large",
        },
        flavorText:
          "When it is woken by moonlight, it wanders about. But during the day, it stays still underground.",
      },
    ],
  },
  {
    id: "me2pt5-7",
    name: "Erika's Tangela",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    abilities: [
      {
        name: "Gathering of Blossoms",
        text: "Once during your turn, you may use this Ability. Search your deck for an Erika's Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bind",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "7",
    flavorText:
      "Hidden beneath a tangle of vines that grows nonstop even if the vines are torn off, this Pokémon’s true appearance remains a mystery.",
    nationalPokedexNumbers: [114],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-7/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-7/large",
    },
    altArts: [
      {
        id: "me2pt5-7",
        number: "7",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-7/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-7/large",
        },
        flavorText:
          "Hidden beneath a tangle of vines that grows nonstop even if the vines are torn off, this Pokémon’s true appearance remains a mystery.",
      },
      {
        id: "me2pt5-218",
        number: "218",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-218/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-218/large",
        },
        flavorText:
          "Hidden beneath a tangle of vines that grows nonstop even if the vines are torn off, this Pokémon’s true appearance remains a mystery.",
      },
    ],
  },
  {
    id: "me2pt5-6",
    name: "Erika's Victreebel",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Erika's Weepinbell",
    attacks: [
      {
        name: "Flower Garden Rondo",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "This attack does 40 damage for each of your Erika's Pokémon in play.",
      },
      {
        name: "Solar Beam",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "6",
    nationalPokedexNumbers: [71],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-6/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-6/large",
    },
    altArts: [
      {
        id: "me2pt5-6",
        number: "6",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-6/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-6/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-3",
    name: "Erika's Vileplume ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "310",
    types: ["Grass"],
    evolvesFrom: "Erika's Gloom",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Lovely Fragrance",
        text: "Once during your turn, you may use this Ability. Heal 30 damage from each of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bloom Powder",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Your opponent's Active Pokémon is now Asleep and Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "3",
    nationalPokedexNumbers: [45],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-3/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-3/large",
    },
    altArts: [
      {
        id: "me2pt5-3",
        number: "3",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-3/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-3/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-5",
    name: "Erika's Weepinbell",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Erika's Bellsprout",
    attacks: [
      {
        name: "Melt",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Leafy Cyclone",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    flavorText:
      "It spits out Poison Powder to immobilize the enemy and then finishes it with a spray of Acid.",
    nationalPokedexNumbers: [70],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-5/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-5/large",
    },
    altArts: [
      {
        id: "me2pt5-5",
        number: "5",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-5/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-5/large",
        },
        flavorText:
          "It spits out Poison Powder to immobilize the enemy and then finishes it with a spray of Acid.",
      },
    ],
  },
  {
    id: "zsv10pt5-60",
    name: "Escavalier",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Karrablast",
    attacks: [
      {
        name: "Wild Lances",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "90",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "60",
    flavorText:
      "They fly around at high speed, striking with their pointed spears. Even when in trouble, they face opponents bravely.",
    nationalPokedexNumbers: [589],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/60.png",
      large: "https://images.pokemontcg.io/zsv10pt5/60_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/60.png",
          large: "https://images.pokemontcg.io/zsv10pt5/60_hires.png",
        },
        flavorText:
          "They fly around at high speed, striking with their pointed spears. Even when in trouble, they face opponents bravely.",
      },
      {
        id: "zsv10pt5-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/138.png",
          large: "https://images.pokemontcg.io/zsv10pt5/138_hires.png",
        },
        flavorText:
          "They fly around at high speed, striking with their pointed spears. Even when in trouble, they face opponents bravely.",
      },
    ],
  },
  {
    id: "sv9-102",
    name: "Escavalier",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Metal"],
    evolvesFrom: "Karrablast",
    attacks: [
      {
        name: "Pierce",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Iron Buster",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "102",
    nationalPokedexNumbers: [589],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/102.png",
      large: "https://images.pokemontcg.io/sv9/102_hires.png",
    },
    altArts: [
      {
        id: "sv9-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/sv9/102.png",
          large: "https://images.pokemontcg.io/sv9/102_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-69",
    name: "Espathra",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Flittle",
    attacks: [
      {
        name: "Psychic Flash",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "69",
    nationalPokedexNumbers: [956],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/69.png",
      large: "https://images.pokemontcg.io/sv7/69_hires.png",
    },
    altArts: [
      {
        id: "sv7-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv7/69.png",
          large: "https://images.pokemontcg.io/sv7/69_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-95",
    name: "Espathra",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Flittle",
    attacks: [
      {
        name: "Mystical Eyes",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Devolve 1 of your opponent's evolved Pokémon by putting the highest Stage Evolution card on it into your opponent's hand.",
      },
      {
        name: "Spiral Drain",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "95",
    nationalPokedexNumbers: [956],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/95.png",
      large: "https://images.pokemontcg.io/sv8/95_hires.png",
    },
    altArts: [
      {
        id: "sv8-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv8/95.png",
          large: "https://images.pokemontcg.io/sv8/95_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-69",
    name: "Espeon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Psychic"],
    evolvesFrom: "Eevee",
    attacks: [
      {
        name: "Miraculous Shine",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        text: "Devolve each of your opponent's evolved Pokémon by putting the highest Stage Evolution card on it into your opponent's hand.",
      },
      {
        name: "Super Psy Bolt",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "69",
    nationalPokedexNumbers: [196],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-69/small",
      large: "https://images.scrydex.com/pokemon/me55-69/large",
    },
    altArts: [
      {
        id: "me55-69",
        number: "69",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-69/small",
          large: "https://images.scrydex.com/pokemon/me55-69/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-70",
    name: "Espeon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Psychic"],
    evolvesFrom: "Eevee",
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Solar Beatdown",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each of your Pokémon in play.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "70",
    nationalPokedexNumbers: [196],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-70/small",
      large: "https://images.scrydex.com/pokemon/me55-70/large",
    },
    altArts: [
      {
        id: "me55-70",
        number: "70",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-70/small",
          large: "https://images.scrydex.com/pokemon/me55-70/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-34",
    name: "Espeon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "270",
    types: ["Psychic"],
    evolvesFrom: "Eevee",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Psych Out",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Discard a random card from your opponent's hand.",
      },
      {
        name: "Amazez",
        cost: ["Grass", "Psychic", "Darkness"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Devolve each of your opponent's evolved Pokémon by shuffling the highest Stage Evolution card on it into your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "34",
    nationalPokedexNumbers: [196],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/34.png",
      large: "https://images.pokemontcg.io/sv8pt5/34_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/34.png",
          large: "https://images.pokemontcg.io/sv8pt5/34_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/155.png",
          large: "https://images.pokemontcg.io/sv8pt5/155_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-33",
    name: "Espurr",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Nap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 20 damage from this Pokémon.",
      },
      {
        name: "Stampede",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    nationalPokedexNumbers: [677],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-33/small",
      large: "https://images.scrydex.com/pokemon/me3-33/large",
    },
    altArts: [
      {
        id: "me3-33",
        number: "33",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-33/small",
          large: "https://images.scrydex.com/pokemon/me3-33/large",
        },
        flavorText: "",
      },
      {
        id: "me3-95",
        number: "95",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-95/small",
          large: "https://images.scrydex.com/pokemon/me3-95/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-36",
    name: "Espurr",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Buddy Attack",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If you played Emma from your hand during this turn, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    flavorText:
      "It keeps its intense psychic power from leaking out by using its ears to cover the organs emitting that power.",
    nationalPokedexNumbers: [677],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-36/small",
      large: "https://images.scrydex.com/pokemon/me4-36/large",
    },
    altArts: [
      {
        id: "me4-36",
        number: "36",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-36/small",
          large: "https://images.scrydex.com/pokemon/me4-36/large",
        },
        flavorText:
          "It keeps its intense psychic power from leaking out by using its ears to cover the organs emitting that power.",
      },
    ],
  },
  {
    id: "sv8-84",
    name: "Espurr",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Meowstic"],
    attacks: [
      {
        name: "See Through",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent reveals their hand.",
      },
      {
        name: "Psyshot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "84",
    nationalPokedexNumbers: [677],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/84.png",
      large: "https://images.pokemontcg.io/sv8/84_hires.png",
    },
    altArts: [
      {
        id: "sv8-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv8/84.png",
          large: "https://images.pokemontcg.io/sv8/84_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-69",
    name: "Eternatus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "150",
    types: ["Darkness"],
    attacks: [
      {
        name: "Shatter",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Discard a Stadium in play.",
      },
      {
        name: "Power Rush",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Flip a coin. If tails, during your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "69",
    flavorText:
      "The core on its chest absorbs energy emanating from the lands of the Galar region. This energy is what allows Eternatus to stay active.",
    nationalPokedexNumbers: [890],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/69.png",
      large: "https://images.pokemontcg.io/me2/69_hires.png",
    },
    altArts: [
      {
        id: "me2-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/me2/69.png",
          large: "https://images.pokemontcg.io/me2/69_hires.png",
        },
        flavorText:
          "The core on its chest absorbs energy emanating from the lands of the Galar region. This energy is what allows Eternatus to stay active.",
      },
    ],
  },
  {
    id: "sv8-141",
    name: "Eternatus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "150",
    types: ["Dragon"],
    attacks: [
      {
        name: "Dyna-Blast",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 80 more damage.",
      },
      {
        name: "World Ender",
        cost: ["Fire", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "230",
        text: "Discard a Stadium in play. If you can't, this attack does nothing.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "141",
    nationalPokedexNumbers: [890],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/141.png",
      large: "https://images.pokemontcg.io/sv8/141_hires.png",
    },
    altArts: [
      {
        id: "sv8-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/sv8/141.png",
          large: "https://images.pokemontcg.io/sv8/141_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-32",
    name: "Ethan's Cyndaquil",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Quilava"],
    attacks: [
      {
        name: "Ember",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    nationalPokedexNumbers: [155],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/32.png",
      large: "https://images.pokemontcg.io/sv10/32_hires.png",
    },
    altArts: [
      {
        id: "sv10-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv10/32.png",
          large: "https://images.pokemontcg.io/sv10/32_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-26",
    name: "Ethan's Ho-Oh ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Fire"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Golden Flame",
        text: "Once during your turn, you may attach up to 2 Basic Fire Energy cards from your hand to 1 of your Benched Ethan's Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Shining Feathers",
        cost: ["Fire", "Fire", "Fire", "Fire"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "Heal 50 damage from each of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "26",
    nationalPokedexNumbers: [250],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-26/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-26/large",
    },
    altArts: [
      {
        id: "me2pt5-26",
        number: "26",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-26/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-26/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv10/39.png",
          large: "https://images.pokemontcg.io/sv10/39_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-209",
        number: "209",
        images: {
          small: "https://images.pokemontcg.io/sv10/209.png",
          large: "https://images.pokemontcg.io/sv10/209_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-230",
        number: "230",
        images: {
          small: "https://images.pokemontcg.io/sv10/230.png",
          large: "https://images.pokemontcg.io/sv10/230_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-239",
        number: "239",
        images: {
          small: "https://images.pokemontcg.io/sv10/239.png",
          large: "https://images.pokemontcg.io/sv10/239_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-24",
    name: "Ethan's Magcargo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fire"],
    evolvesFrom: "Ethan's Slugma",
    abilities: [
      {
        name: "Melt Away",
        text: "If this Pokémon has no Energy attached, it has no Retreat Cost.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Lava Burst",
        cost: ["Fire", "Fire", "Fire"],
        convertedEnergyCost: 3,
        damage: "70×",
        text: "Discard up to 5 Fire Energy from this Pokémon. This attack does 70 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "24",
    flavorText:
      "This Pokémon lives near the craters of volcanoes. It stores fire energy in its shell of cooled and hardened magma.",
    nationalPokedexNumbers: [219],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-24/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-24/large",
    },
    altArts: [
      {
        id: "me2pt5-24",
        number: "24",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-24/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-24/large",
        },
        flavorText:
          "This Pokémon lives near the craters of volcanoes. It stores fire energy in its shell of cooled and hardened magma.",
      },
      {
        id: "me2pt5-222",
        number: "222",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-222/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-222/large",
        },
        flavorText:
          "This Pokémon lives near the craters of volcanoes. It stores fire energy in its shell of cooled and hardened magma.",
      },
      {
        id: "sv10-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv10/36.png",
          large: "https://images.pokemontcg.io/sv10/36_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-71",
    name: "Ethan's Pichu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Lightning"],
    evolvesTo: ["Pikachu"],
    attacks: [
      {
        name: "Zapping Draw",
        cost: [],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Draw a card.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "71",
    nationalPokedexNumbers: [172],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/71.png",
      large: "https://images.pokemontcg.io/sv10/71_hires.png",
    },
    altArts: [
      {
        id: "sv10-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv10/71.png",
          large: "https://images.pokemontcg.io/sv10/71_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-1",
    name: "Ethan's Pinsir",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Vise Grip",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Rallying Horn",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70+",
        text: "If any of your Ethan's Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "1",
    nationalPokedexNumbers: [127],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/1.png",
      large: "https://images.pokemontcg.io/sv10/1_hires.png",
    },
    altArts: [
      {
        id: "sv10-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/sv10/1.png",
          large: "https://images.pokemontcg.io/sv10/1_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-33",
    name: "Ethan's Quilava",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fire"],
    evolvesFrom: "Ethan's Cyndaquil",
    evolvesTo: ["Typhlosion"],
    abilities: [
      {
        name: "Bonded by the Journey",
        text: "Once during your turn, you may search your deck for an Ethan's Adventure card, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Combustion",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    nationalPokedexNumbers: [156],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/33.png",
      large: "https://images.pokemontcg.io/sv10/33_hires.png",
    },
    altArts: [
      {
        id: "sv10-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/sv10/33.png",
          large: "https://images.pokemontcg.io/sv10/33_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-23",
    name: "Ethan's Slugma",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Steady Firebreathing",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    flavorText:
      "Its lava body can cool and chip away at times, but a magma bath will heal it right up.",
    nationalPokedexNumbers: [218],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-23/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-23/large",
    },
    altArts: [
      {
        id: "me2pt5-23",
        number: "23",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-23/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-23/large",
        },
        flavorText:
          "Its lava body can cool and chip away at times, but a magma bath will heal it right up.",
      },
      {
        id: "sv10-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv10/35.png",
          large: "https://images.pokemontcg.io/sv10/35_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-93",
    name: "Ethan's Sudowoodo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Impound",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Try to Imitate",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Flip a coin. If heads, choose 1 of your opponent's Active Pokémon's attacks and use it as this attack.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "93",
    nationalPokedexNumbers: [185],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/93.png",
      large: "https://images.pokemontcg.io/sv10/93_hires.png",
    },
    altArts: [
      {
        id: "sv10-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv10/93.png",
          large: "https://images.pokemontcg.io/sv10/93_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-34",
    name: "Ethan's Typhlosion",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Fire"],
    evolvesFrom: "Ethan's Quilava",
    attacks: [
      {
        name: "Buddy Blast",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "40+",
        text: "This attack does 60 more damage for each Ethan's Adventure card in your discard pile.",
      },
      {
        name: "Steam Artillery",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    nationalPokedexNumbers: [157],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/34.png",
      large: "https://images.pokemontcg.io/sv10/34_hires.png",
    },
    altArts: [
      {
        id: "sv10-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv10/34.png",
          large: "https://images.pokemontcg.io/sv10/34_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-190",
        number: "190",
        images: {
          small: "https://images.pokemontcg.io/sv10/190.png",
          large: "https://images.pokemontcg.io/sv10/190_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-86",
    name: "Excadrill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Drilbur",
    attacks: [
      {
        name: "Mud Shot",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Wild Tackle",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "This Pokémon also does 50 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "86",
    flavorText:
      "It's not uncommon for tunnels that appear to have formed naturally to actually be a result of Excadrill's rampant digging.",
    nationalPokedexNumbers: [530],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/86.png",
      large: "https://images.pokemontcg.io/sv5/86_hires.png",
    },
    altArts: [
      {
        id: "sv5-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv5/86.png",
          large: "https://images.pokemontcg.io/sv5/86_hires.png",
        },
        flavorText:
          "It's not uncommon for tunnels that appear to have formed naturally to actually be a result of Excadrill's rampant digging.",
      },
      {
        id: "sv5-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/sv5/174.png",
          large: "https://images.pokemontcg.io/sv5/174_hires.png",
        },
        flavorText:
          "It's not uncommon for tunnels that appear to have formed naturally to actually be a result of Excadrill's rampant digging.",
      },
    ],
  },
  {
    id: "sv8-109",
    name: "Excadrill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Drilbur",
    attacks: [
      {
        name: "Digging Claw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Discard the top card of your opponent's deck.",
      },
      {
        name: "Drill Smash",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "If you have any Metal Pokémon on your Bench, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "109",
    nationalPokedexNumbers: [530],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/109.png",
      large: "https://images.pokemontcg.io/sv8/109_hires.png",
    },
    altArts: [
      {
        id: "sv8-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/sv8/109.png",
          large: "https://images.pokemontcg.io/sv8/109_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-46",
    name: "Excadrill ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Fighting"],
    evolvesFrom: "Drilbur",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Piercing Drill",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "This attack also does 60 damage to 1 of your opponent's Benched Pokémon that has any damage counters on it. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Rock Tumble",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "46",
    nationalPokedexNumbers: [530],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/46.png",
      large: "https://images.pokemontcg.io/zsv10pt5/46_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/46.png",
          large: "https://images.pokemontcg.io/zsv10pt5/46_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/160.png",
          large: "https://images.pokemontcg.io/zsv10pt5/160_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/168.png",
          large: "https://images.pokemontcg.io/zsv10pt5/168_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-4",
    name: "Exeggcute",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Exeggutor"],
    attacks: [
      {
        name: "Jam-Packed",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Grass Energy card and attach it to this Pokémon. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    nationalPokedexNumbers: [102],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/4.png",
      large: "https://images.pokemontcg.io/me1/4_hires.png",
    },
    altArts: [
      {
        id: "me1-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/me1/4.png",
          large: "https://images.pokemontcg.io/me1/4_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-1",
    name: "Exeggcute",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Hypnosis",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    nationalPokedexNumbers: [102],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-1/small",
      large: "https://images.scrydex.com/pokemon/me55-1/large",
    },
    altArts: [
      {
        id: "me55-1",
        number: "1",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-1/small",
          large: "https://images.scrydex.com/pokemon/me55-1/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-1",
    name: "Exeggcute",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Grass"],
    evolvesTo: ["Exeggutor"],
    attacks: [
      {
        name: "Precocious Evolution",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "If you go first, you can use this attack during your first turn. Search your deck for a card that evolves from this Pokémon and put it onto this Pokémon to evolve it. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    nationalPokedexNumbers: [102],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/1.png",
      large: "https://images.pokemontcg.io/sv8/1_hires.png",
    },
    altArts: [
      {
        id: "sv8-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/sv8/1.png",
          large: "https://images.pokemontcg.io/sv8/1_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-192",
        number: "192",
        images: {
          small: "https://images.pokemontcg.io/sv8/192.png",
          large: "https://images.pokemontcg.io/sv8/192_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-2",
    name: "Exeggcute",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Exeggutor"],
    attacks: [
      {
        name: "Absorb",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Heal 10 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    nationalPokedexNumbers: [102],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/2.png",
      large: "https://images.pokemontcg.io/sv8/2_hires.png",
    },
    altArts: [
      {
        id: "sv8-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv8/2.png",
          large: "https://images.pokemontcg.io/sv8/2_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-1",
    name: "Exeggcute",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Exeggutor"],
    attacks: [
      {
        name: "Ram",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    nationalPokedexNumbers: [102],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/1.png",
      large: "https://images.pokemontcg.io/sv8pt5/1_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/1.png",
          large: "https://images.pokemontcg.io/sv8pt5/1_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-5",
    name: "Exeggutor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Grass"],
    evolvesFrom: "Exeggcute",
    attacks: [
      {
        name: "Guard Press",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Stomping Wood",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60+",
        text: "This attack does 30 more damage for each Grass Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    nationalPokedexNumbers: [103],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/5.png",
      large: "https://images.pokemontcg.io/me1/5_hires.png",
    },
    altArts: [
      {
        id: "me1-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/me1/5.png",
          large: "https://images.pokemontcg.io/me1/5_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/me1/135.png",
          large: "https://images.pokemontcg.io/me1/135_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-3",
    name: "Exeggutor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Exeggcute",
    attacks: [
      {
        name: "Barrage O'Clock",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "60×",
        text: "Flip a coin for each Energy attached to both Active Pokémon. This attack does 60 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "3",
    nationalPokedexNumbers: [103],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/3.png",
      large: "https://images.pokemontcg.io/sv8/3_hires.png",
    },
    altArts: [
      {
        id: "sv8-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv8/3.png",
          large: "https://images.pokemontcg.io/sv8/3_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-2",
    name: "Exeggutor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Grass"],
    evolvesFrom: "Exeggcute",
    attacks: [
      {
        name: "Mega Drain",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Heal 30 damage from this Pokémon.",
      },
      {
        name: "Solar Beam",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "2",
    nationalPokedexNumbers: [103],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/2.png",
      large: "https://images.pokemontcg.io/sv8pt5/2_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/2.png",
          large: "https://images.pokemontcg.io/sv8pt5/2_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-88",
    name: "Falinks",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Form Ranks",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "All-Out Attack",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If this Pokémon used Form Ranks during your last turn, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "88",
    nationalPokedexNumbers: [870],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/88.png",
      large: "https://images.pokemontcg.io/sv7/88_hires.png",
    },
    altArts: [
      {
        id: "sv7-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv7/88.png",
          large: "https://images.pokemontcg.io/sv7/88_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-171",
    name: "Fan Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    abilities: [
      {
        name: "Fan Call",
        text: "Once during your first turn, you may search your deck for up to 3 Colorless Pokémon with 100 HP or less, reveal them, and put them into your hand. Then, shuffle your deck. You can't use more than 1 Fan Call Ability during your turn.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Assault Landing",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "70",
        text: "If there is no Stadium in play, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "171",
    flavorText:
      "There are several appliances that Rotom can inspirit, but the first one to be developed was the electric fan.",
    nationalPokedexNumbers: [479],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-171/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-171/large",
    },
    altArts: [
      {
        id: "me2pt5-171",
        number: "171",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-171/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-171/large",
        },
        flavorText:
          "There are several appliances that Rotom can inspirit, but the first one to be developed was the electric fan.",
      },
      {
        id: "me2pt5-250",
        number: "250",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-250/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-250/large",
        },
        flavorText:
          "There are several appliances that Rotom can inspirit, but the first one to be developed was the electric fan.",
      },
      {
        id: "sv7-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/sv7/118.png",
          large: "https://images.pokemontcg.io/sv7/118_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/85.png",
          large: "https://images.pokemontcg.io/sv8pt5/85_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-132",
    name: "Farfetch'd",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Sirfetch'd"],
    abilities: [
      {
        name: "Impromptu Carrier",
        text: "When you play this Pokémon from your hand onto your Bench during your turn, you may search your deck for a Pokémon Tool card and attach it to this Pokémon. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mach Cut",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Discard a Special Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "132",
    flavorText:
      "The stalk this Pokémon carries in its wings serves as a sword to cut down opponents. In a dire situation, the stalk can also serve as food.",
    nationalPokedexNumbers: [83],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/132.png",
      large: "https://images.pokemontcg.io/sv6/132_hires.png",
    },
    altArts: [
      {
        id: "sv6-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/sv6/132.png",
          large: "https://images.pokemontcg.io/sv6/132_hires.png",
        },
        flavorText:
          "The stalk this Pokémon carries in its wings serves as a sword to cut down opponents. In a dire situation, the stalk can also serve as food.",
      },
    ],
  },
  {
    id: "sv6-84",
    name: "Farigiraf",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Girafarig",
    attacks: [
      {
        name: "One-derful Rumble",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "This attack does 40 damage for each of your Stage 1 Pokémon in play.",
      },
      {
        name: "Eerie Wave",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "84",
    flavorText:
      "The hardened head from the tail protects the head of the main body as Farigiraf whips its long neck around to headbutt enemies.",
    nationalPokedexNumbers: [981],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/84.png",
      large: "https://images.pokemontcg.io/sv6/84_hires.png",
    },
    altArts: [
      {
        id: "sv6-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv6/84.png",
          large: "https://images.pokemontcg.io/sv6/84_hires.png",
        },
        flavorText:
          "The hardened head from the tail protects the head of the main body as Farigiraf whips its long neck around to headbutt enemies.",
      },
    ],
  },
  {
    id: "sv5-108",
    name: "Farigiraf ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "260",
    types: ["Darkness"],
    evolvesFrom: "Girafarig",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    abilities: [
      {
        name: "Armor Tail",
        text: "Prevent all damage done to this Pokémon by attacks from your opponent's Basic Pokémon ex.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dirty Beam",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "108",
    nationalPokedexNumbers: [981],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/108.png",
      large: "https://images.pokemontcg.io/sv5/108_hires.png",
    },
    altArts: [
      {
        id: "sv5-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/sv5/108.png",
          large: "https://images.pokemontcg.io/sv5/108_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-194",
        number: "194",
        images: {
          small: "https://images.pokemontcg.io/sv5/194.png",
          large: "https://images.pokemontcg.io/sv5/194_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-103",
    name: "Fearow",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Spearow",
    attacks: [
      {
        name: "Repeating Drill",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "Flip 5 coins. This attack does 30 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "103",
    nationalPokedexNumbers: [22],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/103.png",
      large: "https://images.pokemontcg.io/me1/103_hires.png",
    },
    altArts: [
      {
        id: "me1-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/me1/103.png",
          large: "https://images.pokemontcg.io/me1/103_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-49",
    name: "Feebas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Water"],
    evolvesTo: ["Milotic"],
    attacks: [
      {
        name: "Flail",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "This attack does 10 damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    flavorText:
      "It is the shabbiest Pokémon of all. It forms schools and lives at the bottom of rivers that teem with plant life.",
    nationalPokedexNumbers: [349],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/49.png",
      large: "https://images.pokemontcg.io/sv6/49_hires.png",
    },
    altArts: [
      {
        id: "sv6-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/sv6/49.png",
          large: "https://images.pokemontcg.io/sv6/49_hires.png",
        },
        flavorText:
          "It is the shabbiest Pokémon of all. It forms schools and lives at the bottom of rivers that teem with plant life.",
      },
    ],
  },
  {
    id: "sv8-41",
    name: "Feebas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Water"],
    evolvesTo: ["Milotic"],
    attacks: [
      {
        name: "Leap Out",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    nationalPokedexNumbers: [349],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/41.png",
      large: "https://images.pokemontcg.io/sv8/41_hires.png",
    },
    altArts: [
      {
        id: "sv8-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv8/41.png",
          large: "https://images.pokemontcg.io/sv8/41_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-198",
        number: "198",
        images: {
          small: "https://images.pokemontcg.io/sv8/198.png",
          large: "https://images.pokemontcg.io/sv8/198_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-11",
    name: "Fennekin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Steady Firebreathing",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    flavorText:
      "Eating a twig fills it with energy, and its roomy ears give vent to air hotter than 390 degrees Fahrenheit.",
    nationalPokedexNumbers: [653],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-11/small",
      large: "https://images.scrydex.com/pokemon/me4-11/large",
    },
    altArts: [
      {
        id: "me4-11",
        number: "11",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-11/small",
          large: "https://images.scrydex.com/pokemon/me4-11/large",
        },
        flavorText:
          "Eating a twig fills it with energy, and its roomy ears give vent to air hotter than 390 degrees Fahrenheit.",
      },
    ],
  },
  {
    id: "sv5-41",
    name: "Feraligatr",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Water"],
    evolvesFrom: "Croconaw",
    abilities: [
      {
        name: "Torrential Heart",
        text: "Once during your turn, you may put 5 damage counters on this Pokémon. If you do, during this turn, attacks used by this Pokémon do 120 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Giant Wave",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "During your next turn, this Pokémon can't use Giant Wave.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "41",
    flavorText:
      "It usually moves slowly, but it goes at blinding speed when it attacks and bites prey.",
    nationalPokedexNumbers: [160],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/41.png",
      large: "https://images.pokemontcg.io/sv5/41_hires.png",
    },
    altArts: [
      {
        id: "sv5-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv5/41.png",
          large: "https://images.pokemontcg.io/sv5/41_hires.png",
        },
        flavorText:
          "It usually moves slowly, but it goes at blinding speed when it attacks and bites prey.",
      },
    ],
  },
  {
    id: "svp-89",
    name: "Feraligatr",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Water"],
    evolvesFrom: "Croconaw",
    abilities: [
      {
        name: "Torrential Heart",
        text: "Once during your turn, you may put 5 damage counters on this Pokémon. If you do, during this turn, attacks used by this Pokémon do 120 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        cost: ["Water", "Water"],
        name: "Giant Wave",
        damage: "160",
        text: "During your next turn, this Pokémon can't use Giant Wave.",
        convertedEnergyCost: 2,
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "89",
    flavorText:
      "It usually moves slowly, but it goes at blinding speed when it attacks and bites prey.",
    nationalPokedexNumbers: [160],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/89.png",
      large: "https://images.pokemontcg.io/svp/89_hires.png",
    },
    altArts: [
      {
        id: "svp-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/svp/89.png",
          large: "https://images.pokemontcg.io/svp/89_hires.png",
        },
        flavorText:
          "It usually moves slowly, but it goes at blinding speed when it attacks and bites prey.",
      },
    ],
  },
  {
    id: "rsv10pt5-68",
    name: "Ferroseed",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    evolvesTo: ["Ferrothorn"],
    attacks: [
      {
        name: "Zzzt",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Metal Claw",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "68",
    flavorText:
      "When threatened, it attacks by shooting a barrage of spikes, which gives it a chance to escape by rolling away.",
    nationalPokedexNumbers: [597],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/68.png",
      large: "https://images.pokemontcg.io/rsv10pt5/68_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/68.png",
          large: "https://images.pokemontcg.io/rsv10pt5/68_hires.png",
        },
        flavorText:
          "When threatened, it attacks by shooting a barrage of spikes, which gives it a chance to escape by rolling away.",
      },
      {
        id: "rsv10pt5-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/148.png",
          large: "https://images.pokemontcg.io/rsv10pt5/148_hires.png",
        },
        flavorText:
          "When threatened, it attacks by shooting a barrage of spikes, which gives it a chance to escape by rolling away.",
      },
    ],
  },
  {
    id: "me4-62",
    name: "Ferroseed",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "62",
    flavorText:
      "It defends itself by launching spikes, but its aim isn't very good at first. Only after a lot of practice will it improve.",
    nationalPokedexNumbers: [597],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-62/small",
      large: "https://images.scrydex.com/pokemon/me4-62/large",
    },
    altArts: [
      {
        id: "me4-62",
        number: "62",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-62/small",
          large: "https://images.scrydex.com/pokemon/me4-62/large",
        },
        flavorText:
          "It defends itself by launching spikes, but its aim isn't very good at first. Only after a lot of practice will it improve.",
      },
    ],
  },
  {
    id: "rsv10pt5-69",
    name: "Ferrothorn",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Metal"],
    evolvesFrom: "Ferroseed",
    attacks: [
      {
        name: "Power Whip",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 20 damage to 1 of your opponent's Pokémon for each Energy attached to this Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Metal Claw",
        cost: ["Metal", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "69",
    flavorText:
      "It fights by swinging around its three spiky feelers. A hit from these steel spikes can reduce a boulder to rubble.",
    nationalPokedexNumbers: [598],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/69.png",
      large: "https://images.pokemontcg.io/rsv10pt5/69_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/69.png",
          large: "https://images.pokemontcg.io/rsv10pt5/69_hires.png",
        },
        flavorText:
          "It fights by swinging around its three spiky feelers. A hit from these steel spikes can reduce a boulder to rubble.",
      },
      {
        id: "rsv10pt5-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/149.png",
          large: "https://images.pokemontcg.io/rsv10pt5/149_hires.png",
        },
        flavorText:
          "It fights by swinging around its three spiky feelers. A hit from these steel spikes can reduce a boulder to rubble.",
      },
    ],
  },
  {
    id: "me4-63",
    name: "Ferrothorn",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Ferroseed",
    abilities: [
      {
        name: "Startling Drop",
        text: "During your opponent's turn, if this Pokémon is discarded from your deck by an effect of an attack or Ability from your opponent's Pokémon, or by an effect of your opponent's Item or Supporter cards, discard the top 8 cards of your opponent's deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Special Whip",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "70+",
        text: "If this Pokémon has any Special Energy attached, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "63",
    flavorText:
      "This Pokémon scrapes its spikes across rocks, and then uses the tips of its feelers to absorb the nutrients it finds within the stone.",
    nationalPokedexNumbers: [598],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-63/small",
      large: "https://images.scrydex.com/pokemon/me4-63/large",
    },
    altArts: [
      {
        id: "me4-63",
        number: "63",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-63/small",
          large: "https://images.scrydex.com/pokemon/me4-63/large",
        },
        flavorText:
          "This Pokémon scrapes its spikes across rocks, and then uses the tips of its feelers to absorb the nutrients it finds within the stone.",
      },
    ],
  },
  {
    id: "me55-104",
    name: "Ferrothorn",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Ferroseed",
    attacks: [
      {
        name: "Spike Sting",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
      },
      {
        name: "Kaboom Needles",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        text: "This attack does 50 damage to each of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.) This Pokémon also does 130 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "104",
    nationalPokedexNumbers: [598],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-104/small",
      large: "https://images.scrydex.com/pokemon/me55-104/large",
    },
    altArts: [
      {
        id: "me55-104",
        number: "104",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-104/small",
          large: "https://images.scrydex.com/pokemon/me55-104/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-96",
    name: "Fezandipiti",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    abilities: [
      {
        name: "Adrena-Pheromone",
        text: "If this Pokémon has any Darkness Energy attached and is damaged by an attack, flip a coin. If heads, prevent that damage.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Energy Feather",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "96",
    nationalPokedexNumbers: [1016],
    flavorText:
      "Fezandipiti beats its glossy wings to scatter pheromones that captivate people and Pokémon.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/96.png",
      large: "https://images.pokemontcg.io/sv6/96_hires.png",
    },
    altArts: [
      {
        id: "sv6-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/sv6/96.png",
          large: "https://images.pokemontcg.io/sv6/96_hires.png",
        },
        flavorText:
          "Fezandipiti beats its glossy wings to scatter pheromones that captivate people and Pokémon.",
      },
      {
        id: "sv6pt5-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/73.png",
          large: "https://images.pokemontcg.io/sv6pt5/73_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/45.png",
          large: "https://images.pokemontcg.io/sv8pt5/45_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-142",
    name: "Fezandipiti ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Darkness"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Flip the Script",
        text: "Once during your turn, if any of your Pokémon were Knocked Out during your opponent's last turn, you may draw 3 cards. You can't use more than 1 Flip the Script Ability each turn.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Cruel Arrow",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 100 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "142",
    nationalPokedexNumbers: [1016],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-142/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-142/large",
    },
    altArts: [
      {
        id: "me2pt5-142",
        number: "142",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-142/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-142/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-288",
        number: "288",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-288/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-288/large",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/38.png",
          large: "https://images.pokemontcg.io/sv6pt5/38_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/84.png",
          large: "https://images.pokemontcg.io/sv6pt5/84_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/92.png",
          large: "https://images.pokemontcg.io/sv6pt5/92_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-66",
    name: "Fidough",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Pleasant Aroma",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Pokémon and put it onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Stampede",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "66",
    nationalPokedexNumbers: [926],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/66.png",
      large: "https://images.pokemontcg.io/sv7/66_hires.png",
    },
    altArts: [
      {
        id: "sv7-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv7/66.png",
          large: "https://images.pokemontcg.io/sv7/66_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-21",
    name: "Finizen",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    attacks: [
      {
        name: "Draining Fin",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Heal 20 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "21",
    flavorText:
      "Its water ring is made from seawater mixed with a sticky fluid that Finizen secretes from its blowhole.",
    nationalPokedexNumbers: [963],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-21/small",
      large: "https://images.scrydex.com/pokemon/me5-21/large",
    },
    altArts: [
      {
        id: "me5-21",
        number: "21",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-21/small",
          large: "https://images.scrydex.com/pokemon/me5-21/large",
        },
        flavorText:
          "Its water ring is made from seawater mixed with a sticky fluid that Finizen secretes from its blowhole.",
      },
    ],
  },
  {
    id: "sv5-48",
    name: "Finizen",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    attacks: [
      {
        name: "Rain Splash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Sharp Fin",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "48",
    flavorText:
      "It likes playing with others of its kind using the water ring on its tail. It uses ultrasonic waves to sense the emotions of other living creatures.",
    nationalPokedexNumbers: [963],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/48.png",
      large: "https://images.pokemontcg.io/sv5/48_hires.png",
    },
    altArts: [
      {
        id: "sv5-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv5/48.png",
          large: "https://images.pokemontcg.io/sv5/48_hires.png",
        },
        flavorText:
          "It likes playing with others of its kind using the water ring on its tail. It uses ultrasonic waves to sense the emotions of other living creatures.",
      },
    ],
  },
  {
    id: "sv6-59",
    name: "Finizen",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Aqua Slash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    flavorText:
      "Its water ring is made from seawater mixed with a sticky fluid that Finizen secretes from its blowhole.",
    nationalPokedexNumbers: [963],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/59.png",
      large: "https://images.pokemontcg.io/sv6/59_hires.png",
    },
    altArts: [
      {
        id: "sv6-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/sv6/59.png",
          large: "https://images.pokemontcg.io/sv6/59_hires.png",
        },
        flavorText:
          "Its water ring is made from seawater mixed with a sticky fluid that Finizen secretes from its blowhole.",
      },
    ],
  },
  {
    id: "sv7-35",
    name: "Finneon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Water"],
    evolvesTo: ["Lumineon"],
    attacks: [
      {
        name: "Sprinkle Water",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    nationalPokedexNumbers: [456],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/35.png",
      large: "https://images.pokemontcg.io/sv7/35_hires.png",
    },
    altArts: [
      {
        id: "sv7-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv7/35.png",
          large: "https://images.pokemontcg.io/sv7/35_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-28",
    name: "Flaaffy",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Mareep",
    attacks: [
      {
        name: "Disconnect",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "During your opponent's next turn, they can't play any Item cards from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "28",
    flavorText:
      "If its coat becomes fully charged with electricity, its tail lights up. Flaaffy can fire wool that zaps on impact.",
    nationalPokedexNumbers: [180],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-28/small",
      large: "https://images.scrydex.com/pokemon/me4-28/large",
    },
    altArts: [
      {
        id: "me4-28",
        number: "28",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-28/small",
          large: "https://images.scrydex.com/pokemon/me4-28/large",
        },
        flavorText:
          "If its coat becomes fully charged with electricity, its tail lights up. Flaaffy can fire wool that zaps on impact.",
      },
    ],
  },
  {
    id: "svp-108",
    name: "Flaaffy",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Mareep",
    evolvesTo: ["Ampharos"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Electro Ball",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "108",
    nationalPokedexNumbers: [180],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/108.png",
      large: "https://images.pokemontcg.io/svp/108_hires.png",
    },
    altArts: [
      {
        id: "svp-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/svp/108.png",
          large: "https://images.pokemontcg.io/svp/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-86",
    name: "Flabébé",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Psychic"],
    evolvesTo: ["Floette"],
    attacks: [
      {
        name: "Bind Wound",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 30 damage from 1 of your Pokémon.",
      },
      {
        name: "Fairy Wind",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "86",
    flavorText:
      "This Flabébé rides a red flower. Immediately after birth, this Pokémon begins flying around in search of a flower it likes.",
    nationalPokedexNumbers: [669],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/86.png",
      large: "https://images.pokemontcg.io/sv6/86_hires.png",
    },
    altArts: [
      {
        id: "sv6-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv6/86.png",
          large: "https://images.pokemontcg.io/sv6/86_hires.png",
        },
        flavorText:
          "This Flabébé rides a red flower. Immediately after birth, this Pokémon begins flying around in search of a flower it likes.",
      },
    ],
  },
  {
    id: "sv8-160",
    name: "Flamigo ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "200",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Precise Beak",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If this Pokémon and your opponent's Active Pokémon have the same amount of Energy attached, this attack does 100 more damage.",
      },
      {
        name: "Brave Bird",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "200",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "160",
    nationalPokedexNumbers: [973],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/160.png",
      large: "https://images.pokemontcg.io/sv8/160_hires.png",
    },
    altArts: [
      {
        id: "sv8-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/sv8/160.png",
          large: "https://images.pokemontcg.io/sv8/160_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-139",
    name: "Flapple",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Dragon"],
    evolvesFrom: "Applin",
    attacks: [
      {
        name: "Acidic Spit",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each damage counter on your opponent's Active Pokémon.",
      },
      {
        name: "Speed Dive",
        cost: ["Grass", "Fire"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "139",
    nationalPokedexNumbers: [841],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/139.png",
      large: "https://images.pokemontcg.io/sv8/139_hires.png",
    },
    altArts: [
      {
        id: "sv8-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/sv8/139.png",
          large: "https://images.pokemontcg.io/sv8/139_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-210",
        number: "210",
        images: {
          small: "https://images.pokemontcg.io/sv8/210.png",
          large: "https://images.pokemontcg.io/sv8/210_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-14",
    name: "Flareon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "270",
    types: ["Fire"],
    evolvesFrom: "Eevee",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Burning Charge",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "Search your deck for up to 2 Basic Energy cards and attach them to 1 of your Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Carnelian",
        cost: ["Fire", "Water", "Lightning"],
        convertedEnergyCost: 3,
        damage: "280",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "14",
    nationalPokedexNumbers: [136],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/14.png",
      large: "https://images.pokemontcg.io/sv8pt5/14_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/14.png",
          large: "https://images.pokemontcg.io/sv8pt5/14_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/146.png",
          large: "https://images.pokemontcg.io/sv8pt5/146_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-13",
    name: "Fletchinder",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fire"],
    evolvesFrom: "Fletchling",
    attacks: [
      {
        name: "Flare",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "13",
    nationalPokedexNumbers: [662],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-13/small",
      large: "https://images.scrydex.com/pokemon/me3-13/large",
    },
    altArts: [
      {
        id: "me3-13",
        number: "13",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-13/small",
          large: "https://images.scrydex.com/pokemon/me3-13/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-122",
    name: "Fletchinder",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Fletchling",
    evolvesTo: ["Talonflame"],
    attacks: [
      {
        name: "Speed Dive",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "122",
    nationalPokedexNumbers: [662],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/122.png",
      large: "https://images.pokemontcg.io/sv7/122_hires.png",
    },
    altArts: [
      {
        id: "sv7-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/sv7/122.png",
          large: "https://images.pokemontcg.io/sv7/122_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-66",
    name: "Fletchling",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    attacks: [
      {
        name: "Chirp",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Pokémon with Fighting Resistance, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Peck",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "66",
    nationalPokedexNumbers: [661],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-66/small",
      large: "https://images.scrydex.com/pokemon/me3-66/large",
    },
    altArts: [
      {
        id: "me3-66",
        number: "66",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-66/small",
          large: "https://images.scrydex.com/pokemon/me3-66/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-121",
    name: "Fletchling",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Fletchinder"],
    attacks: [
      {
        name: "Send Back",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "121",
    nationalPokedexNumbers: [661],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/121.png",
      large: "https://images.pokemontcg.io/sv7/121_hires.png",
    },
    altArts: [
      {
        id: "sv7-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/sv7/121.png",
          large: "https://images.pokemontcg.io/sv7/121_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-68",
    name: "Flittle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    attacks: [
      {
        name: "Peck",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "68",
    nationalPokedexNumbers: [955],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/68.png",
      large: "https://images.pokemontcg.io/sv7/68_hires.png",
    },
    altArts: [
      {
        id: "sv7-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv7/68.png",
          large: "https://images.pokemontcg.io/sv7/68_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-94",
    name: "Flittle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Psychic"],
    attacks: [
      {
        name: "Splashing Dodge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "94",
    nationalPokedexNumbers: [955],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/94.png",
      large: "https://images.pokemontcg.io/sv8/94_hires.png",
    },
    altArts: [
      {
        id: "sv8-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv8/94.png",
          large: "https://images.pokemontcg.io/sv8/94_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-58",
    name: "Floatzel",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Buizel",
    attacks: [
      {
        name: "Whirlpool",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Aqua Slash",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    nationalPokedexNumbers: [419],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/58.png",
      large: "https://images.pokemontcg.io/sv10/58_hires.png",
    },
    altArts: [
      {
        id: "sv10-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv10/58.png",
          large: "https://images.pokemontcg.io/sv10/58_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-87",
    name: "Floette",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Psychic"],
    evolvesFrom: "Flabébé",
    evolvesTo: ["Florges"],
    attacks: [
      {
        name: "Minor Errand-Running",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Basic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Spinning Attack",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "87",
    flavorText:
      "This Pokémon uses red wavelengths of light to pour its own energy into flowers and draw forth their latent potential.",
    nationalPokedexNumbers: [670],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/87.png",
      large: "https://images.pokemontcg.io/sv6/87_hires.png",
    },
    altArts: [
      {
        id: "sv6-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv6/87.png",
          large: "https://images.pokemontcg.io/sv6/87_hires.png",
        },
        flavorText:
          "This Pokémon uses red wavelengths of light to pour its own energy into flowers and draw forth their latent potential.",
      },
    ],
  },
  {
    id: "sv9-17",
    name: "Floragato",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Sprigatito",
    attacks: [
      {
        name: "Magical Leaf",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "Flip a coin. If heads, this attack does 30 more damage, and heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "17",
    nationalPokedexNumbers: [907],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/17.png",
      large: "https://images.pokemontcg.io/sv9/17_hires.png",
    },
    altArts: [
      {
        id: "sv9-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv9/17.png",
          large: "https://images.pokemontcg.io/sv9/17_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-88",
    name: "Florges",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Floette",
    abilities: [
      {
        name: "Captivating Invitation",
        text: "Once during your turn, you may flip a coin. If heads, switch in 1 of your opponent's Benched Pokémon to the Active Spot, and the new Active Pokémon is now Confused.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "88",
    flavorText:
      "They say that flower gardens created by Florges are constantly showered with a power that can heal both body and spirit.",
    nationalPokedexNumbers: [671],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/88.png",
      large: "https://images.pokemontcg.io/sv6/88_hires.png",
    },
    altArts: [
      {
        id: "sv6-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv6/88.png",
          large: "https://images.pokemontcg.io/sv6/88_hires.png",
        },
        flavorText:
          "They say that flower gardens created by Florges are constantly showered with a power that can heal both body and spirit.",
      },
    ],
  },
  {
    id: "sv5-78",
    name: "Flutter Mane",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "90",
    types: ["Psychic"],
    abilities: [
      {
        name: "Midnight Fluttering",
        text: "As long as this Pokémon is in the Active Spot, your opponent's Active Pokémon has no Abilities, except for Midnight Fluttering.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hex Hurl",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Put 2 damage counters on your opponent's Benched Pokémon in any way you like.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    flavorText:
      "This Pokémon has characteristics similar to those of Flutter Mane, a creature mentioned in a certain book.",
    nationalPokedexNumbers: [987],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/78.png",
      large: "https://images.pokemontcg.io/sv5/78_hires.png",
    },
    altArts: [
      {
        id: "sv5-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv5/78.png",
          large: "https://images.pokemontcg.io/sv5/78_hires.png",
        },
        flavorText:
          "This Pokémon has characteristics similar to those of Flutter Mane, a creature mentioned in a certain book.",
      },
      {
        id: "sv8pt5-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/43.png",
          large: "https://images.pokemontcg.io/sv8pt5/43_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-96",
    name: "Flutter Mane",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Perplexing Transfer",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Move all damage counters from 1 of your Benched Ancient Pokémon to your opponent's Active Pokémon.",
      },
      {
        name: "Moonblast",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 30 less damage (before applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "96",
    nationalPokedexNumbers: [987],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/96.png",
      large: "https://images.pokemontcg.io/sv8/96_hires.png",
    },
    altArts: [
      {
        id: "sv8-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/sv8/96.png",
          large: "https://images.pokemontcg.io/sv8/96_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-97",
    name: "Flutter Mane",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "90",
    types: ["Psychic"],
    abilities: [
      {
        name: "Midnight Fluttering",
        text: "As long as this Pokémon is in the Active Spot, your opponent's Active Pokémon has no Abilities, except for Midnight Fluttering.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        cost: ["Colorless", "Colorless", "Colorless"],
        name: "Hex Hurl",
        damage: "90",
        text: "Put 2 damage counters on your opponent's Benched Pokémon in any way you like.",
        convertedEnergyCost: 3,
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "97",
    flavorText:
      "This Pokémon has characteristics similar to those of Flutter Mane, a creature mentioned in a certain book.",
    nationalPokedexNumbers: [987],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/97.png",
      large: "https://images.pokemontcg.io/svp/97_hires.png",
    },
    altArts: [
      {
        id: "svp-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/svp/97.png",
          large: "https://images.pokemontcg.io/svp/97_hires.png",
        },
        flavorText:
          "This Pokémon has characteristics similar to those of Flutter Mane, a creature mentioned in a certain book.",
      },
    ],
  },
  {
    id: "me2-53",
    name: "Flygon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Vibrava",
    abilities: [
      {
        name: "Sandy Flapping",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. You may also use this Ability if this Pokémon is in the Active Spot and is Knocked Out by damage from an attack from your opponent's Pokémon. Discard the top 2 cards of your opponent's deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Cutting Wind",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "53",
    flavorText:
      "Known as the Desert Spirit, this Pokémon hides in the sandstorms it causes by beating its wings.",
    nationalPokedexNumbers: [330],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/53.png",
      large: "https://images.pokemontcg.io/me2/53_hires.png",
    },
    altArts: [
      {
        id: "me2-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/me2/53.png",
          large: "https://images.pokemontcg.io/me2/53_hires.png",
        },
        flavorText:
          "Known as the Desert Spirit, this Pokémon hides in the sandstorms it causes by beating its wings.",
      },
      {
        id: "me2-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/me2/101.png",
          large: "https://images.pokemontcg.io/me2/101_hires.png",
        },
        flavorText:
          "Known as the Desert Spirit, this Pokémon hides in the sandstorms it causes by beating its wings.",
      },
    ],
  },
  {
    id: "sv8-106",
    name: "Flygon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "Tera", "ex"],
    hp: "310",
    types: ["Fighting"],
    evolvesFrom: "Vibrava",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Reversing Storm",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "130",
        text: "You may switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Sonic Peridot",
        cost: ["Water", "Fighting", "Metal"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 100 damage to each of your opponent's Pokémon ex and Pokémon V. This attack's damage isn't affected by Weakness or Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "106",
    nationalPokedexNumbers: [330],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/106.png",
      large: "https://images.pokemontcg.io/sv8/106_hires.png",
    },
    altArts: [
      {
        id: "sv8-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/sv8/106.png",
          large: "https://images.pokemontcg.io/sv8/106_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-222",
        number: "222",
        images: {
          small: "https://images.pokemontcg.io/sv8/222.png",
          large: "https://images.pokemontcg.io/sv8/222_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-3",
    name: "Fomantis",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    flavorText:
      "Many Trainers give their Fomantis their own flowerpots so they can sunbathe in peace and quiet.",
    nationalPokedexNumbers: [753],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-3/small",
      large: "https://images.scrydex.com/pokemon/me5-3/large",
    },
    altArts: [
      {
        id: "me5-3",
        number: "3",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-3/small",
          large: "https://images.scrydex.com/pokemon/me5-3/large",
        },
        flavorText:
          "Many Trainers give their Fomantis their own flowerpots so they can sunbathe in peace and quiet.",
      },
      {
        id: "me5-85",
        number: "85",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-85/small",
          large: "https://images.scrydex.com/pokemon/me5-85/large",
        },
        flavorText:
          "Many Trainers give their Fomantis their own flowerpots so they can sunbathe in peace and quiet.",
      },
    ],
  },
  {
    id: "sv10-13",
    name: "Fomantis",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Lurantis"],
    attacks: [
      {
        name: "Cut Up",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "13",
    nationalPokedexNumbers: [753],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/13.png",
      large: "https://images.pokemontcg.io/sv10/13_hires.png",
    },
    altArts: [
      {
        id: "sv10-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/sv10/13.png",
          large: "https://images.pokemontcg.io/sv10/13_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-10",
    name: "Foongus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Amoonguss"],
    attacks: [
      {
        name: "Toxic Spore",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    flavorText:
      "It lures people in with its Poké Ball pattern, then releases poison spores. Why it resembles a Poké Ball is unknown.",
    nationalPokedexNumbers: [590],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/10.png",
      large: "https://images.pokemontcg.io/zsv10pt5/10_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/10.png",
          large: "https://images.pokemontcg.io/zsv10pt5/10_hires.png",
        },
        flavorText:
          "It lures people in with its Poké Ball pattern, then releases poison spores. Why it resembles a Poké Ball is unknown.",
      },
      {
        id: "zsv10pt5-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/95.png",
          large: "https://images.pokemontcg.io/zsv10pt5/95_hires.png",
        },
        flavorText:
          "It lures people in with its Poké Ball pattern, then releases poison spores. Why it resembles a Poké Ball is unknown.",
      },
    ],
  },
  {
    id: "sv9-10",
    name: "Foongus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Amoonguss"],
    attacks: [
      {
        name: "Spore Ball",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    nationalPokedexNumbers: [590],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/10.png",
      large: "https://images.pokemontcg.io/sv9/10_hires.png",
    },
    altArts: [
      {
        id: "sv9-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv9/10.png",
          large: "https://images.pokemontcg.io/sv9/10_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-140",
    name: "Forretress",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Pineco",
    attacks: [
      {
        name: "Iron Shake-Up",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may move any amount of Metal Energy from your Pokémon to your other Pokémon in any way you like.",
      },
      {
        name: "Hurricane of Needles",
        cost: ["Metal", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "80×",
        text: "Flip 4 coins. This attack does 80 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "140",
    nationalPokedexNumbers: [205],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/140.png",
      large: "https://images.pokemontcg.io/sv10/140_hires.png",
    },
    altArts: [
      {
        id: "sv10-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/sv10/140.png",
          large: "https://images.pokemontcg.io/sv10/140_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-110",
    name: "Forretress",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Pineco",
    attacks: [
      {
        name: "Spike Cannon",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "Flip 3 coins. This attack does 30 damage for each heads.",
      },
      {
        name: "Steel Tackle",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "This Pokémon also does 40 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "110",
    flavorText:
      "Its entire body is shielded by a steel-hard shell. What lurks inside this shell is a total mystery.",
    nationalPokedexNumbers: [205],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/110.png",
      large: "https://images.pokemontcg.io/sv5/110_hires.png",
    },
    altArts: [
      {
        id: "sv5-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/sv5/110.png",
          large: "https://images.pokemontcg.io/sv5/110_hires.png",
        },
        flavorText:
          "Its entire body is shielded by a steel-hard shell. What lurks inside this shell is a total mystery.",
      },
    ],
  },
  {
    id: "zsv10pt5-69",
    name: "Fraxure",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Dragon"],
    evolvesFrom: "Axew",
    evolvesTo: ["Haxorus"],
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Boundless Power",
        cost: ["Fighting", "Metal"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "69",
    flavorText:
      "Since a broken tusk will not grow back, they diligently sharpen their tusks on river rocks after they've been fighting.",
    nationalPokedexNumbers: [611],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/69.png",
      large: "https://images.pokemontcg.io/zsv10pt5/69_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/69.png",
          large: "https://images.pokemontcg.io/zsv10pt5/69_hires.png",
        },
        flavorText:
          "Since a broken tusk will not grow back, they diligently sharpen their tusks on river rocks after they've been fighting.",
      },
      {
        id: "zsv10pt5-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/146.png",
          large: "https://images.pokemontcg.io/zsv10pt5/146_hires.png",
        },
        flavorText:
          "Since a broken tusk will not grow back, they diligently sharpen their tusks on river rocks after they've been fighting.",
      },
    ],
  },
  {
    id: "sv6pt5-45",
    name: "Fraxure",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Dragon"],
    evolvesFrom: "Axew",
    evolvesTo: ["Haxorus"],
    abilities: [
      {
        name: "Unnerve",
        text: "Whenever your opponent plays an Item or Supporter card from their hand, prevent all effects of that card done to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dragon Pulse",
        cost: ["Fighting", "Metal"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "Discard the top card of your deck.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "45",
    nationalPokedexNumbers: [611],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/45.png",
      large: "https://images.pokemontcg.io/sv6pt5/45_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/45.png",
          large: "https://images.pokemontcg.io/sv6pt5/45_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/77.png",
          large: "https://images.pokemontcg.io/sv6pt5/77_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-44",
    name: "Frillish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    evolvesTo: ["Jellicent"],
    attacks: [
      {
        name: "Oceanic Gloom",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your opponent's next turn, they can't play any Item cards from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "44",
    flavorText:
      "With its thin, veil-like arms wrapped around the body of its opponent, it sinks to the ocean floor.",
    nationalPokedexNumbers: [592],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/44.png",
      large: "https://images.pokemontcg.io/rsv10pt5/44_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/44.png",
          large: "https://images.pokemontcg.io/rsv10pt5/44_hires.png",
        },
        flavorText:
          "With its thin, veil-like arms wrapped around the body of its opponent, it sinks to the ocean floor.",
      },
      {
        id: "rsv10pt5-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/126.png",
          large: "https://images.pokemontcg.io/rsv10pt5/126_hires.png",
        },
        flavorText:
          "With its thin, veil-like arms wrapped around the body of its opponent, it sinks to the ocean floor.",
      },
    ],
  },
  {
    id: "me4-20",
    name: "Froakie",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Water Gun",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "20",
    flavorText:
      "It protects its skin by covering its body in delicate bubbles. Beneath its happy-go-lucky air, it keeps a watchful eye on its surroundings.",
    nationalPokedexNumbers: [656],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-20/small",
      large: "https://images.scrydex.com/pokemon/me4-20/large",
    },
    altArts: [
      {
        id: "me4-20",
        number: "20",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-20/small",
          large: "https://images.scrydex.com/pokemon/me4-20/large",
        },
        flavorText:
          "It protects its skin by covering its body in delicate bubbles. Beneath its happy-go-lucky air, it keeps a watchful eye on its surroundings.",
      },
      {
        id: "me4-88",
        number: "88",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-88/small",
          large: "https://images.scrydex.com/pokemon/me4-88/large",
        },
        flavorText:
          "It protects its skin by covering its body in delicate bubbles. Beneath its happy-go-lucky air, it keeps a watch ful eye on its surroundings.",
      },
    ],
  },
  {
    id: "sv6-56",
    name: "Froakie",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Frogadier"],
    attacks: [
      {
        name: "Flock",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Froakie and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Flop",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "56",
    flavorText:
      "It secretes flexible bubbles from its chest and back. The bubbles reduce the damage it would otherwise take when attacked.",
    nationalPokedexNumbers: [656],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/56.png",
      large: "https://images.pokemontcg.io/sv6/56_hires.png",
    },
    altArts: [
      {
        id: "sv6-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/sv6/56.png",
          large: "https://images.pokemontcg.io/sv6/56_hires.png",
        },
        flavorText:
          "It secretes flexible bubbles from its chest and back. The bubbles reduce the damage it would otherwise take when attacked.",
      },
    ],
  },
  {
    id: "sv7-39",
    name: "Froakie",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Frogadier"],
    attacks: [
      {
        name: "Rain Splash",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    nationalPokedexNumbers: [656],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/39.png",
      large: "https://images.pokemontcg.io/sv7/39_hires.png",
    },
    altArts: [
      {
        id: "sv7-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv7/39.png",
          large: "https://images.pokemontcg.io/sv7/39_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-21",
    name: "Frogadier",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Froakie",
    attacks: [
      {
        name: "Summoning Jutsu",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Aqua Edge",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    flavorText:
      "Its swiftness is unparalleled. It can scale a tower of more than 2,000 feet in a minute's time.",
    nationalPokedexNumbers: [657],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-21/small",
      large: "https://images.scrydex.com/pokemon/me4-21/large",
    },
    altArts: [
      {
        id: "me4-21",
        number: "21",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-21/small",
          large: "https://images.scrydex.com/pokemon/me4-21/large",
        },
        flavorText:
          "Its swiftness is unparalleled. It can scale a tower of more than 2,000 feet in a minute's time.",
      },
      {
        id: "me4-89",
        number: "89",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-89/small",
          large: "https://images.scrydex.com/pokemon/me4-89/large",
        },
        flavorText:
          "Its swiftness is unparalleled. It can scale a tower of more than 2,000 feet in a minute's time.",
      },
    ],
  },
  {
    id: "sv6-57",
    name: "Frogadier",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Froakie",
    evolvesTo: ["Greninja"],
    attacks: [
      {
        name: "Numbing Water",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    flavorText:
      "It can throw bubble-covered pebbles with precise control, hitting empty cans up to a hundred feet away.",
    nationalPokedexNumbers: [657],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/57.png",
      large: "https://images.pokemontcg.io/sv6/57_hires.png",
    },
    altArts: [
      {
        id: "sv6-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv6/57.png",
          large: "https://images.pokemontcg.io/sv6/57_hires.png",
        },
        flavorText:
          "It can throw bubble-covered pebbles with precise control, hitting empty cans up to a hundred feet away.",
      },
    ],
  },
  {
    id: "sv7-40",
    name: "Frogadier",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Froakie",
    evolvesTo: ["Greninja"],
    attacks: [
      {
        name: "Wave Splash",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    nationalPokedexNumbers: [657],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/40.png",
      large: "https://images.pokemontcg.io/sv7/40_hires.png",
    },
    altArts: [
      {
        id: "sv7-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv7/40.png",
          large: "https://images.pokemontcg.io/sv7/40_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-53",
    name: "Froslass",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Snorunt",
    abilities: [
      {
        name: "Freezing Shroud",
        text: "During Pokémon Checkup, put 1 damage counter on each Pokémon that has an Ability (both yours and your opponent's), except any Froslass.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Frost Smash",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "53",
    flavorText:
      "It freezes prey by blowing its −58 degree Fahrenheit breath. It is said to then secretly display its prey.",
    nationalPokedexNumbers: [478],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/53.png",
      large: "https://images.pokemontcg.io/sv6/53_hires.png",
    },
    altArts: [
      {
        id: "sv6-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv6/53.png",
          large: "https://images.pokemontcg.io/sv6/53_hires.png",
        },
        flavorText:
          "It freezes prey by blowing its −58 degree Fahrenheit breath. It is said to then secretly display its prey.",
      },
      {
        id: "sv6-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/sv6/174.png",
          large: "https://images.pokemontcg.io/sv6/174_hires.png",
        },
        flavorText:
          "It freezes prey by blowing its −58 degree Fahrenheit breath. It is said to then secretly display its prey.",
      },
      {
        id: "svp-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/svp/117.png",
          large: "https://images.pokemontcg.io/svp/117_hires.png",
        },
        flavorText:
          "It freezes prey by blowing its −58 degree Fahrenheit breath. It is said to then secretly display its prey.",
      },
    ],
  },
  {
    id: "me1-43",
    name: "Frosmoth",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Snom",
    attacks: [
      {
        name: "Chilling Wings",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 20 damage to each of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.) Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    nationalPokedexNumbers: [873],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/43.png",
      large: "https://images.pokemontcg.io/me1/43_hires.png",
    },
    altArts: [
      {
        id: "me1-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/me1/43.png",
          large: "https://images.pokemontcg.io/me1/43_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-53",
    name: "Frosmoth",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Snom",
    abilities: [
      {
        name: "Alluring Wings",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may use this Ability. Each player draws a card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Cold Cyclone",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "Move a Water Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "53",
    flavorText:
      "It causes blizzards as it flies around with its huge, chill-emanating wings. Clean meltwater is its favorite thing to drink.",
    nationalPokedexNumbers: [873],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-53/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-53/large",
    },
    altArts: [
      {
        id: "me2pt5-53",
        number: "53",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-53/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-53/large",
        },
        flavorText:
          "It causes blizzards as it flies around with its huge, chill-emanating wings. Clean meltwater is its favorite thing to drink.",
      },
    ],
  },
  {
    id: "sv5-46",
    name: "Frosmoth",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Snom",
    attacks: [
      {
        name: "Freezing Chill",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "During your opponent's next turn, the Defending Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    flavorText:
      "Frosmoth senses air currents with its antennae. It sends its scales drifting on frigid air, making them fall like snow.",
    nationalPokedexNumbers: [873],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/46.png",
      large: "https://images.pokemontcg.io/sv5/46_hires.png",
    },
    altArts: [
      {
        id: "sv5-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv5/46.png",
          large: "https://images.pokemontcg.io/sv5/46_hires.png",
        },
        flavorText:
          "Frosmoth senses air currents with its antennae. It sends its scales drifting on frigid air, making them fall like snow.",
      },
    ],
  },
  {
    id: "sv8-29",
    name: "Fuecoco",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Heat Burn",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "29",
    nationalPokedexNumbers: [909],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/29.png",
      large: "https://images.pokemontcg.io/sv8/29_hires.png",
    },
    altArts: [
      {
        id: "sv8-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/sv8/29.png",
          large: "https://images.pokemontcg.io/sv8/29_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-15",
    name: "Fuecoco ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Fire"],
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Cheerful Flame",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70×",
        text: "This attack does 70 damage for each Prize card you have taken.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "15",
    nationalPokedexNumbers: [909],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-15/small",
      large: "https://images.scrydex.com/pokemon/me55-15/large",
    },
    altArts: [
      {
        id: "me55-15",
        number: "15",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-15/small",
          large: "https://images.scrydex.com/pokemon/me55-15/large",
        },
        flavorText: "",
      },
      {
        id: "me55-147",
        number: "147",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-147/small",
          large: "https://images.scrydex.com/pokemon/me55-147/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-67",
    name: "Furfrou",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Colorless"],
    attacks: [
      {
        name: "Hand Trim",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard random cards from your opponent's hand until they have 5 cards in their hand.",
      },
      {
        name: "Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    nationalPokedexNumbers: [676],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-67/small",
      large: "https://images.scrydex.com/pokemon/me3-67/large",
    },
    altArts: [
      {
        id: "me3-67",
        number: "67",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-67/small",
          large: "https://images.scrydex.com/pokemon/me3-67/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-51",
    name: "Furfrou",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Colorless"],
    attacks: [
      {
        name: "Energy Assist",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Attach a Basic Energy card from your discard pile to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    nationalPokedexNumbers: [676],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/51.png",
      large: "https://images.pokemontcg.io/sv6pt5/51_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/51.png",
          large: "https://images.pokemontcg.io/sv6pt5/51_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-88",
    name: "Furfrou",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Colorless"],
    abilities: [
      {
        name: "Fur Coat",
        text: "This Pokémon takes 20 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "88",
    nationalPokedexNumbers: [676],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/88.png",
      large: "https://images.pokemontcg.io/sv8pt5/88_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/88.png",
          large: "https://images.pokemontcg.io/sv8pt5/88_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-119",
    name: "Furret",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Sentret",
    attacks: [
      {
        name: "Scratch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Jet Headbutt",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "119",
    nationalPokedexNumbers: [162],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/119.png",
      large: "https://images.pokemontcg.io/sv9/119_hires.png",
    },
    altArts: [
      {
        id: "sv9-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/sv9/119.png",
          large: "https://images.pokemontcg.io/sv9/119_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/sv9/168.png",
          large: "https://images.pokemontcg.io/sv9/168_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-131",
    name: "Galarian Linoone",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Darkness"],
    evolvesFrom: "Galarian Zigzagoon",
    attacks: [
      {
        name: "Gnaw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Claw Slash",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "131",
    flavorText:
      "It uses its long tongue to taunt opponents. Once the opposition is enraged, this Pokémon hurls itself at the opponent, tackling them forcefully.",
    nationalPokedexNumbers: [264],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-131/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-131/large",
    },
    altArts: [
      {
        id: "me2pt5-131",
        number: "131",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-131/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-131/large",
        },
        flavorText:
          "It uses its long tongue to taunt opponents. Once the opposition is enraged, this Pokémon hurls itself at the opponent, tackling them forcefully.",
      },
    ],
  },
  {
    id: "me55-101",
    name: "Galarian Meowth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Pay Day",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Draw a card.",
      },
      {
        name: "Treasure Rush",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "This attack does 10 damage for each card in your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "101",
    nationalPokedexNumbers: [52],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-101/small",
      large: "https://images.scrydex.com/pokemon/me55-101/large",
    },
    altArts: [
      {
        id: "me55-101",
        number: "101",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-101/small",
          large: "https://images.scrydex.com/pokemon/me55-101/large",
        },
        flavorText: "",
      },
      {
        id: "me55-141",
        number: "141",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-141/small",
          large: "https://images.scrydex.com/pokemon/me55-141/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-132",
    name: "Galarian Obstagoon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Galarian Linoone",
    attacks: [
      {
        name: "Scarring Shout",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70×",
        text: "This attack does 70 damage for each damage counter on your opponent's Active Pokémon.",
      },
      {
        name: "Punk Smash",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "132",
    flavorText:
      "Its voice is staggering in volume. Obstagoon has a tendency to take on a threatening posture and shout—this move is known as Obstruct.",
    nationalPokedexNumbers: [862],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-132/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-132/large",
    },
    altArts: [
      {
        id: "me2pt5-132",
        number: "132",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-132/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-132/large",
        },
        flavorText:
          "Its voice is staggering in volume. Obstagoon has a tendency to take on a threatening posture and shout—this move is known as Obstruct.",
      },
      {
        id: "me2pt5-245",
        number: "245",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-245/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-245/large",
        },
        flavorText:
          "Its voice is staggering in volume. Obstagoon has a tendency to take on a threatening posture and shout—this move is known as Obstruct.",
      },
    ],
  },
  {
    id: "sv9-106",
    name: "Galarian Stunfisk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Metal"],
    attacks: [
      {
        name: "Mud-Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
      {
        name: "Bounding Bite",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "106",
    nationalPokedexNumbers: [618],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/106.png",
      large: "https://images.pokemontcg.io/sv9/106_hires.png",
    },
    altArts: [
      {
        id: "sv9-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/sv9/106.png",
          large: "https://images.pokemontcg.io/sv9/106_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-130",
    name: "Galarian Zigzagoon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "130",
    flavorText:
      "Its restlessness has it constantly running around. If it sees another Pokémon, it will purposely run into them in order to start a fight.",
    nationalPokedexNumbers: [263],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-130/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-130/large",
    },
    altArts: [
      {
        id: "me2pt5-130",
        number: "130",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-130/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-130/large",
        },
        flavorText:
          "Its restlessness has it constantly running around. If it sees another Pokémon, it will purposely run into them in order to start a fight.",
      },
    ],
  },
  {
    id: "rsv10pt5-34",
    name: "Galvantula",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Joltik",
    attacks: [
      {
        name: "Discharge",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "Discard all Lightning Energy from this Pokémon. This attack does 50 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "34",
    flavorText:
      "When attacked, they create an electric barrier by spitting out many electrically charged threads.",
    nationalPokedexNumbers: [596],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/34.png",
      large: "https://images.pokemontcg.io/rsv10pt5/34_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/34.png",
          large: "https://images.pokemontcg.io/rsv10pt5/34_hires.png",
        },
        flavorText:
          "When attacked, they create an electric barrier by spitting out many electrically charged threads.",
      },
      {
        id: "rsv10pt5-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/117.png",
          large: "https://images.pokemontcg.io/rsv10pt5/117_hires.png",
        },
        flavorText:
          "When attacked, they create an electric barrier by spitting out many electrically charged threads.",
      },
    ],
  },
  {
    id: "sv6pt5-2",
    name: "Galvantula",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Joltik",
    abilities: [
      {
        name: "Compound Eyes",
        text: "Attacks used by this Pokémon do 50 more damage to your opponent's Active Pokémon that has an Ability (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Shocking Web",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If this Pokémon has any Lightning Energy attached, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    nationalPokedexNumbers: [596],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/2.png",
      large: "https://images.pokemontcg.io/sv6pt5/2_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/2.png",
          large: "https://images.pokemontcg.io/sv6pt5/2_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-51",
    name: "Galvantula ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "260",
    types: ["Lightning"],
    evolvesFrom: "Joltik",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Charged Web",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "110+",
        text: "If your opponent's Active Pokémon is a Pokémon ex or Pokémon V, this attack does 110 more damage.",
      },
      {
        name: "Fulgurite",
        cost: ["Grass", "Lightning", "Fighting"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "Discard all Energy from this Pokémon. During your opponent's next turn, they can't play any Item cards from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    nationalPokedexNumbers: [596],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/51.png",
      large: "https://images.pokemontcg.io/sv7/51_hires.png",
    },
    altArts: [
      {
        id: "sv7-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv7/51.png",
          large: "https://images.pokemontcg.io/sv7/51_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/sv7/159.png",
          large: "https://images.pokemontcg.io/sv7/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/sv7/168.png",
          large: "https://images.pokemontcg.io/sv7/168_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-60",
    name: "Garbodor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Trubbish",
    attacks: [
      {
        name: "Suffocating Gas",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Gunk Shot",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "60",
    flavorText:
      "It clenches opponents with its left arm and finishes them off with foul-smelling poison gas belched from its mouth.",
    nationalPokedexNumbers: [569],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/60.png",
      large: "https://images.pokemontcg.io/rsv10pt5/60_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/60.png",
          large: "https://images.pokemontcg.io/rsv10pt5/60_hires.png",
        },
        flavorText:
          "It clenches opponents with its left arm and finishes them off with foul-smelling poison gas belched from its mouth.",
      },
      {
        id: "rsv10pt5-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/141.png",
          large: "https://images.pokemontcg.io/rsv10pt5/141_hires.png",
        },
        flavorText:
          "It clenches opponents with its left arm and finishes them off with foul-smelling poison gas belched from its mouth.",
      },
    ],
  },
  {
    id: "me4-57",
    name: "Garbodor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Trubbish",
    abilities: [
      {
        name: "Gloomy Garbage",
        text: "Attacks used by your opponent's Active Pokémon that has a Pokémon Tool attached do 20 less damage (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Sludge Bomb",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "57",
    flavorText:
      "Consuming garbage makes new kinds of poison gases and liquids inside their bodies.",
    nationalPokedexNumbers: [569],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-57/small",
      large: "https://images.scrydex.com/pokemon/me4-57/large",
    },
    altArts: [
      {
        id: "me4-57",
        number: "57",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-57/small",
          large: "https://images.scrydex.com/pokemon/me4-57/large",
        },
        flavorText:
          "Consuming garbage makes new kinds of poison gases and liquids inside their bodies.",
      },
    ],
  },
  {
    id: "me1-84",
    name: "Garganacl",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fighting"],
    evolvesFrom: "Naclstack",
    abilities: [
      {
        name: "Powerful a-Salt",
        text: "Attacks used by your Fighting Pokémon do 30 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "84",
    nationalPokedexNumbers: [934],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/84.png",
      large: "https://images.pokemontcg.io/me1/84_hires.png",
    },
    altArts: [
      {
        id: "me1-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/me1/84.png",
          large: "https://images.pokemontcg.io/me1/84_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/me1/147.png",
          large: "https://images.pokemontcg.io/me1/147_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-54",
    name: "Gastly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Haunter"],
    attacks: [
      {
        name: "Petty Grudge",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "54",
    flavorText:
      "It wraps its opponent in its gas-like body, slowly weakening its prey by poisoning it through the skin.",
    nationalPokedexNumbers: [92],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/54.png",
      large: "https://images.pokemontcg.io/me2/54_hires.png",
    },
    altArts: [
      {
        id: "me2-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/me2/54.png",
          large: "https://images.pokemontcg.io/me2/54_hires.png",
        },
        flavorText:
          "It wraps its opponent in its gas-like body, slowly weakening its prey by poisoning it through the skin.",
      },
      {
        id: "me2pt5-123",
        number: "123",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-123/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-123/large",
        },
        flavorText:
          "It wraps its opponent in its gas-like body, slowly weakening its prey by poisoning it through the skin.",
      },
    ],
  },
  {
    id: "me3-48",
    name: "Gastly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "48",
    nationalPokedexNumbers: [92],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-48/small",
      large: "https://images.scrydex.com/pokemon/me3-48/large",
    },
    altArts: [
      {
        id: "me3-48",
        number: "48",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-48/small",
          large: "https://images.scrydex.com/pokemon/me3-48/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-102",
    name: "Gastly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Haunter"],
    attacks: [
      {
        name: "Mysterious Beam",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Suffocating Gas",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "102",
    flavorText:
      "It wraps its opponent in its gas-like body, slowly weakening its prey by poisoning it through the skin.",
    nationalPokedexNumbers: [92],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/102.png",
      large: "https://images.pokemontcg.io/sv5/102_hires.png",
    },
    altArts: [
      {
        id: "sv5-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/sv5/102.png",
          large: "https://images.pokemontcg.io/sv5/102_hires.png",
        },
        flavorText:
          "It wraps its opponent in its gas-like body, slowly weakening its prey by poisoning it through the skin.",
      },
      {
        id: "sv5-177",
        number: "177",
        images: {
          small: "https://images.pokemontcg.io/sv5/177.png",
          large: "https://images.pokemontcg.io/sv5/177_hires.png",
        },
        flavorText:
          "It wraps its opponent in its gas-like body, slowly weakening its prey by poisoning it through the skin.",
      },
    ],
  },
  {
    id: "sv8-107",
    name: "Gastrodon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Shellos",
    abilities: [
      {
        name: "Sticky Bind",
        text: "As long as this Pokémon is on your Bench, Benched Stage 2 Pokémon (both yours and your opponent's) have no Abilities.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mud Shot",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "107",
    nationalPokedexNumbers: [423],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/107.png",
      large: "https://images.pokemontcg.io/sv8/107_hires.png",
    },
    altArts: [
      {
        id: "sv8-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/sv8/107.png",
          large: "https://images.pokemontcg.io/sv8/107_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-8",
    name: "Genesect",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Bug's Cannon",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 20 damage to 1 of your opponent's Pokémon for each Grass Energy attached to this Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Speed Attack",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "8",
    flavorText:
      "This Pokémon existed 300 million years ago. Team Plasma altered it and attached a cannon to its back.",
    nationalPokedexNumbers: [649],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/8.png",
      large: "https://images.pokemontcg.io/me2/8_hires.png",
    },
    altArts: [
      {
        id: "me2-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/me2/8.png",
          large: "https://images.pokemontcg.io/me2/8_hires.png",
        },
        flavorText:
          "This Pokémon existed 300 million years ago. Team Plasma altered it and attached a cannon to its back.",
      },
    ],
  },
  {
    id: "sv6pt5-40",
    name: "Genesect",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Metal"],
    abilities: [
      {
        name: "ACE Nullifier",
        text: "If this Pokémon has a Pokémon Tool attached, your opponent can't play any ACE SPEC cards from their hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Magnetic Blast",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    nationalPokedexNumbers: [649],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/40.png",
      large: "https://images.pokemontcg.io/sv6pt5/40_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/40.png",
          large: "https://images.pokemontcg.io/sv6pt5/40_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-67",
    name: "Genesect ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "220",
    types: ["Metal"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Metallic Signal",
        text: "Once during your turn, you may search your deck for up to 2 Evolution Metal Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Protect Charge",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "67",
    nationalPokedexNumbers: [649],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/67.png",
      large: "https://images.pokemontcg.io/zsv10pt5/67_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/67.png",
          large: "https://images.pokemontcg.io/zsv10pt5/67_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/161.png",
          large: "https://images.pokemontcg.io/zsv10pt5/161_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/169.png",
          large: "https://images.pokemontcg.io/zsv10pt5/169_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-11g",
    name: "Genesect-EX",
    supertype: "Pokémon",
    subtypes: ["Basic", "EX"],
    hp: "170",
    types: ["Grass"],
    rules: [
      "When a Pokémon-EX has been Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Red Signal",
        text: "When you attach a Plasma Energy from your hand to this Pokémon, you may switch 1 of your opponent's Benched Pokémon with his or her Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Megalo Cannon",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Does 20 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    nationalPokedexNumbers: [649],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-11g/small",
      large: "https://images.scrydex.com/pokemon/me55c-11g/large",
    },
    altArts: [
      {
        id: "me55c-11g",
        number: "11",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-11g/small",
          large: "https://images.scrydex.com/pokemon/me55c-11g/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-50",
    name: "Gengar",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Haunter",
    abilities: [
      {
        name: "Infinite Shadow",
        text: "If this Pokémon is Knocked Out by damage from an attack from your opponent's Pokémon, put it into your hand instead of the discard pile. (Discard all attached cards.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mind Jack",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "This attack does 30 more damage for each of your opponent's Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [94],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-50/small",
      large: "https://images.scrydex.com/pokemon/me3-50/large",
    },
    altArts: [
      {
        id: "me3-50",
        number: "50",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-50/small",
          large: "https://images.scrydex.com/pokemon/me3-50/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-94",
    name: "Gengar",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Haunter",
    abilities: [
      {
        name: "Catastrophe",
        text: "As long as Gengar is your Active Pokémon, if any of your opponent's Pokémon would be Knocked Out, put that Pokémon in the Lost Zone instead of discarding. (Discard all cards attached to that Pokémon.)",
        type: "Poké-BODY",
      },
    ],
    attacks: [
      {
        name: "Hurl into Darkness",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        text: "Look at your opponent's hand and choose a number of Pokémon you find there up to the number of Psychic Energy attached to Gengar. Put the Pokémon you chose in the Lost Zone.",
      },
      {
        name: "Cursed Drop",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        text: "Put 4 damage counters on your opponent's Pokémon in any way you like.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Colorless",
        value: "-20",
      },
    ],
    number: "94",
    nationalPokedexNumbers: [94],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-94/small",
      large: "https://images.scrydex.com/pokemon/me55c-94/large",
    },
    altArts: [
      {
        id: "me55c-94",
        number: "94",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-94/small",
          large: "https://images.scrydex.com/pokemon/me55c-94/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-90",
    name: "Gengar ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "280",
    types: ["Darkness"],
    evolvesFrom: "Haunter",
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Fainting Spell",
        text: "If this Pokémon is Knocket Out by damage from an attack from your opponent's Pokémon, flip a coin. If heads, the Attacking Pokémon is Knocket Out.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Chaotic Pain",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        text: "Place 13 damage counters on 1 of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "90",
    nationalPokedexNumbers: [94],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-90/small",
      large: "https://images.scrydex.com/pokemon/me55-90/large",
    },
    altArts: [
      {
        id: "me55-90",
        number: "90",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-90/small",
          large: "https://images.scrydex.com/pokemon/me55-90/large",
        },
        flavorText: "",
      },
      {
        id: "me55-154",
        number: "154",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-154/small",
          large: "https://images.scrydex.com/pokemon/me55-154/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-104",
    name: "Gengar ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "310",
    types: ["Darkness"],
    evolvesFrom: "Haunter",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Gnawing Curse",
        text: "Whenever your opponent attaches an Energy card from their hand to 1 of their Pokémon, put 2 damage counters on that Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Tricky Steps",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "You may move an Energy from your opponent's Active Pokémon to 1 of their Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "104",
    nationalPokedexNumbers: [94],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/104.png",
      large: "https://images.pokemontcg.io/sv5/104_hires.png",
    },
    altArts: [
      {
        id: "sv5-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/sv5/104.png",
          large: "https://images.pokemontcg.io/sv5/104_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-193",
        number: "193",
        images: {
          small: "https://images.pokemontcg.io/sv5/193.png",
          large: "https://images.pokemontcg.io/sv5/193_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-99",
    name: "Gholdengo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Gimmighoul",
    attacks: [
      {
        name: "All-You-Can-Grab",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin until you get tails. Search your deck for a number of cards up to the number of heads and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Speed Attack",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "99",
    nationalPokedexNumbers: [1000],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/99.png",
      large: "https://images.pokemontcg.io/me1/99_hires.png",
    },
    altArts: [
      {
        id: "me1-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/me1/99.png",
          large: "https://images.pokemontcg.io/me1/99_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-108",
    name: "Gholdengo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Gimmighoul",
    attacks: [
      {
        name: "Celebration",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        text: "if you have exactly 30 cards in your hand, take 2 Prize cards. If you do, shuffle your hand into your deck.",
      },
      {
        name: "Triple Smash",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "Flip 3 coins. This attack does 50 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "108",
    nationalPokedexNumbers: [1000],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-108/small",
      large: "https://images.scrydex.com/pokemon/me55-108/large",
    },
    altArts: [
      {
        id: "me55-108",
        number: "108",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-108/small",
          large: "https://images.scrydex.com/pokemon/me55-108/large",
        },
        flavorText: "",
      },
      {
        id: "me55-142",
        number: "142",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-142/small",
          large: "https://images.scrydex.com/pokemon/me55-142/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-131",
    name: "Gholdengo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Metal"],
    evolvesFrom: "Gimmighoul",
    attacks: [
      {
        name: "Strike It Rich",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If this Pokémon evolved from Gimmighoul during this turn, this attack does 90 more damage.",
      },
      {
        name: "Surf Back",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "You may shuffle this Pokémon and all attached cards into your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "131",
    nationalPokedexNumbers: [1000],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/131.png",
      large: "https://images.pokemontcg.io/sv8/131_hires.png",
    },
    altArts: [
      {
        id: "sv8-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/sv8/131.png",
          large: "https://images.pokemontcg.io/sv8/131_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-48",
    name: "Gigalith",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Fighting"],
    evolvesFrom: "Boldore",
    attacks: [
      {
        name: "Vengeful Cannon",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each damage counter on all of your Benched Fighting Pokémon.",
      },
      {
        name: "Heavy Impact",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "48",
    flavorText:
      "Compressing the energy from its internal core lets it fire off an attack capable of blowing away a mountain.",
    nationalPokedexNumbers: [526],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/48.png",
      large: "https://images.pokemontcg.io/rsv10pt5/48_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/48.png",
          large: "https://images.pokemontcg.io/rsv10pt5/48_hires.png",
        },
        flavorText:
          "Compressing the energy from its internal core lets it fire off an attack capable of blowing away a mountain.",
      },
      {
        id: "rsv10pt5-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/129.png",
          large: "https://images.pokemontcg.io/rsv10pt5/129_hires.png",
        },
        flavorText:
          "Compressing the energy from its internal core lets it fire off an attack capable of blowing away a mountain.",
      },
    ],
  },
  {
    id: "me1-67",
    name: "Gimmighoul",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Slap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "67",
    nationalPokedexNumbers: [999],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/67.png",
      large: "https://images.pokemontcg.io/me1/67_hires.png",
    },
    altArts: [
      {
        id: "me1-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/me1/67.png",
          large: "https://images.pokemontcg.io/me1/67_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-81",
    name: "Gimmighoul",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Strolls So Much",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Flip a coin. If heads, search your deck for a card and put it into your hand. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "81",
    nationalPokedexNumbers: [999],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-81/small",
      large: "https://images.scrydex.com/pokemon/me55-81/large",
    },
    altArts: [
      {
        id: "me55-81",
        number: "81",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-81/small",
          large: "https://images.scrydex.com/pokemon/me55-81/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-97",
    name: "Gimmighoul",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Minor Errand-Running",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "97",
    nationalPokedexNumbers: [999],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/97.png",
      large: "https://images.pokemontcg.io/sv8/97_hires.png",
    },
    altArts: [
      {
        id: "sv8-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv8/97.png",
          large: "https://images.pokemontcg.io/sv8/97_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-66",
    name: "Girafarig",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Psychic Assault",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 10 more damage for each damage counter on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "66",
    flavorText:
      "Girafarig's tail has a small head. It instinctively bites at any foe that approaches the Pokémon from behind.",
    nationalPokedexNumbers: [203],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/66.png",
      large: "https://images.pokemontcg.io/sv5/66_hires.png",
    },
    altArts: [
      {
        id: "sv5-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv5/66.png",
          large: "https://images.pokemontcg.io/sv5/66_hires.png",
        },
        flavorText:
          "Girafarig's tail has a small head. It instinctively bites at any foe that approaches the Pokémon from behind.",
      },
    ],
  },
  {
    id: "sv6-83",
    name: "Girafarig",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Psychic"],
    attacks: [
      {
        name: "Dual Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This attack also does 10 damage to 1 of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    flavorText:
      "Girafarig's tail has a small head. It instinctively bites at any foe that approaches the Pokémon from behind.",
    nationalPokedexNumbers: [203],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/83.png",
      large: "https://images.pokemontcg.io/sv6/83_hires.png",
    },
    altArts: [
      {
        id: "sv6-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv6/83.png",
          large: "https://images.pokemontcg.io/sv6/83_hires.png",
        },
        flavorText:
          "Girafarig's tail has a small head. It instinctively bites at any foe that approaches the Pokémon from behind.",
      },
    ],
  },
  {
    id: "sv6-54",
    name: "Glaceon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Eevee",
    attacks: [
      {
        name: "Permeating Chill",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "At the end of your opponent's next turn, put 9 damage counters on the Defending Pokémon.",
      },
      {
        name: "Icicle Missile",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "54",
    flavorText:
      "It lowers its body heat to freeze its fur. The hairs then become like needles it can fire.",
    nationalPokedexNumbers: [471],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/54.png",
      large: "https://images.pokemontcg.io/sv6/54_hires.png",
    },
    altArts: [
      {
        id: "sv6-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv6/54.png",
          large: "https://images.pokemontcg.io/sv6/54_hires.png",
        },
        flavorText:
          "It lowers its body heat to freeze its fur. The hairs then become like needles it can fire.",
      },
      {
        id: "sv8pt5-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/25.png",
          large: "https://images.pokemontcg.io/sv8pt5/25_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-26",
    name: "Glaceon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "270",
    types: ["Water"],
    evolvesFrom: "Eevee",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Frost Bullet",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "110",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Euclase",
        cost: ["Grass", "Water", "Darkness"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Knock Out 1 of your opponent's Pokémon that has exactly 6 damage counters on it.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    nationalPokedexNumbers: [471],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/26.png",
      large: "https://images.pokemontcg.io/sv8pt5/26_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/26.png",
          large: "https://images.pokemontcg.io/sv8pt5/26_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/150.png",
          large: "https://images.pokemontcg.io/sv8pt5/150_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-52",
    name: "Glalie",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Snorunt",
    evolvesTo: ["Froslass"],
    attacks: [
      {
        name: "Damage Beat",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each damage counter on your opponent's Active Pokémon.",
      },
      {
        name: "Crazy Headbutt",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "52",
    flavorText:
      "It prevents prey from escaping by instantaneously freezing moisture in the air.",
    nationalPokedexNumbers: [362],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/52.png",
      large: "https://images.pokemontcg.io/sv6/52_hires.png",
    },
    altArts: [
      {
        id: "sv6-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv6/52.png",
          large: "https://images.pokemontcg.io/sv6/52_hires.png",
        },
        flavorText:
          "It prevents prey from escaping by instantaneously freezing moisture in the air.",
      },
    ],
  },
  {
    id: "sv7-116",
    name: "Glameow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Purugly"],
    attacks: [
      {
        name: "Hook",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "116",
    nationalPokedexNumbers: [431],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/116.png",
      large: "https://images.pokemontcg.io/sv7/116_hires.png",
    },
    altArts: [
      {
        id: "sv7-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/sv7/116.png",
          large: "https://images.pokemontcg.io/sv7/116_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-54",
    name: "Glastrier",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Ice Shot",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This attack also does 20 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Frosty Typhoon",
        cost: ["Water", "Water", "Water"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "During your next turn, this Pokémon can't use Frosty Typhoon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "54",
    flavorText:
      "Glastrier emits intense cold from its hooves. It’s also a belligerent Pokémon—anything it wants, it takes by force.",
    nationalPokedexNumbers: [896],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-54/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-54/large",
    },
    altArts: [
      {
        id: "me2pt5-54",
        number: "54",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-54/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-54/large",
        },
        flavorText:
          "Glastrier emits intense cold from its hooves. It’s also a belligerent Pokémon—anything it wants, it takes by force.",
      },
    ],
  },
  {
    id: "me2-49",
    name: "Gligar",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Gliscor"],
    attacks: [
      {
        name: "Poison Jab",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    flavorText:
      "It builds its nest on a steep cliff. When it is done gliding, it hops along the ground back to its nest.",
    nationalPokedexNumbers: [207],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/49.png",
      large: "https://images.pokemontcg.io/me2/49_hires.png",
    },
    altArts: [
      {
        id: "me2-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/me2/49.png",
          large: "https://images.pokemontcg.io/me2/49_hires.png",
        },
        flavorText:
          "It builds its nest on a steep cliff. When it is done gliding, it hops along the ground back to its nest.",
      },
    ],
  },
  {
    id: "sv6-108",
    name: "Glimmet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    attacks: [
      {
        name: "Rock Shot",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "108",
    flavorText:
      "Glimmet's toxic mineral crystals look just like flower petals. This Pokémon scatters poisonous powder like pollen to protect itself.",
    nationalPokedexNumbers: [969],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/108.png",
      large: "https://images.pokemontcg.io/sv6/108_hires.png",
    },
    altArts: [
      {
        id: "sv6-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/sv6/108.png",
          large: "https://images.pokemontcg.io/sv6/108_hires.png",
        },
        flavorText:
          "Glimmet's toxic mineral crystals look just like flower petals. This Pokémon scatters poisonous powder like pollen to protect itself.",
      },
    ],
  },
  {
    id: "sv8-114",
    name: "Glimmet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Rock Hurl",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "114",
    nationalPokedexNumbers: [969],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/114.png",
      large: "https://images.pokemontcg.io/sv8/114_hires.png",
    },
    altArts: [
      {
        id: "sv8-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/sv8/114.png",
          large: "https://images.pokemontcg.io/sv8/114_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-109",
    name: "Glimmora",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Glimmet",
    attacks: [
      {
        name: "Stun Poison",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed and Poisoned.",
      },
      {
        name: "Venoshock",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your opponent's Active Pokémon is Poisoned, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "109",
    flavorText:
      "Glimmora's petals are made of crystallized poison energy. It has recently become evident that these petals resemble Tera Jewels.",
    nationalPokedexNumbers: [970],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/109.png",
      large: "https://images.pokemontcg.io/sv6/109_hires.png",
    },
    altArts: [
      {
        id: "sv6-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/sv6/109.png",
          large: "https://images.pokemontcg.io/sv6/109_hires.png",
        },
        flavorText:
          "Glimmora's petals are made of crystallized poison energy. It has recently become evident that these petals resemble Tera Jewels.",
      },
    ],
  },
  {
    id: "sv8-115",
    name: "Glimmora",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Glimmet",
    attacks: [
      {
        name: "Corrosive Shards",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Poisoned. During your opponent's next turn, Energy cards can't be attached from your opponent's hand to that Pokémon.",
      },
      {
        name: "Rock Throw",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "115",
    nationalPokedexNumbers: [970],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/115.png",
      large: "https://images.pokemontcg.io/sv8/115_hires.png",
    },
    altArts: [
      {
        id: "sv8-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/sv8/115.png",
          large: "https://images.pokemontcg.io/sv8/115_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-50",
    name: "Gliscor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Gligar",
    attacks: [
      {
        name: "Poison Ring",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Your opponent's Active Pokémon is now Poisoned. During your opponent's next turn, that Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    flavorText:
      "If it succeeds in catching even a faint breeze properly, it can circle the globe without flapping once.",
    nationalPokedexNumbers: [472],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/50.png",
      large: "https://images.pokemontcg.io/me2/50_hires.png",
    },
    altArts: [
      {
        id: "me2-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/me2/50.png",
          large: "https://images.pokemontcg.io/me2/50_hires.png",
        },
        flavorText:
          "If it succeeds in catching even a faint breeze properly, it can circle the globe without flapping once.",
      },
    ],
  },
  {
    id: "me2-2",
    name: "Gloom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Grass"],
    evolvesFrom: "Oddish",
    evolvesTo: ["Vileplume", "Bellossom"],
    attacks: [
      {
        name: "Disperse Drool",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This attack also does 20 damage to each Benched Pokémon (both yours and your opponent's). (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    flavorText:
      "The fluid that oozes from its mouth isn't drool. It is a nectar that is used to attract prey.",
    nationalPokedexNumbers: [44],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/2.png",
      large: "https://images.pokemontcg.io/me2/2_hires.png",
    },
    altArts: [
      {
        id: "me2-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/me2/2.png",
          large: "https://images.pokemontcg.io/me2/2_hires.png",
        },
        flavorText:
          "The fluid that oozes from its mouth isn't drool. It is a nectar that is used to attract prey.",
      },
    ],
  },
  {
    id: "me4-50",
    name: "Golbat",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Darkness"],
    evolvesFrom: "Zubat",
    attacks: [
      {
        name: "Covert Flight",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Basic Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    flavorText:
      "It loves to drink other creatures' blood. It's said that if it finds others of its kind going hungry, it sometimes shares the blood it's gathered.",
    nationalPokedexNumbers: [42],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-50/small",
      large: "https://images.scrydex.com/pokemon/me4-50/large",
    },
    altArts: [
      {
        id: "me4-50",
        number: "50",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-50/small",
          large: "https://images.scrydex.com/pokemon/me4-50/large",
        },
        flavorText:
          "It loves to drink other creatures' blood. It's said that if it finds others of its kind going hungry, it sometimes shares the blood it's gathered.",
      },
    ],
  },
  {
    id: "sv6pt5-28",
    name: "Golbat",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Darkness"],
    evolvesFrom: "Zubat",
    evolvesTo: ["Crobat"],
    attacks: [
      {
        name: "Speed Dive",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Pitch-Black Blade",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "28",
    nationalPokedexNumbers: [42],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/28.png",
      large: "https://images.pokemontcg.io/sv6pt5/28_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/28.png",
          large: "https://images.pokemontcg.io/sv6pt5/28_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-13",
    name: "Goldeen",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Pierce",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "13",
    flavorText:
      "Its dorsal, pectoral, and tail fins wave elegantly in water. That is why it is known as the Water Dancer.",
    nationalPokedexNumbers: [118],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-13/small",
      large: "https://images.scrydex.com/pokemon/me5-13/large",
    },
    altArts: [
      {
        id: "me5-13",
        number: "13",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-13/small",
          large: "https://images.scrydex.com/pokemon/me5-13/large",
        },
        flavorText:
          "Its dorsal, pectoral, and tail fins wave elegantly in water. That is why it is known as the Water Dancer.",
      },
      {
        id: "me5-87",
        number: "87",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-87/small",
          large: "https://images.scrydex.com/pokemon/me5-87/large",
        },
        flavorText:
          "Its dorsal, pectoral, and tail fins wave elegantly in water. That is why it is known as the Water Dancer.",
      },
    ],
  },
  {
    id: "sv6-44",
    name: "Goldeen",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Water"],
    evolvesTo: ["Seaking"],
    abilities: [
      {
        name: "Festival Lead",
        text: "If Festival Grounds is in play, this Pokémon may use an attack it has twice. If the first attack Knocks Out your opponent's Active Pokémon, you may attack again after your opponent chooses a new Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Whirlpool",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "10",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    flavorText:
      "Its dorsal, pectoral, and tail fins wave elegantly in water. That is why it is known as the Water Dancer.",
    nationalPokedexNumbers: [118],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/44.png",
      large: "https://images.pokemontcg.io/sv6/44_hires.png",
    },
    altArts: [
      {
        id: "sv6-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv6/44.png",
          large: "https://images.pokemontcg.io/sv6/44_hires.png",
        },
        flavorText:
          "Its dorsal, pectoral, and tail fins wave elegantly in water. That is why it is known as the Water Dancer.",
      },
      {
        id: "sv8pt5-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/20.png",
          large: "https://images.pokemontcg.io/sv8pt5/20_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-40",
    name: "Golduck",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Psyduck",
    abilities: [
      {
        name: "Damp",
        text: "Pokémon in play (both yours and your opponent's) lose any Ability that requires the Pokémon using it to Knock Out itself.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hydro Pump",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60+",
        text: "This attack does 20 more damage for each Water Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    flavorText:
      "When it swims at full speed using its long, webbed limbs, its forehead somehow begins to glow.",
    nationalPokedexNumbers: [55],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-40/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-40/large",
    },
    altArts: [
      {
        id: "me2pt5-40",
        number: "40",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-40/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-40/large",
        },
        flavorText:
          "When it swims at full speed using its long, webbed limbs, its forehead somehow begins to glow.",
      },
    ],
  },
  {
    id: "zsv10pt5-42",
    name: "Golett",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    evolvesTo: ["Golurk"],
    attacks: [
      {
        name: "Best Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "42",
    flavorText:
      "The energy that burns inside it enables it to move, but no one has yet been able to identify this energy.",
    nationalPokedexNumbers: [622],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/42.png",
      large: "https://images.pokemontcg.io/zsv10pt5/42_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/42.png",
          large: "https://images.pokemontcg.io/zsv10pt5/42_hires.png",
        },
        flavorText:
          "The energy that burns inside it enables it to move, but no one has yet been able to identify this energy.",
      },
      {
        id: "zsv10pt5-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/122.png",
          large: "https://images.pokemontcg.io/zsv10pt5/122_hires.png",
        },
        flavorText:
          "The energy that burns inside it enables it to move, but no one has yet been able to identify this energy.",
      },
    ],
  },
  {
    id: "sv5-87",
    name: "Golett",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    evolvesTo: ["Golurk"],
    attacks: [
      {
        name: "Iron Defense",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage done to this Pokémon by attacks.",
      },
      {
        name: "Punch",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "87",
    flavorText:
      "They were sculpted from clay in ancient times. No one knows why, but some of them are driven to continually line up boulders.",
    nationalPokedexNumbers: [622],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/87.png",
      large: "https://images.pokemontcg.io/sv5/87_hires.png",
    },
    altArts: [
      {
        id: "sv5-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv5/87.png",
          large: "https://images.pokemontcg.io/sv5/87_hires.png",
        },
        flavorText:
          "They were sculpted from clay in ancient times. No one knows why, but some of them are driven to continually line up boulders.",
      },
    ],
  },
  {
    id: "me4-26",
    name: "Golisopod",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Water"],
    evolvesFrom: "Wimpod",
    attacks: [
      {
        name: "Critical Slash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "If your opponent's Pokémon is Knocked Out by damage from this attack, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
      {
        name: "Boundless Power",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "26",
    flavorText:
      "It will do anything to win, taking advantage of every opening and finishing opponents off with the small claws on its front legs.",
    nationalPokedexNumbers: [768],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-26/small",
      large: "https://images.scrydex.com/pokemon/me4-26/large",
    },
    altArts: [
      {
        id: "me4-26",
        number: "26",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-26/small",
          large: "https://images.scrydex.com/pokemon/me4-26/large",
        },
        flavorText:
          "It will do anything to win, taking advantage of every opening and finishing opponents off with the small claws on its front legs.",
      },
    ],
  },
  {
    id: "zsv10pt5-43",
    name: "Golurk",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "160",
    types: ["Psychic"],
    evolvesFrom: "Golett",
    attacks: [
      {
        name: "Double Smash",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80×",
        text: "Flip 2 coins. This attack does 80 damage for each heads.",
      },
      {
        name: "Golurk Hammer",
        cost: ["Psychic", "Psychic", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 5,
        damage: "200",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "43",
    flavorText:
      "It flies across the sky at Mach speeds. Removing the seal on its chest makes its internal energy go out of control.",
    nationalPokedexNumbers: [623],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/43.png",
      large: "https://images.pokemontcg.io/zsv10pt5/43_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/43.png",
          large: "https://images.pokemontcg.io/zsv10pt5/43_hires.png",
        },
        flavorText:
          "It flies across the sky at Mach speeds. Removing the seal on its chest makes its internal energy go out of control.",
      },
      {
        id: "zsv10pt5-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/123.png",
          large: "https://images.pokemontcg.io/zsv10pt5/123_hires.png",
        },
        flavorText:
          "It flies across the sky at Mach speeds. Removing the seal on its chest makes its internal energy go out of control.",
      },
    ],
  },
  {
    id: "sv5-88",
    name: "Golurk",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "160",
    types: ["Fighting"],
    evolvesFrom: "Golett",
    attacks: [
      {
        name: "Iron Defense",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage done to this Pokémon by attacks.",
      },
      {
        name: "Fighting Fist",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120+",
        text: "If your opponent's Active Pokémon is a Pokémon ex or Pokémon V, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "88",
    flavorText:
      "Artillery platforms built into the walls of ancient castles served as perches from which Golurk could fire energy beams.",
    nationalPokedexNumbers: [623],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/88.png",
      large: "https://images.pokemontcg.io/sv5/88_hires.png",
    },
    altArts: [
      {
        id: "sv5-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv5/88.png",
          large: "https://images.pokemontcg.io/sv5/88_hires.png",
        },
        flavorText:
          "Artillery platforms built into the walls of ancient castles served as perches from which Golurk could fire energy beams.",
      },
    ],
  },
  {
    id: "me4-68",
    name: "Goodra",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Dragon"],
    evolvesFrom: "Sliggoo",
    abilities: [
      {
        name: "Slimy Sliding",
        text: "When your opponent's Active Pokémon retreats, your opponent flips a coin. If tails, Energy for its Retreat Cost is not discarded, and they don't switch Pokémon. The effect of Slimy Sliding doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dragon Pulse",
        cost: ["Water", "Psychic"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "Discard the top card of your deck.",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "68",
    flavorText:
      "This very friendly dragon Pokémon will hug its beloved Trainer, leaving that Trainer covered in sticky slime.",
    nationalPokedexNumbers: [706],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-68/small",
      large: "https://images.scrydex.com/pokemon/me4-68/large",
    },
    altArts: [
      {
        id: "me4-68",
        number: "68",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-68/small",
          large: "https://images.scrydex.com/pokemon/me4-68/large",
        },
        flavorText:
          "This very friendly dragon Pokémon will hug its beloved Trainer, leaving that Trainer covered in sticky slime.",
      },
    ],
  },
  {
    id: "me4-66",
    name: "Goomy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Dragon"],
    attacks: [
      {
        name: "Absorb",
        cost: ["Water", "Psychic"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "66",
    flavorText:
      "Thanks to the slimy membrane covering its body punches or kicks from its enemies slide right off it.",
    nationalPokedexNumbers: [704],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-66/small",
      large: "https://images.scrydex.com/pokemon/me4-66/large",
    },
    altArts: [
      {
        id: "me4-66",
        number: "66",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-66/small",
          large: "https://images.scrydex.com/pokemon/me4-66/large",
        },
        flavorText:
          "Thanks to the slimy membrane covering its body punches or kicks from its enemies slide right off it.",
      },
    ],
  },
  {
    id: "sv10-56",
    name: "Gorebyss",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Clamperl",
    attacks: [
      {
        name: "Crescendo Wave",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each Water Energy attached to this Pokémon. Before doing damage, you may attach any number of Basic Water Energy cards from your hand to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "56",
    nationalPokedexNumbers: [368],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/56.png",
      large: "https://images.pokemontcg.io/sv10/56_hires.png",
    },
    altArts: [
      {
        id: "sv10-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/sv10/56.png",
          large: "https://images.pokemontcg.io/sv10/56_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-10",
    name: "Gossifleur",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Eldegoss"],
    attacks: [
      {
        name: "Double Spin",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    nationalPokedexNumbers: [829],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/10.png",
      large: "https://images.pokemontcg.io/sv7/10_hires.png",
    },
    altArts: [
      {
        id: "sv7-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv7/10.png",
          large: "https://images.pokemontcg.io/sv7/10_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-41",
    name: "Gothita",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Gothorita"],
    attacks: [
      {
        name: "Super Psy Bolt",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    flavorText:
      "Their ribbonlike feelers increase their psychic power. They are always staring at something.",
    nationalPokedexNumbers: [574],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/41.png",
      large: "https://images.pokemontcg.io/rsv10pt5/41_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/41.png",
          large: "https://images.pokemontcg.io/rsv10pt5/41_hires.png",
        },
        flavorText:
          "Their ribbonlike feelers increase their psychic power. They are always staring at something.",
      },
      {
        id: "rsv10pt5-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/124.png",
          large: "https://images.pokemontcg.io/rsv10pt5/124_hires.png",
        },
        flavorText:
          "Their ribbonlike feelers increase their psychic power. They are always staring at something.",
      },
    ],
  },
  {
    id: "rsv10pt5-43",
    name: "Gothitelle",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Psychic"],
    evolvesFrom: "Gothorita",
    abilities: [
      {
        name: "Distorted Future",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may have your opponent shuffle their hand into their deck and draw 3 cards.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Synchro Shot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90+",
        text: "If you have the same number of cards in your hand as your opponent, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    flavorText:
      "Starry skies thousands of light-years away are visible in the space distorted by their intense psychic power.",
    nationalPokedexNumbers: [576],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/43.png",
      large: "https://images.pokemontcg.io/rsv10pt5/43_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/43.png",
          large: "https://images.pokemontcg.io/rsv10pt5/43_hires.png",
        },
        flavorText:
          "Starry skies thousands of light-years away are visible in the space distorted by their intense psychic power.",
      },
    ],
  },
  {
    id: "rsv10pt5-42",
    name: "Gothorita",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Gothita",
    evolvesTo: ["Gothitelle"],
    attacks: [
      {
        name: "Fortunate Eye",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top 5 cards of your opponent's deck and put them back in any order.",
      },
      {
        name: "Psyshot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "42",
    flavorText:
      "They use hypnosis to control people and Pokémon. Tales of Gothorita leading people astray are told in every corner.",
    nationalPokedexNumbers: [575],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/42.png",
      large: "https://images.pokemontcg.io/rsv10pt5/42_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/42.png",
          large: "https://images.pokemontcg.io/rsv10pt5/42_hires.png",
        },
        flavorText:
          "They use hypnosis to control people and Pokémon. Tales of Gothorita leading people astray are told in every corner.",
      },
      {
        id: "rsv10pt5-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/125.png",
          large: "https://images.pokemontcg.io/rsv10pt5/125_hires.png",
        },
        flavorText:
          "They use hypnosis to control people and Pokémon. Tales of Gothorita leading people astray are told in every corner.",
      },
    ],
  },
  {
    id: "sv8-38",
    name: "Gouging Fire",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Lunge Out",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Blazing Charge",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If your opponent has 4 or fewer Prize cards remaining, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    nationalPokedexNumbers: [1020],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/38.png",
      large: "https://images.pokemontcg.io/sv8/38_hires.png",
    },
    altArts: [
      {
        id: "sv8-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv8/38.png",
          large: "https://images.pokemontcg.io/sv8/38_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/svp/151.png",
          large: "https://images.pokemontcg.io/svp/151_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-38",
    name: "Gouging Fire ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Ancient"],
    hp: "230",
    types: ["Fire"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Heat Blast",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
      {
        name: "Blaze Blitz",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "260",
        text: "This Pokémon can't use Blaze Blitz again until it leaves the Active Spot.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    nationalPokedexNumbers: [1020],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/38.png",
      large: "https://images.pokemontcg.io/sv5/38_hires.png",
    },
    altArts: [
      {
        id: "sv5-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv5/38.png",
          large: "https://images.pokemontcg.io/sv5/38_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-188",
        number: "188",
        images: {
          small: "https://images.pokemontcg.io/sv5/188.png",
          large: "https://images.pokemontcg.io/sv5/188_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-204",
        number: "204",
        images: {
          small: "https://images.pokemontcg.io/sv5/204.png",
          large: "https://images.pokemontcg.io/sv5/204_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-214",
        number: "214",
        images: {
          small: "https://images.pokemontcg.io/sv5/214.png",
          large: "https://images.pokemontcg.io/sv5/214_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/svp/144.png",
          large: "https://images.pokemontcg.io/svp/144_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-41",
    name: "Gourgeist ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Psychic"],
    evolvesFrom: "Pumpkaboo",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Horrifying Rondo",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "This attack does 50 more damage for each of your Benched Pokémon that has any damage counters on it.",
      },
      {
        name: "Ghostly Touch",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "140",
        text: "Discard a random card from your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "41",
    nationalPokedexNumbers: [711],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-41/small",
      large: "https://images.scrydex.com/pokemon/me4-41/large",
    },
    altArts: [
      {
        id: "me4-41",
        number: "41",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-41/small",
          large: "https://images.scrydex.com/pokemon/me4-41/large",
        },
        flavorText: "",
      },
      {
        id: "me4-102",
        number: "102",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-102/small",
          large: "https://images.scrydex.com/pokemon/me4-102/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-92",
    name: "Grafaiai",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Shroodle",
    attacks: [
      {
        name: "Miraculous Paint",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "Flip a coin. If heads, choose a Special Condition. Your opponent's Active Pokémon is now affected by that Special Condition.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "92",
    nationalPokedexNumbers: [945],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/92.png",
      large: "https://images.pokemontcg.io/me1/92_hires.png",
    },
    altArts: [
      {
        id: "me1-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/me1/92.png",
          large: "https://images.pokemontcg.io/me1/92_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-121",
    name: "Grafaiai",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Shroodle",
    attacks: [
      {
        name: "Mischievous Painting",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 3 Energy cards from your opponent's discard pile to their Pokémon in any way you like.",
      },
      {
        name: "Energized Graffiti",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "This attack does 40 damage for each Energy attached to all of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "121",
    nationalPokedexNumbers: [945],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/121.png",
      large: "https://images.pokemontcg.io/sv8/121_hires.png",
    },
    altArts: [
      {
        id: "sv8-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/sv8/121.png",
          large: "https://images.pokemontcg.io/sv8/121_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-38",
    name: "Granbull",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Snubbull",
    attacks: [
      {
        name: "Bite",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Finishing Blow",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    flavorText:
      "It is actually timid and easily spooked. If attacked, it desperately flails its limbs about in an attempt to repel its opponent.",
    nationalPokedexNumbers: [210],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/38.png",
      large: "https://images.pokemontcg.io/me2/38_hires.png",
    },
    altArts: [
      {
        id: "me2-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/me2/38.png",
          large: "https://images.pokemontcg.io/me2/38_hires.png",
        },
        flavorText:
          "It is actually timid and easily spooked. If attacked, it desperately flails its limbs about in an attempt to repel its opponent.",
      },
    ],
  },
  {
    id: "sv8-113",
    name: "Grapploct",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Clobbopus",
    attacks: [
      {
        name: "Chop",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Raging Tentacles",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "If this Pokémon has any damage counters on it, this attack can be used for Fighting.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "113",
    nationalPokedexNumbers: [853],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/113.png",
      large: "https://images.pokemontcg.io/sv8/113_hires.png",
    },
    altArts: [
      {
        id: "sv8-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/sv8/113.png",
          large: "https://images.pokemontcg.io/sv8/113_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-96",
    name: "Great Tusk",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Lunge Out",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Wrathful Charge",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If your Benched Pokémon have any damage counters on them, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "96",
    flavorText:
      "Sightings of this Pokémon have occurred in recent years. The name Great Tusk was taken from a creature listed in a certain book.",
    nationalPokedexNumbers: [984],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/96.png",
      large: "https://images.pokemontcg.io/sv5/96_hires.png",
    },
    altArts: [
      {
        id: "sv5-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/sv5/96.png",
          large: "https://images.pokemontcg.io/sv5/96_hires.png",
        },
        flavorText:
          "Sightings of this Pokémon have occurred in recent years. The name Great Tusk was taken from a creature listed in a certain book.",
      },
    ],
  },
  {
    id: "sv5-97",
    name: "Great Tusk",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Land Collapse",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Discard the top card of your opponent's deck. If you played an Ancient Supporter card from your hand during this turn, discard 3 more cards in this way.",
      },
      {
        name: "Giant Tusk",
        cost: ["Fighting", "Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "97",
    flavorText:
      "Sightings of this Pokémon have occurred in recent years. The name Great Tusk was taken from a creature listed in a certain book.",
    nationalPokedexNumbers: [984],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/97.png",
      large: "https://images.pokemontcg.io/sv5/97_hires.png",
    },
    altArts: [
      {
        id: "sv5-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv5/97.png",
          large: "https://images.pokemontcg.io/sv5/97_hires.png",
        },
        flavorText:
          "Sightings of this Pokémon have occurred in recent years. The name Great Tusk was taken from a creature listed in a certain book.",
      },
      {
        id: "sv8pt5-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/55.png",
          large: "https://images.pokemontcg.io/sv8pt5/55_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-65",
    name: "Greavard",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Take Down",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "65",
    nationalPokedexNumbers: [971],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/65.png",
      large: "https://images.pokemontcg.io/me1/65_hires.png",
    },
    altArts: [
      {
        id: "me1-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/me1/65.png",
          large: "https://images.pokemontcg.io/me1/65_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-70",
    name: "Greavard",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    attacks: [
      {
        name: "Paw Shake Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
      {
        name: "Bite",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "70",
    nationalPokedexNumbers: [971],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/70.png",
      large: "https://images.pokemontcg.io/sv7/70_hires.png",
    },
    altArts: [
      {
        id: "sv7-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv7/70.png",
          large: "https://images.pokemontcg.io/sv7/70_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-132",
    name: "Greedent",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Skwovet",
    attacks: [
      {
        name: "Gluttonous Tail",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Draw 2 cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "132",
    nationalPokedexNumbers: [820],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/132.png",
      large: "https://images.pokemontcg.io/sv9/132_hires.png",
    },
    altArts: [
      {
        id: "sv9-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/sv9/132.png",
          large: "https://images.pokemontcg.io/sv9/132_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-41",
    name: "Greninja BREAK",
    supertype: "Pokémon",
    subtypes: ["BREAK"],
    hp: "170",
    types: ["Water"],
    evolvesFrom: "Greninja",
    rules: [
      "Greninja BREAK retains the attacks, Abilities, Weakness, Resistance, and Retreat Cost of its previous Evolution.",
    ],
    abilities: [
      {
        name: "Giant Water Shuriken",
        text: "Once during your turn (before your attack), if this Pokémon is your Active Pokémon, you may discard a Water Energy card from your hand. If you do, put 6 damage counters on 1 of your opponents Pokémon.",
        type: "Ability",
      },
    ],
    number: "41",
    nationalPokedexNumbers: [658],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-41/small",
      large: "https://images.scrydex.com/pokemon/me55c-41/large",
    },
    altArts: [
      {
        id: "me55c-41",
        number: "41",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-41/small",
          large: "https://images.scrydex.com/pokemon/me55c-41/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-21",
    name: "Greninja ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "300",
    types: ["Water"],
    evolvesFrom: "Frogadier",
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Stealthy Slash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        text: "This attack does 30 damage to 1 of your opponent's Pokémon for each damage counter on that Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Aqua Edge",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "160",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    nationalPokedexNumbers: [658],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-21/small",
      large: "https://images.scrydex.com/pokemon/me55-21/large",
    },
    altArts: [
      {
        id: "me55-21",
        number: "21",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-21/small",
          large: "https://images.scrydex.com/pokemon/me55-21/large",
        },
        flavorText: "",
      },
      {
        id: "me55-148",
        number: "148",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-148/small",
          large: "https://images.scrydex.com/pokemon/me55-148/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-106",
    name: "Greninja ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "Tera", "ex"],
    hp: "310",
    types: ["Fighting"],
    evolvesFrom: "Frogadier",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Shinobi Blade",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "170",
        text: "You may search your deck for a card and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Mirage Barrage",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard 2 Energy from this Pokémon. This attack does 120 damage to 2 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "106",
    nationalPokedexNumbers: [658],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/106.png",
      large: "https://images.pokemontcg.io/sv6/106_hires.png",
    },
    altArts: [
      {
        id: "sv6-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/sv6/106.png",
          large: "https://images.pokemontcg.io/sv6/106_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-198",
        number: "198",
        images: {
          small: "https://images.pokemontcg.io/sv6/198.png",
          large: "https://images.pokemontcg.io/sv6/198_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-214",
        number: "214",
        images: {
          small: "https://images.pokemontcg.io/sv6/214.png",
          large: "https://images.pokemontcg.io/sv6/214_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-41",
    name: "Greninja ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "300",
    types: ["Water"],
    evolvesFrom: "Frogadier",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Shifting Shuriken",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100+",
        text: "Flip a coin. If heads, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "41",
    nationalPokedexNumbers: [658],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/41.png",
      large: "https://images.pokemontcg.io/sv7/41_hires.png",
    },
    altArts: [
      {
        id: "sv7-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv7/41.png",
          large: "https://images.pokemontcg.io/sv7/41_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-96",
    name: "Grimmsnarl",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Morgrem",
    attacks: [
      {
        name: "Goad 'n' Grab",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.) If you do, this attack does 160 damage to the new Active Pokémon.",
      },
      {
        name: "Knuckle Sandwich",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "96",
    nationalPokedexNumbers: [861],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/96.png",
      large: "https://images.pokemontcg.io/sv7/96_hires.png",
    },
    altArts: [
      {
        id: "sv7-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/sv7/96.png",
          large: "https://images.pokemontcg.io/sv7/96_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-73",
    name: "Grimmsnarl",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Psychic"],
    evolvesFrom: "Morgrem",
    attacks: [
      {
        name: "Shadowy Knot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "This attack does 50 damage for each Colorless in your opponent's Active Pokémon's Retreat Cost.",
      },
      {
        name: "Mega Punch",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "73",
    nationalPokedexNumbers: [861],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/73.png",
      large: "https://images.pokemontcg.io/sv9/73_hires.png",
    },
    altArts: [
      {
        id: "sv9-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv9/73.png",
          large: "https://images.pokemontcg.io/sv9/73_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-14",
    name: "Grookey",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Thwackey"],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Branch Poke",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    flavorText:
      "When it uses its special stick to strike up a beat, the sound waves produced carry revitalizing energy to the plants and flowers in the area.",
    nationalPokedexNumbers: [810],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/14.png",
      large: "https://images.pokemontcg.io/sv6/14_hires.png",
    },
    altArts: [
      {
        id: "sv6-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv6/14.png",
          large: "https://images.pokemontcg.io/sv6/14_hires.png",
        },
        flavorText:
          "When it uses its special stick to strike up a beat, the sound waves produced carry revitalizing energy to the plants and flowers in the area.",
      },
    ],
  },
  {
    id: "sv5-11",
    name: "Grotle",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Turtwig",
    evolvesTo: ["Torterra"],
    attacks: [
      {
        name: "Cut",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Ramming Shell",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "During your opponent's next turn, this Pokémon takes 20 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "11",
    flavorText:
      "It lives along water in forests. In the daytime, it leaves the forest to sunbathe its treed shell.",
    nationalPokedexNumbers: [388],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/11.png",
      large: "https://images.pokemontcg.io/sv5/11_hires.png",
    },
    altArts: [
      {
        id: "sv5-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv5/11.png",
          large: "https://images.pokemontcg.io/sv5/11_hires.png",
        },
        flavorText:
          "It lives along water in forests. In the daytime, it leaves the forest to sunbathe its treed shell.",
      },
      {
        id: "sv5-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/sv5/164.png",
          large: "https://images.pokemontcg.io/sv5/164_hires.png",
        },
        flavorText:
          "It lives along water in forests. In the daytime, it leaves the forest to sunbathe its treed shell.",
      },
    ],
  },
  {
    id: "me2pt5-108",
    name: "Groudon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
      {
        name: "Megaton Fall",
        cost: ["Fighting", "Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "108",
    flavorText:
      "Said to have expanded the lands by evaporating water with raging heat. It battled titanically with Kyogre.",
    nationalPokedexNumbers: [383],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-108/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-108/large",
    },
    altArts: [
      {
        id: "me2pt5-108",
        number: "108",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-108/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-108/large",
        },
        flavorText:
          "Said to have expanded the lands by evaporating water with raging heat. It battled titanically with Kyogre.",
      },
    ],
  },
  {
    id: "me55-82",
    name: "Groudon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Break Ground",
        cost: ["Fighting", "Fighting", "Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 5,
        damage: "250",
        text: "This attack also does 20 damage to each of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "82",
    nationalPokedexNumbers: [383],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-82/small",
      large: "https://images.scrydex.com/pokemon/me55-82/large",
    },
    altArts: [
      {
        id: "me55-82",
        number: "82",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-82/small",
          large: "https://images.scrydex.com/pokemon/me55-82/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-27",
    name: "Growlithe",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Arcanine"],
    attacks: [
      {
        name: "Live Coal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Dig Claws",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "27",
    nationalPokedexNumbers: [58],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/27.png",
      large: "https://images.pokemontcg.io/sv10/27_hires.png",
    },
    altArts: [
      {
        id: "sv10-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv10/27.png",
          large: "https://images.pokemontcg.io/sv10/27_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-17",
    name: "Grubbin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Ambush",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 30 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "17",
    flavorText:
      "It spits sticky threads and winds them around branches, then swings nimbly from tree to tree in a pendulum-like motion.",
    nationalPokedexNumbers: [736],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-17/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-17/large",
    },
    altArts: [
      {
        id: "me2pt5-17",
        number: "17",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-17/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-17/large",
        },
        flavorText:
          "It spits sticky threads and winds them around branches, then swings nimbly from tree to tree in a pendulum-like motion.",
      },
      {
        id: "sv7-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv7/9.png",
          large: "https://images.pokemontcg.io/sv7/9_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-2",
    name: "Grubbin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "String Shot",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "2",
    flavorText:
      "It spits sticky threads and winds them around branches, then swings nimbly from tree to tree in a pendulum-like motion.",
    nationalPokedexNumbers: [736],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-2/small",
      large: "https://images.scrydex.com/pokemon/me5-2/large",
    },
    altArts: [
      {
        id: "me5-2",
        number: "2",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-2/small",
          large: "https://images.scrydex.com/pokemon/me5-2/large",
        },
        flavorText:
          "It spits sticky threads and winds them around branches, then swings nimbly from tree to tree in a pendulum-like motion.",
      },
    ],
  },
  {
    id: "sv5-18",
    name: "Grubbin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Charjabug"],
    attacks: [
      {
        name: "Flock",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Grubbin and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Vise Grip",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    flavorText:
      "Its natural enemies, like Rookidee, may flee rather than risk getting caught in its large mandibles that can snap thick tree branches.",
    nationalPokedexNumbers: [736],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/18.png",
      large: "https://images.pokemontcg.io/sv5/18_hires.png",
    },
    altArts: [
      {
        id: "sv5-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv5/18.png",
          large: "https://images.pokemontcg.io/sv5/18_hires.png",
        },
        flavorText:
          "Its natural enemies, like Rookidee, may flee rather than risk getting caught in its large mandibles that can snap thick tree branches.",
      },
    ],
  },
  {
    id: "me1-63",
    name: "Grumpig",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Spoink",
    abilities: [
      {
        name: "Energized Steps",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Look at the top 4 cards of your deck and attach any number of Basic Energy cards you find there to your Pokémon in any way you like. Shuffle the other cards back into your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Psychic Sphere",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "63",
    nationalPokedexNumbers: [326],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/63.png",
      large: "https://images.pokemontcg.io/me1/63_hires.png",
    },
    altArts: [
      {
        id: "me1-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/me1/63.png",
          large: "https://images.pokemontcg.io/me1/63_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-91",
    name: "Gulpin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Swalot"],
    attacks: [
      {
        name: "Drool",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Super Poison Breath",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "91",
    nationalPokedexNumbers: [316],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/91.png",
      large: "https://images.pokemontcg.io/sv7/91_hires.png",
    },
    altArts: [
      {
        id: "sv7-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv7/91.png",
          large: "https://images.pokemontcg.io/sv7/91_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/sv7/154.png",
          large: "https://images.pokemontcg.io/sv7/154_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-110",
    name: "Gumshoos",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Yungoos",
    abilities: [
      {
        name: "Evidence Gathering",
        text: "Once during your turn, you may use this Ability. Switch a card from your hand with the top card of your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "110",
    nationalPokedexNumbers: [735],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/110.png",
      large: "https://images.pokemontcg.io/me1/110_hires.png",
    },
    altArts: [
      {
        id: "me1-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/me1/110.png",
          large: "https://images.pokemontcg.io/me1/110_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/me1/153.png",
          large: "https://images.pokemontcg.io/me1/153_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-48",
    name: "Gurdurr",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Timburr",
    evolvesTo: ["Conkeldurr"],
    attacks: [
      {
        name: "Low Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Hammer Arm",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "Discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "48",
    flavorText:
      "This Pokémon is so muscular and strongly built that even a group of wrestlers could not make it budge an inch.",
    nationalPokedexNumbers: [533],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/48.png",
      large: "https://images.pokemontcg.io/zsv10pt5/48_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/48.png",
          large: "https://images.pokemontcg.io/zsv10pt5/48_hires.png",
        },
        flavorText:
          "This Pokémon is so muscular and strongly built that even a group of wrestlers could not make it budge an inch.",
      },
      {
        id: "zsv10pt5-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/126.png",
          large: "https://images.pokemontcg.io/zsv10pt5/126_hires.png",
        },
        flavorText:
          "This Pokémon is so muscular and strongly built that even a group of wrestlers could not make it budge an inch.",
      },
    ],
  },
  {
    id: "sv6-104",
    name: "Gurdurr",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Timburr",
    evolvesTo: ["Conkeldurr"],
    attacks: [
      {
        name: "Knuckle Punch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Superpower",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50+",
        text: "You may do 30 more damage. If you do, this Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "104",
    flavorText:
      "This Pokémon is so muscular and strongly built that even a group of wrestlers could not make it budge an inch.",
    nationalPokedexNumbers: [533],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/104.png",
      large: "https://images.pokemontcg.io/sv6/104_hires.png",
    },
    altArts: [
      {
        id: "sv6-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/sv6/104.png",
          large: "https://images.pokemontcg.io/sv6/104_hires.png",
        },
        flavorText:
          "This Pokémon is so muscular and strongly built that even a group of wrestlers could not make it budge an inch.",
      },
    ],
  },
  {
    id: "me55-111",
    name: "Hakamo-o",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Dragon"],
    evolvesFrom: "Jangmo-o",
    attacks: [
      {
        name: "Sharp Fang",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
      },
      {
        name: "Dragon Claw",
        cost: ["Lightning", "Fighting"],
        convertedEnergyCost: 2,
        damage: "70",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "111",
    nationalPokedexNumbers: [783],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-111/small",
      large: "https://images.scrydex.com/pokemon/me55-111/large",
    },
    altArts: [
      {
        id: "me55-111",
        number: "111",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-111/small",
          large: "https://images.scrydex.com/pokemon/me55-111/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-73",
    name: "Hariyama",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Makuhita",
    abilities: [
      {
        name: "Heave-Ho Catcher",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Wild Press",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "This Pokémon also does 70 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "73",
    nationalPokedexNumbers: [297],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/73.png",
      large: "https://images.pokemontcg.io/me1/73_hires.png",
    },
    altArts: [
      {
        id: "me1-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/me1/73.png",
          large: "https://images.pokemontcg.io/me1/73_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-55",
    name: "Haunter",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Gastly",
    evolvesTo: ["Gengar"],
    attacks: [
      {
        name: "Spooky Shot",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    flavorText:
      "It likes to lurk in the dark and tap shoulders with a gaseous hand. Its touch causes endless shuddering.",
    nationalPokedexNumbers: [93],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/55.png",
      large: "https://images.pokemontcg.io/me2/55_hires.png",
    },
    altArts: [
      {
        id: "me2-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/me2/55.png",
          large: "https://images.pokemontcg.io/me2/55_hires.png",
        },
        flavorText:
          "It likes to lurk in the dark and tap shoulders with a gaseous hand. Its touch causes endless shuddering.",
      },
      {
        id: "me2pt5-124",
        number: "124",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-124/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-124/large",
        },
        flavorText:
          "It likes to lurk in the dark and tap shoulders with a gaseous hand. Its touch causes endless shuddering.",
      },
    ],
  },
  {
    id: "me3-49",
    name: "Haunter",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Gastly",
    attacks: [
      {
        name: "Haunt",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Place 3 damage counters on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    nationalPokedexNumbers: [93],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-49/small",
      large: "https://images.scrydex.com/pokemon/me3-49/large",
    },
    altArts: [
      {
        id: "me3-49",
        number: "49",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-49/small",
          large: "https://images.scrydex.com/pokemon/me3-49/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-103",
    name: "Haunter",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Darkness"],
    evolvesFrom: "Gastly",
    evolvesTo: ["Gengar"],
    attacks: [
      {
        name: "Super Poison Breath",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "103",
    flavorText:
      "It likes to lurk in the dark and tap shoulders with a gaseous hand. Its touch causes endless shuddering.",
    nationalPokedexNumbers: [93],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/103.png",
      large: "https://images.pokemontcg.io/sv5/103_hires.png",
    },
    altArts: [
      {
        id: "sv5-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/sv5/103.png",
          large: "https://images.pokemontcg.io/sv5/103_hires.png",
        },
        flavorText:
          "It likes to lurk in the dark and tap shoulders with a gaseous hand. Its touch causes endless shuddering.",
      },
    ],
  },
  {
    id: "me3-46",
    name: "Hawlucha",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Vengeful Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your Benched Pokémon have any damage counters on them, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    number: "46",
    nationalPokedexNumbers: [701],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-46/small",
      large: "https://images.scrydex.com/pokemon/me3-46/large",
    },
    altArts: [
      {
        id: "me3-46",
        number: "46",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-46/small",
          large: "https://images.scrydex.com/pokemon/me3-46/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-107",
    name: "Hawlucha",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Prize Count",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If you have more Prize cards remaining than your opponent, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "107",
    flavorText:
      "Hawlucha live quietly without flocking together. They fight constantly with their natural enemies: noisy groups of Primeape.",
    nationalPokedexNumbers: [701],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/107.png",
      large: "https://images.pokemontcg.io/sv6/107_hires.png",
    },
    altArts: [
      {
        id: "sv6-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/sv6/107.png",
          large: "https://images.pokemontcg.io/sv6/107_hires.png",
        },
        flavorText:
          "Hawlucha live quietly without flocking together. They fight constantly with their natural enemies: noisy groups of Primeape.",
      },
    ],
  },
  {
    id: "sv8pt5-89",
    name: "Hawlucha",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Colorless"],
    attacks: [
      {
        name: "Rising Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 50 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "89",
    nationalPokedexNumbers: [701],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/89.png",
      large: "https://images.pokemontcg.io/sv8pt5/89_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/89.png",
          large: "https://images.pokemontcg.io/sv8pt5/89_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-70",
    name: "Haxorus",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Dragon"],
    evolvesFrom: "Fraxure",
    attacks: [
      {
        name: "Cross-Cut",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80+",
        text: "If your opponent's Active Pokémon is an Evolution Pokémon, this attack does 80 more damage.",
      },
      {
        name: "Axe Blast",
        cost: ["Fighting", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "If your opponent's Active Pokémon is a Basic Pokémon, it is Knocked Out.",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "70",
    flavorText:
      "They are kind but can be relentless when defending territory. They challenge foes with tusks that can cut steel.",
    nationalPokedexNumbers: [612],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/70.png",
      large: "https://images.pokemontcg.io/zsv10pt5/70_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/70.png",
          large: "https://images.pokemontcg.io/zsv10pt5/70_hires.png",
        },
        flavorText:
          "They are kind but can be relentless when defending territory. They challenge foes with tusks that can cut steel.",
      },
      {
        id: "zsv10pt5-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/147.png",
          large: "https://images.pokemontcg.io/zsv10pt5/147_hires.png",
        },
        flavorText:
          "They are kind but can be relentless when defending territory. They challenge foes with tusks that can cut steel.",
      },
    ],
  },
  {
    id: "sv6pt5-46",
    name: "Haxorus",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Dragon"],
    evolvesFrom: "Fraxure",
    attacks: [
      {
        name: "Bring Down the Axe",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "If your opponent's Active Pokémon has any Special Energy attached, it is Knocked Out.",
      },
      {
        name: "Dragon Pulse",
        cost: ["Fighting", "Metal"],
        convertedEnergyCost: 2,
        damage: "230",
        text: "Discard the top 3 cards of your deck.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    nationalPokedexNumbers: [612],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/46.png",
      large: "https://images.pokemontcg.io/sv6pt5/46_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/46.png",
          large: "https://images.pokemontcg.io/sv6pt5/46_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-44",
    name: "Hearthflame Mask Ogerpon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fire"],
    attacks: [
      {
        name: "Fire Kagura",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Fire Energy card and attach it to 1 of your Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Searing Flame",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/44.png",
      large: "https://images.pokemontcg.io/sv10/44_hires.png",
    },
    altArts: [
      {
        id: "sv10-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv10/44.png",
          large: "https://images.pokemontcg.io/sv10/44_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-40",
    name: "Hearthflame Mask Ogerpon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "210",
    types: ["Fire"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Wrathful Hearth",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20×",
        text: "This attack does 20 damage for each damage counter on this Pokémon.",
      },
      {
        name: "Dynamic Blaze",
        cost: ["Fire", "Fire", "Fire"],
        convertedEnergyCost: 3,
        damage: "140+",
        text: "If your opponent's Active Pokémon is an Evolution Pokémon, this attack does 140 more damage, and discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/40.png",
      large: "https://images.pokemontcg.io/sv6/40_hires.png",
    },
    altArts: [
      {
        id: "sv6-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv6/40.png",
          large: "https://images.pokemontcg.io/sv6/40_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-192",
        number: "192",
        images: {
          small: "https://images.pokemontcg.io/sv6/192.png",
          large: "https://images.pokemontcg.io/sv6/192_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-212",
        number: "212",
        images: {
          small: "https://images.pokemontcg.io/sv6/212.png",
          large: "https://images.pokemontcg.io/sv6/212_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/17.png",
          large: "https://images.pokemontcg.io/sv8pt5/17_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/148.png",
          large: "https://images.pokemontcg.io/sv8pt5/148_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-43",
    name: "Heat Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Gadget Show",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each Pokémon Tool attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    nationalPokedexNumbers: [479],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/43.png",
      large: "https://images.pokemontcg.io/sv10/43_hires.png",
    },
    altArts: [
      {
        id: "sv10-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv10/43.png",
          large: "https://images.pokemontcg.io/sv10/43_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-19",
    name: "Heatmor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fire"],
    attacks: [
      {
        name: "Licking Catch",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 in any combination of Fire Pokémon and Basic Fire Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Fire Claws",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    flavorText:
      "It breathes through a hole in its tail while it burns with an internal fire. Durant is its prey.",
    nationalPokedexNumbers: [631],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/19.png",
      large: "https://images.pokemontcg.io/rsv10pt5/19_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/19.png",
          large: "https://images.pokemontcg.io/rsv10pt5/19_hires.png",
        },
        flavorText:
          "It breathes through a hole in its tail while it burns with an internal fire. Durant is its prey.",
      },
      {
        id: "rsv10pt5-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/104.png",
          large: "https://images.pokemontcg.io/rsv10pt5/104_hires.png",
        },
        flavorText:
          "It breathes through a hole in its tail while it burns with an internal fire. Durant is its prey.",
      },
    ],
  },
  {
    id: "sv5-31",
    name: "Heatmor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fire"],
    attacks: [
      {
        name: "Live Coal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Licking Flames",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Flip 3 coins. For each tails, discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    flavorText:
      "There's a hole in its tail that allows it to draw in the air it needs to keep its fire burning. If the hole gets blocked, this Pokémon will fall ill.",
    nationalPokedexNumbers: [631],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/31.png",
      large: "https://images.pokemontcg.io/sv5/31_hires.png",
    },
    altArts: [
      {
        id: "sv5-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/sv5/31.png",
          large: "https://images.pokemontcg.io/sv5/31_hires.png",
        },
        flavorText:
          "There's a hole in its tail that allows it to draw in the air it needs to keep its fire burning. If the hole gets blocked, this Pokémon will fall ill.",
      },
    ],
  },
  {
    id: "me5-7",
    name: "Heatran",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Fire"],
    attacks: [
      {
        name: "Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Lava Wall",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Burned Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "7",
    flavorText:
      "It dwells in volcanic caves. It digs in with its cross- shaped feet to crawl on ceilings and walls.",
    nationalPokedexNumbers: [485],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-7/small",
      large: "https://images.scrydex.com/pokemon/me5-7/large",
    },
    altArts: [
      {
        id: "me5-7",
        number: "7",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-7/small",
          large: "https://images.scrydex.com/pokemon/me5-7/large",
        },
        flavorText:
          "It dwells in volcanic caves. It digs in with its cross- shaped feet to crawl on ceilings and walls.",
      },
    ],
  },
  {
    id: "sv6-123",
    name: "Heatran",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Metal"],
    abilities: [
      {
        name: "Incandescent Body",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), the Attacking Pokémon is now Burned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Steel Burst",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50×",
        text: "Discard all Metal Energy from this Pokémon. This attack does 50 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "123",
    flavorText:
      "It dwells in volcanic caves. It digs in with its cross-shaped feet to crawl on ceilings and walls.",
    nationalPokedexNumbers: [485],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/123.png",
      large: "https://images.pokemontcg.io/sv6/123_hires.png",
    },
    altArts: [
      {
        id: "sv6-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/sv6/123.png",
          large: "https://images.pokemontcg.io/sv6/123_hires.png",
        },
        flavorText:
          "It dwells in volcanic caves. It digs in with its cross-shaped feet to crawl on ceilings and walls.",
      },
    ],
  },
  {
    id: "sv8pt5-68",
    name: "Heatran",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Wrack Down",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
      {
        name: "Iron Buster",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "68",
    nationalPokedexNumbers: [485],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/68.png",
      large: "https://images.pokemontcg.io/sv8pt5/68_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/68.png",
          large: "https://images.pokemontcg.io/sv8pt5/68_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-53",
    name: "Heliolisk",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Helioptile",
    attacks: [
      {
        name: "Dazzle Blast",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Head Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "53",
    nationalPokedexNumbers: [695],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/53.png",
      large: "https://images.pokemontcg.io/me1/53_hires.png",
    },
    altArts: [
      {
        id: "me1-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/me1/53.png",
          large: "https://images.pokemontcg.io/me1/53_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-64",
    name: "Heliolisk",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Helioptile",
    abilities: [
      {
        name: "Frilled Generator",
        text: "Once during your turn, if you played Canari from your hand this turn, you may use this Ability. Search your deck for up to 2 Basic Lightning Energy cards and attach them to this Pokémon. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Powerful Bolt",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70×",
        text: "Flip a coin for each Energy attached to this Pokémon. This attack does 70 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    flavorText:
      "They flare their frills and generate energy. A single Heliolisk can generate sufficient electricity to power a skyscraper.",
    nationalPokedexNumbers: [695],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-64/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-64/large",
    },
    altArts: [
      {
        id: "me2pt5-64",
        number: "64",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-64/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-64/large",
        },
        flavorText:
          "They flare their frills and generate energy. A single Heliolisk can generate sufficient electricity to power a skyscraper.",
      },
      {
        id: "me2pt5-229",
        number: "229",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-229/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-229/large",
        },
        flavorText:
          "They flare their frills and generate energy. A single Heliolisk can generate sufficient electricity to power a skyscraper.",
      },
    ],
  },
  {
    id: "sv6-71",
    name: "Heliolisk",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Lightning"],
    evolvesFrom: "Helioptile",
    attacks: [
      {
        name: "Wild Charge",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "70",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "71",
    flavorText:
      "A now-vanished desert culture treasured these Pokémon. Appropriately, when Heliolisk came to the Galar region, treasure came with them.",
    nationalPokedexNumbers: [695],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/71.png",
      large: "https://images.pokemontcg.io/sv6/71_hires.png",
    },
    altArts: [
      {
        id: "sv6-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv6/71.png",
          large: "https://images.pokemontcg.io/sv6/71_hires.png",
        },
        flavorText:
          "A now-vanished desert culture treasured these Pokémon. Appropriately, when Heliolisk came to the Galar region, treasure came with them.",
      },
      {
        id: "sv6-177",
        number: "177",
        images: {
          small: "https://images.pokemontcg.io/sv6/177.png",
          large: "https://images.pokemontcg.io/sv6/177_hires.png",
        },
        flavorText:
          "A now-vanished desert culture treasured these Pokémon. Appropriately, when Heliolisk came to the Galar region, treasure came with them.",
      },
    ],
  },
  {
    id: "sv8-155",
    name: "Heliolisk",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Helioptile",
    attacks: [
      {
        name: "Parabolic Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 4 Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Electroslug",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "155",
    nationalPokedexNumbers: [695],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/155.png",
      large: "https://images.pokemontcg.io/sv8/155_hires.png",
    },
    altArts: [
      {
        id: "sv8-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/sv8/155.png",
          large: "https://images.pokemontcg.io/sv8/155_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-52",
    name: "Helioptile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Heliolisk"],
    attacks: [
      {
        name: "Double Scratch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    nationalPokedexNumbers: [694],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/52.png",
      large: "https://images.pokemontcg.io/me1/52_hires.png",
    },
    altArts: [
      {
        id: "me1-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/me1/52.png",
          large: "https://images.pokemontcg.io/me1/52_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/me1/143.png",
          large: "https://images.pokemontcg.io/me1/143_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-63",
    name: "Helioptile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Zap Kick",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    flavorText:
      "The frills on either side of its head have cells that generate electricity when exposed to sunlight.",
    nationalPokedexNumbers: [694],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-63/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-63/large",
    },
    altArts: [
      {
        id: "me2pt5-63",
        number: "63",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-63/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-63/large",
        },
        flavorText:
          "The frills on either side of its head have cells that generate electricity when exposed to sunlight.",
      },
    ],
  },
  {
    id: "sv6-70",
    name: "Helioptile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Heliolisk"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Static Shock",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "70",
    flavorText:
      "When spread, the frills on its head act like solar panels, generating the power behind this Pokémon's electric moves.",
    nationalPokedexNumbers: [694],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/70.png",
      large: "https://images.pokemontcg.io/sv6/70_hires.png",
    },
    altArts: [
      {
        id: "sv6-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv6/70.png",
          large: "https://images.pokemontcg.io/sv6/70_hires.png",
        },
        flavorText:
          "When spread, the frills on its head act like solar panels, generating the power behind this Pokémon's electric moves.",
      },
    ],
  },
  {
    id: "sv8-154",
    name: "Helioptile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Heliolisk"],
    attacks: [
      {
        name: "Tiny Bolt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Reckless Charge",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "154",
    nationalPokedexNumbers: [694],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/154.png",
      large: "https://images.pokemontcg.io/sv8/154_hires.png",
    },
    altArts: [
      {
        id: "sv8-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/sv8/154.png",
          large: "https://images.pokemontcg.io/sv8/154_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-8",
    name: "Heracross",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Body Slam",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Seismic Toss",
        cost: ["Grass", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "8",
    flavorText:
      "With its herculean powers, it can easily throw around an object that is 100 times its own weight.",
    nationalPokedexNumbers: [214],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/8.png",
      large: "https://images.pokemontcg.io/sv6/8_hires.png",
    },
    altArts: [
      {
        id: "sv6-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv6/8.png",
          large: "https://images.pokemontcg.io/sv6/8_hires.png",
        },
        flavorText:
          "With its herculean powers, it can easily throw around an object that is 100 times its own weight.",
      },
    ],
  },
  {
    id: "rsv10pt5-75",
    name: "Herdier",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Lillipup",
    evolvesTo: ["Stoutland"],
    attacks: [
      {
        name: "Roar",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
      {
        name: "Lunge Out",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "75",
    flavorText:
      "It has black, cape-like fur that is very hard and decreases the amount of damage it receives.",
    nationalPokedexNumbers: [507],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/75.png",
      large: "https://images.pokemontcg.io/rsv10pt5/75_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/75.png",
          large: "https://images.pokemontcg.io/rsv10pt5/75_hires.png",
        },
        flavorText:
          "It has black, cape-like fur that is very hard and decreases the amount of damage it receives.",
      },
      {
        id: "rsv10pt5-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/155.png",
          large: "https://images.pokemontcg.io/rsv10pt5/155_hires.png",
        },
        flavorText:
          "It has black, cape-like fur that is very hard and decreases the amount of damage it receives.",
      },
    ],
  },
  {
    id: "me3-39",
    name: "Hippopotas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Fighting"],
    attacks: [
      {
        name: "Sand Attack",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, if the Defending Pokémon tries to use an attack, your opponent flips a coin. If tails, that attack doesn't happen.",
      },
      {
        name: "Bite",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "39",
    nationalPokedexNumbers: [449],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-39/small",
      large: "https://images.scrydex.com/pokemon/me3-39/large",
    },
    altArts: [
      {
        id: "me3-39",
        number: "39",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-39/small",
          large: "https://images.scrydex.com/pokemon/me3-39/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-105",
    name: "Hippopotas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    evolvesTo: ["Hippowdon"],
    attacks: [
      {
        name: "Push Down",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "105",
    nationalPokedexNumbers: [449],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv10/105.png",
      large: "https://images.pokemontcg.io/sv10/105_hires.png",
    },
    altArts: [
      {
        id: "sv10-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/sv10/105.png",
          large: "https://images.pokemontcg.io/sv10/105_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-52",
    name: "Hippopotas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    evolvesTo: ["Hippowdon"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "52",
    nationalPokedexNumbers: [449],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/52.png",
      large: "https://images.pokemontcg.io/sv8pt5/52_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/52.png",
          large: "https://images.pokemontcg.io/sv8pt5/52_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-40",
    name: "Hippowdon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Hippopotas",
    attacks: [
      {
        name: "Twister Spewing",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "If you played Tarragon from your hand during this turn, discard the top 3 cards of your opponent's deck.",
      },
      {
        name: "Heavy Impact",
        cost: ["Fighting", "Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "40",
    nationalPokedexNumbers: [450],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-40/small",
      large: "https://images.scrydex.com/pokemon/me3-40/large",
    },
    altArts: [
      {
        id: "me3-40",
        number: "40",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-40/small",
          large: "https://images.scrydex.com/pokemon/me3-40/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-106",
    name: "Hippowdon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "160",
    types: ["Fighting"],
    evolvesFrom: "Hippopotas",
    attacks: [
      {
        name: "Ram",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
      {
        name: "Super Sandstorm",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "This attack also does 40 damage to each Benched Pokémon that has any damage counters on it (both yours and your opponent's). (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "106",
    nationalPokedexNumbers: [450],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv10/106.png",
      large: "https://images.pokemontcg.io/sv10/106_hires.png",
    },
    altArts: [
      {
        id: "sv10-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/sv10/106.png",
          large: "https://images.pokemontcg.io/sv10/106_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-53",
    name: "Hippowdon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Hippopotas",
    attacks: [
      {
        name: "Sand Spray",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
      {
        name: "Land Crush",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "53",
    nationalPokedexNumbers: [450],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/53.png",
      large: "https://images.pokemontcg.io/sv8pt5/53_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/53.png",
          large: "https://images.pokemontcg.io/sv8pt5/53_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-100",
    name: "Hisuian Arcanine",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Hisuian Growlithe",
    attacks: [
      {
        name: "Proud Fangs",
        cost: [],
        convertedEnergyCost: 0,
        damage: "30+",
        text: "If your Benched Pokémon have any damage counters on them, this attack does 90 more damage.",
      },
      {
        name: "Searing Flame",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "100",
    flavorText:
      "Snaps at its foes with fangs cloaked in blazing flame. Despite its bulk, it deftly feints every which way, leading opponents on a deceptively merry chase as it all but dances around them.",
    nationalPokedexNumbers: [59],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/100.png",
      large: "https://images.pokemontcg.io/sv6/100_hires.png",
    },
    altArts: [
      {
        id: "sv6-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/sv6/100.png",
          large: "https://images.pokemontcg.io/sv6/100_hires.png",
        },
        flavorText:
          "Snaps at its foes with fangs cloaked in blazing flame. Despite its bulk, it deftly feints every which way, leading opponents on a deceptively merry chase as it all but dances around them.",
      },
    ],
  },
  {
    id: "sv6-99",
    name: "Hisuian Growlithe",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Arcanine"],
    attacks: [
      {
        name: "Blazing Destruction",
        cost: [],
        convertedEnergyCost: 0,
        damage: "",
        text: "Discard a Stadium in play.",
      },
      {
        name: "Take Down",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "99",
    flavorText:
      "They patrol their territory in pairs. I believe the igneous rock components in the fur of this species are the result of volcanic activity in its habitat.",
    nationalPokedexNumbers: [58],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/99.png",
      large: "https://images.pokemontcg.io/sv6/99_hires.png",
    },
    altArts: [
      {
        id: "sv6-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv6/99.png",
          large: "https://images.pokemontcg.io/sv6/99_hires.png",
        },
        flavorText:
          "They patrol their territory in pairs. I believe the igneous rock components in the fur of this species are the result of volcanic activity in its habitat.",
      },
      {
        id: "sv6-181",
        number: "181",
        images: {
          small: "https://images.pokemontcg.io/sv6/181.png",
          large: "https://images.pokemontcg.io/sv6/181_hires.png",
        },
        flavorText:
          "They patrol their territory in pairs. I believe the igneous rock components in the fur of this species are the result of volcanic activity in its habitat.",
      },
    ],
  },
  {
    id: "me55-123",
    name: "Hisuian Zoroark",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Hisuian Zorua",
    attacks: [
      {
        name: "Scratch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
      },
      {
        name: "Swirling Resentment",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        text: "Place damage counters on your opponent's Active Pokémon until its remaining HP is 50.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "123",
    nationalPokedexNumbers: [571],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-123/small",
      large: "https://images.scrydex.com/pokemon/me55-123/large",
    },
    altArts: [
      {
        id: "me55-123",
        number: "123",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-123/small",
          large: "https://images.scrydex.com/pokemon/me55-123/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-122",
    name: "Hisuian Zorua",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "122",
    nationalPokedexNumbers: [570],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-122/small",
      large: "https://images.scrydex.com/pokemon/me55-122/large",
    },
    altArts: [
      {
        id: "me55-122",
        number: "122",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-122/small",
          large: "https://images.scrydex.com/pokemon/me55-122/large",
        },
        flavorText: "",
      },
      {
        id: "me55-145",
        number: "145",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-145/small",
          large: "https://images.scrydex.com/pokemon/me55-145/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-102",
    name: "Hitmontop",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Fighting"],
    attacks: [
      {
        name: "Spin and Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Shuffle your hand into your deck. Then, draw 6 cards.",
      },
      {
        name: "Low Kick",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "102",
    flavorText:
      "It spins on its horn while dealing out elegant kicks. Its horn grows continuously through its lifetime.",
    nationalPokedexNumbers: [237],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-102/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-102/large",
    },
    altArts: [
      {
        id: "me2pt5-102",
        number: "102",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-102/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-102/large",
        },
        flavorText:
          "It spins on its horn while dealing out elegant kicks. Its horn grows continuously through its lifetime.",
      },
      {
        id: "me2pt5-240",
        number: "240",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-240/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-240/large",
        },
        flavorText:
          "It spins on its horn while dealing out elegant kicks. Its horn grows continuously through its lifetime.",
      },
    ],
  },
  {
    id: "me4-10",
    name: "Ho-Oh",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Flames of Revival",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put up to 3 Basic Pokémon from your discard pile onto your Bench.",
      },
      {
        name: "Bright Wing",
        cost: ["Fire", "Fire", "Fire"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard a Fire Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "10",
    flavorText:
      "A legend says that its body glows in seven colors. A rainbow is said to form behind it when it flies.",
    nationalPokedexNumbers: [250],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-10/small",
      large: "https://images.scrydex.com/pokemon/me4-10/large",
    },
    altArts: [
      {
        id: "me4-10",
        number: "10",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-10/small",
          large: "https://images.scrydex.com/pokemon/me4-10/large",
        },
        flavorText:
          "A legend says that its body glows in seven colors. A rainbow is said to form behind it when it flies.",
      },
    ],
  },
  {
    id: "me55-12",
    name: "Ho-Oh",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Sacred Breath",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        text: "Discard all Energy from this Pokémon. Heal all damage from 1 of your Benched Pokémon.",
      },
      {
        name: "Fire Wing",
        cost: ["Fire", "Fire", "Fire"],
        convertedEnergyCost: 3,
        damage: "100",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "12",
    nationalPokedexNumbers: [250],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-12/small",
      large: "https://images.scrydex.com/pokemon/me55-12/large",
    },
    altArts: [
      {
        id: "me55-12",
        number: "12",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-12/small",
          large: "https://images.scrydex.com/pokemon/me55-12/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-19",
    name: "Ho-Oh",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Flap",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Shining Blaze",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If you have any Tera Pokémon on your Bench, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    nationalPokedexNumbers: [250],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/19.png",
      large: "https://images.pokemontcg.io/sv8/19_hires.png",
    },
    altArts: [
      {
        id: "sv8-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv8/19.png",
          large: "https://images.pokemontcg.io/sv8/19_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-58",
    name: "Honchkrow",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Murkrow",
    attacks: [
      {
        name: "Wind of Darkness",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Sniping Feathers",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard 2 Energy from this Pokémon, and this attack does 120 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    flavorText:
      "It is merciless by nature. It is said that it never forgives the mistakes of its Murkrow followers.",
    nationalPokedexNumbers: [430],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/58.png",
      large: "https://images.pokemontcg.io/me2/58_hires.png",
    },
    altArts: [
      {
        id: "me2-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/me2/58.png",
          large: "https://images.pokemontcg.io/me2/58_hires.png",
        },
        flavorText:
          "It is merciless by nature. It is said that it never forgives the mistakes of its Murkrow followers.",
      },
    ],
  },
  {
    id: "me3-56",
    name: "Honedge",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Cut",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "56",
    nationalPokedexNumbers: [679],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-56/small",
      large: "https://images.scrydex.com/pokemon/me3-56/large",
    },
    altArts: [
      {
        id: "me3-56",
        number: "56",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-56/small",
          large: "https://images.scrydex.com/pokemon/me3-56/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-141",
    name: "Hoopa",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Darkness"],
    attacks: [
      {
        name: "Filch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Knuckle Impact",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "141",
    flavorText:
      "This troublemaker sends anything and everything to faraway places using its loop, which can warp space.",
    nationalPokedexNumbers: [720],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-141/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-141/large",
    },
    altArts: [
      {
        id: "me2pt5-141",
        number: "141",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-141/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-141/large",
        },
        flavorText:
          "This troublemaker sends anything and everything to faraway places using its loop, which can warp space.",
      },
    ],
  },
  {
    id: "sv5-126",
    name: "Hoothoot",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Noctowl"],
    attacks: [
      {
        name: "Silent Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Your opponent reveals their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "126",
    flavorText:
      "It always stands on one foot. It changes feet so fast, the movement can rarely be seen.",
    nationalPokedexNumbers: [163],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/126.png",
      large: "https://images.pokemontcg.io/sv5/126_hires.png",
    },
    altArts: [
      {
        id: "sv5-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/sv5/126.png",
          large: "https://images.pokemontcg.io/sv5/126_hires.png",
        },
        flavorText:
          "It always stands on one foot. It changes feet so fast, the movement can rarely be seen.",
      },
    ],
  },
  {
    id: "sv7-114",
    name: "Hoothoot",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Noctowl"],
    attacks: [
      {
        name: "Triple Stab",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 3 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "114",
    nationalPokedexNumbers: [163],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/114.png",
      large: "https://images.pokemontcg.io/sv7/114_hires.png",
    },
    altArts: [
      {
        id: "sv7-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/sv7/114.png",
          large: "https://images.pokemontcg.io/sv7/114_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-77",
    name: "Hoothoot",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Colorless"],
    evolvesTo: ["Noctowl"],
    abilities: [
      {
        name: "Insomnia",
        text: "This Pokémon can't be Asleep.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "77",
    nationalPokedexNumbers: [163],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/77.png",
      large: "https://images.pokemontcg.io/sv8pt5/77_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/77.png",
          large: "https://images.pokemontcg.io/sv8pt5/77_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-108",
    name: "Hop's Corviknight",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Metal"],
    evolvesFrom: "Hop's Corvisquire",
    attacks: [
      {
        name: "Shoot Through",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "This attack also does 50 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Steel Wing",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "During your opponent's next turn, this Pokémon takes 60 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "108",
    nationalPokedexNumbers: [823],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/108.png",
      large: "https://images.pokemontcg.io/sv9/108_hires.png",
    },
    altArts: [
      {
        id: "sv9-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/sv9/108.png",
          large: "https://images.pokemontcg.io/sv9/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-134",
    name: "Hop's Corvisquire",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Hop's Rookidee",
    evolvesTo: ["Corviknight"],
    attacks: [
      {
        name: "Speed Dive",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Razor Wing",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "134",
    nationalPokedexNumbers: [822],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/134.png",
      large: "https://images.pokemontcg.io/sv9/134_hires.png",
    },
    altArts: [
      {
        id: "sv9-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/sv9/134.png",
          large: "https://images.pokemontcg.io/sv9/134_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-177",
    name: "Hop's Cramorant",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Colorless"],
    attacks: [
      {
        name: "Fickle Spitting",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "120",
        text: "If your opponent doesn't have exactly 3 or 4 Prize cards remaining, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "177",
    flavorText:
      "Cramorant instinctively swallow everything whole. They’re at their most formidable when they’re struggling to swallow overly large prey.",
    nationalPokedexNumbers: [845],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-177/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-177/large",
    },
    altArts: [
      {
        id: "me2pt5-177",
        number: "177",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-177/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-177/large",
        },
        flavorText:
          "Cramorant instinctively swallow everything whole. They’re at their most formidable when they’re struggling to swallow overly large prey.",
      },
      {
        id: "sv9-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/sv9/138.png",
          large: "https://images.pokemontcg.io/sv9/138_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-136",
    name: "Hop's Dubwool",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Hop's Wooloo",
    abilities: [
      {
        name: "Defiant Horn",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "136",
    nationalPokedexNumbers: [832],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/136.png",
      large: "https://images.pokemontcg.io/sv9/136_hires.png",
    },
    altArts: [
      {
        id: "sv9-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/sv9/136.png",
          large: "https://images.pokemontcg.io/sv9/136_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-95",
    name: "Hop's Phantump",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Splashing Dodge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "95",
    flavorText:
      "According to old tales, these Pokémon are stumps possessed by the spirits of children who died while lost in the forest.",
    nationalPokedexNumbers: [708],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-95/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-95/large",
    },
    altArts: [
      {
        id: "me2pt5-95",
        number: "95",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-95/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-95/large",
        },
        flavorText:
          "According to old tales, these Pokémon are stumps possessed by the spirits of children who died while lost in the forest.",
      },
    ],
  },
  {
    id: "me2pt5-68",
    name: "Hop's Pincurchin ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "200",
    types: ["Lightning"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Counterattack Quills",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), place 3 damage counters on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Spiky Thunder",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Draw 2 cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "68",
    nationalPokedexNumbers: [871],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-68/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-68/large",
    },
    altArts: [
      {
        id: "me2pt5-68",
        number: "68",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-68/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-68/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-133",
    name: "Hop's Rookidee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Corvisquire"],
    attacks: [
      {
        name: "Intimidating Stare",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 20 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Peck",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "133",
    nationalPokedexNumbers: [821],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/133.png",
      large: "https://images.pokemontcg.io/sv9/133_hires.png",
    },
    altArts: [
      {
        id: "sv9-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/sv9/133.png",
          large: "https://images.pokemontcg.io/sv9/133_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-87",
    name: "Hop's Sandaconda",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Hop's Silicobra",
    attacks: [
      {
        name: "Rumble",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Break Ground",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "This attack also does 20 damage to each of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "87",
    nationalPokedexNumbers: [844],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/87.png",
      large: "https://images.pokemontcg.io/sv9/87_hires.png",
    },
    altArts: [
      {
        id: "sv9-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv9/87.png",
          large: "https://images.pokemontcg.io/sv9/87_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-86",
    name: "Hop's Silicobra",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Sandaconda"],
    attacks: [
      {
        name: "Turf Maker",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Stadium card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Gnaw",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "86",
    nationalPokedexNumbers: [843],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/86.png",
      large: "https://images.pokemontcg.io/sv9/86_hires.png",
    },
    altArts: [
      {
        id: "sv9-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv9/86.png",
          large: "https://images.pokemontcg.io/sv9/86_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-117",
    name: "Hop's Snorlax",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "150",
    types: ["Colorless"],
    abilities: [
      {
        name: "Extra Helpings",
        text: "Attacks used by your Hop's Pokémon do 30 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance). The effect of Extra Helpings doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dynamic Press",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "This Pokémon also does 80 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "117",
    nationalPokedexNumbers: [143],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/117.png",
      large: "https://images.pokemontcg.io/sv9/117_hires.png",
    },
    altArts: [
      {
        id: "sv9-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/sv9/117.png",
          large: "https://images.pokemontcg.io/sv9/117_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-96",
    name: "Hop's Trevenant",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Hop's Phantump",
    attacks: [
      {
        name: "Horrifying Revenge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If any of your Hop's Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 100 more damage.",
      },
      {
        name: "Corner",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "96",
    flavorText:
      "Using its roots as a nervous system, it controls the trees in the forest. It’s kind to the Pokémon that reside in its body.",
    nationalPokedexNumbers: [709],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-96/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-96/large",
    },
    altArts: [
      {
        id: "me2pt5-96",
        number: "96",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-96/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-96/large",
        },
        flavorText:
          "Using its roots as a nervous system, it controls the trees in the forest. It’s kind to the Pokémon that reside in its body.",
      },
      {
        id: "me2pt5-237",
        number: "237",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-237/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-237/large",
        },
        flavorText:
          "Using its roots as a nervous system, it controls the trees in the forest. It’s kind to the Pokémon that reside in its body.",
      },
    ],
  },
  {
    id: "sv9-135",
    name: "Hop's Wooloo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Dubwool"],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "135",
    nationalPokedexNumbers: [831],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/135.png",
      large: "https://images.pokemontcg.io/sv9/135_hires.png",
    },
    altArts: [
      {
        id: "sv9-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/sv9/135.png",
          large: "https://images.pokemontcg.io/sv9/135_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/sv9/170.png",
          large: "https://images.pokemontcg.io/sv9/170_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-111",
    name: "Hop's Zacian ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Metal"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Insta-Strike",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Brave Slash",
        cost: ["Metal", "Metal", "Metal", "Colorless"],
        convertedEnergyCost: 4,
        damage: "240",
        text: "During your next turn, this Pokémon can't use Brave Slash.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "111",
    nationalPokedexNumbers: [888],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/111.png",
      large: "https://images.pokemontcg.io/sv9/111_hires.png",
    },
    altArts: [
      {
        id: "sv9-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/sv9/111.png",
          large: "https://images.pokemontcg.io/sv9/111_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-176",
        number: "176",
        images: {
          small: "https://images.pokemontcg.io/sv9/176.png",
          large: "https://images.pokemontcg.io/sv9/176_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-186",
        number: "186",
        images: {
          small: "https://images.pokemontcg.io/sv9/186.png",
          large: "https://images.pokemontcg.io/sv9/186_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-10",
    name: "Horsea",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Seadra"],
    attacks: [
      {
        name: "Hold Still",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 30 damage from this Pokémon.",
      },
      {
        name: "Razor Fin",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    nationalPokedexNumbers: [116],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/10.png",
      large: "https://images.pokemontcg.io/sv6pt5/10_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/10.png",
          large: "https://images.pokemontcg.io/sv6pt5/10_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/67.png",
          large: "https://images.pokemontcg.io/sv6pt5/67_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-8",
    name: "Houndoom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Houndour",
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Snarl",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 100 less damage (before applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "8",
    nationalPokedexNumbers: [229],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/8.png",
      large: "https://images.pokemontcg.io/sv6pt5/8_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/8.png",
          large: "https://images.pokemontcg.io/sv6pt5/8_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/66.png",
          large: "https://images.pokemontcg.io/sv6pt5/66_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-63",
    name: "Houndoom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Houndour",
    attacks: [
      {
        name: "Call to Muster",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards and attach them to your Pokémon in any way you like. Then, shuffle your deck.",
      },
      {
        name: "Pitch-Black Fangs",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    nationalPokedexNumbers: [229],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/63.png",
      large: "https://images.pokemontcg.io/sv8pt5/63_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/63.png",
          large: "https://images.pokemontcg.io/sv8pt5/63_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-7",
    name: "Houndour",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Houndoom"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
      {
        name: "Rear Kick",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    nationalPokedexNumbers: [228],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/7.png",
      large: "https://images.pokemontcg.io/sv6pt5/7_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/7.png",
          large: "https://images.pokemontcg.io/sv6pt5/7_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-62",
    name: "Houndour",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Houndoom"],
    attacks: [
      {
        name: "Playful Kick",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    nationalPokedexNumbers: [228],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/62.png",
      large: "https://images.pokemontcg.io/sv8pt5/62_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/62.png",
          large: "https://images.pokemontcg.io/sv8pt5/62_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-66",
    name: "Houndstone",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Greavard",
    attacks: [
      {
        name: "Horrifying Bite",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin until you get tails. For each heads, choose a random card from your opponent's hand. Your opponent reveals those cards and shuffles them into their deck.",
      },
      {
        name: "Hammer In",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "66",
    nationalPokedexNumbers: [972],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/66.png",
      large: "https://images.pokemontcg.io/me1/66_hires.png",
    },
    altArts: [
      {
        id: "me1-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/me1/66.png",
          large: "https://images.pokemontcg.io/me1/66_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/me1/145.png",
          large: "https://images.pokemontcg.io/me1/145_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-162",
    name: "Houndstone ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Psychic"],
    evolvesFrom: "Greavard",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Horrifying Fang",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "Flip a coin until you get tails. This attack does 20 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "162",
    nationalPokedexNumbers: [972],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/162.png",
      large: "https://images.pokemontcg.io/svp/162_hires.png",
    },
    altArts: [
      {
        id: "svp-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/svp/162.png",
          large: "https://images.pokemontcg.io/svp/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-55",
    name: "Huntail",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Clamperl",
    abilities: [
      {
        name: "Diver's Catch",
        text: "When 1 of your Water Pokémon is Knocked Out by damage from an attack from your opponent's Pokémon, you may put all Basic Water Energy attached to that Pokémon into your hand instead of the discard pile.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Wave Splash",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    nationalPokedexNumbers: [367],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/55.png",
      large: "https://images.pokemontcg.io/sv10/55_hires.png",
    },
    altArts: [
      {
        id: "sv10-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv10/55.png",
          large: "https://images.pokemontcg.io/sv10/55_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-18",
    name: "Hydrapple",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Grass"],
    evolvesFrom: "Dipplin",
    attacks: [
      {
        name: "Hydra Breath",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard 6 Basic Grass Energy cards from your hand, and Knock Out your opponent's Active Pokémon. If you can't discard 6 cards in this way, this attack does nothing.",
      },
      {
        name: "Whip Smash",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "18",
    nationalPokedexNumbers: [1019],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/18.png",
      large: "https://images.pokemontcg.io/sv10/18_hires.png",
    },
    altArts: [
      {
        id: "sv10-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv10/18.png",
          large: "https://images.pokemontcg.io/sv10/18_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-188",
        number: "188",
        images: {
          small: "https://images.pokemontcg.io/sv10/188.png",
          large: "https://images.pokemontcg.io/sv10/188_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-14",
    name: "Hydrapple ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "330",
    types: ["Grass"],
    evolvesFrom: "Dipplin",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Ripening Charge",
        text: "Once during your turn, you may attach a Basic Grass Energy card from your hand to 1 of your Pokémon. If you attached Energy to a Pokémon in this way, heal 30 damage from that Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Syrup Storm",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "This attack does 30 more damage for each Grass Energy attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "14",
    nationalPokedexNumbers: [1019],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/14.png",
      large: "https://images.pokemontcg.io/sv7/14_hires.png",
    },
    altArts: [
      {
        id: "sv7-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv7/14.png",
          large: "https://images.pokemontcg.io/sv7/14_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/sv7/156.png",
          large: "https://images.pokemontcg.io/sv7/156_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/sv7/167.png",
          large: "https://images.pokemontcg.io/sv7/167_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/11.png",
          large: "https://images.pokemontcg.io/sv8pt5/11_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-99",
    name: "Hydreigon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Zweilous",
    attacks: [
      {
        name: "Three-Headed Bite",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        text: "Flip 3 coins. For each heads, discard an Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Pitch-Black Fangs",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "140",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "99",
    nationalPokedexNumbers: [635],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-99/small",
      large: "https://images.scrydex.com/pokemon/me55-99/large",
    },
    altArts: [
      {
        id: "me55-99",
        number: "99",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-99/small",
          large: "https://images.scrydex.com/pokemon/me55-99/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-67",
    name: "Hydreigon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "330",
    types: ["Darkness"],
    evolvesFrom: "Zweilous",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Greedy Eater",
        text: "If your opponent's Basic Pokémon is Knocked Out by damage from an attack used by this Pokémon, take 1 more Prize card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dark Bite",
        cost: ["Darkness", "Darkness", "Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 5,
        damage: "200",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "67",
    nationalPokedexNumbers: [635],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/67.png",
      large: "https://images.pokemontcg.io/rsv10pt5/67_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/67.png",
          large: "https://images.pokemontcg.io/rsv10pt5/67_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/161.png",
          large: "https://images.pokemontcg.io/rsv10pt5/161_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/169.png",
          large: "https://images.pokemontcg.io/rsv10pt5/169_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-119",
    name: "Hydreigon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "Tera", "ex"],
    hp: "330",
    types: ["Darkness"],
    evolvesFrom: "Zweilous",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Crashing Headbutt",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "200",
        text: "Discard the top 3 cards of your opponent's deck.",
      },
      {
        name: "Obsidian",
        cost: ["Psychic", "Darkness", "Metal", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130",
        text: "This attack also does 130 damage to 2 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "119",
    nationalPokedexNumbers: [635],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/119.png",
      large: "https://images.pokemontcg.io/sv8/119_hires.png",
    },
    altArts: [
      {
        id: "sv8-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/sv8/119.png",
          large: "https://images.pokemontcg.io/sv8/119_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-223",
        number: "223",
        images: {
          small: "https://images.pokemontcg.io/sv8/223.png",
          large: "https://images.pokemontcg.io/sv8/223_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-240",
        number: "240",
        images: {
          small: "https://images.pokemontcg.io/sv8/240.png",
          large: "https://images.pokemontcg.io/sv8/240_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-17",
    name: "Hypno",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Psychic"],
    evolvesFrom: "Drowzee",
    attacks: [
      {
        name: "Daydream",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "During your opponent's next turn, if they attach an Energy card from their hand to the Defending Pokémon, their turn ends.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "17",
    nationalPokedexNumbers: [97],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/17.png",
      large: "https://images.pokemontcg.io/sv6pt5/17_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/17.png",
          large: "https://images.pokemontcg.io/sv6pt5/17_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-120",
    name: "Igglybuff",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Colorless"],
    attacks: [
      {
        name: "Bouncy Circle",
        cost: [],
        convertedEnergyCost: 0,
        damage: "30×",
        text: "This attack does 30 damage for each of your Benched Pokémon that has a maximum HP of 30.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "120",
    nationalPokedexNumbers: [174],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-120/small",
      large: "https://images.scrydex.com/pokemon/me55-120/large",
    },
    altArts: [
      {
        id: "me55-120",
        number: "120",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-120/small",
          large: "https://images.scrydex.com/pokemon/me55-120/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-4",
    name: "Illumise",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    abilities: [
      {
        name: "Supereffective Pheromones",
        text: "If you have Volbeat in play, apply Weakness for both Active Pokémon as x3",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Ram",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    nationalPokedexNumbers: [314],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-4/small",
      large: "https://images.scrydex.com/pokemon/me55-4/large",
    },
    altArts: [
      {
        id: "me55-4",
        number: "4",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-4/small",
          large: "https://images.scrydex.com/pokemon/me55-4/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-10",
    name: "Illumise",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Slowing Perfume",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "You can use this attack only if you go second, and only during your first turn. Shuffle 1 of your opponent's Benched Pokémon and all attached cards into their deck.",
      },
      {
        name: "Glide",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    flavorText:
      "It guides Volbeat to draw signs in the night sky. There are scholars who research the meaning of these signs.",
    nationalPokedexNumbers: [314],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/10.png",
      large: "https://images.pokemontcg.io/sv6/10_hires.png",
    },
    altArts: [
      {
        id: "sv6-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv6/10.png",
          large: "https://images.pokemontcg.io/sv6/10_hires.png",
        },
        flavorText:
          "It guides Volbeat to draw signs in the night sky. There are scholars who research the meaning of these signs.",
      },
    ],
  },
  {
    id: "sv7-94",
    name: "Impidimp",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Morgrem"],
    attacks: [
      {
        name: "Smack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Claw Slash",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "94",
    nationalPokedexNumbers: [859],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/94.png",
      large: "https://images.pokemontcg.io/sv7/94_hires.png",
    },
    altArts: [
      {
        id: "sv7-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv7/94.png",
          large: "https://images.pokemontcg.io/sv7/94_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-71",
    name: "Impidimp",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Morgrem"],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "71",
    nationalPokedexNumbers: [859],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/71.png",
      large: "https://images.pokemontcg.io/sv9/71_hires.png",
    },
    altArts: [
      {
        id: "sv9-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv9/71.png",
          large: "https://images.pokemontcg.io/sv9/71_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-34",
    name: "Incineroar ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Fire"],
    evolvesFrom: "Torracat",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Hustle Play",
        text: "Attacks used by this Pokémon cost Colorless less for each of your opponent's Benched Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Blaze Blast",
        cost: ["Fire", "Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 5,
        damage: "240",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    nationalPokedexNumbers: [727],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/34.png",
      large: "https://images.pokemontcg.io/sv5/34_hires.png",
    },
    altArts: [
      {
        id: "sv5-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv5/34.png",
          large: "https://images.pokemontcg.io/sv5/34_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-187",
        number: "187",
        images: {
          small: "https://images.pokemontcg.io/sv5/187.png",
          large: "https://images.pokemontcg.io/sv5/187_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-93",
    name: "Indeedee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Psychic"],
    abilities: [
      {
        name: "Obliging Heal",
        text: "When you play this Pokémon from your hand onto your Bench during your turn, you may heal 30 damage from your Active Pokémon and have it recover from a Special Condition.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Super Psy Bolt",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "93",
    nationalPokedexNumbers: [876],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/93.png",
      large: "https://images.pokemontcg.io/sv8/93_hires.png",
    },
    altArts: [
      {
        id: "sv8-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv8/93.png",
          large: "https://images.pokemontcg.io/sv8/93_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/svp/154.png",
          large: "https://images.pokemontcg.io/svp/154_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-33",
    name: "Infernape",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Monferno",
    abilities: [
      {
        name: "Pyro Dance",
        text: "Once during your turn, you may attach a Basic Fire Energy card, a Basic Fighting Energy card, or 1 of each from your hand to your Pokémon in any way you like.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Scorching Fire",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    flavorText:
      "Its crown of fire is indicative of its fiery nature. It is beaten by none in terms of quickness.",
    nationalPokedexNumbers: [392],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/33.png",
      large: "https://images.pokemontcg.io/sv6/33_hires.png",
    },
    altArts: [
      {
        id: "sv6-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/sv6/33.png",
          large: "https://images.pokemontcg.io/sv6/33_hires.png",
        },
        flavorText:
          "Its crown of fire is indicative of its fiery nature. It is beaten by none in terms of quickness.",
      },
      {
        id: "sv6-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/sv6/173.png",
          large: "https://images.pokemontcg.io/sv6/173_hires.png",
        },
        flavorText:
          "Its crown of fire is indicative of its fiery nature. It is beaten by none in terms of quickness.",
      },
      {
        id: "svp-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/svp/116.png",
          large: "https://images.pokemontcg.io/svp/116_hires.png",
        },
        flavorText:
          "Its crown of fire is indicative of its fiery nature. It is beaten by none in terms of quickness.",
      },
    ],
  },
  {
    id: "me5-51",
    name: "Inkay",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    attacks: [
      {
        name: "Procurement",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for an Item card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Spinning Attack",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    flavorText:
      "It drains foes' will to fight by flashing light at them. It then takes the opportunity to hide itself away.",
    nationalPokedexNumbers: [686],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-51/small",
      large: "https://images.scrydex.com/pokemon/me5-51/large",
    },
    altArts: [
      {
        id: "me5-51",
        number: "51",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-51/small",
          large: "https://images.scrydex.com/pokemon/me5-51/large",
        },
        flavorText:
          "It drains foes' will to fight by flashing light at them. It then takes the opportunity to hide itself away.",
      },
    ],
  },
  {
    id: "sv6pt5-33",
    name: "Inkay",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Malamar"],
    attacks: [
      {
        name: "Mischievous Tentacles",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top card of your opponent's deck. You may have your opponent shuffle their deck.",
      },
      {
        name: "Peck",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    nationalPokedexNumbers: [686],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/33.png",
      large: "https://images.pokemontcg.io/sv6pt5/33_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/33.png",
          large: "https://images.pokemontcg.io/sv6pt5/33_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-41",
    name: "Inteleon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "Drizzile",
    attacks: [
      {
        name: "Bring Down",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Choose a Pokémon in play (yours or your opponent's) that has the least HP remaining, except for this Pokémon, and it is Knocked Out.",
      },
      {
        name: "Water Shot",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "110",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    nationalPokedexNumbers: [818],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/41.png",
      large: "https://images.pokemontcg.io/me1/41_hires.png",
    },
    altArts: [
      {
        id: "me1-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/me1/41.png",
          large: "https://images.pokemontcg.io/me1/41_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/me1/142.png",
          large: "https://images.pokemontcg.io/me1/142_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-70",
    name: "Iono's Bellibolt ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "280",
    types: ["Lightning"],
    evolvesFrom: "Iono's Tadbulb",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Electric Streamer",
        text: "As often as you like during your turn, you may attach a Basic Lightning Energy card from your hand to 1 of your Iono's Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Thunderous Bolt",
        cost: ["Lightning", "Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 4,
        damage: "230",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "70",
    nationalPokedexNumbers: [939],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-70/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-70/large",
    },
    altArts: [
      {
        id: "me2pt5-70",
        number: "70",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-70/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-70/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-279",
        number: "279",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-279/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-279/large",
        },
        flavorText: "",
      },
      {
        id: "sv9-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv9/53.png",
          large: "https://images.pokemontcg.io/sv9/53_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/sv9/172.png",
          large: "https://images.pokemontcg.io/sv9/172_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-183",
        number: "183",
        images: {
          small: "https://images.pokemontcg.io/sv9/183.png",
          large: "https://images.pokemontcg.io/sv9/183_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-188",
        number: "188",
        images: {
          small: "https://images.pokemontcg.io/sv9/188.png",
          large: "https://images.pokemontcg.io/sv9/188_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-48",
    name: "Iono's Electrode",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Lightning"],
    evolvesFrom: "Iono's Voltorb",
    attacks: [
      {
        name: "Thump-Thump Boom",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This Pokémon does 100 damage to itself. Flip a coin. If heads, your opponent's Active Pokémon is Knocked Out.",
      },
      {
        name: "Electric Ball",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "48",
    nationalPokedexNumbers: [101],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/48.png",
      large: "https://images.pokemontcg.io/sv9/48_hires.png",
    },
    altArts: [
      {
        id: "sv9-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv9/48.png",
          large: "https://images.pokemontcg.io/sv9/48_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-72",
    name: "Iono's Kilowattrel",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Iono's Wattrel",
    abilities: [
      {
        name: "Flashing Draw",
        text: "You must discard a Basic Lightning Energy from this Pokémon in order to use this Ability. Once during your turn, you may draw cards until you have 6 cards in your hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mach Bolt",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    flavorText:
      "Kilowattrel inflates its throat sac to amplify its electricity. By riding the wind, this Pokémon can fly over 430 miles in a day.",
    nationalPokedexNumbers: [940],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-72/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-72/large",
    },
    altArts: [
      {
        id: "me2pt5-72",
        number: "72",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-72/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-72/large",
        },
        flavorText:
          "Kilowattrel inflates its throat sac to amplify its electricity. By riding the wind, this Pokémon can fly over 430 miles in a day.",
      },
      {
        id: "sv9-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv9/55.png",
          large: "https://images.pokemontcg.io/sv9/55_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/sv9/163.png",
          large: "https://images.pokemontcg.io/sv9/163_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-69",
    name: "Iono's Tadbulb",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Tiny Charge",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "69",
    flavorText:
      "Tadbulb shakes its tail to generate electricity. If it senses danger, it will make its head blink on and off to alert its allies.",
    nationalPokedexNumbers: [938],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-69/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-69/large",
    },
    altArts: [
      {
        id: "me2pt5-69",
        number: "69",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-69/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-69/large",
        },
        flavorText:
          "Tadbulb shakes its tail to generate electricity. If it senses danger, it will make its head blink on and off to alert its allies.",
      },
      {
        id: "sv9-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv9/52.png",
          large: "https://images.pokemontcg.io/sv9/52_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-47",
    name: "Iono's Voltorb",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Electrode"],
    attacks: [
      {
        name: "Voltaic Chain",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 20 more damage for each Lightning Energy attached to all of your Iono's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "47",
    nationalPokedexNumbers: [100],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/47.png",
      large: "https://images.pokemontcg.io/sv9/47_hires.png",
    },
    altArts: [
      {
        id: "sv9-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv9/47.png",
          large: "https://images.pokemontcg.io/sv9/47_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-71",
    name: "Iono's Wattrel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Quick Attack",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "71",
    flavorText:
      "When its wings catch the wind, the bones within produce electricity. This Pokémon dives into the ocean, catching prey by electrocuting them.",
    nationalPokedexNumbers: [940],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-71/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-71/large",
    },
    altArts: [
      {
        id: "me2pt5-71",
        number: "71",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-71/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-71/large",
        },
        flavorText:
          "When its wings catch the wind, the bones within produce electricity. This Pokémon dives into the ocean, catching prey by electrocuting them.",
      },
      {
        id: "me2pt5-231",
        number: "231",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-231/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-231/large",
        },
        flavorText:
          "When its wings catch the wind, the bones within produce electricity. This Pokémon dives into the ocean, catching prey by electrocuting them.",
      },
      {
        id: "sv9-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv9/54.png",
          large: "https://images.pokemontcg.io/sv9/54_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-71",
    name: "Iron Boulder",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "140",
    types: ["Psychic"],
    attacks: [
      {
        name: "Adjusted Horn",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "170",
        text: "If you don't have the same number of cards in your hand as your opponent, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "71",
    nationalPokedexNumbers: [1022],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/71.png",
      large: "https://images.pokemontcg.io/sv7/71_hires.png",
    },
    altArts: [
      {
        id: "sv7-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv7/71.png",
          large: "https://images.pokemontcg.io/sv7/71_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/46.png",
          large: "https://images.pokemontcg.io/sv8pt5/46_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-99",
    name: "Iron Boulder ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Future"],
    hp: "240",
    types: ["Fighting"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Repulsor Axe",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "During your opponent's next turn, if this Pokémon is damaged by an attack (even if it is Knocked Out), put 8 damage counters on the Attacking Pokémon.",
      },
      {
        name: "Power Stomp",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "99",
    nationalPokedexNumbers: [1022],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/99.png",
      large: "https://images.pokemontcg.io/sv5/99_hires.png",
    },
    altArts: [
      {
        id: "sv5-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv5/99.png",
          large: "https://images.pokemontcg.io/sv5/99_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-192",
        number: "192",
        images: {
          small: "https://images.pokemontcg.io/sv5/192.png",
          large: "https://images.pokemontcg.io/sv5/192_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-207",
        number: "207",
        images: {
          small: "https://images.pokemontcg.io/sv5/207.png",
          large: "https://images.pokemontcg.io/sv5/207_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-217",
        number: "217",
        images: {
          small: "https://images.pokemontcg.io/sv5/217.png",
          large: "https://images.pokemontcg.io/sv5/217_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/svp/147.png",
          large: "https://images.pokemontcg.io/svp/147_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-62",
    name: "Iron Bundle",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "90",
    types: ["Water"],
    attacks: [
      {
        name: "Interjet",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Switch this Pokémon with 1 of your Benched Pokémon. If you do, switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    flavorText:
      "It resembles a mysterious object mentioned in an old book. There are only two reported sightings of this Pokémon.",
    nationalPokedexNumbers: [991],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/62.png",
      large: "https://images.pokemontcg.io/sv6/62_hires.png",
    },
    altArts: [
      {
        id: "sv6-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/sv6/62.png",
          large: "https://images.pokemontcg.io/sv6/62_hires.png",
        },
        flavorText:
          "It resembles a mysterious object mentioned in an old book. There are only two reported sightings of this Pokémon.",
      },
    ],
  },
  {
    id: "sv8-55",
    name: "Iron Bundle",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "100",
    types: ["Water"],
    attacks: [
      {
        name: "Gusting Collision",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200-",
        text: "This attack does 50 less damage for each Colorless in your opponent's Active Pokémon's Retreat Cost.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    nationalPokedexNumbers: [991],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/55.png",
      large: "https://images.pokemontcg.io/sv8/55_hires.png",
    },
    altArts: [
      {
        id: "sv8-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv8/55.png",
          large: "https://images.pokemontcg.io/sv8/55_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-132",
    name: "Iron Crown",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Deleting Slash",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40+",
        text: "If your opponent has 3 or more Benched Pokémon, this attack does 80 more damage.",
      },
      {
        name: "Slicing Blade",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "132",
    nationalPokedexNumbers: [1023],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/132.png",
      large: "https://images.pokemontcg.io/sv8/132_hires.png",
    },
    altArts: [
      {
        id: "sv8-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/sv8/132.png",
          large: "https://images.pokemontcg.io/sv8/132_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-81",
    name: "Iron Crown ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Future"],
    hp: "220",
    types: ["Psychic"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Cobalt Command",
        text: "Attacks used by your Future Pokémon, except any Iron Crown ex, do 20 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Twin Shotels",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 50 damage to 2 of your opponent's Pokémon. This attack's damage isn't affected by Weakness or Resistance, or by any effects on those Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "81",
    nationalPokedexNumbers: [1023],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/81.png",
      large: "https://images.pokemontcg.io/sv5/81_hires.png",
    },
    altArts: [
      {
        id: "sv5-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv5/81.png",
          large: "https://images.pokemontcg.io/sv5/81_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-191",
        number: "191",
        images: {
          small: "https://images.pokemontcg.io/sv5/191.png",
          large: "https://images.pokemontcg.io/sv5/191_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-206",
        number: "206",
        images: {
          small: "https://images.pokemontcg.io/sv5/206.png",
          large: "https://images.pokemontcg.io/sv5/206_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-216",
        number: "216",
        images: {
          small: "https://images.pokemontcg.io/sv5/216.png",
          large: "https://images.pokemontcg.io/sv5/216_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/158.png",
          large: "https://images.pokemontcg.io/sv8pt5/158_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/svp/146.png",
          large: "https://images.pokemontcg.io/svp/146_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-61",
    name: "Iron Hands",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "140",
    types: ["Lightning"],
    attacks: [
      {
        name: "Volt Wave",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Superalloy Hands",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If your opponent's Active Pokémon is a Pokémon ex or Pokémon V, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "61",
    flavorText:
      "This Pokémon shares many similarities with Iron Hands, an object mentioned in a certain expedition journal.",
    nationalPokedexNumbers: [992],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/61.png",
      large: "https://images.pokemontcg.io/sv5/61_hires.png",
    },
    altArts: [
      {
        id: "sv5-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv5/61.png",
          large: "https://images.pokemontcg.io/sv5/61_hires.png",
        },
        flavorText:
          "This Pokémon shares many similarities with Iron Hands, an object mentioned in a certain expedition journal.",
      },
    ],
  },
  {
    id: "sv5-139",
    name: "Iron Jugulis",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "130",
    types: ["Colorless"],
    abilities: [
      {
        name: "Automated Combat",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), put 3 damage counters on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Blasting Wind",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "139",
    flavorText:
      "It's possible that Iron Jugulis, an object described in an old book, may actually be this Pokémon.",
    nationalPokedexNumbers: [993],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/139.png",
      large: "https://images.pokemontcg.io/sv5/139_hires.png",
    },
    altArts: [
      {
        id: "sv5-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/sv5/139.png",
          large: "https://images.pokemontcg.io/sv5/139_hires.png",
        },
        flavorText:
          "It's possible that Iron Jugulis, an object described in an old book, may actually be this Pokémon.",
      },
    ],
  },
  {
    id: "sv6-19",
    name: "Iron Leaves",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Recovery Net",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put up to 2 Pokémon from your discard pile into your hand.",
      },
      {
        name: "Avenging Edge",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "19",
    flavorText:
      "According to the few eyewitness accounts that exist, it used its shining blades to julienne large trees and boulders.",
    nationalPokedexNumbers: [1010],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/19.png",
      large: "https://images.pokemontcg.io/sv6/19_hires.png",
    },
    altArts: [
      {
        id: "sv6-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv6/19.png",
          large: "https://images.pokemontcg.io/sv6/19_hires.png",
        },
        flavorText:
          "According to the few eyewitness accounts that exist, it used its shining blades to julienne large trees and boulders.",
      },
    ],
  },
  {
    id: "sv5-25",
    name: "Iron Leaves ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Future"],
    hp: "220",
    types: ["Grass"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Rapid Vernier",
        text: "When you play this Pokémon from your hand onto your Bench during your turn, you may switch it with your Active Pokémon. If you do, you may move any amount of Energy from your other Pokémon to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Prism Edge",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "25",
    nationalPokedexNumbers: [1010],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/25.png",
      large: "https://images.pokemontcg.io/sv5/25_hires.png",
    },
    altArts: [
      {
        id: "sv5-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv5/25.png",
          large: "https://images.pokemontcg.io/sv5/25_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-186",
        number: "186",
        images: {
          small: "https://images.pokemontcg.io/sv5/186.png",
          large: "https://images.pokemontcg.io/sv5/186_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-203",
        number: "203",
        images: {
          small: "https://images.pokemontcg.io/sv5/203.png",
          large: "https://images.pokemontcg.io/sv5/203_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-213",
        number: "213",
        images: {
          small: "https://images.pokemontcg.io/sv5/213.png",
          large: "https://images.pokemontcg.io/sv5/213_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-176",
        number: "176",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/176.png",
          large: "https://images.pokemontcg.io/sv8pt5/176_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/svp/128.png",
          large: "https://images.pokemontcg.io/svp/128_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-9",
    name: "Iron Moth",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "120",
    types: ["Fire"],
    attacks: [
      {
        name: "Suction",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal from this Pokémon the same amount of damage you did to your opponent's Active Pokémon.",
      },
      {
        name: "Anachronism Repulsor",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Ancient Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "9",
    nationalPokedexNumbers: [994],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/9.png",
      large: "https://images.pokemontcg.io/sv6pt5/9_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/9.png",
          large: "https://images.pokemontcg.io/sv6pt5/9_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-62",
    name: "Iron Thorns",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "140",
    types: ["Lightning"],
    attacks: [
      {
        name: "Destructo-Press",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70×",
        text: "Reveal the top 5 cards of your deck. This attack does 70 damage for each Future card you find there. Then, discard those Future cards and shuffle the other cards back into your deck.",
      },
      {
        name: "Megaton Lariat",
        cost: ["Lightning", "Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "62",
    flavorText:
      "Some of its notable features match those of an object named within a certain expedition journal as Iron Thorns.",
    nationalPokedexNumbers: [995],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/62.png",
      large: "https://images.pokemontcg.io/sv5/62_hires.png",
    },
    altArts: [
      {
        id: "sv5-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/sv5/62.png",
          large: "https://images.pokemontcg.io/sv5/62_hires.png",
        },
        flavorText:
          "Some of its notable features match those of an object named within a certain expedition journal as Iron Thorns.",
      },
    ],
  },
  {
    id: "svp-98",
    name: "Iron Thorns",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "140",
    types: ["Lightning"],
    attacks: [
      {
        cost: ["Lightning", "Colorless"],
        name: "Destructo-Press",
        damage: "70×",
        text: "Reveal the top 5 cards of your deck. This attack does 70 damage for each Future card you find there. Then, discard those Future cards and shuffle the other cards back into your deck.",
        convertedEnergyCost: 2,
      },
      {
        cost: ["Lightning", "Lightning", "Lightning", "Colorless"],
        name: "Megaton Lariat",
        damage: "140",
        text: "",
        convertedEnergyCost: 4,
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "98",
    flavorText:
      "Some of its notable features match those of an object named within a certain expedition journal as Iron Thorns.",
    nationalPokedexNumbers: [995],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/98.png",
      large: "https://images.pokemontcg.io/svp/98_hires.png",
    },
    altArts: [
      {
        id: "svp-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/svp/98.png",
          large: "https://images.pokemontcg.io/svp/98_hires.png",
        },
        flavorText:
          "Some of its notable features match those of an object named within a certain expedition journal as Iron Thorns.",
      },
    ],
  },
  {
    id: "sv6-77",
    name: "Iron Thorns ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Future"],
    hp: "230",
    types: ["Lightning"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Initialization",
        text: "As long as this Pokémon is in the Active Spot, Pokémon with a Rule Box in play (both yours and your opponent's) have no Abilities, except for Future Pokémon. (Pokémon ex, Pokémon V, etc. have Rule Boxes.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Volt Cyclone",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "Move an Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "77",
    nationalPokedexNumbers: [995],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/77.png",
      large: "https://images.pokemontcg.io/sv6/77_hires.png",
    },
    altArts: [
      {
        id: "sv6-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv6/77.png",
          large: "https://images.pokemontcg.io/sv6/77_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-196",
        number: "196",
        images: {
          small: "https://images.pokemontcg.io/sv6/196.png",
          large: "https://images.pokemontcg.io/sv6/196_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/32.png",
          large: "https://images.pokemontcg.io/sv8pt5/32_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-118",
    name: "Iron Treads",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "130",
    types: ["Metal"],
    abilities: [
      {
        name: "Dual Core",
        text: "As long as this Pokémon has a Future Booster Energy Capsule attached, it is Fighting and Metal type.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Wheel Pass",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Move an Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "118",
    flavorText:
      "Sightings of this Pokémon have occurred in recent years. It resembles a mysterious object described in an old expedition journal.",
    nationalPokedexNumbers: [990],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/118.png",
      large: "https://images.pokemontcg.io/sv5/118_hires.png",
    },
    altArts: [
      {
        id: "sv5-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/sv5/118.png",
          large: "https://images.pokemontcg.io/sv5/118_hires.png",
        },
        flavorText:
          "Sightings of this Pokémon have occurred in recent years. It resembles a mysterious object described in an old expedition journal.",
      },
    ],
  },
  {
    id: "sv5-79",
    name: "Iron Valiant",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Gemini Laser",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This attack also does 20 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Zen Blade",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your next turn, this Pokémon can't use Zen Blade.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "79",
    flavorText:
      "It's possible that this is the object listed as Iron Valiant in a certain expedition journal.",
    nationalPokedexNumbers: [1006],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/79.png",
      large: "https://images.pokemontcg.io/sv5/79_hires.png",
    },
    altArts: [
      {
        id: "sv5-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv5/79.png",
          large: "https://images.pokemontcg.io/sv5/79_hires.png",
        },
        flavorText:
          "It's possible that this is the object listed as Iron Valiant in a certain expedition journal.",
      },
    ],
  },
  {
    id: "sv5-80",
    name: "Iron Valiant",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Calculation",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top 4 cards of your deck and put them back in any order.",
      },
      {
        name: "Majestic Sword",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If you played a Future Supporter card from your hand during this turn, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "80",
    flavorText:
      "It's possible that this is the object listed as Iron Valiant in a certain expedition journal.",
    nationalPokedexNumbers: [1006],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/80.png",
      large: "https://images.pokemontcg.io/sv5/80_hires.png",
    },
    altArts: [
      {
        id: "sv5-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv5/80.png",
          large: "https://images.pokemontcg.io/sv5/80_hires.png",
        },
        flavorText:
          "It's possible that this is the object listed as Iron Valiant in a certain expedition journal.",
      },
    ],
  },
  {
    id: "me1-2",
    name: "Ivysaur",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Grass"],
    evolvesFrom: "Bulbasaur",
    evolvesTo: ["Venusaur"],
    attacks: [
      {
        name: "Razor Leaf",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "2",
    nationalPokedexNumbers: [2],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/2.png",
      large: "https://images.pokemontcg.io/me1/2_hires.png",
    },
    altArts: [
      {
        id: "me1-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/me1/2.png",
          large: "https://images.pokemontcg.io/me1/2_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/me1/134.png",
          large: "https://images.pokemontcg.io/me1/134_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-110",
    name: "Jangmo-o",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Dragon"],
    attacks: [
      {
        name: "Screech",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "During your next turn, the Defending Pokémon takes 30 more damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Dragon Claw",
        cost: ["Lightning", "Fighting"],
        convertedEnergyCost: 2,
        damage: "40",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "110",
    nationalPokedexNumbers: [782],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-110/small",
      large: "https://images.scrydex.com/pokemon/me55-110/large",
    },
    altArts: [
      {
        id: "me55-110",
        number: "110",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-110/small",
          large: "https://images.scrydex.com/pokemon/me55-110/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-45",
    name: "Jellicent ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Psychic"],
    evolvesFrom: "Frillish",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Oceanic Curse",
        text: "As long as this Pokémon is in the Active Spot, your opponent can't play any Item cards or Pokémon Tool cards from their hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Power Press",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80+",
        text: "If this Pokémon has at least 2 extra Energy attached (in addition to this attack's cost), this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "45",
    nationalPokedexNumbers: [593],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/45.png",
      large: "https://images.pokemontcg.io/rsv10pt5/45_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/45.png",
          large: "https://images.pokemontcg.io/rsv10pt5/45_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/160.png",
          large: "https://images.pokemontcg.io/rsv10pt5/160_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/168.png",
          large: "https://images.pokemontcg.io/rsv10pt5/168_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-76",
    name: "Jigglypuff",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Wigglytuff"],
    attacks: [
      {
        name: "Ball Roll",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "Flip a coin until you get tails. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "76",
    flavorText:
      "When its huge eyes waver, it sings a mysteriously soothing melody that lulls its enemies to sleep.",
    nationalPokedexNumbers: [39],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/76.png",
      large: "https://images.pokemontcg.io/me2/76_hires.png",
    },
    altArts: [
      {
        id: "me2-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/me2/76.png",
          large: "https://images.pokemontcg.io/me2/76_hires.png",
        },
        flavorText:
          "When its huge eyes waver, it sings a mysteriously soothing melody that lulls its enemies to sleep.",
      },
    ],
  },
  {
    id: "sv7-98",
    name: "Jirachi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Metal"],
    attacks: [
      {
        name: "Swelling Wish",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach a Basic Energy card from your discard pile to 1 of your Benched Pokémon.",
      },
      {
        name: "Slap",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "98",
    nationalPokedexNumbers: [385],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/98.png",
      large: "https://images.pokemontcg.io/sv7/98_hires.png",
    },
    altArts: [
      {
        id: "sv7-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv7/98.png",
          large: "https://images.pokemontcg.io/sv7/98_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-102",
    name: "Jirachi ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "160",
    types: ["Metal"],
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Wish Granter",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Draw cards until you have 7 cards in your hand.",
      },
      {
        name: "Swift",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "This attack's damage isn't affected by Weakness or Resistance, or by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-20",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "102",
    nationalPokedexNumbers: [385],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-102/small",
      large: "https://images.scrydex.com/pokemon/me55-102/large",
    },
    altArts: [
      {
        id: "me55-102",
        number: "102",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-102/small",
          large: "https://images.scrydex.com/pokemon/me55-102/large",
        },
        flavorText: "",
      },
      {
        id: "me55-155",
        number: "155",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-155/small",
          large: "https://images.scrydex.com/pokemon/me55-155/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-30",
    name: "Jolteon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "260",
    types: ["Lightning"],
    evolvesFrom: "Eevee",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Flashing Spear",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "You may discard up to 2 Basic Energy from your Benched Pokémon. This attack does 90 more damage for each card you discarded in this way.",
      },
      {
        name: "Dravite",
        cost: ["Fire", "Water", "Lightning"],
        convertedEnergyCost: 3,
        damage: "280",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "30",
    nationalPokedexNumbers: [135],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/30.png",
      large: "https://images.pokemontcg.io/sv8pt5/30_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/30.png",
          large: "https://images.pokemontcg.io/sv8pt5/30_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/153.png",
          large: "https://images.pokemontcg.io/sv8pt5/153_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-33",
    name: "Joltik",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Lightning"],
    evolvesTo: ["Galvantula"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    flavorText:
      "Joltik that live in cities have learned a technique for sucking electricity from the outlets in houses.",
    nationalPokedexNumbers: [595],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/33.png",
      large: "https://images.pokemontcg.io/rsv10pt5/33_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/33.png",
          large: "https://images.pokemontcg.io/rsv10pt5/33_hires.png",
        },
        flavorText:
          "Joltik that live in cities have learned a technique for sucking electricity from the outlets in houses.",
      },
      {
        id: "rsv10pt5-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/116.png",
          large: "https://images.pokemontcg.io/rsv10pt5/116_hires.png",
        },
        flavorText:
          "Joltik that live in cities have learned a technique for sucking electricity from the outlets in houses.",
      },
    ],
  },
  {
    id: "sv6pt5-1",
    name: "Joltik",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    evolvesTo: ["Galvantula"],
    attacks: [
      {
        name: "Splashing Dodge",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    nationalPokedexNumbers: [595],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/1.png",
      large: "https://images.pokemontcg.io/sv6pt5/1_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/1.png",
          large: "https://images.pokemontcg.io/sv6pt5/1_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-50",
    name: "Joltik",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Lightning"],
    evolvesTo: ["Galvantula"],
    attacks: [
      {
        name: "Jolting Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Grass Energy cards and up to 2 Basic Lightning Energy cards and attach them to your Pokémon in any way you like. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [595],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/50.png",
      large: "https://images.pokemontcg.io/sv7/50_hires.png",
    },
    altArts: [
      {
        id: "sv7-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv7/50.png",
          large: "https://images.pokemontcg.io/sv7/50_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/sv7/150.png",
          large: "https://images.pokemontcg.io/sv7/150_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-57",
    name: "Jynx",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Psychic",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "This attack does 30 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    nationalPokedexNumbers: [124],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/57.png",
      large: "https://images.pokemontcg.io/me1/57_hires.png",
    },
    altArts: [
      {
        id: "me1-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/me1/57.png",
          large: "https://images.pokemontcg.io/me1/57_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-32",
    name: "Jynx",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Psychic"],
    attacks: [
      {
        name: "Intense Kiss",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "At the end of your opponent's next turn, discard the Defending Pokémon and all attached cards.",
      },
      {
        name: "Psy Bolt",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    flavorText:
      "Its strange cries sound like human language. There are some musicians who compose songs for Jynx to sing.",
    nationalPokedexNumbers: [124],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-32/small",
      large: "https://images.scrydex.com/pokemon/me5-32/large",
    },
    altArts: [
      {
        id: "me5-32",
        number: "32",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-32/small",
          large: "https://images.scrydex.com/pokemon/me5-32/large",
        },
        flavorText:
          "Its strange cries sound like human language. There are some musicians who compose songs for Jynx to sing.",
      },
    ],
  },
  {
    id: "sv6-46",
    name: "Jynx",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Water"],
    attacks: [
      {
        name: "Inviting Kiss",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Pokémon and put it onto your Bench. Then, shuffle your deck. If you put any Pokémon onto your Bench in this way, move an Energy from this Pokémon to the new Benched Pokémon.",
      },
      {
        name: "Icy Snow",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "46",
    flavorText:
      "In certain parts of Galar, Jynx was once feared and worshiped as the Queen of Ice.",
    nationalPokedexNumbers: [124],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/46.png",
      large: "https://images.pokemontcg.io/sv6/46_hires.png",
    },
    altArts: [
      {
        id: "sv6-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv6/46.png",
          large: "https://images.pokemontcg.io/sv6/46_hires.png",
        },
        flavorText:
          "In certain parts of Galar, Jynx was once feared and worshiped as the Queen of Ice.",
      },
    ],
  },
  {
    id: "me1-55",
    name: "Kadabra",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Psychic"],
    evolvesFrom: "Abra",
    evolvesTo: ["Alakazam"],
    abilities: [
      {
        name: "Psychic Draw",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Draw 2 cards.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Super Psy Bolt",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    nationalPokedexNumbers: [64],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/55.png",
      large: "https://images.pokemontcg.io/me1/55_hires.png",
    },
    altArts: [
      {
        id: "me1-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/me1/55.png",
          large: "https://images.pokemontcg.io/me1/55_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-81",
    name: "Kadabra",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Psychic"],
    evolvesFrom: "Abra",
    evolvesTo: ["Alakazam"],
    attacks: [
      {
        name: "Psychic",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "This attack does 30 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "81",
    flavorText:
      "Using its psychic power, Kadabra levitates as it sleeps. It uses its springy tail as a pillow.",
    nationalPokedexNumbers: [64],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/81.png",
      large: "https://images.pokemontcg.io/sv6/81_hires.png",
    },
    altArts: [
      {
        id: "sv6-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv6/81.png",
          large: "https://images.pokemontcg.io/sv6/81_hires.png",
        },
        flavorText:
          "Using its psychic power, Kadabra levitates as it sleeps. It uses its springy tail as a pillow.",
      },
    ],
  },
  {
    id: "me4-2",
    name: "Kakuna",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Grass"],
    evolvesFrom: "Weedle",
    abilities: [
      {
        name: "Exoskeleton",
        text: "This Pokémon takes 20 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hang Down",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "2",
    flavorText:
      "Almost incapable of moving, this Pokémon can only harden its shell to protect itself when it is in danger.",
    nationalPokedexNumbers: [14],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-2/small",
      large: "https://images.scrydex.com/pokemon/me4-2/large",
    },
    altArts: [
      {
        id: "me4-2",
        number: "2",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-2/small",
          large: "https://images.scrydex.com/pokemon/me4-2/large",
        },
        flavorText:
          "Almost incapable of moving, this Pokémon can only harden its shell to protect itself when it is in danger.",
      },
    ],
  },
  {
    id: "me55-114",
    name: "Kangaskhan",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Colorless"],
    attacks: [
      {
        name: "Rage",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 10 more damage for each damage counter on this Pokémon.",
      },
      {
        name: "Mega Punch",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "114",
    nationalPokedexNumbers: [115],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-114/small",
      large: "https://images.scrydex.com/pokemon/me55-114/large",
    },
    altArts: [
      {
        id: "me55-114",
        number: "114",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-114/small",
          large: "https://images.scrydex.com/pokemon/me55-114/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-151",
    name: "Kangaskhan",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Dizzy Punch",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90×",
        text: "Flip 2 coins. This attack does 90 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "151",
    nationalPokedexNumbers: [115],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/151.png",
      large: "https://images.pokemontcg.io/sv10/151_hires.png",
    },
    altArts: [
      {
        id: "sv10-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/sv10/151.png",
          large: "https://images.pokemontcg.io/sv10/151_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-204",
        number: "204",
        images: {
          small: "https://images.pokemontcg.io/sv10/204.png",
          large: "https://images.pokemontcg.io/sv10/204_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-9",
    name: "Karrablast",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Escavalier"],
    abilities: [
      {
        name: "Stimulated Evolution",
        text: "If you have Shelmet in play, this Pokémon can evolve during your first turn or the turn you play it.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Horn Attack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    flavorText:
      "These mysterious Pokémon evolve when they receive electrical stimulation while they are in the same place as Shelmet.",
    nationalPokedexNumbers: [588],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/9.png",
      large: "https://images.pokemontcg.io/zsv10pt5/9_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/9.png",
          large: "https://images.pokemontcg.io/zsv10pt5/9_hires.png",
        },
        flavorText:
          "These mysterious Pokémon evolve when they receive electrical stimulation while they are in the same place as Shelmet.",
      },
      {
        id: "zsv10pt5-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/94.png",
          large: "https://images.pokemontcg.io/zsv10pt5/94_hires.png",
        },
        flavorText:
          "These mysterious Pokémon evolve when they receive electrical stimulation while they are in the same place as Shelmet.",
      },
    ],
  },
  {
    id: "sv9-9",
    name: "Karrablast",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Escavalier"],
    attacks: [
      {
        name: "Push Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    nationalPokedexNumbers: [588],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/9.png",
      large: "https://images.pokemontcg.io/sv9/9_hires.png",
    },
    altArts: [
      {
        id: "sv9-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv9/9.png",
          large: "https://images.pokemontcg.io/sv9/9_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-150",
    name: "Kecleon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    abilities: [
      {
        name: "Expert Hider",
        text: "If any damage is done to this Pokémon by attacks, flip a coin. If heads, prevent that damage.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Lick Whip",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 30 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "150",
    nationalPokedexNumbers: [352],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/150.png",
      large: "https://images.pokemontcg.io/sv8/150_hires.png",
    },
    altArts: [
      {
        id: "sv8-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/sv8/150.png",
          large: "https://images.pokemontcg.io/sv8/150_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-213",
        number: "213",
        images: {
          small: "https://images.pokemontcg.io/sv8/213.png",
          large: "https://images.pokemontcg.io/sv8/213_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-122",
    name: "Kecleon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Colorless"],
    attacks: [
      {
        name: "Stealth Attack",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "122",
    nationalPokedexNumbers: [352],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/122.png",
      large: "https://images.pokemontcg.io/sv9/122_hires.png",
    },
    altArts: [
      {
        id: "sv9-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/sv9/122.png",
          large: "https://images.pokemontcg.io/sv9/122_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-19",
    name: "Keldeo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Shoot Through",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This attack also does 20 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Reflect Energy",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "Move an Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "19",
    flavorText:
      "Keldeo has strengthened its resolve for battle filling its body with power and changing its form.",
    nationalPokedexNumbers: [647],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-19/small",
      large: "https://images.scrydex.com/pokemon/me4-19/large",
    },
    altArts: [
      {
        id: "me4-19",
        number: "19",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-19/small",
          large: "https://images.scrydex.com/pokemon/me4-19/large",
        },
        flavorText:
          "Keldeo has strengthened its resolve for battle filling its body with power and changing its form.",
      },
    ],
  },
  {
    id: "sv5-44",
    name: "Keldeo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Rapid Draw",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Draw 2 cards.",
      },
      {
        name: "Aqua Blade",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    flavorText:
      "Keldeo has strengthened its resolve for battle, filling its body with power and changing its form.",
    nationalPokedexNumbers: [647],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/44.png",
      large: "https://images.pokemontcg.io/sv5/44_hires.png",
    },
    altArts: [
      {
        id: "sv5-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv5/44.png",
          large: "https://images.pokemontcg.io/sv5/44_hires.png",
        },
        flavorText:
          "Keldeo has strengthened its resolve for battle, filling its body with power and changing its form.",
      },
    ],
  },
  {
    id: "rsv10pt5-30",
    name: "Keldeo ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Gale Thrust",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If this Pokémon moved from your Bench to the Active Spot this turn, this attack does 90 more damage.",
      },
      {
        name: "Sonic Edge",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "30",
    nationalPokedexNumbers: [647],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/30.png",
      large: "https://images.pokemontcg.io/rsv10pt5/30_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/30.png",
          large: "https://images.pokemontcg.io/rsv10pt5/30_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/159.png",
          large: "https://images.pokemontcg.io/rsv10pt5/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/167.png",
          large: "https://images.pokemontcg.io/rsv10pt5/167_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-76",
    name: "Kilowattrel",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Wattrel",
    attacks: [
      {
        name: "Wind Power Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your next turn, attacks used by this Pokémon do 120 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      },
      {
        name: "Strong Volt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "76",
    flavorText:
      "It uses its throat sac to store electricity generated by its wings. There's hardly any oil in its feathers, so it is a poor swimmer.",
    nationalPokedexNumbers: [941],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/76.png",
      large: "https://images.pokemontcg.io/sv6/76_hires.png",
    },
    altArts: [
      {
        id: "sv6-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv6/76.png",
          large: "https://images.pokemontcg.io/sv6/76_hires.png",
        },
        flavorText:
          "It uses its throat sac to store electricity generated by its wings. There's hardly any oil in its feathers, so it is a poor swimmer.",
      },
    ],
  },
  {
    id: "sv8-67",
    name: "Kilowattrel",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Wattrel",
    attacks: [
      {
        name: "Glide",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Storm Bolt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Move all Energy from this Pokémon to your Benched Pokémon in any way you like.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    nationalPokedexNumbers: [941],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/67.png",
      large: "https://images.pokemontcg.io/sv8/67_hires.png",
    },
    altArts: [
      {
        id: "sv8-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv8/67.png",
          large: "https://images.pokemontcg.io/sv8/67_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-68",
    name: "Kilowattrel ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Lightning"],
    evolvesFrom: "Wattrel",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Return Charge",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch this Pokémon with 1 of your Benched Pokémon. If you do, attach up to 2 Basic Lightning Energy cards from your hand to this Pokémon.",
      },
      {
        name: "Thunder Lance",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40+",
        text: "This attack does 40 more damage for each Lightning Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "68",
    nationalPokedexNumbers: [941],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/68.png",
      large: "https://images.pokemontcg.io/sv8/68_hires.png",
    },
    altArts: [
      {
        id: "sv8-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv8/68.png",
          large: "https://images.pokemontcg.io/sv8/68_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-148",
    name: "Kingambit",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Metal"],
    evolvesFrom: "Bisharp",
    abilities: [
      {
        name: "Supreme Overlord",
        text: "Attacks used by this Pokémon do 30 more damage to your opponent's Active Pokémon for each Prize card your opponent has taken (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Double-Edged Slash",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "180",
        text: "This Pokémon also does 50 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "148",
    flavorText:
      "Though it commands a massive army in battle, it’s not skilled at devising complex strategies. It just uses brute strength to keep pushing.",
    nationalPokedexNumbers: [983],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-148/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-148/large",
    },
    altArts: [
      {
        id: "me2pt5-148",
        number: "148",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-148/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-148/large",
        },
        flavorText:
          "Though it commands a massive army in battle, it’s not skilled at devising complex strategies. It just uses brute strength to keep pushing.",
      },
    ],
  },
  {
    id: "svp-113",
    name: "Kingambit",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Bisharp",
    attacks: [
      {
        name: "Elbow Strike",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Slicing Blade",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "113",
    nationalPokedexNumbers: [983],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/113.png",
      large: "https://images.pokemontcg.io/svp/113_hires.png",
    },
    altArts: [
      {
        id: "svp-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/svp/113.png",
          large: "https://images.pokemontcg.io/svp/113_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-12",
    name: "Kingdra ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "310",
    types: ["Water"],
    evolvesFrom: "Seadra",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "King's Order",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put up to 3 Water Pokémon from your discard pile onto your Bench.",
      },
      {
        name: "Hydro Pump",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "This attack does 50 more damage for each Water Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "12",
    nationalPokedexNumbers: [230],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/12.png",
      large: "https://images.pokemontcg.io/sv6pt5/12_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/12.png",
          large: "https://images.pokemontcg.io/sv6pt5/12_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/80.png",
          large: "https://images.pokemontcg.io/sv6pt5/80_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/svp/131.png",
          large: "https://images.pokemontcg.io/svp/131_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-59",
    name: "Kirlia",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Psychic"],
    evolvesFrom: "Ralts",
    evolvesTo: ["Gardevoir", "Gallade"],
    attacks: [
      {
        name: "Call Sign",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Psyshot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    nationalPokedexNumbers: [281],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/59.png",
      large: "https://images.pokemontcg.io/me1/59_hires.png",
    },
    altArts: [
      {
        id: "me1-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/me1/59.png",
          large: "https://images.pokemontcg.io/me1/59_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-88",
        number: "88",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-88/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-88/large",
        },
        flavorText:
          "It has a psychic power that enables it to distort the space around it and see into the future.",
      },
    ],
  },
  {
    id: "zsv10pt5-62",
    name: "Klang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Metal"],
    evolvesFrom: "Klink",
    evolvesTo: ["Klinklang"],
    attacks: [
      {
        name: "Hard Gears",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "During your opponent's next turn, this Pokémon takes 20 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "62",
    flavorText:
      "By changing the direction in which it rotates, it communicates its feelings to others. When angry, it rotates faster.",
    nationalPokedexNumbers: [600],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/62.png",
      large: "https://images.pokemontcg.io/zsv10pt5/62_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/62.png",
          large: "https://images.pokemontcg.io/zsv10pt5/62_hires.png",
        },
        flavorText:
          "By changing the direction in which it rotates, it communicates its feelings to others. When angry, it rotates faster.",
      },
      {
        id: "zsv10pt5-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/140.png",
          large: "https://images.pokemontcg.io/zsv10pt5/140_hires.png",
        },
        flavorText:
          "By changing the direction in which it rotates, it communicates its feelings to others. When angry, it rotates faster.",
      },
    ],
  },
  {
    id: "sv7-100",
    name: "Klang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Metal"],
    evolvesFrom: "Klink",
    evolvesTo: ["Klinklang"],
    attacks: [
      {
        name: "Iron Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "100",
    nationalPokedexNumbers: [600],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/100.png",
      large: "https://images.pokemontcg.io/sv7/100_hires.png",
    },
    altArts: [
      {
        id: "sv7-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/sv7/100.png",
          large: "https://images.pokemontcg.io/sv7/100_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-90",
    name: "Klawf",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fighting"],
    attacks: [
      {
        name: "Snipping Pincers",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Flip 2 coins. For each heads, discard an Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Hammer In",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "90",
    nationalPokedexNumbers: [950],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/90.png",
      large: "https://images.pokemontcg.io/sv9/90_hires.png",
    },
    altArts: [
      {
        id: "sv9-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv9/90.png",
          large: "https://images.pokemontcg.io/sv9/90_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-59",
    name: "Klefki",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Memory Lock",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Choose 1 of your opponent's Active Pokémon's attacks. During your opponent's next turn, that Pokémon can't use that attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    nationalPokedexNumbers: [707],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-59/small",
      large: "https://images.scrydex.com/pokemon/me3-59/large",
    },
    altArts: [
      {
        id: "me3-59",
        number: "59",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-59/small",
          large: "https://images.scrydex.com/pokemon/me3-59/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-128",
    name: "Klefki",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Stick 'n' Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard a card from your hand. If you do, draw 2 cards.",
      },
      {
        name: "Hook",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "128",
    nationalPokedexNumbers: [707],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/128.png",
      large: "https://images.pokemontcg.io/sv8/128_hires.png",
    },
    altArts: [
      {
        id: "sv8-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/sv8/128.png",
          large: "https://images.pokemontcg.io/sv8/128_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-61",
    name: "Klink",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Metal"],
    evolvesTo: ["Klang"],
    attacks: [
      {
        name: "Hard Gears",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, this Pokémon takes 10 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "61",
    flavorText:
      "The two minigears that mesh together are predetermined. Each will rebound from other minigears without meshing.",
    nationalPokedexNumbers: [599],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/61.png",
      large: "https://images.pokemontcg.io/zsv10pt5/61_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/61.png",
          large: "https://images.pokemontcg.io/zsv10pt5/61_hires.png",
        },
        flavorText:
          "The two minigears that mesh together are predetermined. Each will rebound from other minigears without meshing.",
      },
      {
        id: "zsv10pt5-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/139.png",
          large: "https://images.pokemontcg.io/zsv10pt5/139_hires.png",
        },
        flavorText:
          "The two minigears that mesh together are predetermined. Each will rebound from other minigears without meshing.",
      },
    ],
  },
  {
    id: "sv7-99",
    name: "Klink",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Metal"],
    evolvesTo: ["Klang"],
    attacks: [
      {
        name: "Allure",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Beam",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "99",
    nationalPokedexNumbers: [599],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/99.png",
      large: "https://images.pokemontcg.io/sv7/99_hires.png",
    },
    altArts: [
      {
        id: "sv7-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv7/99.png",
          large: "https://images.pokemontcg.io/sv7/99_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-63",
    name: "Klinklang",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Metal"],
    evolvesFrom: "Klang",
    abilities: [
      {
        name: "Gear Coating",
        text: "All of your Pokémon that have any Metal Energy attached take 20 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "63",
    flavorText:
      "Its red core functions as an energy tank. It fires the charged energy through its spikes into an area.",
    nationalPokedexNumbers: [599],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/63.png",
      large: "https://images.pokemontcg.io/zsv10pt5/63_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/63.png",
          large: "https://images.pokemontcg.io/zsv10pt5/63_hires.png",
        },
        flavorText:
          "Its red core functions as an energy tank. It fires the charged energy through its spikes into an area.",
      },
      {
        id: "zsv10pt5-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/141.png",
          large: "https://images.pokemontcg.io/zsv10pt5/141_hires.png",
        },
        flavorText:
          "Its red core functions as an energy tank. It fires the charged energy through its spikes into an area.",
      },
    ],
  },
  {
    id: "sv7-101",
    name: "Klinklang",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Metal"],
    evolvesFrom: "Klang",
    abilities: [
      {
        name: "Emergency Rotation",
        text: "Once during your turn, if this Pokémon is in your hand and your opponent has any Stage 2 Pokémon in play, you may put this Pokémon onto your Bench.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hyper Ray",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "101",
    nationalPokedexNumbers: [601],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/101.png",
      large: "https://images.pokemontcg.io/sv7/101_hires.png",
    },
    altArts: [
      {
        id: "sv7-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/sv7/101.png",
          large: "https://images.pokemontcg.io/sv7/101_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-91",
    name: "Koffing",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Weezing"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Suffocating Gas",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "91",
    nationalPokedexNumbers: [109],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/91.png",
      large: "https://images.pokemontcg.io/sv9/91_hires.png",
    },
    altArts: [
      {
        id: "sv9-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv9/91.png",
          large: "https://images.pokemontcg.io/sv9/91_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-129",
    name: "Komala",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Colorless"],
    attacks: [
      {
        name: "Slumbering Smack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Both Active Pokémon are now Asleep. During your next turn, attacks used by this Pokémon do 100 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "129",
    nationalPokedexNumbers: [775],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/129.png",
      large: "https://images.pokemontcg.io/sv9/129_hires.png",
    },
    altArts: [
      {
        id: "sv9-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/sv9/129.png",
          large: "https://images.pokemontcg.io/sv9/129_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-112",
    name: "Kommo-o",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Dragon"],
    evolvesFrom: "Hakamo-o",
    attacks: [
      {
        name: "Blazing Uppercut",
        cost: ["Lightning", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "250",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "112",
    nationalPokedexNumbers: [784],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-112/small",
      large: "https://images.scrydex.com/pokemon/me55-112/large",
    },
    altArts: [
      {
        id: "me55-112",
        number: "112",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-112/small",
          large: "https://images.scrydex.com/pokemon/me55-112/large",
        },
        flavorText: "",
      },
      {
        id: "me55-143",
        number: "143",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-143/small",
          large: "https://images.scrydex.com/pokemon/me55-143/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-47",
    name: "Koraidon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Battle Claw",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your opponent's Active Pokémon is an Evolution Pokémon, this attack does 30 more damage.",
      },
      {
        name: "Gaia Impact",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "190",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "47",
    nationalPokedexNumbers: [1007],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-47/small",
      large: "https://images.scrydex.com/pokemon/me5-47/large",
    },
    altArts: [
      {
        id: "me5-47",
        number: "47",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-47/small",
          large: "https://images.scrydex.com/pokemon/me5-47/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-86",
    name: "Koraidon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Low Kick",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "50",
      },
      {
        name: "Collision Course",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "Discard 2 Fighting Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "86",
    nationalPokedexNumbers: [1007],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-86/small",
      large: "https://images.scrydex.com/pokemon/me55-86/large",
    },
    altArts: [
      {
        id: "me55-86",
        number: "86",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-86/small",
          large: "https://images.scrydex.com/pokemon/me55-86/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-119",
    name: "Koraidon",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "140",
    types: ["Dragon"],
    attacks: [
      {
        name: "Primordial Beatdown",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each of your Ancient Pokémon in play.",
      },
      {
        name: "Shred",
        cost: ["Fire", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "119",
    flavorText:
      "This seems to be the Winged King mentioned in an old expedition journal. It was said to have split the land with its bare fists.",
    nationalPokedexNumbers: [1007],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/119.png",
      large: "https://images.pokemontcg.io/sv5/119_hires.png",
    },
    altArts: [
      {
        id: "sv5-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/sv5/119.png",
          large: "https://images.pokemontcg.io/sv5/119_hires.png",
        },
        flavorText:
          "This seems to be the Winged King mentioned in an old expedition journal. It was said to have split the land with its bare fists.",
      },
    ],
  },
  {
    id: "sv7-90",
    name: "Koraidon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Resolute Fang",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "90",
    nationalPokedexNumbers: [1007],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/90.png",
      large: "https://images.pokemontcg.io/sv7/90_hires.png",
    },
    altArts: [
      {
        id: "sv7-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv7/90.png",
          large: "https://images.pokemontcg.io/sv7/90_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-116",
    name: "Koraidon",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Unrelenting Onslaught",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If 1 of your other Ancient Pokémon used an attack during your last turn, this attack does 150 more damage.",
      },
      {
        name: "Hammer In",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "116",
    nationalPokedexNumbers: [1007],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/116.png",
      large: "https://images.pokemontcg.io/sv8/116_hires.png",
    },
    altArts: [
      {
        id: "sv8-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/sv8/116.png",
          large: "https://images.pokemontcg.io/sv8/116_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-91",
    name: "Koraidon",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "140",
    types: ["Dragon"],
    attacks: [
      {
        cost: ["Fighting", "Colorless"],
        name: "Primordial Beatdown",
        damage: "30×",
        text: "This attack does 30 damage for each of your Ancient Pokémon in play.",
        convertedEnergyCost: 2,
      },
      {
        cost: ["Fire", "Fighting", "Colorless"],
        name: "Shred",
        damage: "130",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
        convertedEnergyCost: 3,
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "91",
    flavorText:
      "This seems to be the Winged King mentioned in an old expedition journal. It was said to have split the land with its bare fists.",
    nationalPokedexNumbers: [1007],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/91.png",
      large: "https://images.pokemontcg.io/svp/91_hires.png",
    },
    altArts: [
      {
        id: "svp-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/svp/91.png",
          large: "https://images.pokemontcg.io/svp/91_hires.png",
        },
        flavorText:
          "This seems to be the Winged King mentioned in an old expedition journal. It was said to have split the land with its bare fists.",
      },
    ],
  },
  {
    id: "me2pt5-121",
    name: "Koraidon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "230",
    types: ["Fighting"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent’s).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Orichalcum Fang",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 120 more damage.",
      },
      {
        name: "Impact Blow",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "During your next turn, this Pokémon can't use Impact Blow.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "121",
    nationalPokedexNumbers: [1007],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-121/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-121/large",
    },
    altArts: [
      {
        id: "me2pt5-121",
        number: "121",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-121/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-121/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-120",
    name: "Koraidon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Ancient"],
    hp: "230",
    types: ["Dragon"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Retribution Strike",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 10 more damage for each damage counter on this Pokémon.",
      },
      {
        name: "Kaiser Tackle",
        cost: ["Fire", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "280",
        text: "This Pokémon also does 60 damage to itself.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "120",
    nationalPokedexNumbers: [1007],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/120.png",
      large: "https://images.pokemontcg.io/sv5/120_hires.png",
    },
    altArts: [
      {
        id: "sv5-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/sv5/120.png",
          large: "https://images.pokemontcg.io/sv5/120_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-58",
    name: "Krokorok",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Sandile",
    evolvesTo: ["Krookodile"],
    attacks: [
      {
        name: "Tighten Up",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "Your opponent discards 2 cards from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "58",
    flavorText:
      "They live in groups of a few individuals. Protective membranes shield their eyes from sandstorms.",
    nationalPokedexNumbers: [552],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/58.png",
      large: "https://images.pokemontcg.io/zsv10pt5/58_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/58.png",
          large: "https://images.pokemontcg.io/zsv10pt5/58_hires.png",
        },
        flavorText:
          "They live in groups of a few individuals. Protective membranes shield their eyes from sandstorms.",
      },
      {
        id: "zsv10pt5-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/136.png",
          large: "https://images.pokemontcg.io/zsv10pt5/136_hires.png",
        },
        flavorText:
          "They live in groups of a few individuals. Protective membranes shield their eyes from sandstorms.",
      },
    ],
  },
  {
    id: "me2-65",
    name: "Krokorok",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Sandile",
    evolvesTo: ["Krookodile"],
    attacks: [
      {
        name: "Bite",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Confront",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "65",
    flavorText:
      "Protected by thin membranes, their eyes can see even in the dead of night. They live in groups of a few individuals.",
    nationalPokedexNumbers: [552],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/65.png",
      large: "https://images.pokemontcg.io/me2/65_hires.png",
    },
    altArts: [
      {
        id: "me2-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/me2/65.png",
          large: "https://images.pokemontcg.io/me2/65_hires.png",
        },
        flavorText:
          "Protected by thin membranes, their eyes can see even in the dead of night. They live in groups of a few individuals.",
      },
    ],
  },
  {
    id: "zsv10pt5-59",
    name: "Krookodile",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Krokorok",
    attacks: [
      {
        name: "Tighten Up",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Your opponent discards 2 cards from their hand.",
      },
      {
        name: "Cursed Slug",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: "If your opponent has 3 or fewer cards in their hand, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "59",
    flavorText:
      "They never allow prey to escape. Their jaws are so powerful, they can crush the body of an automobile.",
    nationalPokedexNumbers: [553],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/59.png",
      large: "https://images.pokemontcg.io/zsv10pt5/59_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/59.png",
          large: "https://images.pokemontcg.io/zsv10pt5/59_hires.png",
        },
        flavorText:
          "They never allow prey to escape. Their jaws are so powerful, they can crush the body of an automobile.",
      },
      {
        id: "zsv10pt5-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/137.png",
          large: "https://images.pokemontcg.io/zsv10pt5/137_hires.png",
        },
        flavorText:
          "They never allow prey to escape. Their jaws are so powerful, they can crush the body of an automobile.",
      },
    ],
  },
  {
    id: "me2-66",
    name: "Krookodile",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Krokorok",
    attacks: [
      {
        name: "Vengeful Fang",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 160 more damage.",
      },
      {
        name: "Hammer In",
        cost: ["Darkness", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "66",
    flavorText:
      "After clamping down with its powerful jaws, it twists its body around to rip its prey in half.",
    nationalPokedexNumbers: [553],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/66.png",
      large: "https://images.pokemontcg.io/me2/66_hires.png",
    },
    altArts: [
      {
        id: "me2-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/me2/66.png",
          large: "https://images.pokemontcg.io/me2/66_hires.png",
        },
        flavorText:
          "After clamping down with its powerful jaws, it twists its body around to rip its prey in half.",
      },
    ],
  },
  {
    id: "me4-55",
    name: "Krookodile ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Darkness"],
    evolvesFrom: "Krokorok",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Corner",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Strong Bite",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140+",
        text: "If this Pokémon has a Pokémon Tool attached, this attack does 140 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "55",
    nationalPokedexNumbers: [553],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-55/small",
      large: "https://images.scrydex.com/pokemon/me4-55/large",
    },
    altArts: [
      {
        id: "me4-55",
        number: "55",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-55/small",
          large: "https://images.scrydex.com/pokemon/me4-55/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-34",
    name: "Kyogre",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "150",
    types: ["Water"],
    attacks: [
      {
        name: "Riptide",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each Basic Water Energy card in your discard pile. Then, shuffle those cards into your deck.",
      },
      {
        name: "Swirling Waves",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "34",
    nationalPokedexNumbers: [382],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/34.png",
      large: "https://images.pokemontcg.io/me1/34_hires.png",
    },
    altArts: [
      {
        id: "me1-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/me1/34.png",
          large: "https://images.pokemontcg.io/me1/34_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-19",
    name: "Kyogre",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Water"],
    attacks: [
      {
        name: "Hydro Pump",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "60+",
        text: "This attack does 30 more damage for each Water Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "19",
    nationalPokedexNumbers: [382],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-19/small",
      large: "https://images.scrydex.com/pokemon/me55-19/large",
    },
    altArts: [
      {
        id: "me55-19",
        number: "19",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-19/small",
          large: "https://images.scrydex.com/pokemon/me55-19/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-47",
    name: "Kyurem",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Dragon"],
    abilities: [
      {
        name: "Plasma Bane",
        text: 'If your opponent has any cards in their discard pile that have "Colress" in the name, this Pokémon can use the Trifrost attack for Colorless.',
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Trifrost",
        cost: ["Water", "Water", "Metal", "Metal", "Colorless"],
        convertedEnergyCost: 5,
        damage: "",
        text: "Discard all Energy from this Pokémon. This attack does 110 damage to 3 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "47",
    nationalPokedexNumbers: [646],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/47.png",
      large: "https://images.pokemontcg.io/sv6pt5/47_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/47.png",
          large: "https://images.pokemontcg.io/sv6pt5/47_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-28",
    name: "Kyurem ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Slash",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Blizzard Burst",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "This attack also does 10 damage to each of your opponent's Benched Pokémon for each Prize card your opponent has taken. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "28",
    nationalPokedexNumbers: [646],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/28.png",
      large: "https://images.pokemontcg.io/zsv10pt5/28_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/28.png",
          large: "https://images.pokemontcg.io/zsv10pt5/28_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/157.png",
          large: "https://images.pokemontcg.io/zsv10pt5/157_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/165.png",
          large: "https://images.pokemontcg.io/zsv10pt5/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-121",
    name: "Lairon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Metal"],
    evolvesFrom: "Aron",
    evolvesTo: ["Aggron"],
    attacks: [
      {
        name: "Steel Tackle",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "This Pokémon also does 20 damage to itself.",
      },
      {
        name: "Metal Claw",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "121",
    flavorText:
      "Lairon live in mountains brimming with spring water and iron ore, so these Pokémon often came into conflict with humans in the past.",
    nationalPokedexNumbers: [305],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/121.png",
      large: "https://images.pokemontcg.io/sv6/121_hires.png",
    },
    altArts: [
      {
        id: "sv6-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/sv6/121.png",
          large: "https://images.pokemontcg.io/sv6/121_hires.png",
        },
        flavorText:
          "Lairon live in mountains brimming with spring water and iron ore, so these Pokémon often came into conflict with humans in the past.",
      },
      {
        id: "sv6-184",
        number: "184",
        images: {
          small: "https://images.pokemontcg.io/sv6/184.png",
          large: "https://images.pokemontcg.io/sv6/184_hires.png",
        },
        flavorText:
          "Lairon live in mountains brimming with spring water and iron ore, so these Pokémon often came into conflict with humans in the past.",
      },
    ],
  },
  {
    id: "rsv10pt5-17",
    name: "Lampent",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Fire"],
    evolvesFrom: "Litwick",
    evolvesTo: ["Chandelure"],
    attacks: [
      {
        name: "Fire Blast",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "17",
    flavorText:
      "This ominous Pokémon is feared. Through cities it wanders, searching for the spirits of the fallen.",
    nationalPokedexNumbers: [608],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/17.png",
      large: "https://images.pokemontcg.io/rsv10pt5/17_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/17.png",
          large: "https://images.pokemontcg.io/rsv10pt5/17_hires.png",
        },
        flavorText:
          "This ominous Pokémon is feared. Through cities it wanders, searching for the spirits of the fallen.",
      },
      {
        id: "rsv10pt5-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/102.png",
          large: "https://images.pokemontcg.io/rsv10pt5/102_hires.png",
        },
        flavorText:
          "This ominous Pokémon is feared. Through cities it wanders, searching for the spirits of the fallen.",
      },
    ],
  },
  {
    id: "me5-37",
    name: "Lampent",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Litwick",
    attacks: [
      {
        name: "Spreading Light",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Lampent and put them onto your Bench. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    flavorText:
      "Lampent appears at the moment of death and promptly absorbs the spirit as it leaves the body.",
    nationalPokedexNumbers: [608],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-37/small",
      large: "https://images.scrydex.com/pokemon/me5-37/large",
    },
    altArts: [
      {
        id: "me5-37",
        number: "37",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-37/small",
          large: "https://images.scrydex.com/pokemon/me5-37/large",
        },
        flavorText:
          "Lampent appears at the moment of death and promptly absorbs the spirit as it leaves the body.",
      },
    ],
  },
  {
    id: "sv6-37",
    name: "Lampent",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Fire"],
    evolvesFrom: "Litwick",
    evolvesTo: ["Chandelure"],
    attacks: [
      {
        name: "Live Coal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Burn It All Up",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    flavorText:
      "The spirits it absorbs fuel its baleful fire. It hangs around hospitals waiting for people to pass on.",
    nationalPokedexNumbers: [608],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/37.png",
      large: "https://images.pokemontcg.io/sv6/37_hires.png",
    },
    altArts: [
      {
        id: "sv6-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv6/37.png",
          large: "https://images.pokemontcg.io/sv6/37_hires.png",
        },
        flavorText:
          "The spirits it absorbs fuel its baleful fire. It hangs around hospitals waiting for people to pass on.",
      },
    ],
  },
  {
    id: "zsv10pt5-53",
    name: "Landorus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Abundant Harvest",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach a Basic Fighting Energy card from your discard pile to this Pokémon.",
      },
      {
        name: "Earthquake",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "This attack also does 10 damage to each of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "53",
    flavorText:
      "Lands visited by Landorus grant such bountiful crops that it has been hailed as “The Guardian of the Fields.”",
    nationalPokedexNumbers: [645],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/53.png",
      large: "https://images.pokemontcg.io/zsv10pt5/53_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/53.png",
          large: "https://images.pokemontcg.io/zsv10pt5/53_hires.png",
        },
        flavorText:
          "Lands visited by Landorus grant such bountiful crops that it has been hailed as “The Guardian of the Fields.”",
      },
      {
        id: "zsv10pt5-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/131.png",
          large: "https://images.pokemontcg.io/zsv10pt5/131_hires.png",
        },
        flavorText:
          "Lands visited by Landorus grant such bountiful crops that it has been hailed as “The Guardian of the Fields.”",
      },
    ],
  },
  {
    id: "me3-41",
    name: "Landorus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fighting"],
    attacks: [
      {
        name: "Rock Tumble",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "This attack's damage isn't affected by Resistance.",
      },
      {
        name: "Screw Knuckle",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Put an Energy attached to this Pokémon into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    nationalPokedexNumbers: [645],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-41/small",
      large: "https://images.scrydex.com/pokemon/me3-41/large",
    },
    altArts: [
      {
        id: "me3-41",
        number: "41",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-41/small",
          large: "https://images.scrydex.com/pokemon/me3-41/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-110",
    name: "Landorus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Fist of Focus",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Attach an Energy card from your discard pile to this Pokémon.",
      },
      {
        name: "Buster Swing",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "130",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "110",
    nationalPokedexNumbers: [645],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/110.png",
      large: "https://images.pokemontcg.io/sv8/110_hires.png",
    },
    altArts: [
      {
        id: "sv8-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/sv8/110.png",
          large: "https://images.pokemontcg.io/sv8/110_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-49",
    name: "Lanturn",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Chinchou",
    attacks: [
      {
        name: "Disorienting Flash",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Your opponent's Active Pokémon is now Confused. Put 8 damage counters instead of 3 on that Pokémon for this Special Condition.",
      },
      {
        name: "Thunderous Bolt",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "49",
    nationalPokedexNumbers: [171],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/49.png",
      large: "https://images.pokemontcg.io/sv7/49_hires.png",
    },
    altArts: [
      {
        id: "sv7-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/sv7/49.png",
          large: "https://images.pokemontcg.io/sv7/49_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-17",
    name: "Lapras",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Ferry Across",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Search your deck for a Supporter card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Ice Beam",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "17",
    nationalPokedexNumbers: [131],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-17/small",
      large: "https://images.scrydex.com/pokemon/me55-17/large",
    },
    altArts: [
      {
        id: "me55-17",
        number: "17",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-17/small",
          large: "https://images.scrydex.com/pokemon/me55-17/large",
        },
        flavorText: "",
      },
      {
        id: "me55-131",
        number: "131",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-131/small",
          large: "https://images.scrydex.com/pokemon/me55-131/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-31",
    name: "Lapras",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Water Gun",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Surf",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "31",
    nationalPokedexNumbers: [131],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/31.png",
      large: "https://images.pokemontcg.io/sv7/31_hires.png",
    },
    altArts: [
      {
        id: "sv7-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/sv7/31.png",
          large: "https://images.pokemontcg.io/sv7/31_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-22",
    name: "Lapras ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Hydro Turn",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each Water Energy attached to this Pokémon. Switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Surf",
        cost: ["Water", "Water", "Water"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "22",
    nationalPokedexNumbers: [131],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-22/small",
      large: "https://images.scrydex.com/pokemon/me3-22/large",
    },
    altArts: [
      {
        id: "me3-22",
        number: "22",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-22/small",
          large: "https://images.scrydex.com/pokemon/me3-22/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-32",
    name: "Lapras ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "220",
    types: ["Water"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Power Splash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "40×",
        text: "This attack does 40 damage for each Energy attached to this Pokémon.",
      },
      {
        name: "Larimar Rain",
        cost: ["Water", "Psychic", "Metal"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Look at the top 20 cards of your deck and attach any number of Energy cards you find there to your Pokémon in any way you like. Shuffle the other cards back into your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "32",
    nationalPokedexNumbers: [131],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/32.png",
      large: "https://images.pokemontcg.io/sv7/32_hires.png",
    },
    altArts: [
      {
        id: "sv7-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv7/32.png",
          large: "https://images.pokemontcg.io/sv7/32_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/sv7/158.png",
          large: "https://images.pokemontcg.io/sv7/158_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/svp/164.png",
          large: "https://images.pokemontcg.io/svp/164_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-174",
    name: "Larry's Braviary",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Colorless"],
    evolvesFrom: "Larry's Rufflet",
    attacks: [
      {
        name: "Clutch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Brave Bird",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "174",
    flavorText:
      "For the sake of its friends, this brave warrior of the sky will not stop battling, even if injured.",
    nationalPokedexNumbers: [628],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-174/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-174/large",
    },
    altArts: [
      {
        id: "me2pt5-174",
        number: "174",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-174/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-174/large",
        },
        flavorText:
          "For the sake of its friends, this brave warrior of the sky will not stop battling, even if injured.",
      },
    ],
  },
  {
    id: "me2pt5-164",
    name: "Larry's Dudunsparce ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Colorless"],
    evolvesFrom: "Larry's Dunsparce",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Work Rush",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80×",
        text: "Flip a coin for each Energy attached to this Pokémon. This attack does 80 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "164",
    nationalPokedexNumbers: [206],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-164/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-164/large",
    },
    altArts: [
      {
        id: "me2pt5-164",
        number: "164",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-164/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-164/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-163",
    name: "Larry's Dunsparce",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Rising Lunge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "163",
    flavorText:
      "If spotted, it escapes by burrowing with its tail. It can float just slightly using its wings.",
    nationalPokedexNumbers: [206],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-163/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-163/large",
    },
    altArts: [
      {
        id: "me2pt5-163",
        number: "163",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-163/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-163/large",
        },
        flavorText:
          "If spotted, it escapes by burrowing with its tail. It can float just slightly using its wings.",
      },
    ],
  },
  {
    id: "me2pt5-175",
    name: "Larry's Komala",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Colorless"],
    abilities: [
      {
        name: "Lethargic Charge",
        text: "Once during your turn, if this Pokémon is on your Bench, you may use this Ability. Attach an Energy card from your hand to your Active Larry's Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dozing Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This Pokémon is now Asleep. Draw 2 cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "175",
    flavorText:
      "A potent anesthetic can be made by diluting Komala’s drool. This anesthetic was used for surgeries in the past.",
    nationalPokedexNumbers: [775],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-175/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-175/large",
    },
    altArts: [
      {
        id: "me2pt5-175",
        number: "175",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-175/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-175/large",
        },
        flavorText:
          "A potent anesthetic can be made by diluting Komala’s drool. This anesthetic was used for surgeries in the past.",
      },
    ],
  },
  {
    id: "me2pt5-173",
    name: "Larry's Rufflet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Peck the Wound",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "173",
    flavorText:
      "With its sharp claws, this Pokémon pierces its prey, and then it pecks at them. Although it also consumes berries, it’s a carnivore at heart.",
    nationalPokedexNumbers: [627],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-173/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-173/large",
    },
    altArts: [
      {
        id: "me2pt5-173",
        number: "173",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-173/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-173/large",
        },
        flavorText:
          "With its sharp claws, this Pokémon pierces its prey, and then it pecks at them. Although it also consumes berries, it’s a carnivore at heart.",
      },
    ],
  },
  {
    id: "me2pt5-170",
    name: "Larry's Staraptor",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Colorless"],
    evolvesFrom: "Larry's Staravia",
    attacks: [
      {
        name: "Facade",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "If this Pokémon is Burned or Poisoned, this attack does 100 more damage.",
      },
      {
        name: "Feathery Strike",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Discard 2 Energy from this Pokémon, and this attack also does 50 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "170",
    flavorText:
      "It never stops attacking even if it is injured. It fusses over the shape of its comb.",
    nationalPokedexNumbers: [398],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-170/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-170/large",
    },
    altArts: [
      {
        id: "me2pt5-170",
        number: "170",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-170/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-170/large",
        },
        flavorText:
          "It never stops attacking even if it is injured. It fusses over the shape of its comb.",
      },
      {
        id: "me2pt5-249",
        number: "249",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-249/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-249/large",
        },
        flavorText:
          "It never stops attacking even if it is injured. It fusses over the shape of its comb.",
      },
    ],
  },
  {
    id: "me2pt5-169",
    name: "Larry's Staravia",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Larry's Starly",
    attacks: [
      {
        name: "Flap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Razor Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "169",
    flavorText:
      "They maintain huge flocks, although fierce scuffles break out between various flocks.",
    nationalPokedexNumbers: [397],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-169/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-169/large",
    },
    altArts: [
      {
        id: "me2pt5-169",
        number: "169",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-169/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-169/large",
        },
        flavorText:
          "They maintain huge flocks, although fierce scuffles break out between various flocks.",
      },
    ],
  },
  {
    id: "me2pt5-168",
    name: "Larry's Starly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    attacks: [
      {
        name: "Minor Errand-Running",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Glide",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "168",
    flavorText:
      "Because they are weak individually, they form groups. However, they bicker if the group grows too big.",
    nationalPokedexNumbers: [396],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-168/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-168/large",
    },
    altArts: [
      {
        id: "me2pt5-168",
        number: "168",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-168/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-168/large",
        },
        flavorText:
          "Because they are weak individually, they form groups. However, they bicker if the group grows too big.",
      },
    ],
  },
  {
    id: "zsv10pt5-15",
    name: "Larvesta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fire"],
    evolvesTo: ["Volcarona"],
    attacks: [
      {
        name: "Peck Off",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    flavorText:
      "This Pokémon was believed to have been born from the sun. When it evolves, its entire body is engulfed in flames.",
    nationalPokedexNumbers: [636],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/15.png",
      large: "https://images.pokemontcg.io/zsv10pt5/15_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/15.png",
          large: "https://images.pokemontcg.io/zsv10pt5/15_hires.png",
        },
        flavorText:
          "This Pokémon was believed to have been born from the sun. When it evolves, its entire body is engulfed in flames.",
      },
      {
        id: "zsv10pt5-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/99.png",
          large: "https://images.pokemontcg.io/zsv10pt5/99_hires.png",
        },
        flavorText:
          "This Pokémon was believed to have been born from the sun. When it evolves, its entire body is engulfed in flames.",
      },
    ],
  },
  {
    id: "sv8-24",
    name: "Larvesta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Volcarona"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Steady Firebreathing",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "24",
    nationalPokedexNumbers: [636],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/24.png",
      large: "https://images.pokemontcg.io/sv8/24_hires.png",
    },
    altArts: [
      {
        id: "sv8-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv8/24.png",
          large: "https://images.pokemontcg.io/sv8/24_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-196",
        number: "196",
        images: {
          small: "https://images.pokemontcg.io/sv8/196.png",
          large: "https://images.pokemontcg.io/sv8/196_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-28",
    name: "Larvesta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Volcarona"],
    attacks: [
      {
        name: "Will-O-Wisp",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "28",
    nationalPokedexNumbers: [636],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/28.png",
      large: "https://images.pokemontcg.io/sv9/28_hires.png",
    },
    altArts: [
      {
        id: "sv9-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv9/28.png",
          large: "https://images.pokemontcg.io/sv9/28_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-47",
    name: "Larvitar",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Pupitar"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "47",
    nationalPokedexNumbers: [246],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/47.png",
      large: "https://images.pokemontcg.io/sv8pt5/47_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/47.png",
          large: "https://images.pokemontcg.io/sv8pt5/47_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-80",
    name: "Larvitar",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Pupitar"],
    attacks: [
      {
        name: "Crunch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "80",
    nationalPokedexNumbers: [246],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/80.png",
      large: "https://images.pokemontcg.io/sv9/80_hires.png",
    },
    altArts: [
      {
        id: "sv9-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv9/80.png",
          large: "https://images.pokemontcg.io/sv9/80_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-67",
    name: "Latias",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Allure",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Lagoon Flight",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    flavorText:
      "It communicates using telepathy. Its body is covered in down that refracts light to make it invisible.",
    nationalPokedexNumbers: [380],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/67.png",
      large: "https://images.pokemontcg.io/sv5/67_hires.png",
    },
    altArts: [
      {
        id: "sv5-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv5/67.png",
          large: "https://images.pokemontcg.io/sv5/67_hires.png",
        },
        flavorText:
          "It communicates using telepathy. Its body is covered in down that refracts light to make it invisible.",
      },
    ],
  },
  {
    id: "sv8-76",
    name: "Latias ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Psychic"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Skyliner",
        text: "Your Basic Pokémon in play have no Retreat Cost.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Eon Blade",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "76",
    nationalPokedexNumbers: [380],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/76.png",
      large: "https://images.pokemontcg.io/sv8/76_hires.png",
    },
    altArts: [
      {
        id: "sv8-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv8/76.png",
          large: "https://images.pokemontcg.io/sv8/76_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-220",
        number: "220",
        images: {
          small: "https://images.pokemontcg.io/sv8/220.png",
          large: "https://images.pokemontcg.io/sv8/220_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-239",
        number: "239",
        images: {
          small: "https://images.pokemontcg.io/sv8/239.png",
          large: "https://images.pokemontcg.io/sv8/239_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-101",
    name: "Latios",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Dragon"],
    abilities: [
      {
        name: "Lustrous Assist",
        text: "Once during your turn, when your Mega Latias ex moves from your Bench to the Active Spot, you may use this Ability. Move any amount of Energy from your Benched Pokémon to your Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dragon Claw",
        cost: ["Water", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "101",
    nationalPokedexNumbers: [381],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/101.png",
      large: "https://images.pokemontcg.io/me1/101_hires.png",
    },
    altArts: [
      {
        id: "me1-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/me1/101.png",
          large: "https://images.pokemontcg.io/me1/101_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-77",
    name: "Latios",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Skill Dive",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 50 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Jet Headbutt",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "77",
    nationalPokedexNumbers: [381],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/77.png",
      large: "https://images.pokemontcg.io/sv8/77_hires.png",
    },
    altArts: [
      {
        id: "sv8-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv8/77.png",
          large: "https://images.pokemontcg.io/sv8/77_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-203",
        number: "203",
        images: {
          small: "https://images.pokemontcg.io/sv8/203.png",
          large: "https://images.pokemontcg.io/sv8/203_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-11",
    name: "Leafeon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Eevee",
    attacks: [
      {
        name: "Leaflet Blessings",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach a Basic Grass Energy card from your hand to 1 of your Benched Pokémon. If you do, heal all damage from that Pokémon.",
      },
      {
        name: "Solar Beam",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    flavorText:
      "The younger they are, the more they smell like fresh grass. With age, their fragrance takes on the odor of fallen leaves.",
    nationalPokedexNumbers: [470],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/11.png",
      large: "https://images.pokemontcg.io/sv6/11_hires.png",
    },
    altArts: [
      {
        id: "sv6-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv6/11.png",
          large: "https://images.pokemontcg.io/sv6/11_hires.png",
        },
        flavorText:
          "The younger they are, the more they smell like fresh grass. With age, their fragrance takes on the odor of fallen leaves.",
      },
      {
        id: "sv8pt5-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/5.png",
          large: "https://images.pokemontcg.io/sv8pt5/5_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-6",
    name: "Leafeon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "270",
    types: ["Grass"],
    evolvesFrom: "Eevee",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Verdant Storm",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: "This attack does 60 damage for each Energy attached to all of your opponent's Pokémon.",
      },
      {
        name: "Moss Agate",
        cost: ["Grass", "Fire", "Water"],
        convertedEnergyCost: 3,
        damage: "230",
        text: "Heal 100 damage from each of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "6",
    nationalPokedexNumbers: [470],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/6.png",
      large: "https://images.pokemontcg.io/sv8pt5/6_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/6.png",
          large: "https://images.pokemontcg.io/sv8pt5/6_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/144.png",
          large: "https://images.pokemontcg.io/sv8pt5/144_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-3",
    name: "Leavanny",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Swadloon",
    attacks: [
      {
        name: "Healing Wrapping",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 100 damage from each of your Basic Pokémon.",
      },
      {
        name: "X-Scissor",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90+",
        text: "Flip a coin. If heads, this attack does 40 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    flavorText:
      "Upon finding a small Pokémon, it weaves clothing for it from leaves, using the cutters on its arms and sticky silk.",
    nationalPokedexNumbers: [542],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/3.png",
      large: "https://images.pokemontcg.io/rsv10pt5/3_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/3.png",
          large: "https://images.pokemontcg.io/rsv10pt5/3_hires.png",
        },
        flavorText:
          "Upon finding a small Pokémon, it weaves clothing for it from leaves, using the cutters on its arms and sticky silk.",
      },
      {
        id: "rsv10pt5-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/89.png",
          large: "https://images.pokemontcg.io/rsv10pt5/89_hires.png",
        },
        flavorText:
          "Upon finding a small Pokémon, it weaves clothing for it from leaves, using the cutters on its arms and sticky silk.",
      },
    ],
  },
  {
    id: "sv7-126",
    name: "Lechonk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Colorless"],
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "126",
    nationalPokedexNumbers: [915],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/126.png",
      large: "https://images.pokemontcg.io/sv7/126_hires.png",
    },
    altArts: [
      {
        id: "sv7-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/sv7/126.png",
          large: "https://images.pokemontcg.io/sv7/126_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-139",
    name: "Lechonk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "139",
    nationalPokedexNumbers: [915],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/139.png",
      large: "https://images.pokemontcg.io/sv9/139_hires.png",
    },
    altArts: [
      {
        id: "sv9-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/sv9/139.png",
          large: "https://images.pokemontcg.io/sv9/139_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-3",
    name: "Ledian",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Ledyba",
    abilities: [
      {
        name: "Glittering Star Pattern",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may switch in 1 of your opponent's Benched Pokémon that has 90 HP or less remaining to the Active Spot.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Swift",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "This attack's damage isn't affected by Weakness or Resistance, or by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "3",
    nationalPokedexNumbers: [166],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/3.png",
      large: "https://images.pokemontcg.io/sv7/3_hires.png",
    },
    altArts: [
      {
        id: "sv7-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv7/3.png",
          large: "https://images.pokemontcg.io/sv7/3_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/sv7/144.png",
          large: "https://images.pokemontcg.io/sv7/144_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/svp/133.png",
          large: "https://images.pokemontcg.io/svp/133_hires.png",
        },
        flavorText:
          "When the stars flicker in the night sky, it flutters about, scattering a glowing powder.",
      },
    ],
  },
  {
    id: "sv7-2",
    name: "Ledyba",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Ledian"],
    attacks: [
      {
        name: "Headbutt Bounce",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    nationalPokedexNumbers: [165],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/2.png",
      large: "https://images.pokemontcg.io/sv7/2_hires.png",
    },
    altArts: [
      {
        id: "sv7-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv7/2.png",
          large: "https://images.pokemontcg.io/sv7/2_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-125",
    name: "Lickilicky",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Colorless"],
    evolvesFrom: "Lickitung",
    attacks: [
      {
        name: "Body Slam",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Tonguenado",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "70×",
        text: "Flip 4 coins. This attack does 70 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "125",
    flavorText:
      "Lickilicky's strange tongue can stretch to many times the length of its body. No one has figured out how Lickilicky's tongue can stretch so far.",
    nationalPokedexNumbers: [463],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/125.png",
      large: "https://images.pokemontcg.io/sv5/125_hires.png",
    },
    altArts: [
      {
        id: "sv5-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/sv5/125.png",
          large: "https://images.pokemontcg.io/sv5/125_hires.png",
        },
        flavorText:
          "Lickilicky's strange tongue can stretch to many times the length of its body. No one has figured out how Lickilicky's tongue can stretch so far.",
      },
    ],
  },
  {
    id: "sv5-124",
    name: "Lickitung",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Colorless"],
    evolvesTo: ["Lickilicky"],
    attacks: [
      {
        name: "Tongue Pull",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent reveals their hand. Put up to 2 Basic Pokémon you find there onto your opponent's Bench.",
      },
      {
        name: "Strength",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "124",
    flavorText:
      "If this Pokémon's sticky saliva gets on you and you don't clean it off, an intense itch will set in. The itch won't go away, either.",
    nationalPokedexNumbers: [108],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/124.png",
      large: "https://images.pokemontcg.io/sv5/124_hires.png",
    },
    altArts: [
      {
        id: "sv5-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/sv5/124.png",
          large: "https://images.pokemontcg.io/sv5/124_hires.png",
        },
        flavorText:
          "If this Pokémon's sticky saliva gets on you and you don't clean it off, an intense itch will set in. The itch won't go away, either.",
      },
      {
        id: "sv5-180",
        number: "180",
        images: {
          small: "https://images.pokemontcg.io/sv5/180.png",
          large: "https://images.pokemontcg.io/sv5/180_hires.png",
        },
        flavorText:
          "If this Pokémon's sticky saliva gets on you and you don't clean it off, an intense itch will set in. The itch won't go away, either.",
      },
    ],
  },
  {
    id: "rsv10pt5-56",
    name: "Liepard",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Darkness"],
    evolvesFrom: "Purrloin",
    attacks: [
      {
        name: "Knock Off",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Discard a random card from your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "56",
    flavorText:
      "These Pokémon vanish and appear unexpectedly. Many Trainers are drawn to their beautiful form and fur.",
    nationalPokedexNumbers: [510],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/56.png",
      large: "https://images.pokemontcg.io/rsv10pt5/56_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/56.png",
          large: "https://images.pokemontcg.io/rsv10pt5/56_hires.png",
        },
        flavorText:
          "These Pokémon vanish and appear unexpectedly. Many Trainers are drawn to their beautiful form and fur.",
      },
      {
        id: "rsv10pt5-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/137.png",
          large: "https://images.pokemontcg.io/rsv10pt5/137_hires.png",
        },
        flavorText:
          "These Pokémon vanish and appear unexpectedly. Many Trainers are drawn to their beautiful form and fur.",
      },
    ],
  },
  {
    id: "sv7-5",
    name: "Lileep",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Antique Root Fossil",
    evolvesTo: ["Cradily"],
    attacks: [
      {
        name: "Bind Down",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    nationalPokedexNumbers: [345],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/5.png",
      large: "https://images.pokemontcg.io/sv7/5_hires.png",
    },
    altArts: [
      {
        id: "sv7-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv7/5.png",
          large: "https://images.pokemontcg.io/sv7/5_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/sv7/145.png",
          large: "https://images.pokemontcg.io/sv7/145_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-76",
    name: "Lillie's Clefairy ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Psychic"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Fairy Zone",
        text: "The Weakness of each of your opponent's Dragon Pokémon in play is now Psychic. (Apply Weakness as ×2.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Full Moon Rondo",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 20 more damage for each Benched Pokémon (both yours and your opponent's).",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "76",
    nationalPokedexNumbers: [35],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-76/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-76/large",
    },
    altArts: [
      {
        id: "me2pt5-76",
        number: "76",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-76/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-76/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-280",
        number: "280",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-280/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-280/large",
        },
        flavorText: "",
      },
      {
        id: "sv9-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/sv9/56.png",
          large: "https://images.pokemontcg.io/sv9/56_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/sv9/173.png",
          large: "https://images.pokemontcg.io/sv9/173_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-184",
        number: "184",
        images: {
          small: "https://images.pokemontcg.io/sv9/184.png",
          large: "https://images.pokemontcg.io/sv9/184_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-68",
    name: "Lillie's Comfey",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Inviting Flowers",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "You may search your deck for any number of Basic Lillie's Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Fade Out",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Put this Pokémon and all attached cards into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "68",
    nationalPokedexNumbers: [764],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/68.png",
      large: "https://images.pokemontcg.io/sv9/68_hires.png",
    },
    altArts: [
      {
        id: "sv9-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv9/68.png",
          large: "https://images.pokemontcg.io/sv9/68_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-66",
    name: "Lillie's Cutiefly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Psychic"],
    evolvesTo: ["Ribombee"],
    attacks: [
      {
        name: "Hold Still",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 10 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    number: "66",
    nationalPokedexNumbers: [742],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/66.png",
      large: "https://images.pokemontcg.io/sv9/66_hires.png",
    },
    altArts: [
      {
        id: "sv9-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv9/66.png",
          large: "https://images.pokemontcg.io/sv9/66_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-67",
    name: "Lillie's Ribombee",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Psychic"],
    evolvesFrom: "Lillie's Cutiefly",
    abilities: [
      {
        name: "Inviting Wink",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may have your opponent reveal their hand and you put any number of Basic Pokémon you find there onto their Bench.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Magical Shot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    number: "67",
    nationalPokedexNumbers: [743],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/67.png",
      large: "https://images.pokemontcg.io/sv9/67_hires.png",
    },
    altArts: [
      {
        id: "sv9-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv9/67.png",
          large: "https://images.pokemontcg.io/sv9/67_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/sv9/164.png",
          large: "https://images.pokemontcg.io/sv9/164_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-7",
    name: "Lilligant",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Petilil",
    attacks: [
      {
        name: "Bemusing Aroma",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed and Poisoned. If tails, your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Cut",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    flavorText:
      "Even veteran Trainers face a challenge in getting its beautiful flower to bloom. This Pokémon is popular with celebrities.",
    nationalPokedexNumbers: [549],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/7.png",
      large: "https://images.pokemontcg.io/zsv10pt5/7_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/7.png",
          large: "https://images.pokemontcg.io/zsv10pt5/7_hires.png",
        },
        flavorText:
          "Even veteran Trainers face a challenge in getting its beautiful flower to bloom. This Pokémon is popular with celebrities.",
      },
      {
        id: "zsv10pt5-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/92.png",
          large: "https://images.pokemontcg.io/zsv10pt5/92_hires.png",
        },
        flavorText:
          "Even veteran Trainers face a challenge in getting its beautiful flower to bloom. This Pokémon is popular with celebrities.",
      },
    ],
  },
  {
    id: "sv9-7",
    name: "Lilligant",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Grass"],
    evolvesFrom: "Petilil",
    abilities: [
      {
        name: "Sunny Day",
        text: "Attacks used by your Grass Pokémon and Fire Pokémon do 20 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Spinning Attack",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "7",
    nationalPokedexNumbers: [549],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/7.png",
      large: "https://images.pokemontcg.io/sv9/7_hires.png",
    },
    altArts: [
      {
        id: "sv9-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv9/7.png",
          large: "https://images.pokemontcg.io/sv9/7_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-74",
    name: "Lillipup",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Herdier"],
    attacks: [
      {
        name: "Play Rough",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "74",
    flavorText:
      "It faces strong opponents with great courage. But, when at a disadvantage in a fight, this intelligent Pokémon flees.",
    nationalPokedexNumbers: [506],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/74.png",
      large: "https://images.pokemontcg.io/rsv10pt5/74_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/74.png",
          large: "https://images.pokemontcg.io/rsv10pt5/74_hires.png",
        },
        flavorText:
          "It faces strong opponents with great courage. But, when at a disadvantage in a fight, this intelligent Pokémon flees.",
      },
      {
        id: "rsv10pt5-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/154.png",
          large: "https://images.pokemontcg.io/rsv10pt5/154_hires.png",
        },
        flavorText:
          "It faces strong opponents with great courage. But, when at a disadvantage in a fight, this intelligent Pokémon flees.",
      },
    ],
  },
  {
    id: "me2-82",
    name: "Linoone",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Zigzagoon",
    abilities: [
      {
        name: "Excited Dash",
        text: "Once during your turn, if this Pokémon is on your Bench, and if you have any Mega Evolution Pokémon ex in play, you may use this Ability. Switch this Pokémon with your Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Slash",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "82",
    flavorText:
      "It uses its explosive speed and razor-sharp claws to bring down prey. Running along winding paths is not its strong suit.",
    nationalPokedexNumbers: [264],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/82.png",
      large: "https://images.pokemontcg.io/me2/82_hires.png",
    },
    altArts: [
      {
        id: "me2-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/me2/82.png",
          large: "https://images.pokemontcg.io/me2/82_hires.png",
        },
        flavorText:
          "It uses its explosive speed and razor-sharp claws to bring down prey. Running along winding paths is not its strong suit.",
      },
    ],
  },
  {
    id: "me1-23",
    name: "Litleo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Pyroar"],
    attacks: [
      {
        name: "Flare",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    nationalPokedexNumbers: [667],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/23.png",
      large: "https://images.pokemontcg.io/me1/23_hires.png",
    },
    altArts: [
      {
        id: "me1-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/me1/23.png",
          large: "https://images.pokemontcg.io/me1/23_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/me1/139.png",
          large: "https://images.pokemontcg.io/me1/139_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-14",
    name: "Litleo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    flavorText:
      "They set off on their own from their pride and live by themselves to become stronger. These hot-blooded Pokémon are quick to fight.",
    nationalPokedexNumbers: [667],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-14/small",
      large: "https://images.scrydex.com/pokemon/me4-14/large",
    },
    altArts: [
      {
        id: "me4-14",
        number: "14",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-14/small",
          large: "https://images.scrydex.com/pokemon/me4-14/large",
        },
        flavorText:
          "They set off on their own from their pride and live by themselves to become stronger. These hot-blooded Pokémon are quick to fight.",
      },
    ],
  },
  {
    id: "sv8pt5-15",
    name: "Litleo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Pyroar"],
    attacks: [
      {
        name: "Combustion",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Headbutt",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    nationalPokedexNumbers: [667],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/15.png",
      large: "https://images.pokemontcg.io/sv8pt5/15_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/15.png",
          large: "https://images.pokemontcg.io/sv8pt5/15_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-32",
    name: "Litten",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Torracat"],
    attacks: [
      {
        name: "Fake Out",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "32",
    flavorText:
      "It spends even the smallest amount of downtime grooming its fur with its tongue. Loose fur gathers in its stomach and serves as fuel for fiery moves.",
    nationalPokedexNumbers: [725],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/32.png",
      large: "https://images.pokemontcg.io/sv5/32_hires.png",
    },
    altArts: [
      {
        id: "sv5-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv5/32.png",
          large: "https://images.pokemontcg.io/sv5/32_hires.png",
        },
        flavorText:
          "It spends even the smallest amount of downtime grooming its fur with its tongue. Loose fur gathers in its stomach and serves as fuel for fiery moves.",
      },
      {
        id: "sv5-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/sv5/167.png",
          large: "https://images.pokemontcg.io/sv5/167_hires.png",
        },
        flavorText:
          "It spends even the smallest amount of downtime grooming its fur with its tongue. Loose fur gathers in its stomach and serves as fuel for fiery moves.",
      },
    ],
  },
  {
    id: "rsv10pt5-16",
    name: "Litwick",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fire"],
    evolvesTo: ["Lampent"],
    attacks: [
      {
        name: "Brighten and Burn",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top card of your deck. You may discard that card.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    flavorText:
      "Litwick shines a light that absorbs the life energy of people and Pokémon, which becomes the fuel that it burns.",
    nationalPokedexNumbers: [607],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/16.png",
      large: "https://images.pokemontcg.io/rsv10pt5/16_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/16.png",
          large: "https://images.pokemontcg.io/rsv10pt5/16_hires.png",
        },
        flavorText:
          "Litwick shines a light that absorbs the life energy of people and Pokémon, which becomes the fuel that it burns.",
      },
      {
        id: "rsv10pt5-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/101.png",
          large: "https://images.pokemontcg.io/rsv10pt5/101_hires.png",
        },
        flavorText:
          "Litwick shines a light that absorbs the life energy of people and Pokémon, which becomes the fuel that it burns.",
      },
    ],
  },
  {
    id: "me5-36",
    name: "Litwick",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Will-O-Wisp",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    flavorText:
      "Litwick shines a light that absorbs the life energy of people and Pokémon, which becomes the fuel that it burns.",
    nationalPokedexNumbers: [607],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-36/small",
      large: "https://images.scrydex.com/pokemon/me5-36/large",
    },
    altArts: [
      {
        id: "me5-36",
        number: "36",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-36/small",
          large: "https://images.scrydex.com/pokemon/me5-36/large",
        },
        flavorText:
          "Litwick shines a light that absorbs the life energy of people and Pokémon, which becomes the fuel that it burns.",
      },
    ],
  },
  {
    id: "sv6-36",
    name: "Litwick",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fire"],
    evolvesTo: ["Lampent"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Pokémon and put it onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Live Coal",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    flavorText:
      "While shining a light and pretending to be a guide, it leeches off the life-force of any who follow it.",
    nationalPokedexNumbers: [607],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/36.png",
      large: "https://images.pokemontcg.io/sv6/36_hires.png",
    },
    altArts: [
      {
        id: "sv6-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv6/36.png",
          large: "https://images.pokemontcg.io/sv6/36_hires.png",
        },
        flavorText:
          "While shining a light and pretending to be a guide, it leeches off the life-force of any who follow it.",
      },
    ],
  },
  {
    id: "me2-10",
    name: "Lokix",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Nymble",
    attacks: [
      {
        name: "Low Kick",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Jumping Shot",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Shuffle this Pokémon and all attached cards into your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    flavorText:
      "When it decides to fight all out, it stands on its previously folded legs to enter Showdown Mode. It neutralizes its enemies in short order.",
    nationalPokedexNumbers: [920],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/10.png",
      large: "https://images.pokemontcg.io/me2/10_hires.png",
    },
    altArts: [
      {
        id: "me2-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/me2/10.png",
          large: "https://images.pokemontcg.io/me2/10_hires.png",
        },
        flavorText:
          "When it decides to fight all out, it stands on its previously folded legs to enter Showdown Mode. It neutralizes its enemies in short order.",
      },
    ],
  },
  {
    id: "sv7-16",
    name: "Lokix",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Grass"],
    evolvesFrom: "Nymble",
    attacks: [
      {
        name: "Spiral Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    nationalPokedexNumbers: [920],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/16.png",
      large: "https://images.pokemontcg.io/sv7/16_hires.png",
    },
    altArts: [
      {
        id: "sv7-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv7/16.png",
          large: "https://images.pokemontcg.io/sv7/16_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-100",
    name: "Lokix",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Nymble",
    attacks: [
      {
        name: "Low Sweep",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "100",
    nationalPokedexNumbers: [920],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/100.png",
      large: "https://images.pokemontcg.io/sv9/100_hires.png",
    },
    altArts: [
      {
        id: "sv9-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/sv9/100.png",
          large: "https://images.pokemontcg.io/sv9/100_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-6",
    name: "Lombre",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Lotad",
    evolvesTo: ["Ludicolo"],
    attacks: [
      {
        name: "Mega Drain",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    flavorText:
      "It prefers waterfronts with plentiful food. It became nocturnal so it wouldn't have to compete for food with bird Pokémon.",
    nationalPokedexNumbers: [271],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/6.png",
      large: "https://images.pokemontcg.io/me2/6_hires.png",
    },
    altArts: [
      {
        id: "me2-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/me2/6.png",
          large: "https://images.pokemontcg.io/me2/6_hires.png",
        },
        flavorText:
          "It prefers waterfronts with plentiful food. It became nocturnal so it wouldn't have to compete for food with bird Pokémon.",
      },
    ],
  },
  {
    id: "sv9-36",
    name: "Lombre",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Lotad",
    evolvesTo: ["Ludicolo"],
    attacks: [
      {
        name: "Aqua Slash",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    nationalPokedexNumbers: [271],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/36.png",
      large: "https://images.pokemontcg.io/sv9/36_hires.png",
    },
    altArts: [
      {
        id: "sv9-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv9/36.png",
          large: "https://images.pokemontcg.io/sv9/36_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-108",
    name: "Lopunny",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Buneary",
    attacks: [
      {
        name: "Dashing Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 50 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Spiral Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "108",
    nationalPokedexNumbers: [428],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/108.png",
      large: "https://images.pokemontcg.io/me1/108_hires.png",
    },
    altArts: [
      {
        id: "me1-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/me1/108.png",
          large: "https://images.pokemontcg.io/me1/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-84",
    name: "Lopunny",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Buneary",
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "84",
    nationalPokedexNumbers: [428],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/84.png",
      large: "https://images.pokemontcg.io/sv8pt5/84_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/84.png",
          large: "https://images.pokemontcg.io/sv8pt5/84_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-5",
    name: "Lotad",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Lombre"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "5",
    flavorText:
      "The leaf on its head is naturally dirt repellent and will stay clean even after transporting Pokémon that are covered in mud.",
    nationalPokedexNumbers: [270],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/5.png",
      large: "https://images.pokemontcg.io/me2/5_hires.png",
    },
    altArts: [
      {
        id: "me2-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/me2/5.png",
          large: "https://images.pokemontcg.io/me2/5_hires.png",
        },
        flavorText:
          "The leaf on its head is naturally dirt repellent and will stay clean even after transporting Pokémon that are covered in mud.",
      },
    ],
  },
  {
    id: "sv9-35",
    name: "Lotad",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Lombre"],
    attacks: [
      {
        name: "Water Gun",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    nationalPokedexNumbers: [270],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/35.png",
      large: "https://images.pokemontcg.io/sv9/35_hires.png",
    },
    altArts: [
      {
        id: "sv9-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv9/35.png",
          large: "https://images.pokemontcg.io/sv9/35_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-83",
    name: "Lucario",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Riolu",
    attacks: [
      {
        name: "Aura Sphere",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "This attack also does 60 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "83",
    nationalPokedexNumbers: [448],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-83/small",
      large: "https://images.scrydex.com/pokemon/me55-83/large",
    },
    altArts: [
      {
        id: "me55-83",
        number: "83",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-83/small",
          large: "https://images.scrydex.com/pokemon/me55-83/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-82",
    name: "Lucario ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "250",
    types: ["Fighting"],
    evolvesFrom: "Riolu",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Low Kick",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Aura Knuckle",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "82",
    nationalPokedexNumbers: [448],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/82.png",
      large: "https://images.pokemontcg.io/sv7/82_hires.png",
    },
    altArts: [
      {
        id: "sv7-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv7/82.png",
          large: "https://images.pokemontcg.io/sv7/82_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-51",
    name: "Lucario ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Fighting"],
    evolvesFrom: "Riolu",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Aura Uppercut",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
      {
        name: "Tornado Rush",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "During your next turn, this Pokémon's Tornado Rush attack does 100 more damage (before applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "51",
    nationalPokedexNumbers: [448],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/51.png",
      large: "https://images.pokemontcg.io/sv8pt5/51_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/51.png",
          large: "https://images.pokemontcg.io/sv8pt5/51_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-7",
    name: "Ludicolo",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Grass"],
    evolvesFrom: "Lombre",
    abilities: [
      {
        name: "Excited Heal",
        text: "Once during your turn, if you have any Grass Mega Evolution Pokémon ex in play, you may use this Ability. Heal 60 damage from 1 of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Lunge Out",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "7",
    flavorText:
      "There are structures throughout its whole body that produce energy when hit by sound waves with a cheerful rhythm.",
    nationalPokedexNumbers: [272],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/7.png",
      large: "https://images.pokemontcg.io/me2/7_hires.png",
    },
    altArts: [
      {
        id: "me2-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/me2/7.png",
          large: "https://images.pokemontcg.io/me2/7_hires.png",
        },
        flavorText:
          "There are structures throughout its whole body that produce energy when hit by sound waves with a cheerful rhythm.",
      },
      {
        id: "me2-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/me2/95.png",
          large: "https://images.pokemontcg.io/me2/95_hires.png",
        },
        flavorText:
          "There are structures throughout its whole body that produce energy when hit by sound waves with a cheerful rhythm.",
      },
    ],
  },
  {
    id: "sv9-37",
    name: "Ludicolo",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Water"],
    evolvesFrom: "Lombre",
    abilities: [
      {
        name: "Vibrant Dance",
        text: "All of your Pokémon in play get +40 HP. The effect of Vibrant Dance doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hydro Splash",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "37",
    nationalPokedexNumbers: [272],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/37.png",
      large: "https://images.pokemontcg.io/sv9/37_hires.png",
    },
    altArts: [
      {
        id: "sv9-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv9/37.png",
          large: "https://images.pokemontcg.io/sv9/37_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-121",
    name: "Lugia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Elemental Blast",
        cost: ["Fire", "Water", "Lightning"],
        convertedEnergyCost: 3,
        damage: "250",
        text: "Discard a Fire Energy, a Water Energy, and a Lightning Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "121",
    nationalPokedexNumbers: [249],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-121/small",
      large: "https://images.scrydex.com/pokemon/me55-121/large",
    },
    altArts: [
      {
        id: "me55-121",
        number: "121",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-121/small",
          large: "https://images.scrydex.com/pokemon/me55-121/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-149",
    name: "Lugia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Colorless"],
    abilities: [
      {
        name: "Crystal Type",
        text: "Whenever you attach a Fire, Water, or Psychic basic Energy card from your hand to Lugia, Lugia's type (color) becomes the same as that Energy card type until the end of the turn.",
        type: "Poké-BODY",
      },
    ],
    attacks: [
      {
        name: "Psychic",
        cost: ["Psychic", "Fire"],
        convertedEnergyCost: 2,
        damage: "10×",
        text: "This attack does 10 damage times the number of Energy cards attached to the Defending Pokémon.",
      },
      {
        name: "Steam Blast",
        cost: ["Water", "Water", "Fire", "Colorless"],
        convertedEnergyCost: 4,
        damage: "50",
        text: "Discard an Energy card attached to Lugia.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "149",
    nationalPokedexNumbers: [249],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-149/small",
      large: "https://images.scrydex.com/pokemon/me55c-149/large",
    },
    altArts: [
      {
        id: "me55c-149",
        number: "149",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-149/small",
          large: "https://images.scrydex.com/pokemon/me55c-149/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-82",
    name: "Lugia ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "220",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Hyper Whirlpool",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "Flip a coin until you get tails. For each heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "82",
    nationalPokedexNumbers: [249],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/82.png",
      large: "https://images.pokemontcg.io/sv8pt5/82_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/82.png",
          large: "https://images.pokemontcg.io/sv8pt5/82_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-36",
    name: "Lumineon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Finneon",
    attacks: [
      {
        name: "Return",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may draw cards until you have 6 cards in your hand.",
      },
      {
        name: "Razor Fin",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    nationalPokedexNumbers: [457],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/36.png",
      large: "https://images.pokemontcg.io/sv7/36_hires.png",
    },
    altArts: [
      {
        id: "sv7-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv7/36.png",
          large: "https://images.pokemontcg.io/sv7/36_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-80",
    name: "Lunala",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Psychic"],
    evolvesFrom: "Cosmoem",
    attacks: [
      {
        name: "Midnight Ray",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "This attack does 20 more damage for each Energy card in your discard pile.",
      },
      {
        name: "Lunar Blast",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "80",
    nationalPokedexNumbers: [792],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-80/small",
      large: "https://images.scrydex.com/pokemon/me55-80/large",
    },
    altArts: [
      {
        id: "me55-80",
        number: "80",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-80/small",
          large: "https://images.scrydex.com/pokemon/me55-80/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-74",
    name: "Lunatone",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    abilities: [
      {
        name: "Lunar Cycle",
        text: "Once during your turn, if you have Solrock in play, you may discard a Basic Fighting Energy card from your hand in order to use this Ability. Draw 3 cards. You can't use more than 1 Lunar Cycle Ability each turn.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Power Gem",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "74",
    nationalPokedexNumbers: [337],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/74.png",
      large: "https://images.pokemontcg.io/me1/74_hires.png",
    },
    altArts: [
      {
        id: "me1-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/me1/74.png",
          large: "https://images.pokemontcg.io/me1/74_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-105",
        number: "105",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-105/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-105/large",
        },
        flavorText:
          "It was discovered at the site of a meteor strike 40 years ago. Its stare can lull its foes to sleep.",
      },
    ],
  },
  {
    id: "sv10-14",
    name: "Lurantis",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Fomantis",
    attacks: [
      {
        name: "Razor Leaf",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Petal Blade Dance",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "130",
        text: "Discard 2 Basic Grass Energy cards from your hand. If you can't discard 2 cards in this way, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    nationalPokedexNumbers: [754],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/14.png",
      large: "https://images.pokemontcg.io/sv10/14_hires.png",
    },
    altArts: [
      {
        id: "sv10-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv10/14.png",
          large: "https://images.pokemontcg.io/sv10/14_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-4",
    name: "Lurantis ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Grass"],
    evolvesFrom: "Fomantis",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Lively Cutter",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "If this Pokémon was healed during this turn, this attack does 200 more damage.",
      },
      {
        name: "Leaf Guard",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "140",
        text: "During your opponent's next turn, this Pokémon takes 50 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    nationalPokedexNumbers: [754],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-4/small",
      large: "https://images.scrydex.com/pokemon/me5-4/large",
    },
    altArts: [
      {
        id: "me5-4",
        number: "4",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-4/small",
          large: "https://images.scrydex.com/pokemon/me5-4/large",
        },
        flavorText: "",
      },
      {
        id: "me5-96",
        number: "96",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-96/small",
          large: "https://images.scrydex.com/pokemon/me5-96/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-27",
    name: "Luxio",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Shinx",
    abilities: [
      {
        name: "Fighting Roar",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this Pokémon can evolve during your first turn or the turn you play it.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Static Shock",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "27",
    nationalPokedexNumbers: [404],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-27/small",
      large: "https://images.scrydex.com/pokemon/me3-27/large",
    },
    altArts: [
      {
        id: "me3-27",
        number: "27",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-27/small",
          large: "https://images.scrydex.com/pokemon/me3-27/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-67",
    name: "Luxio",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Shinx",
    evolvesTo: ["Luxray"],
    attacks: [
      {
        name: "Big Bite",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    flavorText:
      "By gathering their tails together, they collectively generate powerful electricity from their claws.",
    nationalPokedexNumbers: [404],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/67.png",
      large: "https://images.pokemontcg.io/sv6/67_hires.png",
    },
    altArts: [
      {
        id: "sv6-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv6/67.png",
          large: "https://images.pokemontcg.io/sv6/67_hires.png",
        },
        flavorText:
          "By gathering their tails together, they collectively generate powerful electricity from their claws.",
      },
    ],
  },
  {
    id: "me3-28",
    name: "Luxray",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Lightning"],
    evolvesFrom: "Luxio",
    attacks: [
      {
        name: "Incessant Onslaught",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70×",
        text: "This attack does 70 damage for each Prize card you have taken.",
      },
      {
        name: "Strong Volt",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "28",
    nationalPokedexNumbers: [405],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-28/small",
      large: "https://images.scrydex.com/pokemon/me3-28/large",
    },
    altArts: [
      {
        id: "me3-28",
        number: "28",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-28/small",
          large: "https://images.scrydex.com/pokemon/me3-28/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-68",
    name: "Luxray ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "310",
    types: ["Lightning"],
    evolvesFrom: "Luxio",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Piercing Gaze",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "Your opponent reveals their hand. Discard a card you find there.",
      },
      {
        name: "Volt Strike",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "250",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "68",
    nationalPokedexNumbers: [405],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/68.png",
      large: "https://images.pokemontcg.io/sv6/68_hires.png",
    },
    altArts: [
      {
        id: "sv6-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/sv6/68.png",
          large: "https://images.pokemontcg.io/sv6/68_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-195",
        number: "195",
        images: {
          small: "https://images.pokemontcg.io/sv6/195.png",
          large: "https://images.pokemontcg.io/sv6/195_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-85",
    name: "Lycanroc",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Rockruff",
    attacks: [
      {
        name: "Counter",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If this Pokémon was damaged by an attack during your opponent's last turn, this attack does that much more damage.",
      },
      {
        name: "Boulder Crush",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "80",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "85",
    nationalPokedexNumbers: [745],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-85/small",
      large: "https://images.scrydex.com/pokemon/me55-85/large",
    },
    altArts: [
      {
        id: "me55-85",
        number: "85",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-85/small",
          large: "https://images.scrydex.com/pokemon/me55-85/large",
        },
        flavorText: "",
      },
      {
        id: "me55-138",
        number: "138",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-138/small",
          large: "https://images.scrydex.com/pokemon/me55-138/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-90",
    name: "Lycanroc",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Rockruff",
    attacks: [
      {
        name: "Turbo Edge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Attach up to 2 Basic Fighting Energy cards from your discard pile to your Benched Pokémon in any way you like.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "90",
    flavorText:
      "Lycanroc attacks its prey with its sharp claws and fangs. It loyally obeys the instructions of a Trainer it trusts.",
    nationalPokedexNumbers: [745],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/90.png",
      large: "https://images.pokemontcg.io/sv5/90_hires.png",
    },
    altArts: [
      {
        id: "sv5-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv5/90.png",
          large: "https://images.pokemontcg.io/sv5/90_hires.png",
        },
        flavorText:
          "Lycanroc attacks its prey with its sharp claws and fangs. It loyally obeys the instructions of a Trainer it trusts.",
      },
    ],
  },
  {
    id: "sv9-85",
    name: "Lycanroc",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Rockruff",
    abilities: [
      {
        name: "Spike-Clad",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may attach up to 2 Spiky Energy cards from your discard pile to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Clamping Fangs",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40+",
        text: "This attack does 40 more damage for each damage counter on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "85",
    nationalPokedexNumbers: [745],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/85.png",
      large: "https://images.pokemontcg.io/sv9/85_hires.png",
    },
    altArts: [
      {
        id: "sv9-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv9/85.png",
          large: "https://images.pokemontcg.io/sv9/85_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/sv9/166.png",
          large: "https://images.pokemontcg.io/sv9/166_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-106m",
    name: "M Gardevoir-EX",
    supertype: "Pokémon",
    subtypes: ["MEGA", "EX"],
    hp: "210",
    types: ["Fairy"],
    evolvesFrom: "Gardevoir-EX",
    rules: [
      "When 1 of your Pokémon becomes a Mega Evolution Pokémon, your turn ends.",
      "When a Pokémon-EX has been Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Brilliant Arrow",
        cost: ["Fairy", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30×",
        text: "This attack does 30 damage times the number of Fairy Energy attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Darkness",
        value: "-20",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "106",
    nationalPokedexNumbers: [282],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-106m/small",
      large: "https://images.scrydex.com/pokemon/me55c-106m/large",
    },
    altArts: [
      {
        id: "me55c-106m",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-106m/small",
          large: "https://images.scrydex.com/pokemon/me55c-106m/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-58",
    name: "Mabosstiff",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Maschiff",
    attacks: [
      {
        name: "Bite",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
      {
        name: "Plunging Headbutt",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "During your opponent's next turn, this Pokémon takes 100 more damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "58",
    flavorText:
      "Mabosstiff loves playing with children. Though usually gentle, it takes on an intimidating look when protecting its family.",
    nationalPokedexNumbers: [943],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-58/small",
      large: "https://images.scrydex.com/pokemon/me5-58/large",
    },
    altArts: [
      {
        id: "me5-58",
        number: "58",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-58/small",
          large: "https://images.scrydex.com/pokemon/me5-58/large",
        },
        flavorText:
          "Mabosstiff loves playing with children. Though usually gentle, it takes on an intimidating look when protecting its family.",
      },
    ],
  },
  {
    id: "sv5-29",
    name: "Magcargo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Slugma",
    abilities: [
      {
        name: "Lava Zone",
        text: "Whenever your opponent's Active Pokémon moves to the Bench during their turn, their new Active Pokémon is now Burned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Heat Blast",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "29",
    flavorText:
      "Its brittle shell occasionally spouts intense flames that circulate throughout its body.",
    nationalPokedexNumbers: [219],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/29.png",
      large: "https://images.pokemontcg.io/sv5/29_hires.png",
    },
    altArts: [
      {
        id: "sv5-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/sv5/29.png",
          large: "https://images.pokemontcg.io/sv5/29_hires.png",
        },
        flavorText:
          "Its brittle shell occasionally spouts intense flames that circulate throughout its body.",
      },
    ],
  },
  {
    id: "sv6-29",
    name: "Magcargo ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "270",
    types: ["Fire"],
    evolvesFrom: "Slugma",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Hot Magma",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Ground Burn",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140+",
        text: "Discard the top card of each player's deck. This attack does 140 more damage for each Energy card discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "29",
    nationalPokedexNumbers: [219],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/29.png",
      large: "https://images.pokemontcg.io/sv6/29_hires.png",
    },
    altArts: [
      {
        id: "sv6-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/sv6/29.png",
          large: "https://images.pokemontcg.io/sv6/29_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-191",
        number: "191",
        images: {
          small: "https://images.pokemontcg.io/sv6/191.png",
          large: "https://images.pokemontcg.io/sv6/191_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-107",
    name: "Magearna",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Metal"],
    abilities: [
      {
        name: "Auto Heal",
        text: "As long as this Pokémon is in the Active Spot, whenever you attach an Energy card from your hand to 1 of your Pokémon, heal 90 damage from that Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Spike Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Draw 2 cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "107",
    nationalPokedexNumbers: [801],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/107.png",
      large: "https://images.pokemontcg.io/sv9/107_hires.png",
    },
    altArts: [
      {
        id: "sv9-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/sv9/107.png",
          large: "https://images.pokemontcg.io/sv9/107_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-20",
    name: "Magmar",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Magmortar"],
    attacks: [
      {
        name: "Searing Flame",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "20",
    nationalPokedexNumbers: [126],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/20.png",
      large: "https://images.pokemontcg.io/sv9/20_hires.png",
    },
    altArts: [
      {
        id: "sv9-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv9/20.png",
          large: "https://images.pokemontcg.io/sv9/20_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-21",
    name: "Magmortar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fire"],
    evolvesFrom: "Magmar",
    abilities: [
      {
        name: "Magma Surge",
        text: "During Pokémon Checkup, put 3 more damage counters on your opponent's Burned Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Searing Flame",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "21",
    nationalPokedexNumbers: [467],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/21.png",
      large: "https://images.pokemontcg.io/sv9/21_hires.png",
    },
    altArts: [
      {
        id: "sv9-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/sv9/21.png",
          large: "https://images.pokemontcg.io/sv9/21_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-45",
    name: "Magnemite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Magneton"],
    attacks: [
      {
        name: "Beam",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "45",
    nationalPokedexNumbers: [81],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/45.png",
      large: "https://images.pokemontcg.io/me1/45_hires.png",
    },
    altArts: [
      {
        id: "me1-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/me1/45.png",
          large: "https://images.pokemontcg.io/me1/45_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-58",
    name: "Magnemite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Magneton"],
    attacks: [
      {
        name: "Lightning Ball",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    nationalPokedexNumbers: [81],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/58.png",
      large: "https://images.pokemontcg.io/sv8/58_hires.png",
    },
    altArts: [
      {
        id: "sv8-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv8/58.png",
          large: "https://images.pokemontcg.io/sv8/58_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-46",
    name: "Magneton",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Magnemite",
    evolvesTo: ["Magnezone"],
    attacks: [
      {
        name: "Thunder Shock",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    nationalPokedexNumbers: [82],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/46.png",
      large: "https://images.pokemontcg.io/me1/46_hires.png",
    },
    altArts: [
      {
        id: "me1-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/me1/46.png",
          large: "https://images.pokemontcg.io/me1/46_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-59",
    name: "Magneton",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Lightning"],
    evolvesFrom: "Magnemite",
    evolvesTo: ["Magnezone"],
    abilities: [
      {
        name: "Overvolt Discharge",
        text: "Once during your turn, you may attach up to 3 Basic Energy cards from your discard pile to your Lightning Pokémon in any way you like. If you use this Ability, this Pokémon is Knocked Out.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Electric Ball",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    nationalPokedexNumbers: [82],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/59.png",
      large: "https://images.pokemontcg.io/sv8/59_hires.png",
    },
    altArts: [
      {
        id: "sv8-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/sv8/59.png",
          large: "https://images.pokemontcg.io/sv8/59_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/svp/153.png",
          large: "https://images.pokemontcg.io/svp/153_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/svp/159.png",
          large: "https://images.pokemontcg.io/svp/159_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-47",
    name: "Magnezone",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Lightning"],
    evolvesFrom: "Magneton",
    attacks: [
      {
        name: "Upper Spark",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "50+",
        text: "If this Pokémon evolved from Magneton during this turn, this attack does 120 more damage.",
      },
      {
        name: "Flashing Bolt",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "During your next turn, this Pokémon can't use Flashing Bolt.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "47",
    nationalPokedexNumbers: [462],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/47.png",
      large: "https://images.pokemontcg.io/me1/47_hires.png",
    },
    altArts: [
      {
        id: "me1-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/me1/47.png",
          large: "https://images.pokemontcg.io/me1/47_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-60",
    name: "Magnezone",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Lightning"],
    evolvesFrom: "Magneton",
    attacks: [
      {
        name: "Mighty Magnetism",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Your opponent's Active Pokémon is now Confused. During your opponent's next turn, that Pokémon can't retreat.",
      },
      {
        name: "Zap Cannon",
        cost: ["Lightning", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "180",
        text: "During your next turn, this Pokémon can't use Zap Cannon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "60",
    nationalPokedexNumbers: [462],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/60.png",
      large: "https://images.pokemontcg.io/sv8/60_hires.png",
    },
    altArts: [
      {
        id: "sv8-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv8/60.png",
          large: "https://images.pokemontcg.io/sv8/60_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-72",
    name: "Makuhita",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Hariyama"],
    attacks: [
      {
        name: "Corkscrew Punch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Confront",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "72",
    nationalPokedexNumbers: [296],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/72.png",
      large: "https://images.pokemontcg.io/me1/72_hires.png",
    },
    altArts: [
      {
        id: "me1-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/me1/72.png",
          large: "https://images.pokemontcg.io/me1/72_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-52",
    name: "Malamar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Inkay",
    attacks: [
      {
        name: "Perplex",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Brain Crush",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "130",
        text: "If your opponent's Active Pokémon isn't Confused, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "52",
    flavorText:
      "It wields the most compelling hypnotic powers of any Pokémon, and it forces others to do whatever it wants.",
    nationalPokedexNumbers: [687],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-52/small",
      large: "https://images.scrydex.com/pokemon/me5-52/large",
    },
    altArts: [
      {
        id: "me5-52",
        number: "52",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-52/small",
          large: "https://images.scrydex.com/pokemon/me5-52/large",
        },
        flavorText:
          "It wields the most compelling hypnotic powers of any Pokémon, and it forces others to do whatever it wants.",
      },
    ],
  },
  {
    id: "sv6pt5-34",
    name: "Malamar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Inkay",
    attacks: [
      {
        name: "Colluding Tentacles",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot. If you do, this attack does 120 damage to the new Active Pokémon. If you didn't play Xerosic's Machinations from your hand during this turn, this attack does nothing.",
      },
      {
        name: "Spinning Attack",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "34",
    nationalPokedexNumbers: [687],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/34.png",
      large: "https://images.pokemontcg.io/sv6pt5/34_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/34.png",
          large: "https://images.pokemontcg.io/sv6pt5/34_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-25",
    name: "Mamoswine",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Water"],
    evolvesFrom: "Piloswine",
    attacks: [
      {
        name: "Wreck",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: "If a Stadium is in play, this attack does 120 more damage. Then, discard that Stadium.",
      },
      {
        name: "Blizzard Edge",
        cost: ["Water", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "200",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "25",
    flavorText:
      "A frozen Mamoswine was dug from ice dating back 10,000 years. This Pokémon has been around a long, long, long time.",
    nationalPokedexNumbers: [473],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/25.png",
      large: "https://images.pokemontcg.io/me2/25_hires.png",
    },
    altArts: [
      {
        id: "me2-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/me2/25.png",
          large: "https://images.pokemontcg.io/me2/25_hires.png",
        },
        flavorText:
          "A frozen Mamoswine was dug from ice dating back 10,000 years. This Pokémon has been around a long, long, long time.",
      },
    ],
  },
  {
    id: "sv9-79",
    name: "Mamoswine ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "340",
    types: ["Fighting"],
    evolvesFrom: "Piloswine",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Mammoth Hauler",
        text: "Once during your turn, you may search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rumbling March",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "180+",
        text: "This attack does 40 more damage for each Stage 2 Pokémon on your Bench.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "79",
    nationalPokedexNumbers: [473],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/79.png",
      large: "https://images.pokemontcg.io/sv9/79_hires.png",
    },
    altArts: [
      {
        id: "sv9-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv9/79.png",
          large: "https://images.pokemontcg.io/sv9/79_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-174",
        number: "174",
        images: {
          small: "https://images.pokemontcg.io/sv9/174.png",
          large: "https://images.pokemontcg.io/sv9/174_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-64",
    name: "Mandibuzz",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Darkness"],
    evolvesFrom: "Vullaby",
    abilities: [
      {
        name: "Look for Prey",
        text: "Once during your turn, you may use this Ability. Your opponent reveals their hand, and you put a Basic Pokémon with 70 HP or less that you find there onto your opponent's Bench.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Cutting Wind",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    flavorText:
      "It makes a nest out of bones it finds. It grabs weakened prey in its talons and hauls it to its nest of bones.",
    nationalPokedexNumbers: [630],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/64.png",
      large: "https://images.pokemontcg.io/rsv10pt5/64_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/64.png",
          large: "https://images.pokemontcg.io/rsv10pt5/64_hires.png",
        },
        flavorText:
          "It makes a nest out of bones it finds. It grabs weakened prey in its talons and hauls it to its nest of bones.",
      },
      {
        id: "rsv10pt5-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/145.png",
          large: "https://images.pokemontcg.io/rsv10pt5/145_hires.png",
        },
        flavorText:
          "It makes a nest out of bones it finds. It grabs weakened prey in its talons and hauls it to its nest of bones.",
      },
    ],
  },
  {
    id: "me5-50",
    name: "Mandibuzz",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Vullaby",
    attacks: [
      {
        name: "Bone Sniper",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 70 damage to 1 of your opponent's Pokémon that has any Special Energy attached. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Blasting Wind",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "50",
    flavorText:
      "Watching from the sky, they attack weakened prey on the ground. They have a habit of decorating themselves with bones.",
    nationalPokedexNumbers: [630],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-50/small",
      large: "https://images.scrydex.com/pokemon/me5-50/large",
    },
    altArts: [
      {
        id: "me5-50",
        number: "50",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-50/small",
          large: "https://images.scrydex.com/pokemon/me5-50/large",
        },
        flavorText:
          "Watching from the sky, they attack weakened prey on the ground. They have a habit of decorating themselves with bones.",
      },
    ],
  },
  {
    id: "me2pt5-139",
    name: "Mandibuzz ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Darkness"],
    evolvesFrom: "Vullaby",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Bone Shot",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 50 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Vulture Claw",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Discard a random card from your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "139",
    nationalPokedexNumbers: [630],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-139/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-139/large",
    },
    altArts: [
      {
        id: "me2pt5-139",
        number: "139",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-139/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-139/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-24",
    name: "Manectric",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Electrike",
    attacks: [
      {
        name: "Flashing Barrier",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Evolution Pokémon.",
      },
      {
        name: "Sonic Edge",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    flavorText:
      "It discharges electricity from its mane. The Pokémon creates a thundercloud overhead from which to drop lightning bolts.",
    nationalPokedexNumbers: [310],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-24/small",
      large: "https://images.scrydex.com/pokemon/me5-24/large",
    },
    altArts: [
      {
        id: "me5-24",
        number: "24",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-24/small",
          large: "https://images.scrydex.com/pokemon/me5-24/large",
        },
        flavorText:
          "It discharges electricity from its mane. The Pokémon creates a thundercloud overhead from which to drop lightning bolts.",
      },
      {
        id: "me5-89",
        number: "89",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-89/small",
          large: "https://images.scrydex.com/pokemon/me5-89/large",
        },
        flavorText:
          ".It discharges electricity from its mane. The Pokémon creates a thundercloud overhead from which to drop lightning bolts.",
      },
    ],
  },
  {
    id: "sv10-76",
    name: "Manectric",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Electrike",
    attacks: [
      {
        name: "Zap Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Flash Impact",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "This attack also does 40 damage to 1 of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "76",
    nationalPokedexNumbers: [310],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/76.png",
      large: "https://images.pokemontcg.io/sv10/76_hires.png",
    },
    altArts: [
      {
        id: "sv10-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv10/76.png",
          large: "https://images.pokemontcg.io/sv10/76_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-42",
    name: "Mankey",
    supertype: "Pokémon",
    hp: "50",
    types: ["Fighting"],
    attacks: [
      {
        name: "Low Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "42",
    nationalPokedexNumbers: [56],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-42/small",
      large: "https://images.scrydex.com/pokemon/me5-42/large",
    },
    altArts: [
      {
        id: "me5-42",
        number: "42",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-42/small",
          large: "https://images.scrydex.com/pokemon/me5-42/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-90",
    name: "Mankey",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Primeape"],
    attacks: [
      {
        name: "Wild Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "90",
    nationalPokedexNumbers: [56],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/90.png",
      large: "https://images.pokemontcg.io/sv10/90_hires.png",
    },
    altArts: [
      {
        id: "sv10-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv10/90.png",
          large: "https://images.pokemontcg.io/sv10/90_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-98",
    name: "Mankey",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    evolvesTo: ["Primeape"],
    attacks: [
      {
        name: "Dual Chop",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "98",
    nationalPokedexNumbers: [56],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/98.png",
      large: "https://images.pokemontcg.io/sv8/98_hires.png",
    },
    altArts: [
      {
        id: "sv8-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv8/98.png",
          large: "https://images.pokemontcg.io/sv8/98_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-32",
    name: "Mantine",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Waterfall",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    nationalPokedexNumbers: [226],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/32.png",
      large: "https://images.pokemontcg.io/me1/32_hires.png",
    },
    altArts: [
      {
        id: "me1-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/me1/32.png",
          large: "https://images.pokemontcg.io/me1/32_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-40",
    name: "Mantine",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Wave Splash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Aqua Dive",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 50 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    nationalPokedexNumbers: [226],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/40.png",
      large: "https://images.pokemontcg.io/sv8/40_hires.png",
    },
    altArts: [
      {
        id: "sv8-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv8/40.png",
          large: "https://images.pokemontcg.io/sv8/40_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-8",
    name: "Maractus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Grass"],
    attacks: [
      {
        name: "Lively Needles",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If this Pokémon was healed during this turn, this attack does 100 more damage.",
      },
      {
        name: "Pierce",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    flavorText:
      "It uses an up-tempo song and dance to drive away the bird Pokémon that prey on its flower seeds.",
    nationalPokedexNumbers: [556],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/8.png",
      large: "https://images.pokemontcg.io/zsv10pt5/8_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/8.png",
          large: "https://images.pokemontcg.io/zsv10pt5/8_hires.png",
        },
        flavorText:
          "It uses an up-tempo song and dance to drive away the bird Pokémon that prey on its flower seeds.",
      },
      {
        id: "zsv10pt5-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/93.png",
          large: "https://images.pokemontcg.io/zsv10pt5/93_hires.png",
        },
        flavorText:
          "It uses an up-tempo song and dance to drive away the bird Pokémon that prey on its flower seeds.",
      },
    ],
  },
  {
    id: "sv9-8",
    name: "Maractus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Grass"],
    abilities: [
      {
        name: "Exploding Needles",
        text: "If this Pokémon is in the Active Spot and is Knocked Out by damage from an attack from your opponent's Pokémon, put 6 damage counters on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Corner",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "8",
    nationalPokedexNumbers: [556],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/8.png",
      large: "https://images.pokemontcg.io/sv9/8_hires.png",
    },
    altArts: [
      {
        id: "sv9-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv9/8.png",
          large: "https://images.pokemontcg.io/sv9/8_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/sv9/160.png",
          large: "https://images.pokemontcg.io/sv9/160_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-27",
    name: "Mareep",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Thunder Wave",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "27",
    flavorText:
      "Its fluffy coat doubles in size when static electricity builds up. Touching it can be shocking.",
    nationalPokedexNumbers: [179],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-27/small",
      large: "https://images.scrydex.com/pokemon/me4-27/large",
    },
    altArts: [
      {
        id: "me4-27",
        number: "27",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-27/small",
          large: "https://images.scrydex.com/pokemon/me4-27/large",
        },
        flavorText:
          "Its fluffy coat doubles in size when static electricity builds up. Touching it can be shocking.",
      },
    ],
  },
  {
    id: "svp-107",
    name: "Mareep",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Flaaffy"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Lightning Ball",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "107",
    nationalPokedexNumbers: [179],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/107.png",
      large: "https://images.pokemontcg.io/svp/107_hires.png",
    },
    altArts: [
      {
        id: "svp-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/svp/107.png",
          large: "https://images.pokemontcg.io/svp/107_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-83",
    name: "Marill",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Hide",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
      {
        name: "Flop",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    flavorText:
      "The oil-filled tail functions as a buoy, so it’s fine even in rivers with strong currents.",
    nationalPokedexNumbers: [183],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-83/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-83/large",
    },
    altArts: [
      {
        id: "me2pt5-83",
        number: "83",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-83/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-83/large",
        },
        flavorText:
          "The oil-filled tail functions as a buoy, so it’s fine even in rivers with strong currents.",
      },
      {
        id: "me2pt5-232",
        number: "232",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-232/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-232/large",
        },
        flavorText:
          "The oil-filled tail functions as a buoy, so it’s fine even in rivers with strong currents.",
      },
    ],
  },
  {
    id: "me55-67",
    name: "Marill",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    nationalPokedexNumbers: [183],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-67/small",
      large: "https://images.scrydex.com/pokemon/me55-67/large",
    },
    altArts: [
      {
        id: "me55-67",
        number: "67",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-67/small",
          large: "https://images.scrydex.com/pokemon/me55-67/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-64",
    name: "Marill",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Azumarill"],
    attacks: [
      {
        name: "Ball Roll",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip a coin until you get tails. This attack does 10 damage for each heads.",
      },
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "64",
    flavorText:
      "The fur on its body naturally repels water. It can stay dry even when it plays in the water.",
    nationalPokedexNumbers: [183],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/64.png",
      large: "https://images.pokemontcg.io/sv5/64_hires.png",
    },
    altArts: [
      {
        id: "sv5-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv5/64.png",
          large: "https://images.pokemontcg.io/sv5/64_hires.png",
        },
        flavorText:
          "The fur on its body naturally repels water. It can stay dry even when it plays in the water.",
      },
    ],
  },
  {
    id: "sv7-33",
    name: "Marill",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Azumarill"],
    attacks: [
      {
        name: "Rollout",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    nationalPokedexNumbers: [183],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/33.png",
      large: "https://images.pokemontcg.io/sv7/33_hires.png",
    },
    altArts: [
      {
        id: "sv7-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/sv7/33.png",
          large: "https://images.pokemontcg.io/sv7/33_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-73",
    name: "Marill",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Azumarill"],
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    nationalPokedexNumbers: [183],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/73.png",
      large: "https://images.pokemontcg.io/sv8/73_hires.png",
    },
    altArts: [
      {
        id: "sv8-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv8/73.png",
          large: "https://images.pokemontcg.io/sv8/73_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-287",
    name: "Marnie's Grimmsnarl ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Darkness"],
    evolvesFrom: "Marnie's Morgrem",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Punk Up",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may search your deck for up to 5 Basic Darkness Energy cards and attach them to your Marnie's Pokémon in any way you like. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Shadow Bullet",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "180",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "287",
    nationalPokedexNumbers: [861],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-287/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-287/large",
    },
    altArts: [
      {
        id: "me2pt5-287",
        number: "287",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-287/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-287/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/sv10/136.png",
          large: "https://images.pokemontcg.io/sv10/136_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-134",
    name: "Marnie's Impidimp",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Morgrem"],
    attacks: [
      {
        name: "Filch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Corkscrew Punch",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "134",
    nationalPokedexNumbers: [859],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/134.png",
      large: "https://images.pokemontcg.io/sv10/134_hires.png",
    },
    altArts: [
      {
        id: "sv10-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/sv10/134.png",
          large: "https://images.pokemontcg.io/sv10/134_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-131",
    name: "Marnie's Liepard",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Marnie's Purrloin",
    attacks: [
      {
        name: "Pointy Claws",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "70+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "131",
    nationalPokedexNumbers: [510],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/131.png",
      large: "https://images.pokemontcg.io/sv10/131_hires.png",
    },
    altArts: [
      {
        id: "sv10-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/sv10/131.png",
          large: "https://images.pokemontcg.io/sv10/131_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-135",
    name: "Marnie's Morgrem",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Marnie's Impidimp",
    evolvesTo: ["Grimmsnarl"],
    attacks: [
      {
        name: "Corkscrew Punch",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "135",
    nationalPokedexNumbers: [860],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/135.png",
      large: "https://images.pokemontcg.io/sv10/135_hires.png",
    },
    altArts: [
      {
        id: "sv10-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/sv10/135.png",
          large: "https://images.pokemontcg.io/sv10/135_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-137",
    name: "Marnie's Morpeko",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Spiky Wheel",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20+",
        text: "This attack does 40 more damage for each Darkness Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    number: "137",
    nationalPokedexNumbers: [877],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/137.png",
      large: "https://images.pokemontcg.io/sv10/137_hires.png",
    },
    altArts: [
      {
        id: "sv10-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/sv10/137.png",
          large: "https://images.pokemontcg.io/sv10/137_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-130",
    name: "Marnie's Purrloin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Liepard"],
    attacks: [
      {
        name: "Pointy Nails",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 40 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "130",
    nationalPokedexNumbers: [509],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/130.png",
      large: "https://images.pokemontcg.io/sv10/130_hires.png",
    },
    altArts: [
      {
        id: "sv10-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/sv10/130.png",
          large: "https://images.pokemontcg.io/sv10/130_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-133",
    name: "Marnie's Scrafty",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Marnie's Scraggy",
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Wild Tackle",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "133",
    nationalPokedexNumbers: [560],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/133.png",
      large: "https://images.pokemontcg.io/sv10/133_hires.png",
    },
    altArts: [
      {
        id: "sv10-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/sv10/133.png",
          large: "https://images.pokemontcg.io/sv10/133_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-132",
    name: "Marnie's Scraggy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Scrafty"],
    attacks: [
      {
        name: "Crunch",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "132",
    nationalPokedexNumbers: [559],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/132.png",
      large: "https://images.pokemontcg.io/sv10/132_hires.png",
    },
    altArts: [
      {
        id: "sv10-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/sv10/132.png",
          large: "https://images.pokemontcg.io/sv10/132_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-73",
    name: "Marowak",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Cubone",
    attacks: [
      {
        name: "Growl",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 40 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Bone Vengeance",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "If any of your Benched Cubone have any damage counters on them, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "73",
    nationalPokedexNumbers: [105],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/73.png",
      large: "https://images.pokemontcg.io/sv7/73_hires.png",
    },
    altArts: [
      {
        id: "sv7-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv7/73.png",
          large: "https://images.pokemontcg.io/sv7/73_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-80",
    name: "Marshadow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    attacks: [
      {
        name: "Shadowy Side Kick",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "If your opponent's Pokémon is Knocked Out by damage from this attack, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "80",
    nationalPokedexNumbers: [802],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/80.png",
      large: "https://images.pokemontcg.io/me1/80_hires.png",
    },
    altArts: [
      {
        id: "me1-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/me1/80.png",
          large: "https://images.pokemontcg.io/me1/80_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/me1/146.png",
          large: "https://images.pokemontcg.io/me1/146_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-40",
    name: "Marshadow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Shadowy Knot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each Colorless in your opponent's Active Pokémon's Retreat Cost.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    flavorText:
      "By slipping into the shadow of a martial arts master and copying their movements, this Pokémon learned the ultimate techniques.",
    nationalPokedexNumbers: [802],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-40/small",
      large: "https://images.scrydex.com/pokemon/me5-40/large",
    },
    altArts: [
      {
        id: "me5-40",
        number: "40",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-40/small",
          large: "https://images.scrydex.com/pokemon/me5-40/large",
        },
        flavorText:
          "By slipping into the shadow of a martial arts master and copying their movements, this Pokémon learned the ultimate techniques.",
      },
    ],
  },
  {
    id: "me5-57",
    name: "Maschiff",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Bite",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "57",
    flavorText:
      "Its well-developed jaw and fangs are strong enough to crunch through boulders, and its thick fat makes for an excellent defense.",
    nationalPokedexNumbers: [942],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-57/small",
      large: "https://images.scrydex.com/pokemon/me5-57/large",
    },
    altArts: [
      {
        id: "me5-57",
        number: "57",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-57/small",
          large: "https://images.scrydex.com/pokemon/me5-57/large",
        },
        flavorText:
          "Its well-developed jaw and fangs are strong enough to crunch through boulders, and its thick fat makes for an excellent defense.",
      },
    ],
  },
  {
    id: "me55-125",
    name: "Maushold",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Colorless"],
    evolvesFrom: "Tandemaus",
    attacks: [
      {
        name: "Gnaw Together",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Flip a coin for each Maushold you have in play. For each heads, discard the top 2 cards of your opponent's deck.",
      },
      {
        name: "Pound",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "125",
    nationalPokedexNumbers: [925],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-125/small",
      large: "https://images.scrydex.com/pokemon/me55-125/large",
    },
    altArts: [
      {
        id: "me55-125",
        number: "125",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-125/small",
          large: "https://images.scrydex.com/pokemon/me55-125/large",
        },
        flavorText: "",
      },
      {
        id: "me55-146",
        number: "146",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-146/small",
          large: "https://images.scrydex.com/pokemon/me55-146/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-158",
    name: "Maushold",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Colorless"],
    evolvesFrom: "Tandemaus",
    attacks: [
      {
        name: "Familial March",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 in any combination of Maushold and Maushold ex and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Incessant Incisors",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "Flip 4 coins. This attack does 30 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "158",
    nationalPokedexNumbers: [925],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/158.png",
      large: "https://images.pokemontcg.io/sv8/158_hires.png",
    },
    altArts: [
      {
        id: "sv8-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/sv8/158.png",
          large: "https://images.pokemontcg.io/sv8/158_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-144",
    name: "Mawile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Metal"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Bite",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "144",
    flavorText:
      "Attached to its head is a huge set of jaws formed by horns. It can chew through iron beams.",
    nationalPokedexNumbers: [303],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-144/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-144/large",
    },
    altArts: [
      {
        id: "me2pt5-144",
        number: "144",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-144/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-144/large",
        },
        flavorText:
          "Attached to its head is a huge set of jaws formed by horns. It can chew through iron beams.",
      },
      {
        id: "me2pt5-246",
        number: "246",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-246/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-246/large",
        },
        flavorText:
          "Attached to its head is a huge set of jaws formed by horns. It can chew through iron beams.",
      },
    ],
  },
  {
    id: "me3-32",
    name: "Mawile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Double Eater",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: "Discard up to 2 Energy cards from your hand, and this attack does 60 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "32",
    nationalPokedexNumbers: [303],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-32/small",
      large: "https://images.scrydex.com/pokemon/me3-32/large",
    },
    altArts: [
      {
        id: "me3-32",
        number: "32",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-32/small",
          large: "https://images.scrydex.com/pokemon/me3-32/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-112",
    name: "Mawile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Metal"],
    attacks: [
      {
        name: "Invite and Strike",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot. This attack does 30 damage to the new Active Pokémon.",
      },
      {
        name: "Sharp Fang",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "112",
    flavorText:
      "It uses its docile-looking face to lull foes into complacency, then bites with its huge, relentless jaws.",
    nationalPokedexNumbers: [303],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/112.png",
      large: "https://images.pokemontcg.io/sv5/112_hires.png",
    },
    altArts: [
      {
        id: "sv5-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/sv5/112.png",
          large: "https://images.pokemontcg.io/sv5/112_hires.png",
        },
        flavorText:
          "It uses its docile-looking face to lull foes into complacency, then bites with its huge, relentless jaws.",
      },
    ],
  },
  {
    id: "me2pt5-104",
    name: "Medicham",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Meditite",
    attacks: [
      {
        name: "Seventh Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "150",
        text: "If you don't have exactly 7 cards in your hand, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "104",
    nationalPokedexNumbers: [308],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-104/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-104/large",
    },
    altArts: [
      {
        id: "me2pt5-104",
        number: "104",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-104/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-104/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-241",
        number: "241",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-241/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-241/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-100",
    name: "Medicham",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Meditite",
    attacks: [
      {
        name: "Harmonious Spirit Palm",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "50+",
        text: "If this Pokémon and your opponent's Active Pokémon have the same amount of Energy attached, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "100",
    nationalPokedexNumbers: [308],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/100.png",
      large: "https://images.pokemontcg.io/sv10/100_hires.png",
    },
    altArts: [
      {
        id: "sv10-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/sv10/100.png",
          large: "https://images.pokemontcg.io/sv10/100_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-83",
    name: "Medicham",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Meditite",
    attacks: [
      {
        name: "Low Sweep",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "High Jump Kick",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    flavorText:
      "It elegantly avoids attacks with dance-like steps, then launches a devastating blow in the same motion.",
    nationalPokedexNumbers: [308],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/83.png",
      large: "https://images.pokemontcg.io/sv5/83_hires.png",
    },
    altArts: [
      {
        id: "sv5-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv5/83.png",
          large: "https://images.pokemontcg.io/sv5/83_hires.png",
        },
        flavorText:
          "It elegantly avoids attacks with dance-like steps, then launches a devastating blow in the same motion.",
      },
    ],
  },
  {
    id: "sv7-79",
    name: "Medicham",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Meditite",
    attacks: [
      {
        name: "Double Smash",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40×",
        text: "Flip 2 coins. This attack does 40 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "79",
    nationalPokedexNumbers: [308],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/79.png",
      large: "https://images.pokemontcg.io/sv7/79_hires.png",
    },
    altArts: [
      {
        id: "sv7-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv7/79.png",
          large: "https://images.pokemontcg.io/sv7/79_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-80",
    name: "Medicham ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Fighting"],
    evolvesFrom: "Meditite",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Chi-Atsu",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Put damage counters on your opponent's Active Pokémon until its remaining HP is 50.",
      },
      {
        name: "Yoga Kick",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "190",
        text: "This attack's damage isn't affected by Weakness or Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "80",
    nationalPokedexNumbers: [308],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/80.png",
      large: "https://images.pokemontcg.io/sv7/80_hires.png",
    },
    altArts: [
      {
        id: "sv7-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv7/80.png",
          large: "https://images.pokemontcg.io/sv7/80_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/sv7/161.png",
          large: "https://images.pokemontcg.io/sv7/161_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-103",
    name: "Meditite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Gentle Slap",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "103",
    nationalPokedexNumbers: [307],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-103/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-103/large",
    },
    altArts: [
      {
        id: "me2pt5-103",
        number: "103",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-103/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-103/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-99",
    name: "Meditite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Medicham"],
    attacks: [
      {
        name: "Steady Punch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "99",
    nationalPokedexNumbers: [307],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/99.png",
      large: "https://images.pokemontcg.io/sv10/99_hires.png",
    },
    altArts: [
      {
        id: "sv10-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv10/99.png",
          large: "https://images.pokemontcg.io/sv10/99_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-82",
    name: "Meditite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Medicham"],
    attacks: [
      {
        name: "Slap",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "82",
    flavorText:
      "It meditates to heighten its inner energy and to float in the air. It eats one berry a day.",
    nationalPokedexNumbers: [307],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/82.png",
      large: "https://images.pokemontcg.io/sv5/82_hires.png",
    },
    altArts: [
      {
        id: "sv5-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv5/82.png",
          large: "https://images.pokemontcg.io/sv5/82_hires.png",
        },
        flavorText:
          "It meditates to heighten its inner energy and to float in the air. It eats one berry a day.",
      },
    ],
  },
  {
    id: "sv7-77",
    name: "Meditite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Medicham"],
    attacks: [
      {
        name: "Beat",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "77",
    nationalPokedexNumbers: [307],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/77.png",
      large: "https://images.pokemontcg.io/sv7/77_hires.png",
    },
    altArts: [
      {
        id: "sv7-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv7/77.png",
          large: "https://images.pokemontcg.io/sv7/77_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-78",
    name: "Meditite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Medicham"],
    attacks: [
      {
        name: "Calm Mind",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 20 damage from this Pokémon.",
      },
      {
        name: "Chop",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    nationalPokedexNumbers: [307],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/78.png",
      large: "https://images.pokemontcg.io/sv7/78_hires.png",
    },
    altArts: [
      {
        id: "sv7-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv7/78.png",
          large: "https://images.pokemontcg.io/sv7/78_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/sv7/153.png",
          large: "https://images.pokemontcg.io/sv7/153_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-36",
    name: "Mega Abomasnow ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "350",
    types: ["Water"],
    evolvesFrom: "Snover",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Hammer-lanche",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "100×",
        text: "Discard the top 6 cards of your deck, and this attack does 100 damage for each Basic Water Energy card that you discarded in this way.",
      },
      {
        name: "Frost Barrier",
        cost: ["Water", "Water", "Water"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "36",
    nationalPokedexNumbers: [460],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/36.png",
      large: "https://images.pokemontcg.io/me1/36_hires.png",
    },
    altArts: [
      {
        id: "me1-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/me1/36.png",
          large: "https://images.pokemontcg.io/me1/36_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/me1/157.png",
          large: "https://images.pokemontcg.io/me1/157_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-86",
    name: "Mega Absol ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "280",
    types: ["Darkness"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Terminal Period",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "If your opponent's Active Pokémon has exactly 6 damage counters on it, that Pokémon is Knocked Out.",
      },
      {
        name: "Claw of Darkness",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Your opponent reveals their hand, and you discard a card you find there.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "86",
    nationalPokedexNumbers: [359],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/86.png",
      large: "https://images.pokemontcg.io/me1/86_hires.png",
    },
    altArts: [
      {
        id: "me1-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/me1/86.png",
          large: "https://images.pokemontcg.io/me1/86_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/me1/161.png",
          large: "https://images.pokemontcg.io/me1/161_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-180",
        number: "180",
        images: {
          small: "https://images.pokemontcg.io/me1/180.png",
          large: "https://images.pokemontcg.io/me1/180_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-172",
    name: "Mega Audino ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "270",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Kaleidowaltz",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip 3 coins. For each heads, search your deck for up to 2 Basic Energy cards and attach them to your Pokémon in any way you like. Then, shuffle your deck.",
      },
      {
        name: "Ear Force",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20+",
        text: "This attack does 80 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "172",
    nationalPokedexNumbers: [531],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-172/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-172/large",
    },
    altArts: [
      {
        id: "me2pt5-172",
        number: "172",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-172/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-172/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-253",
        number: "253",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-253/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-253/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-22",
    name: "Mega Camerupt ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "340",
    types: ["Fire"],
    evolvesFrom: "Numel",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Roasting Heat",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "80+",
        text: "If your opponent's Active Pokémon is Burned, this attack does 160 more damage.",
      },
      {
        name: "Volcanic Meteor",
        cost: ["Fire", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "280",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "22",
    nationalPokedexNumbers: [323],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/22.png",
      large: "https://images.pokemontcg.io/me1/22_hires.png",
    },
    altArts: [
      {
        id: "me1-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/me1/22.png",
          large: "https://images.pokemontcg.io/me1/22_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/me1/156.png",
          large: "https://images.pokemontcg.io/me1/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-38",
    name: "Mega Chandelure ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "350",
    types: ["Psychic"],
    evolvesFrom: "Lampent",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Binding Flame",
        text: "Your opponent's Active Pokémon's Retreat Cost is Colorless more.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Phantom Maze",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "130+",
        text: "This attack does 50 more damage for each Colorless in your opponent's Active Pokémon's Retreat Cost.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    nationalPokedexNumbers: [609],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-38/small",
      large: "https://images.scrydex.com/pokemon/me5-38/large",
    },
    altArts: [
      {
        id: "me5-38",
        number: "38",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-38/small",
          large: "https://images.scrydex.com/pokemon/me5-38/large",
        },
        flavorText: "",
      },
      {
        id: "me5-99",
        number: "99",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-99/small",
          large: "https://images.scrydex.com/pokemon/me5-99/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-115",
    name: "Mega Chandelure ex",
    supertype: "Pokémon",
    subtypes: ["MEGA", "ex"],
    hp: "350",
    types: ["Psychic"],
    evolvesFrom: "Lampent",
    abilities: [
      {
        name: "Binding Flame",
        text: "Your opponent's Active Pokémon's Retreat Cost is Colorless more.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Phantom Maze",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "130+",
        text: "This attack does 50 more damage for each Colorless in your opponent's Active Pokémon's Retreat Cost.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "115",
    nationalPokedexNumbers: [609],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-115/small",
      large: "https://images.scrydex.com/pokemon/me5-115/large",
    },
    altArts: [
      {
        id: "me5-115",
        number: "115",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-115/small",
          large: "https://images.scrydex.com/pokemon/me5-115/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-13",
    name: "Mega Charizard X ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "360",
    types: ["Fire"],
    evolvesFrom: "Charmeleon",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Inferno X",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "90×",
        text: "Discard any amount of Fire Energy from among your Pokémon, and this attack does 90 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "13",
    nationalPokedexNumbers: [6],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/13.png",
      large: "https://images.pokemontcg.io/me2/13_hires.png",
    },
    altArts: [
      {
        id: "me2-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/me2/13.png",
          large: "https://images.pokemontcg.io/me2/13_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/me2/109.png",
          large: "https://images.pokemontcg.io/me2/109_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/me2/125.png",
          large: "https://images.pokemontcg.io/me2/125_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/me2/130.png",
          large: "https://images.pokemontcg.io/me2/130_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-22",
    name: "Mega Charizard Y ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "360",
    types: ["Fire"],
    evolvesFrom: "Charmeleon",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Explosion Y",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard 3 Energy from this Pokémon, and this attack does 280 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [6],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-22/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-22/large",
    },
    altArts: [
      {
        id: "me2pt5-22",
        number: "22",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-22/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-22/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-294",
        number: "294",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-294/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-294/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-31",
    name: "Mega Clefable ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "320",
    types: ["Psychic"],
    evolvesFrom: "Clefairy",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Luminous Wing",
        text: "Prevent all effects of your opponent's Pokémon's Abilities done to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Shooting Moons",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "120+",
        text: "You may discard up to 4 Energy cards from your hand, and this attack does 40 more damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    nationalPokedexNumbers: [36],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-31/small",
      large: "https://images.scrydex.com/pokemon/me3-31/large",
    },
    altArts: [
      {
        id: "me3-31",
        number: "31",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-31/small",
          large: "https://images.scrydex.com/pokemon/me3-31/large",
        },
        flavorText: "",
      },
      {
        id: "me3-103",
        number: "103",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-103/small",
          large: "https://images.scrydex.com/pokemon/me3-103/large",
        },
        flavorText: "",
      },
      {
        id: "me3-119",
        number: "119",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-119/small",
          large: "https://images.scrydex.com/pokemon/me3-119/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-48",
    name: "Mega Darkrai ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "280",
    types: ["Darkness"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Dusk Raid",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "110+",
        text: "If your Benched Pokémon have any damage counters on them, this attack does 110 more damage.",
      },
      {
        name: "Abyss Eye",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "",
        text: "If your opponent's Active Pokémon is affected by a Special Condition, it is Knocked Out.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "48",
    nationalPokedexNumbers: [491],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-48/small",
      large: "https://images.scrydex.com/pokemon/me5-48/large",
    },
    altArts: [
      {
        id: "me5-48",
        number: "48",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-48/small",
          large: "https://images.scrydex.com/pokemon/me5-48/large",
        },
        flavorText: "",
      },
      {
        id: "me5-101",
        number: "101",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-101/small",
          large: "https://images.scrydex.com/pokemon/me5-101/large",
        },
        flavorText: "",
      },
      {
        id: "me5-116",
        number: "116",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-116/small",
          large: "https://images.scrydex.com/pokemon/me5-116/large",
        },
        flavorText: "",
      },
      {
        id: "me5-120",
        number: "120",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-120/small",
          large: "https://images.scrydex.com/pokemon/me5-120/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-8",
    name: "Mega Delphox ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "350",
    types: ["Fire"],
    evolvesFrom: "Braixen",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Trick Portal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top 9 cards of your deck, and you may put any number of Pokémon you find there onto your Bench. Shuffle the other cards back into your deck.",
      },
      {
        name: "Eerie Glow",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Your opponent's Active Pokémon is now Burned and Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "8",
    nationalPokedexNumbers: [655],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-8/small",
      large: "https://images.scrydex.com/pokemon/me5-8/large",
    },
    altArts: [
      {
        id: "me5-8",
        number: "8",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-8/small",
          large: "https://images.scrydex.com/pokemon/me5-8/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-41",
    name: "Mega Diancie ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "270",
    types: ["Psychic"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Diamond Coat",
        text: "This Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Garland Ray",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "120×",
        text: "Discard up to 2 Energy cards from this Pokémon, and this attack does 120 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    nationalPokedexNumbers: [719],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/41.png",
      large: "https://images.pokemontcg.io/me2/41_hires.png",
    },
    altArts: [
      {
        id: "me2-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/me2/41.png",
          large: "https://images.pokemontcg.io/me2/41_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-267",
        number: "267",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-267/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-267/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-282",
        number: "282",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-282/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-282/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-65",
    name: "Mega Dragalge ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "330",
    types: ["Dragon"],
    evolvesFrom: "Skrelp",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Corrosive Liquid",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Discard all Pokémon Tools and Special Energy from all of your opponent's Pokémon.",
      },
      {
        name: "Pernicious Poison",
        cost: ["Water", "Darkness"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned. During Pokémon Checkup, place 16 damage counters on that Pokémon instead of 1.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "65",
    nationalPokedexNumbers: [691],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-65/small",
      large: "https://images.scrydex.com/pokemon/me4-65/large",
    },
    altArts: [
      {
        id: "me4-65",
        number: "65",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-65/small",
          large: "https://images.scrydex.com/pokemon/me4-65/large",
        },
        flavorText: "",
      },
      {
        id: "me4-104",
        number: "104",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-104/small",
          large: "https://images.scrydex.com/pokemon/me4-104/large",
        },
        flavorText: "",
      },
      {
        id: "me4-118",
        number: "118",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-118/small",
          large: "https://images.scrydex.com/pokemon/me4-118/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-152",
    name: "Mega Dragonite ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "370",
    types: ["Dragon"],
    evolvesFrom: "Dragonair",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Sky Transport",
        text: "Once during your turn, you may use this Ability. Switch your Active Pokémon with 1 of your Benched Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Ryuno Glide",
        cost: ["Water", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "330",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "152",
    nationalPokedexNumbers: [149],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-152/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-152/large",
    },
    altArts: [
      {
        id: "me2pt5-152",
        number: "152",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-152/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-152/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-271",
        number: "271",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-271/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-271/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-290",
        number: "290",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-290/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-290/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-295",
        number: "295",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-295/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-295/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-61",
    name: "Mega Eelektross ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "350",
    types: ["Lightning"],
    evolvesFrom: "Eelektrik",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Split Bomb",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 60 damage to each of 2 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Disaster Shock",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "190",
        text: "You may discard 2 Lightning Energy from this Pokémon and make your opponent's Active Pokémon Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "61",
    nationalPokedexNumbers: [604],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-61/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-61/large",
    },
    altArts: [
      {
        id: "me2pt5-61",
        number: "61",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-61/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-61/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-266",
        number: "266",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-266/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-266/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-278",
        number: "278",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-278/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-278/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-31",
    name: "Mega Emboar ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "380",
    types: ["Fire"],
    evolvesFrom: "Pignite",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Crimson Blast",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "320",
        text: "This Pokémon also does 60 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "31",
    nationalPokedexNumbers: [500],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-31/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-31/large",
    },
    altArts: [
      {
        id: "me2pt5-31",
        number: "31",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-31/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-31/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-273",
        number: "273",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-273/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-273/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-65",
    name: "Mega Excadrill ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "340",
    types: ["Metal"],
    evolvesFrom: "Drilbur",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Undermine",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "Discard the top 2 cards of your opponent's deck.",
      },
      {
        name: "Maximum Drilling",
        cost: ["Metal", "Metal", "Metal"],
        convertedEnergyCost: 3,
        damage: "200+",
        text: "If this Pokémon has at least 2 extra Energy attached (in addition to this attack's cost), this attack does 130 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "65",
    nationalPokedexNumbers: [530],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-65/small",
      large: "https://images.scrydex.com/pokemon/me5-65/large",
    },
    altArts: [
      {
        id: "me5-65",
        number: "65",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-65/small",
          large: "https://images.scrydex.com/pokemon/me5-65/large",
        },
        flavorText: "",
      },
      {
        id: "me5-103",
        number: "103",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-103/small",
          large: "https://images.scrydex.com/pokemon/me5-103/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-43",
    name: "Mega Feraligatr ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "370",
    types: ["Water"],
    evolvesFrom: "Croconaw",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Mortal Crunch",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 200 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "43",
    nationalPokedexNumbers: [160],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-43/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-43/large",
    },
    altArts: [
      {
        id: "me2pt5-43",
        number: "43",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-43/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-43/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-274",
        number: "274",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-274/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-274/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-35",
    name: "Mega Floette ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "250",
    types: ["Psychic"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Gentle Light",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 30 damage from each Pokémon (both yours and your opponent's).",
      },
      {
        name: "Eternity Bloom",
        cost: ["Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Search your deck for up to 4 Basic Psychic Energy cards and attach them to your Benched Pokémon in any way you like. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    nationalPokedexNumbers: [670],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-35/small",
      large: "https://images.scrydex.com/pokemon/me4-35/large",
    },
    altArts: [
      {
        id: "me4-35",
        number: "35",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-35/small",
          large: "https://images.scrydex.com/pokemon/me4-35/large",
        },
        flavorText: "",
      },
      {
        id: "me4-101",
        number: "101",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-101/small",
          large: "https://images.scrydex.com/pokemon/me4-101/large",
        },
        flavorText: "",
      },
      {
        id: "me4-117",
        number: "117",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-117/small",
          large: "https://images.scrydex.com/pokemon/me4-117/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-47",
    name: "Mega Froslass ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "310",
    types: ["Water"],
    evolvesFrom: "Snorunt",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Resentful Refrain",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "This attack does 50 damage for each card in your opponent's hand.",
      },
      {
        name: "Absolute Snow",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "47",
    nationalPokedexNumbers: [478],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-47/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-47/large",
    },
    altArts: [
      {
        id: "me2pt5-47",
        number: "47",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-47/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-47/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-265",
        number: "265",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-265/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-265/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-275",
        number: "275",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-275/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-275/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-48",
    name: "Mega Gallade ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "350",
    types: ["Fighting"],
    evolvesFrom: "Kirlia",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Gale Slash",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "50+",
        text: "If this Pokémon has no damage counters on it, this attack does 150 more damage.",
      },
      {
        name: "Marvelous Edge",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "240",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "48",
    nationalPokedexNumbers: [475],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-48/small",
      large: "https://images.scrydex.com/pokemon/me4-48/large",
    },
    altArts: [
      {
        id: "me4-48",
        number: "48",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-48/small",
          large: "https://images.scrydex.com/pokemon/me4-48/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-60",
    name: "Mega Gardevoir ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "360",
    types: ["Psychic"],
    evolvesFrom: "Kirlia",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Overflowing Wishes",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "For each of your Benched Pokémon, search your deck for a Basic Psychic Energy card and attach it to that Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Mega Symphonia",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "This attack does 50 damage for each Psychic Energy attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "60",
    nationalPokedexNumbers: [282],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/60.png",
      large: "https://images.pokemontcg.io/me1/60_hires.png",
    },
    altArts: [
      {
        id: "me1-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/me1/60.png",
          large: "https://images.pokemontcg.io/me1/60_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/me1/159.png",
          large: "https://images.pokemontcg.io/me1/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-178",
        number: "178",
        images: {
          small: "https://images.pokemontcg.io/me1/178.png",
          large: "https://images.pokemontcg.io/me1/178_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-187",
        number: "187",
        images: {
          small: "https://images.pokemontcg.io/me1/187.png",
          large: "https://images.pokemontcg.io/me1/187_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-89",
        number: "89",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-89/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-89/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-56",
    name: "Mega Gengar ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "350",
    types: ["Darkness"],
    evolvesFrom: "Haunter",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Shadowy Concealment",
        text: "If 1 of your Darkness Pokémon is Knocked Out by damage from an attack from your opponent's Pokémon ex, that player takes 1 fewer Prize card. The effect of Shadowy Concealment doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Void Gale",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "230",
        text: "Move an Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "56",
    nationalPokedexNumbers: [94],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/56.png",
      large: "https://images.pokemontcg.io/me2/56_hires.png",
    },
    altArts: [
      {
        id: "me2-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/me2/56.png",
          large: "https://images.pokemontcg.io/me2/56_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-125",
        number: "125",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-125/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-125/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-269",
        number: "269",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-269/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-269/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-284",
        number: "284",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-284/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-284/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-22",
    name: "Mega Greninja ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "350",
    types: ["Water"],
    evolvesFrom: "Frogadier",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Mortal Shuriken",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may discard a Basic Water Energy card from your hand in order to use this Ability. Place 6 damage counters on 1 of your opponent's Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Ninja Spinner",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "120+",
        text: "You may put a Water Energy attached to this Pokémon into your hand and have this attack do 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [658],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-22/small",
      large: "https://images.scrydex.com/pokemon/me4-22/large",
    },
    altArts: [
      {
        id: "me4-22",
        number: "22",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-22/small",
          large: "https://images.scrydex.com/pokemon/me4-22/large",
        },
        flavorText: "",
      },
      {
        id: "me4-100",
        number: "100",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-100/small",
          large: "https://images.scrydex.com/pokemon/me4-100/large",
        },
        flavorText: "",
      },
      {
        id: "me4-116",
        number: "116",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-116/small",
          large: "https://images.scrydex.com/pokemon/me4-116/large",
        },
        flavorText: "",
      },
      {
        id: "me4-122",
        number: "122",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-122/small",
          large: "https://images.scrydex.com/pokemon/me4-122/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-116",
    name: "Mega Hawlucha ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "250",
    types: ["Fighting"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Tenacious Body",
        text: "If this Pokémon would be Knocked Out by damage from an attack, flip a coin. If heads, this Pokémon is not Knocked Out, and its remaining HP becomes 10.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Somersault Dive",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: "If a Stadium is in play, this attack does 140 more damage. Then, discard that Stadium.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "116",
    nationalPokedexNumbers: [701],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-116/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-116/large",
    },
    altArts: [
      {
        id: "me2pt5-116",
        number: "116",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-116/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-116/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-268",
        number: "268",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-268/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-268/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-283",
        number: "283",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-283/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-283/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-4",
    name: "Mega Heracross ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "280",
    types: ["Grass"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Juggernaut Horn",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "100+",
        text: "If this Pokémon was damaged by an attack during your opponent's last turn, this attack does that much more damage.",
      },
      {
        name: "Mountain Ramming",
        cost: ["Grass", "Grass", "Grass"],
        convertedEnergyCost: 3,
        damage: "170",
        text: "Discard the top 2 cards of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "4",
    nationalPokedexNumbers: [214],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/4.png",
      large: "https://images.pokemontcg.io/me2/4_hires.png",
    },
    altArts: [
      {
        id: "me2-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/me2/4.png",
          large: "https://images.pokemontcg.io/me2/4_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/me2/108.png",
          large: "https://images.pokemontcg.io/me2/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-104",
    name: "Mega Kangaskhan ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "300",
    types: ["Colorless"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Run Errand",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may use this Ability. Draw 2 cards. You can't use more than 1 Run Errand Ability each turn.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rapid-Fire Combo",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200+",
        text: "Flip a coin until you get tails. This attack does 50 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "104",
    nationalPokedexNumbers: [115],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/104.png",
      large: "https://images.pokemontcg.io/me1/104_hires.png",
    },
    altArts: [
      {
        id: "me1-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/me1/104.png",
          large: "https://images.pokemontcg.io/me1/104_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/me1/164.png",
          large: "https://images.pokemontcg.io/me1/164_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-182",
        number: "182",
        images: {
          small: "https://images.pokemontcg.io/me1/182.png",
          large: "https://images.pokemontcg.io/me1/182_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-100",
    name: "Mega Latias ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "280",
    types: ["Dragon"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Strafe",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "You may switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Illusory Impulse",
        cost: ["Fire", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "300",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "100",
    nationalPokedexNumbers: [380],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/100.png",
      large: "https://images.pokemontcg.io/me1/100_hires.png",
    },
    altArts: [
      {
        id: "me1-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/me1/100.png",
          large: "https://images.pokemontcg.io/me1/100_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/me1/163.png",
          large: "https://images.pokemontcg.io/me1/163_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-181",
        number: "181",
        images: {
          small: "https://images.pokemontcg.io/me1/181.png",
          large: "https://images.pokemontcg.io/me1/181_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-84",
    name: "Mega Lopunny ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "330",
    types: ["Colorless"],
    evolvesFrom: "Buneary",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Gale Thrust",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "If this Pokémon moved from your Bench to the Active Spot this turn, this attack does 170 more damage.",
      },
      {
        name: "Spiky Hopper",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "84",
    nationalPokedexNumbers: [428],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/84.png",
      large: "https://images.pokemontcg.io/me2/84_hires.png",
    },
    altArts: [
      {
        id: "me2-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/me2/84.png",
          large: "https://images.pokemontcg.io/me2/84_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/me2/115.png",
          large: "https://images.pokemontcg.io/me2/115_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/me2/128.png",
          large: "https://images.pokemontcg.io/me2/128_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-77",
    name: "Mega Lucario ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "340",
    types: ["Fighting"],
    evolvesFrom: "Riolu",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Aura Jab",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "130",
        text: "Attach up to 3 Basic Fighting Energy cards from your discard pile to your Benched Pokémon in any way you like.",
      },
      {
        name: "Mega Brave",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "270",
        text: "During your next turn, this Pokémon can't use Mega Brave.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "77",
    nationalPokedexNumbers: [448],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/77.png",
      large: "https://images.pokemontcg.io/me1/77_hires.png",
    },
    altArts: [
      {
        id: "me1-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/me1/77.png",
          large: "https://images.pokemontcg.io/me1/77_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/me1/160.png",
          large: "https://images.pokemontcg.io/me1/160_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-179",
        number: "179",
        images: {
          small: "https://images.pokemontcg.io/me1/179.png",
          large: "https://images.pokemontcg.io/me1/179_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-188",
        number: "188",
        images: {
          small: "https://images.pokemontcg.io/me1/188.png",
          large: "https://images.pokemontcg.io/me1/188_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-113",
        number: "113",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-113/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-113/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-50",
    name: "Mega Manectric ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "330",
    types: ["Lightning"],
    evolvesFrom: "Electrike",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Flash Ray",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Basic Pokémon.",
      },
      {
        name: "Riotous Blasting",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "200+",
        text: "You may discard all Energy from this Pokémon and have this attack do 130 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "50",
    nationalPokedexNumbers: [310],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/50.png",
      large: "https://images.pokemontcg.io/me1/50_hires.png",
    },
    altArts: [
      {
        id: "me1-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/me1/50.png",
          large: "https://images.pokemontcg.io/me1/50_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/me1/158.png",
          large: "https://images.pokemontcg.io/me1/158_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-94",
    name: "Mega Mawile ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "270",
    types: ["Metal"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Gobble Down",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "80×",
        text: "This attack does 80 damage for each Prize card you have taken.",
      },
      {
        name: "Huge Bite",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "260",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack's base damage is 30.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "94",
    nationalPokedexNumbers: [303],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/94.png",
      large: "https://images.pokemontcg.io/me1/94_hires.png",
    },
    altArts: [
      {
        id: "me1-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/me1/94.png",
          large: "https://images.pokemontcg.io/me1/94_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/me1/162.png",
          large: "https://images.pokemontcg.io/me1/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-10",
    name: "Mega Meganium ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "360",
    types: ["Grass"],
    evolvesFrom: "Bayleef",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Giant Bouquet",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70+",
        text: "This attack does 50 more damage for each Grass Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "10",
    nationalPokedexNumbers: [154],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-10/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-10/large",
    },
    altArts: [
      {
        id: "me2pt5-10",
        number: "10",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-10/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-10/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-272",
        number: "272",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-272/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-272/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-15",
    name: "Mega Pyroar ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "340",
    types: ["Fire"],
    evolvesFrom: "Litleo",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Ferocious Bellow",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 50 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Fiery Big Bang",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "290-",
        text: "This attack does 10 less damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "15",
    nationalPokedexNumbers: [668],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-15/small",
      large: "https://images.scrydex.com/pokemon/me4-15/large",
    },
    altArts: [
      {
        id: "me4-15",
        number: "15",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-15/small",
          large: "https://images.scrydex.com/pokemon/me4-15/large",
        },
        flavorText: "",
      },
      {
        id: "me4-99",
        number: "99",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-99/small",
          large: "https://images.scrydex.com/pokemon/me4-99/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-135",
    name: "Mega Scrafty ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "330",
    types: ["Darkness"],
    evolvesFrom: "Scraggy",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Counterattacking Crest",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), place 5 damage counters on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Outlaw Leg",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Discard a random card from your opponent's hand. Discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "135",
    nationalPokedexNumbers: [560],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-135/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-135/large",
    },
    altArts: [
      {
        id: "me2pt5-135",
        number: "135",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-135/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-135/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-270",
        number: "270",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-270/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-270/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-285",
        number: "285",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-285/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-285/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-61",
    name: "Mega Sharpedo ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "330",
    types: ["Darkness"],
    evolvesFrom: "Carvanha",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Greedy Fang",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "70",
        text: "Draw 2 cards.",
      },
      {
        name: "Hungry Jaws",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "120+",
        text: "If this Pokémon has any damage counters on it, this attack does 150 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    number: "61",
    nationalPokedexNumbers: [319],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/61.png",
      large: "https://images.pokemontcg.io/me2/61_hires.png",
    },
    altArts: [
      {
        id: "me2-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/me2/61.png",
          large: "https://images.pokemontcg.io/me2/61_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/me2/113.png",
          large: "https://images.pokemontcg.io/me2/113_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/me2/127.png",
          large: "https://images.pokemontcg.io/me2/127_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-55",
    name: "Mega Skarmory ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "260",
    types: ["Metal"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Sonic Ripper",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Shuffle all Energy attached to this Pokémon into your deck, and this attack does 220 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "55",
    nationalPokedexNumbers: [227],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-55/small",
      large: "https://images.scrydex.com/pokemon/me3-55/large",
    },
    altArts: [
      {
        id: "me3-55",
        number: "55",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-55/small",
          large: "https://images.scrydex.com/pokemon/me3-55/large",
        },
        flavorText: "",
      },
      {
        id: "me3-106",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-106/small",
          large: "https://images.scrydex.com/pokemon/me3-106/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-31",
    name: "Mega Slowbro ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "330",
    types: ["Psychic"],
    evolvesFrom: "Slowpoke",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Shellnado Spin",
        cost: ["Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "During your opponent's next turn, if this Pokémon is damaged by an attack (even if this Pokémon is Knocked Out), place 12 damage counters on the Attacking Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "31",
    nationalPokedexNumbers: [80],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-31/small",
      large: "https://images.scrydex.com/pokemon/me5-31/large",
    },
    altArts: [
      {
        id: "me5-31",
        number: "31",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-31/small",
          large: "https://images.scrydex.com/pokemon/me5-31/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-21",
    name: "Mega Starmie ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "MEGA", "ex"],
    hp: "330",
    types: ["Water"],
    evolvesFrom: "Staryu",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Jetting Blow",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "120",
        text: "This attack also does 50 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Nebula Beam",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "This attack's damage isn't affected by Weakness or Resistance, or by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "21",
    nationalPokedexNumbers: [121],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-21/small",
      large: "https://images.scrydex.com/pokemon/me3-21/large",
    },
    altArts: [
      {
        id: "me3-21",
        number: "21",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-21/small",
          large: "https://images.scrydex.com/pokemon/me3-21/large",
        },
        flavorText: "",
      },
      {
        id: "me3-102",
        number: "102",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-102/small",
          large: "https://images.scrydex.com/pokemon/me3-102/large",
        },
        flavorText: "",
      },
      {
        id: "me3-118",
        number: "118",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-118/small",
          large: "https://images.scrydex.com/pokemon/me3-118/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-3",
    name: "Mega Venusaur ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "MEGA", "ex"],
    hp: "380",
    types: ["Grass"],
    evolvesFrom: "Ivysaur",
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    abilities: [
      {
        name: "Solar Transfer",
        text: "As often as you like during your turn, you may use this Ability. Move a Basic Grass Energy from 1 of your Pokémon to another of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Jungle Dump",
        cost: ["Grass", "Grass", "Grass", "Grass"],
        convertedEnergyCost: 4,
        damage: "240",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "3",
    nationalPokedexNumbers: [3],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/3.png",
      large: "https://images.pokemontcg.io/me1/3_hires.png",
    },
    altArts: [
      {
        id: "me1-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/me1/3.png",
          large: "https://images.pokemontcg.io/me1/3_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/me1/155.png",
          large: "https://images.pokemontcg.io/me1/155_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-177",
        number: "177",
        images: {
          small: "https://images.pokemontcg.io/me1/177.png",
          large: "https://images.pokemontcg.io/me1/177_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-27",
    name: "Mega Zeraora ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "270",
    types: ["Lightning"],
    rules: [
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Thunderous Fist",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "60×",
        text: "This attack does 60 damage for each Lightning Energy attached to this Pokémon.",
      },
      {
        name: "Zepto Turn",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "27",
    nationalPokedexNumbers: [807],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-27/small",
      large: "https://images.scrydex.com/pokemon/me5-27/large",
    },
    altArts: [
      {
        id: "me5-27",
        number: "27",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-27/small",
          large: "https://images.scrydex.com/pokemon/me5-27/large",
        },
        flavorText: "",
      },
      {
        id: "me5-98",
        number: "98",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-98/small",
          large: "https://images.scrydex.com/pokemon/me5-98/large",
        },
        flavorText: "",
      },
      {
        id: "me5-114",
        number: "114",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-114/small",
          large: "https://images.scrydex.com/pokemon/me5-114/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-47",
    name: "Mega Zygarde ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "MEGA", "ex"],
    hp: "310",
    types: ["Fighting"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Mega Evolution ex Rule: When your Mega Evolution Pokémon ex is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Gaia Wave",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Nullifying Zero",
        cost: ["Fighting", "Fighting", "Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 5,
        damage: "",
        text: "For each of your opponent's Pokémon, flip a coin. If heads, this attack does 150 damage to that Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "47",
    nationalPokedexNumbers: [718],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-47/small",
      large: "https://images.scrydex.com/pokemon/me3-47/large",
    },
    altArts: [
      {
        id: "me3-47",
        number: "47",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-47/small",
          large: "https://images.scrydex.com/pokemon/me3-47/large",
        },
        flavorText: "",
      },
      {
        id: "me3-104",
        number: "104",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-104/small",
          large: "https://images.scrydex.com/pokemon/me3-104/large",
        },
        flavorText: "",
      },
      {
        id: "me3-120",
        number: "120",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-120/small",
          large: "https://images.scrydex.com/pokemon/me3-120/large",
        },
        flavorText: "",
      },
      {
        id: "me3-124",
        number: "124",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-124/small",
          large: "https://images.scrydex.com/pokemon/me3-124/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-10",
    name: "Meganium",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Grass"],
    evolvesFrom: "Bayleef",
    abilities: [
      {
        name: "Wild Growth",
        text: "Each Basic Grass Energy attached to all of your Pokémon provides GrassGrass Energy. The effect of Wild Growth doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Solar Beam",
        cost: ["Grass", "Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "10",
    nationalPokedexNumbers: [154],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/10.png",
      large: "https://images.pokemontcg.io/me1/10_hires.png",
    },
    altArts: [
      {
        id: "me1-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/me1/10.png",
          large: "https://images.pokemontcg.io/me1/10_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-117",
    name: "Melmetal",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "160",
    types: ["Metal"],
    evolvesFrom: "Meltan",
    attacks: [
      {
        name: "Hammer In",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
      {
        name: "Iron Bash",
        cost: ["Metal", "Metal", "Metal", "Metal", "Colorless"],
        convertedEnergyCost: 5,
        damage: "230",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "117",
    flavorText:
      "At the end of its life-span, Melmetal will rust and fall apart. The small shards left behind will eventually be reborn as Meltan.",
    nationalPokedexNumbers: [809],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/117.png",
      large: "https://images.pokemontcg.io/sv5/117_hires.png",
    },
    altArts: [
      {
        id: "sv5-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/sv5/117.png",
          large: "https://images.pokemontcg.io/sv5/117_hires.png",
        },
        flavorText:
          "At the end of its life-span, Melmetal will rust and fall apart. The small shards left behind will eventually be reborn as Meltan.",
      },
    ],
  },
  {
    id: "sv7-104",
    name: "Melmetal",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "160",
    types: ["Metal"],
    evolvesFrom: "Meltan",
    attacks: [
      {
        name: "Wrack Down",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Reforged Axe",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "250",
        text: "Before doing damage, discard all Pokémon Tools from this Pokémon. If you can't discard any, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "104",
    nationalPokedexNumbers: [809],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/104.png",
      large: "https://images.pokemontcg.io/sv7/104_hires.png",
    },
    altArts: [
      {
        id: "sv7-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/sv7/104.png",
          large: "https://images.pokemontcg.io/sv7/104_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-105",
    name: "Melmetal ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "280",
    types: ["Metal"],
    evolvesFrom: "Meltan",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Iron Swing",
        cost: ["Metal", "Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100×",
        text: "Flip 2 coins. This attack does 100 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "105",
    nationalPokedexNumbers: [809],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/105.png",
      large: "https://images.pokemontcg.io/sv7/105_hires.png",
    },
    altArts: [
      {
        id: "sv7-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/sv7/105.png",
          large: "https://images.pokemontcg.io/sv7/105_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-40",
    name: "Meloetta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Soothing Melody",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 120 damage from 1 of your Benched Psychic Pokémon.",
      },
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    flavorText:
      "Its melodies are sung with a special vocalization method that can control the feelings of those who hear it.",
    nationalPokedexNumbers: [648],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/40.png",
      large: "https://images.pokemontcg.io/me2/40_hires.png",
    },
    altArts: [
      {
        id: "me2-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/me2/40.png",
          large: "https://images.pokemontcg.io/me2/40_hires.png",
        },
        flavorText:
          "Its melodies are sung with a special vocalization method that can control the feelings of those who hear it.",
      },
    ],
  },
  {
    id: "zsv10pt5-44",
    name: "Meloetta ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "200",
    types: ["Psychic"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Debut Performance",
        text: "If you go first, this Pokémon can use attacks during your first turn.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Echoed Voice",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your next turn, this Pokémon's Echoed Voice attack does 80 more damage (before applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    nationalPokedexNumbers: [648],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/44.png",
      large: "https://images.pokemontcg.io/zsv10pt5/44_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/44.png",
          large: "https://images.pokemontcg.io/zsv10pt5/44_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/159.png",
          large: "https://images.pokemontcg.io/zsv10pt5/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/167.png",
          large: "https://images.pokemontcg.io/zsv10pt5/167_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-116",
    name: "Meltan",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Metal"],
    evolvesTo: ["Melmetal"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "116",
    flavorText:
      "It dissolves and eats metal. Circulating liquid metal within its body is how it generates energy.",
    nationalPokedexNumbers: [808],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/116.png",
      large: "https://images.pokemontcg.io/sv5/116_hires.png",
    },
    altArts: [
      {
        id: "sv5-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/sv5/116.png",
          large: "https://images.pokemontcg.io/sv5/116_hires.png",
        },
        flavorText:
          "It dissolves and eats metal. Circulating liquid metal within its body is how it generates energy.",
      },
      {
        id: "sv5-179",
        number: "179",
        images: {
          small: "https://images.pokemontcg.io/sv5/179.png",
          large: "https://images.pokemontcg.io/sv5/179_hires.png",
        },
        flavorText:
          "It dissolves and eats metal. Circulating liquid metal within its body is how it generates energy.",
      },
    ],
  },
  {
    id: "sv7-102",
    name: "Meltan",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Metal"],
    evolvesTo: ["Melmetal"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Beam",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "102",
    nationalPokedexNumbers: [808],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/102.png",
      large: "https://images.pokemontcg.io/sv7/102_hires.png",
    },
    altArts: [
      {
        id: "sv7-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/sv7/102.png",
          large: "https://images.pokemontcg.io/sv7/102_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-103",
    name: "Meltan",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    evolvesTo: ["Melmetal"],
    attacks: [
      {
        name: "Knickknack Carrying",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Pokémon Tool card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Ram",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "103",
    nationalPokedexNumbers: [808],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/103.png",
      large: "https://images.pokemontcg.io/sv7/103_hires.png",
    },
    altArts: [
      {
        id: "sv7-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/sv7/103.png",
          large: "https://images.pokemontcg.io/sv7/103_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-18",
    name: "Meowscarada",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Grass"],
    evolvesFrom: "Floragato",
    abilities: [
      {
        name: "Showtime",
        text: "Once during your turn, if this Pokémon is on your Bench, you may switch it with your Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rising Bloom",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    nationalPokedexNumbers: [908],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/18.png",
      large: "https://images.pokemontcg.io/sv9/18_hires.png",
    },
    altArts: [
      {
        id: "sv9-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv9/18.png",
          large: "https://images.pokemontcg.io/sv9/18_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-34",
    name: "Meowstic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Psychic"],
    evolvesFrom: "Espurr",
    attacks: [
      {
        name: "Perplex",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Psychic",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "This attack does 30 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "34",
    nationalPokedexNumbers: [678],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-34/small",
      large: "https://images.scrydex.com/pokemon/me3-34/large",
    },
    altArts: [
      {
        id: "me3-34",
        number: "34",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-34/small",
          large: "https://images.scrydex.com/pokemon/me3-34/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-37",
    name: "Meowstic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Psychic"],
    evolvesFrom: "Espurr",
    attacks: [
      {
        name: "Tricky Steps",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "You may move an Energy from your opponent's Active Pokémon to 1 of their Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    flavorText:
      "When in danger, it raises its ears and releases enough psychic power to grind a 10-ton truck into dust.",
    nationalPokedexNumbers: [678],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-37/small",
      large: "https://images.scrydex.com/pokemon/me4-37/large",
    },
    altArts: [
      {
        id: "me4-37",
        number: "37",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-37/small",
          large: "https://images.scrydex.com/pokemon/me4-37/large",
        },
        flavorText:
          "When in danger, it raises its ears and releases enough psychic power to grind a 10-ton truck into dust.",
      },
    ],
  },
  {
    id: "sv8-85",
    name: "Meowstic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Espurr",
    abilities: [
      {
        name: "Beckoning Tail",
        text: "You must discard a Chill Teaser Toy card from your hand in order to use this Ability. Once during your turn, you may switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Psyshot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "85",
    nationalPokedexNumbers: [678],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/85.png",
      large: "https://images.pokemontcg.io/sv8/85_hires.png",
    },
    altArts: [
      {
        id: "sv8-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv8/85.png",
          large: "https://images.pokemontcg.io/sv8/85_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-106",
    name: "Meowth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Persian"],
    attacks: [
      {
        name: "Fury Swipes",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "Flip 3 coins. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "106",
    flavorText:
      "It loves things that sparkle. When it sees a shiny object, the gold coin on its head shines, too.",
    nationalPokedexNumbers: [52],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/me2/106.png",
      large: "https://images.pokemontcg.io/me2/106_hires.png",
    },
    altArts: [
      {
        id: "me2-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/me2/106.png",
          large: "https://images.pokemontcg.io/me2/106_hires.png",
        },
        flavorText:
          "It loves things that sparkle. When it sees a shiny object, the gold coin on its head shines, too.",
      },
      {
        id: "sv6pt5-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/48.png",
          large: "https://images.pokemontcg.io/sv6pt5/48_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-113",
    name: "Meowth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    attacks: [
      {
        name: "Pay Day",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Draw a card.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "113",
    nationalPokedexNumbers: [52],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-113/small",
      large: "https://images.scrydex.com/pokemon/me55-113/large",
    },
    altArts: [
      {
        id: "me55-113",
        number: "113",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-113/small",
          large: "https://images.scrydex.com/pokemon/me55-113/large",
        },
        flavorText: "",
      },
      {
        id: "me55-144",
        number: "144",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-144/small",
          large: "https://images.scrydex.com/pokemon/me55-144/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-62",
    name: "Meowth ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "170",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Last-Ditch Catch",
        text: 'Once during your turn, when you play this Pokémon from your hand onto your Bench, you may use this Ability. Search your deck for a Supporter card, reveal it, and put it into your hand. Then, shuffle your deck. You can\'t use more than 1 Ability that has "Last-Ditch" in its name each turn.',
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Tuck Tail",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "Put this Pokémon and all attached cards into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    nationalPokedexNumbers: [52],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-62/small",
      large: "https://images.scrydex.com/pokemon/me3-62/large",
    },
    altArts: [
      {
        id: "me3-62",
        number: "62",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-62/small",
          large: "https://images.scrydex.com/pokemon/me3-62/large",
        },
        flavorText: "",
      },
      {
        id: "me3-107",
        number: "107",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-107/small",
          large: "https://images.scrydex.com/pokemon/me3-107/large",
        },
        flavorText: "",
      },
      {
        id: "me3-121",
        number: "121",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-121/small",
          large: "https://images.scrydex.com/pokemon/me3-121/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-79",
    name: "Mesprit",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Full Heart",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 2 Basic Psychic Energy cards from your hand to your Pokémon in any way you like.",
      },
      {
        name: "Guardian Burst",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "If you don't have Uxie and Azelf on your Bench, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "79",
    nationalPokedexNumbers: [481],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/79.png",
      large: "https://images.pokemontcg.io/sv8/79_hires.png",
    },
    altArts: [
      {
        id: "sv8-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv8/79.png",
          large: "https://images.pokemontcg.io/sv8/79_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-204",
        number: "204",
        images: {
          small: "https://images.pokemontcg.io/sv8/204.png",
          large: "https://images.pokemontcg.io/sv8/204_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-61",
    name: "Metagross",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Metal"],
    evolvesFrom: "Metang",
    attacks: [
      {
        name: "Bounce Back",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
      {
        name: "Metallic Hammer",
        cost: ["Metal", "Metal", "Metal", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150+",
        text: "You may discard 3 Metal Energy from this Pokémon and have this attack do 150 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "61",
    flavorText:
      "Metang combined to form it. With four brains, it has the intelligence of a supercomputer.",
    nationalPokedexNumbers: [376],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-61/small",
      large: "https://images.scrydex.com/pokemon/me4-61/large",
    },
    altArts: [
      {
        id: "me4-61",
        number: "61",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-61/small",
          large: "https://images.scrydex.com/pokemon/me4-61/large",
        },
        flavorText:
          "Metang combined to form it. With four brains, it has the intelligence of a supercomputer.",
      },
    ],
  },
  {
    id: "me55c-11",
    name: "Metagross",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "100",
    types: ["Lightning", "Metal"],
    evolvesFrom: "Metang",
    rules: ["This Pokémon is both Lightning Metal type."],
    abilities: [
      {
        name: "Delta Control",
        text: "Once during your turn (before your attack), you may look at the top 4 cards of your deck, choose 1 of them, and put it into your hand. Put the 3 other cards on the bottom of your deck in any order. This power can't be used if Metagross is affected by a Special Condition.",
        type: "Poké-POWER",
      },
    ],
    attacks: [
      {
        name: "Crush and Burn",
        cost: ["Lightning", "Metal"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "You may discard as many Energy cards as you like attached to your Pokémon in play. If you do, this attack does 30 damage plus 20 more damage for each Energy card you discarded.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "11",
    nationalPokedexNumbers: [376],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-11/small",
      large: "https://images.scrydex.com/pokemon/me55c-11/large",
    },
    altArts: [
      {
        id: "me55c-11",
        number: "11",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-11/small",
          large: "https://images.scrydex.com/pokemon/me55c-11/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-115",
    name: "Metagross",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Metal"],
    evolvesFrom: "Metang",
    attacks: [
      {
        name: "Meteor Mash",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "During your next turn, this Pokémon's Meteor Mash attack does 60 more damage (before applying Weakness and Resistance).",
      },
      {
        name: "Luster Blast",
        cost: ["Metal", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "200",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "115",
    flavorText:
      "Because the magnetic powers of these Pokémon get stronger in freezing temperatures, Metagross living on snowy mountains are full of energy.",
    nationalPokedexNumbers: [376],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/115.png",
      large: "https://images.pokemontcg.io/sv5/115_hires.png",
    },
    altArts: [
      {
        id: "sv5-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/sv5/115.png",
          large: "https://images.pokemontcg.io/sv5/115_hires.png",
        },
        flavorText:
          "Because the magnetic powers of these Pokémon get stronger in freezing temperatures, Metagross living on snowy mountains are full of energy.",
      },
      {
        id: "sv5-178",
        number: "178",
        images: {
          small: "https://images.pokemontcg.io/sv5/178.png",
          large: "https://images.pokemontcg.io/sv5/178_hires.png",
        },
        flavorText:
          "Because the magnetic powers of these Pokémon get stronger in freezing temperatures, Metagross living on snowy mountains are full of energy.",
      },
    ],
  },
  {
    id: "sv9-63",
    name: "Metagross",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Psychic"],
    evolvesFrom: "Metang",
    attacks: [
      {
        name: "Wrack Down",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "",
      },
      {
        name: "Conjoined Beams",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "130+",
        text: "If Beldum and Metang are on your Bench, this attack does 150 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "63",
    nationalPokedexNumbers: [376],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/63.png",
      large: "https://images.pokemontcg.io/sv9/63_hires.png",
    },
    altArts: [
      {
        id: "sv9-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv9/63.png",
          large: "https://images.pokemontcg.io/sv9/63_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-60",
    name: "Metang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Metal"],
    evolvesFrom: "Beldum",
    attacks: [
      {
        name: "Metal Claw",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Guard Press",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "60",
    flavorText:
      "It is formed by two Beldum joining together. Its steel body won't be scratched if it collides with a jet.",
    nationalPokedexNumbers: [375],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-60/small",
      large: "https://images.scrydex.com/pokemon/me4-60/large",
    },
    altArts: [
      {
        id: "me4-60",
        number: "60",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-60/small",
          large: "https://images.scrydex.com/pokemon/me4-60/large",
        },
        flavorText:
          "It is formed by two Beldum joining together. Its steel body won't be scratched if it collides with a jet.",
      },
      {
        id: "me4-94",
        number: "94",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-94/small",
          large: "https://images.scrydex.com/pokemon/me4-94/large",
        },
        flavorText:
          "It is formed by two Beldum joining together. Its steel body won't be scratched if it collides with a jet.",
      },
    ],
  },
  {
    id: "sv5-114",
    name: "Metang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Metal"],
    evolvesFrom: "Beldum",
    evolvesTo: ["Metagross"],
    abilities: [
      {
        name: "Metal Maker",
        text: "Once during your turn, you may look at the top 4 cards of your deck and attach any number of Basic Metal Energy cards you find there to your Pokémon in any way you like. Shuffle the other cards and put them on the bottom of your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Beam",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "114",
    flavorText:
      "Two Beldum have become stuck together via their own magnetic forces. With two brains, the resulting Metang has doubled psychic powers.",
    nationalPokedexNumbers: [375],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/114.png",
      large: "https://images.pokemontcg.io/sv5/114_hires.png",
    },
    altArts: [
      {
        id: "sv5-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/sv5/114.png",
          large: "https://images.pokemontcg.io/sv5/114_hires.png",
        },
        flavorText:
          "Two Beldum have become stuck together via their own magnetic forces. With two brains, the resulting Metang has doubled psychic powers.",
      },
    ],
  },
  {
    id: "sv9-62",
    name: "Metang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Psychic"],
    evolvesFrom: "Beldum",
    evolvesTo: ["Metagross"],
    attacks: [
      {
        name: "Psypunch",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Zen Headbutt",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "62",
    nationalPokedexNumbers: [375],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/62.png",
      large: "https://images.pokemontcg.io/sv9/62_hires.png",
    },
    altArts: [
      {
        id: "sv9-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/sv9/62.png",
          large: "https://images.pokemontcg.io/sv9/62_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-90",
    name: "Metang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Metal"],
    evolvesFrom: "Beldum",
    abilities: [
      {
        name: "Metal Maker",
        text: "Once during your turn, you may look at the top 4 cards of your deck and attach any number of Basic Metal Energy cards you find there to your Pokémon in any way you like. Shuffle the other cards and put them on the bottom of your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        cost: ["Metal", "Colorless", "Colorless"],
        name: "Beam",
        damage: "60",
        text: "",
        convertedEnergyCost: 3,
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "90",
    flavorText:
      "Two Beldum have become stuck together via their own magnetic forces. With two brains, the resulting Metang has doubled psychic powers.",
    nationalPokedexNumbers: [375],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/90.png",
      large: "https://images.pokemontcg.io/svp/90_hires.png",
    },
    altArts: [
      {
        id: "svp-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/svp/90.png",
          large: "https://images.pokemontcg.io/svp/90_hires.png",
        },
        flavorText:
          "Two Beldum have become stuck together via their own magnetic forces. With two brains, the resulting Metang has doubled psychic powers.",
      },
    ],
  },
  {
    id: "sv9-2",
    name: "Metapod",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Caterpie",
    evolvesTo: ["Butterfree"],
    attacks: [
      {
        name: "Harden",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks if that damage is 60 or less.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "2",
    nationalPokedexNumbers: [11],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/2.png",
      large: "https://images.pokemontcg.io/sv9/2_hires.png",
    },
    altArts: [
      {
        id: "sv9-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv9/2.png",
          large: "https://images.pokemontcg.io/sv9/2_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-65",
    name: "Mew",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Psychic",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "10+",
        text: "This attack does 40 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "65",
    nationalPokedexNumbers: [151],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-65/small",
      large: "https://images.scrydex.com/pokemon/me55-65/large",
    },
    altArts: [
      {
        id: "me55-65",
        number: "65",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-65/small",
          large: "https://images.scrydex.com/pokemon/me55-65/large",
        },
        flavorText: "",
      },
      {
        id: "me55-R",
        number: "R",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-R/small",
          large: "https://images.scrydex.com/pokemon/me55-R/large",
        },
        flavorText: "",
      },
      {
        id: "me55-G",
        number: "G",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-G/small",
          large: "https://images.scrydex.com/pokemon/me55-G/large",
        },
        flavorText: "",
      },
      {
        id: "me55-B",
        number: "B",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-B/small",
          large: "https://images.scrydex.com/pokemon/me55-B/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-114",
    name: "Mew VMAX",
    supertype: "Pokémon",
    subtypes: ["VMAX"],
    hp: "310",
    types: ["Psychic"],
    evolvesFrom: "Mew V",
    rules: [
      "When your Pokémon VMAX is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Cross Fusion Strike",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        text: "Choose 1 of your Benched Fusion Strike Pokémon's attacks and use it as this attack.",
      },
      {
        name: "Max Miracle",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "114",
    nationalPokedexNumbers: [151],
    regulationMark: "E",
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-114/small",
      large: "https://images.scrydex.com/pokemon/me55c-114/large",
    },
    altArts: [
      {
        id: "me55c-114",
        number: "114",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-114/small",
          large: "https://images.scrydex.com/pokemon/me55c-114/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-66",
    name: "Mew ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "160",
    types: ["Psychic"],
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Memory Helix",
        text: "This Pokémon can use the attacks of any of your Benched Pokémon. (You still need the necessary Energy to use each attack.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Teleportation Burst",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "You may switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "66",
    nationalPokedexNumbers: [151],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-66/small",
      large: "https://images.scrydex.com/pokemon/me55-66/large",
    },
    altArts: [
      {
        id: "me55-66",
        number: "66",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-66/small",
          large: "https://images.scrydex.com/pokemon/me55-66/large",
        },
        flavorText: "",
      },
      {
        id: "me55-152",
        number: "152",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-152/small",
          large: "https://images.scrydex.com/pokemon/me55-152/large",
        },
        flavorText: "",
      },
      {
        id: "me55-158",
        number: "158",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-158/small",
          large: "https://images.scrydex.com/pokemon/me55-158/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-63",
    name: "Mewtwo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Empower",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        text: "Attach up to 2 Basic Energy cards from your discard pile to 1 of your Pokémon.",
      },
      {
        name: "Psydrive",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "63",
    nationalPokedexNumbers: [150],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-63/small",
      large: "https://images.scrydex.com/pokemon/me55-63/large",
    },
    altArts: [
      {
        id: "me55-63",
        number: "63",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-63/small",
          large: "https://images.scrydex.com/pokemon/me55-63/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-59",
    name: "Mewtwo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Super Psy Bolt",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "59",
    nationalPokedexNumbers: [150],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/59.png",
      large: "https://images.pokemontcg.io/sv7/59_hires.png",
    },
    altArts: [
      {
        id: "sv7-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/sv7/59.png",
          large: "https://images.pokemontcg.io/sv7/59_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-64",
    name: "Mewtwo ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Psychic"],
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Photon Bullets",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        text: "This attack does 50 damage to each of your opponent's Pokémon ex. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Psychic Powers",
        cost: ["Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 3,
        damage: "230",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "64",
    nationalPokedexNumbers: [150],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-64/small",
      large: "https://images.scrydex.com/pokemon/me55-64/large",
    },
    altArts: [
      {
        id: "me55-64",
        number: "64",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-64/small",
          large: "https://images.scrydex.com/pokemon/me55-64/large",
        },
        flavorText: "",
      },
      {
        id: "me55-151",
        number: "151",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-151/small",
          large: "https://images.scrydex.com/pokemon/me55-151/large",
        },
        flavorText: "",
      },
      {
        id: "me55-157",
        number: "157",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-157/small",
          large: "https://images.scrydex.com/pokemon/me55-157/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-52",
    name: "Mienfoo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    evolvesTo: ["Mienshao"],
    attacks: [
      {
        name: "Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    flavorText:
      "In fights, they dominate with onslaughts of flowing, continuous attacks. With their sharp claws, they cut enemies.",
    nationalPokedexNumbers: [619],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/52.png",
      large: "https://images.pokemontcg.io/rsv10pt5/52_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/52.png",
          large: "https://images.pokemontcg.io/rsv10pt5/52_hires.png",
        },
        flavorText:
          "In fights, they dominate with onslaughts of flowing, continuous attacks. With their sharp claws, they cut enemies.",
      },
      {
        id: "rsv10pt5-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/133.png",
          large: "https://images.pokemontcg.io/rsv10pt5/133_hires.png",
        },
        flavorText:
          "In fights, they dominate with onslaughts of flowing, continuous attacks. With their sharp claws, they cut enemies.",
      },
    ],
  },
  {
    id: "sv7-83",
    name: "Mienfoo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    evolvesTo: ["Mienshao"],
    attacks: [
      {
        name: "Knock Off",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Discard a random card from your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    nationalPokedexNumbers: [619],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/83.png",
      large: "https://images.pokemontcg.io/sv7/83_hires.png",
    },
    altArts: [
      {
        id: "sv7-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv7/83.png",
          large: "https://images.pokemontcg.io/sv7/83_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-53",
    name: "Mienshao",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Mienfoo",
    attacks: [
      {
        name: "Low Sweep",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Smash Uppercut",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "53",
    flavorText:
      "It wields the fur on its arms like a whip. Its arm attacks come with such rapidity that they cannot even be seen.",
    nationalPokedexNumbers: [620],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/53.png",
      large: "https://images.pokemontcg.io/rsv10pt5/53_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/53.png",
          large: "https://images.pokemontcg.io/rsv10pt5/53_hires.png",
        },
        flavorText:
          "It wields the fur on its arms like a whip. Its arm attacks come with such rapidity that they cannot even be seen.",
      },
      {
        id: "rsv10pt5-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/134.png",
          large: "https://images.pokemontcg.io/rsv10pt5/134_hires.png",
        },
        flavorText:
          "It wields the fur on its arms like a whip. Its arm attacks come with such rapidity that they cannot even be seen.",
      },
    ],
  },
  {
    id: "sv7-84",
    name: "Mienshao",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fighting"],
    evolvesFrom: "Mienfoo",
    attacks: [
      {
        name: "Gale Roundhouse",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your opponent has 5 or fewer cards in their hand, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "84",
    nationalPokedexNumbers: [620],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/84.png",
      large: "https://images.pokemontcg.io/sv7/84_hires.png",
    },
    altArts: [
      {
        id: "sv7-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv7/84.png",
          large: "https://images.pokemontcg.io/sv7/84_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-129",
    name: "Mightyena",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Poochyena",
    attacks: [
      {
        name: "Kick Away",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
      {
        name: "Sharp Fang",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "129",
    flavorText:
      "It will always obey the commands of a skilled Trainer. Its behavior arises from its living in packs in ancient times.",
    nationalPokedexNumbers: [262],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-129/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-129/large",
    },
    altArts: [
      {
        id: "me2pt5-129",
        number: "129",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-129/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-129/large",
        },
        flavorText:
          "It will always obey the commands of a skilled Trainer. Its behavior arises from its living in packs in ancient times.",
      },
      {
        id: "me2pt5-243",
        number: "243",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-243/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-243/large",
        },
        flavorText:
          "It will always obey the commands of a skilled Trainer. Its behavior arises from its living in packs in ancient times.",
      },
      {
        id: "sv5-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/sv5/106.png",
          large: "https://images.pokemontcg.io/sv5/106_hires.png",
        },
        flavorText:
          "It will always obey the commands of a skilled Trainer. Its behavior arises from its living in packs in ancient times.",
      },
    ],
  },
  {
    id: "sv6-114",
    name: "Mightyena",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Poochyena",
    attacks: [
      {
        name: "Hunting Pack",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If Mightyena is on your Bench, this attack does 90 more damage.",
      },
      {
        name: "Corner",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "114",
    flavorText:
      "Once it's caught the scent of faraway prey, the leader gives a signal, and the whole pack moves out.",
    nationalPokedexNumbers: [262],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/114.png",
      large: "https://images.pokemontcg.io/sv6/114_hires.png",
    },
    altArts: [
      {
        id: "sv6-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/sv6/114.png",
          large: "https://images.pokemontcg.io/sv6/114_hires.png",
        },
        flavorText:
          "Once it's caught the scent of faraway prey, the leader gives a signal, and the whole pack moves out.",
      },
    ],
  },
  {
    id: "me2-43",
    name: "Milcery",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    evolvesTo: ["Alcremie"],
    attacks: [
      {
        name: "Draining Kiss",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Heal 10 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "43",
    flavorText:
      "The more sweet aromas it absorbs, the more its body swells. Milcery will deflate when its energy level drops.",
    nationalPokedexNumbers: [868],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/43.png",
      large: "https://images.pokemontcg.io/me2/43_hires.png",
    },
    altArts: [
      {
        id: "me2-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/me2/43.png",
          large: "https://images.pokemontcg.io/me2/43_hires.png",
        },
        flavorText:
          "The more sweet aromas it absorbs, the more its body swells. Milcery will deflate when its energy level drops.",
      },
    ],
  },
  {
    id: "sv7-64",
    name: "Milcery",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Alcremie"],
    attacks: [
      {
        name: "Mumble",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    nationalPokedexNumbers: [868],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/64.png",
      large: "https://images.pokemontcg.io/sv7/64_hires.png",
    },
    altArts: [
      {
        id: "sv7-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv7/64.png",
          large: "https://images.pokemontcg.io/sv7/64_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/sv7/152.png",
          large: "https://images.pokemontcg.io/sv7/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-74",
    name: "Milcery",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    evolvesTo: ["Alcremie"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "74",
    nationalPokedexNumbers: [868],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/74.png",
      large: "https://images.pokemontcg.io/sv9/74_hires.png",
    },
    altArts: [
      {
        id: "sv9-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv9/74.png",
          large: "https://images.pokemontcg.io/sv9/74_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-50",
    name: "Milotic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Feebas",
    abilities: [
      {
        name: "Mentally Calm",
        text: "Your opponent's Pokémon in play and all attached cards can't be put into your opponent's hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hydro Splash",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    flavorText:
      "It lives at the bottom of clear lakes. In times of war, it shows itself, which soothes people's minds and hearts.",
    nationalPokedexNumbers: [350],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/50.png",
      large: "https://images.pokemontcg.io/sv6/50_hires.png",
    },
    altArts: [
      {
        id: "sv6-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv6/50.png",
          large: "https://images.pokemontcg.io/sv6/50_hires.png",
        },
        flavorText:
          "It lives at the bottom of clear lakes. In times of war, it shows itself, which soothes people's minds and hearts.",
      },
    ],
  },
  {
    id: "sv8-42",
    name: "Milotic ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Water"],
    evolvesFrom: "Feebas",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Sparkling Scales",
        text: "Prevent all damage from and effects of attacks from your opponent's Tera Pokémon done to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hypno Splash",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "42",
    nationalPokedexNumbers: [350],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/42.png",
      large: "https://images.pokemontcg.io/sv8/42_hires.png",
    },
    altArts: [
      {
        id: "sv8-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/sv8/42.png",
          large: "https://images.pokemontcg.io/sv8/42_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-217",
        number: "217",
        images: {
          small: "https://images.pokemontcg.io/sv8/217.png",
          large: "https://images.pokemontcg.io/sv8/217_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-237",
        number: "237",
        images: {
          small: "https://images.pokemontcg.io/sv8/237.png",
          large: "https://images.pokemontcg.io/sv8/237_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-106",
    name: "Miltank",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Bellyful of Milk",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Flip 2 coins. If both of them are heads, heal all damage from 1 of your Pokémon.",
      },
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "106",
    nationalPokedexNumbers: [241],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/106.png",
      large: "https://images.pokemontcg.io/me1/106_hires.png",
    },
    altArts: [
      {
        id: "me1-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/me1/106.png",
          large: "https://images.pokemontcg.io/me1/106_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-81",
    name: "Miltank",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Colorless"],
    attacks: [
      {
        name: "Rollout",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Moomoo Rolling",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "You can use this attack only if this Pokémon used Rollout during your last turn.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "81",
    nationalPokedexNumbers: [241],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/81.png",
      large: "https://images.pokemontcg.io/sv8pt5/81_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/81.png",
          large: "https://images.pokemontcg.io/sv8pt5/81_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-42",
    name: "Mimikyu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Pokémon and put it onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Scratch",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "42",
    flavorText:
      "This Pokémon lives in dark places untouched by sunlight. When it appears before humans, it hides itself under a cloth that resembles a Pikachu.",
    nationalPokedexNumbers: [778],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/42.png",
      large: "https://images.pokemontcg.io/me2/42_hires.png",
    },
    altArts: [
      {
        id: "me2-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/me2/42.png",
          large: "https://images.pokemontcg.io/me2/42_hires.png",
        },
        flavorText:
          "This Pokémon lives in dark places untouched by sunlight. When it appears before humans, it hides itself under a cloth that resembles a Pikachu.",
      },
    ],
  },
  {
    id: "sv9-69",
    name: "Mimikyu ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Psychic"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Mischievous Hands",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Choose 2 of your opponent's Pokémon and put 3 damage counters on each of them.",
      },
      {
        name: "Ghostly Trip",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "69",
    nationalPokedexNumbers: [778],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/69.png",
      large: "https://images.pokemontcg.io/sv9/69_hires.png",
    },
    altArts: [
      {
        id: "sv9-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv9/69.png",
          large: "https://images.pokemontcg.io/sv9/69_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-75",
    name: "Minccino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Cinccino"],
    attacks: [
      {
        name: "Tail Slap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "Flip 2 coins. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "75",
    flavorText:
      "They greet one another by rubbing each other with their tails, which are always kept well groomed and clean.",
    nationalPokedexNumbers: [572],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/75.png",
      large: "https://images.pokemontcg.io/zsv10pt5/75_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/75.png",
          large: "https://images.pokemontcg.io/zsv10pt5/75_hires.png",
        },
        flavorText:
          "They greet one another by rubbing each other with their tails, which are always kept well groomed and clean.",
      },
      {
        id: "zsv10pt5-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/152.png",
          large: "https://images.pokemontcg.io/zsv10pt5/152_hires.png",
        },
        flavorText:
          "They greet one another by rubbing each other with their tails, which are always kept well groomed and clean.",
      },
    ],
  },
  {
    id: "me4-72",
    name: "Minccino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Take Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    flavorText:
      "These Pokemon like things neat and tidy. They are always sweeping and dusting their habitat, using their tails as brooms.",
    nationalPokedexNumbers: [572],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-72/small",
      large: "https://images.scrydex.com/pokemon/me4-72/large",
    },
    altArts: [
      {
        id: "me4-72",
        number: "72",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-72/small",
          large: "https://images.scrydex.com/pokemon/me4-72/large",
        },
        flavorText:
          "These Pokemon like things neat and tidy. They are always sweeping and dusting their habitat, using their tails as brooms.",
      },
    ],
  },
  {
    id: "sv5-136",
    name: "Minccino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Cinccino"],
    attacks: [
      {
        name: "Beat",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Cleaning Up",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Discard up to 2 Pokémon Tools from your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "136",
    flavorText:
      "The way it brushes away grime with its tail can be helpful when cleaning. But its focus on spotlessness can make cleaning more of a hassle.",
    nationalPokedexNumbers: [572],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/136.png",
      large: "https://images.pokemontcg.io/sv5/136_hires.png",
    },
    altArts: [
      {
        id: "sv5-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/sv5/136.png",
          large: "https://images.pokemontcg.io/sv5/136_hires.png",
        },
        flavorText:
          "The way it brushes away grime with its tail can be helpful when cleaning. But its focus on spotlessness can make cleaning more of a hassle.",
      },
      {
        id: "sv5-182",
        number: "182",
        images: {
          small: "https://images.pokemontcg.io/sv5/182.png",
          large: "https://images.pokemontcg.io/sv5/182_hires.png",
        },
        flavorText:
          "The way it brushes away grime with its tail can be helpful when cleaning. But its focus on spotlessness can make cleaning more of a hassle.",
      },
    ],
  },
  {
    id: "sv9-125",
    name: "Minccino",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Cinccino"],
    attacks: [
      {
        name: "Slap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "125",
    nationalPokedexNumbers: [572],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/125.png",
      large: "https://images.pokemontcg.io/sv9/125_hires.png",
    },
    altArts: [
      {
        id: "sv9-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/sv9/125.png",
          large: "https://images.pokemontcg.io/sv9/125_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-124",
    name: "Minior",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Colorless"],
    attacks: [
      {
        name: "Shoot Meteors",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        text: "Discard all Energy from this Pokémon, and this attack does 120 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "124",
    nationalPokedexNumbers: [774],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-124/small",
      large: "https://images.scrydex.com/pokemon/me55-124/large",
    },
    altArts: [
      {
        id: "me55-124",
        number: "124",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-124/small",
          large: "https://images.scrydex.com/pokemon/me55-124/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-28",
    name: "Miraidon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    abilities: [
      {
        name: "Photon Cord",
        text: "If this Pokémon is in the Active Spot and is Knocked Out by damage from an attack from your opponent's Pokémon, move up to 2 Basic Lightning Energy cards from this Pokémon to 1 of your Benched Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Thunder",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "28",
    flavorText:
      "This seems to be the Iron Serpent mentioned in an old book. The Iron Serpent is said to have turned the land to ash with its lightning.",
    nationalPokedexNumbers: [1008],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-28/small",
      large: "https://images.scrydex.com/pokemon/me5-28/large",
    },
    altArts: [
      {
        id: "me5-28",
        number: "28",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-28/small",
          large: "https://images.scrydex.com/pokemon/me5-28/large",
        },
        flavorText:
          "This seems to be the Iron Serpent mentioned in an old book. The Iron Serpent is said to have turned the land to ash with its lightning.",
      },
    ],
  },
  {
    id: "me55-62",
    name: "Miraidon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Mach Bolt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20",
      },
      {
        name: "Electro Drift",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "Discard 2 Lightning Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    nationalPokedexNumbers: [1008],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-62/small",
      large: "https://images.scrydex.com/pokemon/me55-62/large",
    },
    altArts: [
      {
        id: "me55-62",
        number: "62",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-62/small",
          large: "https://images.scrydex.com/pokemon/me55-62/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-121",
    name: "Miraidon",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "110",
    types: ["Dragon"],
    attacks: [
      {
        name: "Peak Acceleration",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "Search your deck for up to 2 Basic Energy cards and attach them to your Future Pokémon in any way you like. Then, shuffle your deck.",
      },
      {
        name: "Sparking Strike",
        cost: ["Lightning", "Lightning", "Psychic"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "121",
    flavorText:
      "This seems to be the Iron Serpent mentioned in an old book. The Iron Serpent is said to have turned the land to ash with its lightning.",
    nationalPokedexNumbers: [1008],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/121.png",
      large: "https://images.pokemontcg.io/sv5/121_hires.png",
    },
    altArts: [
      {
        id: "sv5-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/sv5/121.png",
          large: "https://images.pokemontcg.io/sv5/121_hires.png",
        },
        flavorText:
          "This seems to be the Iron Serpent mentioned in an old book. The Iron Serpent is said to have turned the land to ash with its lightning.",
      },
    ],
  },
  {
    id: "sv8-69",
    name: "Miraidon",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "C.O.D.E.: Protect",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "During your opponent's next turn, prevent all damage done to each of your Future Pokémon by attacks from Pokémon ex. If this Pokémon is no longer your Active Pokémon, this effect ends.",
      },
      {
        name: "Thunder Claws",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "69",
    nationalPokedexNumbers: [1008],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/69.png",
      large: "https://images.pokemontcg.io/sv8/69_hires.png",
    },
    altArts: [
      {
        id: "sv8-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/sv8/69.png",
          large: "https://images.pokemontcg.io/sv8/69_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-92",
    name: "Miraidon",
    supertype: "Pokémon",
    subtypes: ["Basic", "Future"],
    hp: "110",
    types: ["Dragon"],
    attacks: [
      {
        cost: ["Colorless"],
        name: "Peak Acceleration",
        damage: "40",
        text: "Search your deck for up to 2 Basic Energy cards and attach them to your Future Pokémon in any way you like. Then, shuffle your deck.",
        convertedEnergyCost: 1,
      },
      {
        cost: ["Lightning", "Lightning", "Psychic"],
        name: "Sparking Strike",
        damage: "160",
        text: "",
        convertedEnergyCost: 3,
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "92",
    flavorText:
      "This seems to be the Iron Serpent mentioned in an old book. The Iron Serpent is said to have turned the land to ash with its lightning.",
    nationalPokedexNumbers: [1008],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/92.png",
      large: "https://images.pokemontcg.io/svp/92_hires.png",
    },
    altArts: [
      {
        id: "svp-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/svp/92.png",
          large: "https://images.pokemontcg.io/svp/92_hires.png",
        },
        flavorText:
          "This seems to be the Iron Serpent mentioned in an old book. The Iron Serpent is said to have turned the land to ash with its lightning.",
      },
    ],
  },
  {
    id: "svp-148",
    name: "Miraidon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Electric Claws",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Mach Bolt",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "148",
    nationalPokedexNumbers: [1008],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/148.png",
      large: "https://images.pokemontcg.io/svp/148_hires.png",
    },
    altArts: [
      {
        id: "svp-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/svp/148.png",
          large: "https://images.pokemontcg.io/svp/148_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-73",
    name: "Miraidon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "220",
    types: ["Lightning"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent’s).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Slashing Claw",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Hadron Spark",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    nationalPokedexNumbers: [1008],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-73/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-73/large",
    },
    altArts: [
      {
        id: "me2pt5-73",
        number: "73",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-73/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-73/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-122",
    name: "Miraidon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Future"],
    hp: "220",
    types: ["Dragon"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Repulsion Bolt",
        cost: ["Lightning", "Psychic"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 100 more damage.",
      },
      {
        name: "Cyber Drive",
        cost: ["Lightning", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "220",
        text: "During your next turn, this Pokémon can't use Cyber Drive.",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "122",
    nationalPokedexNumbers: [1008],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/122.png",
      large: "https://images.pokemontcg.io/sv5/122_hires.png",
    },
    altArts: [
      {
        id: "sv5-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/sv5/122.png",
          large: "https://images.pokemontcg.io/sv5/122_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-35",
    name: "Misdreavus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Mismagius"],
    attacks: [
      {
        name: "Petty Grudge",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    flavorText:
      "This Pokémon startles people in the middle of the night. It gathers fear as its energy.",
    nationalPokedexNumbers: [200],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/35.png",
      large: "https://images.pokemontcg.io/me2/35_hires.png",
    },
    altArts: [
      {
        id: "me2-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/me2/35.png",
          large: "https://images.pokemontcg.io/me2/35_hires.png",
        },
        flavorText:
          "This Pokémon startles people in the middle of the night. It gathers fear as its energy.",
      },
    ],
  },
  {
    id: "me2pt5-85",
    name: "Misdreavus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Ascension",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a card that evolves from this Pokémon and put it onto this Pokémon to evolve it. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "85",
    flavorText:
      "It loves to bite and yank people's hair from behind without warning, just to see their shocked reactions.",
    nationalPokedexNumbers: [200],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-85/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-85/large",
    },
    altArts: [
      {
        id: "me2pt5-85",
        number: "85",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-85/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-85/large",
        },
        flavorText:
          "It loves to bite and yank people's hair from behind without warning, just to see their shocked reactions.",
      },
      {
        id: "me2pt5-233",
        number: "233",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-233/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-233/large",
        },
        flavorText:
          "It loves to bite and yank people’s hair from behind without warning, just to see their shocked reactions.",
      },
    ],
  },
  {
    id: "me2pt5-86",
    name: "Mismagius",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Psychic"],
    evolvesFrom: "Misdreavus",
    attacks: [
      {
        name: "Assassin's Magic",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "If your opponent's Active Pokémon is affected by a Special Condition, place 6 damage counters on 1 of your opponent's Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "86",
    flavorText:
      "Its cries sound like incantations to torment the foe. It appears where you least expect it.",
    nationalPokedexNumbers: [429],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-86/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-86/large",
    },
    altArts: [
      {
        id: "me2pt5-86",
        number: "86",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-86/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-86/large",
        },
        flavorText:
          "Its cries sound like incantations to torment the foe. It appears where you least expect it.",
      },
    ],
  },
  {
    id: "me2-36",
    name: "Mismagius ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Psychic"],
    evolvesFrom: "Misdreavus",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Swirling Prose",
        text: "As long as this Pokémon is in the Active Spot, whenever your opponent's Active Pokémon moves to the Bench during their turn, their new Active Pokémon is now Confused.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hexa-Magic",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "150",
        text: "You may draw cards until you have 6 cards in your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    nationalPokedexNumbers: [429],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/36.png",
      large: "https://images.pokemontcg.io/me2/36_hires.png",
    },
    altArts: [
      {
        id: "me2-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/me2/36.png",
          large: "https://images.pokemontcg.io/me2/36_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/me2/112.png",
          large: "https://images.pokemontcg.io/me2/112_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-49",
    name: "Misty's Gyarados",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "180",
    types: ["Water"],
    evolvesFrom: "Misty's Magikarp",
    attacks: [
      {
        name: "Splashing Panic",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "70×",
        text: "Discard the top 7 cards of your deck, and this attack does 70 damage for each Misty's Pokémon that you discarded in this way.",
      },
      {
        name: "Waterfall",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "49",
    nationalPokedexNumbers: [130],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/49.png",
      large: "https://images.pokemontcg.io/sv10/49_hires.png",
    },
    altArts: [
      {
        id: "sv10-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/sv10/49.png",
          large: "https://images.pokemontcg.io/sv10/49_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-50",
    name: "Misty's Lapras",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Swim Together",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Misty's Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Surf",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [131],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/50.png",
      large: "https://images.pokemontcg.io/sv10/50_hires.png",
    },
    altArts: [
      {
        id: "sv10-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv10/50.png",
          large: "https://images.pokemontcg.io/sv10/50_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-194",
        number: "194",
        images: {
          small: "https://images.pokemontcg.io/sv10/194.png",
          large: "https://images.pokemontcg.io/sv10/194_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-48",
    name: "Misty's Magikarp",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Water"],
    evolvesTo: ["Gyarados"],
    abilities: [
      {
        name: "So Submerged",
        text: "As long as this Pokémon is on your Bench, prevent all damage from and effects of attacks from your opponent's Pokémon done to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Splash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "48",
    nationalPokedexNumbers: [129],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/48.png",
      large: "https://images.pokemontcg.io/sv10/48_hires.png",
    },
    altArts: [
      {
        id: "sv10-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv10/48.png",
          large: "https://images.pokemontcg.io/sv10/48_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-45",
    name: "Misty's Psyduck",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Golduck"],
    abilities: [
      {
        name: "Flustered Leap",
        text: "Once during your turn, if this Pokémon is on your Bench, you may discard the bottom card of your deck. If you do, discard all cards from this Pokémon and put this Pokémon on top of your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Sprinkle Water",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "45",
    nationalPokedexNumbers: [54],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/45.png",
      large: "https://images.pokemontcg.io/sv10/45_hires.png",
    },
    altArts: [
      {
        id: "sv10-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv10/45.png",
          large: "https://images.pokemontcg.io/sv10/45_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-193",
        number: "193",
        images: {
          small: "https://images.pokemontcg.io/sv10/193.png",
          large: "https://images.pokemontcg.io/sv10/193_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-47",
    name: "Misty's Starmie",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Misty's Staryu",
    attacks: [
      {
        name: "Abrupt Flash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "If this Pokémon evolved from Misty's Staryu during this turn, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "47",
    nationalPokedexNumbers: [121],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/47.png",
      large: "https://images.pokemontcg.io/sv10/47_hires.png",
    },
    altArts: [
      {
        id: "sv10-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv10/47.png",
          large: "https://images.pokemontcg.io/sv10/47_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-46",
    name: "Misty's Staryu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Starmie"],
    attacks: [
      {
        name: "Bubble Beam",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "46",
    nationalPokedexNumbers: [120],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/46.png",
      large: "https://images.pokemontcg.io/sv10/46_hires.png",
    },
    altArts: [
      {
        id: "sv10-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv10/46.png",
          large: "https://images.pokemontcg.io/sv10/46_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-14",
    name: "Moltres",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fire"],
    attacks: [
      {
        name: "Fighting Wings",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    flavorText:
      "There are stories of this Pokémon using its radiant, flame-cloaked wings to light up paths for those lost in the mountains.",
    nationalPokedexNumbers: [146],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/14.png",
      large: "https://images.pokemontcg.io/me2/14_hires.png",
    },
    altArts: [
      {
        id: "me2-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/me2/14.png",
          large: "https://images.pokemontcg.io/me2/14_hires.png",
        },
        flavorText:
          "There are stories of this Pokémon using its radiant, flame-cloaked wings to light up paths for those lost in the mountains.",
      },
    ],
  },
  {
    id: "me55-11",
    name: "Moltres",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fire"],
    abilities: [
      {
        name: "Fiery Flapping",
        text: "Once during your turn, if you have Articuno and Zapdos in play, you may use this Ability. Attach a Basic Fire Energy card from your hand to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Fire Spin",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    nationalPokedexNumbers: [146],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-11/small",
      large: "https://images.scrydex.com/pokemon/me55-11/large",
    },
    altArts: [
      {
        id: "me55-11",
        number: "11",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-11/small",
          large: "https://images.scrydex.com/pokemon/me55-11/large",
        },
        flavorText: "",
      },
      {
        id: "me55-130",
        number: "130",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-130/small",
          large: "https://images.scrydex.com/pokemon/me55-130/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-32",
    name: "Monferno",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fire"],
    evolvesFrom: "Chimchar",
    evolvesTo: ["Infernape"],
    attacks: [
      {
        name: "Chop",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
      {
        name: "Heat Blow",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    flavorText:
      "It skillfully controls the intensity of the fire on its tail to keep its foes at an ideal distance.",
    nationalPokedexNumbers: [391],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/32.png",
      large: "https://images.pokemontcg.io/sv6/32_hires.png",
    },
    altArts: [
      {
        id: "sv6-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv6/32.png",
          large: "https://images.pokemontcg.io/sv6/32_hires.png",
        },
        flavorText:
          "It skillfully controls the intensity of the fire on its tail to keep its foes at an ideal distance.",
      },
    ],
  },
  {
    id: "sv8-8",
    name: "Morelull",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Shiinotic"],
    attacks: [
      {
        name: "Attach",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    nationalPokedexNumbers: [755],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/8.png",
      large: "https://images.pokemontcg.io/sv8/8_hires.png",
    },
    altArts: [
      {
        id: "sv8-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv8/8.png",
          large: "https://images.pokemontcg.io/sv8/8_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-95",
    name: "Morgrem",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Darkness"],
    evolvesFrom: "Impidimp",
    evolvesTo: ["Grimmsnarl"],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
      {
        name: "Darkness Fang",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "95",
    nationalPokedexNumbers: [860],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/95.png",
      large: "https://images.pokemontcg.io/sv7/95_hires.png",
    },
    altArts: [
      {
        id: "sv7-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv7/95.png",
          large: "https://images.pokemontcg.io/sv7/95_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-72",
    name: "Morgrem",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Impidimp",
    evolvesTo: ["Grimmsnarl"],
    attacks: [
      {
        name: "Light Punch",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Smash Kick",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    nationalPokedexNumbers: [860],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/72.png",
      large: "https://images.pokemontcg.io/sv9/72_hires.png",
    },
    altArts: [
      {
        id: "sv9-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv9/72.png",
          large: "https://images.pokemontcg.io/sv9/72_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-61",
    name: "Morpeko",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Select a Snack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Discard the top 3 cards of your deck and put 1 of them into your hand.",
      },
      {
        name: "Slap",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "61",
    nationalPokedexNumbers: [877],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-61/small",
      large: "https://images.scrydex.com/pokemon/me55-61/large",
    },
    altArts: [
      {
        id: "me55-61",
        number: "61",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-61/small",
          large: "https://images.scrydex.com/pokemon/me55-61/large",
        },
        flavorText: "",
      },
      {
        id: "me55-135",
        number: "135",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-135/small",
          large: "https://images.scrydex.com/pokemon/me55-135/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-72",
    name: "Morpeko",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    abilities: [
      {
        name: "Snack Seek",
        text: "Once during your turn, you may look at the top card of your deck. You may discard that card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Pick and Stick",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 2 Basic Energy cards from your discard pile to your Pokémon in any way you like.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    flavorText:
      "It has a small stomach. If it isn't constantly eating the seeds it keeps in its pockets, it will get hungry immediately.",
    nationalPokedexNumbers: [877],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/72.png",
      large: "https://images.pokemontcg.io/sv6/72_hires.png",
    },
    altArts: [
      {
        id: "sv6-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv6/72.png",
          large: "https://images.pokemontcg.io/sv6/72_hires.png",
        },
        flavorText:
          "It has a small stomach. If it isn't constantly eating the seeds it keeps in its pockets, it will get hungry immediately.",
      },
    ],
  },
  {
    id: "me5-55",
    name: "Morpeko ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "180",
    types: ["Darkness"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Wheely Draw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Shuffle your hand into your deck. Then, draw 6 cards.",
      },
      {
        name: "Hangry Blaster",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "40+",
        text: "This attack does 40 more damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    nationalPokedexNumbers: [877],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-55/small",
      large: "https://images.scrydex.com/pokemon/me5-55/large",
    },
    altArts: [
      {
        id: "me5-55",
        number: "55",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-55/small",
          large: "https://images.scrydex.com/pokemon/me5-55/large",
        },
        flavorText: "",
      },
      {
        id: "me5-102",
        number: "102",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-102/small",
          large: "https://images.scrydex.com/pokemon/me5-102/large",
        },
        flavorText: "",
      },
      {
        id: "me5-117",
        number: "117",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-117/small",
          large: "https://images.scrydex.com/pokemon/me5-117/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-9",
    name: "Mow Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Trimming Mower",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Discard a Stadium in play.",
      },
      {
        name: "Gadget Show",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each Pokémon Tool attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    nationalPokedexNumbers: [479],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/9.png",
      large: "https://images.pokemontcg.io/sv10/9_hires.png",
    },
    altArts: [
      {
        id: "sv10-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv10/9.png",
          large: "https://images.pokemontcg.io/sv10/9_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-8",
    name: "Mow Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Grass"],
    attacks: [
      {
        name: "Reaping Dash",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Before doing damage, discard all Pokémon Tools and Special Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    nationalPokedexNumbers: [479],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/8.png",
      large: "https://images.pokemontcg.io/sv7/8_hires.png",
    },
    altArts: [
      {
        id: "sv7-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv7/8.png",
          large: "https://images.pokemontcg.io/sv7/8_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-63",
    name: "Mr. Mime",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Look-Alike Show",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent reveals their hand. You may use the effect of a Supporter card you find there as the effect of this attack.",
      },
      {
        name: "Eerie Wave",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    flavorText:
      "The broadness of its hands may be no coincidence—many scientists believe its palms became enlarged specifically for pantomiming.",
    nationalPokedexNumbers: [122],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/63.png",
      large: "https://images.pokemontcg.io/sv5/63_hires.png",
    },
    altArts: [
      {
        id: "sv5-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv5/63.png",
          large: "https://images.pokemontcg.io/sv5/63_hires.png",
        },
        flavorText:
          "The broadness of its hands may be no coincidence—many scientists believe its palms became enlarged specifically for pantomiming.",
      },
    ],
  },
  {
    id: "sv9-58",
    name: "Mr. Mime",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Mimic",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Shuffle your hand into your deck. Then, draw a card for each card in your opponent's hand.",
      },
      {
        name: "Psy Bolt",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    nationalPokedexNumbers: [122],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/58.png",
      large: "https://images.pokemontcg.io/sv9/58_hires.png",
    },
    altArts: [
      {
        id: "sv9-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv9/58.png",
          large: "https://images.pokemontcg.io/sv9/58_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-107",
    name: "Mudbray",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    evolvesTo: ["Mudsdale"],
    attacks: [
      {
        name: "Running Charge",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "Flip a coin until you get tails. This attack does 40 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "107",
    nationalPokedexNumbers: [749],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/107.png",
      large: "https://images.pokemontcg.io/sv10/107_hires.png",
    },
    altArts: [
      {
        id: "sv10-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/sv10/107.png",
          large: "https://images.pokemontcg.io/sv10/107_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-91",
    name: "Mudbray",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Mudsdale"],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Mud-Slap",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "91",
    flavorText:
      "This Pokémon covers itself in mud that it has regurgitated. The mud won't dry out even if it's exposed to the sun for a long time.",
    nationalPokedexNumbers: [749],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/91.png",
      large: "https://images.pokemontcg.io/sv5/91_hires.png",
    },
    altArts: [
      {
        id: "sv5-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv5/91.png",
          large: "https://images.pokemontcg.io/sv5/91_hires.png",
        },
        flavorText:
          "This Pokémon covers itself in mud that it has regurgitated. The mud won't dry out even if it's exposed to the sun for a long time.",
      },
    ],
  },
  {
    id: "sv10-108",
    name: "Mudsdale",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Mudbray",
    abilities: [
      {
        name: "Mud Coat",
        text: "This Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Heavy Impact",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "108",
    nationalPokedexNumbers: [750],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/108.png",
      large: "https://images.pokemontcg.io/sv10/108_hires.png",
    },
    altArts: [
      {
        id: "sv10-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/sv10/108.png",
          large: "https://images.pokemontcg.io/sv10/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-92",
    name: "Mudsdale",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Fighting"],
    evolvesFrom: "Mudbray",
    attacks: [
      {
        name: "Mud Stock",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach a Basic Fighting Energy card from your discard pile to each of your Benched Pokémon.",
      },
      {
        name: "High Horsepower",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "This Pokémon also does 40 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "92",
    flavorText:
      "This Pokémon has been treasured not just for its physical labor but also because it produces high-quality mud used for making pottery.",
    nationalPokedexNumbers: [750],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/92.png",
      large: "https://images.pokemontcg.io/sv5/92_hires.png",
    },
    altArts: [
      {
        id: "sv5-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv5/92.png",
          large: "https://images.pokemontcg.io/sv5/92_hires.png",
        },
        flavorText:
          "This Pokémon has been treasured not just for its physical labor but also because it produces high-quality mud used for making pottery.",
      },
      {
        id: "sv5-175",
        number: "175",
        images: {
          small: "https://images.pokemontcg.io/sv5/175.png",
          large: "https://images.pokemontcg.io/sv5/175_hires.png",
        },
        flavorText:
          "This Pokémon has been treasured not just for its physical labor but also because it produces high-quality mud used for making pottery.",
      },
    ],
  },
  {
    id: "me2pt5-99",
    name: "Munkidori",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    abilities: [
      {
        name: "Adrena-Brain",
        text: "Once during your turn, if this Pokémon has any Darkness Energy attached, you may move up to 3 damage counters from 1 of your Pokémon to 1 of your opponent's Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mind Bend",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "99",
    flavorText:
      "Munkidori keeps itself somewhere safe while it toys with its foes, using psychokinesis to induce intense dizziness.",
    nationalPokedexNumbers: [1015],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-99/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-99/large",
    },
    altArts: [
      {
        id: "me2pt5-99",
        number: "99",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-99/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-99/large",
        },
        flavorText:
          "Munkidori keeps itself somewhere safe while it toys with its foes, using psychokinesis to induce intense dizziness.",
      },
      {
        id: "sv6-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv6/95.png",
          large: "https://images.pokemontcg.io/sv6/95_hires.png",
        },
        flavorText:
          "Munkidori keeps itself somewhere safe while it toys with its foes, using psychokinesis to induce intense dizziness.",
      },
      {
        id: "sv6pt5-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/72.png",
          large: "https://images.pokemontcg.io/sv6pt5/72_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/44.png",
          large: "https://images.pokemontcg.io/sv8pt5/44_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-37",
    name: "Munkidori ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Darkness"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Oh No You Don't",
        text: "If this Pokémon is Knocked Out by damage from an attack from your opponent's Pokémon, and if you have any Pecharunt ex in play, your opponent takes 1 fewer Prize card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dirty Headbutt",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "190",
        text: "During your next turn, this Pokémon can't use Dirty Headbutt.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    nationalPokedexNumbers: [1015],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/37.png",
      large: "https://images.pokemontcg.io/sv6pt5/37_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/37.png",
          large: "https://images.pokemontcg.io/sv6pt5/37_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/83.png",
          large: "https://images.pokemontcg.io/sv6pt5/83_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/91.png",
          large: "https://images.pokemontcg.io/sv6pt5/91_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-35",
    name: "Munna",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Musharna"],
    attacks: [
      {
        name: "Rest",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This Pokémon is now Asleep. Heal 30 damage from it.",
      },
      {
        name: "Mumble",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    flavorText:
      "Munna always float in the air. People whose dreams are eaten by them forget what the dreams had been about.",
    nationalPokedexNumbers: [517],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/35.png",
      large: "https://images.pokemontcg.io/zsv10pt5/35_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/35.png",
          large: "https://images.pokemontcg.io/zsv10pt5/35_hires.png",
        },
        flavorText:
          "Munna always float in the air. People whose dreams are eaten by them forget what the dreams had been about.",
      },
      {
        id: "zsv10pt5-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/116.png",
          large: "https://images.pokemontcg.io/zsv10pt5/116_hires.png",
        },
        flavorText:
          "Munna always float in the air. People whose dreams are eaten by them forget what the dreams had been about.",
      },
    ],
  },
  {
    id: "me2-57",
    name: "Murkrow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Honchkrow"],
    attacks: [
      {
        name: "Ambush",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    flavorText:
      "Feared and loathed by many, it is believed to bring misfortune to all those who see it at night.",
    nationalPokedexNumbers: [198],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/57.png",
      large: "https://images.pokemontcg.io/me2/57_hires.png",
    },
    altArts: [
      {
        id: "me2-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/me2/57.png",
          large: "https://images.pokemontcg.io/me2/57_hires.png",
        },
        flavorText:
          "Feared and loathed by many, it is believed to bring misfortune to all those who see it at night.",
      },
    ],
  },
  {
    id: "me55-93",
    name: "Murkrow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    attacks: [
      {
        name: "Clumsily Clutch",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If heads, during your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "93",
    nationalPokedexNumbers: [198],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-93/small",
      large: "https://images.scrydex.com/pokemon/me55-93/large",
    },
    altArts: [
      {
        id: "me55-93",
        number: "93",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-93/small",
          large: "https://images.scrydex.com/pokemon/me55-93/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-36",
    name: "Musharna",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Munna",
    attacks: [
      {
        name: "Dream Calling",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "You may search your deck for any number of Fennel cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Sleep Pulse",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "36",
    flavorText:
      "The mist emanating from their foreheads is packed with the dreams of people and Pokémon.",
    nationalPokedexNumbers: [518],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/36.png",
      large: "https://images.pokemontcg.io/zsv10pt5/36_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/36.png",
          large: "https://images.pokemontcg.io/zsv10pt5/36_hires.png",
        },
        flavorText:
          "The mist emanating from their foreheads is packed with the dreams of people and Pokémon.",
      },
      {
        id: "zsv10pt5-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/117.png",
          large: "https://images.pokemontcg.io/zsv10pt5/117_hires.png",
        },
        flavorText:
          "The mist emanating from their foreheads is packed with the dreams of people and Pokémon.",
      },
    ],
  },
  {
    id: "me2pt5-33",
    name: "N's Darmanitan",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "N's Darumaka",
    attacks: [
      {
        name: "Back Draft",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each Basic Energy card in your opponent's discard pile.",
      },
      {
        name: "Flamebody Cannon",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Discard all Energy from this Pokémon, and this attack also does 90 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "33",
    flavorText:
      "This Pokémon’s power level rises along with the temperature of its fire, which can reach 2,500 degrees Fahrenheit.",
    nationalPokedexNumbers: [555],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-33/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-33/large",
    },
    altArts: [
      {
        id: "me2pt5-33",
        number: "33",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-33/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-33/large",
        },
        flavorText:
          "This Pokémon’s power level rises along with the temperature of its fire, which can reach 2,500 degrees Fahrenheit.",
      },
      {
        id: "sv9-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv9/27.png",
          large: "https://images.pokemontcg.io/sv9/27_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-32",
    name: "N's Darumaka",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
      {
        name: "Flare",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "32",
    flavorText:
      "This popular symbol of good fortune will never fall over in its sleep, no matter how it’s pushed or pulled.",
    nationalPokedexNumbers: [554],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-32/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-32/large",
    },
    altArts: [
      {
        id: "me2pt5-32",
        number: "32",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-32/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-32/large",
        },
        flavorText:
          "This popular symbol of good fortune will never fall over in its sleep, no matter how it’s pushed or pulled.",
      },
      {
        id: "sv9-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv9/26.png",
          large: "https://images.pokemontcg.io/sv9/26_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-49",
    name: "N's Joltik",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Lightning"],
    evolvesTo: ["Galvantula"],
    attacks: [
      {
        name: "Zapping Short",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon. If you discarded a Pokémon Tool in this way, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    nationalPokedexNumbers: [595],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/49.png",
      large: "https://images.pokemontcg.io/sv9/49_hires.png",
    },
    altArts: [
      {
        id: "sv9-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/sv9/49.png",
          large: "https://images.pokemontcg.io/sv9/49_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-104",
    name: "N's Klang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Metal"],
    evolvesFrom: "N's Klink",
    evolvesTo: ["Klinklang"],
    attacks: [
      {
        name: "Spinning Gears",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Confront",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "104",
    nationalPokedexNumbers: [600],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/104.png",
      large: "https://images.pokemontcg.io/sv9/104_hires.png",
    },
    altArts: [
      {
        id: "sv9-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/sv9/104.png",
          large: "https://images.pokemontcg.io/sv9/104_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-103",
    name: "N's Klink",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Metal"],
    evolvesTo: ["Klang"],
    attacks: [
      {
        name: "Double Spin",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "103",
    nationalPokedexNumbers: [599],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/103.png",
      large: "https://images.pokemontcg.io/sv9/103_hires.png",
    },
    altArts: [
      {
        id: "sv9-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/sv9/103.png",
          large: "https://images.pokemontcg.io/sv9/103_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-105",
    name: "N's Klinklang",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Metal"],
    evolvesFrom: "N's Klang",
    attacks: [
      {
        name: "Magnetic Blast",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
      {
        name: "Triple Smash",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120×",
        text: "Flip 3 coins. This attack does 120 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "105",
    nationalPokedexNumbers: [601],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/105.png",
      large: "https://images.pokemontcg.io/sv9/105_hires.png",
    },
    altArts: [
      {
        id: "sv9-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/sv9/105.png",
          large: "https://images.pokemontcg.io/sv9/105_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-96",
    name: "N's Purrloin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Liepard"],
    attacks: [
      {
        name: "Thieving Swipe",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Your opponent reveals their hand, and you choose a card you find there and put it on the bottom of their deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "96",
    nationalPokedexNumbers: [509],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/96.png",
      large: "https://images.pokemontcg.io/sv9/96_hires.png",
    },
    altArts: [
      {
        id: "sv9-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/sv9/96.png",
          large: "https://images.pokemontcg.io/sv9/96_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-154",
    name: "N's Reshiram",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Dragon"],
    attacks: [
      {
        name: "Powerful Rage",
        cost: ["Fire", "Lightning"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "This attack does 20 damage for each damage counter on this Pokémon.",
      },
      {
        name: "Virtuous Flame",
        cost: ["Fire", "Fire", "Lightning", "Colorless"],
        convertedEnergyCost: 4,
        damage: "170",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "154",
    flavorText:
      "According to myth, if people ignore truth and let themselves become consumed by greed, Reshiram will arrive to burn their kingdoms down.",
    nationalPokedexNumbers: [643],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-154/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-154/large",
    },
    altArts: [
      {
        id: "me2pt5-154",
        number: "154",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-154/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-154/large",
        },
        flavorText:
          "According to myth, if people ignore truth and let themselves become consumed by greed, Reshiram will arrive to burn their kingdoms down.",
      },
      {
        id: "sv9-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/sv9/116.png",
          large: "https://images.pokemontcg.io/sv9/116_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/sv9/167.png",
          large: "https://images.pokemontcg.io/sv9/167_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-64",
    name: "N's Sigilyph",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Psychic Sphere",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Victory Symbol",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "If you use this attack when you have exactly 1 Prize card remaining, you win this game.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    nationalPokedexNumbers: [561],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/64.png",
      large: "https://images.pokemontcg.io/sv9/64_hires.png",
    },
    altArts: [
      {
        id: "sv9-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv9/64.png",
          large: "https://images.pokemontcg.io/sv9/64_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-50",
    name: "N's Vanillish",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "N's Vanillite",
    attacks: [
      {
        name: "Flop",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Sheer Cold",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "During your opponent's next turn, the Defending Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    flavorText:
      "They cool down the surrounding air and create ice particles, which they use to freeze their foes.",
    nationalPokedexNumbers: [583],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-50/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-50/large",
    },
    altArts: [
      {
        id: "me2pt5-50",
        number: "50",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-50/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-50/large",
        },
        flavorText:
          "They cool down the surrounding air and create ice particles, which they use to freeze their foes.",
      },
    ],
  },
  {
    id: "me2pt5-49",
    name: "N's Vanillite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Icy Snow",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    flavorText:
      "The temperature of their breath is -58 degrees Fahrenheit. They create snow crystals and make snow fall in the areas around them.",
    nationalPokedexNumbers: [582],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-49/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-49/large",
    },
    altArts: [
      {
        id: "me2pt5-49",
        number: "49",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-49/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-49/large",
        },
        flavorText:
          "The temperature of their breath is -58 degrees Fahrenheit. They create snow crystals and make snow fall in the areas around them.",
      },
    ],
  },
  {
    id: "me2pt5-51",
    name: "N's Vanilluxe",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "N's Vanillish",
    attacks: [
      {
        name: "Snow Coating",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Double the number of damage counters on each of your opponent's Pokémon.",
      },
      {
        name: "Blizzard",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "This attack also does 10 damage to each of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "51",
    nationalPokedexNumbers: [584],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-51/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-51/large",
    },
    altArts: [
      {
        id: "me2pt5-51",
        number: "51",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-51/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-51/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-155",
    name: "N's Zekrom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Dragon"],
    attacks: [
      {
        name: "Shred",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
      {
        name: "Rampaging Thunder",
        cost: ["Fire", "Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 4,
        damage: "250",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "155",
    flavorText:
      "When the interior part of its tail spins like a motor, Zekrom can generate many bolts of lightning to blast its surroundings.",
    nationalPokedexNumbers: [644],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-155/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-155/large",
    },
    altArts: [
      {
        id: "me2pt5-155",
        number: "155",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-155/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-155/large",
        },
        flavorText:
          "When the interior part of its tail spins like a motor, Zekrom can generate many bolts of lightning to blast its surroundings.",
      },
    ],
  },
  {
    id: "me2pt5-137",
    name: "N's Zoroark ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "280",
    types: ["Darkness"],
    evolvesFrom: "N's Zorua",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Trade",
        text: "You must discard a card from your hand in order to use this Ability. Once during your turn, you may draw 2 cards.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Night Joker",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Choose 1 of your Benched N's Pokémon's attacks and use it as this attack.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "137",
    nationalPokedexNumbers: [571],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-137/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-137/large",
    },
    altArts: [
      {
        id: "me2pt5-137",
        number: "137",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-137/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-137/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-286",
        number: "286",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-286/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-286/large",
        },
        flavorText: "",
      },
      {
        id: "sv9-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv9/98.png",
          large: "https://images.pokemontcg.io/sv9/98_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-175",
        number: "175",
        images: {
          small: "https://images.pokemontcg.io/sv9/175.png",
          large: "https://images.pokemontcg.io/sv9/175_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-185",
        number: "185",
        images: {
          small: "https://images.pokemontcg.io/sv9/185.png",
          large: "https://images.pokemontcg.io/sv9/185_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-189",
        number: "189",
        images: {
          small: "https://images.pokemontcg.io/sv9/189.png",
          large: "https://images.pokemontcg.io/sv9/189_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-136",
    name: "N's Zorua",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "136",
    flavorText:
      "It changes into the forms of others to surprise them. Apparently, it often transforms into a silent child.",
    nationalPokedexNumbers: [570],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-136/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-136/large",
    },
    altArts: [
      {
        id: "me2pt5-136",
        number: "136",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-136/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-136/large",
        },
        flavorText:
          "It changes into the forms of others to surprise them. Apparently, it often transforms into a silent child.",
      },
      {
        id: "sv9-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv9/97.png",
          large: "https://images.pokemontcg.io/sv9/97_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-82",
    name: "Nacli",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "82",
    nationalPokedexNumbers: [932],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/82.png",
      large: "https://images.pokemontcg.io/me1/82_hires.png",
    },
    altArts: [
      {
        id: "me1-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/me1/82.png",
          large: "https://images.pokemontcg.io/me1/82_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-83",
    name: "Naclstack",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Nacli",
    attacks: [
      {
        name: "Rock Hurl",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "83",
    nationalPokedexNumbers: [933],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/83.png",
      large: "https://images.pokemontcg.io/me1/83_hires.png",
    },
    altArts: [
      {
        id: "me1-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/me1/83.png",
          large: "https://images.pokemontcg.io/me1/83_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-89",
    name: "Nickit",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Thievul"],
    attacks: [
      {
        name: "Darkness Fang",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "89",
    nationalPokedexNumbers: [827],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/89.png",
      large: "https://images.pokemontcg.io/me1/89_hires.png",
    },
    altArts: [
      {
        id: "me1-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/me1/89.png",
          large: "https://images.pokemontcg.io/me1/89_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-53",
    name: "Nickit",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Rear Kick",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "53",
    flavorText:
      "Aided by the soft pads on its feet, it silently raids the food stores of other Pokemon. It survives off its ill-gotten gains.",
    nationalPokedexNumbers: [827],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-53/small",
      large: "https://images.scrydex.com/pokemon/me5-53/large",
    },
    altArts: [
      {
        id: "me5-53",
        number: "53",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-53/small",
          large: "https://images.scrydex.com/pokemon/me5-53/large",
        },
        flavorText:
          "Aided by the soft pads on its feet, it silently raids the food stores of other Pokemon. It survives off its ill-gotten gains.",
      },
    ],
  },
  {
    id: "me55-87",
    name: "Nidoran ♀",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    attacks: [
      {
        name: "Growl",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 30 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Headbutt",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "87",
    nationalPokedexNumbers: [29],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-87/small",
      large: "https://images.scrydex.com/pokemon/me55-87/large",
    },
    altArts: [
      {
        id: "me55-87",
        number: "87",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-87/small",
          large: "https://images.scrydex.com/pokemon/me55-87/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-88",
    name: "Nidorina",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Darkness"],
    evolvesFrom: "Nidoran ♀",
    abilities: [
      {
        name: "Share Happiness",
        text: "Once during your turn, you may use this Ability. Heal 30 damage from 1 of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "88",
    nationalPokedexNumbers: [30],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-88/small",
      large: "https://images.scrydex.com/pokemon/me55-88/large",
    },
    altArts: [
      {
        id: "me55-88",
        number: "88",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-88/small",
          large: "https://images.scrydex.com/pokemon/me55-88/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-16",
    name: "Nincada",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Ninjask"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    nationalPokedexNumbers: [290],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/16.png",
      large: "https://images.pokemontcg.io/me1/16_hires.png",
    },
    altArts: [
      {
        id: "me1-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/me1/16.png",
          large: "https://images.pokemontcg.io/me1/16_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-20",
    name: "Ninetales",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Vulpix",
    attacks: [
      {
        name: "Supernatural Shapeshifter",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard the top card of your deck, and if that card is a Supporter card, use the effect of that card as the effect of this attack.",
      },
      {
        name: "Combustion",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "20",
    nationalPokedexNumbers: [38],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/20.png",
      large: "https://images.pokemontcg.io/me1/20_hires.png",
    },
    altArts: [
      {
        id: "me1-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/me1/20.png",
          large: "https://images.pokemontcg.io/me1/20_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-9",
    name: "Ninetales",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Vulpix",
    attacks: [
      {
        name: "Nine-Tailed Transfer",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Move all damage counters from 1 of your Benched Pokémon to your opponent's Active Pokémon.",
      },
      {
        name: "Will-O-Wisp",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    flavorText:
      "It has nine long tails and fur that gleams gold. It is said to live for 1,000 years.",
    nationalPokedexNumbers: [38],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-9/small",
      large: "https://images.scrydex.com/pokemon/me4-9/large",
    },
    altArts: [
      {
        id: "me4-9",
        number: "9",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-9/small",
          large: "https://images.scrydex.com/pokemon/me4-9/large",
        },
        flavorText:
          "It has nine long tails and fur that gleams gold. It is said to live for 1,000 years.",
      },
    ],
  },
  {
    id: "me55-10",
    name: "Ninetales",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fire"],
    evolvesFrom: "Vulpix",
    attacks: [
      {
        name: "Flame Tail",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "60",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    nationalPokedexNumbers: [38],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-10/small",
      large: "https://images.scrydex.com/pokemon/me55-10/large",
    },
    altArts: [
      {
        id: "me55-10",
        number: "10",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-10/small",
          large: "https://images.scrydex.com/pokemon/me55-10/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-27",
    name: "Ninetales",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Vulpix",
    attacks: [
      {
        name: "Eerie Glow",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "Your opponent's Active Pokémon is now Burned and Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "27",
    flavorText:
      "It has nine long tails and fur that gleams gold. It is said to live for 1,000 years.",
    nationalPokedexNumbers: [38],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/27.png",
      large: "https://images.pokemontcg.io/sv6/27_hires.png",
    },
    altArts: [
      {
        id: "sv6-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv6/27.png",
          large: "https://images.pokemontcg.io/sv6/27_hires.png",
        },
        flavorText:
          "It has nine long tails and fur that gleams gold. It is said to live for 1,000 years.",
      },
    ],
  },
  {
    id: "sv8-17",
    name: "Ninetales",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Vulpix",
    attacks: [
      {
        name: "Fire Soul",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "17",
    nationalPokedexNumbers: [38],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/17.png",
      large: "https://images.pokemontcg.io/sv8/17_hires.png",
    },
    altArts: [
      {
        id: "sv8-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv8/17.png",
          large: "https://images.pokemontcg.io/sv8/17_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-17",
    name: "Ninjask",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Grass"],
    evolvesFrom: "Nincada",
    evolvesTo: ["Shedinja"],
    abilities: [
      {
        name: "Cast-Off Shell",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Search your deck for a Shedinja and put it onto your Bench. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "U-turn",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "17",
    nationalPokedexNumbers: [291],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/17.png",
      large: "https://images.pokemontcg.io/me1/17_hires.png",
    },
    altArts: [
      {
        id: "me1-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/me1/17.png",
          large: "https://images.pokemontcg.io/me1/17_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/me1/137.png",
          large: "https://images.pokemontcg.io/me1/137_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-127",
    name: "Noctowl",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Hoothoot",
    attacks: [
      {
        name: "Talon Hunt",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "You may search your deck for up to 2 cards and put them into your hand. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "127",
    flavorText:
      "Its eyes are specially developed to enable it to see clearly even in murky darkness and minimal light.",
    nationalPokedexNumbers: [164],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/127.png",
      large: "https://images.pokemontcg.io/sv5/127_hires.png",
    },
    altArts: [
      {
        id: "sv5-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/sv5/127.png",
          large: "https://images.pokemontcg.io/sv5/127_hires.png",
        },
        flavorText:
          "Its eyes are specially developed to enable it to see clearly even in murky darkness and minimal light.",
      },
    ],
  },
  {
    id: "sv7-115",
    name: "Noctowl",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Hoothoot",
    abilities: [
      {
        name: "Jewel Seeker",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, if you have any Tera Pokémon in play, you may search your deck for up to 2 Trainer cards, reveal them, and put them into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Speed Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "115",
    nationalPokedexNumbers: [164],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/115.png",
      large: "https://images.pokemontcg.io/sv7/115_hires.png",
    },
    altArts: [
      {
        id: "sv7-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/sv7/115.png",
          large: "https://images.pokemontcg.io/sv7/115_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/78.png",
          large: "https://images.pokemontcg.io/sv8pt5/78_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/svp/141.png",
          large: "https://images.pokemontcg.io/svp/141_hires.png",
        },
        flavorText:
          "Its extremely soft wings make no sound in flight. It silently sneaks up on prey without being detected.",
      },
    ],
  },
  {
    id: "me2pt5-156",
    name: "Noibat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Dragon"],
    attacks: [
      {
        name: "Knickknack Carrying",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Pokémon Tool card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Bite",
        cost: ["Psychic", "Darkness"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "156",
    flavorText:
      "Even a robust wrestler will become dizzy and unable to stand when exposed to its 200,000-hertz ultrasonic waves.",
    nationalPokedexNumbers: [714],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-156/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-156/large",
    },
    altArts: [
      {
        id: "me2pt5-156",
        number: "156",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-156/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-156/large",
        },
        flavorText:
          "Even a robust wrestler will become dizzy and unable to stand when exposed to its 200,000-hertz ultrasonic waves.",
      },
    ],
  },
  {
    id: "sv8pt5-90",
    name: "Noibat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Noivern"],
    attacks: [
      {
        name: "Flap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "90",
    nationalPokedexNumbers: [714],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/90.png",
      large: "https://images.pokemontcg.io/sv8pt5/90_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/90.png",
          large: "https://images.pokemontcg.io/sv8pt5/90_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-127",
    name: "Noibat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Noivern"],
    attacks: [
      {
        name: "Rapid Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Draw a card.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "127",
    nationalPokedexNumbers: [714],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/127.png",
      large: "https://images.pokemontcg.io/sv9/127_hires.png",
    },
    altArts: [
      {
        id: "sv9-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/sv9/127.png",
          large: "https://images.pokemontcg.io/sv9/127_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/sv9/169.png",
          large: "https://images.pokemontcg.io/sv9/169_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-157",
    name: "Noivern",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Dragon"],
    evolvesFrom: "Noibat",
    attacks: [
      {
        name: "Agility",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
      {
        name: "Enhanced Blade",
        cost: ["Psychic", "Darkness"],
        convertedEnergyCost: 2,
        damage: "70+",
        text: "If this Pokémon has a Pokémon Tool attached, this attack does 70 more damage.",
      },
    ],
    number: "157",
    flavorText:
      "They fly around on moonless nights and attack careless prey. Nothing can beat them in a battle in the dark.",
    nationalPokedexNumbers: [715],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-157/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-157/large",
    },
    altArts: [
      {
        id: "me2pt5-157",
        number: "157",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-157/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-157/large",
        },
        flavorText:
          "They fly around on moonless nights and attack careless prey. Nothing can beat them in a battle in the dark.",
      },
    ],
  },
  {
    id: "sv9-128",
    name: "Noivern",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Noibat",
    abilities: [
      {
        name: "Tuning Echo",
        text: "If you have the same number of cards in your hand as your opponent, ignore all Energy in the cost of Frightening Howl used by this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Frightening Howl",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "128",
    nationalPokedexNumbers: [715],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/128.png",
      large: "https://images.pokemontcg.io/sv9/128_hires.png",
    },
    altArts: [
      {
        id: "sv9-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/sv9/128.png",
          large: "https://images.pokemontcg.io/sv9/128_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-91",
    name: "Noivern ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Colorless"],
    evolvesFrom: "Noibat",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Strafe",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "You may switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Sonic Blast",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "220",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "91",
    nationalPokedexNumbers: [715],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/91.png",
      large: "https://images.pokemontcg.io/sv8pt5/91_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/91.png",
          large: "https://images.pokemontcg.io/sv8pt5/91_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-37",
    name: "Nosepass",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fighting"],
    attacks: [
      {
        name: "Rolling Rocks",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "37",
    nationalPokedexNumbers: [299],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-37/small",
      large: "https://images.scrydex.com/pokemon/me3-37/large",
    },
    altArts: [
      {
        id: "me3-37",
        number: "37",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-37/small",
          large: "https://images.scrydex.com/pokemon/me3-37/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-97",
    name: "Nosepass",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Probopass"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Rock Throw",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "97",
    nationalPokedexNumbers: [299],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/97.png",
      large: "https://images.pokemontcg.io/sv10/97_hires.png",
    },
    altArts: [
      {
        id: "sv10-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv10/97.png",
          large: "https://images.pokemontcg.io/sv10/97_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-101",
    name: "Nosepass",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Probopass"],
    attacks: [
      {
        name: "Power Rush",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "Flip a coin. If tails, during your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "101",
    flavorText:
      "When endangered, it may protect itself by increasing its magnetism and drawing nearby iron objects to its body.",
    nationalPokedexNumbers: [299],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/101.png",
      large: "https://images.pokemontcg.io/sv6/101_hires.png",
    },
    altArts: [
      {
        id: "sv6-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/sv6/101.png",
          large: "https://images.pokemontcg.io/sv6/101_hires.png",
        },
        flavorText:
          "When endangered, it may protect itself by increasing its magnetism and drawing nearby iron objects to its body.",
      },
    ],
  },
  {
    id: "me1-21",
    name: "Numel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Camerupt"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Flare",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "21",
    nationalPokedexNumbers: [322],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/21.png",
      large: "https://images.pokemontcg.io/me1/21_hires.png",
    },
    altArts: [
      {
        id: "me1-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/me1/21.png",
          large: "https://images.pokemontcg.io/me1/21_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-27",
    name: "Numel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    abilities: [
      {
        name: "Incandescent Body",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), the Attacking Pokémon is now Burned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Combustion",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "27",
    flavorText:
      "The magma in its body reaches 2,200 degrees Fahrenheit. Its hump gets smaller when it uses Fire-type moves.",
    nationalPokedexNumbers: [322],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-27/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-27/large",
    },
    altArts: [
      {
        id: "me2pt5-27",
        number: "27",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-27/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-27/large",
        },
        flavorText:
          "The magma in its body reaches 2,200 degrees Fahrenheit. Its hump gets smaller when it uses Fire-type moves.",
      },
      {
        id: "me2pt5-223",
        number: "223",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-223/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-223/large",
        },
        flavorText:
          "The magma in its body reaches 2,200 degrees Fahrenheit. Its hump gets smaller when it uses Fire-type moves.",
      },
    ],
  },
  {
    id: "me1-14",
    name: "Nuzleaf",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Seedot",
    evolvesTo: ["Shiftry"],
    attacks: [
      {
        name: "Pound",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Low Kick",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "14",
    nationalPokedexNumbers: [274],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/14.png",
      large: "https://images.pokemontcg.io/me1/14_hires.png",
    },
    altArts: [
      {
        id: "me1-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/me1/14.png",
          large: "https://images.pokemontcg.io/me1/14_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-4",
    name: "Nuzleaf",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Seedot",
    evolvesTo: ["Shiftry"],
    attacks: [
      {
        name: "Corkscrew Punch",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Comet Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "Flip 3 coins. This attack does 30 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    flavorText:
      "It lives deep in forests. With the leaf on its head, it makes a flute whose song makes listeners uneasy.",
    nationalPokedexNumbers: [274],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/4.png",
      large: "https://images.pokemontcg.io/sv5/4_hires.png",
    },
    altArts: [
      {
        id: "sv5-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv5/4.png",
          large: "https://images.pokemontcg.io/sv5/4_hires.png",
        },
        flavorText:
          "It lives deep in forests. With the leaf on its head, it makes a flute whose song makes listeners uneasy.",
      },
    ],
  },
  {
    id: "me2-9",
    name: "Nymble",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    attacks: [
      {
        name: "Flail Around",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 3 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    flavorText:
      "It has its third set of legs folded up. When it's in a tough spot, this Pokémon jumps over 30 feet using the strength of its legs.",
    nationalPokedexNumbers: [919],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/9.png",
      large: "https://images.pokemontcg.io/me2/9_hires.png",
    },
    altArts: [
      {
        id: "me2-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/me2/9.png",
          large: "https://images.pokemontcg.io/me2/9_hires.png",
        },
        flavorText:
          "It has its third set of legs folded up. When it's in a tough spot, this Pokémon jumps over 30 feet using the strength of its legs.",
      },
      {
        id: "me2-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/me2/96.png",
          large: "https://images.pokemontcg.io/me2/96_hires.png",
        },
        flavorText:
          "It has its third set of legs folded up. When it's in a tough spot, this Pokémon jumps over 30 feet using the strength of its legs.",
      },
    ],
  },
  {
    id: "sv7-15",
    name: "Nymble",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    nationalPokedexNumbers: [919],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/15.png",
      large: "https://images.pokemontcg.io/sv7/15_hires.png",
    },
    altArts: [
      {
        id: "sv7-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv7/15.png",
          large: "https://images.pokemontcg.io/sv7/15_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-19",
    name: "Nymble",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "19",
    nationalPokedexNumbers: [919],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/19.png",
      large: "https://images.pokemontcg.io/sv9/19_hires.png",
    },
    altArts: [
      {
        id: "sv9-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv9/19.png",
          large: "https://images.pokemontcg.io/sv9/19_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-17",
    name: "Octillery",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Remoraid",
    attacks: [
      {
        name: "Jet of Ink",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your opponent's next turn, if the Defending Pokémon tries to use an attack, your opponent flips 2 coins. If either of them is tails, that attack doesn't happen.",
      },
      {
        name: "Tantrum",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "This Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "17",
    flavorText:
      "Its instinct is to bury itself in holes. It often steals the nesting holes of others to sleep in them.",
    nationalPokedexNumbers: [224],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-17/small",
      large: "https://images.scrydex.com/pokemon/me4-17/large",
    },
    altArts: [
      {
        id: "me4-17",
        number: "17",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-17/small",
          large: "https://images.scrydex.com/pokemon/me4-17/large",
        },
        flavorText:
          "Its instinct is to bury itself in holes. It often steals the nesting holes of others to sleep in them.",
      },
    ],
  },
  {
    id: "sv9-34",
    name: "Octillery",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Remoraid",
    attacks: [
      {
        name: "Aqua Wash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may put an Energy attached to your opponent's Active Pokémon into their hand.",
      },
      {
        name: "Octo Beatdown",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90×",
        text: "Flip a coin until you get tails. This attack does 90 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    nationalPokedexNumbers: [224],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/34.png",
      large: "https://images.pokemontcg.io/sv9/34_hires.png",
    },
    altArts: [
      {
        id: "sv9-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/sv9/34.png",
          large: "https://images.pokemontcg.io/sv9/34_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-1",
    name: "Oddish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Gloom"],
    attacks: [
      {
        name: "Seed Bomb",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    flavorText:
      "Its scientific name is Oddium wanderus. It is said to cover distances as far as 1,000 feet when night falls, walking on its two roots.",
    nationalPokedexNumbers: [43],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/1.png",
      large: "https://images.pokemontcg.io/me2/1_hires.png",
    },
    altArts: [
      {
        id: "me2-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/me2/1.png",
          large: "https://images.pokemontcg.io/me2/1_hires.png",
        },
        flavorText:
          "Its scientific name is Oddium wanderus. It is said to cover distances as far as 1,000 feet when night falls, walking on its two roots.",
      },
    ],
  },
  {
    id: "sv9-140",
    name: "Oinkologne",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Lechonk",
    attacks: [
      {
        name: "Aromatic Stomps",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, during your opponent's next turn, the Defending Pokémon can't attack.",
      },
      {
        name: "Headbutt Bounce",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "140",
    nationalPokedexNumbers: [916],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/140.png",
      large: "https://images.pokemontcg.io/sv9/140_hires.png",
    },
    altArts: [
      {
        id: "sv9-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/sv9/140.png",
          large: "https://images.pokemontcg.io/sv9/140_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-122",
    name: "Okidogi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Light Punch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Settle the Score",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "This attack does 60 more damage for each Prize card your opponent took during their last turn.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "122",
    flavorText:
      "Okidogi is a ruffian with a short temper. It can pulverize anything by swinging around the chain on its neck.",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-122/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-122/large",
    },
    altArts: [
      {
        id: "me2pt5-122",
        number: "122",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-122/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-122/large",
        },
        flavorText:
          "Okidogi is a ruffian with a short temper. It can pulverize anything by swinging around the chain on its neck.",
      },
    ],
  },
  {
    id: "sv6-111",
    name: "Okidogi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    abilities: [
      {
        name: "Adrena-Power",
        text: "If this Pokémon has any Darkness Energy attached, it gets +100 HP, and the attacks it uses do 100 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Good Punch",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "111",
    nationalPokedexNumbers: [1014],
    flavorText:
      "Okidogi is a ruffian with a short temper. It can pulverize anything by swinging around the chain on its neck.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/111.png",
      large: "https://images.pokemontcg.io/sv6/111_hires.png",
    },
    altArts: [
      {
        id: "sv6-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/sv6/111.png",
          large: "https://images.pokemontcg.io/sv6/111_hires.png",
        },
        flavorText:
          "Okidogi is a ruffian with a short temper. It can pulverize anything by swinging around the chain on its neck.",
      },
      {
        id: "sv6pt5-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/74.png",
          large: "https://images.pokemontcg.io/sv6pt5/74_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/57.png",
          large: "https://images.pokemontcg.io/sv8pt5/57_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-36",
    name: "Okidogi ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "250",
    types: ["Darkness"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Poisonous Musculature",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Darkness Energy cards and attach them to this Pokémon. Then, shuffle your deck. If you attached Energy to a Pokémon in this way, this Pokémon is now Poisoned.",
      },
      {
        name: "Chain-Crazed",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130+",
        text: "If this Pokémon is Poisoned, this attack does 130 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "36",
    nationalPokedexNumbers: [1014],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/36.png",
      large: "https://images.pokemontcg.io/sv6pt5/36_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/36.png",
          large: "https://images.pokemontcg.io/sv6pt5/36_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/82.png",
          large: "https://images.pokemontcg.io/sv6pt5/82_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/90.png",
          large: "https://images.pokemontcg.io/sv6pt5/90_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-70",
    name: "Onix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fighting"],
    evolvesTo: ["Steelix"],
    attacks: [
      {
        name: "Bind",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Strength",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "70",
    nationalPokedexNumbers: [95],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/70.png",
      large: "https://images.pokemontcg.io/me1/70_hires.png",
    },
    altArts: [
      {
        id: "me1-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/me1/70.png",
          large: "https://images.pokemontcg.io/me1/70_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-156",
    name: "Oranguru",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Now You're in My Power",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Until the end of your next turn, the Defending Pokémon's Weakness is now Colorless. (The amount of Weakness doesn't change.)",
      },
      {
        name: "Smack",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "156",
    nationalPokedexNumbers: [765],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/156.png",
      large: "https://images.pokemontcg.io/sv8/156_hires.png",
    },
    altArts: [
      {
        id: "sv8-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/sv8/156.png",
          large: "https://images.pokemontcg.io/sv8/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-26",
    name: "Oricorio",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Fire"],
    attacks: [
      {
        name: "Energy Assist",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 2 Basic Energy cards from your discard pile to 1 of your Benched Pokémon.",
      },
      {
        name: "Fireworks",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    nationalPokedexNumbers: [741],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/26.png",
      large: "https://images.pokemontcg.io/sv8/26_hires.png",
    },
    altArts: [
      {
        id: "sv8-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv8/26.png",
          large: "https://images.pokemontcg.io/sv8/26_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-89",
    name: "Oricorio",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Energy Assist",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 2 Basic Energy cards from your discard pile to 1 of your Benched Pokémon.",
      },
      {
        name: "Dazzle Dance",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "89",
    nationalPokedexNumbers: [741],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/89.png",
      large: "https://images.pokemontcg.io/sv8/89_hires.png",
    },
    altArts: [
      {
        id: "sv8-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/sv8/89.png",
          large: "https://images.pokemontcg.io/sv8/89_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-65",
    name: "Oricorio",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Spooky Shot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "65",
    nationalPokedexNumbers: [741],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/65.png",
      large: "https://images.pokemontcg.io/sv9/65_hires.png",
    },
    altArts: [
      {
        id: "sv9-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv9/65.png",
          large: "https://images.pokemontcg.io/sv9/65_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-18",
    name: "Oricorio ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Fire"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Excited Turbo",
        text: "As often as you like during your turn, if you have any Fire Mega Evolution Pokémon ex in play, you may use this Ability. Attach a Basic Fire Energy card from your hand to 1 of your Benched Fire Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Fire Wing",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    nationalPokedexNumbers: [741],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/18.png",
      large: "https://images.pokemontcg.io/me2/18_hires.png",
    },
    altArts: [
      {
        id: "me2-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/me2/18.png",
          large: "https://images.pokemontcg.io/me2/18_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/me2/110.png",
          large: "https://images.pokemontcg.io/me2/110_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-110",
    name: "Orthworm ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "220",
    types: ["Metal"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Pummeling Payback",
        text: "If this Pokémon is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), put 2 damage counters on the Attacking Pokémon for each Metal Energy attached to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rock Tomb",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "110",
    nationalPokedexNumbers: [968],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/110.png",
      large: "https://images.pokemontcg.io/sv7/110_hires.png",
    },
    altArts: [
      {
        id: "sv7-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/sv7/110.png",
          large: "https://images.pokemontcg.io/sv7/110_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/sv7/162.png",
          large: "https://images.pokemontcg.io/sv7/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-21",
    name: "Oshawott",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Dewott"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Water Gun",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    flavorText:
      "It fights using the scalchop on its stomach. In response to an attack, it retaliates immediately by slashing.",
    nationalPokedexNumbers: [501],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/21.png",
      large: "https://images.pokemontcg.io/rsv10pt5/21_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/21.png",
          large: "https://images.pokemontcg.io/rsv10pt5/21_hires.png",
        },
        flavorText:
          "It fights using the scalchop on its stomach. In response to an attack, it retaliates immediately by slashing.",
      },
      {
        id: "rsv10pt5-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/105.png",
          large: "https://images.pokemontcg.io/rsv10pt5/105_hires.png",
        },
        flavorText:
          "It fights using the scalchop on its stomach. In response to an attack, it retaliates immediately by slashing.",
      },
    ],
  },
  {
    id: "me1-51",
    name: "Pachirisu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Electrified Incisors",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, whenever they attach an Energy card from their hand to the Defending Pokémon, place 8 damage counters on that Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    nationalPokedexNumbers: [417],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/51.png",
      large: "https://images.pokemontcg.io/me1/51_hires.png",
    },
    altArts: [
      {
        id: "me1-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/me1/51.png",
          large: "https://images.pokemontcg.io/me1/51_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-158",
    name: "Pachirisu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Crackling Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip 3 coins. Attach a number of Basic Lightning Energy cards up to the number of heads from your discard pile to your Benched Pokémon in any way you like.",
      },
      {
        name: "Tiny Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "158",
    nationalPokedexNumbers: [417],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/158.png",
      large: "https://images.pokemontcg.io/svp/158_hires.png",
    },
    altArts: [
      {
        id: "svp-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/svp/158.png",
          large: "https://images.pokemontcg.io/svp/158_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-22",
    name: "Palafin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "Finizen",
    attacks: [
      {
        name: "Knuckle Justice",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "80+",
        text: "If your opponent has exactly 1 Prize card remaining, this attack does 200 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "22",
    flavorText:
      "This hero of the ocean swims at a speed of 50 knots and saves drowning people and Pokémon.",
    nationalPokedexNumbers: [964],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-22/small",
      large: "https://images.scrydex.com/pokemon/me5-22/large",
    },
    altArts: [
      {
        id: "me5-22",
        number: "22",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-22/small",
          large: "https://images.scrydex.com/pokemon/me5-22/large",
        },
        flavorText:
          "This hero of the ocean swims at a speed of 50 knots and saves drowning people and Pokémon.",
      },
    ],
  },
  {
    id: "sv5-49",
    name: "Palafin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "Finizen",
    attacks: [
      {
        name: "Vanguard Punch",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "130",
        text: "This Pokémon also does 10 damage to itself for each damage counter on it.",
      },
      {
        name: "Double Hit",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90×",
        text: "Flip 2 coins. This attack does 90 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "49",
    flavorText:
      "This Pokémon's ancient genes have awakened. It is now so extraordinarily strong that it can easily lift a cruise ship with one fin.",
    nationalPokedexNumbers: [964],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/49.png",
      large: "https://images.pokemontcg.io/sv5/49_hires.png",
    },
    altArts: [
      {
        id: "sv5-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/sv5/49.png",
          large: "https://images.pokemontcg.io/sv5/49_hires.png",
        },
        flavorText:
          "This Pokémon's ancient genes have awakened. It is now so extraordinarily strong that it can easily lift a cruise ship with one fin.",
      },
    ],
  },
  {
    id: "sv6-60",
    name: "Palafin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Finizen",
    abilities: [
      {
        name: "Zero to Hero",
        text: "Once during your turn, when this Pokémon moves from the Active Spot to the Bench, you may search your deck for a Palafin ex and switch it with this Pokémon. Any attached cards, damage counters, Special Conditions, turns in play, and any other effects remain on the new Pokémon. If you switched a Pokémon in this way, put this card into your deck. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Wave Splash",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "60",
    flavorText:
      "Its physical capabilities are no different than a Finizen's, but when its allies are in danger, it transforms and powers itself up.",
    nationalPokedexNumbers: [964],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/60.png",
      large: "https://images.pokemontcg.io/sv6/60_hires.png",
    },
    altArts: [
      {
        id: "sv6-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv6/60.png",
          large: "https://images.pokemontcg.io/sv6/60_hires.png",
        },
        flavorText:
          "Its physical capabilities are no different than a Finizen's, but when its allies are in danger, it transforms and powers itself up.",
      },
    ],
  },
  {
    id: "sv6-61",
    name: "Palafin ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "340",
    types: ["Water"],
    evolvesFrom: "Finizen",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Hero's Spirit",
        text: "Put this Pokémon into play only with the effect of Palafin's Zero to Hero Ability.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Giga Impact",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "250",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "61",
    nationalPokedexNumbers: [964],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/61.png",
      large: "https://images.pokemontcg.io/sv6/61_hires.png",
    },
    altArts: [
      {
        id: "sv6-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv6/61.png",
          large: "https://images.pokemontcg.io/sv6/61_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-193",
        number: "193",
        images: {
          small: "https://images.pokemontcg.io/sv6/193.png",
          large: "https://images.pokemontcg.io/sv6/193_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/151.png",
          large: "https://images.pokemontcg.io/sv8pt5/151_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/svp/126.png",
          large: "https://images.pokemontcg.io/svp/126_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-94",
    name: "Paldean Clodsire ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "280",
    types: ["Darkness"],
    evolvesFrom: "Paldean Wooper",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Poison Ring",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Your opponent's Active Pokémon is now Poisoned. During your opponent's next turn, that Pokémon can't retreat.",
      },
      {
        name: "Giga Impact",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "220",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "94",
    nationalPokedexNumbers: [980],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/94.png",
      large: "https://images.pokemontcg.io/sv9/94_hires.png",
    },
    altArts: [
      {
        id: "sv9-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv9/94.png",
          large: "https://images.pokemontcg.io/sv9/94_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-48",
    name: "Paldean Tauros",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Raging Charge",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40×",
        text: 'This attack does 40 damage for each of your Pokémon that has "Tauros" in its name that has any damage counters on it.',
      },
      {
        name: "Double-Edge",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "48",
    flavorText:
      "This Pokémon has a muscular body and excels at close-quarters combat. It uses its short horns to strike the opponent's weak spots.",
    nationalPokedexNumbers: [128],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/48.png",
      large: "https://images.pokemontcg.io/me2/48_hires.png",
    },
    altArts: [
      {
        id: "me2-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/me2/48.png",
          large: "https://images.pokemontcg.io/me2/48_hires.png",
        },
        flavorText:
          "This Pokémon has a muscular body and excels at close-quarters combat. It uses its short horns to strike the opponent's weak spots.",
      },
    ],
  },
  {
    id: "sv8-18",
    name: "Paldean Tauros",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Spirited Tackle",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90+",
        text: "If your opponent's Active Pokémon is a Stage 1 Pokémon, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "18",
    nationalPokedexNumbers: [128],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/18.png",
      large: "https://images.pokemontcg.io/sv8/18_hires.png",
    },
    altArts: [
      {
        id: "sv8-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv8/18.png",
          large: "https://images.pokemontcg.io/sv8/18_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-39",
    name: "Paldean Tauros",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Upthrusting Horns",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "You may put 2 Energy attached to your opponent's Active Stage 2 Pokémon into their hand.",
      },
      {
        name: "Jet Headbutt",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "39",
    nationalPokedexNumbers: [128],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/39.png",
      large: "https://images.pokemontcg.io/sv8/39_hires.png",
    },
    altArts: [
      {
        id: "sv8-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv8/39.png",
          large: "https://images.pokemontcg.io/sv8/39_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-101",
    name: "Paldean Tauros",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
      {
        name: "Blocking Stomp",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "If the Defending Pokémon is a Basic Pokémon, it can't attack during your opponent's next turn.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "101",
    nationalPokedexNumbers: [128],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/101.png",
      large: "https://images.pokemontcg.io/sv8/101_hires.png",
    },
    altArts: [
      {
        id: "sv8-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/sv8/101.png",
          large: "https://images.pokemontcg.io/sv8/101_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-102",
    name: "Paldean Wooper",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Quagsire"],
    attacks: [
      {
        name: "Trip Over",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "102",
    flavorText:
      "It's dangerous for Wooper to travel alone. They line up in groups of three or four and help each other as they walk around the wetlands.",
    nationalPokedexNumbers: [194],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/me2/102.png",
      large: "https://images.pokemontcg.io/me2/102_hires.png",
    },
    altArts: [
      {
        id: "me2-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/me2/102.png",
          large: "https://images.pokemontcg.io/me2/102_hires.png",
        },
        flavorText:
          "It's dangerous for Wooper to travel alone. They line up in groups of three or four and help each other as they walk around the wetlands.",
      },
      {
        id: "sv9-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv9/93.png",
          large: "https://images.pokemontcg.io/sv9/93_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-20",
    name: "Palkia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Wormhole",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Switch this Pokémon with 1 of your Benched Pokémon. If you do, switch out your oppoennt's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "20",
    nationalPokedexNumbers: [484],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-20/small",
      large: "https://images.scrydex.com/pokemon/me55-20/large",
    },
    altArts: [
      {
        id: "me55-20",
        number: "20",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-20/small",
          large: "https://images.scrydex.com/pokemon/me55-20/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-136",
    name: "Palkia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Dragon"],
    attacks: [
      {
        name: "Space Crash",
        cost: ["Grass", "Water"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "This attack does 40 damage for each Basic Energy attached to this Pokémon.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "136",
    nationalPokedexNumbers: [484],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/136.png",
      large: "https://images.pokemontcg.io/sv8/136_hires.png",
    },
    altArts: [
      {
        id: "sv8-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/sv8/136.png",
          large: "https://images.pokemontcg.io/sv8/136_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-106p",
    name: "Palkia LV.X",
    supertype: "Pokémon",
    subtypes: ["LEVEL-UP"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Palkia",
    rules: [
      "Put this card onto your Active Palkia. Palkia LV.X can use any attack, Poké-Power, or Poké-Body from its previous level.",
    ],
    abilities: [
      {
        name: "Restructure",
        text: "Once during your turn (before your attack), you may have your opponent switch 1 of your Active Pokémon with 1 of your Benched Pokémon. Then, you switch 1 of the Defending Pokémon with 1 of your opponent's Benched Pokémon. This power can't be used if Palkia is affected by a Special Condition.",
        type: "Poké-POWER",
      },
    ],
    attacks: [
      {
        name: "Hydro Reflect",
        cost: ["Water", "Water", "Water"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "You may move all Energy cards attached to Palkia to your Benched Pokémon in any way you like. (Ignore this effect if you don't have any Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "106",
    nationalPokedexNumbers: [484],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-106p/small",
      large: "https://images.scrydex.com/pokemon/me55c-106p/large",
    },
    altArts: [
      {
        id: "me55c-106p",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-106p/small",
          large: "https://images.scrydex.com/pokemon/me55c-106p/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-92",
    name: "Palossand",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Psychic"],
    evolvesFrom: "Sandygast",
    attacks: [
      {
        name: "Sand Attack",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "During your opponent's next turn, if the Defending Pokémon tries to use an attack, your opponent flips a coin. If tails, that attack doesn't happen.",
      },
      {
        name: "Spooky Sand",
        cost: ["Psychic", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "92",
    flavorText:
      "From the hollows in its arms, it fires the bones of its victims, which are all dried up after being drained of their vitality.",
    nationalPokedexNumbers: [770],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/92.png",
      large: "https://images.pokemontcg.io/sv6/92_hires.png",
    },
    altArts: [
      {
        id: "sv6-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv6/92.png",
          large: "https://images.pokemontcg.io/sv6/92_hires.png",
        },
        flavorText:
          "From the hollows in its arms, it fires the bones of its victims, which are all dried up after being drained of their vitality.",
      },
    ],
  },
  {
    id: "sv8-91",
    name: "Palossand ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "280",
    types: ["Psychic"],
    evolvesFrom: "Sandygast",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Sand Tomb",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Barite Jail",
        cost: ["Water", "Psychic", "Fighting"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Put damage counters on each of your opponent's Benched Pokémon until its remaining HP is 100.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "91",
    nationalPokedexNumbers: [770],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/91.png",
      large: "https://images.pokemontcg.io/sv8/91_hires.png",
    },
    altArts: [
      {
        id: "sv8-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv8/91.png",
          large: "https://images.pokemontcg.io/sv8/91_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-221",
        number: "221",
        images: {
          small: "https://images.pokemontcg.io/sv8/221.png",
          large: "https://images.pokemontcg.io/sv8/221_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-20",
    name: "Palpitoad",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Tympole",
    evolvesTo: ["Seismitoad"],
    attacks: [
      {
        name: "Round",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "This attack does 40 damage for each of your Pokémon in play that has the Round attack.",
      },
      {
        name: "Wave Splash",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "20",
    flavorText:
      "When they vibrate the bumps on their heads, they can make waves in water or earthquake-like vibrations on land.",
    nationalPokedexNumbers: [536],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/20.png",
      large: "https://images.pokemontcg.io/zsv10pt5/20_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/20.png",
          large: "https://images.pokemontcg.io/zsv10pt5/20_hires.png",
        },
        flavorText:
          "When they vibrate the bumps on their heads, they can make waves in water or earthquake-like vibrations on land.",
      },
      {
        id: "zsv10pt5-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/104.png",
          large: "https://images.pokemontcg.io/zsv10pt5/104_hires.png",
        },
        flavorText:
          "When they vibrate the bumps on their heads, they can make waves in water or earthquake-like vibrations on land.",
      },
    ],
  },
  {
    id: "me2pt5-115",
    name: "Pancham",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "115",
    flavorText:
      "It does its level best to glare and pull a scary face, but it can’t help grinning if anyone pats its head.",
    nationalPokedexNumbers: [674],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-115/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-115/large",
    },
    altArts: [
      {
        id: "me2pt5-115",
        number: "115",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-115/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-115/large",
        },
        flavorText:
          "It does its level best to glare and pull a scary face, but it can’t help grinning if anyone pats its head.",
      },
    ],
  },
  {
    id: "sv7-85",
    name: "Pancham",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Pangoro"],
    attacks: [
      {
        name: "Leer",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Low Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "85",
    nationalPokedexNumbers: [674],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/85.png",
      large: "https://images.pokemontcg.io/sv7/85_hires.png",
    },
    altArts: [
      {
        id: "sv7-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv7/85.png",
          large: "https://images.pokemontcg.io/sv7/85_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-83",
    name: "Pancham",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    evolvesTo: ["Pangoro"],
    attacks: [
      {
        name: "Corkscrew Punch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Focus Fist",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    nationalPokedexNumbers: [674],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/83.png",
      large: "https://images.pokemontcg.io/sv9/83_hires.png",
    },
    altArts: [
      {
        id: "sv9-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv9/83.png",
          large: "https://images.pokemontcg.io/sv9/83_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-140",
    name: "Pangoro",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Pancham",
    attacks: [
      {
        name: "Corkscrew Punch",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Master's Punch",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If any of your Benched Pancham have any damage counters on them, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "140",
    nationalPokedexNumbers: [675],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-140/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-140/large",
    },
    altArts: [
      {
        id: "me2pt5-140",
        number: "140",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-140/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-140/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-93",
    name: "Pangoro",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Pancham",
    attacks: [
      {
        name: "Pull",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
      },
      {
        name: "Tantrum",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "This Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "93",
    nationalPokedexNumbers: [675],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/93.png",
      large: "https://images.pokemontcg.io/sv7/93_hires.png",
    },
    altArts: [
      {
        id: "sv7-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv7/93.png",
          large: "https://images.pokemontcg.io/sv7/93_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-99",
    name: "Pangoro",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Pancham",
    attacks: [
      {
        name: "Torment",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Choose 1 of your opponent's Active Pokémon's attacks. During your opponent's next turn, that Pokémon can't use that attack.",
      },
      {
        name: "Power Tackle",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "99",
    nationalPokedexNumbers: [675],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/99.png",
      large: "https://images.pokemontcg.io/sv9/99_hires.png",
    },
    altArts: [
      {
        id: "sv9-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv9/99.png",
          large: "https://images.pokemontcg.io/sv9/99_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-17",
    name: "Panpour",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Simipour"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Scratch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "17",
    flavorText:
      "The water stored inside the tuft on its head is full of nutrients. Plants that receive its water grow large.",
    nationalPokedexNumbers: [515],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/17.png",
      large: "https://images.pokemontcg.io/zsv10pt5/17_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/17.png",
          large: "https://images.pokemontcg.io/zsv10pt5/17_hires.png",
        },
        flavorText:
          "The water stored inside the tuft on its head is full of nutrients. Plants that receive its water grow large.",
      },
      {
        id: "zsv10pt5-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/101.png",
          large: "https://images.pokemontcg.io/zsv10pt5/101_hires.png",
        },
        flavorText:
          "The water stored inside the tuft on its head is full of nutrients. Plants that receive its water grow large.",
      },
    ],
  },
  {
    id: "zsv10pt5-4",
    name: "Pansage",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Simisage"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Scratch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    flavorText:
      "This Pokémon dwells deep in the forest. Eating a leaf from its head whisks weariness away as if by magic.",
    nationalPokedexNumbers: [511],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/4.png",
      large: "https://images.pokemontcg.io/zsv10pt5/4_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/4.png",
          large: "https://images.pokemontcg.io/zsv10pt5/4_hires.png",
        },
        flavorText:
          "This Pokémon dwells deep in the forest. Eating a leaf from its head whisks weariness away as if by magic.",
      },
      {
        id: "zsv10pt5-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/89.png",
          large: "https://images.pokemontcg.io/zsv10pt5/89_hires.png",
        },
        flavorText:
          "This Pokémon dwells deep in the forest. Eating a leaf from its head whisks weariness away as if by magic.",
      },
    ],
  },
  {
    id: "rsv10pt5-14",
    name: "Pansear",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Simisear"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Scratch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    flavorText:
      "When it is angered, the temperature of its head tuft reaches 600° F. It uses its tuft to roast berries.",
    nationalPokedexNumbers: [513],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/14.png",
      large: "https://images.pokemontcg.io/rsv10pt5/14_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/14.png",
          large: "https://images.pokemontcg.io/rsv10pt5/14_hires.png",
        },
        flavorText:
          "When it is angered, the temperature of its head tuft reaches 600° F. It uses its tuft to roast berries.",
      },
      {
        id: "rsv10pt5-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/99.png",
          large: "https://images.pokemontcg.io/rsv10pt5/99_hires.png",
        },
        flavorText:
          "When it is angered, the temperature of its head tuft reaches 600° F. It uses its tuft to roast berries.",
      },
    ],
  },
  {
    id: "sv8-22",
    name: "Pansear",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fire"],
    evolvesTo: ["Simisear"],
    attacks: [
      {
        name: "Combustion",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [513],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/22.png",
      large: "https://images.pokemontcg.io/sv8/22_hires.png",
    },
    altArts: [
      {
        id: "sv8-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/sv8/22.png",
          large: "https://images.pokemontcg.io/sv8/22_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-4",
    name: "Paras",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Parasect"],
    attacks: [
      {
        name: "Leech Life",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Heal from this Pokémon the same amount of damage you did to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    nationalPokedexNumbers: [46],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/4.png",
      large: "https://images.pokemontcg.io/sv9/4_hires.png",
    },
    altArts: [
      {
        id: "sv9-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv9/4.png",
          large: "https://images.pokemontcg.io/sv9/4_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-5",
    name: "Parasect",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Paras",
    attacks: [
      {
        name: "Spore",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
      {
        name: "Scissor Swing",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "Flip 2 coins. This attack does 30 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    nationalPokedexNumbers: [47],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/5.png",
      large: "https://images.pokemontcg.io/sv9/5_hires.png",
    },
    altArts: [
      {
        id: "sv9-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv9/5.png",
          large: "https://images.pokemontcg.io/sv9/5_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-111",
    name: "Passimian",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Coordinated Throwing",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "This attack does 20 damage for each of your Basic Pokémon in play.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "111",
    nationalPokedexNumbers: [766],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/111.png",
      large: "https://images.pokemontcg.io/sv8/111_hires.png",
    },
    altArts: [
      {
        id: "sv8-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/sv8/111.png",
          large: "https://images.pokemontcg.io/sv8/111_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-72",
    name: "Patrat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Watchog"],
    attacks: [
      {
        name: "Procurement",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for an Item card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Gnaw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    flavorText:
      "Using food stored in cheek pouches, they can keep watch for days. They use their tails to communicate with others.",
    nationalPokedexNumbers: [504],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/72.png",
      large: "https://images.pokemontcg.io/rsv10pt5/72_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/72.png",
          large: "https://images.pokemontcg.io/rsv10pt5/72_hires.png",
        },
        flavorText:
          "Using food stored in cheek pouches, they can keep watch for days. They use their tails to communicate with others.",
      },
      {
        id: "rsv10pt5-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/152.png",
          large: "https://images.pokemontcg.io/rsv10pt5/152_hires.png",
        },
        flavorText:
          "Using food stored in cheek pouches, they can keep watch for days. They use their tails to communicate with others.",
      },
    ],
  },
  {
    id: "me4-70",
    name: "Patrat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    abilities: [
      {
        name: "Watchful Eye",
        text: "Damage counters on each Pokémon (both yours and your opponent's) can't be moved to other Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bite",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "70",
    flavorText:
      "Using food stored in cheek pouches, they can keep watch for days. They use their tails to communicate with others.",
    nationalPokedexNumbers: [504],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-70/small",
      large: "https://images.scrydex.com/pokemon/me4-70/large",
    },
    altArts: [
      {
        id: "me4-70",
        number: "70",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-70/small",
          large: "https://images.scrydex.com/pokemon/me4-70/large",
        },
        flavorText:
          "Using food stored in cheek pouches, they can keep watch for days. They use their tails to communicate with others.",
      },
    ],
  },
  {
    id: "me2-32",
    name: "Pawmi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Growl",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 30 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Tiny Charge",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    flavorText:
      "It has underdeveloped electric sacs on its cheeks. These sacs can produce electricity only if Pawmi rubs them furiously with the pads on its forepaws.",
    nationalPokedexNumbers: [921],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/32.png",
      large: "https://images.pokemontcg.io/me2/32_hires.png",
    },
    altArts: [
      {
        id: "me2-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/me2/32.png",
          large: "https://images.pokemontcg.io/me2/32_hires.png",
        },
        flavorText:
          "It has underdeveloped electric sacs on its cheeks. These sacs can produce electricity only if Pawmi rubs them furiously with the pads on its forepaws.",
      },
    ],
  },
  {
    id: "sv7-56",
    name: "Pawmi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Lightning"],
    attacks: [
      {
        name: "Targeted Spark",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 20 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "56",
    nationalPokedexNumbers: [921],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/56.png",
      large: "https://images.pokemontcg.io/sv7/56_hires.png",
    },
    altArts: [
      {
        id: "sv7-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/sv7/56.png",
          large: "https://images.pokemontcg.io/sv7/56_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-33",
    name: "Pawmo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Pawmi",
    attacks: [
      {
        name: "Electric Punch",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    flavorText:
      "When its group is attacked, Pawmo is the first to leap into battle, defeating enemies with a fighting technique that utilizes electric shocks.",
    nationalPokedexNumbers: [922],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/33.png",
      large: "https://images.pokemontcg.io/me2/33_hires.png",
    },
    altArts: [
      {
        id: "me2-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/me2/33.png",
          large: "https://images.pokemontcg.io/me2/33_hires.png",
        },
        flavorText:
          "When its group is attacked, Pawmo is the first to leap into battle, defeating enemies with a fighting technique that utilizes electric shocks.",
      },
    ],
  },
  {
    id: "me2-34",
    name: "Pawmot",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Lightning"],
    evolvesFrom: "Pawmo",
    attacks: [
      {
        name: "Voltaic Fist",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "You may have this Pokémon also do 60 damage to itself and make your opponent's Active Pokémon Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "34",
    flavorText:
      "This Pokémon normally is slow to react, but once it enters battle, it will strike down its enemies with lightning-fast movements.",
    nationalPokedexNumbers: [923],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/34.png",
      large: "https://images.pokemontcg.io/me2/34_hires.png",
    },
    altArts: [
      {
        id: "me2-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/me2/34.png",
          large: "https://images.pokemontcg.io/me2/34_hires.png",
        },
        flavorText:
          "This Pokémon normally is slow to react, but once it enters battle, it will strike down its enemies with lightning-fast movements.",
      },
    ],
  },
  {
    id: "zsv10pt5-64",
    name: "Pawniard",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Metal"],
    evolvesTo: ["Bisharp"],
    attacks: [
      {
        name: "Corner",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    flavorText:
      "Blades comprise this Pokémon's entire body. If battling dulls the blades, it sharpens them on stones by the river.",
    nationalPokedexNumbers: [624],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/64.png",
      large: "https://images.pokemontcg.io/zsv10pt5/64_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/64.png",
          large: "https://images.pokemontcg.io/zsv10pt5/64_hires.png",
        },
        flavorText:
          "Blades comprise this Pokémon's entire body. If battling dulls the blades, it sharpens them on stones by the river.",
      },
      {
        id: "zsv10pt5-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/142.png",
          large: "https://images.pokemontcg.io/zsv10pt5/142_hires.png",
        },
        flavorText:
          "Blades comprise this Pokémon's entire body. If battling dulls the blades, it sharpens them on stones by the river.",
      },
    ],
  },
  {
    id: "me2pt5-146",
    name: "Pawniard",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Push Down",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "146",
    flavorText:
      "Any chips in its blades would prove fatal for it. After each battle, it diligently maintains its blades using its favorite sharpening stone.",
    nationalPokedexNumbers: [624],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-146/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-146/large",
    },
    altArts: [
      {
        id: "me2pt5-146",
        number: "146",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-146/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-146/large",
        },
        flavorText:
          "Any chips in its blades would prove fatal for it. After each battle, it diligently maintains its blades using its favorite sharpening stone.",
      },
    ],
  },
  {
    id: "svp-111",
    name: "Pawniard",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Bisharp"],
    attacks: [
      {
        name: "Pierce",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "111",
    nationalPokedexNumbers: [624],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/111.png",
      large: "https://images.pokemontcg.io/svp/111_hires.png",
    },
    altArts: [
      {
        id: "svp-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/svp/111.png",
          large: "https://images.pokemontcg.io/svp/111_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-143",
    name: "Pecharunt",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    abilities: [
      {
        name: "Final Chain",
        text: "If this Pokémon is Knocked Out by damage from an attack from your opponent's Pokémon, search your deck for a card and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mochi Rush",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your next turn, this Pokémon's Mochi Rush attack does 50 more damage (before applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "143",
    flavorText:
      "Its peach-shaped shell serves as storage for a potent poison. It makes poisonous mochi and serves them to people and Pokémon.",
    nationalPokedexNumbers: [1025],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-143/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-143/large",
    },
    altArts: [
      {
        id: "me2pt5-143",
        number: "143",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-143/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-143/large",
        },
        flavorText:
          "Its peach-shaped shell serves as storage for a potent poison. It makes poisonous mochi and serves them to people and Pokémon.",
      },
    ],
  },
  {
    id: "svp-129",
    name: "Pecharunt",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    abilities: [
      {
        name: "Toxic Subjugation",
        text: "As long as this Pokémon is in the Active Spot, put 5 more damage counters on your opponent's Poisoned Pokémon during Pokémon Checkup.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Poison Chain",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Poisoned. During your opponent's next turn, that Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "129",
    flavorText:
      "Its peach-shaped shell serves as storage for a potent poison. It makes poisonous mochi and serves them to people and Pokémon.",
    nationalPokedexNumbers: [1025],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/129.png",
      large: "https://images.pokemontcg.io/svp/129_hires.png",
    },
    altArts: [
      {
        id: "svp-129",
        number: "129",
        images: {
          small: "https://images.pokemontcg.io/svp/129.png",
          large: "https://images.pokemontcg.io/svp/129_hires.png",
        },
        flavorText:
          "Its peach-shaped shell serves as storage for a potent poison. It makes poisonous mochi and serves them to people and Pokémon.",
      },
      {
        id: "svp-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/svp/149.png",
          large: "https://images.pokemontcg.io/svp/149_hires.png",
        },
        flavorText:
          "Its peach-shaped shell serves as storage for a potent poison. It makes poisonous mochi and serves them to people and Pokémon.",
      },
    ],
  },
  {
    id: "sv6pt5-39",
    name: "Pecharunt ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Darkness"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Subjugating Chains",
        text: "Once during your turn, you may switch 1 of your Benched Darkness Pokémon, except any Pecharunt ex, with your Active Pokémon. If you do, the new Active Pokémon is now Poisoned. You can't use more than 1 Subjugating Chains Ability each turn.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Irritated Outburst",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: "This attack does 60 damage for each Prize card your opponent has taken.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    nationalPokedexNumbers: [1025],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/39.png",
      large: "https://images.pokemontcg.io/sv6pt5/39_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/39.png",
          large: "https://images.pokemontcg.io/sv6pt5/39_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/85.png",
          large: "https://images.pokemontcg.io/sv6pt5/85_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/93.png",
          large: "https://images.pokemontcg.io/sv6pt5/93_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/95.png",
          large: "https://images.pokemontcg.io/sv6pt5/95_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/163.png",
          large: "https://images.pokemontcg.io/sv8pt5/163_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-39",
    name: "Pelipper",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Wingull",
    attacks: [
      {
        name: "Spit Up",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Speed Dive",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "39",
    nationalPokedexNumbers: [279],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/39.png",
      large: "https://images.pokemontcg.io/sv9/39_hires.png",
    },
    altArts: [
      {
        id: "sv9-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv9/39.png",
          large: "https://images.pokemontcg.io/sv9/39_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-49",
    name: "Persian",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Meowth",
    attacks: [
      {
        name: "Fury Swipes",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50×",
        text: "Flip 3 coins. This attack does 50 damage for each heads.",
      },
      {
        name: "Slashing Claw",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    nationalPokedexNumbers: [53],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/49.png",
      large: "https://images.pokemontcg.io/sv6pt5/49_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/49.png",
          large: "https://images.pokemontcg.io/sv6pt5/49_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/78.png",
          large: "https://images.pokemontcg.io/sv6pt5/78_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-6",
    name: "Petilil",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Lilligant"],
    attacks: [
      {
        name: "Hide",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
      {
        name: "Leafage",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    flavorText:
      "The leaves on its head are very bitter. Eating one of these leaves is known to refresh a tired body.",
    nationalPokedexNumbers: [548],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/6.png",
      large: "https://images.pokemontcg.io/zsv10pt5/6_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/6.png",
          large: "https://images.pokemontcg.io/zsv10pt5/6_hires.png",
        },
        flavorText:
          "The leaves on its head are very bitter. Eating one of these leaves is known to refresh a tired body.",
      },
      {
        id: "zsv10pt5-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/91.png",
          large: "https://images.pokemontcg.io/zsv10pt5/91_hires.png",
        },
        flavorText:
          "The leaves on its head are very bitter. Eating one of these leaves is known to refresh a tired body.",
      },
    ],
  },
  {
    id: "sv9-6",
    name: "Petilil",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Lilligant"],
    attacks: [
      {
        name: "Leaf Step",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    nationalPokedexNumbers: [548],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/6.png",
      large: "https://images.pokemontcg.io/sv9/6_hires.png",
    },
    altArts: [
      {
        id: "sv9-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv9/6.png",
          large: "https://images.pokemontcg.io/sv9/6_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-44",
    name: "Phanpy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    attacks: [
      {
        name: "Mud-Slap",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Rollout",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "44",
    flavorText:
      "It is far stronger than it appears. If a Phanpy is swinging its trunk around and your arm gets hit by it, your arm bone will shatter.",
    nationalPokedexNumbers: [231],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-44/small",
      large: "https://images.scrydex.com/pokemon/me4-44/large",
    },
    altArts: [
      {
        id: "me4-44",
        number: "44",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-44/small",
          large: "https://images.scrydex.com/pokemon/me4-44/large",
        },
        flavorText:
          "It is far stronger than it appears. If a Phanpy is swinging its trunk around and your arm gets hit by it, your arm bone will shatter.",
      },
    ],
  },
  {
    id: "sv8-102",
    name: "Phanpy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Donphan"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "102",
    nationalPokedexNumbers: [231],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/102.png",
      large: "https://images.pokemontcg.io/sv8/102_hires.png",
    },
    altArts: [
      {
        id: "sv8-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/sv8/102.png",
          large: "https://images.pokemontcg.io/sv8/102_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-205",
        number: "205",
        images: {
          small: "https://images.pokemontcg.io/sv8/205.png",
          large: "https://images.pokemontcg.io/sv8/205_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-38",
    name: "Phantump",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    abilities: [
      {
        name: "Spiteful Evolution",
        text: "Once during your turn, you may use this Ability. Choose a card in your hand that evolves from this Pokémon and put it onto this Pokémon to evolve it. If you do, place 2 damage counters on the Pokémon you evolved in this way. You can't use this Ability during your first turn.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mumble",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    flavorText:
      "According to old tales, these Pokémon are stumps possessed by the spirits of children who died while lost in the forest.",
    nationalPokedexNumbers: [708],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-38/small",
      large: "https://images.scrydex.com/pokemon/me4-38/large",
    },
    altArts: [
      {
        id: "me4-38",
        number: "38",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-38/small",
          large: "https://images.scrydex.com/pokemon/me4-38/large",
        },
        flavorText:
          "According to old tales, these Pokémon are stumps possessed by the spirits of children who died while lost in the forest.",
      },
    ],
  },
  {
    id: "sv6-12",
    name: "Phantump",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Trevenant"],
    attacks: [
      {
        name: "Leech Seed",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Heal 20 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "12",
    flavorText:
      "This Pokémon came to be when the spirit of a deceased child possessed a tree stump. It now wanders the forest searching for friends.",
    nationalPokedexNumbers: [708],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/12.png",
      large: "https://images.pokemontcg.io/sv6/12_hires.png",
    },
    altArts: [
      {
        id: "sv6-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv6/12.png",
          large: "https://images.pokemontcg.io/sv6/12_hires.png",
        },
        flavorText:
          "This Pokémon came to be when the spirit of a deceased child possessed a tree stump. It now wanders the forest searching for friends.",
      },
    ],
  },
  {
    id: "sv6-55",
    name: "Phione",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Beckon",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put a Supporter card from your discard pile into your hand.",
      },
      {
        name: "Energy Press",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    flavorText:
      "When the water warms, they inflate the flotation sac on their heads and drift languidly on the sea in packs.",
    nationalPokedexNumbers: [489],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/55.png",
      large: "https://images.pokemontcg.io/sv6/55_hires.png",
    },
    altArts: [
      {
        id: "sv6-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv6/55.png",
          large: "https://images.pokemontcg.io/sv6/55_hires.png",
        },
        flavorText:
          "When the water warms, they inflate the flotation sac on their heads and drift languidly on the sea in packs.",
      },
      {
        id: "sv6-175",
        number: "175",
        images: {
          small: "https://images.pokemontcg.io/sv6/175.png",
          large: "https://images.pokemontcg.io/sv6/175_hires.png",
        },
        flavorText:
          "When the water warms, they inflate the flotation sac on their heads and drift languidly on the sea in packs.",
      },
    ],
  },
  {
    id: "zsv10pt5-71",
    name: "Pidove",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Tranquill"],
    attacks: [
      {
        name: "Scout",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent reveals their hand.",
      },
      {
        name: "Stampede",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "71",
    flavorText:
      "Each follows its Trainer's orders as best it can, but they sometimes fail to understand complicated commands.",
    nationalPokedexNumbers: [519],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/71.png",
      large: "https://images.pokemontcg.io/zsv10pt5/71_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/71.png",
          large: "https://images.pokemontcg.io/zsv10pt5/71_hires.png",
        },
        flavorText:
          "Each follows its Trainer's orders as best it can, but they sometimes fail to understand complicated commands.",
      },
      {
        id: "zsv10pt5-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/148.png",
          large: "https://images.pokemontcg.io/zsv10pt5/148_hires.png",
        },
        flavorText:
          "Each follows its Trainer's orders as best it can, but they sometimes fail to understand complicated commands.",
      },
    ],
  },
  {
    id: "sv5-133",
    name: "Pidove",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Colorless"],
    evolvesTo: ["Tranquill"],
    abilities: [
      {
        name: "Emergency Evolution",
        text: "Once during your turn, if this Pokémon's remaining HP is 30 or less, you may search your deck for an Unfezant or Unfezant ex and put it onto this Pidove to evolve it. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Gust",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "133",
    flavorText:
      "Where people go, these Pokémon follow. If you're scattering food for them, be careful— several hundred of them can gather at once.",
    nationalPokedexNumbers: [519],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/133.png",
      large: "https://images.pokemontcg.io/sv5/133_hires.png",
    },
    altArts: [
      {
        id: "sv5-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/sv5/133.png",
          large: "https://images.pokemontcg.io/sv5/133_hires.png",
        },
        flavorText:
          "Where people go, these Pokémon follow. If you're scattering food for them, be careful— several hundred of them can gather at once.",
      },
    ],
  },
  {
    id: "rsv10pt5-12",
    name: "Pignite",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fire"],
    evolvesFrom: "Tepig",
    evolvesTo: ["Emboar"],
    attacks: [
      {
        name: "Combustion",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Heat Crash",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "12",
    flavorText:
      "When its internal fire flares up, its movements grow sharper and faster. When in trouble, it emits smoke.",
    nationalPokedexNumbers: [499],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/12.png",
      large: "https://images.pokemontcg.io/rsv10pt5/12_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/12.png",
          large: "https://images.pokemontcg.io/rsv10pt5/12_hires.png",
        },
        flavorText:
          "When its internal fire flares up, its movements grow sharper and faster. When in trouble, it emits smoke.",
      },
      {
        id: "rsv10pt5-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/97.png",
          large: "https://images.pokemontcg.io/rsv10pt5/97_hires.png",
        },
        flavorText:
          "When its internal fire flares up, its movements grow sharper and faster. When in trouble, it emits smoke.",
      },
    ],
  },
  {
    id: "me2pt5-30",
    name: "Pignite",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fire"],
    evolvesFrom: "Tepig",
    attacks: [
      {
        name: "Super Singe",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "30",
    flavorText:
      "The more it eats, the more fuel it has to make the fire in its stomach stronger. This fills it with even more power.",
    nationalPokedexNumbers: [499],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-30/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-30/large",
    },
    altArts: [
      {
        id: "me2pt5-30",
        number: "30",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-30/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-30/large",
        },
        flavorText:
          "The more it eats, the more fuel it has to make the fire in its stomach stronger. This fills it with even more power.",
      },
    ],
  },
  {
    id: "me2pt5-55",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Tail Smack",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Tiny Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    nationalPokedexNumbers: [25],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-55/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-55/large",
    },
    altArts: [
      {
        id: "me2pt5-55",
        number: "55",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-55/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-55/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-23",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Thunder Shock",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "23",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-23/small",
      large: "https://images.scrydex.com/pokemon/me55-23/large",
    },
    altArts: [
      {
        id: "me55-23",
        number: "23",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-23/small",
          large: "https://images.scrydex.com/pokemon/me55-23/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-24",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Volt Tackle",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-24/small",
      large: "https://images.scrydex.com/pokemon/me55-24/large",
    },
    altArts: [
      {
        id: "me55-24",
        number: "24",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-24/small",
          large: "https://images.scrydex.com/pokemon/me55-24/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-25",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Spark",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "This attack also does 20 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "25",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-25/small",
      large: "https://images.scrydex.com/pokemon/me55-25/large",
    },
    altArts: [
      {
        id: "me55-25",
        number: "25",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-25/small",
          large: "https://images.scrydex.com/pokemon/me55-25/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-26",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Peer At",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Your opponent reveals their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "26",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-26/small",
      large: "https://images.scrydex.com/pokemon/me55-26/large",
    },
    altArts: [
      {
        id: "me55-26",
        number: "26",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-26/small",
          large: "https://images.scrydex.com/pokemon/me55-26/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-27",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Lightning"],
    attacks: [
      {
        name: "Nap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "27",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-27/small",
      large: "https://images.scrydex.com/pokemon/me55-27/large",
    },
    altArts: [
      {
        id: "me55-27",
        number: "27",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-27/small",
          large: "https://images.scrydex.com/pokemon/me55-27/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-28",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    abilities: [
      {
        name: "Lonely Gaze",
        text: "As long as this Pokémon is in the Active Spot, attacks used by your opponent's Active Pokémon do 20 less damage (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Pika Ball",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "28",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-28/small",
      large: "https://images.scrydex.com/pokemon/me55-28/large",
    },
    altArts: [
      {
        id: "me55-28",
        number: "28",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-28/small",
          large: "https://images.scrydex.com/pokemon/me55-28/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-29",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Find a Friend",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "29",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-29/small",
      large: "https://images.scrydex.com/pokemon/me55-29/large",
    },
    altArts: [
      {
        id: "me55-29",
        number: "29",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-29/small",
          large: "https://images.scrydex.com/pokemon/me55-29/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-30",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Mach Bolt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "30",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-30/small",
      large: "https://images.scrydex.com/pokemon/me55-30/large",
    },
    altArts: [
      {
        id: "me55-30",
        number: "30",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-30/small",
          large: "https://images.scrydex.com/pokemon/me55-30/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-31",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Lightning"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "31",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-31/small",
      large: "https://images.scrydex.com/pokemon/me55-31/large",
    },
    altArts: [
      {
        id: "me55-31",
        number: "31",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-31/small",
          large: "https://images.scrydex.com/pokemon/me55-31/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-32",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Lightning"],
    attacks: [
      {
        name: "Scurry About",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-32/small",
      large: "https://images.scrydex.com/pokemon/me55-32/large",
    },
    altArts: [
      {
        id: "me55-32",
        number: "32",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-32/small",
          large: "https://images.scrydex.com/pokemon/me55-32/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-33",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    abilities: [
      {
        name: "Keep Hidden",
        text: "As long as this Pokémon is on your Bench, prevent all damage from and effects of attacks from your opponent's Pokémon done to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Tiny Charge",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-33/small",
      large: "https://images.scrydex.com/pokemon/me55-33/large",
    },
    altArts: [
      {
        id: "me55-33",
        number: "33",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-33/small",
          large: "https://images.scrydex.com/pokemon/me55-33/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-34",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Pika Chain",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "40×",
        text: "This attack does 40 damage for each of your Pikachu and Pikachu ex in play.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-34/small",
      large: "https://images.scrydex.com/pokemon/me55-34/large",
    },
    altArts: [
      {
        id: "me55-34",
        number: "34",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-34/small",
          large: "https://images.scrydex.com/pokemon/me55-34/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-35",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Rollout",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-35/small",
      large: "https://images.scrydex.com/pokemon/me55-35/large",
    },
    altArts: [
      {
        id: "me55-35",
        number: "35",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-35/small",
          large: "https://images.scrydex.com/pokemon/me55-35/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-36",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Slight Intrusion",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "36",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-36/small",
      large: "https://images.scrydex.com/pokemon/me55-36/large",
    },
    altArts: [
      {
        id: "me55-36",
        number: "36",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-36/small",
          large: "https://images.scrydex.com/pokemon/me55-36/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-37",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Energized Tail",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Search your deck for an Energy card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Pika Punch",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-37/small",
      large: "https://images.scrydex.com/pokemon/me55-37/large",
    },
    altArts: [
      {
        id: "me55-37",
        number: "37",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-37/small",
          large: "https://images.scrydex.com/pokemon/me55-37/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-38",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Targeted Spark",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        text: "This attack does 20 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "38",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-38/small",
      large: "https://images.scrydex.com/pokemon/me55-38/large",
    },
    altArts: [
      {
        id: "me55-38",
        number: "38",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-38/small",
          large: "https://images.scrydex.com/pokemon/me55-38/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-39",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Iron Tail",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "Flip a coin until you get tails. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-39/small",
      large: "https://images.scrydex.com/pokemon/me55-39/large",
    },
    altArts: [
      {
        id: "me55-39",
        number: "39",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-39/small",
          large: "https://images.scrydex.com/pokemon/me55-39/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-40",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Lightning"],
    attacks: [
      {
        name: "Overwriting Bolt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "The Defending Pokémon's Weakness is now Lightning until the end of your next turn. (Apply Weakness as x2.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "40",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-40/small",
      large: "https://images.scrydex.com/pokemon/me55-40/large",
    },
    altArts: [
      {
        id: "me55-40",
        number: "40",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-40/small",
          large: "https://images.scrydex.com/pokemon/me55-40/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-41",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Hang Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
      },
      {
        name: "Zap Kick",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-41/small",
      large: "https://images.scrydex.com/pokemon/me55-41/large",
    },
    altArts: [
      {
        id: "me55-41",
        number: "41",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-41/small",
          large: "https://images.scrydex.com/pokemon/me55-41/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-42",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Charge-Up Dash",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Flip a coin until you get tails. Search your deck for an amount of Basic Lightning Energy up to the number of heads and attach it to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Pika Bolt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "42",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-42/small",
      large: "https://images.scrydex.com/pokemon/me55-42/large",
    },
    altArts: [
      {
        id: "me55-42",
        number: "42",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-42/small",
          large: "https://images.scrydex.com/pokemon/me55-42/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-43",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Tropical Vibes",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        text: "This Pokémon is now Asleep. Draw cards until you have 6 cards in your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-43/small",
      large: "https://images.scrydex.com/pokemon/me55-43/large",
    },
    altArts: [
      {
        id: "me55-43",
        number: "43",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-43/small",
          large: "https://images.scrydex.com/pokemon/me55-43/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-44",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Agility",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-44/small",
      large: "https://images.scrydex.com/pokemon/me55-44/large",
    },
    altArts: [
      {
        id: "me55-44",
        number: "44",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-44/small",
          large: "https://images.scrydex.com/pokemon/me55-44/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-45",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Nightime Stroll",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Draw a card.",
      },
      {
        name: "Static Shock",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "45",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-45/small",
      large: "https://images.scrydex.com/pokemon/me55-45/large",
    },
    altArts: [
      {
        id: "me55-45",
        number: "45",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-45/small",
          large: "https://images.scrydex.com/pokemon/me55-45/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-46",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Get Some Air",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "This Pokémon recovers from all Special Conditions.",
      },
      {
        name: "Smash Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "46",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-46/small",
      large: "https://images.scrydex.com/pokemon/me55-46/large",
    },
    altArts: [
      {
        id: "me55-46",
        number: "46",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-46/small",
          large: "https://images.scrydex.com/pokemon/me55-46/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-47",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Play Rough",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "47",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-47/small",
      large: "https://images.scrydex.com/pokemon/me55-47/large",
    },
    altArts: [
      {
        id: "me55-47",
        number: "47",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-47/small",
          large: "https://images.scrydex.com/pokemon/me55-47/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-48",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Store Up",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Put up to 2 Basic Energy cards from your discard pile into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "48",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-48/small",
      large: "https://images.scrydex.com/pokemon/me55-48/large",
    },
    altArts: [
      {
        id: "me55-48",
        number: "48",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-48/small",
          large: "https://images.scrydex.com/pokemon/me55-48/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-49",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Lightning"],
    attacks: [
      {
        name: "Fighting Lightning",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20+",
        text: "If your opponent's Active Pokémon is a Pokémon ex, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "49",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-49/small",
      large: "https://images.scrydex.com/pokemon/me55-49/large",
    },
    altArts: [
      {
        id: "me55-49",
        number: "49",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-49/small",
          large: "https://images.scrydex.com/pokemon/me55-49/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-50",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Lightning"],
    attacks: [
      {
        name: "Satisfied Spark",
        cost: ["Lightning", "Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "50",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-50/small",
      large: "https://images.scrydex.com/pokemon/me55-50/large",
    },
    altArts: [
      {
        id: "me55-50",
        number: "50",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-50/small",
          large: "https://images.scrydex.com/pokemon/me55-50/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-51",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Lightning Crash",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        text: "Discard all Lightning Energy from this Pokémon, and this attack does 90 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "51",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-51/small",
      large: "https://images.scrydex.com/pokemon/me55-51/large",
    },
    altArts: [
      {
        id: "me55-51",
        number: "51",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-51/small",
          large: "https://images.scrydex.com/pokemon/me55-51/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-52",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Angry Bolt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "This attack does 10 more damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-52/small",
      large: "https://images.scrydex.com/pokemon/me55-52/large",
    },
    altArts: [
      {
        id: "me55-52",
        number: "52",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-52/small",
          large: "https://images.scrydex.com/pokemon/me55-52/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-58",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Lightning"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
      },
      {
        name: "Thunder Jolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Flip a coin. If tails, Pikachu does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    nationalPokedexNumbers: [25],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-58/small",
      large: "https://images.scrydex.com/pokemon/me55c-58/large",
    },
    altArts: [
      {
        id: "me55c-58",
        number: "58",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-58/small",
          large: "https://images.scrydex.com/pokemon/me55c-58/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-51",
    name: "Pikachu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Raichu"],
    attacks: [
      {
        name: "Random Spark",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 10 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    flavorText:
      "When several of these Pokémon gather, their electricity can build and cause lightning storms.",
    nationalPokedexNumbers: [25],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/51.png",
      large: "https://images.pokemontcg.io/sv5/51_hires.png",
    },
    altArts: [
      {
        id: "sv5-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv5/51.png",
          large: "https://images.pokemontcg.io/sv5/51_hires.png",
        },
        flavorText:
          "When several of these Pokémon gather, their electricity can build and cause lightning storms.",
      },
    ],
  },
  {
    id: "me55c-33",
    name: "Pikachu & Zekrom-GX",
    supertype: "Pokémon",
    subtypes: ["Basic", "GX", "TAG TEAM"],
    hp: "240",
    types: ["Lightning"],
    rules: [
      "When your TAG TEAM is Knocked Out, your opponent takes 3 Prize cards.",
    ],
    attacks: [
      {
        name: "Full Blitz",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Search your deck for up to 3 Lightning Energy cards and attach them to 1 of your Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Tag Bolt-GX",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "If this Pokémon has at least 3 extra Lightning Energy attached to it (in addition to this attack's cost), this attack does 170 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.) (You can't use more than 1 GX attack in a game.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Metal",
        value: "-20",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "33",
    nationalPokedexNumbers: [25],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-33/small",
      large: "https://images.scrydex.com/pokemon/me55c-33/large",
    },
    altArts: [
      {
        id: "me55c-33",
        number: "33",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-33/small",
          large: "https://images.scrydex.com/pokemon/me55c-33/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-57",
    name: "Pikachu ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "200",
    types: ["Lightning"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent’s).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Resolute Heart",
        text: "If this Pokémon has full HP and would be Knocked Out by damage from an attack, it is not Knocked Out, and its remaining HP becomes 10.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Topaz Bolt",
        cost: ["Grass", "Lightning", "Metal"],
        convertedEnergyCost: 3,
        damage: "300",
        text: "Discard 3 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    nationalPokedexNumbers: [25],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-57/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-57/large",
    },
    altArts: [
      {
        id: "me2pt5-57",
        number: "57",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-57/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-57/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-277",
        number: "277",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-277/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-277/large",
        },
        flavorText: "",
      },
      {
        id: "sv8-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv8/57.png",
          large: "https://images.pokemontcg.io/sv8/57_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-219",
        number: "219",
        images: {
          small: "https://images.pokemontcg.io/sv8/219.png",
          large: "https://images.pokemontcg.io/sv8/219_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-238",
        number: "238",
        images: {
          small: "https://images.pokemontcg.io/sv8/238.png",
          large: "https://images.pokemontcg.io/sv8/238_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-247",
        number: "247",
        images: {
          small: "https://images.pokemontcg.io/sv8/247.png",
          large: "https://images.pokemontcg.io/sv8/247_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-179",
        number: "179",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/179.png",
          large: "https://images.pokemontcg.io/sv8pt5/179_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-276",
    name: "Pikachu ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "200",
    types: ["Lightning"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Thunderbolt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "276",
    nationalPokedexNumbers: [25],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-276/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-276/large",
    },
    altArts: [
      {
        id: "me2pt5-276",
        number: "276",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-276/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-276/large",
        },
        flavorText: "",
      },
      {
        id: "svp-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/svp/106.png",
          large: "https://images.pokemontcg.io/svp/106_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-53",
    name: "Pikachu ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Lightning"],
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Pika-Pika Parade",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Search your deck for any number of Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Thunderbolt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "53",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-53/small",
      large: "https://images.scrydex.com/pokemon/me55-53/large",
    },
    altArts: [
      {
        id: "me55-53",
        number: "53",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-53/small",
          large: "https://images.scrydex.com/pokemon/me55-53/large",
        },
        flavorText: "",
      },
      {
        id: "me55-149",
        number: "149",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-149/small",
          large: "https://images.scrydex.com/pokemon/me55-149/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-54",
    name: "Pikachu ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Lightning"],
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Zip-Zap Frenzy",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        text: "You may attach any number of Basic Energy cards from your hand to your Pokémon in any way you like.",
      },
      {
        name: "Thunder",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "54",
    nationalPokedexNumbers: [25],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-54/small",
      large: "https://images.scrydex.com/pokemon/me55-54/large",
    },
    altArts: [
      {
        id: "me55-54",
        number: "54",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-54/small",
          large: "https://images.scrydex.com/pokemon/me55-54/large",
        },
        flavorText: "",
      },
      {
        id: "me55-150",
        number: "150",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-150/small",
          large: "https://images.scrydex.com/pokemon/me55-150/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-28",
    name: "Pikachu ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "190",
    types: ["Lightning"],
    evolvesTo: ["Raichu"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Tail Whap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Thunder",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "220",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "28",
    nationalPokedexNumbers: [25],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/28.png",
      large: "https://images.pokemontcg.io/sv8pt5/28_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/28.png",
          large: "https://images.pokemontcg.io/sv8pt5/28_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-66",
    name: "Pikipek",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Double Stab",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "66",
    flavorText:
      "Pikipek has strong muscles in its neck, so it won't hurt itself even if it violently shakes its head.",
    nationalPokedexNumbers: [731],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-66/small",
      large: "https://images.scrydex.com/pokemon/me5-66/large",
    },
    altArts: [
      {
        id: "me5-66",
        number: "66",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-66/small",
          large: "https://images.scrydex.com/pokemon/me5-66/large",
        },
        flavorText:
          "Pikipek has strong muscles in its neck, so it won't hurt itself even if it violently shakes its head.",
      },
    ],
  },
  {
    id: "me2-24",
    name: "Piloswine",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Swinub",
    evolvesTo: ["Mamoswine"],
    attacks: [
      {
        name: "Rising Lunge",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "Flip a coin. If heads, this attack does 30 more damage.",
      },
      {
        name: "Frost Smash",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "24",
    flavorText:
      "Covered by a shaggy coat, it is resistant to the cold. Its tusks of ice thicken when it snows.",
    nationalPokedexNumbers: [221],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/24.png",
      large: "https://images.pokemontcg.io/me2/24_hires.png",
    },
    altArts: [
      {
        id: "me2-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/me2/24.png",
          large: "https://images.pokemontcg.io/me2/24_hires.png",
        },
        flavorText:
          "Covered by a shaggy coat, it is resistant to the cold. Its tusks of ice thicken when it snows.",
      },
    ],
  },
  {
    id: "sv9-78",
    name: "Piloswine",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Swinub",
    evolvesTo: ["Mamoswine"],
    attacks: [
      {
        name: "Strength",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Impaling Tusk",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "78",
    nationalPokedexNumbers: [221],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/78.png",
      large: "https://images.pokemontcg.io/sv9/78_hires.png",
    },
    altArts: [
      {
        id: "sv9-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv9/78.png",
          large: "https://images.pokemontcg.io/sv9/78_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-4",
    name: "Pineco",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Forretress"],
    attacks: [
      {
        name: "Hang Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "4",
    nationalPokedexNumbers: [204],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/4.png",
      large: "https://images.pokemontcg.io/sv10/4_hires.png",
    },
    altArts: [
      {
        id: "sv10-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv10/4.png",
          large: "https://images.pokemontcg.io/sv10/4_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-2",
    name: "Pineco",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Forretress"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "2",
    flavorText:
      "It spits out a fluid that it uses to glue tree bark to its body. The fluid hardens when it touches air.",
    nationalPokedexNumbers: [204],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/2.png",
      large: "https://images.pokemontcg.io/sv5/2_hires.png",
    },
    altArts: [
      {
        id: "sv5-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv5/2.png",
          large: "https://images.pokemontcg.io/sv5/2_hires.png",
        },
        flavorText:
          "It spits out a fluid that it uses to glue tree bark to its body. The fluid hardens when it touches air.",
      },
    ],
  },
  {
    id: "sv6-3",
    name: "Pinsir",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Grass"],
    attacks: [
      {
        name: "Slow Crunch",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Discard all Energy from this Pokémon. At the end of your opponent's next turn, the Defending Pokémon will be Knocked Out.",
      },
      {
        name: "Superpowered Horns",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "3",
    flavorText:
      "These Pokémon judge one another based on pincers. Thicker, more impressive pincers make for more popularity with the opposite gender.",
    nationalPokedexNumbers: [127],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/3.png",
      large: "https://images.pokemontcg.io/sv6/3_hires.png",
    },
    altArts: [
      {
        id: "sv6-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv6/3.png",
          large: "https://images.pokemontcg.io/sv6/3_hires.png",
        },
        flavorText:
          "These Pokémon judge one another based on pincers. Thicker, more impressive pincers make for more popularity with the opposite gender.",
      },
      {
        id: "sv6-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/sv6/168.png",
          large: "https://images.pokemontcg.io/sv6/168_hires.png",
        },
        flavorText:
          "These Pokémon judge one another based on pincers. Thicker, more impressive pincers make for more popularity with the opposite gender.",
      },
    ],
  },
  {
    id: "sv8pt5-3",
    name: "Pinsir",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Slash",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "3",
    nationalPokedexNumbers: [127],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/3.png",
      large: "https://images.pokemontcg.io/sv8pt5/3_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/3.png",
          large: "https://images.pokemontcg.io/sv8pt5/3_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-27",
    name: "Piplup",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Prinplup"],
    attacks: [
      {
        name: "Call for Support",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Supporter card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "27",
    flavorText:
      "A poor walker, it often falls down. However, its strong pride makes it puff up its chest without a care.",
    nationalPokedexNumbers: [393],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/27.png",
      large: "https://images.pokemontcg.io/me2/27_hires.png",
    },
    altArts: [
      {
        id: "me2-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/me2/27.png",
          large: "https://images.pokemontcg.io/me2/27_hires.png",
        },
        flavorText:
          "A poor walker, it often falls down. However, its strong pride makes it puff up its chest without a care.",
      },
      {
        id: "me2-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/me2/98.png",
          large: "https://images.pokemontcg.io/me2/98_hires.png",
        },
        flavorText:
          "A poor walker, it often falls down. However, its strong pride makes it puff up its chest without a care.",
      },
    ],
  },
  {
    id: "sv6-41",
    name: "Poliwag",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Poliwhirl"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Tail Rap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "Flip 2 coins. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    flavorText:
      "Its legs are newly grown, and it can't walk very well. It seems to prefer swimming through the water instead.",
    nationalPokedexNumbers: [60],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/41.png",
      large: "https://images.pokemontcg.io/sv6/41_hires.png",
    },
    altArts: [
      {
        id: "sv6-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv6/41.png",
          large: "https://images.pokemontcg.io/sv6/41_hires.png",
        },
        flavorText:
          "Its legs are newly grown, and it can't walk very well. It seems to prefer swimming through the water instead.",
      },
    ],
  },
  {
    id: "sv6-42",
    name: "Poliwhirl",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Poliwag",
    evolvesTo: ["Poliwrath", "Politoed"],
    attacks: [
      {
        name: "Hypnosis",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
      {
        name: "Double Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "Flip 2 coins. This attack does 30 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "42",
    flavorText:
      "Its skin is moist all over its body. The skin on its belly spiral also feels smooth.",
    nationalPokedexNumbers: [61],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/42.png",
      large: "https://images.pokemontcg.io/sv6/42_hires.png",
    },
    altArts: [
      {
        id: "sv6-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/sv6/42.png",
          large: "https://images.pokemontcg.io/sv6/42_hires.png",
        },
        flavorText:
          "Its skin is moist all over its body. The skin on its belly spiral also feels smooth.",
      },
    ],
  },
  {
    id: "sv6-43",
    name: "Poliwrath",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Water"],
    evolvesFrom: "Poliwhirl",
    attacks: [
      {
        name: "Hypnosis",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
      {
        name: "Jumping Uppercut",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120+",
        text: "You may do 120 more damage. If you do, shuffle this Pokémon and all attached cards into your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "43",
    flavorText:
      "It can use its well-developed arms and legs to run on the surface of the water for a split second.",
    nationalPokedexNumbers: [62],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/43.png",
      large: "https://images.pokemontcg.io/sv6/43_hires.png",
    },
    altArts: [
      {
        id: "sv6-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv6/43.png",
          large: "https://images.pokemontcg.io/sv6/43_hires.png",
        },
        flavorText:
          "It can use its well-developed arms and legs to run on the surface of the water for a split second.",
      },
    ],
  },
  {
    id: "me5-5",
    name: "Poltchageist",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Grass"],
    abilities: [
      {
        name: "Hide 'n' Sneak",
        text: "Prevent all effects of your opponent's Pokémon's attacks and Abilities done to this Pokémon. (Damage is not an effect.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Furtive Drop",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Place 1 damage counter on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "5",
    flavorText:
      "Poltchageist looks like a regional form of Sinistea, but it was recently discovered that the two Pokémon are entirely unrelated.",
    nationalPokedexNumbers: [1012],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-5/small",
      large: "https://images.scrydex.com/pokemon/me5-5/large",
    },
    altArts: [
      {
        id: "me5-5",
        number: "5",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-5/small",
          large: "https://images.scrydex.com/pokemon/me5-5/large",
        },
        flavorText:
          "Poltchageist looks like a regional form of Sinistea, but it was recently discovered that the two Pokémon are entirely unrelated.",
      },
    ],
  },
  {
    id: "sv6-20",
    name: "Poltchageist",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Grass"],
    abilities: [
      {
        name: "Storehouse Hideaway",
        text: "As long as this Pokémon is on your Bench, prevent all damage from and effects of attacks from your opponent's Pokémon done to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hook",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "20",
    nationalPokedexNumbers: [1012],
    flavorText:
      "Poltchageist looks like a regional form of Sinistea, but it was recently discovered that the two Pokémon are entirely unrelated.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/20.png",
      large: "https://images.pokemontcg.io/sv6/20_hires.png",
    },
    altArts: [
      {
        id: "sv6-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv6/20.png",
          large: "https://images.pokemontcg.io/sv6/20_hires.png",
        },
        flavorText:
          "Poltchageist looks like a regional form of Sinistea, but it was recently discovered that the two Pokémon are entirely unrelated.",
      },
      {
        id: "sv6-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/sv6/171.png",
          large: "https://images.pokemontcg.io/sv6/171_hires.png",
        },
        flavorText:
          "Poltchageist looks like a regional form of Sinistea, but it was recently discovered that the two Pokémon are entirely unrelated.",
      },
    ],
  },
  {
    id: "sv6-21",
    name: "Poltchageist",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    attacks: [
      {
        name: "Tea Server",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put a Basic Grass Energy card from your discard pile into your hand.",
      },
      {
        name: "Surprise Attack",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    nationalPokedexNumbers: [1012],
    flavorText:
      "Poltchageist looks like a regional form of Sinistea, but it was recently discovered that the two Pokémon are entirely unrelated.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/21.png",
      large: "https://images.pokemontcg.io/sv6/21_hires.png",
    },
    altArts: [
      {
        id: "sv6-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/sv6/21.png",
          large: "https://images.pokemontcg.io/sv6/21_hires.png",
        },
        flavorText:
          "Poltchageist looks like a regional form of Sinistea, but it was recently discovered that the two Pokémon are entirely unrelated.",
      },
    ],
  },
  {
    id: "sv10-29",
    name: "Ponyta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Rapidash"],
    attacks: [
      {
        name: "Double Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "29",
    nationalPokedexNumbers: [77],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/29.png",
      large: "https://images.pokemontcg.io/sv10/29_hires.png",
    },
    altArts: [
      {
        id: "sv10-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/sv10/29.png",
          large: "https://images.pokemontcg.io/sv10/29_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-26",
    name: "Ponyta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Rapidash"],
    attacks: [
      {
        name: "Charge Energy",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Energy card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Flame Tail",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    flavorText:
      "It can't run properly when it's newly born. As it races around with others of its kind, its legs grow stronger.",
    nationalPokedexNumbers: [77],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/26.png",
      large: "https://images.pokemontcg.io/sv5/26_hires.png",
    },
    altArts: [
      {
        id: "sv5-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv5/26.png",
          large: "https://images.pokemontcg.io/sv5/26_hires.png",
        },
        flavorText:
          "It can't run properly when it's newly born. As it races around with others of its kind, its legs grow stronger.",
      },
    ],
  },
  {
    id: "sv7-19",
    name: "Ponyta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Rapidash"],
    attacks: [
      {
        name: "Flop",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "19",
    nationalPokedexNumbers: [77],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/19.png",
      large: "https://images.pokemontcg.io/sv7/19_hires.png",
    },
    altArts: [
      {
        id: "sv7-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv7/19.png",
          large: "https://images.pokemontcg.io/sv7/19_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-128",
    name: "Poochyena",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Gnaw Off",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "128",
    flavorText:
      "A Pokémon with a persistent nature, it chases its chosen prey until the prey becomes exhausted.",
    nationalPokedexNumbers: [261],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-128/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-128/large",
    },
    altArts: [
      {
        id: "me2pt5-128",
        number: "128",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-128/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-128/large",
        },
        flavorText:
          "A Pokémon with a persistent nature, it chases its chosen prey until the prey becomes exhausted.",
      },
      {
        id: "sv5-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/sv5/105.png",
          large: "https://images.pokemontcg.io/sv5/105_hires.png",
        },
        flavorText:
          "A Pokémon with a persistent nature, it chases its chosen prey until the prey becomes exhausted.",
      },
    ],
  },
  {
    id: "sv6-113",
    name: "Poochyena",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Mightyena"],
    attacks: [
      {
        name: "Continuous Steps",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip a coin until you get tails. This attack does 10 damage for each heads.",
      },
      {
        name: "Darkness Fang",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "113",
    flavorText:
      "Poochyena pursue their prey in packs. Once the prey is exhausted, the pack finishes it off. But sometimes the prey retaliates, and the pack flees.",
    nationalPokedexNumbers: [261],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/113.png",
      large: "https://images.pokemontcg.io/sv6/113_hires.png",
    },
    altArts: [
      {
        id: "sv6-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/sv6/113.png",
          large: "https://images.pokemontcg.io/sv6/113_hires.png",
        },
        flavorText:
          "Poochyena pursue their prey in packs. Once the prey is exhausted, the pack finishes it off. But sometimes the prey retaliates, and the pack flees.",
      },
    ],
  },
  {
    id: "me5-18",
    name: "Popplio",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Pound",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    flavorText:
      "The balloons it inflates with its nose grow larger and larger as it practices day by day.",
    nationalPokedexNumbers: [728],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-18/small",
      large: "https://images.scrydex.com/pokemon/me5-18/large",
    },
    altArts: [
      {
        id: "me5-18",
        number: "18",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-18/small",
          large: "https://images.scrydex.com/pokemon/me5-18/large",
        },
        flavorText:
          "The balloons it inflates with its nose grow larger and larger as it practices day by day.",
      },
    ],
  },
  {
    id: "me5-20",
    name: "Primarina",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "Brionne",
    abilities: [
      {
        name: "Enriching Melody",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Heal all damage from 1 of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Aqua Return",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "Shuffle this Pokémon and all attached cards into your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "20",
    flavorText:
      "Also known as a songstress, it is a sight to behold on moonlit nights when it sings in front of the colony it leads.",
    nationalPokedexNumbers: [730],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-20/small",
      large: "https://images.scrydex.com/pokemon/me5-20/large",
    },
    altArts: [
      {
        id: "me5-20",
        number: "20",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-20/small",
          large: "https://images.scrydex.com/pokemon/me5-20/large",
        },
        flavorText:
          "Also known as a songstress, it is a sight to behold on moonlit nights when it sings in front of the colony it leads.",
      },
      {
        id: "me5-88",
        number: "88",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-88/small",
          large: "https://images.scrydex.com/pokemon/me5-88/large",
        },
        flavorText:
          "Also known as a songstress, it is a sight to behold on moonlit nights when it sings in front of the colony it leads.",
      },
    ],
  },
  {
    id: "me5-43",
    name: "Primeape",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Mankey",
    attacks: [
      {
        name: "Corkscrew Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    flavorText:
      "Some researchers theorize that Primeape remains angry even when inside a Poké Ball.",
    nationalPokedexNumbers: [57],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-43/small",
      large: "https://images.scrydex.com/pokemon/me5-43/large",
    },
    altArts: [
      {
        id: "me5-43",
        number: "43",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-43/small",
          large: "https://images.scrydex.com/pokemon/me5-43/large",
        },
        flavorText:
          "Some researchers theorize that Primeape remains angry even when inside a Poké Ball.",
      },
    ],
  },
  {
    id: "sv10-91",
    name: "Primeape",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Mankey",
    attacks: [
      {
        name: "Drag Off",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot. This attack does 30 damage to the new Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "91",
    nationalPokedexNumbers: [57],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/91.png",
      large: "https://images.pokemontcg.io/sv10/91_hires.png",
    },
    altArts: [
      {
        id: "sv10-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv10/91.png",
          large: "https://images.pokemontcg.io/sv10/91_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-99",
    name: "Primeape",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fighting"],
    evolvesFrom: "Mankey",
    attacks: [
      {
        name: "Sweep the Leg",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
      {
        name: "Mega Punch",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "99",
    nationalPokedexNumbers: [57],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/99.png",
      large: "https://images.pokemontcg.io/sv8/99_hires.png",
    },
    altArts: [
      {
        id: "sv8-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv8/99.png",
          large: "https://images.pokemontcg.io/sv8/99_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-28",
    name: "Prinplup",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Piplup",
    evolvesTo: ["Empoleon"],
    attacks: [
      {
        name: "Peck",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Targeted Dive",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 70 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "28",
    flavorText:
      "It lives a solitary life. Its wings deliver wicked blows that can snap even the thickest of trees in half with a single hit.",
    nationalPokedexNumbers: [394],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/28.png",
      large: "https://images.pokemontcg.io/me2/28_hires.png",
    },
    altArts: [
      {
        id: "me2-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/me2/28.png",
          large: "https://images.pokemontcg.io/me2/28_hires.png",
        },
        flavorText:
          "It lives a solitary life. Its wings deliver wicked blows that can snap even the thickest of trees in half with a single hit.",
      },
    ],
  },
  {
    id: "me3-38",
    name: "Probopass",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Nosepass",
    attacks: [
      {
        name: "Rolling Rocks",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
      {
        name: "Obliterating Nose",
        cost: ["Fighting", "Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 4,
        damage: "260",
        text: "Discard 3 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "38",
    nationalPokedexNumbers: [476],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-38/small",
      large: "https://images.scrydex.com/pokemon/me3-38/large",
    },
    altArts: [
      {
        id: "me3-38",
        number: "38",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-38/small",
          large: "https://images.scrydex.com/pokemon/me3-38/large",
        },
        flavorText: "",
      },
      {
        id: "me3-96",
        number: "96",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-96/small",
          large: "https://images.scrydex.com/pokemon/me3-96/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-98",
    name: "Probopass",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Nosepass",
    attacks: [
      {
        name: "Power Gem",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Mountain Drop",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70+",
        text: "If a Stadium is in play, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "98",
    nationalPokedexNumbers: [476],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/98.png",
      large: "https://images.pokemontcg.io/sv10/98_hires.png",
    },
    altArts: [
      {
        id: "sv10-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv10/98.png",
          large: "https://images.pokemontcg.io/sv10/98_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-102",
    name: "Probopass",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Nosepass",
    attacks: [
      {
        name: "Assault Laser",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If your opponent's Active Pokémon has a Pokémon Tool attached, this attack does 80 more damage.",
      },
      {
        name: "Land Crush",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "102",
    flavorText:
      "Probopass radiates such a powerful magnetic field that nearby electrical appliances are rendered useless while it's around.",
    nationalPokedexNumbers: [476],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/102.png",
      large: "https://images.pokemontcg.io/sv6/102_hires.png",
    },
    altArts: [
      {
        id: "sv6-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/sv6/102.png",
          large: "https://images.pokemontcg.io/sv6/102_hires.png",
        },
        flavorText:
          "Probopass radiates such a powerful magnetic field that nearby electrical appliances are rendered useless while it's around.",
      },
      {
        id: "sv6-182",
        number: "182",
        images: {
          small: "https://images.pokemontcg.io/sv6/182.png",
          large: "https://images.pokemontcg.io/sv6/182_hires.png",
        },
        flavorText:
          "Probopass radiates such a powerful magnetic field that nearby electrical appliances are rendered useless while it's around.",
      },
    ],
  },
  {
    id: "me2pt5-39",
    name: "Psyduck",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    abilities: [
      {
        name: "Damp",
        text: "Pokémon in play (both yours and your opponent's) lose any Ability that requires the Pokémon using it to Knock Out itself.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    flavorText:
      "It is constantly wracked by a headache. When the headache turns intense, it begins using mysterious powers.",
    nationalPokedexNumbers: [54],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-39/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-39/large",
    },
    altArts: [
      {
        id: "me2pt5-39",
        number: "39",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-39/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-39/large",
        },
        flavorText:
          "It is constantly wracked by a headache. When the headache turns intense, it begins using mysterious powers.",
      },
      {
        id: "me2pt5-226",
        number: "226",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-226/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-226/large",
        },
        flavorText:
          "It is constantly wracked by a headache. When the headache turns intense, it begins using mysterious powers.",
      },
    ],
  },
  {
    id: "me4-40",
    name: "Pumpkaboo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "40",
    flavorText:
      "It was recently discovered that the different varieties of Pumpkaboo vary not only in size but also in the size of the souls they collect.",
    nationalPokedexNumbers: [710],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-40/small",
      large: "https://images.scrydex.com/pokemon/me4-40/large",
    },
    altArts: [
      {
        id: "me4-40",
        number: "40",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-40/small",
          large: "https://images.scrydex.com/pokemon/me4-40/large",
        },
        flavorText:
          "It was recently discovered that the different varieties of Pumpkaboo vary not only in size but also in the size of the souls they collect.",
      },
    ],
  },
  {
    id: "sv8pt5-48",
    name: "Pupitar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fighting"],
    evolvesFrom: "Larvitar",
    evolvesTo: ["Tyranitar"],
    attacks: [
      {
        name: "Sand Spray",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Hammer In",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "48",
    nationalPokedexNumbers: [247],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/48.png",
      large: "https://images.pokemontcg.io/sv8pt5/48_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/48.png",
          large: "https://images.pokemontcg.io/sv8pt5/48_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-81",
    name: "Pupitar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fighting"],
    evolvesFrom: "Larvitar",
    evolvesTo: ["Tyranitar"],
    attacks: [
      {
        name: "Take Down",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "81",
    nationalPokedexNumbers: [247],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/81.png",
      large: "https://images.pokemontcg.io/sv9/81_hires.png",
    },
    altArts: [
      {
        id: "sv9-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv9/81.png",
          large: "https://images.pokemontcg.io/sv9/81_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-55",
    name: "Purrloin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Liepard"],
    attacks: [
      {
        name: "Invite Evil",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Darkness Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    flavorText:
      "They steal from people for fun, but their victims can't help but forgive them. Their deceptively cute act is perfect.",
    nationalPokedexNumbers: [509],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/55.png",
      large: "https://images.pokemontcg.io/rsv10pt5/55_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/55.png",
          large: "https://images.pokemontcg.io/rsv10pt5/55_hires.png",
        },
        flavorText:
          "They steal from people for fun, but their victims can't help but forgive them. Their deceptively cute act is perfect.",
      },
      {
        id: "rsv10pt5-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/136.png",
          large: "https://images.pokemontcg.io/rsv10pt5/136_hires.png",
        },
        flavorText:
          "They steal from people for fun, but their victims can't help but forgive them. Their deceptively cute act is perfect.",
      },
    ],
  },
  {
    id: "sv7-117",
    name: "Purugly",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Glameow",
    attacks: [
      {
        name: "Nyan Roll",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "117",
    nationalPokedexNumbers: [432],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/117.png",
      large: "https://images.pokemontcg.io/sv7/117_hires.png",
    },
    altArts: [
      {
        id: "sv7-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/sv7/117.png",
          large: "https://images.pokemontcg.io/sv7/117_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-24",
    name: "Pyroar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fire"],
    evolvesFrom: "Litleo",
    abilities: [
      {
        name: "Intimidating Fang",
        text: "As long as this Pokémon is in the Active Spot, attacks used by your opponent's Active Pokémon do 30 less damage (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Searing Flame",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "24",
    nationalPokedexNumbers: [668],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/24.png",
      large: "https://images.pokemontcg.io/me1/24_hires.png",
    },
    altArts: [
      {
        id: "me1-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/me1/24.png",
          large: "https://images.pokemontcg.io/me1/24_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-16",
    name: "Pyroar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Litleo",
    attacks: [
      {
        name: "Fire Mane",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Flame Tackle",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "16",
    nationalPokedexNumbers: [668],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/16.png",
      large: "https://images.pokemontcg.io/sv8pt5/16_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/16.png",
          large: "https://images.pokemontcg.io/sv8pt5/16_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-156",
    name: "Quagsire",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Wooper",
    attacks: [
      {
        name: "Rollout",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Drenched Headbutt",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80×",
        text: "Discard the top 3 cards of your deck. This attack does 80 damage for each Energy card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "156",
    nationalPokedexNumbers: [195],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/156.png",
      large: "https://images.pokemontcg.io/svp/156_hires.png",
    },
    altArts: [
      {
        id: "svp-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/svp/156.png",
          large: "https://images.pokemontcg.io/svp/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-52",
    name: "Quaquaval",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Water"],
    evolvesFrom: "Quaxwell",
    abilities: [
      {
        name: "Up-Tempo",
        text: "You must put a card from your hand on the bottom of your deck in order to use this Ability. Once during your turn, you may draw cards until you have 5 cards in your hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hydro Splash",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "52",
    nationalPokedexNumbers: [914],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/52.png",
      large: "https://images.pokemontcg.io/sv8/52_hires.png",
    },
    altArts: [
      {
        id: "sv8-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv8/52.png",
          large: "https://images.pokemontcg.io/sv8/52_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-50",
    name: "Quaxly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    attacks: [
      {
        name: "Aerial Ace",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [912],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/50.png",
      large: "https://images.pokemontcg.io/sv8/50_hires.png",
    },
    altArts: [
      {
        id: "sv8-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv8/50.png",
          large: "https://images.pokemontcg.io/sv8/50_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-51",
    name: "Quaxwell",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Quaxly",
    attacks: [
      {
        name: "Aqua Edge",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    nationalPokedexNumbers: [913],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/51.png",
      large: "https://images.pokemontcg.io/sv8/51_hires.png",
    },
    altArts: [
      {
        id: "sv8-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv8/51.png",
          large: "https://images.pokemontcg.io/sv8/51_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-6",
    name: "Quilladin",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Chespin",
    attacks: [
      {
        name: "Leafy Charge",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Search your deck for a Basic Grass Energy card and attach it to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Vine Whip",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "6",
    flavorText:
      "They strengthen their lower bodies by running into one another. They are very kind and won't start fights.",
    nationalPokedexNumbers: [651],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-6/small",
      large: "https://images.scrydex.com/pokemon/me4-6/large",
    },
    altArts: [
      {
        id: "me4-6",
        number: "6",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-6/small",
          large: "https://images.scrydex.com/pokemon/me4-6/large",
        },
        flavorText:
          "They strengthen their lower bodies by running into one another. They are very kind and won't start fights.",
      },
    ],
  },
  {
    id: "me4-52",
    name: "Qwilfish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Darkness"],
    abilities: [
      {
        name: "Poison Point",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), the Attacking Pokémon is now Poisoned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Venoshock",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your opponent's Active Pokémon is Poisoned, this attack does 50 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    flavorText:
      "Experienced fishers say they try to catch Qwilfish in the brief moment that these Pokemon become defenseless just after launching poisonous spikes.",
    nationalPokedexNumbers: [211],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-52/small",
      large: "https://images.scrydex.com/pokemon/me4-52/large",
    },
    altArts: [
      {
        id: "me4-52",
        number: "52",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-52/small",
          large: "https://images.scrydex.com/pokemon/me4-52/large",
        },
        flavorText:
          "Experienced fishers say they try to catch Qwilfish in the brief moment that these Pokemon become defenseless just after launching poisonous spikes.",
      },
    ],
  },
  {
    id: "me1-27",
    name: "Raboot",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fire"],
    evolvesFrom: "Scorbunny",
    evolvesTo: ["Cinderace"],
    attacks: [
      {
        name: "Jumping Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 40 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "27",
    nationalPokedexNumbers: [814],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/27.png",
      large: "https://images.pokemontcg.io/me1/27_hires.png",
    },
    altArts: [
      {
        id: "me1-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/me1/27.png",
          large: "https://images.pokemontcg.io/me1/27_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-37",
    name: "Raboot",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fire"],
    evolvesFrom: "Scorbunny",
    attacks: [
      {
        name: "Low Sweep",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Combustion",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    flavorText:
      "While it prides itself on its varied kicking moves, it can also deliver powerful headbutts once its flames have heated up its forehead.",
    nationalPokedexNumbers: [814],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-37/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-37/large",
    },
    altArts: [
      {
        id: "me2pt5-37",
        number: "37",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-37/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-37/large",
        },
        flavorText:
          "While it prides itself on its varied kicking moves, it can also deliver powerful headbutts once its flames have heated up its forehead.",
      },
      {
        id: "sv7-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv7/27.png",
          large: "https://images.pokemontcg.io/sv7/27_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/sv7/147.png",
          large: "https://images.pokemontcg.io/sv7/147_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-24",
    name: "Rabsca",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Grass"],
    evolvesFrom: "Rellor",
    abilities: [
      {
        name: "Spherical Shield",
        text: "Prevent all damage from and effects of attacks from your opponent's Pokémon done to your Benched Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Psychic",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "This attack does 30 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    flavorText:
      "An infant sleeps inside the ball. Rabsca rolls the ball soothingly with its legs to ensure the infant sleeps comfortably.",
    nationalPokedexNumbers: [954],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/24.png",
      large: "https://images.pokemontcg.io/sv5/24_hires.png",
    },
    altArts: [
      {
        id: "sv5-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv5/24.png",
          large: "https://images.pokemontcg.io/sv5/24_hires.png",
        },
        flavorText:
          "An infant sleeps inside the ball. Rabsca rolls the ball soothingly with its legs to ensure the infant sleeps comfortably.",
      },
    ],
  },
  {
    id: "sv8-14",
    name: "Rabsca",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Grass"],
    evolvesFrom: "Rellor",
    attacks: [
      {
        name: "Triple Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 3 cards.",
      },
      {
        name: "Counterturn",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "40+",
        text: "If there are 3 or fewer cards in your deck, this attack does 200 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    nationalPokedexNumbers: [954],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/14.png",
      large: "https://images.pokemontcg.io/sv8/14_hires.png",
    },
    altArts: [
      {
        id: "sv8-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv8/14.png",
          large: "https://images.pokemontcg.io/sv8/14_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-25",
    name: "Rabsca ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "250",
    types: ["Grass"],
    evolvesFrom: "Rellor",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Upside-Down Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 3 cards from the bottom of your deck.",
      },
      {
        name: "Psychic",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20+",
        text: "This attack does 90 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "25",
    nationalPokedexNumbers: [954],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv10/25.png",
      large: "https://images.pokemontcg.io/sv10/25_hires.png",
    },
    altArts: [
      {
        id: "sv10-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv10/25.png",
          large: "https://images.pokemontcg.io/sv10/25_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-111",
    name: "Raging Bolt",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "130",
    types: ["Dragon"],
    attacks: [
      {
        name: "Thunderburst Storm",
        cost: ["Lightning", "Fighting"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 30 damage to 1 of your opponent's Pokémon for each Energy attached to this Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Dragon Headbutt",
        cost: ["Lightning", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "111",
    nationalPokedexNumbers: [1021],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/111.png",
      large: "https://images.pokemontcg.io/sv7/111_hires.png",
    },
    altArts: [
      {
        id: "sv7-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/sv7/111.png",
          large: "https://images.pokemontcg.io/sv7/111_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-123",
    name: "Raging Bolt ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Ancient"],
    hp: "240",
    types: ["Dragon"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Burst Roar",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard your hand and draw 6 cards.",
      },
      {
        name: "Bellowing Thunder",
        cost: ["Lightning", "Fighting"],
        convertedEnergyCost: 2,
        damage: "70×",
        text: "You may discard any amount of Basic Energy from your Pokémon. This attack does 70 damage for each card you discarded in this way.",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "123",
    nationalPokedexNumbers: [1021],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/123.png",
      large: "https://images.pokemontcg.io/sv5/123_hires.png",
    },
    altArts: [
      {
        id: "sv5-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/sv5/123.png",
          large: "https://images.pokemontcg.io/sv5/123_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-196",
        number: "196",
        images: {
          small: "https://images.pokemontcg.io/sv5/196.png",
          large: "https://images.pokemontcg.io/sv5/196_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-208",
        number: "208",
        images: {
          small: "https://images.pokemontcg.io/sv5/208.png",
          large: "https://images.pokemontcg.io/sv5/208_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-218",
        number: "218",
        images: {
          small: "https://images.pokemontcg.io/sv5/218.png",
          large: "https://images.pokemontcg.io/sv5/218_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/166.png",
          large: "https://images.pokemontcg.io/sv8pt5/166_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/svp/145.png",
          large: "https://images.pokemontcg.io/svp/145_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-56",
    name: "Raichu",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Lightning"],
    evolvesFrom: "Pikachu",
    attacks: [
      {
        name: "Quick Blow",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 50 more damage.",
      },
      {
        name: "Strong Volt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Discard a Lightning Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "56",
    flavorText:
      "When its electricity builds, its muscles are stimulated, and it becomes more aggressive than usual.",
    nationalPokedexNumbers: [26],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-56/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-56/large",
    },
    altArts: [
      {
        id: "me2pt5-56",
        number: "56",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-56/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-56/large",
        },
        flavorText:
          "When its electricity builds, its muscles are stimulated, and it becomes more aggressive than usual.",
      },
    ],
  },
  {
    id: "sv5-52",
    name: "Raichu",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Lightning"],
    evolvesFrom: "Pikachu",
    attacks: [
      {
        name: "Collateral Bolts",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 50 damage to each Pokémon that has any damage counters on it (both yours and your opponent's), except for this Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Electric Ball",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    flavorText:
      "If the electric pouches in its cheeks become fully charged, both ears will stand straight up.",
    nationalPokedexNumbers: [26],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/52.png",
      large: "https://images.pokemontcg.io/sv5/52_hires.png",
    },
    altArts: [
      {
        id: "sv5-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv5/52.png",
          large: "https://images.pokemontcg.io/sv5/52_hires.png",
        },
        flavorText:
          "If the electric pouches in its cheeks become fully charged, both ears will stand straight up.",
      },
    ],
  },
  {
    id: "me1-48",
    name: "Raikou",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Electro Fall",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If you have at least 4 Lightning Energy in play, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "48",
    nationalPokedexNumbers: [243],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/48.png",
      large: "https://images.pokemontcg.io/me1/48_hires.png",
    },
    altArts: [
      {
        id: "me1-48",
        number: "48",
        images: {
          small: "https://images.pokemontcg.io/me1/48.png",
          large: "https://images.pokemontcg.io/me1/48_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-50",
    name: "Raikou",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Lightning"],
    attacks: [
      {
        name: "Amazing Shot",
        cost: ["Grass", "Lightning", "Metal"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "This attack also does 120 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "50",
    nationalPokedexNumbers: [243],
    regulationMark: "D",
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-50/small",
      large: "https://images.scrydex.com/pokemon/me55c-50/large",
    },
    altArts: [
      {
        id: "me55c-50",
        number: "50",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-50/small",
          large: "https://images.scrydex.com/pokemon/me55c-50/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-58",
    name: "Ralts",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Kirlia"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Headbutt",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    nationalPokedexNumbers: [280],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/58.png",
      large: "https://images.pokemontcg.io/me1/58_hires.png",
    },
    altArts: [
      {
        id: "me1-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/me1/58.png",
          large: "https://images.pokemontcg.io/me1/58_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-87",
        number: "87",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-87/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-87/large",
        },
        flavorText:
          "The horns on its head provide a strong power that enables it to sense people’s emotions.",
      },
    ],
  },
  {
    id: "me5-45",
    name: "Rampardos ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "330",
    types: ["Fighting"],
    evolvesFrom: "Cranidos",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Destructive Headbutting",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may use this Ability. Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rowdy Hammer",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "150",
        text: "During your next turn, attacks used by this Pokémon do 150 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "45",
    nationalPokedexNumbers: [409],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-45/small",
      large: "https://images.scrydex.com/pokemon/me5-45/large",
    },
    altArts: [
      {
        id: "me5-45",
        number: "45",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-45/small",
          large: "https://images.scrydex.com/pokemon/me5-45/large",
        },
        flavorText: "",
      },
      {
        id: "me5-100",
        number: "100",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-100/small",
          large: "https://images.scrydex.com/pokemon/me5-100/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-30",
    name: "Rapidash",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fire"],
    evolvesFrom: "Ponyta",
    abilities: [
      {
        name: "Hurried Gait",
        text: "Once during your turn, you may draw a card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Fire Mane",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "30",
    nationalPokedexNumbers: [78],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/30.png",
      large: "https://images.pokemontcg.io/sv10/30_hires.png",
    },
    altArts: [
      {
        id: "sv10-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/sv10/30.png",
          large: "https://images.pokemontcg.io/sv10/30_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-189",
        number: "189",
        images: {
          small: "https://images.pokemontcg.io/sv10/189.png",
          large: "https://images.pokemontcg.io/sv10/189_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-27",
    name: "Rapidash",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Fire"],
    evolvesFrom: "Ponyta",
    attacks: [
      {
        name: "Combustion",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Inferno Onrush",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    number: "27",
    flavorText:
      "This Pokémon can be seen galloping through fields at speeds of up to 150 mph, its fiery mane fluttering in the wind.",
    nationalPokedexNumbers: [78],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/27.png",
      large: "https://images.pokemontcg.io/sv5/27_hires.png",
    },
    altArts: [
      {
        id: "sv5-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv5/27.png",
          large: "https://images.pokemontcg.io/sv5/27_hires.png",
        },
        flavorText:
          "This Pokémon can be seen galloping through fields at speeds of up to 150 mph, its fiery mane fluttering in the wind.",
      },
    ],
  },
  {
    id: "sv7-20",
    name: "Rapidash",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Ponyta",
    attacks: [
      {
        name: "Burning Run",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "Flip a coin. If heads, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "20",
    nationalPokedexNumbers: [78],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/20.png",
      large: "https://images.pokemontcg.io/sv7/20_hires.png",
    },
    altArts: [
      {
        id: "sv7-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv7/20.png",
          large: "https://images.pokemontcg.io/sv7/20_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-61",
    name: "Raticate",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Rattata",
    attacks: [
      {
        name: "Scrape Off",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon.",
      },
      {
        name: "Retaliatory Incisors",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40×",
        text: "This attack does 40 damage for each damage counter on all of your Benched Rattata.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "61",
    nationalPokedexNumbers: [20],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-61/small",
      large: "https://images.scrydex.com/pokemon/me3-61/large",
    },
    altArts: [
      {
        id: "me3-61",
        number: "61",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-61/small",
          large: "https://images.scrydex.com/pokemon/me3-61/large",
        },
        flavorText: "",
      },
      {
        id: "me3-99",
        number: "99",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-99/small",
          large: "https://images.scrydex.com/pokemon/me3-99/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-60",
    name: "Rattata",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Colorless"],
    attacks: [
      {
        name: "Take Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "60",
    nationalPokedexNumbers: [19],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-60/small",
      large: "https://images.scrydex.com/pokemon/me3-60/large",
    },
    altArts: [
      {
        id: "me3-60",
        number: "60",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-60/small",
          large: "https://images.scrydex.com/pokemon/me3-60/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-153",
    name: "Rayquaza",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Dragon"],
    attacks: [
      {
        name: "Breakthrough Assault",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "If this Pokémon moved from your Bench to the Active Spot this turn, this attack does 90 more damage.",
      },
      {
        name: "Dragon Claw",
        cost: ["Fire", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "153",
    flavorText:
      "It lives in the ozone layer far above the clouds and cannot be seen from the ground.",
    nationalPokedexNumbers: [384],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-153/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-153/large",
    },
    altArts: [
      {
        id: "me2pt5-153",
        number: "153",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-153/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-153/large",
        },
        flavorText:
          "It lives in the ozone layer far above the clouds and cannot be seen from the ground.",
      },
    ],
  },
  {
    id: "me55c-85",
    name: "Rayquaza-EX",
    supertype: "Pokémon",
    subtypes: ["Basic", "EX"],
    hp: "170",
    types: ["Dragon"],
    rules: [
      "When a Pokémon-EX has been Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Celestial Roar",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Discard the top 3 cards of your deck. If any of those cards are Energy cards, attach them to this Pokémon.",
      },
      {
        name: "Dragon Burst",
        cost: ["Fire", "Lightning"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: "Discard all basic Fire Energy or all basic Lightning Energy attached to this Pokémon. This attack does 60 damage times the number of Energy cards you discarded.",
      },
    ],
    weaknesses: [
      {
        type: "Dragon",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "85",
    nationalPokedexNumbers: [384],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-85/small",
      large: "https://images.scrydex.com/pokemon/me55c-85/large",
    },
    altArts: [
      {
        id: "me55c-85",
        number: "85",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-85/small",
          large: "https://images.scrydex.com/pokemon/me55c-85/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-42",
    name: "Regice",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Water"],
    attacks: [
      {
        name: "Icicle",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Blizzard",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "This attack also does 10 damage to each of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "42",
    nationalPokedexNumbers: [378],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/42.png",
      large: "https://images.pokemontcg.io/sv9/42_hires.png",
    },
    altArts: [
      {
        id: "sv9-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/sv9/42.png",
          large: "https://images.pokemontcg.io/sv9/42_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-48",
    name: "Regice ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Regi Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 2 Basic Water Energy cards from your discard pile to this Pokémon.",
      },
      {
        name: "Ice Prison",
        cost: ["Water", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "Discard 2 Energy from this Pokémon, and your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "48",
    nationalPokedexNumbers: [378],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-48/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-48/large",
    },
    altArts: [
      {
        id: "me2pt5-48",
        number: "48",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-48/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-48/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-86",
    name: "Regigigas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "160",
    types: ["Colorless"],
    attacks: [
      {
        name: "Jewel Breaker",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100+",
        text: "If your opponent's Active Pokémon is a Tera Pokémon, this attack does 230 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "86",
    nationalPokedexNumbers: [486],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/86.png",
      large: "https://images.pokemontcg.io/sv8pt5/86_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/86.png",
          large: "https://images.pokemontcg.io/sv8pt5/86_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-82",
    name: "Regirock",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    abilities: [
      {
        name: "Rock Armor",
        text: "If this Pokémon has any Energy attached, it takes 30 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Breaching Lariat",
        cost: ["Fighting", "Fighting", "Fighting"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "82",
    nationalPokedexNumbers: [377],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/82.png",
      large: "https://images.pokemontcg.io/sv9/82_hires.png",
    },
    altArts: [
      {
        id: "sv9-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv9/82.png",
          large: "https://images.pokemontcg.io/sv9/82_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-107",
    name: "Regirock ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Fighting"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Regi Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 2 Basic Fighting Energy cards from your discard pile to this Pokémon.",
      },
      {
        name: "Giant Rock",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140+",
        text: "If your opponent's Active Pokémon is a Stage 2 Pokémon, this attack does 140 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "107",
    nationalPokedexNumbers: [377],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-107/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-107/large",
    },
    altArts: [
      {
        id: "me2pt5-107",
        number: "107",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-107/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-107/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-101",
        number: "101",
        images: {
          small: "https://images.pokemontcg.io/sv10/101.png",
          large: "https://images.pokemontcg.io/sv10/101_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-214",
        number: "214",
        images: {
          small: "https://images.pokemontcg.io/sv10/214.png",
          large: "https://images.pokemontcg.io/sv10/214_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-125",
    name: "Registeel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Raging Hammer",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "This attack does 10 more damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "125",
    nationalPokedexNumbers: [379],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/125.png",
      large: "https://images.pokemontcg.io/sv8/125_hires.png",
    },
    altArts: [
      {
        id: "sv8-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/sv8/125.png",
          large: "https://images.pokemontcg.io/sv8/125_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-145",
    name: "Registeel ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Metal"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Regi Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach up to 2 Basic Metal Energy cards from your discard pile to this Pokémon.",
      },
      {
        name: "Protecting Steel",
        cost: ["Metal", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "During your opponent's next turn, this Pokémon takes 50 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "145",
    nationalPokedexNumbers: [379],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-145/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-145/large",
    },
    altArts: [
      {
        id: "me2pt5-145",
        number: "145",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-145/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-145/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-17",
    name: "Relicanth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Water"],
    attacks: [
      {
        name: "Fossil Beatdown",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: 'This attack does 30 more damage for each of your Benched Pokémon that has "Antique" in its name.',
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "17",
    flavorText:
      "Rock-hard scales and oil-filled swim bladders allow this Pokémon to survive the intense water pressure of the deep sea.",
    nationalPokedexNumbers: [369],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-17/small",
      large: "https://images.scrydex.com/pokemon/me5-17/large",
    },
    altArts: [
      {
        id: "me5-17",
        number: "17",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-17/small",
          large: "https://images.scrydex.com/pokemon/me5-17/large",
        },
        flavorText:
          "Rock-hard scales and oil-filled swim bladders allow this Pokémon to survive the intense water pressure of the deep sea.",
      },
    ],
  },
  {
    id: "sv5-84",
    name: "Relicanth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Fighting"],
    abilities: [
      {
        name: "Memory Dive",
        text: "Each of your evolved Pokémon can use any attack from its previous Evolutions. (You still need the necessary Energy to use each attack.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Razor Fin",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "84",
    flavorText:
      "Rock-hard scales and oil-filled swim bladders allow this Pokémon to survive the intense water pressure of the deep sea.",
    nationalPokedexNumbers: [369],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/84.png",
      large: "https://images.pokemontcg.io/sv5/84_hires.png",
    },
    altArts: [
      {
        id: "sv5-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv5/84.png",
          large: "https://images.pokemontcg.io/sv5/84_hires.png",
        },
        flavorText:
          "Rock-hard scales and oil-filled swim bladders allow this Pokémon to survive the intense water pressure of the deep sea.",
      },
      {
        id: "sv5-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/sv5/173.png",
          large: "https://images.pokemontcg.io/sv5/173_hires.png",
        },
        flavorText:
          "Rock-hard scales and oil-filled swim bladders allow this Pokémon to survive the intense water pressure of the deep sea.",
      },
    ],
  },
  {
    id: "sv10-24",
    name: "Rellor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Rollout",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    nationalPokedexNumbers: [953],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv10/24.png",
      large: "https://images.pokemontcg.io/sv10/24_hires.png",
    },
    altArts: [
      {
        id: "sv10-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv10/24.png",
          large: "https://images.pokemontcg.io/sv10/24_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/sv8/13.png",
          large: "https://images.pokemontcg.io/sv8/13_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-23",
    name: "Rellor",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    attacks: [
      {
        name: "Slight Intrusion",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "23",
    flavorText:
      "It rolls its mud ball around while the energy it needs for evolution matures. Eventually the time comes for it to evolve.",
    nationalPokedexNumbers: [953],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/23.png",
      large: "https://images.pokemontcg.io/sv5/23_hires.png",
    },
    altArts: [
      {
        id: "sv5-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv5/23.png",
          large: "https://images.pokemontcg.io/sv5/23_hires.png",
        },
        flavorText:
          "It rolls its mud ball around while the energy it needs for evolution matures. Eventually the time comes for it to evolve.",
      },
    ],
  },
  {
    id: "me4-16",
    name: "Remoraid",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Sharp Fin",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    flavorText:
      "The water they shoot from their mouths can hit moving prey from more than 300 feet away.",
    nationalPokedexNumbers: [223],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-16/small",
      large: "https://images.scrydex.com/pokemon/me4-16/large",
    },
    altArts: [
      {
        id: "me4-16",
        number: "16",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-16/small",
          large: "https://images.scrydex.com/pokemon/me4-16/large",
        },
        flavorText:
          "The water they shoot from their mouths can hit moving prey from more than 300 feet away.",
      },
    ],
  },
  {
    id: "sv9-33",
    name: "Remoraid",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Octillery"],
    attacks: [
      {
        name: "Flail",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "This attack does 10 damage for each damage counter on this Pokémon.",
      },
      {
        name: "Rain Splash",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    nationalPokedexNumbers: [223],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/33.png",
      large: "https://images.pokemontcg.io/sv9/33_hires.png",
    },
    altArts: [
      {
        id: "sv9-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/sv9/33.png",
          large: "https://images.pokemontcg.io/sv9/33_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-17",
    name: "Reshiram",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Combustion",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Burning Flare",
        cost: ["Fire", "Fire", "Fire", "Fire"],
        convertedEnergyCost: 4,
        damage: "240",
        text: "This Pokémon also does 60 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "17",
    flavorText:
      "According to myth, if people ignore truth and let themselves become consumed by greed, Reshiram will arrive to burn their kingdoms down.",
    nationalPokedexNumbers: [643],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/17.png",
      large: "https://images.pokemontcg.io/me2/17_hires.png",
    },
    altArts: [
      {
        id: "me2-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/me2/17.png",
          large: "https://images.pokemontcg.io/me2/17_hires.png",
        },
        flavorText:
          "According to myth, if people ignore truth and let themselves become consumed by greed, Reshiram will arrive to burn their kingdoms down.",
      },
    ],
  },
  {
    id: "me55-14",
    name: "Reshiram",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Slash",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
      },
      {
        name: "Laser Flame",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If this Pokémon has any Lightning Energy attached, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "14",
    nationalPokedexNumbers: [643],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-14/small",
      large: "https://images.scrydex.com/pokemon/me55-14/large",
    },
    altArts: [
      {
        id: "me55-14",
        number: "14",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-14/small",
          large: "https://images.scrydex.com/pokemon/me55-14/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-22",
    name: "Reshiram",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Heat Blast",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "22",
    nationalPokedexNumbers: [643],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/22.png",
      large: "https://images.pokemontcg.io/sv7/22_hires.png",
    },
    altArts: [
      {
        id: "sv7-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/sv7/22.png",
          large: "https://images.pokemontcg.io/sv7/22_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-20",
    name: "Reshiram ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Fire"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Slash",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Blazing Burst",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130+",
        text: "This attack does 50 more damage for each Prize card your opponent has taken. Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "20",
    nationalPokedexNumbers: [643],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/20.png",
      large: "https://images.pokemontcg.io/rsv10pt5/20_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/20.png",
          large: "https://images.pokemontcg.io/rsv10pt5/20_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/158.png",
          large: "https://images.pokemontcg.io/rsv10pt5/158_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/166.png",
          large: "https://images.pokemontcg.io/rsv10pt5/166_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/173.png",
          large: "https://images.pokemontcg.io/rsv10pt5/173_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-30",
    name: "Reshiram ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "220",
    types: ["Fire"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Fire Wing",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Scorching Fire",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "30",
    nationalPokedexNumbers: [643],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/30.png",
      large: "https://images.pokemontcg.io/sv9/30_hires.png",
    },
    altArts: [
      {
        id: "sv9-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/sv9/30.png",
          large: "https://images.pokemontcg.io/sv9/30_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-39",
    name: "Reuniclus",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Duosion",
    attacks: [
      {
        name: "Cellular Ascension",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "For each of your Benched Pokémon, search your deck for a card that evolves from that Pokémon and put it onto that Pokémon to evolve it. Then, shuffle your deck.",
      },
      {
        name: "Evo-Lariat",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40+",
        text: "This attack does 40 more damage for each of your Evolution Pokémon in play.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    flavorText:
      "When Reuniclus shake hands, a network forms between their brains, increasing their psychic power.",
    nationalPokedexNumbers: [579],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/39.png",
      large: "https://images.pokemontcg.io/zsv10pt5/39_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/39.png",
          large: "https://images.pokemontcg.io/zsv10pt5/39_hires.png",
        },
        flavorText:
          "When Reuniclus shake hands, a network forms between their brains, increasing their psychic power.",
      },
    ],
  },
  {
    id: "sv5-72",
    name: "Reuniclus",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Duosion",
    attacks: [
      {
        name: "Summoning Gate",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top 8 cards of your deck. You may put any number of Pokémon you find there onto your Bench. Shuffle the other cards back into your deck.",
      },
      {
        name: "Brain Shake",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "72",
    flavorText:
      "While it could use its psychic abilities in battle, this Pokémon prefers to swing its powerful arms around to beat opponents into submission.",
    nationalPokedexNumbers: [579],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/72.png",
      large: "https://images.pokemontcg.io/sv5/72_hires.png",
    },
    altArts: [
      {
        id: "sv5-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv5/72.png",
          large: "https://images.pokemontcg.io/sv5/72_hires.png",
        },
        flavorText:
          "While it could use its psychic abilities in battle, this Pokémon prefers to swing its powerful arms around to beat opponents into submission.",
      },
      {
        id: "sv5-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/sv5/171.png",
          large: "https://images.pokemontcg.io/sv5/171_hires.png",
        },
        flavorText:
          "While it could use its psychic abilities in battle, this Pokémon prefers to swing its powerful arms around to beat opponents into submission.",
      },
    ],
  },
  {
    id: "sv6-125",
    name: "Revavroom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Metal"],
    evolvesFrom: "Varoom",
    attacks: [
      {
        name: "Rally Back",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 90 more damage.",
      },
      {
        name: "Running Charge",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100×",
        text: "Flip a coin until you get tails. This attack does 100 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "125",
    flavorText:
      "Revavroom viciously threatens others with the sound of its exhaust. It sticks its tongue out from its cylindrical mouth and sprays toxic fluids.",
    nationalPokedexNumbers: [966],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/125.png",
      large: "https://images.pokemontcg.io/sv6/125_hires.png",
    },
    altArts: [
      {
        id: "sv6-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/sv6/125.png",
          large: "https://images.pokemontcg.io/sv6/125_hires.png",
        },
        flavorText:
          "Revavroom viciously threatens others with the sound of its exhaust. It sticks its tongue out from its cylindrical mouth and sprays toxic fluids.",
      },
    ],
  },
  {
    id: "sv7-109",
    name: "Revavroom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Metal"],
    evolvesFrom: "Varoom",
    attacks: [
      {
        name: "Outta-Control Dash",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "109",
    nationalPokedexNumbers: [966],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/109.png",
      large: "https://images.pokemontcg.io/sv7/109_hires.png",
    },
    altArts: [
      {
        id: "sv7-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/sv7/109.png",
          large: "https://images.pokemontcg.io/sv7/109_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-15",
    name: "Revavroom ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "280",
    types: ["Lightning"],
    evolvesFrom: "Varoom",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Accelerator Flash",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If this Pokémon moved from your Bench to the Active Spot this turn, this attack does 120 more damage.",
      },
      {
        name: "Shattering Speed",
        cost: ["Metal", "Metal", "Metal"],
        convertedEnergyCost: 3,
        damage: "250",
        text: "Discard this Pokémon and all attached cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    nationalPokedexNumbers: [966],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/15.png",
      large: "https://images.pokemontcg.io/sv6pt5/15_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/15.png",
          large: "https://images.pokemontcg.io/sv6pt5/15_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/81.png",
          large: "https://images.pokemontcg.io/sv6pt5/81_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-75",
    name: "Rhydon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fighting"],
    evolvesFrom: "Rhyhorn",
    evolvesTo: ["Rhyperior"],
    attacks: [
      {
        name: "Destructive Horn",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "75",
    nationalPokedexNumbers: [112],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/75.png",
      large: "https://images.pokemontcg.io/sv7/75_hires.png",
    },
    altArts: [
      {
        id: "sv7-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv7/75.png",
          large: "https://images.pokemontcg.io/sv7/75_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-74",
    name: "Rhyhorn",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Fighting"],
    evolvesTo: ["Rhydon"],
    attacks: [
      {
        name: "Horn Attack",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "74",
    nationalPokedexNumbers: [111],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/74.png",
      large: "https://images.pokemontcg.io/sv7/74_hires.png",
    },
    altArts: [
      {
        id: "sv7-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv7/74.png",
          large: "https://images.pokemontcg.io/sv7/74_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-76",
    name: "Rhyperior",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "200",
    types: ["Fighting"],
    evolvesFrom: "Rhydon",
    abilities: [
      {
        name: "Wide Wall",
        text: "As long as this Pokémon is in the Active Spot, whenever your opponent plays a Supporter card from their hand, prevent all effects of that card done to all of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Drill Run",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "76",
    nationalPokedexNumbers: [464],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/76.png",
      large: "https://images.pokemontcg.io/sv7/76_hires.png",
    },
    altArts: [
      {
        id: "sv7-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv7/76.png",
          large: "https://images.pokemontcg.io/sv7/76_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-76",
    name: "Ribombee",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Psychic"],
    evolvesFrom: "Cutiefly",
    attacks: [
      {
        name: "Plentiful Pollen",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your next turn, if the Defending Pokémon is Knocked Out, take 2 more Prize cards.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    number: "76",
    flavorText:
      "It makes pollen puffs from pollen and nectar. The puffs' effects depend on the type of ingredients and how much of each one is used.",
    nationalPokedexNumbers: [743],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/76.png",
      large: "https://images.pokemontcg.io/sv5/76_hires.png",
    },
    altArts: [
      {
        id: "sv5-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv5/76.png",
          large: "https://images.pokemontcg.io/sv5/76_hires.png",
        },
        flavorText:
          "It makes pollen puffs from pollen and nectar. The puffs' effects depend on the type of ingredients and how much of each one is used.",
      },
    ],
  },
  {
    id: "sv6-16",
    name: "Rillaboom",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Grass"],
    evolvesFrom: "Thwackey",
    attacks: [
      {
        name: "Drum Beating",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon cost Colorless more, and its Retreat Cost is Colorless more.",
      },
      {
        name: "Wood Hammer",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "180",
        text: "This Pokémon also does 50 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "16",
    flavorText:
      "By drumming, it taps into the power of its special tree stump. The roots of the stump follow its direction in battle.",
    nationalPokedexNumbers: [812],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/16.png",
      large: "https://images.pokemontcg.io/sv6/16_hires.png",
    },
    altArts: [
      {
        id: "sv6-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv6/16.png",
          large: "https://images.pokemontcg.io/sv6/16_hires.png",
        },
        flavorText:
          "By drumming, it taps into the power of its special tree stump. The roots of the stump follow its direction in battle.",
      },
    ],
  },
  {
    id: "me1-76",
    name: "Riolu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Lucario"],
    attacks: [
      {
        name: "Accelerating Stab",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your next turn, this Pokémon can't use Accelerating Stab.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "76",
    nationalPokedexNumbers: [447],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/76.png",
      large: "https://images.pokemontcg.io/me1/76_hires.png",
    },
    altArts: [
      {
        id: "me1-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/me1/76.png",
          large: "https://images.pokemontcg.io/me1/76_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-112",
        number: "112",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-112/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-112/large",
        },
        flavorText:
          "They communicate with one another using their auras. They are able to run all through the night.",
      },
    ],
  },
  {
    id: "sv7-81",
    name: "Riolu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Lucario"],
    attacks: [
      {
        name: "Punch",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "81",
    nationalPokedexNumbers: [447],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/81.png",
      large: "https://images.pokemontcg.io/sv7/81_hires.png",
    },
    altArts: [
      {
        id: "sv7-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv7/81.png",
          large: "https://images.pokemontcg.io/sv7/81_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-50",
    name: "Riolu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Lucario"],
    attacks: [
      {
        name: "Quick Attack",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [447],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/50.png",
      large: "https://images.pokemontcg.io/sv8pt5/50_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/50.png",
          large: "https://images.pokemontcg.io/sv8pt5/50_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-109",
    name: "Roaring Moon",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "140",
    types: ["Darkness"],
    attacks: [
      {
        name: "Vengeance Fletching",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "70+",
        text: "This attack does 10 more damage for each Ancient card in your discard pile.",
      },
      {
        name: "Speed Wing",
        cost: ["Darkness", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "109",
    flavorText:
      "It is possible that this is the creature listed as Roaring Moon in an expedition journal that still holds many mysteries.",
    nationalPokedexNumbers: [1005],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/109.png",
      large: "https://images.pokemontcg.io/sv5/109_hires.png",
    },
    altArts: [
      {
        id: "sv5-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/sv5/109.png",
          large: "https://images.pokemontcg.io/sv5/109_hires.png",
        },
        flavorText:
          "It is possible that this is the creature listed as Roaring Moon in an expedition journal that still holds many mysteries.",
      },
      {
        id: "sv8pt5-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/65.png",
          large: "https://images.pokemontcg.io/sv8pt5/65_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-89",
    name: "Rockruff",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Lycanroc"],
    attacks: [
      {
        name: "Paw Shake Punch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "89",
    flavorText:
      "This Pokémon is very friendly when it's young. Its disposition becomes vicious once it matures, but it never forgets the kindness of its master.",
    nationalPokedexNumbers: [744],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/89.png",
      large: "https://images.pokemontcg.io/sv5/89_hires.png",
    },
    altArts: [
      {
        id: "sv5-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/sv5/89.png",
          large: "https://images.pokemontcg.io/sv5/89_hires.png",
        },
        flavorText:
          "This Pokémon is very friendly when it's young. Its disposition becomes vicious once it matures, but it never forgets the kindness of its master.",
      },
    ],
  },
  {
    id: "sv9-84",
    name: "Rockruff",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Lycanroc"],
    attacks: [
      {
        name: "Dig It Up",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top card of your deck. You may discard that card.",
      },
      {
        name: "Stampede",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "84",
    nationalPokedexNumbers: [744],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/84.png",
      large: "https://images.pokemontcg.io/sv9/84_hires.png",
    },
    altArts: [
      {
        id: "sv9-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv9/84.png",
          large: "https://images.pokemontcg.io/sv9/84_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-46",
    name: "Roggenrola",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Boldore"],
    attacks: [
      {
        name: "Harden",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks if that damage is 40 or less.",
      },
      {
        name: "Rolling Rocks",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    flavorText:
      "Its ear is hexagonal in shape. Compressed underground, its body is as hard as steel.",
    nationalPokedexNumbers: [524],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/46.png",
      large: "https://images.pokemontcg.io/rsv10pt5/46_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/46.png",
          large: "https://images.pokemontcg.io/rsv10pt5/46_hires.png",
        },
        flavorText:
          "Its ear is hexagonal in shape. Compressed underground, its body is as hard as steel.",
      },
      {
        id: "rsv10pt5-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/127.png",
          large: "https://images.pokemontcg.io/rsv10pt5/127_hires.png",
        },
        flavorText:
          "Its ear is hexagonal in shape. Compressed underground, its body is as hard as steel.",
      },
    ],
  },
  {
    id: "me2pt5-118",
    name: "Rolycoly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    attacks: [
      {
        name: "Mud-Slap",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "118",
    flavorText:
      "Chunks of the surface of this Pokémon’s body that have grown old and flaked off have long been used for fuel as an alternative to coal.",
    nationalPokedexNumbers: [837],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-118/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-118/large",
    },
    altArts: [
      {
        id: "me2pt5-118",
        number: "118",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-118/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-118/large",
        },
        flavorText:
          "Chunks of the surface of this Pokémon’s body that have grown old and flaked off have long been used for fuel as an alternative to coal.",
      },
    ],
  },
  {
    id: "sv5-93",
    name: "Rolycoly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Carkol"],
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Power Gem",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "93",
    flavorText:
      "On sunny days, Rolycoly will come out onto grassy plains and roll around. Then it will eat the grass that gets tangled in its wheel-like leg.",
    nationalPokedexNumbers: [837],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/93.png",
      large: "https://images.pokemontcg.io/sv5/93_hires.png",
    },
    altArts: [
      {
        id: "sv5-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/sv5/93.png",
          large: "https://images.pokemontcg.io/sv5/93_hires.png",
        },
        flavorText:
          "On sunny days, Rolycoly will come out onto grassy plains and roll around. Then it will eat the grass that gets tangled in its wheel-like leg.",
      },
    ],
  },
  {
    id: "sv5-8",
    name: "Roselia",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Roserade"],
    abilities: [
      {
        name: "Poison Point",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), the Attacking Pokémon is now Poisoned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Leaf Step",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    flavorText:
      "Its flowers give off a relaxing fragrance. The stronger its aroma, the healthier the Roselia is.",
    nationalPokedexNumbers: [315],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/8.png",
      large: "https://images.pokemontcg.io/sv5/8_hires.png",
    },
    altArts: [
      {
        id: "sv5-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv5/8.png",
          large: "https://images.pokemontcg.io/sv5/8_hires.png",
        },
        flavorText:
          "Its flowers give off a relaxing fragrance. The stronger its aroma, the healthier the Roselia is.",
      },
    ],
  },
  {
    id: "sv5-9",
    name: "Roserade",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Roselia",
    abilities: [
      {
        name: "Poison Point",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), the Attacking Pokémon is now Poisoned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bind Down",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "9",
    flavorText:
      "After captivating opponents with its sweet scent, it lashes them with its thorny whips.",
    nationalPokedexNumbers: [407],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/9.png",
      large: "https://images.pokemontcg.io/sv5/9_hires.png",
    },
    altArts: [
      {
        id: "sv5-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv5/9.png",
          large: "https://images.pokemontcg.io/sv5/9_hires.png",
        },
        flavorText:
          "After captivating opponents with its sweet scent, it lashes them with its thorny whips.",
      },
    ],
  },
  {
    id: "me2pt5-92",
    name: "Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Roto Call",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: 'You may search your deck for any number of Pokémon that have "Rotom" in their name and put them onto your Bench. Then, shuffle your deck.',
      },
      {
        name: "Gadget Show",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each Pokémon Tool attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "92",
    flavorText:
      "Research continues on this Pokémon, which could be the power source of a unique motor.",
    nationalPokedexNumbers: [479],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-92/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-92/large",
    },
    altArts: [
      {
        id: "me2pt5-92",
        number: "92",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-92/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-92/large",
        },
        flavorText:
          "Research continues on this Pokémon, which could be the power source of a unique motor.",
      },
    ],
  },
  {
    id: "sv10-77",
    name: "Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Astonish",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Choose a random card from your opponent's hand. Your opponent reveals that card and shuffles it into their deck.",
      },
      {
        name: "Gadget Show",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each Pokémon Tool attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "77",
    nationalPokedexNumbers: [479],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/77.png",
      large: "https://images.pokemontcg.io/sv10/77_hires.png",
    },
    altArts: [
      {
        id: "sv10-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv10/77.png",
          large: "https://images.pokemontcg.io/sv10/77_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-197",
        number: "197",
        images: {
          small: "https://images.pokemontcg.io/sv10/197.png",
          large: "https://images.pokemontcg.io/sv10/197_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-61",
    name: "Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Lightning"],
    attacks: [
      {
        name: "Crushing Pulse",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent reveals their hand. Discard all Item cards and Pokémon Tool cards you find there.",
      },
      {
        name: "Energy Short",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "61",
    nationalPokedexNumbers: [479],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/61.png",
      large: "https://images.pokemontcg.io/sv8/61_hires.png",
    },
    altArts: [
      {
        id: "sv8-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv8/61.png",
          large: "https://images.pokemontcg.io/sv8/61_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-29",
    name: "Rotom ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Lightning"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Multi Adapter",
        text: 'Each of your Pokémon that has "Rotom" in its name may have up to 2 Pokémon Tool cards attached. If this Ability goes away, discard Pokémon Tools from those Pokémon until only 1 remains on each.',
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Thunderbolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "29",
    nationalPokedexNumbers: [479],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/29.png",
      large: "https://images.pokemontcg.io/me2/29_hires.png",
    },
    altArts: [
      {
        id: "me2-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/me2/29.png",
          large: "https://images.pokemontcg.io/me2/29_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/me2/111.png",
          large: "https://images.pokemontcg.io/me2/111_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/me2/126.png",
          large: "https://images.pokemontcg.io/me2/126_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-10",
    name: "Rowlet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    attacks: [
      {
        name: "Find a Friend",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "10",
    nationalPokedexNumbers: [722],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-10/small",
      large: "https://images.scrydex.com/pokemon/me3-10/large",
    },
    altArts: [
      {
        id: "me3-10",
        number: "10",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-10/small",
          large: "https://images.scrydex.com/pokemon/me3-10/large",
        },
        flavorText: "",
      },
      {
        id: "me3-90",
        number: "90",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-90/small",
          large: "https://images.scrydex.com/pokemon/me3-90/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-3",
    name: "Rowlet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Dartrix"],
    attacks: [
      {
        name: "Add On",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Leafage",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    nationalPokedexNumbers: [722],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/3.png",
      large: "https://images.pokemontcg.io/sv6pt5/3_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/3.png",
          large: "https://images.pokemontcg.io/sv6pt5/3_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-77",
    name: "Rufflet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Braviary"],
    attacks: [
      {
        name: "Peck",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Glide",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "77",
    flavorText:
      "They crush berries with their talons. They bravely stand up to any opponent, no matter how strong it is.",
    nationalPokedexNumbers: [627],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/77.png",
      large: "https://images.pokemontcg.io/zsv10pt5/77_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/77.png",
          large: "https://images.pokemontcg.io/zsv10pt5/77_hires.png",
        },
        flavorText:
          "They crush berries with their talons. They bravely stand up to any opponent, no matter how strong it is.",
      },
      {
        id: "zsv10pt5-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/154.png",
          large: "https://images.pokemontcg.io/zsv10pt5/154_hires.png",
        },
        flavorText:
          "They crush berries with their talons. They bravely stand up to any opponent, no matter how strong it is.",
      },
    ],
  },
  {
    id: "sv8-152",
    name: "Rufflet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Braviary"],
    attacks: [
      {
        name: "Flap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "152",
    nationalPokedexNumbers: [627],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/152.png",
      large: "https://images.pokemontcg.io/sv8/152_hires.png",
    },
    altArts: [
      {
        id: "sv8-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/sv8/152.png",
          large: "https://images.pokemontcg.io/sv8/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-59",
    name: "Sableye",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    attacks: [
      {
        name: "Cocky Claw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If you have any Stage 2 Darkness Pokémon on your Bench, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "59",
    flavorText:
      "It dwells in the darkness of caves. It uses its sharp claws to dig up gems to nourish itself.",
    nationalPokedexNumbers: [302],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/59.png",
      large: "https://images.pokemontcg.io/me2/59_hires.png",
    },
    altArts: [
      {
        id: "me2-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/me2/59.png",
          large: "https://images.pokemontcg.io/me2/59_hires.png",
        },
        flavorText:
          "It dwells in the darkness of caves. It uses its sharp claws to dig up gems to nourish itself.",
      },
    ],
  },
  {
    id: "sv5-107",
    name: "Sableye",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Claw Slash",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Damage Collection",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "You may move any number of damage counters from your opponent's Benched Pokémon to their Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "107",
    flavorText:
      "It dwells in the darkness of caves. It uses its sharp claws to dig up gems to nourish itself.",
    nationalPokedexNumbers: [302],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/107.png",
      large: "https://images.pokemontcg.io/sv5/107_hires.png",
    },
    altArts: [
      {
        id: "sv5-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/sv5/107.png",
          large: "https://images.pokemontcg.io/sv5/107_hires.png",
        },
        flavorText:
          "It dwells in the darkness of caves. It uses its sharp claws to dig up gems to nourish itself.",
      },
    ],
  },
  {
    id: "me55-109",
    name: "Salamence ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "330",
    types: ["Dragon"],
    evolvesFrom: "Shelgon",
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Booming Call",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Put up to 3 Dragon Pokémon from your discard pile onto your Bench.",
      },
      {
        name: "Dragon Pulse",
        cost: ["Fire", "Water"],
        convertedEnergyCost: 2,
        damage: "240",
        text: "Discard the top 2 cards of your deck.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "109",
    nationalPokedexNumbers: [373],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-109/small",
      large: "https://images.scrydex.com/pokemon/me55-109/large",
    },
    altArts: [
      {
        id: "me55-109",
        number: "109",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-109/small",
          large: "https://images.scrydex.com/pokemon/me55-109/large",
        },
        flavorText: "",
      },
      {
        id: "me55-156",
        number: "156",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-156/small",
          large: "https://images.scrydex.com/pokemon/me55-156/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-114",
    name: "Salamence ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Dragon"],
    evolvesFrom: "Shelgon",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Wide Blast",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 50 damage to each of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Dragon Impact",
        cost: ["Fire", "Water", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "300",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "114",
    nationalPokedexNumbers: [373],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/114.png",
      large: "https://images.pokemontcg.io/sv9/114_hires.png",
    },
    altArts: [
      {
        id: "sv9-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/sv9/114.png",
          large: "https://images.pokemontcg.io/sv9/114_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-177",
        number: "177",
        images: {
          small: "https://images.pokemontcg.io/sv9/177.png",
          large: "https://images.pokemontcg.io/sv9/177_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-187",
        number: "187",
        images: {
          small: "https://images.pokemontcg.io/sv9/187.png",
          large: "https://images.pokemontcg.io/sv9/187_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-34",
    name: "Salandit",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Ember",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "34",
    flavorText:
      "Only female Salandit can produce gas laden with pheromones. Males entranced by this gas will do whatever the females tell them.",
    nationalPokedexNumbers: [757],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-34/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-34/large",
    },
    altArts: [
      {
        id: "me2pt5-34",
        number: "34",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-34/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-34/large",
        },
        flavorText:
          "Only female Salandit can produce gas laden with pheromones. Males entranced by this gas will do whatever the females tell them.",
      },
      {
        id: "sv7-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv7/23.png",
          large: "https://images.pokemontcg.io/sv7/23_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-15",
    name: "Salandit",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Fire Claws",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    nationalPokedexNumbers: [757],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-15/small",
      large: "https://images.scrydex.com/pokemon/me3-15/large",
    },
    altArts: [
      {
        id: "me3-15",
        number: "15",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-15/small",
          large: "https://images.scrydex.com/pokemon/me3-15/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-35",
    name: "Salazzle",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Salandit",
    attacks: [
      {
        name: "Sudden Scorching",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Your opponent discards a card from their hand. If this Pokémon evolved from Salandit during this turn, your opponent discards 2 more cards.",
      },
      {
        name: "Flamethrower",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    flavorText:
      "When two Salazzle meet, they will use their pheromone gas to fight over the males in each other’s group.",
    nationalPokedexNumbers: [758],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-35/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-35/large",
    },
    altArts: [
      {
        id: "me2pt5-35",
        number: "35",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-35/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-35/large",
        },
        flavorText:
          "When two Salazzle meet, they will use their pheromone gas to fight over the males in each other’s group.",
      },
      {
        id: "me2pt5-224",
        number: "224",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-224/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-224/large",
        },
        flavorText:
          "When two Salazzle meet, they will use their pheromone gas to fight over the males in each other’s group.",
      },
      {
        id: "sv7-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv7/24.png",
          large: "https://images.pokemontcg.io/sv7/24_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-16",
    name: "Salazzle ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Fire"],
    evolvesFrom: "Salandit",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Nasty Plot",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 cards and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Dire Nails",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "Your opponent's Active Pokémon is now Burned and Poisoned. Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    nationalPokedexNumbers: [758],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-16/small",
      large: "https://images.scrydex.com/pokemon/me3-16/large",
    },
    altArts: [
      {
        id: "me3-16",
        number: "16",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-16/small",
          large: "https://images.scrydex.com/pokemon/me3-16/large",
        },
        flavorText: "",
      },
      {
        id: "me3-101",
        number: "101",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-101/small",
          large: "https://images.scrydex.com/pokemon/me3-101/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-23",
    name: "Samurott",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Water"],
    evolvesFrom: "Dewott",
    abilities: [
      {
        name: "Torrential Whirlpool",
        text: "Once during your turn, you may switch your Active Pokémon with 1 of your Benched Pokémon. If you do, switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Energized Slash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "This attack does 50 more damage for each Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    flavorText:
      "One swing of the sword incorporated in its armor can fell an opponent. A simple glare from one of them quiets everybody.",
    nationalPokedexNumbers: [503],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/23.png",
      large: "https://images.pokemontcg.io/rsv10pt5/23_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/23.png",
          large: "https://images.pokemontcg.io/rsv10pt5/23_hires.png",
        },
        flavorText:
          "One swing of the sword incorporated in its armor can fell an opponent. A simple glare from one of them quiets everybody.",
      },
      {
        id: "rsv10pt5-107",
        number: "107",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/107.png",
          large: "https://images.pokemontcg.io/rsv10pt5/107_hires.png",
        },
        flavorText:
          "One swing of the sword incorporated in its armor can fell an opponent. A simple glare from one of them quiets everybody.",
      },
    ],
  },
  {
    id: "zsv10pt5-57",
    name: "Sandile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Krokorok"],
    attacks: [
      {
        name: "Tighten Up",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent discards a card from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "57",
    flavorText:
      "They live buried in the sands of the desert. The sun-warmed sands prevent their body temperature from dropping.",
    nationalPokedexNumbers: [551],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/57.png",
      large: "https://images.pokemontcg.io/zsv10pt5/57_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/57.png",
          large: "https://images.pokemontcg.io/zsv10pt5/57_hires.png",
        },
        flavorText:
          "They live buried in the sands of the desert. The sun-warmed sands prevent their body temperature from dropping.",
      },
      {
        id: "zsv10pt5-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/135.png",
          large: "https://images.pokemontcg.io/zsv10pt5/135_hires.png",
        },
        flavorText:
          "They live buried in the sands of the desert. The sun-warmed sands prevent their body temperature from dropping.",
      },
    ],
  },
  {
    id: "me2-64",
    name: "Sandile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Krokorok"],
    attacks: [
      {
        name: "Ram",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Rear Kick",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "64",
    flavorText:
      "It submerges itself in sand and moves as if swimming. This wise behavior keeps its enemies from finding it and maintains its temperature.",
    nationalPokedexNumbers: [551],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/64.png",
      large: "https://images.pokemontcg.io/me2/64_hires.png",
    },
    altArts: [
      {
        id: "me2-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/me2/64.png",
          large: "https://images.pokemontcg.io/me2/64_hires.png",
        },
        flavorText:
          "It submerges itself in sand and moves as if swimming. This wise behavior keeps its enemies from finding it and maintains its temperature.",
      },
    ],
  },
  {
    id: "me1-68",
    name: "Sandshrew",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Sandslash"],
    attacks: [
      {
        name: "Dig Claws",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Mud-Slap",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "68",
    nationalPokedexNumbers: [27],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/68.png",
      large: "https://images.pokemontcg.io/me1/68_hires.png",
    },
    altArts: [
      {
        id: "me1-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/me1/68.png",
          large: "https://images.pokemontcg.io/me1/68_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-97",
    name: "Sandshrew",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    evolvesTo: ["Sandslash"],
    attacks: [
      {
        name: "Rollout",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Double Scratch",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "Flip 2 coins. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "97",
    flavorText:
      "No matter how high a place it falls from, this Pokémon can save itself by rolling into a ball and bouncing.",
    nationalPokedexNumbers: [27],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/97.png",
      large: "https://images.pokemontcg.io/sv6/97_hires.png",
    },
    altArts: [
      {
        id: "sv6-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/sv6/97.png",
          large: "https://images.pokemontcg.io/sv6/97_hires.png",
        },
        flavorText:
          "No matter how high a place it falls from, this Pokémon can save itself by rolling into a ball and bouncing.",
      },
    ],
  },
  {
    id: "me1-69",
    name: "Sandslash",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Sandshrew",
    attacks: [
      {
        name: "Sand Attack",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "During your opponent's next turn, if the Defending Pokémon tries to use an attack, your opponent flips a coin. If tails, that attack doesn't happen.",
      },
      {
        name: "Mud Shot",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "69",
    nationalPokedexNumbers: [28],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/69.png",
      large: "https://images.pokemontcg.io/me1/69_hires.png",
    },
    altArts: [
      {
        id: "me1-69",
        number: "69",
        images: {
          small: "https://images.pokemontcg.io/me1/69.png",
          large: "https://images.pokemontcg.io/me1/69_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-98",
    name: "Sandslash",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fighting"],
    evolvesFrom: "Sandshrew",
    attacks: [
      {
        name: "Dig Claws",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Earthquake",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "This attack also does 10 damage to each of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "98",
    flavorText:
      "The spikes on its body are made up of its hardened hide. It rolls up and attacks foes with its spikes.",
    nationalPokedexNumbers: [28],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/98.png",
      large: "https://images.pokemontcg.io/sv6/98_hires.png",
    },
    altArts: [
      {
        id: "sv6-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv6/98.png",
          large: "https://images.pokemontcg.io/sv6/98_hires.png",
        },
        flavorText:
          "The spikes on its body are made up of its hardened hide. It rolls up and attacks foes with its spikes.",
      },
    ],
  },
  {
    id: "sv5-98",
    name: "Sandy Shocks",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "120",
    types: ["Fighting"],
    attacks: [
      {
        name: "Magnetic Burst",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If you have 3 or more Energy in play, this attack does 70 more damage. This attack's damage isn't affected by Weakness.",
      },
      {
        name: "Power Gem",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "98",
    flavorText:
      "No records exist of this Pokémon being caught. Data is lacking, but the Pokémon's traits match up with a creature shown in an expedition journal.",
    nationalPokedexNumbers: [989],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/98.png",
      large: "https://images.pokemontcg.io/sv5/98_hires.png",
    },
    altArts: [
      {
        id: "sv5-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv5/98.png",
          large: "https://images.pokemontcg.io/sv5/98_hires.png",
        },
        flavorText:
          "No records exist of this Pokémon being caught. Data is lacking, but the Pokémon's traits match up with a creature shown in an expedition journal.",
      },
    ],
  },
  {
    id: "sv6-91",
    name: "Sandygast",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    evolvesTo: ["Palossand"],
    attacks: [
      {
        name: "Sand Attack",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, if the Defending Pokémon tries to use an attack, your opponent flips a coin. If tails, that attack doesn't happen.",
      },
      {
        name: "Spooky Shot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "91",
    flavorText:
      "It flings sand into the eyes of its prey and tries to close in on them while they're blinded, but since Sandygast is so slow, the prey tends to escape.",
    nationalPokedexNumbers: [769],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/91.png",
      large: "https://images.pokemontcg.io/sv6/91_hires.png",
    },
    altArts: [
      {
        id: "sv6-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/sv6/91.png",
          large: "https://images.pokemontcg.io/sv6/91_hires.png",
        },
        flavorText:
          "It flings sand into the eyes of its prey and tries to close in on them while they're blinded, but since Sandygast is so slow, the prey tends to escape.",
      },
    ],
  },
  {
    id: "sv8-90",
    name: "Sandygast",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Psychic"],
    evolvesTo: ["Palossand"],
    attacks: [
      {
        name: "Sand Spray",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "90",
    nationalPokedexNumbers: [769],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/90.png",
      large: "https://images.pokemontcg.io/sv8/90_hires.png",
    },
    altArts: [
      {
        id: "sv8-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv8/90.png",
          large: "https://images.pokemontcg.io/sv8/90_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-49",
    name: "Sawk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Elbow Strike",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Rising Chop",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "90",
        text: "If your opponent's Active Pokémon isn't a Pokémon ex, this attack does nothing. This attack's damage isn't affected by Weakness or Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    flavorText:
      "The sound of Sawk punching boulders and trees can be heard all the way from the mountains where they train.",
    nationalPokedexNumbers: [539],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/49.png",
      large: "https://images.pokemontcg.io/rsv10pt5/49_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-49",
        number: "49",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/49.png",
          large: "https://images.pokemontcg.io/rsv10pt5/49_hires.png",
        },
        flavorText:
          "The sound of Sawk punching boulders and trees can be heard all the way from the mountains where they train.",
      },
      {
        id: "rsv10pt5-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/130.png",
          large: "https://images.pokemontcg.io/rsv10pt5/130_hires.png",
        },
        flavorText:
          "The sound of Sawk punching boulders and trees can be heard all the way from the mountains where they train.",
      },
    ],
  },
  {
    id: "rsv10pt5-7",
    name: "Sawsbuck",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Deerling",
    attacks: [
      {
        name: "Push Down",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
      {
        name: "Solar Beam",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "7",
    flavorText:
      "They migrate according to the seasons. People can tell the season by looking at Sawsbuck's horns.",
    nationalPokedexNumbers: [586],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/7.png",
      large: "https://images.pokemontcg.io/rsv10pt5/7_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/7.png",
          large: "https://images.pokemontcg.io/rsv10pt5/7_hires.png",
        },
        flavorText:
          "They migrate according to the seasons. People can tell the season by looking at Sawsbuck's horns.",
      },
      {
        id: "rsv10pt5-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/92.png",
          large: "https://images.pokemontcg.io/rsv10pt5/92_hires.png",
        },
        flavorText:
          "They migrate according to the seasons. People can tell the season by looking at Sawsbuck's horns.",
      },
    ],
  },
  {
    id: "sv5-17",
    name: "Sawsbuck",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Deerling",
    abilities: [
      {
        name: "Changing Seasons",
        text: "Once during your turn, you may search your deck for a Stadium card, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Superpowered Horns",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "17",
    flavorText:
      "Sawsbuck in their Autumn Form are known for having very short tempers. The males fight each other incessantly.",
    nationalPokedexNumbers: [586],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/17.png",
      large: "https://images.pokemontcg.io/sv5/17_hires.png",
    },
    altArts: [
      {
        id: "sv5-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv5/17.png",
          large: "https://images.pokemontcg.io/sv5/17_hires.png",
        },
        flavorText:
          "Sawsbuck in their Autumn Form are known for having very short tempers. The males fight each other incessantly.",
      },
      {
        id: "sv5-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/sv5/166.png",
          large: "https://images.pokemontcg.io/sv5/166_hires.png",
        },
        flavorText:
          "Sawsbuck in their Autumn Form are known for having very short tempers. The males fight each other incessantly.",
      },
    ],
  },
  {
    id: "me3-7",
    name: "Scatterbug",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    nationalPokedexNumbers: [664],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-7/small",
      large: "https://images.scrydex.com/pokemon/me3-7/large",
    },
    altArts: [
      {
        id: "me3-7",
        number: "7",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-7/small",
          large: "https://images.scrydex.com/pokemon/me3-7/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-5",
    name: "Scatterbug",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    evolvesTo: ["Spewpa"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Pokémon and put it onto your Bench. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "5",
    nationalPokedexNumbers: [664],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/5.png",
      large: "https://images.pokemontcg.io/sv8/5_hires.png",
    },
    altArts: [
      {
        id: "sv8-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv8/5.png",
          large: "https://images.pokemontcg.io/sv8/5_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-108",
    name: "Scizor ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "120",
    types: ["Metal"],
    evolvesFrom: "Scyther",
    rules: [
      "When Pokémon-ex has been Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Danger Perception",
        text: "As long as Scizor ex's remaining HP is 60 or less, Scizor ex does 40 more damage to the Defending Pokémon (before applying Weakness and Resistance).",
        type: "Poké-BODY",
      },
    ],
    attacks: [
      {
        name: "Steel Wing",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "During your opponent's next turn, any damage done to Scizor ex by attacks is reduced by 20 (after applying Weakness and Resistance).",
      },
      {
        name: "Cross-Cut",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50+",
        text: "If the Defending Pokémon is an Evolved Pokémon, this attack does 50 damage plus 30 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "108",
    nationalPokedexNumbers: [212],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-108/small",
      large: "https://images.scrydex.com/pokemon/me55c-108/large",
    },
    altArts: [
      {
        id: "me55c-108",
        number: "108",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-108/small",
          large: "https://images.scrydex.com/pokemon/me55c-108/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-111",
    name: "Scizor ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Metal"],
    evolvesFrom: "Scyther",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Steel Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "During your opponent's next turn, this Pokémon takes 50 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Cross Breaker",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "120×",
        text: "Discard up to 2 Metal Energy from this Pokémon. This attack does 120 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "111",
    nationalPokedexNumbers: [212],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/111.png",
      large: "https://images.pokemontcg.io/sv5/111_hires.png",
    },
    altArts: [
      {
        id: "sv5-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/sv5/111.png",
          large: "https://images.pokemontcg.io/sv5/111_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-195",
        number: "195",
        images: {
          small: "https://images.pokemontcg.io/sv5/195.png",
          large: "https://images.pokemontcg.io/sv5/195_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-56",
    name: "Scolipede",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Darkness"],
    evolvesFrom: "Whirlipede",
    abilities: [
      {
        name: "Poison Point",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), the Attacking Pokémon is now Poisoned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Venoshock",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90+",
        text: "If your opponent's Active Pokémon is Poisoned, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "56",
    flavorText:
      "With quick movements, it chases down its foes, attacking relentlessly with its horns until it prevails.",
    nationalPokedexNumbers: [545],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/56.png",
      large: "https://images.pokemontcg.io/zsv10pt5/56_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/56.png",
          large: "https://images.pokemontcg.io/zsv10pt5/56_hires.png",
        },
        flavorText:
          "With quick movements, it chases down its foes, attacking relentlessly with its horns until it prevails.",
      },
      {
        id: "zsv10pt5-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/134.png",
          large: "https://images.pokemontcg.io/zsv10pt5/134_hires.png",
        },
        flavorText:
          "With quick movements, it chases down its foes, attacking relentlessly with its horns until it prevails.",
      },
    ],
  },
  {
    id: "sv6-117",
    name: "Scolipede",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Whirlipede",
    attacks: [
      {
        name: "Dastardly Jab",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Put damage counters on your opponent's Active Pokémon until its remaining HP is 10.",
      },
      {
        name: "Sludge Bomb",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "117",
    flavorText:
      "Scolipede latches on to its prey with the claws on its neck before slamming them into the ground and jabbing them with its claws' toxic spikes.",
    nationalPokedexNumbers: [545],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/117.png",
      large: "https://images.pokemontcg.io/sv6/117_hires.png",
    },
    altArts: [
      {
        id: "sv6-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/sv6/117.png",
          large: "https://images.pokemontcg.io/sv6/117_hires.png",
        },
        flavorText:
          "Scolipede latches on to its prey with the claws on its neck before slamming them into the ground and jabbing them with its claws' toxic spikes.",
      },
    ],
  },
  {
    id: "me1-26",
    name: "Scorbunny",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Raboot"],
    attacks: [
      {
        name: "Wild Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    nationalPokedexNumbers: [813],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/26.png",
      large: "https://images.pokemontcg.io/me1/26_hires.png",
    },
    altArts: [
      {
        id: "me1-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/me1/26.png",
          large: "https://images.pokemontcg.io/me1/26_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-36",
    name: "Scorbunny",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Quick Attack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 10 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    flavorText:
      "Fire energy gathers in the pads of its feet, raising their temperature. Once hot, Scorbunny’s footpads can deal heavy damage to opponents.",
    nationalPokedexNumbers: [813],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-36/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-36/large",
    },
    altArts: [
      {
        id: "me2pt5-36",
        number: "36",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-36/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-36/large",
        },
        flavorText:
          "Fire energy gathers in the pads of its feet, raising their temperature. Once hot, Scorbunny’s footpads can deal heavy damage to opponents.",
      },
      {
        id: "me2pt5-225",
        number: "225",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-225/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-225/large",
        },
        flavorText:
          "Fire energy gathers in the pads of its feet, raising their temperature. Once hot, Scorbunny’s footpads can deal heavy damage to opponents.",
      },
      {
        id: "sv7-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv7/26.png",
          large: "https://images.pokemontcg.io/sv7/26_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-22",
    name: "Scovillain ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Grass"],
    evolvesFrom: "Capsakid",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Chili Snapper Bind",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned. During your opponent's next turn, that Pokémon can't retreat.",
      },
      {
        name: "Two-Headed Crushing",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "140",
        text: "Discard a random card from your opponent's hand. Discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "22",
    nationalPokedexNumbers: [952],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/22.png",
      large: "https://images.pokemontcg.io/sv5/22_hires.png",
    },
    altArts: [
      {
        id: "sv5-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/sv5/22.png",
          large: "https://images.pokemontcg.io/sv5/22_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-37",
    name: "Scovillain ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Fire"],
    evolvesFrom: "Capsakid",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Double Type",
        text: "As long as this Pokémon is in play, it is Grass and Fire type.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Spicy Rage",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "10+",
        text: "This attack does 70 more damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "37",
    nationalPokedexNumbers: [952],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/37.png",
      large: "https://images.pokemontcg.io/sv8/37_hires.png",
    },
    altArts: [
      {
        id: "sv8-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv8/37.png",
          large: "https://images.pokemontcg.io/sv8/37_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-216",
        number: "216",
        images: {
          small: "https://images.pokemontcg.io/sv8/216.png",
          large: "https://images.pokemontcg.io/sv8/216_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-58",
    name: "Scrafty",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Scraggy",
    attacks: [
      {
        name: "Ruffians Attack",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: "Flip a coin for each Darkness Pokémon you have in play. This attack does 60 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "58",
    flavorText:
      "Groups of them beat up anything that enters their territory. Each can spit acidic liquid from its mouth.",
    nationalPokedexNumbers: [560],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/58.png",
      large: "https://images.pokemontcg.io/rsv10pt5/58_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/58.png",
          large: "https://images.pokemontcg.io/rsv10pt5/58_hires.png",
        },
        flavorText:
          "Groups of them beat up anything that enters their territory. Each can spit acidic liquid from its mouth.",
      },
      {
        id: "rsv10pt5-139",
        number: "139",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/139.png",
          large: "https://images.pokemontcg.io/rsv10pt5/139_hires.png",
        },
        flavorText:
          "Groups of them beat up anything that enters their territory. Each can spit acidic liquid from its mouth.",
      },
    ],
  },
  {
    id: "rsv10pt5-57",
    name: "Scraggy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Scrafty"],
    attacks: [
      {
        name: "Headbutt",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Invade",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    flavorText:
      "Its skin has a rubbery elasticity, so it can reduce damage by defensively pulling its skin up to its neck.",
    nationalPokedexNumbers: [559],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/57.png",
      large: "https://images.pokemontcg.io/rsv10pt5/57_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/57.png",
          large: "https://images.pokemontcg.io/rsv10pt5/57_hires.png",
        },
        flavorText:
          "Its skin has a rubbery elasticity, so it can reduce damage by defensively pulling its skin up to its neck.",
      },
      {
        id: "rsv10pt5-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/138.png",
          large: "https://images.pokemontcg.io/rsv10pt5/138_hires.png",
        },
        flavorText:
          "Its skin has a rubbery elasticity, so it can reduce damage by defensively pulling its skin up to its neck.",
      },
    ],
  },
  {
    id: "me2pt5-134",
    name: "Scraggy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    attacks: [
      {
        name: "Knock Off",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Discard a random card from your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "134",
    flavorText:
      "Its skin has a rubbery elasticity, so it can reduce damage by defensively pulling its skin up to its neck.",
    nationalPokedexNumbers: [559],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-134/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-134/large",
    },
    altArts: [
      {
        id: "me2pt5-134",
        number: "134",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-134/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-134/large",
        },
        flavorText:
          "Its skin has a rubbery elasticity, so it can reduce damage by defensively pulling its skin up to its neck.",
      },
    ],
  },
  {
    id: "me55-94",
    name: "Scraggy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    attacks: [
      {
        name: "Nitpick",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        text: "Your opponent shuffles their hand into their deck and draws 4 cards.",
      },
      {
        name: "Corkscrew Punch",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "94",
    nationalPokedexNumbers: [559],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-94/small",
      large: "https://images.scrydex.com/pokemon/me55-94/large",
    },
    altArts: [
      {
        id: "me55-94",
        number: "94",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-94/small",
          large: "https://images.scrydex.com/pokemon/me55-94/large",
        },
        flavorText: "",
      },
      {
        id: "me55-140",
        number: "140",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-140/small",
          large: "https://images.scrydex.com/pokemon/me55-140/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-77",
    name: "Scream Tail",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "90",
    types: ["Psychic"],
    attacks: [
      {
        name: "Supportive Singing",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 100 damage from 1 of your Benched Ancient Pokémon.",
      },
      {
        name: "Hyper Voice",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "77",
    flavorText:
      "There has been only one reported sighting of this Pokémon. It resembles a mysterious creature depicted in an old expedition journal.",
    nationalPokedexNumbers: [985],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/77.png",
      large: "https://images.pokemontcg.io/sv5/77_hires.png",
    },
    altArts: [
      {
        id: "sv5-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv5/77.png",
          large: "https://images.pokemontcg.io/sv5/77_hires.png",
        },
        flavorText:
          "There has been only one reported sighting of this Pokémon. It resembles a mysterious creature depicted in an old expedition journal.",
      },
    ],
  },
  {
    id: "sv6-94",
    name: "Scream Tail ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Ancient"],
    hp: "190",
    types: ["Psychic"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Scream",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "You can use this attack only if you go second, and only during your first turn. Your opponent can't play any Supporter cards from their hand during their next turn.",
      },
      {
        name: "Crunch",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "94",
    nationalPokedexNumbers: [985],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/94.png",
      large: "https://images.pokemontcg.io/sv6/94_hires.png",
    },
    altArts: [
      {
        id: "sv6-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv6/94.png",
          large: "https://images.pokemontcg.io/sv6/94_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-197",
        number: "197",
        images: {
          small: "https://images.pokemontcg.io/sv6/197.png",
          large: "https://images.pokemontcg.io/sv6/197_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-1",
    name: "Scyther",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Grass"],
    evolvesTo: ["Scizor"],
    attacks: [
      {
        name: "Cut Up",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Slashing Strike",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "During your next turn, this Pokémon can't use Slashing Strike.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    flavorText:
      "The sharp scythes on its forearms become increasingly sharp by cutting through hard objects.",
    nationalPokedexNumbers: [123],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/1.png",
      large: "https://images.pokemontcg.io/sv5/1_hires.png",
    },
    altArts: [
      {
        id: "sv5-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/sv5/1.png",
          large: "https://images.pokemontcg.io/sv5/1_hires.png",
        },
        flavorText:
          "The sharp scythes on its forearms become increasingly sharp by cutting through hard objects.",
      },
    ],
  },
  {
    id: "sv6pt5-11",
    name: "Seadra",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Horsea",
    evolvesTo: ["Kingdra"],
    attacks: [
      {
        name: "Call for Backup",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Sharp Fin",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    nationalPokedexNumbers: [117],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/11.png",
      large: "https://images.pokemontcg.io/sv6pt5/11_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/11.png",
          large: "https://images.pokemontcg.io/sv6pt5/11_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-14",
    name: "Seaking",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Goldeen",
    attacks: [
      {
        name: "Hydro Jet",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 30 damage to 1 of your opponent's Pokémon for each Water Energy attached to this Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    flavorText:
      "In autumn, its body becomes more fatty in preparing to propose to a mate. It takes on beautiful colors.",
    nationalPokedexNumbers: [119],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-14/small",
      large: "https://images.scrydex.com/pokemon/me5-14/large",
    },
    altArts: [
      {
        id: "me5-14",
        number: "14",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-14/small",
          large: "https://images.scrydex.com/pokemon/me5-14/large",
        },
        flavorText:
          "In autumn, its body becomes more fatty in preparing to propose to a mate. It takes on beautiful colors.",
      },
    ],
  },
  {
    id: "sv6-45",
    name: "Seaking",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Goldeen",
    attacks: [
      {
        name: "Peck Off",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon.",
      },
      {
        name: "Horn Drill",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "45",
    flavorText:
      "In autumn, its body becomes more fatty in preparing to propose to a mate. It takes on beautiful colors.",
    nationalPokedexNumbers: [119],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/45.png",
      large: "https://images.pokemontcg.io/sv6/45_hires.png",
    },
    altArts: [
      {
        id: "sv6-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv6/45.png",
          large: "https://images.pokemontcg.io/sv6/45_hires.png",
        },
        flavorText:
          "In autumn, its body becomes more fatty in preparing to propose to a mate. It takes on beautiful colors.",
      },
    ],
  },
  {
    id: "sv8pt5-21",
    name: "Seaking",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Water"],
    evolvesFrom: "Goldeen",
    abilities: [
      {
        name: "Festival Lead",
        text: "If Festival Grounds is in play, this Pokémon may use an attack it has twice. If the first attack Knocks Out your opponent's Active Pokémon, you may attack again after your opponent chooses a new Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rapid Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "Draw 2 cards.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    nationalPokedexNumbers: [119],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/21.png",
      large: "https://images.pokemontcg.io/sv8pt5/21_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/21.png",
          large: "https://images.pokemontcg.io/sv8pt5/21_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-44",
    name: "Sealeo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Spheal",
    evolvesTo: ["Walrein"],
    attacks: [
      {
        name: "Lunge Out",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Ice Ball",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "44",
    nationalPokedexNumbers: [364],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/44.png",
      large: "https://images.pokemontcg.io/sv8/44_hires.png",
    },
    altArts: [
      {
        id: "sv8-44",
        number: "44",
        images: {
          small: "https://images.pokemontcg.io/sv8/44.png",
          large: "https://images.pokemontcg.io/sv8/44_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-13",
    name: "Seedot",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Nuzleaf"],
    attacks: [
      {
        name: "Nap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 20 damage from this Pokémon.",
      },
      {
        name: "Seed Bomb",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "13",
    nationalPokedexNumbers: [273],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/13.png",
      large: "https://images.pokemontcg.io/me1/13_hires.png",
    },
    altArts: [
      {
        id: "me1-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/me1/13.png",
          large: "https://images.pokemontcg.io/me1/13_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-3",
    name: "Seedot",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Nuzleaf"],
    attacks: [
      {
        name: "Rigidify",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Hang Down",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    flavorText:
      "If it remains still, it looks just like a real nut. It delights in surprising foraging Pokémon.",
    nationalPokedexNumbers: [273],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/3.png",
      large: "https://images.pokemontcg.io/sv5/3_hires.png",
    },
    altArts: [
      {
        id: "sv5-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv5/3.png",
          large: "https://images.pokemontcg.io/sv5/3_hires.png",
        },
        flavorText:
          "If it remains still, it looks just like a real nut. It delights in surprising foraging Pokémon.",
      },
    ],
  },
  {
    id: "me2-21",
    name: "Seel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    evolvesTo: ["Dewgong"],
    attacks: [
      {
        name: "Bubble Drain",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Heal 20 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "21",
    flavorText:
      "The protrusion on its head is very hard. It is used for bashing through thick ice.",
    nationalPokedexNumbers: [86],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/21.png",
      large: "https://images.pokemontcg.io/me2/21_hires.png",
    },
    altArts: [
      {
        id: "me2-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/me2/21.png",
          large: "https://images.pokemontcg.io/me2/21_hires.png",
        },
        flavorText:
          "The protrusion on its head is very hard. It is used for bashing through thick ice.",
      },
    ],
  },
  {
    id: "me3-18",
    name: "Seel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    attacks: [
      {
        name: "Rain Splash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Wave Splash",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "18",
    nationalPokedexNumbers: [86],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-18/small",
      large: "https://images.scrydex.com/pokemon/me3-18/large",
    },
    altArts: [
      {
        id: "me3-18",
        number: "18",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-18/small",
          large: "https://images.scrydex.com/pokemon/me3-18/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-21",
    name: "Seismitoad",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Water"],
    evolvesFrom: "Palpitoad",
    attacks: [
      {
        name: "Round",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70×",
        text: "This attack does 70 damage for each of your Pokémon in play that has the Round attack.",
      },
      {
        name: "Hyper Voice",
        cost: ["Water", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "21",
    flavorText:
      "They shoot paralyzing liquid from their head bumps. They use vibration to hurt their opponents.",
    nationalPokedexNumbers: [537],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/21.png",
      large: "https://images.pokemontcg.io/zsv10pt5/21_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/21.png",
          large: "https://images.pokemontcg.io/zsv10pt5/21_hires.png",
        },
        flavorText:
          "They shoot paralyzing liquid from their head bumps. They use vibration to hurt their opponents.",
      },
      {
        id: "zsv10pt5-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/105.png",
          large: "https://images.pokemontcg.io/zsv10pt5/105_hires.png",
        },
        flavorText:
          "They shoot paralyzing liquid from their head bumps. They use vibration to hurt their opponents.",
      },
    ],
  },
  {
    id: "me55-84",
    name: "Seismitoad",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Fighting"],
    evolvesFrom: "Palpitoad",
    attacks: [
      {
        name: "Quaking Fist",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "During your opponent's next turn, whenever they try to use a Trainer card from their hand, they flip a coin. If tails, your opponent discards that Trainer card instead of using it.",
      },
      {
        name: "Mega Punch",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "180",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "84",
    nationalPokedexNumbers: [537],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-84/small",
      large: "https://images.scrydex.com/pokemon/me55-84/large",
    },
    altArts: [
      {
        id: "me55-84",
        number: "84",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-84/small",
          large: "https://images.scrydex.com/pokemon/me55-84/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-118",
    name: "Sentret",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Furret"],
    attacks: [
      {
        name: "Smack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "118",
    nationalPokedexNumbers: [161],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/118.png",
      large: "https://images.pokemontcg.io/sv9/118_hires.png",
    },
    altArts: [
      {
        id: "sv9-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/sv9/118.png",
          large: "https://images.pokemontcg.io/sv9/118_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-6",
    name: "Serperior",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Grass"],
    evolvesFrom: "Servine",
    attacks: [
      {
        name: "Regal Command",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each of your Pokémon in play.",
      },
      {
        name: "Solar Coiling",
        cost: ["Grass", "Grass", "Grass"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If Rosa's Encouragement is in your discard pile, this attack does 150 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "6",
    nationalPokedexNumbers: [497],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-6/small",
      large: "https://images.scrydex.com/pokemon/me3-6/large",
    },
    altArts: [
      {
        id: "me3-6",
        number: "6",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-6/small",
          large: "https://images.scrydex.com/pokemon/me3-6/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-3",
    name: "Serperior ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "320",
    types: ["Grass"],
    evolvesFrom: "Servine",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Regal Cheer",
        text: "Attacks used by your Pokémon do 20 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Command the Grass",
        cost: ["Grass", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "150",
        text: "You may search your deck for up to 3 cards and put them into your hand. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "3",
    nationalPokedexNumbers: [497],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/3.png",
      large: "https://images.pokemontcg.io/zsv10pt5/3_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/3.png",
          large: "https://images.pokemontcg.io/zsv10pt5/3_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/156.png",
          large: "https://images.pokemontcg.io/zsv10pt5/156_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-164",
        number: "164",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/164.png",
          large: "https://images.pokemontcg.io/zsv10pt5/164_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-2",
    name: "Servine",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Snivy",
    evolvesTo: ["Serperior"],
    attacks: [
      {
        name: "Wrap",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Vine Whip",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    flavorText:
      "It moves along the ground as if sliding. Its swift movements befuddle its foes, and it then attacks with a vine whip.",
    nationalPokedexNumbers: [496],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/2.png",
      large: "https://images.pokemontcg.io/zsv10pt5/2_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/2.png",
          large: "https://images.pokemontcg.io/zsv10pt5/2_hires.png",
        },
        flavorText:
          "It moves along the ground as if sliding. Its swift movements befuddle its foes, and it then attacks with a vine whip.",
      },
      {
        id: "zsv10pt5-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/88.png",
          large: "https://images.pokemontcg.io/zsv10pt5/88_hires.png",
        },
        flavorText:
          "It moves along the ground as if sliding. Its swift movements befuddle its foes, and it then attacks with a vine whip.",
      },
    ],
  },
  {
    id: "me3-5",
    name: "Servine",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Snivy",
    attacks: [
      {
        name: "Solar Cutter",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "5",
    nationalPokedexNumbers: [496],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-5/small",
      large: "https://images.scrydex.com/pokemon/me3-5/large",
    },
    altArts: [
      {
        id: "me3-5",
        number: "5",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-5/small",
          large: "https://images.scrydex.com/pokemon/me3-5/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-62",
    name: "Seviper",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Darkness"],
    abilities: [
      {
        name: "Excited Power",
        text: "If you have any Darkness Mega Evolution Pokémon ex in play, attacks used by this Pokémon do 120 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Pitch-Black Fangs",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    flavorText:
      "It sharpens its swordlike tail on hard rocks. It hides in tall grass and strikes unwary prey with venomous fangs.",
    nationalPokedexNumbers: [336],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/62.png",
      large: "https://images.pokemontcg.io/me2/62_hires.png",
    },
    altArts: [
      {
        id: "me2-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/me2/62.png",
          large: "https://images.pokemontcg.io/me2/62_hires.png",
        },
        flavorText:
          "It sharpens its swordlike tail on hard rocks. It hides in tall grass and strikes unwary prey with venomous fangs.",
      },
    ],
  },
  {
    id: "rsv10pt5-1",
    name: "Sewaddle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    evolvesTo: ["Swadloon"],
    attacks: [
      {
        name: "Bug Bite",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    flavorText:
      "Leavanny dress it in clothes they made for it when it hatched. It hides its head in its hood while it is sleeping.",
    nationalPokedexNumbers: [540],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/1.png",
      large: "https://images.pokemontcg.io/rsv10pt5/1_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/1.png",
          large: "https://images.pokemontcg.io/rsv10pt5/1_hires.png",
        },
        flavorText:
          "Leavanny dress it in clothes they made for it when it hatched. It hides its head in its hood while it is sleeping.",
      },
      {
        id: "rsv10pt5-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/87.png",
          large: "https://images.pokemontcg.io/rsv10pt5/87_hires.png",
        },
        flavorText:
          "Leavanny dress it in clothes they made for it when it hatched. It hides its head in its hood while it is sleeping.",
      },
    ],
  },
  {
    id: "sv5-43",
    name: "Sharpedo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Carvanha",
    attacks: [
      {
        name: "Chew Off",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip 3 coins. For each heads, discard a random card from your opponent's hand.",
      },
      {
        name: "Jet Headbutt",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "43",
    flavorText:
      "As soon as it catches the scent of prey, Sharpedo will jet seawater from its backside, hurtling toward the target to attack at 75 mph.",
    nationalPokedexNumbers: [319],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/43.png",
      large: "https://images.pokemontcg.io/sv5/43_hires.png",
    },
    altArts: [
      {
        id: "sv5-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv5/43.png",
          large: "https://images.pokemontcg.io/sv5/43_hires.png",
        },
        flavorText:
          "As soon as it catches the scent of prey, Sharpedo will jet seawater from its backside, hurtling toward the target to attack at 75 mph.",
      },
    ],
  },
  {
    id: "me3-3",
    name: "Shaymin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Send Flowers",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for an Energy card and attach it to 1 of your Benched Grass Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Leaf Step",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "3",
    nationalPokedexNumbers: [492],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-3/small",
      large: "https://images.scrydex.com/pokemon/me3-3/large",
    },
    altArts: [
      {
        id: "me3-3",
        number: "3",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-3/small",
          large: "https://images.scrydex.com/pokemon/me3-3/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-10",
    name: "Shaymin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    abilities: [
      {
        name: "Flower Curtain",
        text: "Prevent all damage done to your Benched Pokémon that don't have a Rule Box by attacks from your opponent's Pokémon. (Pokémon ex, Pokémon V, etc. have Rule Boxes.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    nationalPokedexNumbers: [492],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/10.png",
      large: "https://images.pokemontcg.io/sv10/10_hires.png",
    },
    altArts: [
      {
        id: "sv10-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv10/10.png",
          large: "https://images.pokemontcg.io/sv10/10_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-185",
        number: "185",
        images: {
          small: "https://images.pokemontcg.io/sv10/185.png",
          large: "https://images.pokemontcg.io/sv10/185_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-13",
    name: "Shaymin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Pinpoint Dive",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 60 damage to 1 of your opponent's Benched Pokémon ex or Benched Pokémon V. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Rear Kick",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "13",
    flavorText:
      "It can dissolve toxins in the air to instantly transform ruined land into a lush field of flowers.",
    nationalPokedexNumbers: [492],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/13.png",
      large: "https://images.pokemontcg.io/sv5/13_hires.png",
    },
    altArts: [
      {
        id: "sv5-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/sv5/13.png",
          large: "https://images.pokemontcg.io/sv5/13_hires.png",
        },
        flavorText:
          "It can dissolve toxins in the air to instantly transform ruined land into a lush field of flowers.",
      },
    ],
  },
  {
    id: "sv8pt5-87",
    name: "Shaymin",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Reflect Energy",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Move an Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "87",
    nationalPokedexNumbers: [492],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/87.png",
      large: "https://images.pokemontcg.io/sv8pt5/87_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/87.png",
          large: "https://images.pokemontcg.io/sv8pt5/87_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-61",
    name: "Shedinja",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "60",
    types: ["Psychic"],
    evolvesFrom: "Nincada",
    abilities: [
      {
        name: "Fragile Husk",
        text: "If this Pokémon is Knocked Out by damage from an attack from your opponent's Pokémon ex, your opponent can't take any Prize cards for it.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Damage Beat",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20×",
        text: "This attack does 20 damage for each damage counter on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "61",
    nationalPokedexNumbers: [292],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/61.png",
      large: "https://images.pokemontcg.io/me1/61_hires.png",
    },
    altArts: [
      {
        id: "me1-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/me1/61.png",
          large: "https://images.pokemontcg.io/me1/61_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/me1/144.png",
          large: "https://images.pokemontcg.io/me1/144_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-113",
    name: "Shelgon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Dragon"],
    evolvesFrom: "Bagon",
    evolvesTo: ["Salamence"],
    attacks: [
      {
        name: "Guard Press",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Heavy Impact",
        cost: ["Fire", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "113",
    nationalPokedexNumbers: [372],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/113.png",
      large: "https://images.pokemontcg.io/sv9/113_hires.png",
    },
    altArts: [
      {
        id: "sv9-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/sv9/113.png",
          large: "https://images.pokemontcg.io/sv9/113_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-46",
    name: "Shellos",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Gastrodon"],
    attacks: [
      {
        name: "Sprinkle Water",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "46",
    nationalPokedexNumbers: [422],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/46.png",
      large: "https://images.pokemontcg.io/sv8/46_hires.png",
    },
    altArts: [
      {
        id: "sv8-46",
        number: "46",
        images: {
          small: "https://images.pokemontcg.io/sv8/46.png",
          large: "https://images.pokemontcg.io/sv8/46_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-8",
    name: "Shelmet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Accelgor"],
    abilities: [
      {
        name: "Stimulated Evolution",
        text: "If you have Karrablast in play, this Pokémon can evolve during your first turn or the turn you play it.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Headbutt Bounce",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "8",
    flavorText:
      "When attacked, it defends itself by closing the lid of its shell. It can spit a sticky, poisonous liquid.",
    nationalPokedexNumbers: [616],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/8.png",
      large: "https://images.pokemontcg.io/rsv10pt5/8_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/8.png",
          large: "https://images.pokemontcg.io/rsv10pt5/8_hires.png",
        },
        flavorText:
          "When attacked, it defends itself by closing the lid of its shell. It can spit a sticky, poisonous liquid.",
      },
      {
        id: "rsv10pt5-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/93.png",
          large: "https://images.pokemontcg.io/rsv10pt5/93_hires.png",
        },
        flavorText:
          "When attacked, it defends itself by closing the lid of its shell. It can spit a sticky, poisonous liquid.",
      },
    ],
  },
  {
    id: "sv9-12",
    name: "Shelmet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Accelgor"],
    attacks: [
      {
        name: "Shell Smack",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage done to this Pokémon by attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "12",
    nationalPokedexNumbers: [616],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/12.png",
      large: "https://images.pokemontcg.io/sv9/12_hires.png",
    },
    altArts: [
      {
        id: "sv9-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv9/12.png",
          large: "https://images.pokemontcg.io/sv9/12_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-61",
    name: "Shieldon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Metal"],
    evolvesFrom: "Antique Armor Fossil",
    attacks: [
      {
        name: "Smithereen Smash",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "61",
    flavorText:
      "This Pokémon lived in primeval jungles. It's thought that Shieldon had few enemies thanks to its sturdy face.",
    nationalPokedexNumbers: [410],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-61/small",
      large: "https://images.scrydex.com/pokemon/me5-61/large",
    },
    altArts: [
      {
        id: "me5-61",
        number: "61",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-61/small",
          large: "https://images.scrydex.com/pokemon/me5-61/large",
        },
        flavorText:
          "This Pokémon lived in primeval jungles. It's thought that Shieldon had few enemies thanks to its sturdy face.",
      },
    ],
  },
  {
    id: "me1-15",
    name: "Shiftry",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Grass"],
    evolvesFrom: "Nuzleaf",
    attacks: [
      {
        name: "Reversing Gust",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, choose 1 of your opponent's Pokémon. Shuffle that Pokémon and all attached cards into their deck.",
      },
      {
        name: "Perplex",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "15",
    nationalPokedexNumbers: [275],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/15.png",
      large: "https://images.pokemontcg.io/me1/15_hires.png",
    },
    altArts: [
      {
        id: "me1-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/me1/15.png",
          large: "https://images.pokemontcg.io/me1/15_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-5",
    name: "Shiftry",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Nuzleaf",
    attacks: [
      {
        name: "Expelling Tornado",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Choose 3 of your opponent's Benched Pokémon. If you do, shuffle all of your opponent's Benched Pokémon that you didn't choose, and all cards attached to those Pokémon, into their deck.",
      },
      {
        name: "Energy Loop",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "140",
        text: "Put an Energy attached to this Pokémon into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    flavorText:
      "A Pokémon that was feared as a forest guardian. It can read the foe's mind and take preemptive action.",
    nationalPokedexNumbers: [275],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/5.png",
      large: "https://images.pokemontcg.io/sv5/5_hires.png",
    },
    altArts: [
      {
        id: "sv5-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv5/5.png",
          large: "https://images.pokemontcg.io/sv5/5_hires.png",
        },
        flavorText:
          "A Pokémon that was feared as a forest guardian. It can read the foe's mind and take preemptive action.",
      },
      {
        id: "sv5-163",
        number: "163",
        images: {
          small: "https://images.pokemontcg.io/sv5/163.png",
          large: "https://images.pokemontcg.io/sv5/163_hires.png",
        },
        flavorText:
          "A Pokémon that was feared as a forest guardian. It can read the foe's mind and take preemptive action.",
      },
    ],
  },
  {
    id: "sv8-9",
    name: "Shiinotic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Grass"],
    evolvesFrom: "Morelull",
    abilities: [
      {
        name: "Calming Light",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may make your opponent's Active Pokémon Asleep.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Spiral Rush",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "Flip a coin until you get tails. This attack does 30 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "9",
    nationalPokedexNumbers: [756],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/9.png",
      large: "https://images.pokemontcg.io/sv8/9_hires.png",
    },
    altArts: [
      {
        id: "sv8-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv8/9.png",
          large: "https://images.pokemontcg.io/sv8/9_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-194",
        number: "194",
        images: {
          small: "https://images.pokemontcg.io/sv8/194.png",
          large: "https://images.pokemontcg.io/sv8/194_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-106",
    name: "Shining Celebi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    rules: ["You can't have more than 1 Shining Celebi in your deck."],
    attacks: [
      {
        name: "Healing Water",
        cost: ["Water"],
        convertedEnergyCost: 1,
        text: "Remove a number of damage counters from 1 of your Benched Pokémon equal to the number of Water Energy cards attached to Shining Celebi. If the Pokémon has fewer damage counters than that, remove all of them.",
      },
      {
        name: "Miracle Leaf",
        cost: ["Grass", "Psychic"],
        convertedEnergyCost: 2,
        damage: "10",
        text: "Flip a number of coins equal to the number of Energy attached to the Defending Pokémon. If you get 1 or more heads, the Defending Pokémon is now Asleep, Confused, or Poisoned (your choice).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "106",
    nationalPokedexNumbers: [251],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-106/small",
      large: "https://images.scrydex.com/pokemon/me55c-106/large",
    },
    altArts: [
      {
        id: "me55c-106",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-106/small",
          large: "https://images.scrydex.com/pokemon/me55c-106/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-26",
    name: "Shinx",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Double Scratch",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    nationalPokedexNumbers: [403],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-26/small",
      large: "https://images.scrydex.com/pokemon/me3-26/large",
    },
    altArts: [
      {
        id: "me3-26",
        number: "26",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-26/small",
          large: "https://images.scrydex.com/pokemon/me3-26/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-66",
    name: "Shinx",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Luxio"],
    attacks: [
      {
        name: "Curiosity",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent reveals their hand.",
      },
      {
        name: "Static Shock",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "66",
    flavorText:
      "The extension and contraction of its muscles generates electricity. Its fur glows when it's in trouble.",
    nationalPokedexNumbers: [403],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/66.png",
      large: "https://images.pokemontcg.io/sv6/66_hires.png",
    },
    altArts: [
      {
        id: "sv6-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv6/66.png",
          large: "https://images.pokemontcg.io/sv6/66_hires.png",
        },
        flavorText:
          "The extension and contraction of its muscles generates electricity. Its fur glows when it's in trouble.",
      },
    ],
  },
  {
    id: "me1-91",
    name: "Shroodle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    attacks: [
      {
        name: "Poison Jab",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "91",
    nationalPokedexNumbers: [944],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/91.png",
      large: "https://images.pokemontcg.io/me1/91_hires.png",
    },
    altArts: [
      {
        id: "me1-91",
        number: "91",
        images: {
          small: "https://images.pokemontcg.io/me1/91.png",
          large: "https://images.pokemontcg.io/me1/91_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/me1/149.png",
          large: "https://images.pokemontcg.io/me1/149_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-120",
    name: "Shroodle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    attacks: [
      {
        name: "Spray Fluid",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "120",
    nationalPokedexNumbers: [944],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/120.png",
      large: "https://images.pokemontcg.io/sv8/120_hires.png",
    },
    altArts: [
      {
        id: "sv8-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/sv8/120.png",
          large: "https://images.pokemontcg.io/sv8/120_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-5",
    name: "Shroomish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Breloom"],
    attacks: [
      {
        name: "Rolling Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "5",
    nationalPokedexNumbers: [285],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/5.png",
      large: "https://images.pokemontcg.io/sv10/5_hires.png",
    },
    altArts: [
      {
        id: "sv10-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/sv10/5.png",
          large: "https://images.pokemontcg.io/sv10/5_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-6",
    name: "Shroomish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Breloom"],
    attacks: [
      {
        name: "Double Headbutt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
      {
        name: "Seed Bomb",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    flavorText:
      "If it senses danger, it scatters spores from the top of its head to protect itself.",
    nationalPokedexNumbers: [285],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/6.png",
      large: "https://images.pokemontcg.io/sv5/6_hires.png",
    },
    altArts: [
      {
        id: "sv5-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv5/6.png",
          large: "https://images.pokemontcg.io/sv5/6_hires.png",
        },
        flavorText:
          "If it senses danger, it scatters spores from the top of its head to protect itself.",
      },
    ],
  },
  {
    id: "me1-11",
    name: "Shuckle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    abilities: [
      {
        name: "Fermented Juice",
        text: "Once during your turn, if this Pokémon has any Grass Energy attached, you may use this Ability. Heal 30 damage from 1 of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rollout",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    nationalPokedexNumbers: [213],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/11.png",
      large: "https://images.pokemontcg.io/me1/11_hires.png",
    },
    altArts: [
      {
        id: "me1-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/me1/11.png",
          large: "https://images.pokemontcg.io/me1/11_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/me1/136.png",
          large: "https://images.pokemontcg.io/me1/136_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-90",
    name: "Shuppet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Spooky Shot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "90",
    flavorText:
      "It loves to feed on feelings like envy and malice. Its upright horn catches the emotions of people.",
    nationalPokedexNumbers: [353],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-90/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-90/large",
    },
    altArts: [
      {
        id: "me2pt5-90",
        number: "90",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-90/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-90/large",
        },
        flavorText:
          "It loves to feed on feelings like envy and malice. Its upright horn catches the emotions of people.",
      },
      {
        id: "sv9-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/sv9/59.png",
          large: "https://images.pokemontcg.io/sv9/59_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-33",
    name: "Shuppet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    abilities: [
      {
        name: "Hide 'n' Sneak",
        text: "Prevent all effects of your opponent's Pokémon's attacks and Abilities done to this Pokémon. (Damage is not an effect.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Hang Down",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    flavorText:
      "It uses its horn to feed on envy and malice-or so it's said. It's very active at night.",
    nationalPokedexNumbers: [353],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-33/small",
      large: "https://images.scrydex.com/pokemon/me5-33/large",
    },
    altArts: [
      {
        id: "me5-33",
        number: "33",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-33/small",
          large: "https://images.scrydex.com/pokemon/me5-33/large",
        },
        flavorText:
          "It uses its horn to feed on envy and malice-or so it's said. It's very active at night.",
      },
    ],
  },
  {
    id: "rsv10pt5-38",
    name: "Sigilyph",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Reflect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, this Pokémon takes 40 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Telekinesis",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 70 damage to 1 of your opponent's Pokémon. This attack's damage isn't affected by Weakness or Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "38",
    flavorText:
      "They never vary the route they fly, because their memories of guarding an ancient city remain steadfast.",
    nationalPokedexNumbers: [561],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/38.png",
      large: "https://images.pokemontcg.io/rsv10pt5/38_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/38.png",
          large: "https://images.pokemontcg.io/rsv10pt5/38_hires.png",
        },
        flavorText:
          "They never vary the route they fly, because their memories of guarding an ancient city remain steadfast.",
      },
      {
        id: "rsv10pt5-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/121.png",
          large: "https://images.pokemontcg.io/rsv10pt5/121_hires.png",
        },
        flavorText:
          "They never vary the route they fly, because their memories of guarding an ancient city remain steadfast.",
      },
    ],
  },
  {
    id: "sv8-81",
    name: "Sigilyph",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Double Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Psy Bolt",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "81",
    nationalPokedexNumbers: [561],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/81.png",
      large: "https://images.pokemontcg.io/sv8/81_hires.png",
    },
    altArts: [
      {
        id: "sv8-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv8/81.png",
          large: "https://images.pokemontcg.io/sv8/81_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-12",
    name: "Silcoon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Grass"],
    evolvesFrom: "Wurmple",
    abilities: [
      {
        name: "Multiplying Cocoon",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Search your deck for a Silcoon or a Cascoon and put it onto your Bench. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Tackle",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "12",
    flavorText:
      "It wraps silk around the branches of a tree. It drinks rainwater on its silk while awaiting evolution.",
    nationalPokedexNumbers: [266],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-12/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-12/large",
    },
    altArts: [
      {
        id: "me2pt5-12",
        number: "12",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-12/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-12/large",
        },
        flavorText:
          "It wraps silk around the branches of a tree. It drinks rainwater on its silk while awaiting evolution.",
      },
    ],
  },
  {
    id: "me5-70",
    name: "Silvally",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Colorless"],
    evolvesFrom: "Type: Null",
    abilities: [
      {
        name: "Call a Buddy",
        text: "Once during your turn, if you have no cards in your hand, you may use this Ability. Search your deck for a Supporter card, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Air Slash",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "70",
    flavorText:
      "The final factor needed to release this Pokémon's true power was a strong bond with a Trainer it trusts.",
    nationalPokedexNumbers: [773],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-70/small",
      large: "https://images.scrydex.com/pokemon/me5-70/large",
    },
    altArts: [
      {
        id: "me5-70",
        number: "70",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-70/small",
          large: "https://images.scrydex.com/pokemon/me5-70/large",
        },
        flavorText:
          "The final factor needed to release this Pokémon's true power was a strong bond with a Trainer it trusts.",
      },
      {
        id: "me5-95",
        number: "95",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-95/small",
          large: "https://images.scrydex.com/pokemon/me5-95/large",
        },
        flavorText:
          "The final factor needed to release this Pokémon's true power was a strong bond with a Trainer it trusts.",
      },
    ],
  },
  {
    id: "zsv10pt5-18",
    name: "Simipour",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Panpour",
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    flavorText:
      "The tuft on its head holds water. When the level runs low, it replenishes the tuft by siphoning up water with its tail.",
    nationalPokedexNumbers: [516],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/18.png",
      large: "https://images.pokemontcg.io/zsv10pt5/18_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/18.png",
          large: "https://images.pokemontcg.io/zsv10pt5/18_hires.png",
        },
        flavorText:
          "The tuft on its head holds water. When the level runs low, it replenishes the tuft by siphoning up water with its tail.",
      },
      {
        id: "zsv10pt5-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/102.png",
          large: "https://images.pokemontcg.io/zsv10pt5/102_hires.png",
        },
        flavorText:
          "The tuft on its head holds water. When the level runs low, it replenishes the tuft by siphoning up water with its tail.",
      },
    ],
  },
  {
    id: "zsv10pt5-5",
    name: "Simisage",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Pansage",
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "5",
    flavorText:
      "Ill tempered, it fights by swinging its barbed tail around wildly. The leaf growing on its head is very bitter.",
    nationalPokedexNumbers: [512],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/5.png",
      large: "https://images.pokemontcg.io/zsv10pt5/5_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/5.png",
          large: "https://images.pokemontcg.io/zsv10pt5/5_hires.png",
        },
        flavorText:
          "Ill tempered, it fights by swinging its barbed tail around wildly. The leaf growing on its head is very bitter.",
      },
      {
        id: "zsv10pt5-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/90.png",
          large: "https://images.pokemontcg.io/zsv10pt5/90_hires.png",
        },
        flavorText:
          "Ill tempered, it fights by swinging its barbed tail around wildly. The leaf growing on its head is very bitter.",
      },
    ],
  },
  {
    id: "rsv10pt5-15",
    name: "Simisear",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fire"],
    evolvesFrom: "Pansear",
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    flavorText:
      "It loves sweets because they become energy for the fire burning inside its body.",
    nationalPokedexNumbers: [514],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/15.png",
      large: "https://images.pokemontcg.io/rsv10pt5/15_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/15.png",
          large: "https://images.pokemontcg.io/rsv10pt5/15_hires.png",
        },
        flavorText:
          "It loves sweets because they become energy for the fire burning inside its body.",
      },
      {
        id: "rsv10pt5-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/100.png",
          large: "https://images.pokemontcg.io/rsv10pt5/100_hires.png",
        },
        flavorText:
          "It loves sweets because they become energy for the fire burning inside its body.",
      },
    ],
  },
  {
    id: "sv8-23",
    name: "Simisear",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fire"],
    evolvesFrom: "Pansear",
    attacks: [
      {
        name: "Double Smash",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "70×",
        text: "Flip 2 coins. This attack does 70 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "23",
    nationalPokedexNumbers: [514],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/23.png",
      large: "https://images.pokemontcg.io/sv8/23_hires.png",
    },
    altArts: [
      {
        id: "sv8-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv8/23.png",
          large: "https://images.pokemontcg.io/sv8/23_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-6",
    name: "Sinistcha",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "60",
    types: ["Grass"],
    evolvesFrom: "Poltchageist",
    abilities: [
      {
        name: "Hide 'n' Sneak",
        text: "Prevent all effects of your opponent's Pokémon's attacks and Abilities done to this Pokémon. (Damage is not an effect.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Matcha Spin",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "If you have 6 or more Pokémon that have the Hide 'n' Sneak Ability in your discard pile, place 4 damage counters on each of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    flavorText:
      "It prefers cool, dark places, such as the back of a shelf or the space beneath a home's floorboards. It wanders in search of prey after sunset.",
    nationalPokedexNumbers: [1013],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-6/small",
      large: "https://images.scrydex.com/pokemon/me5-6/large",
    },
    altArts: [
      {
        id: "me5-6",
        number: "6",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-6/small",
          large: "https://images.scrydex.com/pokemon/me5-6/large",
        },
        flavorText:
          "It prefers cool, dark places, such as the back of a shelf or the space beneath a home's floorboards. It wanders in search of prey after sunset.",
      },
    ],
  },
  {
    id: "sv6-22",
    name: "Sinistcha",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "70",
    types: ["Grass"],
    evolvesFrom: "Poltchageist",
    attacks: [
      {
        name: "Cursed Drop",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put 4 damage counters on your opponent's Pokémon in any way you like.",
      },
      {
        name: "Spill the Tea",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "70×",
        text: "Discard up to 3 Grass Energy cards from your Pokémon. This attack does 70 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [1013],
    flavorText:
      "It prefers cool, dark places, such as the back of a shelf or the space beneath a home's floorboards. It wanders in search of prey after sunset.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/22.png",
      large: "https://images.pokemontcg.io/sv6/22_hires.png",
    },
    altArts: [
      {
        id: "sv6-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/sv6/22.png",
          large: "https://images.pokemontcg.io/sv6/22_hires.png",
        },
        flavorText:
          "It prefers cool, dark places, such as the back of a shelf or the space beneath a home's floorboards. It wanders in search of prey after sunset.",
      },
    ],
  },
  {
    id: "sv6-23",
    name: "Sinistcha ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "240",
    types: ["Grass"],
    evolvesFrom: "Poltchageist",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Re-Brew",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put 2 damage counters on 1 of your opponent's Pokémon for each Basic Grass Energy card in your discard pile. Then, shuffle those Energy cards into your deck.",
      },
      {
        name: "Matcha Splash",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "Heal 30 damage from each of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "23",
    nationalPokedexNumbers: [1013],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/23.png",
      large: "https://images.pokemontcg.io/sv6/23_hires.png",
    },
    altArts: [
      {
        id: "sv6-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv6/23.png",
          large: "https://images.pokemontcg.io/sv6/23_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-189",
        number: "189",
        images: {
          small: "https://images.pokemontcg.io/sv6/189.png",
          large: "https://images.pokemontcg.io/sv6/189_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-210",
        number: "210",
        images: {
          small: "https://images.pokemontcg.io/sv6/210.png",
          large: "https://images.pokemontcg.io/sv6/210_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-29",
    name: "Sizzlipede",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Centiskorch"],
    attacks: [
      {
        name: "Ram",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Combustion",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "29",
    nationalPokedexNumbers: [850],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/29.png",
      large: "https://images.pokemontcg.io/me1/29_hires.png",
    },
    altArts: [
      {
        id: "me1-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/me1/29.png",
          large: "https://images.pokemontcg.io/me1/29_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-9",
    name: "Sizzlipede",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Controlled Burn",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard the top card of your opponent's deck.",
      },
      {
        name: "Bug Out",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50×",
        text: "Reveal the bottom 7 cards of your deck, and this attack does 50 damage for each Pokémon you find there that has the Bug Out attack. Then, shuffle any revealed Pokémon back into your deck. Discard the other cards.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "9",
    flavorText:
      "It stores flammable gas in its body and uses it to generate heat. The yellow sections on its belly get particularly hot.",
    nationalPokedexNumbers: [850],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-9/small",
      large: "https://images.scrydex.com/pokemon/me5-9/large",
    },
    altArts: [
      {
        id: "me5-9",
        number: "9",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-9/small",
          large: "https://images.scrydex.com/pokemon/me5-9/large",
        },
        flavorText:
          "It stores flammable gas in its body and uses it to generate heat. The yellow sections on its belly get particularly hot.",
      },
    ],
  },
  {
    id: "sv5-36",
    name: "Sizzlipede",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Centiskorch"],
    attacks: [
      {
        name: "Heat Dive",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "36",
    flavorText:
      "It stores flammable gas in its body and uses it to generate heat. The yellow sections on its belly get particularly hot.",
    nationalPokedexNumbers: [850],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/36.png",
      large: "https://images.pokemontcg.io/sv5/36_hires.png",
    },
    altArts: [
      {
        id: "sv5-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/sv5/36.png",
          large: "https://images.pokemontcg.io/sv5/36_hires.png",
        },
        flavorText:
          "It stores flammable gas in its body and uses it to generate heat. The yellow sections on its belly get particularly hot.",
      },
    ],
  },
  {
    id: "sv8-27",
    name: "Sizzlipede",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Centiskorch"],
    attacks: [
      {
        name: "Live Coal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Hook",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "27",
    nationalPokedexNumbers: [850],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/27.png",
      large: "https://images.pokemontcg.io/sv8/27_hires.png",
    },
    altArts: [
      {
        id: "sv8-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv8/27.png",
          large: "https://images.pokemontcg.io/sv8/27_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-60",
    name: "Skarmory",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Metal"],
    attacks: [
      {
        name: "Steel Cutter",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "40×",
        text: "Discard up to 2 Basic Metal Energy cards from your hand, and this attack does 40 damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "60",
    flavorText:
      "Because it nests in bramble bushes, the feathers of its chicks grow hard from being scratched by thorns.",
    nationalPokedexNumbers: [227],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-60/small",
      large: "https://images.scrydex.com/pokemon/me5-60/large",
    },
    altArts: [
      {
        id: "me5-60",
        number: "60",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-60/small",
          large: "https://images.scrydex.com/pokemon/me5-60/large",
        },
        flavorText:
          "Because it nests in bramble bushes, the feathers of its chicks grow hard from being scratched by thorns.",
      },
    ],
  },
  {
    id: "sv10-141",
    name: "Skarmory",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Metal"],
    attacks: [
      {
        name: "Roost",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 50 damage from this Pokémon. During your next turn, this Pokémon can't retreat.",
      },
      {
        name: "Metal Claw",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "141",
    nationalPokedexNumbers: [227],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/141.png",
      large: "https://images.pokemontcg.io/sv10/141_hires.png",
    },
    altArts: [
      {
        id: "sv10-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/sv10/141.png",
          large: "https://images.pokemontcg.io/sv10/141_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-119",
    name: "Skarmory",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Metal"],
    attacks: [
      {
        name: "Cutting Wind",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Big Storm",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Discard a Stadium in play.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "119",
    flavorText:
      "People fashion swords from Skarmory's shed feathers, so this Pokémon is a popular element in heraldic designs.",
    nationalPokedexNumbers: [227],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/119.png",
      large: "https://images.pokemontcg.io/sv6/119_hires.png",
    },
    altArts: [
      {
        id: "sv6-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/sv6/119.png",
          large: "https://images.pokemontcg.io/sv6/119_hires.png",
        },
        flavorText:
          "People fashion swords from Skarmory's shed feathers, so this Pokémon is a popular element in heraldic designs.",
      },
    ],
  },
  {
    id: "sv8-124",
    name: "Skarmory",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Metal"],
    attacks: [
      {
        name: "Steel Wing",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "124",
    nationalPokedexNumbers: [227],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/124.png",
      large: "https://images.pokemontcg.io/sv8/124_hires.png",
    },
    altArts: [
      {
        id: "sv8-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/sv8/124.png",
          large: "https://images.pokemontcg.io/sv8/124_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-209",
        number: "209",
        images: {
          small: "https://images.pokemontcg.io/sv8/209.png",
          large: "https://images.pokemontcg.io/sv8/209_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-31",
    name: "Skeledirge",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fire"],
    evolvesFrom: "Crocalor",
    abilities: [
      {
        name: "Unaware",
        text: "Prevent all effects of attacks used by your opponent's Pokémon done to this Pokémon. (Damage is not an effect.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Torcherto",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "This attack does 20 more damage for each Benched Pokémon (both yours and your opponent's).",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "31",
    nationalPokedexNumbers: [911],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/31.png",
      large: "https://images.pokemontcg.io/sv8/31_hires.png",
    },
    altArts: [
      {
        id: "sv8-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/sv8/31.png",
          large: "https://images.pokemontcg.io/sv8/31_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-165",
    name: "Skitty",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    attacks: [
      {
        name: "Cat Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "165",
    flavorText:
      "It can’t stop itself from chasing moving things, and it runs in a circle, chasing its own tail.",
    nationalPokedexNumbers: [300],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-165/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-165/large",
    },
    altArts: [
      {
        id: "me2pt5-165",
        number: "165",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-165/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-165/large",
        },
        flavorText:
          "It can’t stop itself from chasing moving things, and it runs in a circle, chasing its own tail.",
      },
    ],
  },
  {
    id: "sv5-130",
    name: "Skitty",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Delcatty"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Pokémon and put it onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Tackle",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "130",
    flavorText:
      "It can't stop itself from chasing moving things, and it runs in a circle, chasing its own tail.",
    nationalPokedexNumbers: [300],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/130.png",
      large: "https://images.pokemontcg.io/sv5/130_hires.png",
    },
    altArts: [
      {
        id: "sv5-130",
        number: "130",
        images: {
          small: "https://images.pokemontcg.io/sv5/130.png",
          large: "https://images.pokemontcg.io/sv5/130_hires.png",
        },
        flavorText:
          "It can't stop itself from chasing moving things, and it runs in a circle, chasing its own tail.",
      },
    ],
  },
  {
    id: "me3-51",
    name: "Skorupi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    attacks: [
      {
        name: "Poison Jab",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "51",
    nationalPokedexNumbers: [451],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-51/small",
      large: "https://images.scrydex.com/pokemon/me3-51/large",
    },
    altArts: [
      {
        id: "me3-51",
        number: "51",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-51/small",
          large: "https://images.scrydex.com/pokemon/me3-51/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-58",
    name: "Skrelp",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Hook",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    flavorText:
      "Camouflaged as rotten kelp, this Pokemon sprays liquid poison to take down prey that approach unawares.",
    nationalPokedexNumbers: [690],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-58/small",
      large: "https://images.scrydex.com/pokemon/me4-58/large",
    },
    altArts: [
      {
        id: "me4-58",
        number: "58",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-58/small",
          large: "https://images.scrydex.com/pokemon/me4-58/large",
        },
        flavorText:
          "Camouflaged as rotten kelp, this Pokemon sprays liquid poison to take down prey that approach unawares.",
      },
    ],
  },
  {
    id: "me4-54",
    name: "Skuntank",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Darkness"],
    evolvesFrom: "Stunky",
    attacks: [
      {
        name: "Rear Kick",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Smash Turn",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "54",
    flavorText:
      "It attacks by spraying a repugnant fluid from its tail, but the stench dulls after a few squirts.",
    nationalPokedexNumbers: [435],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-54/small",
      large: "https://images.scrydex.com/pokemon/me4-54/large",
    },
    altArts: [
      {
        id: "me4-54",
        number: "54",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-54/small",
          large: "https://images.scrydex.com/pokemon/me4-54/large",
        },
        flavorText:
          "It attacks by spraying a repugnant fluid from its tail, but the stench dulls after a few squirts.",
      },
    ],
  },
  {
    id: "sv9-131",
    name: "Skwovet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Greedent"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Gnaw",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "131",
    nationalPokedexNumbers: [819],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/131.png",
      large: "https://images.pokemontcg.io/sv9/131_hires.png",
    },
    altArts: [
      {
        id: "sv9-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/sv9/131.png",
          large: "https://images.pokemontcg.io/sv9/131_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-147",
    name: "Slaking ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "340",
    types: ["Colorless"],
    evolvesFrom: "Vigoroth",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Born to Slack",
        text: "If your opponent has no Pokémon ex or Pokémon V in play, this Pokémon can't attack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Great Swing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "280",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "147",
    nationalPokedexNumbers: [289],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/147.png",
      large: "https://images.pokemontcg.io/sv8/147_hires.png",
    },
    altArts: [
      {
        id: "sv8-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/sv8/147.png",
          large: "https://images.pokemontcg.io/sv8/147_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-227",
        number: "227",
        images: {
          small: "https://images.pokemontcg.io/sv8/227.png",
          large: "https://images.pokemontcg.io/sv8/227_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-145",
    name: "Slakoth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Vigoroth"],
    attacks: [
      {
        name: "Take It Easy",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 60 damage from this Pokémon. During your next turn, this Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "145",
    nationalPokedexNumbers: [287],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/145.png",
      large: "https://images.pokemontcg.io/sv8/145_hires.png",
    },
    altArts: [
      {
        id: "sv8-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/sv8/145.png",
          large: "https://images.pokemontcg.io/sv8/145_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-212",
        number: "212",
        images: {
          small: "https://images.pokemontcg.io/sv8/212.png",
          large: "https://images.pokemontcg.io/sv8/212_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-67",
    name: "Sliggoo",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Dragon"],
    evolvesFrom: "Goomy",
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Water", "Psychic"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "67",
    flavorText:
      "Its four horns are a high-performance radar system. It uses them to sense sounds and smells, rather than using ears or a nose.",
    nationalPokedexNumbers: [705],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-67/small",
      large: "https://images.scrydex.com/pokemon/me4-67/large",
    },
    altArts: [
      {
        id: "me4-67",
        number: "67",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-67/small",
          large: "https://images.scrydex.com/pokemon/me4-67/large",
        },
        flavorText:
          "Its four horns are a high-performance radar system. It uses them to sense sounds and smells, rather than using ears or a nose.",
      },
      {
        id: "me4-95",
        number: "95",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-95/small",
          large: "https://images.scrydex.com/pokemon/me4-95/large",
        },
        flavorText:
          "Its four horns are a high-performance radar system. It uses them to sense sounds and smells, rather than using ears or a nose.",
      },
    ],
  },
  {
    id: "sv6pt5-26",
    name: "Slither Wing",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Iron Smasher",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "If your opponent has any Future Pokémon in play, this attack does 120 more damage.",
      },
      {
        name: "Smashing Wing",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "26",
    nationalPokedexNumbers: [988],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/26.png",
      large: "https://images.pokemontcg.io/sv6pt5/26_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/26.png",
          large: "https://images.pokemontcg.io/sv6pt5/26_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-30",
    name: "Slowbro",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Slowpoke",
    attacks: [
      {
        name: "All Out",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "50+",
        text: "If you have no cards in your hand, this attack does 160 more damage.",
      },
      {
        name: "Zen Headbutt",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "30",
    flavorText:
      "An attached Shellder won't let go because of the tasty flavor that oozes out of Slowbro's tail.",
    nationalPokedexNumbers: [80],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-30/small",
      large: "https://images.scrydex.com/pokemon/me5-30/large",
    },
    altArts: [
      {
        id: "me5-30",
        number: "30",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-30/small",
          large: "https://images.scrydex.com/pokemon/me5-30/large",
        },
        flavorText:
          "An attached Shellder won't let go because of the tasty flavor that oozes out of Slowbro's tail.",
      },
      {
        id: "me5-90",
        number: "90",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-90/small",
          large: "https://images.scrydex.com/pokemon/me5-90/large",
        },
        flavorText:
          "An attached Shellder won't let go because of the tasty flavor that oozes out of Slowbro's tail.",
      },
    ],
  },
  {
    id: "sv7-58",
    name: "Slowking",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Slowpoke",
    attacks: [
      {
        name: "Seek Inspiration",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Discard the top card of your deck, and if that card is a Pokémon that doesn't have a Rule Box, choose 1 of its attacks and use it as this attack. (Pokémon ex, Pokémon V, etc. have Rule Boxes.)",
      },
      {
        name: "Super Psy Bolt",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "58",
    nationalPokedexNumbers: [199],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/58.png",
      large: "https://images.pokemontcg.io/sv7/58_hires.png",
    },
    altArts: [
      {
        id: "sv7-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv7/58.png",
          large: "https://images.pokemontcg.io/sv7/58_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-19",
    name: "Slowking",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Water"],
    evolvesFrom: "Slowpoke",
    attacks: [
      {
        name: "Wash the Slate Clean",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "You may put 2 Energy attached to your opponent's Active Pokémon into their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    nationalPokedexNumbers: [199],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/19.png",
      large: "https://images.pokemontcg.io/sv8pt5/19_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/19.png",
          large: "https://images.pokemontcg.io/sv8pt5/19_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-29",
    name: "Slowpoke",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "All-You-Can-Yeet",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "You may discard any number of cards from your hand.",
      },
      {
        name: "Headbutt",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "29",
    flavorText:
      "It lazes vacantly near water. If something bites its tail, it won't even notice for a whole day.",
    nationalPokedexNumbers: [79],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-29/small",
      large: "https://images.scrydex.com/pokemon/me5-29/large",
    },
    altArts: [
      {
        id: "me5-29",
        number: "29",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-29/small",
          large: "https://images.scrydex.com/pokemon/me5-29/large",
        },
        flavorText:
          "It lazes vacantly near water. If something bites its tail, it won't even notice for a whole day.",
      },
    ],
  },
  {
    id: "me55-16",
    name: "Slowpoke",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    attacks: [
      {
        name: "Well-Hidden",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
      {
        name: "Water Gun",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "16",
    nationalPokedexNumbers: [79],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-16/small",
      large: "https://images.scrydex.com/pokemon/me55-16/large",
    },
    altArts: [
      {
        id: "me55-16",
        number: "16",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-16/small",
          large: "https://images.scrydex.com/pokemon/me55-16/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-57",
    name: "Slowpoke",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    evolvesTo: ["Slowbro", "Slowking"],
    attacks: [
      {
        name: "Dangle Tail",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put a Pokémon from your discard pile into your hand.",
      },
      {
        name: "Tackle",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "57",
    nationalPokedexNumbers: [79],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/57.png",
      large: "https://images.pokemontcg.io/sv7/57_hires.png",
    },
    altArts: [
      {
        id: "sv7-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv7/57.png",
          large: "https://images.pokemontcg.io/sv7/57_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-18",
    name: "Slowpoke",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Slowbro"],
    attacks: [
      {
        name: "Water Gun",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Tail Whap",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "18",
    nationalPokedexNumbers: [79],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/18.png",
      large: "https://images.pokemontcg.io/sv8pt5/18_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/18.png",
          large: "https://images.pokemontcg.io/sv8pt5/18_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-28",
    name: "Slugma",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Magcargo"],
    attacks: [
      {
        name: "Roasting Heat",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If your opponent's Active Pokémon is Burned, this attack does 40 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "28",
    flavorText:
      "A common sight in volcanic areas, it slowly slithers around in a constant search for warm places.",
    nationalPokedexNumbers: [218],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/28.png",
      large: "https://images.pokemontcg.io/sv5/28_hires.png",
    },
    altArts: [
      {
        id: "sv5-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv5/28.png",
          large: "https://images.pokemontcg.io/sv5/28_hires.png",
        },
        flavorText:
          "A common sight in volcanic areas, it slowly slithers around in a constant search for warm places.",
      },
    ],
  },
  {
    id: "sv6-28",
    name: "Slugma",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    evolvesTo: ["Magcargo"],
    attacks: [
      {
        name: "Hot Magma",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "28",
    flavorText:
      "It's said that in ancient times, when volcanoes were more active, there were many more Slugma than there are now.",
    nationalPokedexNumbers: [218],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/28.png",
      large: "https://images.pokemontcg.io/sv6/28_hires.png",
    },
    altArts: [
      {
        id: "sv6-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/sv6/28.png",
          large: "https://images.pokemontcg.io/sv6/28_hires.png",
        },
        flavorText:
          "It's said that in ancient times, when volcanoes were more active, there were many more Slugma than there are now.",
      },
    ],
  },
  {
    id: "me2pt5-94",
    name: "Slurpuff",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Swirlix",
    attacks: [
      {
        name: "Tackle",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "94",
    flavorText:
      "It can distinguish the faintest of scents. It puts its sensitive sense of smell to use by helping pastry chefs in their work.",
    nationalPokedexNumbers: [685],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-94/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-94/large",
    },
    altArts: [
      {
        id: "me2pt5-94",
        number: "94",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-94/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-94/large",
        },
        flavorText:
          "It can distinguish the faintest of scents. It puts its sensitive sense of smell to use by helping pastry chefs in their work.",
      },
      {
        id: "me2pt5-236",
        number: "236",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-236/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-236/large",
        },
        flavorText:
          "It can distinguish the faintest of scents. It puts its sensitive sense of smell to use by helping pastry chefs in their work.",
      },
    ],
  },
  {
    id: "sv6-90",
    name: "Slurpuff",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Swirlix",
    attacks: [
      {
        name: "Slurp Slurp",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "90×",
        text: "Flip 2 coins. This attack does 90 damage for each heads. If both of them are tails,  your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "90",
    flavorText:
      "By taking in a person's scent, it can sniff out their mental and physical condition. It's hoped that this skill will have many medical applications.",
    nationalPokedexNumbers: [685],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/90.png",
      large: "https://images.pokemontcg.io/sv6/90_hires.png",
    },
    altArts: [
      {
        id: "sv6-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/sv6/90.png",
          large: "https://images.pokemontcg.io/sv6/90_hires.png",
        },
        flavorText:
          "By taking in a person's scent, it can sniff out their mental and physical condition. It's hoped that this skill will have many medical applications.",
      },
    ],
  },
  {
    id: "me2-80",
    name: "Smeargle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Colorless"],
    attacks: [
      {
        name: "Energizing Sketch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip 3 coins. Attach an amount of Basic Energy up to the number of heads from your discard pile to your Benched Pokémon in any way you like.",
      },
      {
        name: "Hook",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "80",
    flavorText:
      "Once a Smeargle reaches adulthood, it will have other members of its species leave paw prints on its back.",
    nationalPokedexNumbers: [235],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/80.png",
      large: "https://images.pokemontcg.io/me2/80_hires.png",
    },
    altArts: [
      {
        id: "me2-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/me2/80.png",
          large: "https://images.pokemontcg.io/me2/80_hires.png",
        },
        flavorText:
          "Once a Smeargle reaches adulthood, it will have other members of its species leave paw prints on its back.",
      },
    ],
  },
  {
    id: "sv10-21",
    name: "Smoliv",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    nationalPokedexNumbers: [928],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/21.png",
      large: "https://images.pokemontcg.io/sv10/21_hires.png",
    },
    altArts: [
      {
        id: "sv10-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/sv10/21.png",
          large: "https://images.pokemontcg.io/sv10/21_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-75",
    name: "Smoochum",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Psychic"],
    evolvesTo: ["Jynx"],
    attacks: [
      {
        name: "Delightful Kiss",
        cost: [],
        convertedEnergyCost: 0,
        damage: "",
        text: "Search your deck for up to 2 Basic Psychic Energy cards and attach them to 1 of your Benched Pokémon. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "75",
    nationalPokedexNumbers: [238],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/75.png",
      large: "https://images.pokemontcg.io/sv8/75_hires.png",
    },
    altArts: [
      {
        id: "sv8-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv8/75.png",
          large: "https://images.pokemontcg.io/sv8/75_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-44",
    name: "Sneasel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Cut",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Beset",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "44",
    flavorText:
      "This is a smart and sneaky Pokémon. A pair may work together to steal eggs by having one lure the parents away.",
    nationalPokedexNumbers: [215],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-44/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-44/large",
    },
    altArts: [
      {
        id: "me2pt5-44",
        number: "44",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-44/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-44/large",
        },
        flavorText:
          "This is a smart and sneaky Pokémon. A pair may work together to steal eggs by having one lure the parents away.",
      },
      {
        id: "sv6pt5-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/13.png",
          large: "https://images.pokemontcg.io/sv6pt5/13_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-25",
    name: "Sneasel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    attacks: [
      {
        name: "Fury Swipes",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 3 coins. This attack does 10 damage times the number of heads.",
      },
      {
        name: "Beat Up",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "Flip a coin for each of your Pokémon in play (including this one). This attack does 20 damage times the number of heads.",
      },
    ],
    resistances: [
      {
        type: "Psychic",
        value: "-30",
      },
    ],
    number: "25",
    nationalPokedexNumbers: [215],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-25/small",
      large: "https://images.scrydex.com/pokemon/me55c-25/large",
    },
    altArts: [
      {
        id: "me55c-25",
        number: "25",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-25/small",
          large: "https://images.scrydex.com/pokemon/me55c-25/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-61",
    name: "Sneasel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Darkness"],
    evolvesTo: ["Weavile"],
    attacks: [
      {
        name: "Claw Slash",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    number: "61",
    nationalPokedexNumbers: [215],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/61.png",
      large: "https://images.pokemontcg.io/sv8pt5/61_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/61.png",
          large: "https://images.pokemontcg.io/sv8pt5/61_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-1",
    name: "Snivy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Servine"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Vine Whip",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    flavorText:
      "It is very intelligent and calm. Being exposed to lots of sunlight makes its movements swifter.",
    nationalPokedexNumbers: [495],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/1.png",
      large: "https://images.pokemontcg.io/zsv10pt5/1_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/1.png",
          large: "https://images.pokemontcg.io/zsv10pt5/1_hires.png",
        },
        flavorText:
          "It is very intelligent and calm. Being exposed to lots of sunlight makes its movements swifter.",
      },
      {
        id: "zsv10pt5-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/87.png",
          large: "https://images.pokemontcg.io/zsv10pt5/87_hires.png",
        },
        flavorText:
          "It is very intelligent and calm. Being exposed to lots of sunlight makes its movements swifter.",
      },
    ],
  },
  {
    id: "me3-4",
    name: "Snivy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    nationalPokedexNumbers: [495],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-4/small",
      large: "https://images.scrydex.com/pokemon/me3-4/large",
    },
    altArts: [
      {
        id: "me3-4",
        number: "4",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-4/small",
          large: "https://images.scrydex.com/pokemon/me3-4/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-42",
    name: "Snom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Water"],
    evolvesTo: ["Frosmoth"],
    attacks: [
      {
        name: "Hide",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "42",
    nationalPokedexNumbers: [872],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/42.png",
      large: "https://images.pokemontcg.io/me1/42_hires.png",
    },
    altArts: [
      {
        id: "me1-42",
        number: "42",
        images: {
          small: "https://images.pokemontcg.io/me1/42.png",
          large: "https://images.pokemontcg.io/me1/42_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-52",
    name: "Snom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Water"],
    attacks: [
      {
        name: "Icicle",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    flavorText:
      "Within its internal organs, Snom amplifies the frigid air it gets from eating snow and then uses this amplified air to create icicle-like spikes.",
    nationalPokedexNumbers: [872],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-52/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-52/large",
    },
    altArts: [
      {
        id: "me2pt5-52",
        number: "52",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-52/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-52/large",
        },
        flavorText:
          "Within its internal organs, Snom amplifies the frigid air it gets from eating snow and then uses this amplified air to create icicle-like spikes.",
      },
    ],
  },
  {
    id: "sv5-45",
    name: "Snom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Water"],
    evolvesTo: ["Frosmoth"],
    attacks: [
      {
        name: "Powder Snow",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "45",
    flavorText:
      "It eats snow that has accumulated on the ground. It prefers soft, freshly fallen snow, so it will eat its way up a mountain, aiming for the peak.",
    nationalPokedexNumbers: [872],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/45.png",
      large: "https://images.pokemontcg.io/sv5/45_hires.png",
    },
    altArts: [
      {
        id: "sv5-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv5/45.png",
          large: "https://images.pokemontcg.io/sv5/45_hires.png",
        },
        flavorText:
          "It eats snow that has accumulated on the ground. It prefers soft, freshly fallen snow, so it will eat its way up a mountain, aiming for the peak.",
      },
      {
        id: "sv5-168",
        number: "168",
        images: {
          small: "https://images.pokemontcg.io/sv5/168.png",
          large: "https://images.pokemontcg.io/sv5/168_hires.png",
        },
        flavorText:
          "It eats snow that has accumulated on the ground. It prefers soft, freshly fallen snow, so it will eat its way up a mountain, aiming for the peak.",
      },
    ],
  },
  {
    id: "me3-63",
    name: "Snorlax",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "160",
    types: ["Colorless"],
    attacks: [
      {
        name: "Gormandizer",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin until you get tails. Search your deck for an amount of Basic Energy up to the number of heads and attach it to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Collapse",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "160",
        text: "This Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "63",
    nationalPokedexNumbers: [143],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-63/small",
      large: "https://images.scrydex.com/pokemon/me3-63/large",
    },
    altArts: [
      {
        id: "me3-63",
        number: "63",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-63/small",
          large: "https://images.scrydex.com/pokemon/me3-63/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-119",
    name: "Snorlax",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "160",
    types: ["Colorless"],
    abilities: [
      {
        name: "Good Sleep",
        text: "If this Pokémon remains Asleep during Pokémon Checkup, heal all damage from this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Collapse",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "This Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "119",
    nationalPokedexNumbers: [143],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-119/small",
      large: "https://images.scrydex.com/pokemon/me55-119/large",
    },
    altArts: [
      {
        id: "me55-119",
        number: "119",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-119/small",
          large: "https://images.scrydex.com/pokemon/me55-119/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-136",
    name: "Snorlax",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "160",
    types: ["Colorless"],
    attacks: [
      {
        name: "But First, Food",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach an Energy card from your hand to this Pokémon. If you do, heal 60 damage from this Pokémon.",
      },
      {
        name: "Heavy Impact",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 5,
        damage: "160",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "136",
    flavorText:
      "Its stomach's digestive juices can dissolve any kind of poison. Eating things off the ground doesn't bother it at all.",
    nationalPokedexNumbers: [143],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/136.png",
      large: "https://images.pokemontcg.io/sv6/136_hires.png",
    },
    altArts: [
      {
        id: "sv6-136",
        number: "136",
        images: {
          small: "https://images.pokemontcg.io/sv6/136.png",
          large: "https://images.pokemontcg.io/sv6/136_hires.png",
        },
        flavorText:
          "Its stomach's digestive juices can dissolve any kind of poison. Eating things off the ground doesn't bother it at all.",
      },
    ],
  },
  {
    id: "sv8-144",
    name: "Snorlax",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "150",
    types: ["Colorless"],
    attacks: [
      {
        name: "Spike Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Draw a card.",
      },
      {
        name: "Mega Punch",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "144",
    nationalPokedexNumbers: [143],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/144.png",
      large: "https://images.pokemontcg.io/sv8/144_hires.png",
    },
    altArts: [
      {
        id: "sv8-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/sv8/144.png",
          large: "https://images.pokemontcg.io/sv8/144_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-122",
    name: "Snorlax",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "160",
    types: ["Colorless"],
    attacks: [
      {
        name: "Lazy Press",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "122",
    flavorText:
      "It is not satisfied unless it eats over 880 pounds of food every day. When it is done eating, it goes promptly to sleep.",
    nationalPokedexNumbers: [143],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/122.png",
      large: "https://images.pokemontcg.io/svp/122_hires.png",
    },
    altArts: [
      {
        id: "svp-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/svp/122.png",
          large: "https://images.pokemontcg.io/svp/122_hires.png",
        },
        flavorText:
          "It is not satisfied unless it eats over 880 pounds of food every day. When it is done eating, it goes promptly to sleep.",
      },
    ],
  },
  {
    id: "sv8pt5-76",
    name: "Snorlax ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "260",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Strength",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
      {
        name: "Toss-and-Turn Press",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120×",
        text: "Flip 3 coins. This attack does 120 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "76",
    nationalPokedexNumbers: [143],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/76.png",
      large: "https://images.pokemontcg.io/sv8pt5/76_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/76.png",
          large: "https://images.pokemontcg.io/sv8pt5/76_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-46",
    name: "Snorunt",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Chilly",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "46",
    flavorText:
      "In some snowy lands, certain folklore says a house will prosper if a Snorunt lives there.",
    nationalPokedexNumbers: [361],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-46/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-46/large",
    },
    altArts: [
      {
        id: "me2pt5-46",
        number: "46",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-46/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-46/large",
        },
        flavorText:
          "In some snowy lands, certain folklore says a house will prosper if a Snorunt lives there.",
      },
      {
        id: "me2pt5-227",
        number: "227",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-227/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-227/large",
        },
        flavorText:
          "In some snowy lands, certain folklore says a house will prosper if a Snorunt lives there.",
      },
    ],
  },
  {
    id: "sv6-51",
    name: "Snorunt",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Glalie", "Froslass"],
    attacks: [
      {
        name: "Astonish",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Choose a random card from your opponent's hand. Your opponent reveals that card and shuffles it into their deck.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    flavorText:
      "It is said that a home visited by a Snorunt will prosper. It can withstand cold of −150 degrees Fahrenheit.",
    nationalPokedexNumbers: [361],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/51.png",
      large: "https://images.pokemontcg.io/sv6/51_hires.png",
    },
    altArts: [
      {
        id: "sv6-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv6/51.png",
          large: "https://images.pokemontcg.io/sv6/51_hires.png",
        },
        flavorText:
          "It is said that a home visited by a Snorunt will prosper. It can withstand cold of −150 degrees Fahrenheit.",
      },
    ],
  },
  {
    id: "me1-35",
    name: "Snover",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Water"],
    evolvesTo: ["Abomasnow"],
    attacks: [
      {
        name: "Beat",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Icy Snow",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "35",
    nationalPokedexNumbers: [459],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/35.png",
      large: "https://images.pokemontcg.io/me1/35_hires.png",
    },
    altArts: [
      {
        id: "me1-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/me1/35.png",
          large: "https://images.pokemontcg.io/me1/35_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/me1/140.png",
          large: "https://images.pokemontcg.io/me1/140_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-59",
    name: "Snover",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Water"],
    evolvesTo: ["Abomasnow"],
    attacks: [
      {
        name: "Light Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
      {
        name: "Icicle",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "59",
    nationalPokedexNumbers: [459],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/59.png",
      large: "https://images.pokemontcg.io/sv10/59_hires.png",
    },
    altArts: [
      {
        id: "sv10-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/sv10/59.png",
          large: "https://images.pokemontcg.io/sv10/59_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-37",
    name: "Snubbull",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Granbull"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    flavorText:
      "In truth, it is a cowardly Pokémon. It growls eagerly in order to hide its fear from its opponent.",
    nationalPokedexNumbers: [209],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/37.png",
      large: "https://images.pokemontcg.io/me2/37_hires.png",
    },
    altArts: [
      {
        id: "me2-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/me2/37.png",
          large: "https://images.pokemontcg.io/me2/37_hires.png",
        },
        flavorText:
          "In truth, it is a cowardly Pokémon. It growls eagerly in order to hide its fear from its opponent.",
      },
    ],
  },
  {
    id: "me1-39",
    name: "Sobble",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Drizzile"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    nationalPokedexNumbers: [816],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/39.png",
      large: "https://images.pokemontcg.io/me1/39_hires.png",
    },
    altArts: [
      {
        id: "me1-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/me1/39.png",
          large: "https://images.pokemontcg.io/me1/39_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-105",
    name: "Solgaleo",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Metal"],
    evolvesFrom: "Cosmoem",
    abilities: [
      {
        name: "Sunrise",
        text: "Once during your turn, if this Pokémon is on your Bench, you may use this Ability. Search your deck for up to 2 Basic Metal Energy cards and attach them to this Pokémon. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Sunsteel Strike",
        cost: ["Metal", "Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "220",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "105",
    nationalPokedexNumbers: [791],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-105/small",
      large: "https://images.scrydex.com/pokemon/me55-105/large",
    },
    altArts: [
      {
        id: "me55-105",
        number: "105",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-105/small",
          large: "https://images.scrydex.com/pokemon/me55-105/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-89",
    name: "Solgaleo-GX",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "GX"],
    hp: "250",
    types: ["Metal"],
    evolvesFrom: "Cosmoem",
    rules: [
      "When your Pokémon-GX is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Ultra Road",
        text: "Once during your turn (before your attack), you may switch your Active Pokémon with 1 of your Benched Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Sunsteel Strike",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "230",
        text: "Discard all Energy from this Pokémon.",
      },
      {
        name: "Sol Burst-GX",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        text: "Search your deck for up to 5 Energy cards and attach them to your Pokémon in any way you like. Then, shuffle your deck. (You can't use more than 1 GX attack in a game.)",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Psychic",
        value: "-20",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "89",
    nationalPokedexNumbers: [791],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-89/small",
      large: "https://images.scrydex.com/pokemon/me55c-89/large",
    },
    altArts: [
      {
        id: "me55c-89",
        number: "89",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-89/small",
          large: "https://images.scrydex.com/pokemon/me55c-89/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-37",
    name: "Solosis",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Psychic"],
    evolvesTo: ["Duosion"],
    attacks: [
      {
        name: "Rollout",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    flavorText:
      "They drive away attackers by unleashing psychic power. They can use telepathy to talk with others.",
    nationalPokedexNumbers: [577],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/37.png",
      large: "https://images.pokemontcg.io/zsv10pt5/37_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/37.png",
          large: "https://images.pokemontcg.io/zsv10pt5/37_hires.png",
        },
        flavorText:
          "They drive away attackers by unleashing psychic power. They can use telepathy to talk with others.",
      },
      {
        id: "zsv10pt5-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/118.png",
          large: "https://images.pokemontcg.io/zsv10pt5/118_hires.png",
        },
        flavorText:
          "They drive away attackers by unleashing psychic power. They can use telepathy to talk with others.",
      },
    ],
  },
  {
    id: "sv5-70",
    name: "Solosis",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Psychic"],
    evolvesTo: ["Duosion"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "70",
    flavorText:
      "It communicates with others telepathically. Its body is encapsulated in liquid, but if it takes a heavy blow, the liquid will leak out.",
    nationalPokedexNumbers: [577],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/70.png",
      large: "https://images.pokemontcg.io/sv5/70_hires.png",
    },
    altArts: [
      {
        id: "sv5-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv5/70.png",
          large: "https://images.pokemontcg.io/sv5/70_hires.png",
        },
        flavorText:
          "It communicates with others telepathically. Its body is encapsulated in liquid, but if it takes a heavy blow, the liquid will leak out.",
      },
    ],
  },
  {
    id: "me1-75",
    name: "Solrock",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Cosmic Beam",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "70",
        text: "If you don't have Lunatone on your Bench, this attack does nothing. This attack's damage isn't affected by Weakness or Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "75",
    nationalPokedexNumbers: [338],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/75.png",
      large: "https://images.pokemontcg.io/me1/75_hires.png",
    },
    altArts: [
      {
        id: "me1-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/me1/75.png",
          large: "https://images.pokemontcg.io/me1/75_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-106",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-106/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-106/large",
        },
        flavorText:
          "Solar energy is the source of its power, so it is strong during the daytime. When it spins, its body shines.",
      },
    ],
  },
  {
    id: "me1-102",
    name: "Spearow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Fearow"],
    attacks: [
      {
        name: "Pluck",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "102",
    nationalPokedexNumbers: [21],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/102.png",
      large: "https://images.pokemontcg.io/me1/102_hires.png",
    },
    altArts: [
      {
        id: "me1-102",
        number: "102",
        images: {
          small: "https://images.pokemontcg.io/me1/102.png",
          large: "https://images.pokemontcg.io/me1/102_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/me1/151.png",
          large: "https://images.pokemontcg.io/me1/151_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-98",
    name: "Spectrier",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Spooky Shot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Phantasmal Barrage",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Energy from this Pokémon and place 12 damage counters on 1 of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "98",
    flavorText:
      "It probes its surroundings with all its senses save one—it doesn’t use its sense of sight. Spectrier’s kicks are said to separate soul from body.",
    nationalPokedexNumbers: [897],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-98/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-98/large",
    },
    altArts: [
      {
        id: "me2pt5-98",
        number: "98",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-98/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-98/large",
        },
        flavorText:
          "It probes its surroundings with all its senses save one—it doesn’t use its sense of sight. Spectrier’s kicks are said to separate soul from body.",
      },
    ],
  },
  {
    id: "me3-8",
    name: "Spewpa",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Grass"],
    evolvesFrom: "Scatterbug",
    attacks: [
      {
        name: "Hide",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "8",
    nationalPokedexNumbers: [665],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-8/small",
      large: "https://images.scrydex.com/pokemon/me3-8/large",
    },
    altArts: [
      {
        id: "me3-8",
        number: "8",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-8/small",
          large: "https://images.scrydex.com/pokemon/me3-8/large",
        },
        flavorText: "",
      },
      {
        id: "me3-89",
        number: "89",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-89/small",
          large: "https://images.scrydex.com/pokemon/me3-89/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-6",
    name: "Spewpa",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Grass"],
    evolvesFrom: "Scatterbug",
    evolvesTo: ["Vivillon"],
    attacks: [
      {
        name: "Wander About",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
      {
        name: "Tackle",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "6",
    nationalPokedexNumbers: [665],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/6.png",
      large: "https://images.pokemontcg.io/sv8/6_hires.png",
    },
    altArts: [
      {
        id: "sv8-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv8/6.png",
          large: "https://images.pokemontcg.io/sv8/6_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-43",
    name: "Spheal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Sealeo"],
    attacks: [
      {
        name: "Powder Snow",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "43",
    nationalPokedexNumbers: [363],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/43.png",
      large: "https://images.pokemontcg.io/sv8/43_hires.png",
    },
    altArts: [
      {
        id: "sv8-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv8/43.png",
          large: "https://images.pokemontcg.io/sv8/43_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-199",
        number: "199",
        images: {
          small: "https://images.pokemontcg.io/sv8/199.png",
          large: "https://images.pokemontcg.io/sv8/199_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-1",
    name: "Spinarak",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Gooey Thread",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    nationalPokedexNumbers: [167],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-1/small",
      large: "https://images.scrydex.com/pokemon/me3-1/large",
    },
    altArts: [
      {
        id: "me3-1",
        number: "1",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-1/small",
          large: "https://images.scrydex.com/pokemon/me3-1/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-4",
    name: "Spinarak",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Ariados"],
    attacks: [
      {
        name: "Bug Bite",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "4",
    flavorText:
      "Some fishers weave its sturdy thread into nets to catch fish Pokémon.",
    nationalPokedexNumbers: [167],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/4.png",
      large: "https://images.pokemontcg.io/sv6/4_hires.png",
    },
    altArts: [
      {
        id: "sv6-4",
        number: "4",
        images: {
          small: "https://images.pokemontcg.io/sv6/4.png",
          large: "https://images.pokemontcg.io/sv6/4_hires.png",
        },
        flavorText:
          "Some fishers weave its sturdy thread into nets to catch fish Pokémon.",
      },
    ],
  },
  {
    id: "me1-87",
    name: "Spiritomb",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    abilities: [
      {
        name: "Spiteful Swirl",
        text: "If your Active Darkness Pokémon is damaged by an attack from your opponent's Pokémon (even if your Active Darkness Pokémon is Knocked Out), place 1 damage counter on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mountain Breaker",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "87",
    nationalPokedexNumbers: [442],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/87.png",
      large: "https://images.pokemontcg.io/me1/87_hires.png",
    },
    altArts: [
      {
        id: "me1-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/me1/87.png",
          large: "https://images.pokemontcg.io/me1/87_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/me1/148.png",
          large: "https://images.pokemontcg.io/me1/148_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-35",
    name: "Spiritomb",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Spiritual End",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "If you have 13 or more Pokémon that have the Hide 'n' Sneak Ability in your discard pile, choose 2 of your opponent's Pokémon and quadruple the number of damage counters on each of them.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    flavorText:
      "It was formed by uniting 108 spirits. It has been bound to the Odd Keystone to keep it from doing any mischief.",
    nationalPokedexNumbers: [442],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-35/small",
      large: "https://images.scrydex.com/pokemon/me5-35/large",
    },
    altArts: [
      {
        id: "me5-35",
        number: "35",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-35/small",
          large: "https://images.scrydex.com/pokemon/me5-35/large",
        },
        flavorText:
          "It was formed by uniting 108 spirits. It has been bound to the Odd Keystone to keep it from doing any mischief.",
      },
    ],
  },
  {
    id: "me1-62",
    name: "Spoink",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Grumpig"],
    attacks: [
      {
        name: "Triple Spin",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 3 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    nationalPokedexNumbers: [325],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/62.png",
      large: "https://images.pokemontcg.io/me1/62_hires.png",
    },
    altArts: [
      {
        id: "me1-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/me1/62.png",
          large: "https://images.pokemontcg.io/me1/62_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-16",
    name: "Sprigatito",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Tons of Treading",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 3 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    nationalPokedexNumbers: [906],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/16.png",
      large: "https://images.pokemontcg.io/sv9/16_hires.png",
    },
    altArts: [
      {
        id: "sv9-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv9/16.png",
          large: "https://images.pokemontcg.io/sv9/16_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-251",
    name: "Sprigatito ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "200",
    types: ["Grass"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Scratch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Magical Leaf",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "251",
    nationalPokedexNumbers: [906],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-251/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-251/large",
    },
    altArts: [
      {
        id: "me2pt5-251",
        number: "251",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-251/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-251/large",
        },
        flavorText: "",
      },
      {
        id: "svp-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/svp/87.png",
          large: "https://images.pokemontcg.io/svp/87_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-35",
    name: "Spritzee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Sweet Scent",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 30 damage from 1 of your Pokémon.",
      },
      {
        name: "Ram",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    nationalPokedexNumbers: [682],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-35/small",
      large: "https://images.scrydex.com/pokemon/me3-35/large",
    },
    altArts: [
      {
        id: "me3-35",
        number: "35",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-35/small",
          large: "https://images.scrydex.com/pokemon/me3-35/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-38",
    name: "Spritzee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Aromatisse"],
    attacks: [
      {
        name: "Fairy Wind",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "38",
    nationalPokedexNumbers: [682],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/38.png",
      large: "https://images.pokemontcg.io/sv8pt5/38_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/38.png",
          large: "https://images.pokemontcg.io/sv8pt5/38_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-160",
    name: "Squawkabilly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Push Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "160",
    nationalPokedexNumbers: [931],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/160.png",
      large: "https://images.pokemontcg.io/sv10/160_hires.png",
    },
    altArts: [
      {
        id: "sv10-160",
        number: "160",
        images: {
          small: "https://images.pokemontcg.io/sv10/160.png",
          large: "https://images.pokemontcg.io/sv10/160_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-141",
    name: "Squawkabilly",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Add On",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 2 cards.",
      },
      {
        name: "Hyper Voice",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "141",
    nationalPokedexNumbers: [931],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/141.png",
      large: "https://images.pokemontcg.io/sv9/141_hires.png",
    },
    altArts: [
      {
        id: "sv9-141",
        number: "141",
        images: {
          small: "https://images.pokemontcg.io/sv9/141.png",
          large: "https://images.pokemontcg.io/sv9/141_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-20",
    name: "Staryu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Water Gun",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "20",
    nationalPokedexNumbers: [120],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-20/small",
      large: "https://images.scrydex.com/pokemon/me3-20/large",
    },
    altArts: [
      {
        id: "me3-20",
        number: "20",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-20/small",
          large: "https://images.scrydex.com/pokemon/me3-20/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-93",
    name: "Steelix",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "200",
    types: ["Metal"],
    evolvesFrom: "Onix",
    attacks: [
      {
        name: "Welcoming Tail",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40+",
        text: "If you have exactly 6 Prize cards remaining, this attack does 200 more damage.",
      },
      {
        name: "Skull Bash",
        cost: ["Metal", "Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "93",
    nationalPokedexNumbers: [208],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/93.png",
      large: "https://images.pokemontcg.io/me1/93_hires.png",
    },
    altArts: [
      {
        id: "me1-93",
        number: "93",
        images: {
          small: "https://images.pokemontcg.io/me1/93.png",
          large: "https://images.pokemontcg.io/me1/93_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/me1/150.png",
          large: "https://images.pokemontcg.io/me1/150_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-83",
    name: "Steven's Baltoy",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Claydol"],
    attacks: [
      {
        name: "Summoning Sign",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Steven's Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Psychic Sphere",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "83",
    nationalPokedexNumbers: [343],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/83.png",
      large: "https://images.pokemontcg.io/sv10/83_hires.png",
    },
    altArts: [
      {
        id: "sv10-83",
        number: "83",
        images: {
          small: "https://images.pokemontcg.io/sv10/83.png",
          large: "https://images.pokemontcg.io/sv10/83_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-143",
    name: "Steven's Beldum",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    evolvesTo: ["Metang"],
    attacks: [
      {
        name: "Ram",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "143",
    nationalPokedexNumbers: [374],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/143.png",
      large: "https://images.pokemontcg.io/sv10/143_hires.png",
    },
    altArts: [
      {
        id: "sv10-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/sv10/143.png",
          large: "https://images.pokemontcg.io/sv10/143_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-86",
    name: "Steven's Carbink",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    abilities: [
      {
        name: "Stone Palace",
        text: "As long as this Pokémon is on your Bench, all of your Steven's Pokémon take 30 less damage from attacks from your opponent's Pokémon (after applying Weakness and Resistance). The effect of Stone Palace doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "86",
    nationalPokedexNumbers: [703],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/86.png",
      large: "https://images.pokemontcg.io/sv10/86_hires.png",
    },
    altArts: [
      {
        id: "sv10-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv10/86.png",
          large: "https://images.pokemontcg.io/sv10/86_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-84",
    name: "Steven's Claydol",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Steven's Baltoy",
    attacks: [
      {
        name: "Eerie Light",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Clay Blast",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "220",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "84",
    nationalPokedexNumbers: [344],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/84.png",
      large: "https://images.pokemontcg.io/sv10/84_hires.png",
    },
    altArts: [
      {
        id: "sv10-84",
        number: "84",
        images: {
          small: "https://images.pokemontcg.io/sv10/84.png",
          large: "https://images.pokemontcg.io/sv10/84_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-289",
    name: "Steven's Metagross ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "340",
    types: ["Metal"],
    evolvesFrom: "Steven's Metang",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "X-Boot",
        text: "Once during your turn, you may search your deck for a Basic Psychic Energy card, a Basic Metal Energy card, or 1 of each and attach them to your Psychic Pokémon and Metal Pokémon in any way you like. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Metal Stomp",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "200",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "289",
    nationalPokedexNumbers: [376],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-289/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-289/large",
    },
    altArts: [
      {
        id: "me2pt5-289",
        number: "289",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-289/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-289/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/sv10/145.png",
          large: "https://images.pokemontcg.io/sv10/145_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-144",
    name: "Steven's Metang",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Metal"],
    evolvesFrom: "Steven's Beldum",
    evolvesTo: ["Metagross"],
    attacks: [
      {
        name: "Metal Slash",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "144",
    nationalPokedexNumbers: [375],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/144.png",
      large: "https://images.pokemontcg.io/sv10/144_hires.png",
    },
    altArts: [
      {
        id: "sv10-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/sv10/144.png",
          large: "https://images.pokemontcg.io/sv10/144_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-142",
    name: "Steven's Skarmory",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Metal"],
    attacks: [
      {
        name: "Razor Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Sonic Double",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 50 damage to 2 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "142",
    nationalPokedexNumbers: [227],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/142.png",
      large: "https://images.pokemontcg.io/sv10/142_hires.png",
    },
    altArts: [
      {
        id: "sv10-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/sv10/142.png",
          large: "https://images.pokemontcg.io/sv10/142_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-81",
    name: "Stonjourner",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Stony Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "This attack also does 20 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Boundless Power",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "81",
    nationalPokedexNumbers: [874],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/81.png",
      large: "https://images.pokemontcg.io/me1/81_hires.png",
    },
    altArts: [
      {
        id: "me1-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/me1/81.png",
          large: "https://images.pokemontcg.io/me1/81_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-76",
    name: "Stoutland",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Colorless"],
    evolvesFrom: "Herdier",
    attacks: [
      {
        name: "Odor Sleuth",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Flip 3 coins. Put a number of cards up to the number of heads from your discard pile into your hand.",
      },
      {
        name: "Special Fang",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100+",
        text: "If this Pokémon has any Special Energy attached, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "76",
    flavorText:
      "It rescues people stranded by blizzards in the mountains. Its shaggy fur shields it from the cold.",
    nationalPokedexNumbers: [508],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/76.png",
      large: "https://images.pokemontcg.io/rsv10pt5/76_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-76",
        number: "76",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/76.png",
          large: "https://images.pokemontcg.io/rsv10pt5/76_hires.png",
        },
        flavorText:
          "It rescues people stranded by blizzards in the mountains. Its shaggy fur shields it from the cold.",
      },
      {
        id: "rsv10pt5-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/156.png",
          large: "https://images.pokemontcg.io/rsv10pt5/156_hires.png",
        },
        flavorText:
          "It rescues people stranded by blizzards in the mountains. Its shaggy fur shields it from the cold.",
      },
    ],
  },
  {
    id: "me1-111",
    name: "Stufful",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Bewear"],
    attacks: [
      {
        name: "Light Punch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Flop",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "111",
    nationalPokedexNumbers: [759],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/111.png",
      large: "https://images.pokemontcg.io/me1/111_hires.png",
    },
    altArts: [
      {
        id: "me1-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/me1/111.png",
          large: "https://images.pokemontcg.io/me1/111_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/me1/154.png",
          large: "https://images.pokemontcg.io/me1/154_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-52",
    name: "Stufful",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Colorless"],
    evolvesTo: ["Bewear"],
    attacks: [
      {
        name: "Take Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "52",
    nationalPokedexNumbers: [759],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/52.png",
      large: "https://images.pokemontcg.io/sv6pt5/52_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/52.png",
          large: "https://images.pokemontcg.io/sv6pt5/52_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-35",
    name: "Stunfisk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Lightning"],
    attacks: [
      {
        name: "Muddy Bolt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If this Pokémon has any Fighting Energy attached, this attack does 20 more damage.",
      },
      {
        name: "Flop",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "35",
    flavorText:
      "Its skin is very hard, so it is unhurt even if stepped on by sumo wrestlers. It smiles when transmitting electricity.",
    nationalPokedexNumbers: [618],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/35.png",
      large: "https://images.pokemontcg.io/rsv10pt5/35_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/35.png",
          large: "https://images.pokemontcg.io/rsv10pt5/35_hires.png",
        },
        flavorText:
          "Its skin is very hard, so it is unhurt even if stepped on by sumo wrestlers. It smiles when transmitting electricity.",
      },
      {
        id: "rsv10pt5-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/118.png",
          large: "https://images.pokemontcg.io/rsv10pt5/118_hires.png",
        },
        flavorText:
          "Its skin is very hard, so it is unhurt even if stepped on by sumo wrestlers. It smiles when transmitting electricity.",
      },
    ],
  },
  {
    id: "me2pt5-62",
    name: "Stunfisk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Lightning"],
    attacks: [
      {
        name: "Pouncing Trap",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat. During your next turn, the Defending Pokémon takes 100 more damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "62",
    flavorText:
      "It conceals itself in the mud of the seashore. Then it waits. When prey touch it, it delivers a jolt of electricity.",
    nationalPokedexNumbers: [618],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-62/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-62/large",
    },
    altArts: [
      {
        id: "me2pt5-62",
        number: "62",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-62/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-62/large",
        },
        flavorText:
          "It conceals itself in the mud of the seashore. Then it waits. When prey touch it, it delivers a jolt of electricity.",
      },
    ],
  },
  {
    id: "sv8-64",
    name: "Stunfisk",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Lightning"],
    attacks: [
      {
        name: "Paralyzing Crackle",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed, and discard an Energy from that Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "64",
    nationalPokedexNumbers: [618],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/64.png",
      large: "https://images.pokemontcg.io/sv8/64_hires.png",
    },
    altArts: [
      {
        id: "sv8-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv8/64.png",
          large: "https://images.pokemontcg.io/sv8/64_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-202",
        number: "202",
        images: {
          small: "https://images.pokemontcg.io/sv8/202.png",
          large: "https://images.pokemontcg.io/sv8/202_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-114",
    name: "Stunfisk ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Fighting"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Big Bite",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Flopping Trap",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If this Pokémon has any damage counters on it, this attack does 100 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "114",
    nationalPokedexNumbers: [618],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-114/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-114/large",
    },
    altArts: [
      {
        id: "me2pt5-114",
        number: "114",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-114/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-114/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-252",
        number: "252",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-252/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-252/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-53",
    name: "Stunky",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "53",
    flavorText:
      "The foul fluid from its rear is so revolting that it can make people feel queasy up to a mile and a quarter away.",
    nationalPokedexNumbers: [434],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-53/small",
      large: "https://images.scrydex.com/pokemon/me4-53/large",
    },
    altArts: [
      {
        id: "me4-53",
        number: "53",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-53/small",
          large: "https://images.scrydex.com/pokemon/me4-53/large",
        },
        flavorText:
          "The foul fluid from its rear is so revolting that it can make people feel queasy up to a mile and a quarter away.",
      },
    ],
  },
  {
    id: "me4-43",
    name: "Sudowoodo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Fighting"],
    attacks: [
      {
        name: "Trials and Trip-ulations",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Transformation Tome cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Rock Hurl",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This attack's damage isn't affected by Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "43",
    flavorText:
      "To avoid being attacked, it does nothing but mimic a tree. It hates water and flees from rain.",
    nationalPokedexNumbers: [185],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-43/small",
      large: "https://images.scrydex.com/pokemon/me4-43/large",
    },
    altArts: [
      {
        id: "me4-43",
        number: "43",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-43/small",
          large: "https://images.scrydex.com/pokemon/me4-43/large",
        },
        flavorText:
          "To avoid being attacked, it does nothing but mimic a tree. It hates water and flees from rain.",
      },
    ],
  },
  {
    id: "me2-26",
    name: "Suicune",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Crystal Fall",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If you have at least 4 Water Energy in play, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "26",
    flavorText:
      "Said to be the embodiment of north winds, it can instantly purify filthy, murky water.",
    nationalPokedexNumbers: [245],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/26.png",
      large: "https://images.pokemontcg.io/me2/26_hires.png",
    },
    altArts: [
      {
        id: "me2-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/me2/26.png",
          large: "https://images.pokemontcg.io/me2/26_hires.png",
        },
        flavorText:
          "Said to be the embodiment of north winds, it can instantly purify filthy, murky water.",
      },
    ],
  },
  {
    id: "sv8pt5-24",
    name: "Suicune",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Water"],
    attacks: [
      {
        name: "Overrun",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Aurora Beam",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    nationalPokedexNumbers: [245],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/24.png",
      large: "https://images.pokemontcg.io/sv8pt5/24_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/24.png",
          large: "https://images.pokemontcg.io/sv8pt5/24_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-7",
    name: "Sunflora",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Sunkern",
    attacks: [
      {
        name: "Redirected Sunlight",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "60×",
        text: "This attack does 60 damage for each Fire Energy attached to all of your opponent's Pokémon.",
      },
      {
        name: "Mega Drain",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    flavorText:
      "Since it converts sunlight into energy, it is always looking in the direction of the sun.",
    nationalPokedexNumbers: [192],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/7.png",
      large: "https://images.pokemontcg.io/sv6/7_hires.png",
    },
    altArts: [
      {
        id: "sv6-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv6/7.png",
          large: "https://images.pokemontcg.io/sv6/7_hires.png",
        },
        flavorText:
          "Since it converts sunlight into energy, it is always looking in the direction of the sun.",
      },
      {
        id: "sv6-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/sv6/169.png",
          large: "https://images.pokemontcg.io/sv6/169_hires.png",
        },
        flavorText:
          "Since it converts sunlight into energy, it is always looking in the direction of the sun.",
      },
    ],
  },
  {
    id: "sv6-6",
    name: "Sunkern",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Grass"],
    evolvesTo: ["Sunflora"],
    attacks: [
      {
        name: "Bullet Seed",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 4 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "6",
    flavorText:
      "It is very weak. Its only means of defense is to shake its leaves desperately at its attacker.",
    nationalPokedexNumbers: [191],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/6.png",
      large: "https://images.pokemontcg.io/sv6/6_hires.png",
    },
    altArts: [
      {
        id: "sv6-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv6/6.png",
          large: "https://images.pokemontcg.io/sv6/6_hires.png",
        },
        flavorText:
          "It is very weak. Its only means of defense is to shake its leaves desperately at its attacker.",
      },
    ],
  },
  {
    id: "sv8-148",
    name: "Swablu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Colorless"],
    evolvesTo: ["Altaria"],
    attacks: [
      {
        name: "Disarming Voice",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "148",
    nationalPokedexNumbers: [333],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/148.png",
      large: "https://images.pokemontcg.io/sv8/148_hires.png",
    },
    altArts: [
      {
        id: "sv8-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/sv8/148.png",
          large: "https://images.pokemontcg.io/sv8/148_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-2",
    name: "Swadloon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Grass"],
    evolvesFrom: "Sewaddle",
    evolvesTo: ["Leavanny"],
    abilities: [
      {
        name: "Healing Leaves",
        text: "Once during your turn, you may heal 20 damage from your Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Bug Buzz",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "2",
    flavorText:
      "Forests where Swadloon live have superb foliage because the nutrients they make from fallen leaves nourish the plant life.",
    nationalPokedexNumbers: [541],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/2.png",
      large: "https://images.pokemontcg.io/rsv10pt5/2_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/2.png",
          large: "https://images.pokemontcg.io/rsv10pt5/2_hires.png",
        },
        flavorText:
          "Forests where Swadloon live have superb foliage because the nutrients they make from fallen leaves nourish the plant life.",
      },
      {
        id: "rsv10pt5-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/88.png",
          large: "https://images.pokemontcg.io/rsv10pt5/88_hires.png",
        },
        flavorText:
          "Forests where Swadloon live have superb foliage because the nutrients they make from fallen leaves nourish the plant life.",
      },
    ],
  },
  {
    id: "sv7-92",
    name: "Swalot",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Gulpin",
    attacks: [
      {
        name: "Devouring Mouth",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "If this Pokémon has more Energy attached than your opponent's Active Pokémon, this attack does 160 more damage.",
      },
      {
        name: "Venomous Hit",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "92",
    nationalPokedexNumbers: [317],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/92.png",
      large: "https://images.pokemontcg.io/sv7/92_hires.png",
    },
    altArts: [
      {
        id: "sv7-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv7/92.png",
          large: "https://images.pokemontcg.io/sv7/92_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-26",
    name: "Swanna",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Water"],
    evolvesFrom: "Ducklett",
    attacks: [
      {
        name: "Flap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Air Slash",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    flavorText:
      "Swanna start to dance at dusk. The one dancing in the middle is the leader of the flock.",
    nationalPokedexNumbers: [581],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/26.png",
      large: "https://images.pokemontcg.io/rsv10pt5/26_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/26.png",
          large: "https://images.pokemontcg.io/rsv10pt5/26_hires.png",
        },
        flavorText:
          "Swanna start to dance at dusk. The one dancing in the middle is the leader of the flock.",
      },
      {
        id: "rsv10pt5-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/110.png",
          large: "https://images.pokemontcg.io/rsv10pt5/110_hires.png",
        },
        flavorText:
          "Swanna start to dance at dusk. The one dancing in the middle is the leader of the flock.",
      },
    ],
  },
  {
    id: "sv6-140",
    name: "Swanna",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Colorless"],
    evolvesFrom: "Ducklett",
    attacks: [
      {
        name: "Fighting Wings",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If your opponent's Active Pokémon is a Pokémon ex or Pokémon V, this attack does 90 more damage.",
      },
      {
        name: "Gust",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "140",
    flavorText:
      "It's said that many artists have taken inspiration from the sight of a Swanna performing a beautiful dance in the light of dawn.",
    nationalPokedexNumbers: [581],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/140.png",
      large: "https://images.pokemontcg.io/sv6/140_hires.png",
    },
    altArts: [
      {
        id: "sv6-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/sv6/140.png",
          large: "https://images.pokemontcg.io/sv6/140_hires.png",
        },
        flavorText:
          "It's said that many artists have taken inspiration from the sight of a Swanna performing a beautiful dance in the light of dawn.",
      },
    ],
  },
  {
    id: "sv10-157",
    name: "Swellow",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Taillow",
    attacks: [
      {
        name: "Add On",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 3 cards.",
      },
      {
        name: "Speed Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "157",
    nationalPokedexNumbers: [277],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/157.png",
      large: "https://images.pokemontcg.io/sv10/157_hires.png",
    },
    altArts: [
      {
        id: "sv10-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/sv10/157.png",
          large: "https://images.pokemontcg.io/sv10/157_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-23",
    name: "Swinub",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Piloswine"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Icy Snow",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    flavorText:
      "It searches for food by digging into the ground with its snout. Even frozen ground doesn't give it any trouble.",
    nationalPokedexNumbers: [220],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/23.png",
      large: "https://images.pokemontcg.io/me2/23_hires.png",
    },
    altArts: [
      {
        id: "me2-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/me2/23.png",
          large: "https://images.pokemontcg.io/me2/23_hires.png",
        },
        flavorText:
          "It searches for food by digging into the ground with its snout. Even frozen ground doesn't give it any trouble.",
      },
    ],
  },
  {
    id: "sv9-77",
    name: "Swinub",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Piloswine"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Lunge Out",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "77",
    nationalPokedexNumbers: [220],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/77.png",
      large: "https://images.pokemontcg.io/sv9/77_hires.png",
    },
    altArts: [
      {
        id: "sv9-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/sv9/77.png",
          large: "https://images.pokemontcg.io/sv9/77_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/sv9/165.png",
          large: "https://images.pokemontcg.io/sv9/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-93",
    name: "Swirlix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Ram",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "93",
    nationalPokedexNumbers: [684],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-93/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-93/large",
    },
    altArts: [
      {
        id: "me2pt5-93",
        number: "93",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-93/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-93/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-89",
    name: "Swirlix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    evolvesTo: ["Slurpuff"],
    abilities: [
      {
        name: "Festival Lead",
        text: "If Festival Grounds is in play, this Pokémon may use an attack it has twice. If the first attack Knocks Out your opponent's Active Pokémon, you may attack again after your opponent chooses a new Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Sneaky Placement",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put 2 damage counters on 1 of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "89",
    flavorText:
      "It eats its own weight in sugar every day. If it doesn't get enough sugar, it becomes incredibly grumpy.",
    nationalPokedexNumbers: [684],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/89.png",
      large: "https://images.pokemontcg.io/sv6/89_hires.png",
    },
    altArts: [
      {
        id: "sv6-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/sv6/89.png",
          large: "https://images.pokemontcg.io/sv6/89_hires.png",
        },
        flavorText:
          "It eats its own weight in sugar every day. If it doesn't get enough sugar, it becomes incredibly grumpy.",
      },
    ],
  },
  {
    id: "rsv10pt5-37",
    name: "Swoobat",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Woobat",
    attacks: [
      {
        name: "Happy Return",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put 1 of your Benched Pokémon and all attached cards into your hand.",
      },
      {
        name: "Gust",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    flavorText:
      "It emits sound waves of various frequencies from its nose, including some powerful enough to destroy rocks.",
    nationalPokedexNumbers: [528],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/37.png",
      large: "https://images.pokemontcg.io/rsv10pt5/37_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/37.png",
          large: "https://images.pokemontcg.io/rsv10pt5/37_hires.png",
        },
        flavorText:
          "It emits sound waves of various frequencies from its nose, including some powerful enough to destroy rocks.",
      },
      {
        id: "rsv10pt5-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/120.png",
          large: "https://images.pokemontcg.io/rsv10pt5/120_hires.png",
        },
        flavorText:
          "It emits sound waves of various frequencies from its nose, including some powerful enough to destroy rocks.",
      },
    ],
  },
  {
    id: "sv6pt5-22",
    name: "Sylveon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Eevee",
    attacks: [
      {
        name: "Mystical Return",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, choose 1 of your opponent's Benched Pokémon. Shuffle that Pokémon and all attached cards into their deck.",
      },
      {
        name: "Disarming Voice",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [700],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/22.png",
      large: "https://images.pokemontcg.io/sv6pt5/22_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/22.png",
          large: "https://images.pokemontcg.io/sv6pt5/22_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-40",
    name: "Sylveon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Psychic"],
    evolvesFrom: "Eevee",
    abilities: [
      {
        name: "Safeguard",
        text: "Prevent all damage done to this Pokémon by attacks from your opponent's Pokémon ex.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Magical Shot",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    nationalPokedexNumbers: [700],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/40.png",
      large: "https://images.pokemontcg.io/sv8pt5/40_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/40.png",
          large: "https://images.pokemontcg.io/sv8pt5/40_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-71",
    name: "Sylveon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Psychic"],
    evolvesFrom: "Eevee",
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Colorful Harmony",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50×",
        text: "This attack does 50 damage for each type of Basic Energy attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "71",
    nationalPokedexNumbers: [700],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-71/small",
      large: "https://images.scrydex.com/pokemon/me55-71/large",
    },
    altArts: [
      {
        id: "me55-71",
        number: "71",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-71/small",
          large: "https://images.scrydex.com/pokemon/me55-71/large",
        },
        flavorText: "",
      },
      {
        id: "me55-153",
        number: "153",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-153/small",
          large: "https://images.scrydex.com/pokemon/me55-153/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-86",
    name: "Sylveon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "270",
    types: ["Psychic"],
    evolvesFrom: "Eevee",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Magical Charm",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "During your opponent's next turn, attacks used by the Defending Pokémon do 100 less damage (before applying Weakness and Resistance).",
      },
      {
        name: "Angelite",
        cost: ["Water", "Lightning", "Psychic"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Choose 2 of your opponent's Benched Pokémon. Shuffle those Pokémon and all attached cards into your opponent's deck. If 1 of your Pokémon used Angelite during your last turn, this attack can't be used.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "86",
    nationalPokedexNumbers: [700],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/86.png",
      large: "https://images.pokemontcg.io/sv8/86_hires.png",
    },
    altArts: [
      {
        id: "sv8-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/sv8/86.png",
          large: "https://images.pokemontcg.io/sv8/86_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/41.png",
          large: "https://images.pokemontcg.io/sv8pt5/41_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/156.png",
          large: "https://images.pokemontcg.io/sv8pt5/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-73",
    name: "Tadbulb",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Lightning"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Electro Ball",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    flavorText:
      "It floats using the electricity stored in its body. When thunderclouds are around, Tadbulb will float higher off the ground.",
    nationalPokedexNumbers: [938],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/73.png",
      large: "https://images.pokemontcg.io/sv6/73_hires.png",
    },
    altArts: [
      {
        id: "sv6-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv6/73.png",
          large: "https://images.pokemontcg.io/sv6/73_hires.png",
        },
        flavorText:
          "It floats using the electricity stored in its body. When thunderclouds are around, Tadbulb will float higher off the ground.",
      },
    ],
  },
  {
    id: "sv10-156",
    name: "Taillow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Swellow"],
    attacks: [
      {
        name: "Wing Attack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "156",
    nationalPokedexNumbers: [276],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/156.png",
      large: "https://images.pokemontcg.io/sv10/156_hires.png",
    },
    altArts: [
      {
        id: "sv10-156",
        number: "156",
        images: {
          small: "https://images.pokemontcg.io/sv10/156.png",
          large: "https://images.pokemontcg.io/sv10/156_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-14",
    name: "Talonflame",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Fire"],
    evolvesFrom: "Fletchinder",
    abilities: [
      {
        name: "Sky Hunt",
        text: "Once during your turn, you may use this Ability. Flip a coin. If heads, discard a random card from your opponent's hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Fire Wing",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "14",
    nationalPokedexNumbers: [663],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-14/small",
      large: "https://images.scrydex.com/pokemon/me3-14/large",
    },
    altArts: [
      {
        id: "me3-14",
        number: "14",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-14/small",
          large: "https://images.scrydex.com/pokemon/me3-14/large",
        },
        flavorText: "",
      },
      {
        id: "me3-91",
        number: "91",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-91/small",
          large: "https://images.scrydex.com/pokemon/me3-91/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-123",
    name: "Talonflame",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Colorless"],
    evolvesFrom: "Fletchinder",
    attacks: [
      {
        name: "Aero Chase",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "110+",
        text: "If the Retreat Cost of your opponent's Active Pokémon is ColorlessColorless or more, this attack does 110 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "123",
    nationalPokedexNumbers: [663],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/123.png",
      large: "https://images.pokemontcg.io/sv7/123_hires.png",
    },
    altArts: [
      {
        id: "sv7-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/sv7/123.png",
          large: "https://images.pokemontcg.io/sv7/123_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-157",
    name: "Tandemaus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Colorless"],
    attacks: [
      {
        name: "Play Rough",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 10 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "157",
    nationalPokedexNumbers: [924],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/157.png",
      large: "https://images.pokemontcg.io/sv8/157_hires.png",
    },
    altArts: [
      {
        id: "sv8-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/sv8/157.png",
          large: "https://images.pokemontcg.io/sv8/157_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-6",
    name: "Tangela",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    evolvesTo: ["Tangrowth"],
    attacks: [
      {
        name: "Poison Powder",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
      {
        name: "Hook",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "6",
    nationalPokedexNumbers: [114],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/6.png",
      large: "https://images.pokemontcg.io/me1/6_hires.png",
    },
    altArts: [
      {
        id: "me1-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/me1/6.png",
          large: "https://images.pokemontcg.io/me1/6_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-1",
    name: "Tangela",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    evolvesTo: ["Tangrowth"],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Vine Slap",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "1",
    flavorText:
      "Hidden beneath a tangle of vines that grows nonstop even if the vines are torn off, this Pokémon's true appearance remains a mystery.",
    nationalPokedexNumbers: [114],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/1.png",
      large: "https://images.pokemontcg.io/sv6/1_hires.png",
    },
    altArts: [
      {
        id: "sv6-1",
        number: "1",
        images: {
          small: "https://images.pokemontcg.io/sv6/1.png",
          large: "https://images.pokemontcg.io/sv6/1_hires.png",
        },
        flavorText:
          "Hidden beneath a tangle of vines that grows nonstop even if the vines are torn off, this Pokémon's true appearance remains a mystery.",
      },
    ],
  },
  {
    id: "me1-7",
    name: "Tangrowth",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Tangela",
    attacks: [
      {
        name: "Absorb",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
      {
        name: "Pumped-Up Whip",
        cost: ["Grass", "Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "120+",
        text: "If this Pokémon has at least 2 extra Energy attached (in addition to this attack's cost), this attack does 140 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "7",
    nationalPokedexNumbers: [465],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/7.png",
      large: "https://images.pokemontcg.io/me1/7_hires.png",
    },
    altArts: [
      {
        id: "me1-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/me1/7.png",
          large: "https://images.pokemontcg.io/me1/7_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-2",
    name: "Tangrowth",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Tangela",
    abilities: [
      {
        name: "Thicket Body",
        text: "This Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Loom Over",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150-",
        text: "This attack does 10 less damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "2",
    flavorText:
      "Tangrowth has two arms that it can extend as it pleases. Recent research has shown that these arms are, in fact, bundles of vines.",
    nationalPokedexNumbers: [465],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/2.png",
      large: "https://images.pokemontcg.io/sv6/2_hires.png",
    },
    altArts: [
      {
        id: "sv6-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv6/2.png",
          large: "https://images.pokemontcg.io/sv6/2_hires.png",
        },
        flavorText:
          "Tangrowth has two arms that it can extend as it pleases. Recent research has shown that these arms are, in fact, bundles of vines.",
      },
    ],
  },
  {
    id: "sv6pt5-6",
    name: "Tapu Bulu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Grass"],
    attacks: [
      {
        name: "Wood Hammer",
        cost: ["Grass", "Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "220",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "6",
    nationalPokedexNumbers: [787],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/6.png",
      large: "https://images.pokemontcg.io/sv6pt5/6_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-6",
        number: "6",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/6.png",
          large: "https://images.pokemontcg.io/sv6pt5/6_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/65.png",
          large: "https://images.pokemontcg.io/sv6pt5/65_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-67",
    name: "Tapu Koko",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Fast Flight",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "If you go first, you can use this attack during your first turn. Discard your hand and draw 5 cards.",
      },
      {
        name: "Thunder Blast",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    flavorText:
      "Although it’s called a guardian deity, if a person or Pokémon puts it in a bad mood, it will become a malevolent deity and attack.",
    nationalPokedexNumbers: [785],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-67/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-67/large",
    },
    altArts: [
      {
        id: "me2pt5-67",
        number: "67",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-67/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-67/large",
        },
        flavorText:
          "Although it’s called a guardian deity, if a person or Pokémon puts it in a bad mood, it will become a malevolent deity and attack.",
      },
    ],
  },
  {
    id: "sv8-65",
    name: "Tapu Koko",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Summon Lightning",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Lightning Pokémon, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Prize Count",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90+",
        text: "If you have more Prize cards remaining than your opponent, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "65",
    nationalPokedexNumbers: [785],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/65.png",
      large: "https://images.pokemontcg.io/sv8/65_hires.png",
    },
    altArts: [
      {
        id: "sv8-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv8/65.png",
          large: "https://images.pokemontcg.io/sv8/65_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-51",
    name: "Tapu Koko ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "200",
    types: ["Lightning"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Linked Lightning",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "This attack does 20 more damage for each of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "51",
    nationalPokedexNumbers: [785],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/51.png",
      large: "https://images.pokemontcg.io/sv9/51_hires.png",
    },
    altArts: [
      {
        id: "sv9-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv9/51.png",
          large: "https://images.pokemontcg.io/sv9/51_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-92",
    name: "Tapu Lele",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Perplex",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Mental Crush",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90+",
        text: "If your opponent's Active Pokémon is Confused, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "92",
    nationalPokedexNumbers: [786],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/92.png",
      large: "https://images.pokemontcg.io/sv8/92_hires.png",
    },
    altArts: [
      {
        id: "sv8-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv8/92.png",
          large: "https://images.pokemontcg.io/sv8/92_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-131",
    name: "Tatsugiri",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Dragon"],
    abilities: [
      {
        name: "Attract Customers",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may look at the top 6 cards of your deck, reveal a Supporter card you find there, and put it into your hand. Shuffle the other cards back into your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Surf",
        cost: ["Fire", "Water"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "131",
    flavorText:
      "Tatsugiri is an extremely cunning Pokémon. It feigns weakness to lure in prey, then orders its partner to attack.",
    nationalPokedexNumbers: [978],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/131.png",
      large: "https://images.pokemontcg.io/sv6/131_hires.png",
    },
    altArts: [
      {
        id: "sv6-131",
        number: "131",
        images: {
          small: "https://images.pokemontcg.io/sv6/131.png",
          large: "https://images.pokemontcg.io/sv6/131_hires.png",
        },
        flavorText:
          "Tatsugiri is an extremely cunning Pokémon. It feigns weakness to lure in prey, then orders its partner to attack.",
      },
      {
        id: "sv6-186",
        number: "186",
        images: {
          small: "https://images.pokemontcg.io/sv6/186.png",
          large: "https://images.pokemontcg.io/sv6/186_hires.png",
        },
        flavorText:
          "Tatsugiri is an extremely cunning Pokémon. It feigns weakness to lure in prey, then orders its partner to attack.",
      },
      {
        id: "svp-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/svp/118.png",
          large: "https://images.pokemontcg.io/svp/118_hires.png",
        },
        flavorText:
          "Tatsugiri is an extremely cunning Pokémon. It feigns weakness to lure in prey, then orders its partner to attack.",
      },
    ],
  },
  {
    id: "sv8-142",
    name: "Tatsugiri ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "160",
    types: ["Dragon"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Surprise Pump",
        cost: ["Fire", "Water"],
        convertedEnergyCost: 2,
        damage: "100",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
      {
        name: "Cinnabar Lure",
        cost: ["Fire", "Water", "Darkness"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Look at the top 10 cards of your deck. You may put any number of Pokémon you find there onto your Bench. Shuffle the other cards back into your deck.",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "142",
    nationalPokedexNumbers: [978],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/142.png",
      large: "https://images.pokemontcg.io/sv8/142_hires.png",
    },
    altArts: [
      {
        id: "sv8-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/sv8/142.png",
          large: "https://images.pokemontcg.io/sv8/142_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-226",
        number: "226",
        images: {
          small: "https://images.pokemontcg.io/sv8/226.png",
          large: "https://images.pokemontcg.io/sv8/226_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-69",
    name: "Tauros",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Colorless"],
    attacks: [
      {
        name: "Target Together",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Choose 1 of your opponent's Pokémon and flip a coin for each of your Pokémon in play that has \"Tauros\" in its name. This attack does 50 damage to the chosen Pokémon for each heads. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "69",
    flavorText:
      "They fight each other by locking horns. The herd's protectors take pride in their battle-scarred horns.",
    nationalPokedexNumbers: [128],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-69/small",
      large: "https://images.scrydex.com/pokemon/me4-69/large",
    },
    altArts: [
      {
        id: "me4-69",
        number: "69",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-69/small",
          large: "https://images.scrydex.com/pokemon/me4-69/large",
        },
        flavorText:
          "They fight each other by locking horns. The herd's protectors take pride in their battle-scarred horns.",
      },
      {
        id: "me4-96",
        number: "96",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-96/small",
          large: "https://images.scrydex.com/pokemon/me4-96/large",
        },
        flavorText:
          "They fight each other by locking horns. The herd's protectors take pride in their battle-scarred horns.",
      },
    ],
  },
  {
    id: "sv10-152",
    name: "Tauros",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Colorless"],
    attacks: [
      {
        name: "Horn Attack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Clean Hit",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If your opponent's Active Pokémon is an Evolution Pokémon, this attack does 50 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "152",
    nationalPokedexNumbers: [128],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/152.png",
      large: "https://images.pokemontcg.io/sv10/152_hires.png",
    },
    altArts: [
      {
        id: "sv10-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/sv10/152.png",
          large: "https://images.pokemontcg.io/sv10/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-112",
    name: "Tauros",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Destructive Horn",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "112",
    nationalPokedexNumbers: [128],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/112.png",
      large: "https://images.pokemontcg.io/sv7/112_hires.png",
    },
    altArts: [
      {
        id: "sv7-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/sv7/112.png",
          large: "https://images.pokemontcg.io/sv7/112_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-26",
    name: "Teal Mask Ogerpon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Grass"],
    attacks: [
      {
        name: "Grass Kagura",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Grass Energy card and attach it to 1 of your Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Ogre's Hammer",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your next turn, this Pokémon can't use Ogre's Hammer.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/26.png",
      large: "https://images.pokemontcg.io/sv10/26_hires.png",
    },
    altArts: [
      {
        id: "sv10-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv10/26.png",
          large: "https://images.pokemontcg.io/sv10/26_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-24",
    name: "Teal Mask Ogerpon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Grass"],
    attacks: [
      {
        name: "Mountain Stroll",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Energy cards, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Ogre Comeback",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 20 more damage for each of your opponent's Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    nationalPokedexNumbers: [1017],
    flavorText:
      "This mischief-loving Pokémon is full of curiosity. It battles by drawing out the type-based energy contained within its masks.",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/24.png",
      large: "https://images.pokemontcg.io/sv6/24_hires.png",
    },
    altArts: [
      {
        id: "sv6-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv6/24.png",
          large: "https://images.pokemontcg.io/sv6/24_hires.png",
        },
        flavorText:
          "This mischief-loving Pokémon is full of curiosity. It battles by drawing out the type-based energy contained within its masks.",
      },
      {
        id: "svp-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/svp/123.png",
          large: "https://images.pokemontcg.io/svp/123_hires.png",
        },
        flavorText:
          "This mischief-loving Pokémon is full of curiosity. It battles by drawing out the type-based energy contained within its masks.",
      },
    ],
  },
  {
    id: "sv6-25",
    name: "Teal Mask Ogerpon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "210",
    types: ["Grass"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    abilities: [
      {
        name: "Teal Dance",
        text: "Once during your turn, you may attach a Basic Grass Energy card from your hand to this Pokémon. If you attached Energy to a Pokémon in this way, draw a card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Myriad Leaf Shower",
        cost: ["Grass", "Grass", "Grass"],
        convertedEnergyCost: 3,
        damage: "30+",
        text: "This attack does 30 more damage for each Energy attached to both Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "25",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/25.png",
      large: "https://images.pokemontcg.io/sv6/25_hires.png",
    },
    altArts: [
      {
        id: "sv6-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv6/25.png",
          large: "https://images.pokemontcg.io/sv6/25_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-190",
        number: "190",
        images: {
          small: "https://images.pokemontcg.io/sv6/190.png",
          large: "https://images.pokemontcg.io/sv6/190_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-211",
        number: "211",
        images: {
          small: "https://images.pokemontcg.io/sv6/211.png",
          large: "https://images.pokemontcg.io/sv6/211_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-221",
        number: "221",
        images: {
          small: "https://images.pokemontcg.io/sv6/221.png",
          large: "https://images.pokemontcg.io/sv6/221_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/12.png",
          large: "https://images.pokemontcg.io/sv8pt5/12_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-145",
        number: "145",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/145.png",
          large: "https://images.pokemontcg.io/sv8pt5/145_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-177",
        number: "177",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/177.png",
          large: "https://images.pokemontcg.io/sv8pt5/177_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-74",
    name: "Team Rocket's Ampharos",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Lightning"],
    evolvesFrom: "Team Rocket's Flaaffy",
    abilities: [
      {
        name: "Darkest Impulse",
        text: "Whenever your opponent plays a Pokémon from their hand to evolve 1 of their Pokémon, put 4 damage counters on that Pokémon. The effect of Darkest Impulse doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Head Bolt",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "74",
    nationalPokedexNumbers: [181],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/74.png",
      large: "https://images.pokemontcg.io/sv10/74_hires.png",
    },
    altArts: [
      {
        id: "sv10-74",
        number: "74",
        images: {
          small: "https://images.pokemontcg.io/sv10/74.png",
          large: "https://images.pokemontcg.io/sv10/74_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-113",
    name: "Team Rocket's Arbok",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Ekans",
    abilities: [
      {
        name: "Potent Glare",
        text: "As long as this Pokémon is in the Active Spot, your opponent can't play any Pokémon that has an Ability from their hand, except for Team Rocket's Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Spinning Tail",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "",
        text: "This attack does 30 damage to each of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "113",
    nationalPokedexNumbers: [24],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/113.png",
      large: "https://images.pokemontcg.io/sv10/113_hires.png",
    },
    altArts: [
      {
        id: "sv10-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/sv10/113.png",
          large: "https://images.pokemontcg.io/sv10/113_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-51",
    name: "Team Rocket's Articuno",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Water"],
    abilities: [
      {
        name: "Repelling Veil",
        text: "Prevent all effects of attacks used by your opponent's Pokémon done to your Basic Team Rocket's Pokémon. (Existing effects are not removed. Damage is not an effect.)",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dark Frost",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60+",
        text: "If this Pokémon has any Team Rocket's Energy attached, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    nationalPokedexNumbers: [144],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/51.png",
      large: "https://images.pokemontcg.io/sv10/51_hires.png",
    },
    altArts: [
      {
        id: "sv10-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/sv10/51.png",
          large: "https://images.pokemontcg.io/sv10/51_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-15",
    name: "Team Rocket's Blipbug",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    evolvesTo: ["Dottler"],
    attacks: [
      {
        name: "Searching Eyes",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at 1 of your opponent's face-down Prize cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    nationalPokedexNumbers: [824],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/15.png",
      large: "https://images.pokemontcg.io/sv10/15_hires.png",
    },
    altArts: [
      {
        id: "sv10-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv10/15.png",
          large: "https://images.pokemontcg.io/sv10/15_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-85",
    name: "Team Rocket's Chingling",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Psychic"],
    evolvesTo: ["Chimecho"],
    attacks: [
      {
        name: "Chiming Commotion",
        cost: [],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard a random card from your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "85",
    nationalPokedexNumbers: [433],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/85.png",
      large: "https://images.pokemontcg.io/sv10/85_hires.png",
    },
    altArts: [
      {
        id: "sv10-85",
        number: "85",
        images: {
          small: "https://images.pokemontcg.io/sv10/85.png",
          large: "https://images.pokemontcg.io/sv10/85_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-122",
    name: "Team Rocket's Crobat ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "310",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Golbat",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Biting Spree",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may choose 2 of your opponent's Pokémon and put 2 damage counters on each of them.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Assassin's Return",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "You may put this Pokémon into your hand. (Discard all cards attached to this Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "122",
    nationalPokedexNumbers: [169],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/122.png",
      large: "https://images.pokemontcg.io/sv10/122_hires.png",
    },
    altArts: [
      {
        id: "sv10-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/sv10/122.png",
          large: "https://images.pokemontcg.io/sv10/122_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-217",
        number: "217",
        images: {
          small: "https://images.pokemontcg.io/sv10/217.png",
          large: "https://images.pokemontcg.io/sv10/217_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-234",
        number: "234",
        images: {
          small: "https://images.pokemontcg.io/sv10/234.png",
          large: "https://images.pokemontcg.io/sv10/234_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-242",
        number: "242",
        images: {
          small: "https://images.pokemontcg.io/sv10/242.png",
          large: "https://images.pokemontcg.io/sv10/242_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-100",
    name: "Team Rocket's Diglett",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    attacks: [
      {
        name: "Relentless Burrowing",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin until you get tails. For each heads, discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "100",
    flavorText:
      "Its skin is very thin. If it is exposed to light, its blood heats up, causing it to grow weak.",
    nationalPokedexNumbers: [50],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-100/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-100/large",
    },
    altArts: [
      {
        id: "me2pt5-100",
        number: "100",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-100/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-100/large",
        },
        flavorText:
          "Its skin is very thin. If it is exposed to light, its blood heats up, causing it to grow weak.",
      },
    ],
  },
  {
    id: "sv10-88",
    name: "Team Rocket's Dottler",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Psychic"],
    evolvesFrom: "Team Rocket's Blipbug",
    evolvesTo: ["Orbeetle"],
    attacks: [
      {
        name: "Disruptive Radar",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top 5 cards of your opponent's deck and put them back in any order.",
      },
      {
        name: "Super Psy Bolt",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "88",
    nationalPokedexNumbers: [825],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/88.png",
      large: "https://images.pokemontcg.io/sv10/88_hires.png",
    },
    altArts: [
      {
        id: "sv10-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv10/88.png",
          large: "https://images.pokemontcg.io/sv10/88_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-79",
    name: "Team Rocket's Drowzee",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    evolvesTo: ["Hypno"],
    attacks: [
      {
        name: "Hypnotic Ray",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "79",
    nationalPokedexNumbers: [96],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/79.png",
      large: "https://images.pokemontcg.io/sv10/79_hires.png",
    },
    altArts: [
      {
        id: "sv10-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/sv10/79.png",
          large: "https://images.pokemontcg.io/sv10/79_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-101",
    name: "Team Rocket's Dugtrio",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Team Rocket's Diglett",
    abilities: [
      {
        name: "Holes",
        text: "Whenever your opponent's Active Pokémon moves to the Bench during their turn, place 2 damage counters on that Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mud Shot",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "101",
    flavorText:
      "In battle, it digs through the ground and strikes the unsuspecting foe from an unexpected direction.",
    nationalPokedexNumbers: [51],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-101/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-101/large",
    },
    altArts: [
      {
        id: "me2pt5-101",
        number: "101",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-101/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-101/large",
        },
        flavorText:
          "In battle, it digs through the ground and strikes the unsuspecting foe from an unexpected direction.",
      },
      {
        id: "me2pt5-239",
        number: "239",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-239/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-239/large",
        },
        flavorText:
          "In battle, it digs through the ground and strikes the unsuspecting foe from an unexpected direction.",
      },
    ],
  },
  {
    id: "sv10-112",
    name: "Team Rocket's Ekans",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Arbok"],
    attacks: [
      {
        name: "Drag Down",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Gnaw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "112",
    nationalPokedexNumbers: [23],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/112.png",
      large: "https://images.pokemontcg.io/sv10/112_hires.png",
    },
    altArts: [
      {
        id: "sv10-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/sv10/112.png",
          large: "https://images.pokemontcg.io/sv10/112_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-77",
    name: "Team Rocket's Exeggcute",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Focused Wish",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "77",
    flavorText:
      "Using telepathy only fellow Exeggcute can pick up on, they always form a cluster of six.",
    nationalPokedexNumbers: [102],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-77/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-77/large",
    },
    altArts: [
      {
        id: "me2pt5-77",
        number: "77",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-77/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-77/large",
        },
        flavorText:
          "Using telepathy only fellow Exeggcute can pick up on, they always form a cluster of six.",
      },
    ],
  },
  {
    id: "me2pt5-78",
    name: "Team Rocket's Exeggutor",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Team Rocket's Exeggcute",
    attacks: [
      {
        name: "Tri Kinesis",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Flip 3 coins. If all of them are heads, Knock Out 1 of your opponent's Pokémon.",
      },
      {
        name: "Double-Edge",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "78",
    flavorText:
      "It is said that on rare occasions, one of its heads will drop off and continue on as an Exeggcute.",
    nationalPokedexNumbers: [103],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-78/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-78/large",
    },
    altArts: [
      {
        id: "me2pt5-78",
        number: "78",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-78/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-78/large",
        },
        flavorText:
          "It is said that on rare occasions, one of its heads will drop off and continue on as an Exeggcute.",
      },
    ],
  },
  {
    id: "sv10-73",
    name: "Team Rocket's Flaaffy",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Lightning"],
    evolvesFrom: "Team Rocket's Mareep",
    evolvesTo: ["Ampharos"],
    attacks: [
      {
        name: "Thunder Shock",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "73",
    nationalPokedexNumbers: [180],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/73.png",
      large: "https://images.pokemontcg.io/sv10/73_hires.png",
    },
    altArts: [
      {
        id: "sv10-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/sv10/73.png",
          large: "https://images.pokemontcg.io/sv10/73_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-121",
    name: "Team Rocket's Golbat",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Zubat",
    evolvesTo: ["Crobat"],
    abilities: [
      {
        name: "Sneaky Bite",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may put 2 damage counters on 1 of your opponent's Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Confuse Ray",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "121",
    nationalPokedexNumbers: [42],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/121.png",
      large: "https://images.pokemontcg.io/sv10/121_hires.png",
    },
    altArts: [
      {
        id: "sv10-121",
        number: "121",
        images: {
          small: "https://images.pokemontcg.io/sv10/121.png",
          large: "https://images.pokemontcg.io/sv10/121_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-123",
    name: "Team Rocket's Grimer",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    evolvesTo: ["Muk"],
    attacks: [
      {
        name: "Corrosive Sludge",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "At the end of your opponent's next turn, discard the Defending Pokémon and all attached cards.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "123",
    nationalPokedexNumbers: [88],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/123.png",
      large: "https://images.pokemontcg.io/sv10/123_hires.png",
    },
    altArts: [
      {
        id: "sv10-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/sv10/123.png",
          large: "https://images.pokemontcg.io/sv10/123_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-127",
    name: "Team Rocket's Honchkrow",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Murkrow",
    attacks: [
      {
        name: "Rocket Feathers",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: 'You may discard any number of Supporter cards that have "Team Rocket" in their name from your hand, and this attack does 60 damage for each card you discarded in this way.',
      },
      {
        name: "Hammer In",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "127",
    flavorText:
      "A single cry from this nocturnal Pokémon, and more than 100 of its Murkrow cronies will assemble.",
    nationalPokedexNumbers: [430],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-127/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-127/large",
    },
    altArts: [
      {
        id: "me2pt5-127",
        number: "127",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-127/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-127/large",
        },
        flavorText:
          "A single cry from this nocturnal Pokémon, and more than 100 of its Murkrow cronies will assemble.",
      },
    ],
  },
  {
    id: "sv10-38",
    name: "Team Rocket's Houndoom",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fire"],
    evolvesFrom: "Team Rocket's Houndour",
    attacks: [
      {
        name: "Cruel Coal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned and Confused.",
      },
      {
        name: "Scorching Fire",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "38",
    nationalPokedexNumbers: [229],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/38.png",
      large: "https://images.pokemontcg.io/sv10/38_hires.png",
    },
    altArts: [
      {
        id: "sv10-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv10/38.png",
          large: "https://images.pokemontcg.io/sv10/38_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-191",
        number: "191",
        images: {
          small: "https://images.pokemontcg.io/sv10/191.png",
          large: "https://images.pokemontcg.io/sv10/191_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-37",
    name: "Team Rocket's Houndour",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Houndoom"],
    attacks: [
      {
        name: "Steady Firebreathing",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "37",
    nationalPokedexNumbers: [228],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/37.png",
      large: "https://images.pokemontcg.io/sv10/37_hires.png",
    },
    altArts: [
      {
        id: "sv10-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv10/37.png",
          large: "https://images.pokemontcg.io/sv10/37_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-80",
    name: "Team Rocket's Hypno",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Team Rocket's Drowzee",
    attacks: [
      {
        name: "Psyshot",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Bench Manipulation",
        cost: ["Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 3,
        damage: "80×",
        text: "Your opponent flips a coin for each of their Benched Pokémon. This attack does 80 damage to your opponent's Active Pokémon for each tails. This attack's damage isn't affected by Weakness or Resistance.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "80",
    nationalPokedexNumbers: [97],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/80.png",
      large: "https://images.pokemontcg.io/sv10/80_hires.png",
    },
    altArts: [
      {
        id: "sv10-80",
        number: "80",
        images: {
          small: "https://images.pokemontcg.io/sv10/80.png",
          large: "https://images.pokemontcg.io/sv10/80_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-162",
    name: "Team Rocket's Kangaskhan ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Comet Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "Flip 4 coins. This attack does 30 damage for each heads.",
      },
      {
        name: "Wicked Impact",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: 'If you played a Supporter card that has "Team Rocket" in its name from your hand during this turn, this attack does 100 more damage.',
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "162",
    nationalPokedexNumbers: [115],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-162/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-162/large",
    },
    altArts: [
      {
        id: "me2pt5-162",
        number: "162",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-162/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-162/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-125",
    name: "Team Rocket's Koffing",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Weezing"],
    abilities: [
      {
        name: "Smog Signals",
        text: 'If this Pokémon is in the Active Spot and is damaged by an attack from your opponent\'s Pokémon (even if this Pokémon is Knocked Out), search your deck for up to 2 Pokémon that have "Koffing" in their name and put them onto your Bench. Then, shuffle your deck.',
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Leaking Gas",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "125",
    nationalPokedexNumbers: [109],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/125.png",
      large: "https://images.pokemontcg.io/sv10/125_hires.png",
    },
    altArts: [
      {
        id: "sv10-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/sv10/125.png",
          large: "https://images.pokemontcg.io/sv10/125_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-94",
    name: "Team Rocket's Larvitar",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Pupitar"],
    attacks: [
      {
        name: "Mountain Munch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "94",
    nationalPokedexNumbers: [246],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/94.png",
      large: "https://images.pokemontcg.io/sv10/94_hires.png",
    },
    altArts: [
      {
        id: "sv10-94",
        number: "94",
        images: {
          small: "https://images.pokemontcg.io/sv10/94.png",
          large: "https://images.pokemontcg.io/sv10/94_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-72",
    name: "Team Rocket's Mareep",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    evolvesTo: ["Flaaffy"],
    attacks: [
      {
        name: "Procurement",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for an Item card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Tiny Bolt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    nationalPokedexNumbers: [179],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/72.png",
      large: "https://images.pokemontcg.io/sv10/72_hires.png",
    },
    altArts: [
      {
        id: "sv10-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv10/72.png",
          large: "https://images.pokemontcg.io/sv10/72_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-161",
    name: "Team Rocket's Meowth",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    attacks: [
      {
        name: "Paw-cket Pilfer",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Choose a random card from your opponent's hand. Your opponent reveals that card and shuffles it into their deck.",
      },
      {
        name: "Fury Swipes",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "Flip 3 coins. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "161",
    flavorText:
      "All it does is sleep during the daytime. At night, it patrols its territory with its eyes aglow.",
    nationalPokedexNumbers: [52],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-161/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-161/large",
    },
    altArts: [
      {
        id: "me2pt5-161",
        number: "161",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-161/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-161/large",
        },
        flavorText:
          "All it does is sleep during the daytime. At night, it patrols its territory with its eyes aglow.",
      },
      {
        id: "sv10-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/sv10/149.png",
          large: "https://images.pokemontcg.io/sv10/149_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-203",
        number: "203",
        images: {
          small: "https://images.pokemontcg.io/sv10/203.png",
          large: "https://images.pokemontcg.io/sv10/203_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-79",
    name: "Team Rocket's Mewtwo ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "280",
    types: ["Psychic"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Power Saver",
        text: "This Pokémon can't attack unless you have 4 or more Team Rocket's Pokémon in play.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Erasure Ball",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160+",
        text: "You may discard up to 2 Energy from your Benched Pokémon. This attack does 60 more damage for each card you discarded in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "79",
    nationalPokedexNumbers: [150],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-79/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-79/large",
    },
    altArts: [
      {
        id: "me2pt5-79",
        number: "79",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-79/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-79/large",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-281",
        number: "281",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-281/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-281/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/sv10/81.png",
          large: "https://images.pokemontcg.io/sv10/81_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-213",
        number: "213",
        images: {
          small: "https://images.pokemontcg.io/sv10/213.png",
          large: "https://images.pokemontcg.io/sv10/213_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-231",
        number: "231",
        images: {
          small: "https://images.pokemontcg.io/sv10/231.png",
          large: "https://images.pokemontcg.io/sv10/231_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-240",
        number: "240",
        images: {
          small: "https://images.pokemontcg.io/sv10/240.png",
          large: "https://images.pokemontcg.io/sv10/240_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-97",
    name: "Team Rocket's Mimikyu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    attacks: [
      {
        name: "Gemstone Mimicry",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Choose 1 of your opponent's Active Tera Pokémon's attacks and use it as this attack.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "97",
    flavorText:
      "This Pokémon lives in dark places untouched by sunlight. When it appears before humans, it hides itself under a cloth that resembles a Pikachu.",
    nationalPokedexNumbers: [778],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-97/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-97/large",
    },
    altArts: [
      {
        id: "me2pt5-97",
        number: "97",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-97/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-97/large",
        },
        flavorText:
          "This Pokémon lives in dark places untouched by sunlight. When it appears before humans, it hides itself under a cloth that resembles a Pikachu.",
      },
      {
        id: "me2pt5-238",
        number: "238",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-238/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-238/large",
        },
        flavorText:
          "This Pokémon lives in dark places untouched by sunlight. When it appears before humans, it hides itself under a cloth that resembles a Pikachu.",
      },
      {
        id: "sv10-87",
        number: "87",
        images: {
          small: "https://images.pokemontcg.io/sv10/87.png",
          large: "https://images.pokemontcg.io/sv10/87_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-31",
    name: "Team Rocket's Moltres ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "220",
    types: ["Fire"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Flame Screen",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "During your opponent's next turn, this Pokémon takes 50 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Evil Incineration",
        cost: ["Fire", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "",
        text: "Discard a Team Rocket's Energy from this Pokémon. If you do, discard your opponent's Active Pokémon and all attached cards.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "31",
    nationalPokedexNumbers: [146],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/31.png",
      large: "https://images.pokemontcg.io/sv10/31_hires.png",
    },
    altArts: [
      {
        id: "sv10-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/sv10/31.png",
          large: "https://images.pokemontcg.io/sv10/31_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-208",
        number: "208",
        images: {
          small: "https://images.pokemontcg.io/sv10/208.png",
          large: "https://images.pokemontcg.io/sv10/208_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-229",
        number: "229",
        images: {
          small: "https://images.pokemontcg.io/sv10/229.png",
          large: "https://images.pokemontcg.io/sv10/229_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-124",
    name: "Team Rocket's Muk",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "150",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Grimer",
    attacks: [
      {
        name: "Gooped Up",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "Your opponent's Active Pokémon is now Confused. During your opponent's next turn, that Pokémon can't retreat.",
      },
      {
        name: "Hazardous Venom",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100×",
        text: "This attack does 100 damage for each Special Condition affecting your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "124",
    nationalPokedexNumbers: [89],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/124.png",
      large: "https://images.pokemontcg.io/sv10/124_hires.png",
    },
    altArts: [
      {
        id: "sv10-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/sv10/124.png",
          large: "https://images.pokemontcg.io/sv10/124_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-126",
    name: "Team Rocket's Murkrow",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    attacks: [
      {
        name: "Deceit",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Supporter card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Torment",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Choose 1 of your opponent's Active Pokémon's attacks. During your opponent's next turn, that Pokémon can't use that attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "126",
    flavorText:
      "Feared and loathed by many, it is believed to bring misfortune to all those who see it at night.",
    nationalPokedexNumbers: [198],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-126/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-126/large",
    },
    altArts: [
      {
        id: "me2pt5-126",
        number: "126",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-126/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-126/large",
        },
        flavorText:
          "Feared and loathed by many, it is believed to bring misfortune to all those who see it at night.",
      },
      {
        id: "sv10-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/sv10/127.png",
          large: "https://images.pokemontcg.io/sv10/127_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-200",
        number: "200",
        images: {
          small: "https://images.pokemontcg.io/sv10/200.png",
          large: "https://images.pokemontcg.io/sv10/200_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-119",
    name: "Team Rocket's Nidoking ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "330",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Nidorino",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Tainted Horn",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Your opponent's Active Pokémon is now Poisoned. During Pokémon Checkup, put 8 damage counters on that Pokémon instead of 1.",
      },
      {
        name: "Kingly Impact",
        cost: ["Darkness", "Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 4,
        damage: "240",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "119",
    nationalPokedexNumbers: [34],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/119.png",
      large: "https://images.pokemontcg.io/sv10/119_hires.png",
    },
    altArts: [
      {
        id: "sv10-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/sv10/119.png",
          large: "https://images.pokemontcg.io/sv10/119_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-216",
        number: "216",
        images: {
          small: "https://images.pokemontcg.io/sv10/216.png",
          large: "https://images.pokemontcg.io/sv10/216_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-233",
        number: "233",
        images: {
          small: "https://images.pokemontcg.io/sv10/233.png",
          large: "https://images.pokemontcg.io/sv10/233_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-116",
    name: "Team Rocket's Nidoqueen",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Nidorina",
    attacks: [
      {
        name: "Love Impact",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: 'If a Pokémon that has "Nidoking" in its name is on your Bench, this attack does 120 more damage.',
      },
      {
        name: "Mega Kick",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "116",
    nationalPokedexNumbers: [31],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/116.png",
      large: "https://images.pokemontcg.io/sv10/116_hires.png",
    },
    altArts: [
      {
        id: "sv10-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/sv10/116.png",
          large: "https://images.pokemontcg.io/sv10/116_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-114",
    name: "Team Rocket's Nidoran♀",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Nidorina"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "114",
    nationalPokedexNumbers: [29],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/114.png",
      large: "https://images.pokemontcg.io/sv10/114_hires.png",
    },
    altArts: [
      {
        id: "sv10-114",
        number: "114",
        images: {
          small: "https://images.pokemontcg.io/sv10/114.png",
          large: "https://images.pokemontcg.io/sv10/114_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-117",
    name: "Team Rocket's Nidoran♂",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Nidorino"],
    attacks: [
      {
        name: "Pierce",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Hammer In",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "117",
    nationalPokedexNumbers: [32],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/117.png",
      large: "https://images.pokemontcg.io/sv10/117_hires.png",
    },
    altArts: [
      {
        id: "sv10-117",
        number: "117",
        images: {
          small: "https://images.pokemontcg.io/sv10/117.png",
          large: "https://images.pokemontcg.io/sv10/117_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-115",
    name: "Team Rocket's Nidorina",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Nidoran♀",
    evolvesTo: ["Nidoqueen"],
    attacks: [
      {
        name: "Dark Awakening",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Choose up to 2 of your Darkness Pokémon. For each of those Pokémon, search your deck for a card that evolves from that Pokémon and put it onto that Pokémon to evolve it. Then, shuffle your deck.",
      },
      {
        name: "Scratch",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "115",
    nationalPokedexNumbers: [30],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/115.png",
      large: "https://images.pokemontcg.io/sv10/115_hires.png",
    },
    altArts: [
      {
        id: "sv10-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/sv10/115.png",
          large: "https://images.pokemontcg.io/sv10/115_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-118",
    name: "Team Rocket's Nidorino",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Nidoran♂",
    evolvesTo: ["Nidoking"],
    attacks: [
      {
        name: "Hammer In",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Horn Rend",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "118",
    nationalPokedexNumbers: [33],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/118.png",
      large: "https://images.pokemontcg.io/sv10/118_hires.png",
    },
    altArts: [
      {
        id: "sv10-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/sv10/118.png",
          large: "https://images.pokemontcg.io/sv10/118_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-89",
    name: "Team Rocket's Orbeetle",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Team Rocket's Dottler",
    abilities: [
      {
        name: "Rocket Brain",
        text: "As often as you like during your turn, you may move 1 damage counter from 1 of your Team Rocket's Pokémon to another of your Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Psychic",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40+",
        text: "This attack does 40 more damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "89",
    nationalPokedexNumbers: [826],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/89.png",
      large: "https://images.pokemontcg.io/sv10/89_hires.png",
    },
    altArts: [
      {
        id: "sv10-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/sv10/89.png",
          large: "https://images.pokemontcg.io/sv10/89_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-198",
        number: "198",
        images: {
          small: "https://images.pokemontcg.io/sv10/198.png",
          large: "https://images.pokemontcg.io/sv10/198_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-150",
    name: "Team Rocket's Persian ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "260",
    types: ["Colorless"],
    evolvesFrom: "Team Rocket's Meowth",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Haughty Order",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Reveal the top 10 cards of your opponent's deck. You may choose an attack from a Pokémon you find there and use it as this attack. Shuffle the revealed cards into your opponent's deck.",
      },
      {
        name: "Cruel Slash",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "150",
    nationalPokedexNumbers: [53],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/150.png",
      large: "https://images.pokemontcg.io/sv10/150_hires.png",
    },
    altArts: [
      {
        id: "sv10-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/sv10/150.png",
          large: "https://images.pokemontcg.io/sv10/150_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-219",
        number: "219",
        images: {
          small: "https://images.pokemontcg.io/sv10/219.png",
          large: "https://images.pokemontcg.io/sv10/219_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-153",
    name: "Team Rocket's Porygon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Colorless"],
    evolvesTo: ["Porygon2"],
    attacks: [
      {
        name: "Hacking",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard a card from your hand. If you do, your opponent discards a card from their hand.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "153",
    nationalPokedexNumbers: [137],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/153.png",
      large: "https://images.pokemontcg.io/sv10/153_hires.png",
    },
    altArts: [
      {
        id: "sv10-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/sv10/153.png",
          large: "https://images.pokemontcg.io/sv10/153_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-155",
    name: "Team Rocket's Porygon-Z",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Colorless"],
    evolvesFrom: "Team Rocket's Porygon2",
    abilities: [
      {
        name: "Reconstitute",
        text: "You must discard 2 cards from your hand in order to use this Ability. Once during your turn, you may draw a card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "R Command",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: 'This attack does 20 damage for each Supporter card that has "Team Rocket" in its name in your discard pile.',
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "155",
    nationalPokedexNumbers: [474],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/155.png",
      large: "https://images.pokemontcg.io/sv10/155_hires.png",
    },
    altArts: [
      {
        id: "sv10-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/sv10/155.png",
          large: "https://images.pokemontcg.io/sv10/155_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-154",
    name: "Team Rocket's Porygon2",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Team Rocket's Porygon",
    evolvesTo: ["Porygon-Z"],
    attacks: [
      {
        name: "R Command",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20×",
        text: 'This attack does 20 damage for each Supporter card that has "Team Rocket" in its name in your discard pile.',
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "154",
    nationalPokedexNumbers: [233],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/154.png",
      large: "https://images.pokemontcg.io/sv10/154_hires.png",
    },
    altArts: [
      {
        id: "sv10-154",
        number: "154",
        images: {
          small: "https://images.pokemontcg.io/sv10/154.png",
          large: "https://images.pokemontcg.io/sv10/154_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-95",
    name: "Team Rocket's Pupitar",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Team Rocket's Larvitar",
    evolvesTo: ["Tyranitar"],
    attacks: [
      {
        name: "Explosive Ascension",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Search your deck for a card that evolves from this Pokémon and put it onto this Pokémon to evolve it. Then, shuffle your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "95",
    nationalPokedexNumbers: [247],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/95.png",
      large: "https://images.pokemontcg.io/sv10/95_hires.png",
    },
    altArts: [
      {
        id: "sv10-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv10/95.png",
          large: "https://images.pokemontcg.io/sv10/95_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-148",
    name: "Team Rocket's Raticate",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Team Rocket's Rattata",
    attacks: [
      {
        name: "Reckless Abandon",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "90",
        text: "Flip 2 coins. If both of them are tails, this Pokémon also does 90 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "148",
    nationalPokedexNumbers: [20],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/148.png",
      large: "https://images.pokemontcg.io/sv10/148_hires.png",
    },
    altArts: [
      {
        id: "sv10-148",
        number: "148",
        images: {
          small: "https://images.pokemontcg.io/sv10/148.png",
          large: "https://images.pokemontcg.io/sv10/148_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-202",
        number: "202",
        images: {
          small: "https://images.pokemontcg.io/sv10/202.png",
          large: "https://images.pokemontcg.io/sv10/202_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-147",
    name: "Team Rocket's Rattata",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Colorless"],
    evolvesTo: ["Raticate"],
    attacks: [
      {
        name: "Dangerous Incisors",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "147",
    nationalPokedexNumbers: [19],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/147.png",
      large: "https://images.pokemontcg.io/sv10/147_hires.png",
    },
    altArts: [
      {
        id: "sv10-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/sv10/147.png",
          large: "https://images.pokemontcg.io/sv10/147_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-128",
    name: "Team Rocket's Sneasel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    evolvesTo: ["Weavile"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Strike the Sleeper",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 20 damage to 1 of your opponent's Benched Pokémon for each damage counter on that Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "128",
    nationalPokedexNumbers: [215],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/128.png",
      large: "https://images.pokemontcg.io/sv10/128_hires.png",
    },
    altArts: [
      {
        id: "sv10-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/sv10/128.png",
          large: "https://images.pokemontcg.io/sv10/128_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-19",
    name: "Team Rocket's Spidops",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Grass"],
    evolvesFrom: "Team Rocket's Tarountula",
    abilities: [
      {
        name: "Charging Up",
        text: "Once during your turn, you may attach a Basic Energy card from your discard pile to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Rocket Rush",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each of your Team Rocket's Pokémon in play.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "19",
    flavorText:
      "It clings to branches and ceilings using its threads and moves without a sound. It takes out its prey before the prey even notices it.",
    nationalPokedexNumbers: [918],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-19/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-19/large",
    },
    altArts: [
      {
        id: "me2pt5-19",
        number: "19",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-19/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-19/large",
        },
        flavorText:
          "It clings to branches and ceilings using its threads and moves without a sound. It takes out its prey before the prey even notices it.",
      },
      {
        id: "sv10-20",
        number: "20",
        images: {
          small: "https://images.pokemontcg.io/sv10/20.png",
          large: "https://images.pokemontcg.io/sv10/20_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-187",
        number: "187",
        images: {
          small: "https://images.pokemontcg.io/sv10/187.png",
          large: "https://images.pokemontcg.io/sv10/187_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-18",
    name: "Team Rocket's Tarountula",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    attacks: [
      {
        name: "Take Down",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "18",
    flavorText:
      "The ball of threads wrapped around its body is elastic enough to deflect the scythes of Scyther, this Pokémon’s natural enemy.",
    nationalPokedexNumbers: [917],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-18/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-18/large",
    },
    altArts: [
      {
        id: "me2pt5-18",
        number: "18",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-18/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-18/large",
        },
        flavorText:
          "The ball of threads wrapped around its body is elastic enough to deflect the scythes of Scyther, this Pokémon’s natural enemy.",
      },
      {
        id: "sv10-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/sv10/19.png",
          large: "https://images.pokemontcg.io/sv10/19_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-96",
    name: "Team Rocket's Tyranitar",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fighting"],
    evolvesFrom: "Team Rocket's Pupitar",
    abilities: [
      {
        name: "Sand Stream",
        text: "During Pokémon Checkup, if this Pokémon is in the Active Spot, put 2 damage counters on each of your opponent's Basic Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Demolition Tackle",
        cost: ["Fighting", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "180",
        text: "Discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "96",
    nationalPokedexNumbers: [248],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/96.png",
      large: "https://images.pokemontcg.io/sv10/96_hires.png",
    },
    altArts: [
      {
        id: "sv10-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/sv10/96.png",
          large: "https://images.pokemontcg.io/sv10/96_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-126",
    name: "Team Rocket's Weezing",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Team Rocket's Koffing",
    attacks: [
      {
        name: "Explode Together Now",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: 'This attack does 40 damage for each Pokémon in play that has "Koffing" or "Weezing" in its name (both yours and your opponent\'s).',
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "126",
    nationalPokedexNumbers: [110],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/126.png",
      large: "https://images.pokemontcg.io/sv10/126_hires.png",
    },
    altArts: [
      {
        id: "sv10-126",
        number: "126",
        images: {
          small: "https://images.pokemontcg.io/sv10/126.png",
          large: "https://images.pokemontcg.io/sv10/126_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-199",
        number: "199",
        images: {
          small: "https://images.pokemontcg.io/sv10/199.png",
          large: "https://images.pokemontcg.io/sv10/199_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-82",
    name: "Team Rocket's Wobbuffet",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Psychic"],
    attacks: [
      {
        name: "Rocket Mirror",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "Move all damage counters from 1 of your Benched Team Rocket's Pokémon to your opponent's Active Pokémon.",
      },
      {
        name: "Headbutt Bounce",
        cost: ["Psychic", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "82",
    nationalPokedexNumbers: [202],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/82.png",
      large: "https://images.pokemontcg.io/sv10/82_hires.png",
    },
    altArts: [
      {
        id: "sv10-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv10/82.png",
          large: "https://images.pokemontcg.io/sv10/82_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-70",
    name: "Team Rocket's Zapdos",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Jamming Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "You may move an Energy from your opponent's Active Pokémon to 1 of their Benched Pokémon.",
      },
      {
        name: "Wicked Thunder",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60+",
        text: "If this Pokémon has any Team Rocket's Energy attached, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "70",
    nationalPokedexNumbers: [145],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/70.png",
      large: "https://images.pokemontcg.io/sv10/70_hires.png",
    },
    altArts: [
      {
        id: "sv10-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv10/70.png",
          large: "https://images.pokemontcg.io/sv10/70_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-120",
    name: "Team Rocket's Zubat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Darkness"],
    evolvesTo: ["Golbat"],
    attacks: [
      {
        name: "Poison Spray",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "120",
    nationalPokedexNumbers: [41],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/120.png",
      large: "https://images.pokemontcg.io/sv10/120_hires.png",
    },
    altArts: [
      {
        id: "sv10-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/sv10/120.png",
          large: "https://images.pokemontcg.io/sv10/120_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-11",
    name: "Tepig",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Pignite"],
    attacks: [
      {
        name: "Tackle",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Rollout",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    flavorText:
      "It can deftly dodge its foe's attacks while shooting fireballs from its nose. It roasts berries before it eats them.",
    nationalPokedexNumbers: [498],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/11.png",
      large: "https://images.pokemontcg.io/rsv10pt5/11_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/11.png",
          large: "https://images.pokemontcg.io/rsv10pt5/11_hires.png",
        },
        flavorText:
          "It can deftly dodge its foe's attacks while shooting fireballs from its nose. It roasts berries before it eats them.",
      },
      {
        id: "rsv10pt5-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/96.png",
          large: "https://images.pokemontcg.io/rsv10pt5/96_hires.png",
        },
        flavorText:
          "It can deftly dodge its foe's attacks while shooting fireballs from its nose. It roasts berries before it eats them.",
      },
    ],
  },
  {
    id: "me2pt5-29",
    name: "Tepig",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Steady Firebreathing",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "29",
    flavorText:
      "It can deftly dodge its foe’s attacks while shooting fireballs from its nose. It roasts berries before it eats them.",
    nationalPokedexNumbers: [498],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-29/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-29/large",
    },
    altArts: [
      {
        id: "me2pt5-29",
        number: "29",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-29/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-29/large",
        },
        flavorText:
          "It can deftly dodge its foe’s attacks while shooting fireballs from its nose. It roasts berries before it eats them.",
      },
    ],
  },
  {
    id: "me2pt5-178",
    name: "Terapagos",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Prism Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Basic Energy cards of different types and attach them to your Tera Pokémon in any way you like. Then, shuffle your deck.",
      },
      {
        name: "Hard Tackle",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "178",
    flavorText:
      "The shell is made of crystallized Terastal energy. When struck by a move, this shell absorbs the move’s energy and transfers it to Terapagos.",
    nationalPokedexNumbers: [1024],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-178/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-178/large",
    },
    altArts: [
      {
        id: "me2pt5-178",
        number: "178",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-178/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-178/large",
        },
        flavorText:
          "The shell is made of crystallized Terastal energy. When struck by a move, this shell absorbs the move’s energy and transfers it to Terapagos.",
      },
      {
        id: "sv8-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/sv8/161.png",
          large: "https://images.pokemontcg.io/sv8/161_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-179",
    name: "Terapagos ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "230",
    types: ["Colorless"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent’s).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Unified Beatdown",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "If you go second, you can't use this attack during your first turn. This attack does 30 damage for each of your Benched Pokémon.",
      },
      {
        name: "Crown Opal",
        cost: ["Grass", "Water", "Lightning"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Basic non-Colorless Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "179",
    nationalPokedexNumbers: [1024],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-179/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-179/large",
    },
    altArts: [
      {
        id: "me2pt5-179",
        number: "179",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-179/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-179/large",
        },
        flavorText: "",
      },
      {
        id: "sv7-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/sv7/128.png",
          large: "https://images.pokemontcg.io/sv7/128_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-170",
        number: "170",
        images: {
          small: "https://images.pokemontcg.io/sv7/170.png",
          large: "https://images.pokemontcg.io/sv7/170_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-173",
        number: "173",
        images: {
          small: "https://images.pokemontcg.io/sv7/173.png",
          large: "https://images.pokemontcg.io/sv7/173_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-169",
        number: "169",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/169.png",
          large: "https://images.pokemontcg.io/sv8pt5/169_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-180",
        number: "180",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/180.png",
          large: "https://images.pokemontcg.io/sv8pt5/180_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/svp/165.png",
          large: "https://images.pokemontcg.io/svp/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-92",
    name: "Terapagos ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Unified Beatdown",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "If you go second, you can't use this attack during your first turn. This attack does 30 damage for each of your Benched Pokémon.",
      },
      {
        name: "Crown Opal",
        cost: ["Grass", "Water", "Lightning"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "During your opponent's next turn, prevent all damage done to this Pokémon by attacks from Basic non-Colorless Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "92",
    nationalPokedexNumbers: [1024],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/92.png",
      large: "https://images.pokemontcg.io/sv8pt5/92_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/92.png",
          large: "https://images.pokemontcg.io/sv8pt5/92_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-54",
    name: "Terrakion",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Retaliate",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 80 more damage.",
      },
      {
        name: "Land Crush",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "54",
    flavorText:
      "This Pokémon came to the defense of Pokémon that had lost their homes in a war among humans.",
    nationalPokedexNumbers: [639],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/54.png",
      large: "https://images.pokemontcg.io/rsv10pt5/54_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/54.png",
          large: "https://images.pokemontcg.io/rsv10pt5/54_hires.png",
        },
        flavorText:
          "This Pokémon came to the defense of Pokémon that had lost their homes in a war among humans.",
      },
      {
        id: "rsv10pt5-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/135.png",
          large: "https://images.pokemontcg.io/rsv10pt5/135_hires.png",
        },
        flavorText:
          "This Pokémon came to the defense of Pokémon that had lost their homes in a war among humans.",
      },
    ],
  },
  {
    id: "me1-90",
    name: "Thievul",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Nickit",
    attacks: [
      {
        name: "Greedy Hunt",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may draw cards until you have 6 cards in your hand.",
      },
      {
        name: "Pitch-Black Fangs",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "90",
    nationalPokedexNumbers: [828],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/90.png",
      large: "https://images.pokemontcg.io/me1/90_hires.png",
    },
    altArts: [
      {
        id: "me1-90",
        number: "90",
        images: {
          small: "https://images.pokemontcg.io/me1/90.png",
          large: "https://images.pokemontcg.io/me1/90_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-54",
    name: "Thievul",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Nickit",
    attacks: [
      {
        name: "Skill Thief",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "If you have no cards in your hand, choose an attack from 1 of your opponent's Pokémon in play and use it as this attack.",
      },
      {
        name: "Sharp Fang",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "54",
    flavorText:
      "It secretly marks potential targets with a scent. By following the scent, it stalks its targets and steals from them when they least expect it.",
    nationalPokedexNumbers: [828],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-54/small",
      large: "https://images.scrydex.com/pokemon/me5-54/large",
    },
    altArts: [
      {
        id: "me5-54",
        number: "54",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-54/small",
          large: "https://images.scrydex.com/pokemon/me5-54/large",
        },
        flavorText:
          "It secretly marks potential targets with a scent. By following the scent, it stalks its targets and steals from them when they least expect it.",
      },
      {
        id: "me5-92",
        number: "92",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-92/small",
          large: "https://images.scrydex.com/pokemon/me5-92/large",
        },
        flavorText:
          "It secretly marks potential targets with a scent. By following the scent, it stalks its targets and steals from them when they least expect it.",
      },
    ],
  },
  {
    id: "zsv10pt5-50",
    name: "Throh",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fighting"],
    attacks: [
      {
        name: "Shoulder Throw",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120-",
        text: "This attack does 30 less damage for each Colorless in your opponent's Active Pokémon's Retreat Cost.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "50",
    flavorText:
      "When it tightens its belt, it becomes stronger. Wild Throh use vines to weave their own belts.",
    nationalPokedexNumbers: [538],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/50.png",
      large: "https://images.pokemontcg.io/zsv10pt5/50_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/50.png",
          large: "https://images.pokemontcg.io/zsv10pt5/50_hires.png",
        },
        flavorText:
          "When it tightens its belt, it becomes stronger. Wild Throh use vines to weave their own belts.",
      },
      {
        id: "zsv10pt5-128",
        number: "128",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/128.png",
          large: "https://images.pokemontcg.io/zsv10pt5/128_hires.png",
        },
        flavorText:
          "When it tightens its belt, it becomes stronger. Wild Throh use vines to weave their own belts.",
      },
    ],
  },
  {
    id: "zsv10pt5-33",
    name: "Thundurus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Charge",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Lightning Energy card and attach it to this Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Disaster Volt",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "33",
    flavorText:
      "Countless charred remains mar the landscape of places through which Thundurus has passed.",
    nationalPokedexNumbers: [642],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/33.png",
      large: "https://images.pokemontcg.io/zsv10pt5/33_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/33.png",
          large: "https://images.pokemontcg.io/zsv10pt5/33_hires.png",
        },
        flavorText:
          "Countless charred remains mar the landscape of places through which Thundurus has passed.",
      },
    ],
  },
  {
    id: "sv6-15",
    name: "Thwackey",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Grookey",
    evolvesTo: ["Rillaboom"],
    abilities: [
      {
        name: "Boom Boom Groove",
        text: "Once during your turn, if your Active Pokémon has the Festival Lead Ability, you may search your deck for a card and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Beat",
        cost: ["Grass", "Grass"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "15",
    flavorText:
      "The faster a Thwackey can beat out a rhythm with its two sticks, the more respect it wins from its peers.",
    nationalPokedexNumbers: [811],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/15.png",
      large: "https://images.pokemontcg.io/sv6/15_hires.png",
    },
    altArts: [
      {
        id: "sv6-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv6/15.png",
          large: "https://images.pokemontcg.io/sv6/15_hires.png",
        },
        flavorText:
          "The faster a Thwackey can beat out a rhythm with its two sticks, the more respect it wins from its peers.",
      },
      {
        id: "svp-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/svp/115.png",
          large: "https://images.pokemontcg.io/svp/115_hires.png",
        },
        flavorText:
          "The faster a Thwackey can beat out a rhythm with its two sticks, the more respect it wins from its peers.",
      },
    ],
  },
  {
    id: "zsv10pt5-47",
    name: "Timburr",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Gurdurr"],
    attacks: [
      {
        name: "Low Kick",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Strength",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "47",
    flavorText:
      "It fights by swinging a piece of lumber around. It is close to evolving when it can handle the lumber without difficulty.",
    nationalPokedexNumbers: [532],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/47.png",
      large: "https://images.pokemontcg.io/zsv10pt5/47_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/47.png",
          large: "https://images.pokemontcg.io/zsv10pt5/47_hires.png",
        },
        flavorText:
          "It fights by swinging a piece of lumber around. It is close to evolving when it can handle the lumber without difficulty.",
      },
      {
        id: "zsv10pt5-125",
        number: "125",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/125.png",
          large: "https://images.pokemontcg.io/zsv10pt5/125_hires.png",
        },
        flavorText:
          "It fights by swinging a piece of lumber around. It is close to evolving when it can handle the lumber without difficulty.",
      },
    ],
  },
  {
    id: "sv6-103",
    name: "Timburr",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fighting"],
    evolvesTo: ["Gurdurr"],
    attacks: [
      {
        name: "Best Punch",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "103",
    flavorText:
      "It fights by swinging a piece of lumber around. It is close to evolving when it can handle heavy lumber without difficulty.",
    nationalPokedexNumbers: [532],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/103.png",
      large: "https://images.pokemontcg.io/sv6/103_hires.png",
    },
    altArts: [
      {
        id: "sv6-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/sv6/103.png",
          large: "https://images.pokemontcg.io/sv6/103_hires.png",
        },
        flavorText:
          "It fights by swinging a piece of lumber around. It is close to evolving when it can handle heavy lumber without difficulty.",
      },
      {
        id: "sv6-183",
        number: "183",
        images: {
          small: "https://images.pokemontcg.io/sv6/183.png",
          large: "https://images.pokemontcg.io/sv6/183_hires.png",
        },
        flavorText:
          "It fights by swinging a piece of lumber around. It is close to evolving when it can handle heavy lumber without difficulty.",
      },
    ],
  },
  {
    id: "sv6-110",
    name: "Ting-Lu",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "140",
    types: ["Fighting"],
    attacks: [
      {
        name: "Ground Crasher",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "If a Stadium is in play, this attack also does 30 damage to each of your opponent's Benched Pokémon, and discard that Stadium. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Hammer In",
        cost: ["Fighting", "Fighting", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "110",
    flavorText:
      "It slowly brings its exceedingly heavy head down upon the ground, splitting the earth open with huge fissures that run over 160 feet deep.",
    nationalPokedexNumbers: [1003],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/110.png",
      large: "https://images.pokemontcg.io/sv6/110_hires.png",
    },
    altArts: [
      {
        id: "sv6-110",
        number: "110",
        images: {
          small: "https://images.pokemontcg.io/sv6/110.png",
          large: "https://images.pokemontcg.io/sv6/110_hires.png",
        },
        flavorText:
          "It slowly brings its exceedingly heavy head down upon the ground, splitting the earth open with huge fissures that run over 160 feet deep.",
      },
    ],
  },
  {
    id: "me1-96",
    name: "Tinkatink",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Beat",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "96",
    nationalPokedexNumbers: [957],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/96.png",
      large: "https://images.pokemontcg.io/me1/96_hires.png",
    },
    altArts: [
      {
        id: "me1-96",
        number: "96",
        images: {
          small: "https://images.pokemontcg.io/me1/96.png",
          large: "https://images.pokemontcg.io/me1/96_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-98",
    name: "Tinkaton",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Metal"],
    evolvesFrom: "Tinkatuff",
    attacks: [
      {
        name: "Windup Swing",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "240-",
        text: "This attack does 60 less damage for each Energy attached to your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "98",
    nationalPokedexNumbers: [959],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/98.png",
      large: "https://images.pokemontcg.io/me1/98_hires.png",
    },
    altArts: [
      {
        id: "me1-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/me1/98.png",
          large: "https://images.pokemontcg.io/me1/98_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-97",
    name: "Tinkatuff",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Metal"],
    evolvesFrom: "Tinkatink",
    abilities: [
      {
        name: "Haphazard Hammer",
        text: "Once during your turn, when you play this Pokémon from your hand to evolve 1 of your Pokémon, you may use this Ability. Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Light Punch",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "97",
    nationalPokedexNumbers: [958],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/97.png",
      large: "https://images.pokemontcg.io/me1/97_hires.png",
    },
    altArts: [
      {
        id: "me1-97",
        number: "97",
        images: {
          small: "https://images.pokemontcg.io/me1/97.png",
          large: "https://images.pokemontcg.io/me1/97_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-22",
    name: "Tirtouga",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Antique Cover Fossil",
    evolvesTo: ["Carracosta"],
    attacks: [
      {
        name: "Ancient Seaweed",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each Item card in your opponent's discard pile.",
      },
      {
        name: "Surf",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "22",
    flavorText:
      "Restored from a fossil, this Pokémon can dive to depths beyond half a mile.",
    nationalPokedexNumbers: [564],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/22.png",
      large: "https://images.pokemontcg.io/zsv10pt5/22_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/22.png",
          large: "https://images.pokemontcg.io/zsv10pt5/22_hires.png",
        },
        flavorText:
          "Restored from a fossil, this Pokémon can dive to depths beyond half a mile.",
      },
      {
        id: "zsv10pt5-106",
        number: "106",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/106.png",
          large: "https://images.pokemontcg.io/zsv10pt5/106_hires.png",
        },
        flavorText:
          "Restored from a fossil, this Pokémon can dive to depths beyond half a mile.",
      },
    ],
  },
  {
    id: "sv7-37",
    name: "Tirtouga",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Antique Cover Fossil",
    evolvesTo: ["Carracosta"],
    attacks: [
      {
        name: "Splashing Turn",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "Switch this Pokémon with 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "37",
    nationalPokedexNumbers: [564],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/37.png",
      large: "https://images.pokemontcg.io/sv7/37_hires.png",
    },
    altArts: [
      {
        id: "sv7-37",
        number: "37",
        images: {
          small: "https://images.pokemontcg.io/sv7/37.png",
          large: "https://images.pokemontcg.io/sv7/37_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-17",
    name: "Toedscool",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Ram",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Gentle Slap",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "17",
    nationalPokedexNumbers: [948],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/17.png",
      large: "https://images.pokemontcg.io/sv7/17_hires.png",
    },
    altArts: [
      {
        id: "sv7-17",
        number: "17",
        images: {
          small: "https://images.pokemontcg.io/sv7/17.png",
          large: "https://images.pokemontcg.io/sv7/17_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-88",
    name: "Toedscool",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    attacks: [
      {
        name: "Spray Fluid",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "88",
    nationalPokedexNumbers: [948],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/88.png",
      large: "https://images.pokemontcg.io/sv9/88_hires.png",
    },
    altArts: [
      {
        id: "sv9-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv9/88.png",
          large: "https://images.pokemontcg.io/sv9/88_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-18",
    name: "Toedscruel",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Grass"],
    evolvesFrom: "Toedscool",
    attacks: [
      {
        name: "Mega Drain",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
      {
        name: "Whip Smash",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "18",
    nationalPokedexNumbers: [949],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/18.png",
      large: "https://images.pokemontcg.io/sv7/18_hires.png",
    },
    altArts: [
      {
        id: "sv7-18",
        number: "18",
        images: {
          small: "https://images.pokemontcg.io/sv7/18.png",
          large: "https://images.pokemontcg.io/sv7/18_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-89",
    name: "Toedscruel",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Toedscool",
    abilities: [
      {
        name: "Secret Forest Path",
        text: "As long as this Pokémon is on your Bench, your Active Pokémon's Retreat Cost is ColorlessColorless less.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Mud Shot",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "89",
    nationalPokedexNumbers: [949],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/89.png",
      large: "https://images.pokemontcg.io/sv9/89_hires.png",
    },
    altArts: [
      {
        id: "sv9-89",
        number: "89",
        images: {
          small: "https://images.pokemontcg.io/sv9/89.png",
          large: "https://images.pokemontcg.io/sv9/89_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-73",
    name: "Togedemaru",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Metal"],
    attacks: [
      {
        name: "Find a Friend",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Gnaw",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    flavorText:
      "When it's in trouble, it curls up into a ball, makes its fur spikes stand on end, and then discharges electricity indiscriminately.",
    nationalPokedexNumbers: [777],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/73.png",
      large: "https://images.pokemontcg.io/me2/73_hires.png",
    },
    altArts: [
      {
        id: "me2-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/me2/73.png",
          large: "https://images.pokemontcg.io/me2/73_hires.png",
        },
        flavorText:
          "When it's in trouble, it curls up into a ball, makes its fur spikes stand on end, and then discharges electricity indiscriminately.",
      },
      {
        id: "me2-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/me2/104.png",
          large: "https://images.pokemontcg.io/me2/104_hires.png",
        },
        flavorText:
          "When it's in trouble, it curls up into a ball, makes its fur spikes stand on end, and then discharges electricity indiscriminately.",
      },
    ],
  },
  {
    id: "sv7-54",
    name: "Togedemaru",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Lightning"],
    attacks: [
      {
        name: "Electrifying Chance",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "If you have exactly 1 Prize card remaining, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "54",
    nationalPokedexNumbers: [777],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/54.png",
      large: "https://images.pokemontcg.io/sv7/54_hires.png",
    },
    altArts: [
      {
        id: "sv7-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/sv7/54.png",
          large: "https://images.pokemontcg.io/sv7/54_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-50",
    name: "Togedemaru",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Lightning"],
    attacks: [
      {
        name: "Toge Spark",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [777],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/50.png",
      large: "https://images.pokemontcg.io/sv9/50_hires.png",
    },
    altArts: [
      {
        id: "sv9-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv9/50.png",
          large: "https://images.pokemontcg.io/sv9/50_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-149",
    name: "Togedemaru ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "190",
    types: ["Metal"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Stun Needle",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Spiky Rolling",
        cost: ["Metal", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80+",
        text: "If this Pokémon used Spiky Rolling during your last turn, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "149",
    nationalPokedexNumbers: [777],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-149/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-149/large",
    },
    altArts: [
      {
        id: "me2pt5-149",
        number: "149",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-149/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-149/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-82",
    name: "Togekiss",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "140",
    types: ["Psychic"],
    evolvesFrom: "Togetic",
    abilities: [
      {
        name: "Wonder Kiss",
        text: "When your opponent's Active Pokémon is Knocked Out, flip a coin. If heads, take 1 more Prize card. The effect of Wonder Kiss doesn't stack.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Speed Wing",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "140",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "82",
    flavorText:
      "These Pokémon are never seen anywhere near conflict or turmoil. In recent times, they’ve hardly been seen at all.",
    nationalPokedexNumbers: [468],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-82/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-82/large",
    },
    altArts: [
      {
        id: "me2pt5-82",
        number: "82",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-82/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-82/large",
        },
        flavorText:
          "These Pokémon are never seen anywhere near conflict or turmoil. In recent times, they’ve hardly been seen at all.",
      },
      {
        id: "me2pt5-235",
        number: "235",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-235/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-235/large",
        },
        flavorText:
          "These Pokémon are never seen anywhere near conflict or turmoil. In recent times, they’ve hardly been seen at all.",
      },
      {
        id: "sv8-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/sv8/72.png",
          large: "https://images.pokemontcg.io/sv8/72_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-80",
    name: "Togepi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Psychic"],
    attacks: [
      {
        name: "Pound",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "80",
    flavorText:
      "The shell seems to be filled with joy. It is said that it will share good luck when treated kindly.",
    nationalPokedexNumbers: [175],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-80/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-80/large",
    },
    altArts: [
      {
        id: "me2pt5-80",
        number: "80",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-80/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-80/large",
        },
        flavorText:
          "The shell seems to be filled with joy. It is said that it will share good luck when treated kindly.",
      },
      {
        id: "sv8-70",
        number: "70",
        images: {
          small: "https://images.pokemontcg.io/sv8/70.png",
          large: "https://images.pokemontcg.io/sv8/70_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-81",
    name: "Togetic",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Psychic"],
    evolvesFrom: "Togepi",
    attacks: [
      {
        name: "Draining Kiss",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "81",
    flavorText:
      "They say that it will appear before kindhearted, caring people and shower them with happiness.",
    nationalPokedexNumbers: [176],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-81/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-81/large",
    },
    altArts: [
      {
        id: "me2pt5-81",
        number: "81",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-81/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-81/large",
        },
        flavorText:
          "They say that it will appear before kindhearted, caring people and shower them with happiness.",
      },
      {
        id: "sv8-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/sv8/71.png",
          large: "https://images.pokemontcg.io/sv8/71_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-40",
    name: "Torchic",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Combusken"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Combustion",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "40",
    nationalPokedexNumbers: [255],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/40.png",
      large: "https://images.pokemontcg.io/sv10/40_hires.png",
    },
    altArts: [
      {
        id: "sv10-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv10/40.png",
          large: "https://images.pokemontcg.io/sv10/40_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-22",
    name: "Torchic",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fire"],
    evolvesTo: ["Combusken"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [255],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/22.png",
      large: "https://images.pokemontcg.io/sv9/22_hires.png",
    },
    altArts: [
      {
        id: "sv9-22",
        number: "22",
        images: {
          small: "https://images.pokemontcg.io/sv9/22.png",
          large: "https://images.pokemontcg.io/sv9/22_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-30",
    name: "Torkoal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Ramming Shell",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Fire Spin",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "Discard 2 Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "30",
    flavorText:
      "Coal is the source of Torkoal's energy. Large amounts of coal can be found in the mountains where they live.",
    nationalPokedexNumbers: [324],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/30.png",
      large: "https://images.pokemontcg.io/sv6/30_hires.png",
    },
    altArts: [
      {
        id: "sv6-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/sv6/30.png",
          large: "https://images.pokemontcg.io/sv6/30_hires.png",
        },
        flavorText:
          "Coal is the source of Torkoal's energy. Large amounts of coal can be found in the mountains where they live.",
      },
      {
        id: "sv6-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/sv6/172.png",
          large: "https://images.pokemontcg.io/sv6/172_hires.png",
        },
        flavorText:
          "Coal is the source of Torkoal's energy. Large amounts of coal can be found in the mountains where they live.",
      },
    ],
  },
  {
    id: "sv9-25",
    name: "Torkoal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Live Coal",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Heat Blast",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "25",
    nationalPokedexNumbers: [324],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/25.png",
      large: "https://images.pokemontcg.io/sv9/25_hires.png",
    },
    altArts: [
      {
        id: "sv9-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv9/25.png",
          large: "https://images.pokemontcg.io/sv9/25_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-78",
    name: "Tornadus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Colorless"],
    attacks: [
      {
        name: "Wrapped in Wind",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach a Basic Energy card from your hand to this Pokémon.",
      },
      {
        name: "Hurricane",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Move a Basic Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    flavorText:
      "The lower half of its body is wrapped in a cloud of energy. It zooms through the sky at 200 mph.",
    nationalPokedexNumbers: [641],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/78.png",
      large: "https://images.pokemontcg.io/rsv10pt5/78_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/78.png",
          large: "https://images.pokemontcg.io/rsv10pt5/78_hires.png",
        },
        flavorText:
          "The lower half of its body is wrapped in a cloud of energy. It zooms through the sky at 200 mph.",
      },
    ],
  },
  {
    id: "sv7-120",
    name: "Tornadus",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Colorless"],
    attacks: [
      {
        name: "Knuckle Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Storm Barrier",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "During your opponent's next turn, this Pokémon takes 50 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "120",
    nationalPokedexNumbers: [641],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/120.png",
      large: "https://images.pokemontcg.io/sv7/120_hires.png",
    },
    altArts: [
      {
        id: "sv7-120",
        number: "120",
        images: {
          small: "https://images.pokemontcg.io/sv7/120.png",
          large: "https://images.pokemontcg.io/sv7/120_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-33",
    name: "Torracat",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fire"],
    evolvesFrom: "Litten",
    evolvesTo: ["Incineroar"],
    attacks: [
      {
        name: "Bite",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Flare Strike",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "During your next turn, this Pokémon can't use Flare Strike.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "33",
    flavorText:
      "In the midst of battle, the fire pouch on Torracat's neck rings like a bell and produces stronger flames than usual.",
    nationalPokedexNumbers: [726],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/33.png",
      large: "https://images.pokemontcg.io/sv5/33_hires.png",
    },
    altArts: [
      {
        id: "sv5-33",
        number: "33",
        images: {
          small: "https://images.pokemontcg.io/sv5/33.png",
          large: "https://images.pokemontcg.io/sv5/33_hires.png",
        },
        flavorText:
          "In the midst of battle, the fire pouch on Torracat's neck rings like a bell and produces stronger flames than usual.",
      },
    ],
  },
  {
    id: "sv5-12",
    name: "Torterra ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "340",
    types: ["Grass"],
    evolvesFrom: "Grotle",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Forest March",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each of your Grass Pokémon in play.",
      },
      {
        name: "Jungle Hammer",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Heal 50 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "12",
    nationalPokedexNumbers: [389],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/12.png",
      large: "https://images.pokemontcg.io/sv5/12_hires.png",
    },
    altArts: [
      {
        id: "sv5-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/sv5/12.png",
          large: "https://images.pokemontcg.io/sv5/12_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-185",
        number: "185",
        images: {
          small: "https://images.pokemontcg.io/sv5/185.png",
          large: "https://images.pokemontcg.io/sv5/185_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-41",
    name: "Totodile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    attacks: [
      {
        name: "Slight Intrusion",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "41",
    flavorText:
      "It is small but rough and tough. It won't hesitate to take a bite out of anything that moves.",
    nationalPokedexNumbers: [158],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-41/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-41/large",
    },
    altArts: [
      {
        id: "me2pt5-41",
        number: "41",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-41/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-41/large",
        },
        flavorText:
          "It is small but rough and tough. It won't hesitate to take a bite out of anything that moves.",
      },
    ],
  },
  {
    id: "sv5-39",
    name: "Totodile",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    evolvesTo: ["Croconaw"],
    attacks: [
      {
        name: "Big Bite",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "39",
    flavorText:
      "It is small but rough and tough. It won't hesitate to take a bite out of anything that moves.",
    nationalPokedexNumbers: [158],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/39.png",
      large: "https://images.pokemontcg.io/sv5/39_hires.png",
    },
    altArts: [
      {
        id: "sv5-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/sv5/39.png",
          large: "https://images.pokemontcg.io/sv5/39_hires.png",
        },
        flavorText:
          "It is small but rough and tough. It won't hesitate to take a bite out of anything that moves.",
      },
    ],
  },
  {
    id: "me5-68",
    name: "Toucannon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Colorless"],
    evolvesFrom: "Trumbeak",
    abilities: [
      {
        name: "Aerial Draw",
        text: "Once during your turn, you may use this Ability. Draw a card.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Feather Rondo",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "This attack does 20 more damage for each Benched Pokémon (both yours and your opponent's).",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "68",
    flavorText:
      "Pairs of Toucannon are considered symbols of companionship, as these Pokémon will raise the temperature of their beaks to warm each other.",
    nationalPokedexNumbers: [733],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-68/small",
      large: "https://images.scrydex.com/pokemon/me5-68/large",
    },
    altArts: [
      {
        id: "me5-68",
        number: "68",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-68/small",
          large: "https://images.scrydex.com/pokemon/me5-68/large",
        },
        flavorText:
          "Pairs of Toucannon are considered symbols of companionship, as these Pokémon will raise the temperature of their beaks to warm each other.",
      },
      {
        id: "me5-94",
        number: "94",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-94/small",
          large: "https://images.scrydex.com/pokemon/me5-94/large",
        },
        flavorText:
          "Pairs of Toucannon are considered symbols of companionship, as these Pokémon will raise the temperature of their beaks to warm each other.",
      },
    ],
  },
  {
    id: "me2-67",
    name: "Toxel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Toxtricity"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Playful Kick",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    flavorText:
      "It has no problem drinking dirty water. An organ inside Toxel's body filters such water into a poisonous liquid that is harmless to Toxel.",
    nationalPokedexNumbers: [848],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/67.png",
      large: "https://images.pokemontcg.io/me2/67_hires.png",
    },
    altArts: [
      {
        id: "me2-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/me2/67.png",
          large: "https://images.pokemontcg.io/me2/67_hires.png",
        },
        flavorText:
          "It has no problem drinking dirty water. An organ inside Toxel's body filters such water into a poisonous liquid that is harmless to Toxel.",
      },
    ],
  },
  {
    id: "me55-58",
    name: "Toxel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    nationalPokedexNumbers: [848],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-58/small",
      large: "https://images.scrydex.com/pokemon/me55-58/large",
    },
    altArts: [
      {
        id: "me55-58",
        number: "58",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-58/small",
          large: "https://images.scrydex.com/pokemon/me55-58/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-79",
    name: "Toxicroak",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Croagunk",
    attacks: [
      {
        name: "Reckless Charge",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "70",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "79",
    nationalPokedexNumbers: [454],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/79.png",
      large: "https://images.pokemontcg.io/me1/79_hires.png",
    },
    altArts: [
      {
        id: "me1-79",
        number: "79",
        images: {
          small: "https://images.pokemontcg.io/me1/79.png",
          large: "https://images.pokemontcg.io/me1/79_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-24",
    name: "Toxicroak",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Fighting"],
    evolvesFrom: "Croagunk",
    attacks: [
      {
        name: "Corkscrew Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Clean Hit",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90+",
        text: "If your opponent's Active Pokémon is an Evolution Pokémon, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "24",
    nationalPokedexNumbers: [454],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/24.png",
      large: "https://images.pokemontcg.io/sv6pt5/24_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-24",
        number: "24",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/24.png",
          large: "https://images.pokemontcg.io/sv6pt5/24_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-68",
    name: "Toxtricity",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Darkness"],
    evolvesFrom: "Toxel",
    abilities: [
      {
        name: "Sinister Surge",
        text: "Once during your turn, you may use this Ability. Search your deck for a Basic Darkness Energy card and attach it to 1 of your Benched Darkness Pokémon. Then, shuffle your deck. If you attached Energy to a Pokémon in this way, place 2 damage counters on that Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Gentle Slap",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "68",
    flavorText:
      "As it scatters toxic sweat and emits electricity, a melody that sounds like it came from a guitar reverberates through the surrounding area.",
    nationalPokedexNumbers: [849],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/68.png",
      large: "https://images.pokemontcg.io/me2/68_hires.png",
    },
    altArts: [
      {
        id: "me2-68",
        number: "68",
        images: {
          small: "https://images.pokemontcg.io/me2/68.png",
          large: "https://images.pokemontcg.io/me2/68_hires.png",
        },
        flavorText:
          "As it scatters toxic sweat and emits electricity, a melody that sounds like it came from a guitar reverberates through the surrounding area.",
      },
      {
        id: "me2-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/me2/103.png",
          large: "https://images.pokemontcg.io/me2/103_hires.png",
        },
        flavorText:
          "As it scatters toxic sweat and emits electricity, a melody that sounds like it came from a guitar reverberates through the surrounding area.",
      },
    ],
  },
  {
    id: "me55-59",
    name: "Toxtricity",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Lightning"],
    evolvesFrom: "Toxel",
    attacks: [
      {
        name: "Mach Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "59",
    nationalPokedexNumbers: [849],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-59/small",
      large: "https://images.scrydex.com/pokemon/me55-59/large",
    },
    altArts: [
      {
        id: "me55-59",
        number: "59",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-59/small",
          large: "https://images.scrydex.com/pokemon/me55-59/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-60",
    name: "Toxtricity",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Lightning"],
    evolvesFrom: "Toxel",
    attacks: [
      {
        name: "Light Punch",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "40",
      },
      {
        name: "Thunderous Bolt",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "60",
    nationalPokedexNumbers: [849],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-60/small",
      large: "https://images.scrydex.com/pokemon/me55-60/large",
    },
    altArts: [
      {
        id: "me55-60",
        number: "60",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-60/small",
          large: "https://images.scrydex.com/pokemon/me55-60/large",
        },
        flavorText: "",
      },
      {
        id: "me55-134",
        number: "134",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-134/small",
          large: "https://images.scrydex.com/pokemon/me55-134/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-72",
    name: "Tranquill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Colorless"],
    evolvesFrom: "Pidove",
    evolvesTo: ["Unfezant"],
    attacks: [
      {
        name: "Fly",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "Flip a coin. If tails, this attack does nothing. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "72",
    flavorText:
      "It can return to its Trainer's location regardless of the distance separating them.",
    nationalPokedexNumbers: [520],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/72.png",
      large: "https://images.pokemontcg.io/zsv10pt5/72_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-72",
        number: "72",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/72.png",
          large: "https://images.pokemontcg.io/zsv10pt5/72_hires.png",
        },
        flavorText:
          "It can return to its Trainer's location regardless of the distance separating them.",
      },
      {
        id: "zsv10pt5-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/149.png",
          large: "https://images.pokemontcg.io/zsv10pt5/149_hires.png",
        },
        flavorText:
          "It can return to its Trainer's location regardless of the distance separating them.",
      },
    ],
  },
  {
    id: "sv5-134",
    name: "Tranquill",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "80",
    types: ["Colorless"],
    evolvesFrom: "Pidove",
    evolvesTo: ["Unfezant"],
    attacks: [
      {
        name: "Speed Dive",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Jet Wing",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "134",
    flavorText:
      "It can fly moderately quickly. No matter how far it travels, it can always find its way back to its master and its nest.",
    nationalPokedexNumbers: [520],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/134.png",
      large: "https://images.pokemontcg.io/sv5/134_hires.png",
    },
    altArts: [
      {
        id: "sv5-134",
        number: "134",
        images: {
          small: "https://images.pokemontcg.io/sv5/134.png",
          large: "https://images.pokemontcg.io/sv5/134_hires.png",
        },
        flavorText:
          "It can fly moderately quickly. No matter how far it travels, it can always find its way back to its master and its nest.",
      },
    ],
  },
  {
    id: "me2-51",
    name: "Trapinch",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fighting"],
    evolvesTo: ["Vibrava"],
    attacks: [
      {
        name: "Double Headbutt",
        cost: ["Fighting"],
        convertedEnergyCost: 1,
        damage: "10×",
        text: "Flip 2 coins. This attack does 10 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "51",
    flavorText:
      "This Pokémon lives in arid deserts. It patiently awaits prey inside its funnel- shaped nest.",
    nationalPokedexNumbers: [328],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/51.png",
      large: "https://images.pokemontcg.io/me2/51_hires.png",
    },
    altArts: [
      {
        id: "me2-51",
        number: "51",
        images: {
          small: "https://images.pokemontcg.io/me2/51.png",
          large: "https://images.pokemontcg.io/me2/51_hires.png",
        },
        flavorText:
          "This Pokémon lives in arid deserts. It patiently awaits prey inside its funnel- shaped nest.",
      },
    ],
  },
  {
    id: "sv8-104",
    name: "Trapinch",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Fighting"],
    evolvesTo: ["Vibrava"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Bite",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "104",
    nationalPokedexNumbers: [328],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/104.png",
      large: "https://images.pokemontcg.io/sv8/104_hires.png",
    },
    altArts: [
      {
        id: "sv8-104",
        number: "104",
        images: {
          small: "https://images.pokemontcg.io/sv8/104.png",
          large: "https://images.pokemontcg.io/sv8/104_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-39",
    name: "Trevenant",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Psychic"],
    evolvesFrom: "Phantump",
    attacks: [
      {
        name: "Cursed Roots",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "During your opponent's next turn, Energy can't be attached from your opponent's hand to the Defending Pokémon.",
      },
      {
        name: "Overwhelming Pain",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "60+",
        text: "This attack does 10 more damage for each damage counter on all of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "39",
    flavorText:
      "Using its roots as a nervous system, it controls the trees in the forest. It's kind to the Pokémon that reside in its body.",
    nationalPokedexNumbers: [709],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-39/small",
      large: "https://images.scrydex.com/pokemon/me4-39/large",
    },
    altArts: [
      {
        id: "me4-39",
        number: "39",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-39/small",
          large: "https://images.scrydex.com/pokemon/me4-39/large",
        },
        flavorText:
          "Using its roots as a nervous system, it controls the trees in the forest. It's kind to the Pokémon that reside in its body.",
      },
    ],
  },
  {
    id: "sv6-13",
    name: "Trevenant",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Phantump",
    attacks: [
      {
        name: "Giga Drain",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "Heal from this Pokémon the same amount of damage you did to your opponent's Active Pokémon.",
      },
      {
        name: "Forest Dump",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "13",
    flavorText:
      "Trevenant is very kind to Pokémon living in the forest. It doesn't even care if these Pokémon take up residence in the greenery on its head.",
    nationalPokedexNumbers: [709],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/13.png",
      large: "https://images.pokemontcg.io/sv6/13_hires.png",
    },
    altArts: [
      {
        id: "sv6-13",
        number: "13",
        images: {
          small: "https://images.pokemontcg.io/sv6/13.png",
          large: "https://images.pokemontcg.io/sv6/13_hires.png",
        },
        flavorText:
          "Trevenant is very kind to Pokémon living in the forest. It doesn't even care if these Pokémon take up residence in the greenery on its head.",
      },
    ],
  },
  {
    id: "me5-1",
    name: "Tropius",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Grass"],
    attacks: [
      {
        name: "Fruity Aroma",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Look at the top 6 cards of your deck, and you may reveal any number of Pokémon you find there and put them into your hand. Shuffle the other cards back into your deck.",
      },
      {
        name: "Solar Beam",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    flavorText:
      "Delicious fruits grew out from around its neck because it always ate the same kind of fruit.",
    nationalPokedexNumbers: [357],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-1/small",
      large: "https://images.scrydex.com/pokemon/me5-1/large",
    },
    altArts: [
      {
        id: "me5-1",
        number: "1",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-1/small",
          large: "https://images.scrydex.com/pokemon/me5-1/large",
        },
        flavorText:
          "Delicious fruits grew out from around its neck because it always ate the same kind of fruit.",
      },
    ],
  },
  {
    id: "me55-5",
    name: "Tropius",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Rally Back",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 90 more damage.",
      },
      {
        name: "Cutting Wind",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "5",
    nationalPokedexNumbers: [357],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-5/small",
      large: "https://images.scrydex.com/pokemon/me55-5/large",
    },
    altArts: [
      {
        id: "me55-5",
        number: "5",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-5/small",
          large: "https://images.scrydex.com/pokemon/me55-5/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-123",
    name: "Tropius",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Colorless"],
    attacks: [
      {
        name: "Fruit Bearing",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard a card from your hand. If you do, draw 3 cards.",
      },
      {
        name: "Gust",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "123",
    nationalPokedexNumbers: [357],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/123.png",
      large: "https://images.pokemontcg.io/sv9/123_hires.png",
    },
    altArts: [
      {
        id: "sv9-123",
        number: "123",
        images: {
          small: "https://images.pokemontcg.io/sv9/123.png",
          large: "https://images.pokemontcg.io/sv9/123_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-59",
    name: "Trubbish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Garbodor"],
    attacks: [
      {
        name: "Drool",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Sludge Bomb",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "59",
    flavorText:
      "Inhaling the gas they belch will make you sleep for a week. They prefer unsanitary places.",
    nationalPokedexNumbers: [568],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/59.png",
      large: "https://images.pokemontcg.io/rsv10pt5/59_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-59",
        number: "59",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/59.png",
          large: "https://images.pokemontcg.io/rsv10pt5/59_hires.png",
        },
        flavorText:
          "Inhaling the gas they belch will make you sleep for a week. They prefer unsanitary places.",
      },
      {
        id: "rsv10pt5-140",
        number: "140",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/140.png",
          large: "https://images.pokemontcg.io/rsv10pt5/140_hires.png",
        },
        flavorText:
          "Inhaling the gas they belch will make you sleep for a week. They prefer unsanitary places.",
      },
    ],
  },
  {
    id: "me4-56",
    name: "Trubbish",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Acid Spray",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "56",
    flavorText:
      "The combination of garbage bags and industrial waste caused the chemical reaction that created this Pokémon.",
    nationalPokedexNumbers: [568],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-56/small",
      large: "https://images.scrydex.com/pokemon/me4-56/large",
    },
    altArts: [
      {
        id: "me4-56",
        number: "56",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-56/small",
          large: "https://images.scrydex.com/pokemon/me4-56/large",
        },
        flavorText:
          "The combination of garbage bags and industrial waste caused the chemical reaction that created this Pokémon.",
      },
    ],
  },
  {
    id: "me5-67",
    name: "Trumbeak",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Pikipek",
    attacks: [
      {
        name: "Fly",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    nationalPokedexNumbers: [732],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-67/small",
      large: "https://images.scrydex.com/pokemon/me5-67/large",
    },
    altArts: [
      {
        id: "me5-67",
        number: "67",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-67/small",
          large: "https://images.scrydex.com/pokemon/me5-67/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-17",
    name: "Turtonator",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fire"],
    abilities: [
      {
        name: "Shell Spikes",
        text: "If this Pokémon is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), discard an Energy from the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Heat Breath",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "Flip a coin. If heads, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "17",
    nationalPokedexNumbers: [776],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-17/small",
      large: "https://images.scrydex.com/pokemon/me3-17/large",
    },
    altArts: [
      {
        id: "me3-17",
        number: "17",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-17/small",
          large: "https://images.scrydex.com/pokemon/me3-17/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-35",
    name: "Turtonator",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Fire"],
    attacks: [
      {
        name: "Spit-Out Shot",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 40 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Steam Artillery",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "35",
    flavorText:
      "Explosive substances coat the shell on its back. Enemies that dare attack it will be blown away by an immense detonation.",
    nationalPokedexNumbers: [776],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/35.png",
      large: "https://images.pokemontcg.io/sv5/35_hires.png",
    },
    altArts: [
      {
        id: "sv5-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv5/35.png",
          large: "https://images.pokemontcg.io/sv5/35_hires.png",
        },
        flavorText:
          "Explosive substances coat the shell on its back. Enemies that dare attack it will be blown away by an immense detonation.",
      },
    ],
  },
  {
    id: "sv7-25",
    name: "Turtonator",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Ring of Fire",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "Your opponent's Active Pokémon is now Burned. During your opponent's next turn, that Pokémon can't retreat.",
      },
      {
        name: "Inferno Onrush",
        cost: ["Fire", "Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "180",
        text: "This Pokémon also does 60 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "25",
    nationalPokedexNumbers: [776],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/25.png",
      large: "https://images.pokemontcg.io/sv7/25_hires.png",
    },
    altArts: [
      {
        id: "sv7-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv7/25.png",
          large: "https://images.pokemontcg.io/sv7/25_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/sv7/146.png",
          large: "https://images.pokemontcg.io/sv7/146_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-137",
    name: "Turtonator",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Dragon"],
    attacks: [
      {
        name: "Fully Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard an Energy from your opponent's Active Pokémon ex.",
      },
      {
        name: "Steaming Stomp",
        cost: ["Fighting", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "137",
    nationalPokedexNumbers: [776],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/137.png",
      large: "https://images.pokemontcg.io/sv8/137_hires.png",
    },
    altArts: [
      {
        id: "sv8-137",
        number: "137",
        images: {
          small: "https://images.pokemontcg.io/sv8/137.png",
          large: "https://images.pokemontcg.io/sv8/137_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-10",
    name: "Turtwig",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    evolvesTo: ["Grotle"],
    abilities: [
      {
        name: "Solid Shell",
        text: "This Pokémon takes 20 less damage from attacks (after applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Leafage",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "10",
    flavorText:
      "Photosynthesis occurs across its body under the sun. The shell on its back is actually hardened soil.",
    nationalPokedexNumbers: [387],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/10.png",
      large: "https://images.pokemontcg.io/sv5/10_hires.png",
    },
    altArts: [
      {
        id: "sv5-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/sv5/10.png",
          large: "https://images.pokemontcg.io/sv5/10_hires.png",
        },
        flavorText:
          "Photosynthesis occurs across its body under the sun. The shell on its back is actually hardened soil.",
      },
    ],
  },
  {
    id: "zsv10pt5-19",
    name: "Tympole",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Palpitoad"],
    attacks: [
      {
        name: "Round",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "This attack does 20 damage for each of your Pokémon in play that has the Round attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "19",
    flavorText:
      "They warn others of danger by vibrating their cheeks to create a high-pitched sound.",
    nationalPokedexNumbers: [535],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/19.png",
      large: "https://images.pokemontcg.io/zsv10pt5/19_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/19.png",
          large: "https://images.pokemontcg.io/zsv10pt5/19_hires.png",
        },
        flavorText:
          "They warn others of danger by vibrating their cheeks to create a high-pitched sound.",
      },
      {
        id: "zsv10pt5-103",
        number: "103",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/103.png",
          large: "https://images.pokemontcg.io/zsv10pt5/103_hires.png",
        },
        flavorText:
          "They warn others of danger by vibrating their cheeks to create a high-pitched sound.",
      },
    ],
  },
  {
    id: "zsv10pt5-30",
    name: "Tynamo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Lightning"],
    evolvesTo: ["Eelektrik"],
    attacks: [
      {
        name: "Hold Still",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Heal 10 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    number: "30",
    flavorText:
      "While one alone doesn't have much power, a chain of many Tynamo can be as powerful as lightning.",
    nationalPokedexNumbers: [602],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/30.png",
      large: "https://images.pokemontcg.io/zsv10pt5/30_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/30.png",
          large: "https://images.pokemontcg.io/zsv10pt5/30_hires.png",
        },
        flavorText:
          "While one alone doesn't have much power, a chain of many Tynamo can be as powerful as lightning.",
      },
      {
        id: "zsv10pt5-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/113.png",
          large: "https://images.pokemontcg.io/zsv10pt5/113_hires.png",
        },
        flavorText:
          "While one alone doesn't have much power, a chain of many Tynamo can be as powerful as lightning.",
      },
      {
        id: "me2pt5-59",
        number: "59",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-59/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-59/large",
        },
        flavorText:
          "While one alone doesn’t have much power, a chain of many Tynamo can be as powerful as lightning.",
      },
    ],
  },
  {
    id: "me5-69",
    name: "Type: Null",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Colorless"],
    attacks: [
      {
        name: "Power Edge",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "69",
    flavorText:
      "It was modeled after a mighty Pokémon of myth. The mask placed upon it limits its power in order to keep it under control.",
    nationalPokedexNumbers: [772],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-69/small",
      large: "https://images.scrydex.com/pokemon/me5-69/large",
    },
    altArts: [
      {
        id: "me5-69",
        number: "69",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-69/small",
          large: "https://images.scrydex.com/pokemon/me5-69/large",
        },
        flavorText:
          "It was modeled after a mighty Pokémon of myth. The mask placed upon it limits its power in order to keep it under control.",
      },
    ],
  },
  {
    id: "sv9-95",
    name: "Tyranitar",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "190",
    types: ["Darkness"],
    evolvesFrom: "Pupitar",
    abilities: [
      {
        name: "Daunting Gaze",
        text: "As long as this Pokémon is in the Active Spot, your opponent can't play any Item cards from their hand.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Cracking Stomp",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "150",
        text: "Discard the top 2 cards of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "95",
    nationalPokedexNumbers: [248],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/95.png",
      large: "https://images.pokemontcg.io/sv9/95_hires.png",
    },
    altArts: [
      {
        id: "sv9-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/sv9/95.png",
          large: "https://images.pokemontcg.io/sv9/95_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-64",
    name: "Tyranitar ex",
    supertype: "Pokémon",
    subtypes: ["Stage 2", "ex"],
    hp: "340",
    types: ["Darkness"],
    evolvesFrom: "Pupitar",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Grind",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "This attack does 50 damage for each Energy attached to this Pokémon.",
      },
      {
        name: "Tyrannical Crush",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "Discard a random card from your opponent's hand.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "64",
    nationalPokedexNumbers: [248],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/64.png",
      large: "https://images.pokemontcg.io/sv8pt5/64_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/64.png",
          large: "https://images.pokemontcg.io/sv8pt5/64_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-45",
    name: "Tyrantrum",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "180",
    types: ["Fighting"],
    evolvesFrom: "Tyrunt",
    abilities: [
      {
        name: "Tyrannically Gutsy",
        text: "If this Pokémon has any Special Energy attached, it gets +150 HP.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Wreak Havoc",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "160",
        text: "Flip a coin until you get tails. For each heads, discard the top card of your opponent's deck.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "45",
    nationalPokedexNumbers: [697],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-45/small",
      large: "https://images.scrydex.com/pokemon/me3-45/large",
    },
    altArts: [
      {
        id: "me3-45",
        number: "45",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-45/small",
          large: "https://images.scrydex.com/pokemon/me3-45/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-71",
    name: "Tyrogue",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Fighting"],
    evolvesTo: ["Hitmonlee", "Hitmonchan", "Hitmontop"],
    attacks: [
      {
        name: "Pow-Pow Punching",
        cost: ["Free"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin until you get tails. This attack does 30 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "×2",
      },
    ],
    number: "71",
    nationalPokedexNumbers: [236],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/71.png",
      large: "https://images.pokemontcg.io/me1/71_hires.png",
    },
    altArts: [
      {
        id: "me1-71",
        number: "71",
        images: {
          small: "https://images.pokemontcg.io/me1/71.png",
          large: "https://images.pokemontcg.io/me1/71_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-44",
    name: "Tyrunt",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Fighting"],
    evolvesFrom: "Antique Jaw Fossil",
    attacks: [
      {
        name: "Get Angry",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "This attack does 20 damage for each damage counter on this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "44",
    nationalPokedexNumbers: [696],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-44/small",
      large: "https://images.scrydex.com/pokemon/me3-44/large",
    },
    altArts: [
      {
        id: "me3-44",
        number: "44",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-44/small",
          large: "https://images.scrydex.com/pokemon/me3-44/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-91",
    name: "Umbreon",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Darkness"],
    evolvesFrom: "Eevee",
    attacks: [
      {
        name: "Retaliate",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If any of your Pokémon were Knocked Out by damage from an attack during your opponent's last turn, this attack does 100 more damage.",
      },
      {
        name: "Darkness Fang",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "91",
    nationalPokedexNumbers: [197],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-91/small",
      large: "https://images.scrydex.com/pokemon/me55-91/large",
    },
    altArts: [
      {
        id: "me55-91",
        number: "91",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-91/small",
          large: "https://images.scrydex.com/pokemon/me55-91/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-92",
    name: "Umbreon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "270",
    types: ["Darkness"],
    evolvesFrom: "Eevee",
    rules: [
      "When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Lunatic Claw",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "100+",
        text: "If your opponent's Active Pokémon already has any damage counters on it, this attack does 140 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "92",
    nationalPokedexNumbers: [197],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-92/small",
      large: "https://images.scrydex.com/pokemon/me55-92/large",
    },
    altArts: [
      {
        id: "me55-92",
        number: "92",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-92/small",
          large: "https://images.scrydex.com/pokemon/me55-92/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8pt5-60",
    name: "Umbreon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "280",
    types: ["Darkness"],
    evolvesFrom: "Eevee",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Moon Mirage",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Onyx",
        cost: ["Lightning", "Psychic", "Darkness"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Energy from this Pokémon, and take a Prize card.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "60",
    nationalPokedexNumbers: [197],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/60.png",
      large: "https://images.pokemontcg.io/sv8pt5/60_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/60.png",
          large: "https://images.pokemontcg.io/sv8pt5/60_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/161.png",
          large: "https://images.pokemontcg.io/sv8pt5/161_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-73",
    name: "Unfezant",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Colorless"],
    evolvesFrom: "Tranquill",
    attacks: [
      {
        name: "Add On",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw 4 cards.",
      },
      {
        name: "Swift Flight",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "Flip a coin. If heads, during your opponent's next turn, prevent all damage from and effects of attacks done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "73",
    flavorText:
      "Males swing their head plumage to threaten opponents. The females' flying abilities surpass those of the males.",
    nationalPokedexNumbers: [521],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/73.png",
      large: "https://images.pokemontcg.io/zsv10pt5/73_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/73.png",
          large: "https://images.pokemontcg.io/zsv10pt5/73_hires.png",
        },
        flavorText:
          "Males swing their head plumage to threaten opponents. The females' flying abilities surpass those of the males.",
      },
      {
        id: "zsv10pt5-150",
        number: "150",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/150.png",
          large: "https://images.pokemontcg.io/zsv10pt5/150_hires.png",
        },
        flavorText:
          "Males swing their head plumage to threaten opponents. The females' flying abilities surpass those of the males.",
      },
    ],
  },
  {
    id: "sv5-135",
    name: "Unfezant",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Colorless"],
    evolvesFrom: "Tranquill",
    attacks: [
      {
        name: "Opposing Winds",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "You may put 2 Energy attached to your opponent's Active Pokémon into their hand.",
      },
      {
        name: "Boundless Power",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "135",
    flavorText:
      "Unfezant are exceptional fliers. The females are known for their stamina, while the males outclass them in terms of speed.",
    nationalPokedexNumbers: [521],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/135.png",
      large: "https://images.pokemontcg.io/sv5/135_hires.png",
    },
    altArts: [
      {
        id: "sv5-135",
        number: "135",
        images: {
          small: "https://images.pokemontcg.io/sv5/135.png",
          large: "https://images.pokemontcg.io/sv5/135_hires.png",
        },
        flavorText:
          "Unfezant are exceptional fliers. The females are known for their stamina, while the males outclass them in terms of speed.",
      },
    ],
  },
  {
    id: "me55-72",
    name: "Unown",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Psychic"],
    attacks: [
      {
        name: "Mysterious Signal",
        cost: ["Psychic", "Psychic"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "If your opponent's Pokémon is Knocked Out by damage from this attack, take 1 more Prize card.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "72",
    nationalPokedexNumbers: [201],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-72/small",
      large: "https://images.scrydex.com/pokemon/me55-72/large",
    },
    altArts: [
      {
        id: "me55-72",
        number: "72",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-72/small",
          large: "https://images.scrydex.com/pokemon/me55-72/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-43",
    name: "Uxie",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    abilities: [
      {
        name: "Set Up",
        text: "Once during your turn, when you put Uxie from your hand onto your Bench, you may draw cards until you have 7 cards in your hand.",
        type: "Poké-POWER",
      },
    ],
    attacks: [
      {
        name: "Psychic Restore",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "You may put Uxie and all cards attached to it on the bottom of your deck in any order.",
      },
    ],
    weaknesses: [
      {
        type: "Psychic",
        value: "+20",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "43",
    nationalPokedexNumbers: [480],
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-43/small",
      large: "https://images.scrydex.com/pokemon/me55c-43/large",
    },
    altArts: [
      {
        id: "me55c-43",
        number: "43",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-43/small",
          large: "https://images.scrydex.com/pokemon/me55c-43/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-78",
    name: "Uxie",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    attacks: [
      {
        name: "Painful Memories",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put 2 damage counters on each of your opponent's Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    nationalPokedexNumbers: [480],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/78.png",
      large: "https://images.pokemontcg.io/sv8/78_hires.png",
    },
    altArts: [
      {
        id: "sv8-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv8/78.png",
          large: "https://images.pokemontcg.io/sv8/78_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-28",
    name: "Vanillish",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Water"],
    evolvesFrom: "Vanillite",
    evolvesTo: ["Vanilluxe"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
      {
        name: "Ice Beam",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "28",
    flavorText:
      "Snowy mountains are this Pokémon's habitat. During an ancient ice age, they moved to southern areas.",
    nationalPokedexNumbers: [583],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/28.png",
      large: "https://images.pokemontcg.io/rsv10pt5/28_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-28",
        number: "28",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/28.png",
          large: "https://images.pokemontcg.io/rsv10pt5/28_hires.png",
        },
        flavorText:
          "Snowy mountains are this Pokémon's habitat. During an ancient ice age, they moved to southern areas.",
      },
      {
        id: "rsv10pt5-112",
        number: "112",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/112.png",
          large: "https://images.pokemontcg.io/rsv10pt5/112_hires.png",
        },
        flavorText:
          "Snowy mountains are this Pokémon's habitat. During an ancient ice age, they moved to southern areas.",
      },
    ],
  },
  {
    id: "rsv10pt5-27",
    name: "Vanillite",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Vanillish"],
    attacks: [
      {
        name: "Beat",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Ice Edge",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "27",
    flavorText:
      "The temperature of their breath is -58° F. They create snow crystals and make snow fall in the areas around them.",
    nationalPokedexNumbers: [582],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/27.png",
      large: "https://images.pokemontcg.io/rsv10pt5/27_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/27.png",
          large: "https://images.pokemontcg.io/rsv10pt5/27_hires.png",
        },
        flavorText:
          "The temperature of their breath is -58° F. They create snow crystals and make snow fall in the areas around them.",
      },
      {
        id: "rsv10pt5-111",
        number: "111",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/111.png",
          large: "https://images.pokemontcg.io/rsv10pt5/111_hires.png",
        },
        flavorText:
          "The temperature of their breath is -58° F. They create snow crystals and make snow fall in the areas around them.",
      },
    ],
  },
  {
    id: "rsv10pt5-29",
    name: "Vanilluxe",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Water"],
    evolvesFrom: "Vanillish",
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
      {
        name: "Double Freeze",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90×",
        text: "Flip 2 coins. This attack does 90 damage for each heads. If either of them is heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "29",
    flavorText:
      "Swallowing large amounts of water, they make snow clouds inside their bodies and attack their foes with violent blizzards.",
    nationalPokedexNumbers: [584],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/29.png",
      large: "https://images.pokemontcg.io/rsv10pt5/29_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/29.png",
          large: "https://images.pokemontcg.io/rsv10pt5/29_hires.png",
        },
        flavorText:
          "Swallowing large amounts of water, they make snow clouds inside their bodies and attack their foes with violent blizzards.",
      },
      {
        id: "rsv10pt5-113",
        number: "113",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/113.png",
          large: "https://images.pokemontcg.io/rsv10pt5/113_hires.png",
        },
        flavorText:
          "Swallowing large amounts of water, they make snow clouds inside their bodies and attack their foes with violent blizzards.",
      },
    ],
  },
  {
    id: "sv8pt5-23",
    name: "Vaporeon ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "280",
    types: ["Water"],
    evolvesFrom: "Eevee",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Severe Squall",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "",
        text: "This attack does 60 damage to each of your opponent's Pokémon ex. This attack's damage isn't affected by Weakness or Resistance.",
      },
      {
        name: "Aquamarine",
        cost: ["Fire", "Water", "Lightning"],
        convertedEnergyCost: 3,
        damage: "280",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "23",
    nationalPokedexNumbers: [134],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8pt5/23.png",
      large: "https://images.pokemontcg.io/sv8pt5/23_hires.png",
    },
    altArts: [
      {
        id: "sv8pt5-23",
        number: "23",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/23.png",
          large: "https://images.pokemontcg.io/sv8pt5/23_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/149.png",
          large: "https://images.pokemontcg.io/sv8pt5/149_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-124",
    name: "Varoom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Metal Coating",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Attach a Basic Metal Energy card from your discard pile to this Pokémon.",
      },
      {
        name: "Ram",
        cost: ["Metal", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "124",
    flavorText:
      "The steel section is Varoom's actual body. This Pokémon clings to rocks and converts the minerals within into energy to fuel its activities.",
    nationalPokedexNumbers: [965],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/124.png",
      large: "https://images.pokemontcg.io/sv6/124_hires.png",
    },
    altArts: [
      {
        id: "sv6-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/sv6/124.png",
          large: "https://images.pokemontcg.io/sv6/124_hires.png",
        },
        flavorText:
          "The steel section is Varoom's actual body. This Pokémon clings to rocks and converts the minerals within into energy to fuel its activities.",
      },
    ],
  },
  {
    id: "sv6pt5-43",
    name: "Varoom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Metal"],
    attacks: [
      {
        name: "Rigidify",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your opponent's next turn, this Pokémon takes 30 less damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Headbutt Bounce",
        cost: ["Metal", "Metal"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "43",
    nationalPokedexNumbers: [965],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/43.png",
      large: "https://images.pokemontcg.io/sv6pt5/43_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/43.png",
          large: "https://images.pokemontcg.io/sv6pt5/43_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-108",
    name: "Varoom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Metal"],
    attacks: [
      {
        name: "Ram",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "108",
    nationalPokedexNumbers: [965],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/108.png",
      large: "https://images.pokemontcg.io/sv7/108_hires.png",
    },
    altArts: [
      {
        id: "sv7-108",
        number: "108",
        images: {
          small: "https://images.pokemontcg.io/sv7/108.png",
          large: "https://images.pokemontcg.io/sv7/108_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv7-45",
    name: "Veluza",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    abilities: [
      {
        name: "Food Prep",
        text: "Attacks used by this Pokémon cost Colorless less for each Kofu card in your discard pile.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Sonic Edge",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "110",
        text: "This attack's damage isn't affected by any effects on your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "45",
    nationalPokedexNumbers: [976],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/45.png",
      large: "https://images.pokemontcg.io/sv7/45_hires.png",
    },
    altArts: [
      {
        id: "sv7-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv7/45.png",
          large: "https://images.pokemontcg.io/sv7/45_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-43",
    name: "Veluza ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Razor Fin",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Purging Strike",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: "You may discard your hand. If you discarded any cards in this way, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "43",
    nationalPokedexNumbers: [976],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/43.png",
      large: "https://images.pokemontcg.io/sv9/43_hires.png",
    },
    altArts: [
      {
        id: "sv9-43",
        number: "43",
        images: {
          small: "https://images.pokemontcg.io/sv9/43.png",
          large: "https://images.pokemontcg.io/sv9/43_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-54",
    name: "Venipede",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    evolvesTo: ["Whirlipede"],
    attacks: [
      {
        name: "Poison Spray",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "54",
    flavorText:
      "Its bite injects a potent poison, enough to paralyze large bird Pokémon that try to prey on it.",
    nationalPokedexNumbers: [543],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/54.png",
      large: "https://images.pokemontcg.io/zsv10pt5/54_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-54",
        number: "54",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/54.png",
          large: "https://images.pokemontcg.io/zsv10pt5/54_hires.png",
        },
        flavorText:
          "Its bite injects a potent poison, enough to paralyze large bird Pokémon that try to prey on it.",
      },
      {
        id: "zsv10pt5-132",
        number: "132",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/132.png",
          large: "https://images.pokemontcg.io/zsv10pt5/132_hires.png",
        },
        flavorText:
          "Its bite injects a potent poison, enough to paralyze large bird Pokémon that try to prey on it.",
      },
    ],
  },
  {
    id: "sv6-115",
    name: "Venipede",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Darkness"],
    evolvesTo: ["Whirlipede"],
    attacks: [
      {
        name: "Spit Poison",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
      {
        name: "Spinning Attack",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "115",
    flavorText:
      "Venipede and Sizzlipede are similar species, but when the two meet, a huge fight ensues.",
    nationalPokedexNumbers: [543],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/115.png",
      large: "https://images.pokemontcg.io/sv6/115_hires.png",
    },
    altArts: [
      {
        id: "sv6-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/sv6/115.png",
          large: "https://images.pokemontcg.io/sv6/115_hires.png",
        },
        flavorText:
          "Venipede and Sizzlipede are similar species, but when the two meet, a huge fight ensues.",
      },
    ],
  },
  {
    id: "me2-52",
    name: "Vibrava",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fighting"],
    evolvesFrom: "Trapinch",
    evolvesTo: ["Flygon"],
    attacks: [
      {
        name: "Super Vibration",
        cost: ["Fighting", "Fighting"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "52",
    flavorText:
      "Rather than using its underdeveloped wings for flight, it rubs them together, emitting ultrasonic waves to attack its enemies.",
    nationalPokedexNumbers: [329],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/52.png",
      large: "https://images.pokemontcg.io/me2/52_hires.png",
    },
    altArts: [
      {
        id: "me2-52",
        number: "52",
        images: {
          small: "https://images.pokemontcg.io/me2/52.png",
          large: "https://images.pokemontcg.io/me2/52_hires.png",
        },
        flavorText:
          "Rather than using its underdeveloped wings for flight, it rubs them together, emitting ultrasonic waves to attack its enemies.",
      },
    ],
  },
  {
    id: "sv8-105",
    name: "Vibrava",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Fighting"],
    evolvesFrom: "Trapinch",
    evolvesTo: ["Flygon"],
    attacks: [
      {
        name: "Screech",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your next turn, the Defending Pokémon takes 50 more damage from attacks (after applying Weakness and Resistance).",
      },
      {
        name: "Cutting Wind",
        cost: ["Fighting", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "105",
    nationalPokedexNumbers: [329],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/105.png",
      large: "https://images.pokemontcg.io/sv8/105_hires.png",
    },
    altArts: [
      {
        id: "sv8-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/sv8/105.png",
          large: "https://images.pokemontcg.io/sv8/105_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-206",
        number: "206",
        images: {
          small: "https://images.pokemontcg.io/sv8/206.png",
          large: "https://images.pokemontcg.io/sv8/206_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-172",
    name: "Victini",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "V-Force",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "If you have 4 or fewer Benched Pokémon, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "172",
    flavorText:
      "This Pokémon brings victory. It is said that Trainers with Victini always win, regardless of the type of encounter.",
    nationalPokedexNumbers: [494],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/172.png",
      large: "https://images.pokemontcg.io/rsv10pt5/172_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/172.png",
          large: "https://images.pokemontcg.io/rsv10pt5/172_hires.png",
        },
        flavorText:
          "This Pokémon brings victory. It is said that Trainers with Victini always win, regardless of the type of encounter.",
      },
      {
        id: "zsv10pt5-12",
        number: "12",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/12.png",
          large: "https://images.pokemontcg.io/zsv10pt5/12_hires.png",
        },
        flavorText:
          "This Pokémon brings victory. It is said that Trainers with Victini always win, regardless of the type of encounter.",
      },
      {
        id: "zsv10pt5-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/171.png",
          large: "https://images.pokemontcg.io/zsv10pt5/171_hires.png",
        },
        flavorText:
          "This Pokémon brings victory. It is said that Trainers with Victini always win, regardless of the type of encounter.",
      },
    ],
  },
  {
    id: "me55-13",
    name: "Victini",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Call for Family",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "V-Flame",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "13",
    nationalPokedexNumbers: [494],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-13/small",
      large: "https://images.scrydex.com/pokemon/me55-13/large",
    },
    altArts: [
      {
        id: "me55-13",
        number: "13",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-13/small",
          large: "https://images.scrydex.com/pokemon/me55-13/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-30",
    name: "Victini",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Fire"],
    attacks: [
      {
        name: "Flippity Flap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Shuffle your hand into your deck. Then, draw 6 cards.",
      },
      {
        name: "Singe Off",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Discard a Special Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "30",
    flavorText:
      "This Pokémon brings victory. It is said that Trainers with Victini always win, regardless of the type of encounter.",
    nationalPokedexNumbers: [494],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/30.png",
      large: "https://images.pokemontcg.io/sv5/30_hires.png",
    },
    altArts: [
      {
        id: "sv5-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/sv5/30.png",
          large: "https://images.pokemontcg.io/sv5/30_hires.png",
        },
        flavorText:
          "This Pokémon brings victory. It is said that Trainers with Victini always win, regardless of the type of encounter.",
      },
    ],
  },
  {
    id: "sv8-21",
    name: "Victini",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    abilities: [
      {
        name: "Victory Cheer",
        text: "Attacks used by your Evolution Fire Pokémon do 10 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Flare",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "21",
    nationalPokedexNumbers: [494],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/21.png",
      large: "https://images.pokemontcg.io/sv8/21_hires.png",
    },
    altArts: [
      {
        id: "sv8-21",
        number: "21",
        images: {
          small: "https://images.pokemontcg.io/sv8/21.png",
          large: "https://images.pokemontcg.io/sv8/21_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-146",
    name: "Vigoroth",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Slakoth",
    evolvesTo: ["Slaking"],
    attacks: [
      {
        name: "Slashing Claw",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "146",
    nationalPokedexNumbers: [288],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/146.png",
      large: "https://images.pokemontcg.io/sv8/146_hires.png",
    },
    altArts: [
      {
        id: "sv8-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/sv8/146.png",
          large: "https://images.pokemontcg.io/sv8/146_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-66",
    name: "Vikavolt",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Lightning"],
    evolvesFrom: "Charjabug",
    attacks: [
      {
        name: "Volt Switch",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "90",
        text: "Switch this Pokémon with 1 of your Benched Lightning Pokémon.",
      },
      {
        name: "Sparking Strike",
        cost: ["Lightning", "Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "240",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "66",
    flavorText:
      "When carrying a Charjabug, Vikavolt can receive electricity from it and then rapidly fire powerful electromagnetic beams from its large jaws.",
    nationalPokedexNumbers: [738],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-66/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-66/large",
    },
    altArts: [
      {
        id: "me2pt5-66",
        number: "66",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-66/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-66/large",
        },
        flavorText:
          "When carrying a Charjabug, Vikavolt can receive electricity from it and then rapidly fire powerful electromagnetic beams from its large jaws.",
      },
      {
        id: "me2pt5-230",
        number: "230",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-230/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-230/large",
        },
        flavorText:
          "When carrying a Charjabug, Vikavolt can receive electricity from it and then rapidly fire powerful electromagnetic beams from its large jaws.",
      },
      {
        id: "sv7-53",
        number: "53",
        images: {
          small: "https://images.pokemontcg.io/sv7/53.png",
          large: "https://images.pokemontcg.io/sv7/53_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-26",
    name: "Vikavolt",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Lightning"],
    evolvesFrom: "Charjabug",
    attacks: [
      {
        name: "Quick Dive",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "This attack does 50 damage to 1 of your opponent's Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Giga Railgun",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "260",
        text: "If this Pokémon has no Voltaic Lightning Energy attached, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "26",
    flavorText:
      "When carrying a Charjabug, Vikavolt can receive electricity from it and then rapidly fire powerful electromagnetic beams from its large jaws.",
    nationalPokedexNumbers: [738],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-26/small",
      large: "https://images.scrydex.com/pokemon/me5-26/large",
    },
    altArts: [
      {
        id: "me5-26",
        number: "26",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-26/small",
          large: "https://images.scrydex.com/pokemon/me5-26/large",
        },
        flavorText:
          "When carrying a Charjabug, Vikavolt can receive electricity from it and then rapidly fire powerful electromagnetic beams from its large jaws.",
      },
    ],
  },
  {
    id: "sv5-56",
    name: "Vikavolt",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "160",
    types: ["Lightning"],
    evolvesFrom: "Charjabug",
    attacks: [
      {
        name: "Mach Bolt",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
      {
        name: "Circuit Cannon",
        cost: ["Lightning", "Lightning"],
        convertedEnergyCost: 2,
        damage: "120+",
        text: "This attack does 80 more damage for each of your Benched Charjabug.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "56",
    flavorText:
      "It builds up electricity in its abdomen, focuses it through its jaws, and then fires the electricity off in concentrated beams.",
    nationalPokedexNumbers: [738],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/56.png",
      large: "https://images.pokemontcg.io/sv5/56_hires.png",
    },
    altArts: [
      {
        id: "sv5-56",
        number: "56",
        images: {
          small: "https://images.pokemontcg.io/sv5/56.png",
          large: "https://images.pokemontcg.io/sv5/56_hires.png",
        },
        flavorText:
          "It builds up electricity in its abdomen, focuses it through its jaws, and then fires the electricity off in concentrated beams.",
      },
    ],
  },
  {
    id: "me2-3",
    name: "Vileplume",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "150",
    types: ["Grass"],
    evolvesFrom: "Gloom",
    attacks: [
      {
        name: "Pollen Bomb",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Your opponent's Active Pokémon is now Asleep and Poisoned.",
      },
      {
        name: "Lively Flower",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "If this Pokémon was healed during this turn, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "3",
    flavorText:
      "The bud bursts into bloom with a bang. It then starts scattering allergenic, poisonous pollen.",
    nationalPokedexNumbers: [45],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/3.png",
      large: "https://images.pokemontcg.io/me2/3_hires.png",
    },
    altArts: [
      {
        id: "me2-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/me2/3.png",
          large: "https://images.pokemontcg.io/me2/3_hires.png",
        },
        flavorText:
          "The bud bursts into bloom with a bang. It then starts scattering allergenic, poisonous pollen.",
      },
    ],
  },
  {
    id: "rsv10pt5-10",
    name: "Virizion",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Giga Drain",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Heal from this Pokémon the same amount of damage you did to your opponent's Active Pokémon.",
      },
      {
        name: "Emerald Blade",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "During your next turn, this Pokémon can't use attacks.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "10",
    flavorText:
      "This Pokémon fought humans in order to protect its friends. Legends about it continue to be passed down.",
    nationalPokedexNumbers: [640],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/10.png",
      large: "https://images.pokemontcg.io/rsv10pt5/10_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-10",
        number: "10",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/10.png",
          large: "https://images.pokemontcg.io/rsv10pt5/10_hires.png",
        },
        flavorText:
          "This Pokémon fought humans in order to protect its friends. Legends about it continue to be passed down.",
      },
      {
        id: "rsv10pt5-95",
        number: "95",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/95.png",
          large: "https://images.pokemontcg.io/rsv10pt5/95_hires.png",
        },
        flavorText:
          "This Pokémon fought humans in order to protect its friends. Legends about it continue to be passed down.",
      },
    ],
  },
  {
    id: "sv9-15",
    name: "Virizion",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Leaf Drain",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
      {
        name: "Slicing Blade",
        cost: ["Grass", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    nationalPokedexNumbers: [640],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/15.png",
      large: "https://images.pokemontcg.io/sv9/15_hires.png",
    },
    altArts: [
      {
        id: "sv9-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv9/15.png",
          large: "https://images.pokemontcg.io/sv9/15_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-9",
    name: "Vivillon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Spewpa",
    abilities: [
      {
        name: "Grand Wing",
        text: "Once during your turn, you may use this Ability. Your opponent shuffles their hand and puts it on the bottom of their deck. If they put any cards on the bottom of their deck in this way, they draw 4 cards.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Blow Through",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "60+",
        text: "If a Stadium is in play, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    nationalPokedexNumbers: [666],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-9/small",
      large: "https://images.scrydex.com/pokemon/me3-9/large",
    },
    altArts: [
      {
        id: "me3-9",
        number: "9",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-9/small",
          large: "https://images.scrydex.com/pokemon/me3-9/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-8",
    name: "Vivillon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Spewpa",
    abilities: [
      {
        name: "Guiding Dance",
        text: "Once during your turn, you may use this Ability. Flip a coin. If heads, search your deck for a Pokémon, reveal it, and put it into your hand. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Poison Powder",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60",
        text: "Your opponent's Active Pokémon is now Poisoned.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    nationalPokedexNumbers: [666],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-8/small",
      large: "https://images.scrydex.com/pokemon/me55-8/large",
    },
    altArts: [
      {
        id: "me55-8",
        number: "8",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-8/small",
          large: "https://images.scrydex.com/pokemon/me55-8/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-7",
    name: "Vivillon",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "120",
    types: ["Grass"],
    evolvesFrom: "Spewpa",
    attacks: [
      {
        name: "Evo-Powder",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "For each of your Benched Pokémon, search your deck for a card that evolves from that Pokémon and put it onto that Pokémon to evolve it. Then, shuffle your deck.",
      },
      {
        name: "Cutting Wind",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "90",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "7",
    nationalPokedexNumbers: [666],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/7.png",
      large: "https://images.pokemontcg.io/sv8/7_hires.png",
    },
    altArts: [
      {
        id: "sv8-7",
        number: "7",
        images: {
          small: "https://images.pokemontcg.io/sv8/7.png",
          large: "https://images.pokemontcg.io/sv8/7_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8-193",
        number: "193",
        images: {
          small: "https://images.pokemontcg.io/sv8/193.png",
          large: "https://images.pokemontcg.io/sv8/193_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-3",
    name: "Volbeat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Grass"],
    attacks: [
      {
        name: "Luring Glow",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        text: "Switch in 1 of your opponent's Benched Pokémon to the Active Spot.",
      },
      {
        name: "Bug Buzz",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    nationalPokedexNumbers: [313],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-3/small",
      large: "https://images.scrydex.com/pokemon/me55-3/large",
    },
    altArts: [
      {
        id: "me55-3",
        number: "3",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-3/small",
          large: "https://images.scrydex.com/pokemon/me55-3/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-9",
    name: "Volbeat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    attacks: [
      {
        name: "Quick Sign",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "If you go first, you can use this attack during your first turn. Search your deck for up to 2 Basic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Coordinated Strike",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "If Illumise is on your Bench, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    flavorText:
      "It flashes the light on its rear to communicate with other Volbeat. It loves the sweet aroma given off by Illumise.",
    nationalPokedexNumbers: [313],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/9.png",
      large: "https://images.pokemontcg.io/sv6/9_hires.png",
    },
    altArts: [
      {
        id: "sv6-9",
        number: "9",
        images: {
          small: "https://images.pokemontcg.io/sv6/9.png",
          large: "https://images.pokemontcg.io/sv6/9_hires.png",
        },
        flavorText:
          "It flashes the light on its rear to communicate with other Volbeat. It loves the sweet aroma given off by Illumise.",
      },
    ],
  },
  {
    id: "me1-25",
    name: "Volcanion",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Fire"],
    attacks: [
      {
        name: "Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
      {
        name: "Backfire",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Put 2 Fire Energy attached to this Pokémon into your hand.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "25",
    nationalPokedexNumbers: [721],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/25.png",
      large: "https://images.pokemontcg.io/me1/25_hires.png",
    },
    altArts: [
      {
        id: "me1-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/me1/25.png",
          large: "https://images.pokemontcg.io/me1/25_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-25",
    name: "Volcanion",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Strength",
        cost: ["Water", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Powerful Steam",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90×",
        text: "Flip a coin for each Water Energy attached to this Pokémon. This attack does 90 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "25",
    nationalPokedexNumbers: [721],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-25/small",
      large: "https://images.scrydex.com/pokemon/me3-25/large",
    },
    altArts: [
      {
        id: "me3-25",
        number: "25",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-25/small",
          large: "https://images.scrydex.com/pokemon/me3-25/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-31",
    name: "Volcanion ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "220",
    types: ["Fire"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Scalding Steam",
        text: "Once during your turn, if this Pokémon is in the Active Spot, you may make your opponent's Active Pokémon Burned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Scorching Cyclone",
        cost: ["Fire", "Fire", "Colorless"],
        convertedEnergyCost: 3,
        damage: "160",
        text: "Move an Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "31",
    nationalPokedexNumbers: [721],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/31.png",
      large: "https://images.pokemontcg.io/sv9/31_hires.png",
    },
    altArts: [
      {
        id: "sv9-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/sv9/31.png",
          large: "https://images.pokemontcg.io/sv9/31_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-171",
        number: "171",
        images: {
          small: "https://images.pokemontcg.io/sv9/171.png",
          large: "https://images.pokemontcg.io/sv9/171_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-182",
        number: "182",
        images: {
          small: "https://images.pokemontcg.io/sv9/182.png",
          large: "https://images.pokemontcg.io/sv9/182_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-16",
    name: "Volcarona",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Fire"],
    evolvesFrom: "Larvesta",
    abilities: [
      {
        name: "Torrid Scales",
        text: "You must discard a Basic Fire Energy card from your hand in order to use this Ability. Once during your turn, you may make your opponent's Active Pokémon Burned.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Fire Wing",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    flavorText:
      "When volcanic ash darkened the atmosphere, it is said that Volcarona's fire provided a replacement for the sun.",
    nationalPokedexNumbers: [637],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/16.png",
      large: "https://images.pokemontcg.io/zsv10pt5/16_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/16.png",
          large: "https://images.pokemontcg.io/zsv10pt5/16_hires.png",
        },
        flavorText:
          "When volcanic ash darkened the atmosphere, it is said that Volcarona's fire provided a replacement for the sun.",
      },
      {
        id: "zsv10pt5-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/100.png",
          large: "https://images.pokemontcg.io/zsv10pt5/100_hires.png",
        },
        flavorText:
          "When volcanic ash darkened the atmosphere, it is said that Volcarona's fire provided a replacement for the sun.",
      },
    ],
  },
  {
    id: "sv8-25",
    name: "Volcarona",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Larvesta",
    attacks: [
      {
        name: "Leech Life",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Heal from this Pokémon the same amount of damage you did to your opponent's Active Pokémon.",
      },
      {
        name: "Turbulent Wings",
        cost: ["Fire", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "150",
        text: "This Pokémon also does 50 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "25",
    nationalPokedexNumbers: [637],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/25.png",
      large: "https://images.pokemontcg.io/sv8/25_hires.png",
    },
    altArts: [
      {
        id: "sv8-25",
        number: "25",
        images: {
          small: "https://images.pokemontcg.io/sv8/25.png",
          large: "https://images.pokemontcg.io/sv8/25_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-29",
    name: "Volcarona",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "140",
    types: ["Fire"],
    evolvesFrom: "Larvesta",
    attacks: [
      {
        name: "Smoldering Scales",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "29",
    nationalPokedexNumbers: [637],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/29.png",
      large: "https://images.pokemontcg.io/sv9/29_hires.png",
    },
    altArts: [
      {
        id: "sv9-29",
        number: "29",
        images: {
          small: "https://images.pokemontcg.io/sv9/29.png",
          large: "https://images.pokemontcg.io/sv9/29_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-58",
    name: "Voltorb ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "170",
    types: ["Lightning"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Hundred-Hitting Ball",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "Flip a coin until you get tails. This attack does 100 more damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    nationalPokedexNumbers: [100],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-58/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-58/large",
    },
    altArts: [
      {
        id: "me2pt5-58",
        number: "58",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-58/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-58/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-63",
    name: "Vullaby",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Mandibuzz"],
    attacks: [
      {
        name: "Playful Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    flavorText:
      "Its wings are too tiny to allow it to fly. As the time approaches for it to evolve, it discards the bones it was wearing.",
    nationalPokedexNumbers: [629],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/63.png",
      large: "https://images.pokemontcg.io/rsv10pt5/63_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/63.png",
          large: "https://images.pokemontcg.io/rsv10pt5/63_hires.png",
        },
        flavorText:
          "Its wings are too tiny to allow it to fly. As the time approaches for it to evolve, it discards the bones it was wearing.",
      },
      {
        id: "rsv10pt5-144",
        number: "144",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/144.png",
          large: "https://images.pokemontcg.io/rsv10pt5/144_hires.png",
        },
        flavorText:
          "Its wings are too tiny to allow it to fly. As the time approaches for it to evolve, it discards the bones it was wearing.",
      },
    ],
  },
  {
    id: "me2pt5-138",
    name: "Vullaby",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Flap",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "138",
    flavorText:
      "Its healthy appetite leads to visible growth spurts. It often has to replace the bones it wears as its size increases.",
    nationalPokedexNumbers: [629],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-138/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-138/large",
    },
    altArts: [
      {
        id: "me2pt5-138",
        number: "138",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-138/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-138/large",
        },
        flavorText:
          "Its healthy appetite leads to visible growth spurts. It often has to replace the bones it wears as its size increases.",
      },
    ],
  },
  {
    id: "me5-49",
    name: "Vullaby",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Flap",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Gust",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "49",
    flavorText:
      "Its healthy appetite leads to visible growth spurts. It often has to replace the bones it wears as its size increases.",
    nationalPokedexNumbers: [629],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-49/small",
      large: "https://images.scrydex.com/pokemon/me5-49/large",
    },
    altArts: [
      {
        id: "me5-49",
        number: "49",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-49/small",
          large: "https://images.scrydex.com/pokemon/me5-49/large",
        },
        flavorText:
          "Its healthy appetite leads to visible growth spurts. It often has to replace the bones it wears as its size increases.",
      },
    ],
  },
  {
    id: "me1-19",
    name: "Vulpix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Ninetales"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Combustion",
        cost: ["Fire", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "19",
    nationalPokedexNumbers: [37],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/19.png",
      large: "https://images.pokemontcg.io/me1/19_hires.png",
    },
    altArts: [
      {
        id: "me1-19",
        number: "19",
        images: {
          small: "https://images.pokemontcg.io/me1/19.png",
          large: "https://images.pokemontcg.io/me1/19_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me1-138",
        number: "138",
        images: {
          small: "https://images.pokemontcg.io/me1/138.png",
          large: "https://images.pokemontcg.io/me1/138_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-8",
    name: "Vulpix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Singe",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Burned.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "8",
    flavorText:
      "As its body grows larger, its six warm tails become more beautiful, with a more luxurious coat of fur.",
    nationalPokedexNumbers: [37],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-8/small",
      large: "https://images.scrydex.com/pokemon/me4-8/large",
    },
    altArts: [
      {
        id: "me4-8",
        number: "8",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-8/small",
          large: "https://images.scrydex.com/pokemon/me4-8/large",
        },
        flavorText:
          "As its body grows larger, its six warm tails become more beautiful, with a more luxurious coat of fur.",
      },
    ],
  },
  {
    id: "me55-9",
    name: "Vulpix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    attacks: [
      {
        name: "Wild Kick",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "9",
    nationalPokedexNumbers: [37],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-9/small",
      large: "https://images.scrydex.com/pokemon/me55-9/large",
    },
    altArts: [
      {
        id: "me55-9",
        number: "9",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-9/small",
          large: "https://images.scrydex.com/pokemon/me55-9/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-26",
    name: "Vulpix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Ninetales"],
    attacks: [
      {
        name: "Live Coal",
        cost: ["Fire", "Fire"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "26",
    flavorText:
      "As its body grows larger, its six warm tails become more beautiful, with a more luxurious coat of fur.",
    nationalPokedexNumbers: [37],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/26.png",
      large: "https://images.pokemontcg.io/sv6/26_hires.png",
    },
    altArts: [
      {
        id: "sv6-26",
        number: "26",
        images: {
          small: "https://images.pokemontcg.io/sv6/26.png",
          large: "https://images.pokemontcg.io/sv6/26_hires.png",
        },
        flavorText:
          "As its body grows larger, its six warm tails become more beautiful, with a more luxurious coat of fur.",
      },
    ],
  },
  {
    id: "sv8-16",
    name: "Vulpix",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Fire"],
    evolvesTo: ["Ninetales"],
    attacks: [
      {
        name: "Take Down",
        cost: ["Fire"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Water",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "16",
    nationalPokedexNumbers: [37],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/16.png",
      large: "https://images.pokemontcg.io/sv8/16_hires.png",
    },
    altArts: [
      {
        id: "sv8-16",
        number: "16",
        images: {
          small: "https://images.pokemontcg.io/sv8/16.png",
          large: "https://images.pokemontcg.io/sv8/16_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-15",
    name: "Wailmer",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Water Gun",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "",
      },
      {
        name: "Wave Splash",
        cost: ["Water", "Water", "Water"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "15",
    flavorText:
      "It shows off by spraying jets of seawater from the nostrils above its eyes. It eats a solid ton of Wishiwashi every day.",
    nationalPokedexNumbers: [320],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-15/small",
      large: "https://images.scrydex.com/pokemon/me5-15/large",
    },
    altArts: [
      {
        id: "me5-15",
        number: "15",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-15/small",
          large: "https://images.scrydex.com/pokemon/me5-15/large",
        },
        flavorText:
          "It shows off by spraying jets of seawater from the nostrils above its eyes. It eats a solid ton of Wishiwashi every day.",
      },
    ],
  },
  {
    id: "sv9-40",
    name: "Wailmer",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Water"],
    evolvesTo: ["Wailord"],
    attacks: [
      {
        name: "Surf",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "40",
    nationalPokedexNumbers: [320],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/40.png",
      large: "https://images.pokemontcg.io/sv9/40_hires.png",
    },
    altArts: [
      {
        id: "sv9-40",
        number: "40",
        images: {
          small: "https://images.pokemontcg.io/sv9/40.png",
          large: "https://images.pokemontcg.io/sv9/40_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-41",
    name: "Wailord",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "240",
    types: ["Water"],
    evolvesFrom: "Wailmer",
    attacks: [
      {
        name: "Hydro Pump",
        cost: ["Colorless", "Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "10+",
        text: "This attack does 50 more damage for each Water Energy attached to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "41",
    nationalPokedexNumbers: [321],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/41.png",
      large: "https://images.pokemontcg.io/sv9/41_hires.png",
    },
    altArts: [
      {
        id: "sv9-41",
        number: "41",
        images: {
          small: "https://images.pokemontcg.io/sv9/41.png",
          large: "https://images.pokemontcg.io/sv9/41_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/sv9/162.png",
          large: "https://images.pokemontcg.io/sv9/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-16",
    name: "Wailord ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "380",
    types: ["Water"],
    evolvesFrom: "Wailmer",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Surf",
        cost: ["Water", "Water", "Water"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
      {
        name: "Falling Down",
        cost: ["Water", "Water", "Water", "Water", "Water"],
        convertedEnergyCost: 5,
        damage: "270",
        text: "This Pokémon is now Asleep.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 4,
    number: "16",
    nationalPokedexNumbers: [321],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-16/small",
      large: "https://images.scrydex.com/pokemon/me5-16/large",
    },
    altArts: [
      {
        id: "me5-16",
        number: "16",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-16/small",
          large: "https://images.scrydex.com/pokemon/me5-16/large",
        },
        flavorText: "",
      },
      {
        id: "me5-97",
        number: "97",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-97/small",
          large: "https://images.scrydex.com/pokemon/me5-97/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-63",
    name: "Walking Wake",
    supertype: "Pokémon",
    subtypes: ["Basic", "Ancient"],
    hp: "130",
    types: ["Water"],
    attacks: [
      {
        name: "Aurora Gain",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Heal 20 damage from this Pokémon.",
      },
      {
        name: "Undulating Slice",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "20×",
        text: "Put up to 9 damage counters on this Pokémon. This attack does 20 damage for each damage counter you placed in this way.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    flavorText:
      "This ferocious creature is shrouded in mystery. It's named after an aquatic monster mentioned in an old expedition journal.",
    nationalPokedexNumbers: [1009],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/63.png",
      large: "https://images.pokemontcg.io/sv6/63_hires.png",
    },
    altArts: [
      {
        id: "sv6-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv6/63.png",
          large: "https://images.pokemontcg.io/sv6/63_hires.png",
        },
        flavorText:
          "This ferocious creature is shrouded in mystery. It's named after an aquatic monster mentioned in an old expedition journal.",
      },
    ],
  },
  {
    id: "sv5-50",
    name: "Walking Wake ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex", "Ancient"],
    hp: "220",
    types: ["Water"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Azure Seas",
        text: "Damage from attacks used by this Pokémon isn't affected by any effects on your opponent's Active Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Catharsis Roar",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120+",
        text: "If your opponent's Active Pokémon is affected by a Special Condition, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "50",
    nationalPokedexNumbers: [1009],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/50.png",
      large: "https://images.pokemontcg.io/sv5/50_hires.png",
    },
    altArts: [
      {
        id: "sv5-50",
        number: "50",
        images: {
          small: "https://images.pokemontcg.io/sv5/50.png",
          large: "https://images.pokemontcg.io/sv5/50_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-189",
        number: "189",
        images: {
          small: "https://images.pokemontcg.io/sv5/189.png",
          large: "https://images.pokemontcg.io/sv5/189_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-205",
        number: "205",
        images: {
          small: "https://images.pokemontcg.io/sv5/205.png",
          large: "https://images.pokemontcg.io/sv5/205_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-215",
        number: "215",
        images: {
          small: "https://images.pokemontcg.io/sv5/215.png",
          large: "https://images.pokemontcg.io/sv5/215_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-178",
        number: "178",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/178.png",
          large: "https://images.pokemontcg.io/sv8pt5/178_hires.png",
        },
        flavorText: "",
      },
      {
        id: "svp-127",
        number: "127",
        images: {
          small: "https://images.pokemontcg.io/svp/127.png",
          large: "https://images.pokemontcg.io/svp/127_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-45",
    name: "Walrein",
    supertype: "Pokémon",
    subtypes: ["Stage 2"],
    hp: "170",
    types: ["Water"],
    evolvesFrom: "Sealeo",
    attacks: [
      {
        name: "Frigid Fangs",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "60",
        text: "During your opponent's next turn, Pokémon that have 2 or less Energy attached can't attack. (This includes new Pokémon that come into play.)",
      },
      {
        name: "Megaton Fall",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "170",
        text: "This Pokémon also does 50 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "45",
    nationalPokedexNumbers: [365],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/45.png",
      large: "https://images.pokemontcg.io/sv8/45_hires.png",
    },
    altArts: [
      {
        id: "sv8-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/sv8/45.png",
          large: "https://images.pokemontcg.io/sv8/45_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-61",
    name: "Wash Rotom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "80",
    types: ["Water"],
    attacks: [
      {
        name: "Manual Wash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Heal 10 damage from each of your Pokémon.",
      },
      {
        name: "Gadget Show",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30×",
        text: "This attack does 30 damage for each Pokémon Tool attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "61",
    nationalPokedexNumbers: [479],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/61.png",
      large: "https://images.pokemontcg.io/sv10/61_hires.png",
    },
    altArts: [
      {
        id: "sv10-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/sv10/61.png",
          large: "https://images.pokemontcg.io/sv10/61_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-73",
    name: "Watchog",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "90",
    types: ["Colorless"],
    evolvesFrom: "Patrat",
    attacks: [
      {
        name: "Focus Energy",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "During your next turn, this Pokémon's Hyper Fang attack's base damage is 240.",
      },
      {
        name: "Hyper Fang",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "80",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "73",
    flavorText:
      "When they see an enemy, their tails stand high, and they spit the seeds of berries stored in their cheek pouches.",
    nationalPokedexNumbers: [505],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/73.png",
      large: "https://images.pokemontcg.io/rsv10pt5/73_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-73",
        number: "73",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/73.png",
          large: "https://images.pokemontcg.io/rsv10pt5/73_hires.png",
        },
        flavorText:
          "When they see an enemy, their tails stand high, and they spit the seeds of berries stored in their cheek pouches.",
      },
      {
        id: "rsv10pt5-153",
        number: "153",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/153.png",
          large: "https://images.pokemontcg.io/rsv10pt5/153_hires.png",
        },
        flavorText:
          "When they see an enemy, their tails stand high, and they spit the seeds of berries stored in their cheek pouches.",
      },
    ],
  },
  {
    id: "me4-71",
    name: "Watchog",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Colorless"],
    evolvesFrom: "Patrat",
    attacks: [
      {
        name: "Snap Inspection",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip 3 coins. If any of them are heads, your opponent reveals their hand. For each heads, choose a card you find there and shuffle it into your opponent's deck.",
      },
      {
        name: "Low Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "50",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "71",
    flavorText:
      "Using luminescent matter within its body, it makes its eyes and body glow and stuns attacking opponents.",
    nationalPokedexNumbers: [505],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-71/small",
      large: "https://images.scrydex.com/pokemon/me4-71/large",
    },
    altArts: [
      {
        id: "me4-71",
        number: "71",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-71/small",
          large: "https://images.scrydex.com/pokemon/me4-71/large",
        },
        flavorText:
          "Using luminescent matter within its body, it makes its eyes and body glow and stuns attacking opponents.",
      },
      {
        id: "me4-97",
        number: "97",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-97/small",
          large: "https://images.scrydex.com/pokemon/me4-97/large",
        },
        flavorText:
          "Using luminescent matter within its body, it makes its eyes and body glow and stuns attacking opponents.",
      },
    ],
  },
  {
    id: "sv6-75",
    name: "Wattrel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Thunder Shock",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "75",
    flavorText:
      "These Pokémon make their nests on coastal cliffs. The nests have a strange, crackling texture, and they're a popular delicacy.",
    nationalPokedexNumbers: [940],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/75.png",
      large: "https://images.pokemontcg.io/sv6/75_hires.png",
    },
    altArts: [
      {
        id: "sv6-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv6/75.png",
          large: "https://images.pokemontcg.io/sv6/75_hires.png",
        },
        flavorText:
          "These Pokémon make their nests on coastal cliffs. The nests have a strange, crackling texture, and they're a popular delicacy.",
      },
      {
        id: "sv6-178",
        number: "178",
        images: {
          small: "https://images.pokemontcg.io/sv6/178.png",
          large: "https://images.pokemontcg.io/sv6/178_hires.png",
        },
        flavorText:
          "These Pokémon make their nests on coastal cliffs. The nests have a strange, crackling texture, and they're a popular delicacy.",
      },
    ],
  },
  {
    id: "sv8-66",
    name: "Wattrel",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Lightning"],
    attacks: [
      {
        name: "Aerial Ace",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "66",
    nationalPokedexNumbers: [940],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/66.png",
      large: "https://images.pokemontcg.io/sv8/66_hires.png",
    },
    altArts: [
      {
        id: "sv8-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/sv8/66.png",
          large: "https://images.pokemontcg.io/sv8/66_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-45",
    name: "Weavile",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Water"],
    evolvesFrom: "Sneasel",
    attacks: [
      {
        name: "Slash",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
      {
        name: "Hail Claw",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "70",
        text: "Discard all Energy from this Pokémon. Your opponent's Active Pokémon is now Paralyzed.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "45",
    flavorText:
      "They travel in groups of four or five, leaving signs for one another on trees and rocks. They bring down their prey with coordinated attacks.",
    nationalPokedexNumbers: [461],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-45/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-45/large",
    },
    altArts: [
      {
        id: "me2pt5-45",
        number: "45",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-45/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-45/large",
        },
        flavorText:
          "They travel in groups of four or five, leaving signs for one another on trees and rocks. They bring down their prey with coordinated attacks.",
      },
      {
        id: "me2pt5-228",
        number: "228",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-228/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-228/large",
        },
        flavorText:
          "They travel in groups of four or five, leaving signs for one another on trees and rocks. They bring down their prey with coordinated attacks.",
      },
      {
        id: "sv6pt5-14",
        number: "14",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/14.png",
          large: "https://images.pokemontcg.io/sv6pt5/14_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-1",
    name: "Weedle",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Grass"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "1",
    flavorText:
      "Often found in forests and grasslands. It has a sharp, toxic barb of around two inches on top of its head.",
    nationalPokedexNumbers: [13],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-1/small",
      large: "https://images.scrydex.com/pokemon/me4-1/large",
    },
    altArts: [
      {
        id: "me4-1",
        number: "1",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-1/small",
          large: "https://images.scrydex.com/pokemon/me4-1/large",
        },
        flavorText:
          "Often found in forests and grasslands. It has a sharp, toxic barb of around two inches on top of its head.",
      },
    ],
  },
  {
    id: "sv9-92",
    name: "Weezing",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Darkness"],
    evolvesFrom: "Koffing",
    attacks: [
      {
        name: "Pervasive Gas",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
      {
        name: "Crazy Blast",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If this Pokémon used Pervasive Gas during your last turn, this attack does 120 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "92",
    nationalPokedexNumbers: [110],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/92.png",
      large: "https://images.pokemontcg.io/sv9/92_hires.png",
    },
    altArts: [
      {
        id: "sv9-92",
        number: "92",
        images: {
          small: "https://images.pokemontcg.io/sv9/92.png",
          large: "https://images.pokemontcg.io/sv9/92_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-67",
    name: "Wellspring Mask Ogerpon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Water"],
    attacks: [
      {
        name: "Water Kagura",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Basic Water Energy card and attach it to 1 of your Pokémon. Then, shuffle your deck.",
      },
      {
        name: "Bubble Drain",
        cost: ["Water", "Water", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Heal 30 damage from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "67",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/67.png",
      large: "https://images.pokemontcg.io/sv10/67_hires.png",
    },
    altArts: [
      {
        id: "sv10-67",
        number: "67",
        images: {
          small: "https://images.pokemontcg.io/sv10/67.png",
          large: "https://images.pokemontcg.io/sv10/67_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-64",
    name: "Wellspring Mask Ogerpon ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "Tera", "ex"],
    hp: "210",
    types: ["Water"],
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Sob",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Torrential Pump",
        cost: ["Water", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "You may shuffle 3 Energy attached to this Pokémon into your deck. If you do, this attack also does 120 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    nationalPokedexNumbers: [1017],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/64.png",
      large: "https://images.pokemontcg.io/sv6/64_hires.png",
    },
    altArts: [
      {
        id: "sv6-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/sv6/64.png",
          large: "https://images.pokemontcg.io/sv6/64_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-194",
        number: "194",
        images: {
          small: "https://images.pokemontcg.io/sv6/194.png",
          large: "https://images.pokemontcg.io/sv6/194_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6-213",
        number: "213",
        images: {
          small: "https://images.pokemontcg.io/sv6/213.png",
          large: "https://images.pokemontcg.io/sv6/213_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/27.png",
          large: "https://images.pokemontcg.io/sv8pt5/27_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv8pt5-152",
        number: "152",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/152.png",
          large: "https://images.pokemontcg.io/sv8pt5/152_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-15",
    name: "Whimsicott",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Grass"],
    evolvesFrom: "Cottonee",
    abilities: [
      {
        name: "Wafting Heal",
        text: "When you play this Pokémon from your hand to evolve 1 of your Pokémon during your turn, you may heal all damage from your Active Grass Pokémon. If you healed any damage in this way, discard all Energy from that Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Seed Bomb",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "40",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "15",
    flavorText:
      "It scatters cotton all over the place as a prank. If it gets wet, it'll become too heavy to move and have no choice but to answer for its mischief.",
    nationalPokedexNumbers: [547],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/15.png",
      large: "https://images.pokemontcg.io/sv5/15_hires.png",
    },
    altArts: [
      {
        id: "sv5-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv5/15.png",
          large: "https://images.pokemontcg.io/sv5/15_hires.png",
        },
        flavorText:
          "It scatters cotton all over the place as a prank. If it gets wet, it'll become too heavy to move and have no choice but to answer for its mischief.",
      },
      {
        id: "sv8pt5-8",
        number: "8",
        images: {
          small: "https://images.pokemontcg.io/sv8pt5/8.png",
          large: "https://images.pokemontcg.io/sv8pt5/8_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-5",
    name: "Whimsicott ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "230",
    types: ["Grass"],
    evolvesFrom: "Cottonee",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Energy Gift",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Basic Energy cards and attach them to your Pokémon in any way you like. Then, shuffle your deck.",
      },
      {
        name: "Wondrous Cotton",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "50×",
        text: "Your opponent reveals their hand. This attack does 50 damage for each Trainer card you find there.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    number: "5",
    nationalPokedexNumbers: [547],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/5.png",
      large: "https://images.pokemontcg.io/rsv10pt5/5_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-5",
        number: "5",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/5.png",
          large: "https://images.pokemontcg.io/rsv10pt5/5_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/157.png",
          large: "https://images.pokemontcg.io/rsv10pt5/157_hires.png",
        },
        flavorText: "",
      },
      {
        id: "rsv10pt5-165",
        number: "165",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/165.png",
          large: "https://images.pokemontcg.io/rsv10pt5/165_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-55",
    name: "Whirlipede",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Venipede",
    evolvesTo: ["Scolipede"],
    attacks: [
      {
        name: "Venoshock",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30+",
        text: "If your opponent's Active Pokémon is Poisoned, this attack does 60 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "55",
    flavorText:
      "Protected by a hard shell, it spins its body like a wheel and crashes furiously into its enemies.",
    nationalPokedexNumbers: [544],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/55.png",
      large: "https://images.pokemontcg.io/zsv10pt5/55_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/55.png",
          large: "https://images.pokemontcg.io/zsv10pt5/55_hires.png",
        },
        flavorText:
          "Protected by a hard shell, it spins its body like a wheel and crashes furiously into its enemies.",
      },
      {
        id: "zsv10pt5-133",
        number: "133",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/133.png",
          large: "https://images.pokemontcg.io/zsv10pt5/133_hires.png",
        },
        flavorText:
          "Protected by a hard shell, it spins its body like a wheel and crashes furiously into its enemies.",
      },
    ],
  },
  {
    id: "sv6-116",
    name: "Whirlipede",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Venipede",
    evolvesTo: ["Scolipede"],
    attacks: [
      {
        name: "Poison Ring",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Poisoned. During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Spinning Attack",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "116",
    flavorText:
      "This Pokémon spins itself rapidly and charges into its opponents. Its top speed is just over 60 mph.",
    nationalPokedexNumbers: [544],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/116.png",
      large: "https://images.pokemontcg.io/sv6/116_hires.png",
    },
    altArts: [
      {
        id: "sv6-116",
        number: "116",
        images: {
          small: "https://images.pokemontcg.io/sv6/116.png",
          large: "https://images.pokemontcg.io/sv6/116_hires.png",
        },
        flavorText:
          "This Pokémon spins itself rapidly and charges into its opponents. Its top speed is just over 60 mph.",
      },
    ],
  },
  {
    id: "me2-77",
    name: "Wigglytuff",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Colorless"],
    evolvesFrom: "Jigglypuff",
    attacks: [
      {
        name: "Round",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "This attack does 40 damage for each of your Pokémon in play that has the Round attack.",
      },
      {
        name: "Seismic Toss",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "77",
    flavorText:
      "It has a very fine fur. Take care not to make it angry, or it may inflate steadily and hit with a body slam.",
    nationalPokedexNumbers: [40],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/77.png",
      large: "https://images.pokemontcg.io/me2/77_hires.png",
    },
    altArts: [
      {
        id: "me2-77",
        number: "77",
        images: {
          small: "https://images.pokemontcg.io/me2/77.png",
          large: "https://images.pokemontcg.io/me2/77_hires.png",
        },
        flavorText:
          "It has a very fine fur. Take care not to make it angry, or it may inflate steadily and hit with a body slam.",
      },
      {
        id: "me2-105",
        number: "105",
        images: {
          small: "https://images.pokemontcg.io/me2/105.png",
          large: "https://images.pokemontcg.io/me2/105_hires.png",
        },
        flavorText:
          "It has a very fine fur. Take care not to make it angry, or it may inflate steadily and hit with a body slam.",
      },
    ],
  },
  {
    id: "sv5-47",
    name: "Wiglett",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    attacks: [
      {
        name: "Lucky Find",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for an Item card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Aqua Bomb",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "40",
        text: "This Pokémon also does 20 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "47",
    flavorText:
      "This Pokémon can pick up the scent of a Veluza just over 65 feet away and will hide itself in the sand.",
    nationalPokedexNumbers: [960],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/47.png",
      large: "https://images.pokemontcg.io/sv5/47_hires.png",
    },
    altArts: [
      {
        id: "sv5-47",
        number: "47",
        images: {
          small: "https://images.pokemontcg.io/sv5/47.png",
          large: "https://images.pokemontcg.io/sv5/47_hires.png",
        },
        flavorText:
          "This Pokémon can pick up the scent of a Veluza just over 65 feet away and will hide itself in the sand.",
      },
    ],
  },
  {
    id: "me4-25",
    name: "Wimpod",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Water"],
    attacks: [
      {
        name: "Gnaw",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Corkscrew Punch",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "25",
    flavorText:
      "It's nature's cleaner-it eats anything and everything, including garbage and rotten things. The ground near its nest is always clean.",
    nationalPokedexNumbers: [767],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-25/small",
      large: "https://images.scrydex.com/pokemon/me4-25/large",
    },
    altArts: [
      {
        id: "me4-25",
        number: "25",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-25/small",
          large: "https://images.scrydex.com/pokemon/me4-25/large",
        },
        flavorText:
          "It's nature's cleaner-it eats anything and everything, including garbage and rotten things. The ground near its nest is always clean.",
      },
    ],
  },
  {
    id: "sv9-38",
    name: "Wingull",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Pelipper"],
    attacks: [
      {
        name: "Flap",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "38",
    nationalPokedexNumbers: [278],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv9/38.png",
      large: "https://images.pokemontcg.io/sv9/38_hires.png",
    },
    altArts: [
      {
        id: "sv9-38",
        number: "38",
        images: {
          small: "https://images.pokemontcg.io/sv9/38.png",
          large: "https://images.pokemontcg.io/sv9/38_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-22",
    name: "Wishiwashi",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "30",
    types: ["Water"],
    abilities: [
      {
        name: "Counterattack Grouping",
        text: "If your Wishiwashi or Wishiwashi ex is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if your Pokémon is Knocked Out), place 3 damage counters on the Attacking Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "22",
    nationalPokedexNumbers: [746],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-22/small",
      large: "https://images.scrydex.com/pokemon/me55-22/large",
    },
    altArts: [
      {
        id: "me55-22",
        number: "22",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-22/small",
          large: "https://images.scrydex.com/pokemon/me55-22/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-15",
    name: "Wo-Chien",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Grass"],
    attacks: [
      {
        name: "Hazardous Greed",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "If there are 3 or fewer cards in your deck, this attack also does 120 damage to 2 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Entangling Whip",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "Discard the top 3 cards of your deck.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "15",
    nationalPokedexNumbers: [1001],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/15.png",
      large: "https://images.pokemontcg.io/sv8/15_hires.png",
    },
    altArts: [
      {
        id: "sv8-15",
        number: "15",
        images: {
          small: "https://images.pokemontcg.io/sv8/15.png",
          large: "https://images.pokemontcg.io/sv8/15_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-36",
    name: "Woobat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Psychic"],
    evolvesTo: ["Swoobat"],
    attacks: [
      {
        name: "Heart Stamp",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "36",
    flavorText:
      "Its habitat is dark forests and caves. It emits ultrasonic waves from its nose to learn about its surroundings.",
    nationalPokedexNumbers: [527],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/36.png",
      large: "https://images.pokemontcg.io/rsv10pt5/36_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-36",
        number: "36",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/36.png",
          large: "https://images.pokemontcg.io/rsv10pt5/36_hires.png",
        },
        flavorText:
          "Its habitat is dark forests and caves. It emits ultrasonic waves from its nose to learn about its surroundings.",
      },
      {
        id: "rsv10pt5-119",
        number: "119",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/119.png",
          large: "https://images.pokemontcg.io/rsv10pt5/119_hires.png",
        },
        flavorText:
          "Its habitat is dark forests and caves. It emits ultrasonic waves from its nose to learn about its surroundings.",
      },
    ],
  },
  {
    id: "sv7-124",
    name: "Wooloo",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Dubwool"],
    attacks: [
      {
        name: "Knock Over",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "You may discard a Stadium in play.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "124",
    nationalPokedexNumbers: [831],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/124.png",
      large: "https://images.pokemontcg.io/sv7/124_hires.png",
    },
    altArts: [
      {
        id: "sv7-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/sv7/124.png",
          large: "https://images.pokemontcg.io/sv7/124_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "svp-155",
    name: "Wooper",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Water"],
    evolvesTo: ["Quagsire"],
    attacks: [
      {
        name: "Scoop Water",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Shuffle up to 3 Basic Water Energy cards from your discard pile into your deck.",
      },
      {
        name: "Headbutt",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "155",
    nationalPokedexNumbers: [194],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/155.png",
      large: "https://images.pokemontcg.io/svp/155_hires.png",
    },
    altArts: [
      {
        id: "svp-155",
        number: "155",
        images: {
          small: "https://images.pokemontcg.io/svp/155.png",
          large: "https://images.pokemontcg.io/svp/155_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-60",
    name: "Wugtrio ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "Tera", "ex"],
    hp: "250",
    types: ["Lightning"],
    evolvesFrom: "Wiglett",
    rules: [
      "As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
      "Tera: As long as this Pokémon is on your Bench, prevent all damage done to this Pokémon by attacks (both yours and your opponent's).",
    ],
    attacks: [
      {
        name: "Tricolor Pump",
        cost: ["Water"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard up to 3 Energy cards from your hand. This attack does 60 damage to 1 of your opponent's Pokémon for each Energy card you discarded in this way. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Numbing Hold",
        cost: ["Water", "Water"],
        convertedEnergyCost: 2,
        damage: "120",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "60",
    nationalPokedexNumbers: [961],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/60.png",
      large: "https://images.pokemontcg.io/sv5/60_hires.png",
    },
    altArts: [
      {
        id: "sv5-60",
        number: "60",
        images: {
          small: "https://images.pokemontcg.io/sv5/60.png",
          large: "https://images.pokemontcg.io/sv5/60_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv5-190",
        number: "190",
        images: {
          small: "https://images.pokemontcg.io/sv5/190.png",
          large: "https://images.pokemontcg.io/sv5/190_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-11",
    name: "Wurmple",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "60",
    types: ["Grass"],
    attacks: [
      {
        name: "Bug Bite",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    flavorText:
      "It loves to eat leaves. If it is attacked by a Starly, it will defend itself with its spiked rear.",
    nationalPokedexNumbers: [265],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-11/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-11/large",
    },
    altArts: [
      {
        id: "me2pt5-11",
        number: "11",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-11/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-11/large",
        },
        flavorText:
          "It loves to eat leaves. If it is attacked by a Starly, it will defend itself with its spiked rear.",
      },
    ],
  },
  {
    id: "me1-64",
    name: "Xerneas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Geo Gate",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for up to 3 Basic Psychic Pokémon and put them onto your Bench. Then, shuffle your deck.",
      },
      {
        name: "Bright Horns",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your next turn, this Pokémon can't use Bright Horns.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "64",
    nationalPokedexNumbers: [716],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/64.png",
      large: "https://images.pokemontcg.io/me1/64_hires.png",
    },
    altArts: [
      {
        id: "me1-64",
        number: "64",
        images: {
          small: "https://images.pokemontcg.io/me1/64.png",
          large: "https://images.pokemontcg.io/me1/64_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-42",
    name: "Xerneas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Geo Storm",
        cost: ["Psychic", "Psychic", "Psychic"],
        convertedEnergyCost: 3,
        damage: "30×",
        text: "This attack does 30 damage for each Psychic Energy attached to all of your Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "42",
    flavorText:
      "When the horns on its head shine in seven colors, it is said to be sharing everlasting life.",
    nationalPokedexNumbers: [716],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-42/small",
      large: "https://images.scrydex.com/pokemon/me4-42/large",
    },
    altArts: [
      {
        id: "me4-42",
        number: "42",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-42/small",
          large: "https://images.scrydex.com/pokemon/me4-42/large",
        },
        flavorText:
          "When the horns on its head shine in seven colors, it is said to be sharing everlasting life.",
      },
      {
        id: "me4-91",
        number: "91",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-91/small",
          large: "https://images.scrydex.com/pokemon/me4-91/large",
        },
        flavorText:
          "When the horns on its head shine in seven colors, it is said to be sharing everlasting life.",
      },
    ],
  },
  {
    id: "me55-76",
    name: "Xerneas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Psychic"],
    attacks: [
      {
        name: "Geonavigation",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        text: "Search your deck for up to 2 Stadium card, reveal them, and put them into your hand. Then, shuffle your deck.",
      },
      {
        name: "Aurora Horns",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "76",
    nationalPokedexNumbers: [716],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-76/small",
      large: "https://images.scrydex.com/pokemon/me55-76/large",
    },
    altArts: [
      {
        id: "me55-76",
        number: "76",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-76/small",
          large: "https://images.scrydex.com/pokemon/me55-76/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-88",
    name: "Xerneas",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Aurora Gain",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "Heal 30 damage from this Pokémon.",
      },
      {
        name: "Giga Impact",
        cost: ["Psychic", "Psychic", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "88",
    nationalPokedexNumbers: [716],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/88.png",
      large: "https://images.pokemontcg.io/sv8/88_hires.png",
    },
    altArts: [
      {
        id: "sv8-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/sv8/88.png",
          large: "https://images.pokemontcg.io/sv8/88_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-39",
    name: "Yamask",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Cofagrigus"],
    attacks: [
      {
        name: "Focused Wish",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "39",
    flavorText:
      "Each of them carries a mask that used to be its face when it was human. Sometimes they look at it and cry.",
    nationalPokedexNumbers: [562],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/39.png",
      large: "https://images.pokemontcg.io/rsv10pt5/39_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-39",
        number: "39",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/39.png",
          large: "https://images.pokemontcg.io/rsv10pt5/39_hires.png",
        },
        flavorText:
          "Each of them carries a mask that used to be its face when it was human. Sometimes they look at it and cry.",
      },
      {
        id: "rsv10pt5-122",
        number: "122",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/122.png",
          large: "https://images.pokemontcg.io/rsv10pt5/122_hires.png",
        },
        flavorText:
          "Each of them carries a mask that used to be its face when it was human. Sometimes they look at it and cry.",
      },
    ],
  },
  {
    id: "sv8-82",
    name: "Yamask",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Psychic"],
    evolvesTo: ["Cofagrigus"],
    attacks: [
      {
        name: "Mumble",
        cost: ["Psychic"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Petty Grudge",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Darkness",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "82",
    nationalPokedexNumbers: [562],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/82.png",
      large: "https://images.pokemontcg.io/sv8/82_hires.png",
    },
    altArts: [
      {
        id: "sv8-82",
        number: "82",
        images: {
          small: "https://images.pokemontcg.io/sv8/82.png",
          large: "https://images.pokemontcg.io/sv8/82_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-30",
    name: "Yamper",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Boltund"],
    attacks: [
      {
        name: "Play Rough",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "Flip a coin. If heads, this attack does 20 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "30",
    flavorText:
      "This gluttonous Pokémon only assists people with their work because it wants treats. As it runs, it crackles with electricity.",
    nationalPokedexNumbers: [835],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/30.png",
      large: "https://images.pokemontcg.io/me2/30_hires.png",
    },
    altArts: [
      {
        id: "me2-30",
        number: "30",
        images: {
          small: "https://images.pokemontcg.io/me2/30.png",
          large: "https://images.pokemontcg.io/me2/30_hires.png",
        },
        flavorText:
          "This gluttonous Pokémon only assists people with their work because it wants treats. As it runs, it crackles with electricity.",
      },
      {
        id: "me2-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/me2/99.png",
          large: "https://images.pokemontcg.io/me2/99_hires.png",
        },
        flavorText:
          "This gluttonous Pokémon only assists people with their work because it wants treats. As it runs, it crackles with electricity.",
      },
    ],
  },
  {
    id: "sv5-58",
    name: "Yamper",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Lightning"],
    evolvesTo: ["Boltund"],
    attacks: [
      {
        name: "Whimsy Tackle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "58",
    flavorText:
      "This Pokémon is very popular as a herding dog in the Galar region. As it runs, it generates electricity from the base of its tail.",
    nationalPokedexNumbers: [835],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/58.png",
      large: "https://images.pokemontcg.io/sv5/58_hires.png",
    },
    altArts: [
      {
        id: "sv5-58",
        number: "58",
        images: {
          small: "https://images.pokemontcg.io/sv5/58.png",
          large: "https://images.pokemontcg.io/sv5/58_hires.png",
        },
        flavorText:
          "This Pokémon is very popular as a herding dog in the Galar region. As it runs, it generates electricity from the base of its tail.",
      },
    ],
  },
  {
    id: "sv10-2",
    name: "Yanma",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Grass"],
    evolvesTo: ["Yanmega"],
    attacks: [
      {
        name: "Whirlwind",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Switch out your opponent's Active Pokémon to the Bench. (Your opponent chooses the new Active Pokémon.)",
      },
      {
        name: "Razor Wing",
        cost: ["Grass", "Colorless"],
        convertedEnergyCost: 2,
        damage: "30",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "2",
    nationalPokedexNumbers: [193],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/2.png",
      large: "https://images.pokemontcg.io/sv10/2_hires.png",
    },
    altArts: [
      {
        id: "sv10-2",
        number: "2",
        images: {
          small: "https://images.pokemontcg.io/sv10/2.png",
          large: "https://images.pokemontcg.io/sv10/2_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-183",
        number: "183",
        images: {
          small: "https://images.pokemontcg.io/sv10/183.png",
          large: "https://images.pokemontcg.io/sv10/183_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-3",
    name: "Yanmega ex",
    supertype: "Pokémon",
    subtypes: ["Stage 1", "ex"],
    hp: "280",
    types: ["Grass"],
    evolvesFrom: "Yanma",
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Buzzing Boost",
        text: "Once during your turn, when this Pokémon moves from your Bench to the Active Spot, you may search your deck for up to 3 Basic Grass Energy cards and attach them to this Pokémon. Then, shuffle your deck.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Jet Cyclone",
        cost: ["Grass", "Grass", "Grass", "Colorless"],
        convertedEnergyCost: 4,
        damage: "210",
        text: "Move 3 Energy from this Pokémon to 1 of your Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "3",
    nationalPokedexNumbers: [469],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/3.png",
      large: "https://images.pokemontcg.io/sv10/3_hires.png",
    },
    altArts: [
      {
        id: "sv10-3",
        number: "3",
        images: {
          small: "https://images.pokemontcg.io/sv10/3.png",
          large: "https://images.pokemontcg.io/sv10/3_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-206",
        number: "206",
        images: {
          small: "https://images.pokemontcg.io/sv10/206.png",
          large: "https://images.pokemontcg.io/sv10/206_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-228",
        number: "228",
        images: {
          small: "https://images.pokemontcg.io/sv10/228.png",
          large: "https://images.pokemontcg.io/sv10/228_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-109",
    name: "Yungoos",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Gumshoos"],
    attacks: [
      {
        name: "Collect",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Draw a card.",
      },
      {
        name: "Gnaw",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "109",
    nationalPokedexNumbers: [734],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/109.png",
      large: "https://images.pokemontcg.io/me1/109_hires.png",
    },
    altArts: [
      {
        id: "me1-109",
        number: "109",
        images: {
          small: "https://images.pokemontcg.io/me1/109.png",
          large: "https://images.pokemontcg.io/me1/109_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me1-88",
    name: "Yveltal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Darkness"],
    attacks: [
      {
        name: "Clutch",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "During your opponent's next turn, the Defending Pokémon can't retreat.",
      },
      {
        name: "Dark Feather",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "88",
    nationalPokedexNumbers: [717],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me1/88.png",
      large: "https://images.pokemontcg.io/me1/88_hires.png",
    },
    altArts: [
      {
        id: "me1-88",
        number: "88",
        images: {
          small: "https://images.pokemontcg.io/me1/88.png",
          large: "https://images.pokemontcg.io/me1/88_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-100",
    name: "Yveltal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Darkness"],
    abilities: [
      {
        name: "Life-Locked",
        text: "Your opponent's Active Pokémon can't be healed.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Dark Cutter",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "100",
    nationalPokedexNumbers: [717],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-100/small",
      large: "https://images.scrydex.com/pokemon/me55-100/large",
    },
    altArts: [
      {
        id: "me55-100",
        number: "100",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-100/small",
          large: "https://images.scrydex.com/pokemon/me55-100/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-35",
    name: "Yveltal",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Darkness"],
    attacks: [
      {
        name: "Corrosive Winds",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Put 2 damage counters on each of your opponent's Pokémon that has any damage counters on it.",
      },
      {
        name: "Destructive Beam",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "Flip a coin. If heads, discard an Energy from your opponent's Active Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "35",
    nationalPokedexNumbers: [717],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/35.png",
      large: "https://images.pokemontcg.io/sv6pt5/35_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-35",
        number: "35",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/35.png",
          large: "https://images.pokemontcg.io/sv6pt5/35_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-53",
    name: "Yveltal ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "210",
    types: ["Darkness"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Soul Destroyer",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Knock Out each of your opponent's Pokémon that has 50 HP or less remaining.",
      },
      {
        name: "Dark Strike",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "210",
        text: "During your next turn, this Pokémon can't use Dark Strike.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "53",
    nationalPokedexNumbers: [717],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-53/small",
      large: "https://images.scrydex.com/pokemon/me3-53/large",
    },
    altArts: [
      {
        id: "me3-53",
        number: "53",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-53/small",
          large: "https://images.scrydex.com/pokemon/me3-53/large",
        },
        flavorText: "",
      },
      {
        id: "me3-105",
        number: "105",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-105/small",
          large: "https://images.scrydex.com/pokemon/me3-105/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-45",
    name: "Zacian",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Psychic"],
    attacks: [
      {
        name: "Limit Break",
        cost: ["Psychic", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50+",
        text: "If your opponent has 3 or fewer Prize cards remaining, this attack does 90 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Metal",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "45",
    flavorText:
      "Able to cut down anything with a single strike, it became known as the Fairy King's Sword, and it inspired awe in friend and foe alike.",
    nationalPokedexNumbers: [888],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/45.png",
      large: "https://images.pokemontcg.io/me2/45_hires.png",
    },
    altArts: [
      {
        id: "me2-45",
        number: "45",
        images: {
          small: "https://images.pokemontcg.io/me2/45.png",
          large: "https://images.pokemontcg.io/me2/45_hires.png",
        },
        flavorText:
          "Able to cut down anything with a single strike, it became known as the Fairy King's Sword, and it inspired awe in friend and foe alike.",
      },
      {
        id: "me2-100",
        number: "100",
        images: {
          small: "https://images.pokemontcg.io/me2/100.png",
          large: "https://images.pokemontcg.io/me2/100_hires.png",
        },
        flavorText:
          "Able to cut down anything with a single strike, it became known as the Fairy King's Sword, and it inspired awe in friend and foe alike.",
      },
    ],
  },
  {
    id: "me55-106",
    name: "Zacian",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Hardened Blade",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "20+",
        text: "If this Pokémon has a Pokémon Tool attached, this attack does 40 more damage.",
      },
      {
        name: "Slashing Strike",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "During your next turn, this Pokémon can't use Slashing Strike",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "106",
    nationalPokedexNumbers: [888],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-106/small",
      large: "https://images.scrydex.com/pokemon/me55-106/large",
    },
    altArts: [
      {
        id: "me55-106",
        number: "106",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-106/small",
          large: "https://images.scrydex.com/pokemon/me55-106/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55c-138",
    name: "Zacian V",
    supertype: "Pokémon",
    subtypes: ["Basic", "V"],
    hp: "220",
    types: ["Metal"],
    rules: [
      "When your Pokémon V is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    abilities: [
      {
        name: "Intrepid Sword",
        text: "Once during your turn, you may look at the top 3 cards of your deck and attach any number of Metal Energy cards you find there to this Pokémon. Put the other cards into your hand. If you use this Ability, your turn ends.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Brave Blade",
        cost: ["Metal", "Metal", "Metal"],
        convertedEnergyCost: 3,
        damage: "230",
        text: "During your next turn, this Pokémon can't attack.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "138",
    nationalPokedexNumbers: [888],
    regulationMark: "D",
    images: {
      small: "https://images.scrydex.com/pokemon/me55c-138/small",
      large: "https://images.scrydex.com/pokemon/me55c-138/large",
    },
    altArts: [
      {
        id: "me55c-138",
        number: "138",
        images: {
          small: "https://images.scrydex.com/pokemon/me55c-138/small",
          large: "https://images.scrydex.com/pokemon/me55c-138/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-107",
    name: "Zamazenta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Fend Off",
        cost: ["Metal"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Before doing damage, discard all Pokémon Tools from your opponent's Active Pokémon.",
      },
      {
        name: "Shield Press",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "During your opponent's next turn, this Pokémon takes 50 less damage from attacks (after applying Weakness and Resistance).",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "107",
    nationalPokedexNumbers: [889],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-107/small",
      large: "https://images.scrydex.com/pokemon/me55-107/large",
    },
    altArts: [
      {
        id: "me55-107",
        number: "107",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-107/small",
          large: "https://images.scrydex.com/pokemon/me55-107/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-146",
    name: "Zamazenta",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Metal"],
    attacks: [
      {
        name: "Strong Bash",
        cost: ["Metal", "Metal", "Colorless"],
        convertedEnergyCost: 3,
        damage: "70",
        text: "During your opponent's next turn, if this Pokémon is damaged by an attack (even if this Pokémon is Knocked Out), put damage counters on the Attacking Pokémon equal to the damage done to this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Grass",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "146",
    nationalPokedexNumbers: [889],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/146.png",
      large: "https://images.pokemontcg.io/sv10/146_hires.png",
    },
    altArts: [
      {
        id: "sv10-146",
        number: "146",
        images: {
          small: "https://images.pokemontcg.io/sv10/146.png",
          large: "https://images.pokemontcg.io/sv10/146_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv10-201",
        number: "201",
        images: {
          small: "https://images.pokemontcg.io/sv10/201.png",
          large: "https://images.pokemontcg.io/sv10/201_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-149",
    name: "Zangoose",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "90",
    types: ["Colorless"],
    attacks: [
      {
        name: "Fury Cutter",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10+",
        text: "Flip 3 coins. If 1 of them is heads, this attack does 20 more damage. If 2 of them are heads, this attack does 50 more damage. If all of them are heads, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "149",
    nationalPokedexNumbers: [335],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/149.png",
      large: "https://images.pokemontcg.io/sv8/149_hires.png",
    },
    altArts: [
      {
        id: "sv8-149",
        number: "149",
        images: {
          small: "https://images.pokemontcg.io/sv8/149.png",
          large: "https://images.pokemontcg.io/sv8/149_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-167",
    name: "Zangoose ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "200",
    types: ["Colorless"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Spike Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Draw 2 cards.",
      },
      {
        name: "Wild Scissors",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "180",
        text: "This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "167",
    nationalPokedexNumbers: [335],
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-167/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-167/large",
    },
    altArts: [
      {
        id: "me2pt5-167",
        number: "167",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-167/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-167/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-55",
    name: "Zapdos",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    abilities: [
      {
        name: "Flash-Pop Flapping",
        text: "Once during your turn, if you have Moltres and Articuno in play, you may use this Ability. Attach a Basic Lightning Energy card from your hand to this Pokémon.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Thundering Lightning",
        cost: ["Lightning", "Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 4,
        damage: "210",
        text: "This Pokémon also does 60 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    nationalPokedexNumbers: [145],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-55/small",
      large: "https://images.scrydex.com/pokemon/me55-55/large",
    },
    altArts: [
      {
        id: "me55-55",
        number: "55",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-55/small",
          large: "https://images.scrydex.com/pokemon/me55-55/large",
        },
        flavorText: "",
      },
      {
        id: "me55-133",
        number: "133",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-133/small",
          large: "https://images.scrydex.com/pokemon/me55-133/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-65",
    name: "Zapdos",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Thunder Wave",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Thunderbolt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "190",
        text: "Discard all Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "65",
    flavorText:
      "This Pokémon has complete control over electricity. There are tales of Zapdos nesting in the dark depths of pitch-black thunderclouds.",
    nationalPokedexNumbers: [145],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/65.png",
      large: "https://images.pokemontcg.io/sv6/65_hires.png",
    },
    altArts: [
      {
        id: "sv6-65",
        number: "65",
        images: {
          small: "https://images.pokemontcg.io/sv6/65.png",
          large: "https://images.pokemontcg.io/sv6/65_hires.png",
        },
        flavorText:
          "This Pokémon has complete control over electricity. There are tales of Zapdos nesting in the dark depths of pitch-black thunderclouds.",
      },
    ],
  },
  {
    id: "svp-157",
    name: "Zapdos",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Lightning"],
    attacks: [
      {
        name: "Follow-Up Bolt",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 10 more damage for each damage counter on your opponent's Active Pokémon.",
      },
      {
        name: "Drill Peck",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "157",
    nationalPokedexNumbers: [145],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/svp/157.png",
      large: "https://images.pokemontcg.io/svp/157_hires.png",
    },
    altArts: [
      {
        id: "svp-157",
        number: "157",
        images: {
          small: "https://images.pokemontcg.io/svp/157.png",
          large: "https://images.pokemontcg.io/svp/157_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-56",
    name: "Zarude",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Darkness"],
    attacks: [
      {
        name: "Overhead Throw",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This attack also does 30 damage to 1 of your Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
      {
        name: "Shadowy Whip",
        cost: ["Darkness", "Darkness", "Darkness"],
        convertedEnergyCost: 3,
        damage: "100+",
        text: "If your Benched Pokémon have any Shadowy Darkness Energy attached, this attack does 70 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "56",
    flavorText:
      "Within dense forests, this Pokemon lives in a pack with others of its kind. It's incredibly aggressive, and the other Pokemon of the forest fear it.",
    nationalPokedexNumbers: [893],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-56/small",
      large: "https://images.scrydex.com/pokemon/me5-56/large",
    },
    altArts: [
      {
        id: "me5-56",
        number: "56",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-56/small",
          large: "https://images.scrydex.com/pokemon/me5-56/large",
        },
        flavorText:
          "Within dense forests, this Pokemon lives in a pack with others of its kind. It's incredibly aggressive, and the other Pokemon of the forest fear it.",
      },
    ],
  },
  {
    id: "sv8-11",
    name: "Zarude",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Grass"],
    attacks: [
      {
        name: "Leaf Drain",
        cost: ["Grass"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Heal 20 damage from this Pokémon.",
      },
      {
        name: "Jungle Whip",
        cost: ["Grass", "Grass", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "You may put all Energy attached to this Pokémon into your hand to have this attack do 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fire",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "11",
    nationalPokedexNumbers: [893],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/11.png",
      large: "https://images.pokemontcg.io/sv8/11_hires.png",
    },
    altArts: [
      {
        id: "sv8-11",
        number: "11",
        images: {
          small: "https://images.pokemontcg.io/sv8/11.png",
          large: "https://images.pokemontcg.io/sv8/11_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-32",
    name: "Zebstrika",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Lightning"],
    evolvesFrom: "Blitzle",
    attacks: [
      {
        name: "Smash Kick",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Electrobullet",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "100",
        text: "This attack also does 30 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    flavorText:
      "They have lightning-like movements. When Zebstrika run at full speed, the sound of thunder reverberates.",
    nationalPokedexNumbers: [523],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/32.png",
      large: "https://images.pokemontcg.io/rsv10pt5/32_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/32.png",
          large: "https://images.pokemontcg.io/rsv10pt5/32_hires.png",
        },
        flavorText:
          "They have lightning-like movements. When Zebstrika run at full speed, the sound of thunder reverberates.",
      },
      {
        id: "rsv10pt5-115",
        number: "115",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/115.png",
          large: "https://images.pokemontcg.io/rsv10pt5/115_hires.png",
        },
        flavorText:
          "They have lightning-like movements. When Zebstrika run at full speed, the sound of thunder reverberates.",
      },
    ],
  },
  {
    id: "sv8-63",
    name: "Zebstrika",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "130",
    types: ["Lightning"],
    evolvesFrom: "Blitzle",
    attacks: [
      {
        name: "Kick",
        cost: ["Lightning"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "",
      },
      {
        name: "Mach Bolt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "63",
    nationalPokedexNumbers: [523],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/63.png",
      large: "https://images.pokemontcg.io/sv8/63_hires.png",
    },
    altArts: [
      {
        id: "sv8-63",
        number: "63",
        images: {
          small: "https://images.pokemontcg.io/sv8/63.png",
          large: "https://images.pokemontcg.io/sv8/63_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-56",
    name: "Zekrom",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "130",
    types: ["Lightning"],
    attacks: [
      {
        name: "Slash",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
      },
      {
        name: "Nitro Thunder",
        cost: ["Lightning", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "80+",
        text: "If this Pokémon has any Fire Energy attaches, this attack does 80 more damage.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "56",
    nationalPokedexNumbers: [644],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-56/small",
      large: "https://images.scrydex.com/pokemon/me55-56/large",
    },
    altArts: [
      {
        id: "me55-56",
        number: "56",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-56/small",
          large: "https://images.scrydex.com/pokemon/me55-56/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-34",
    name: "Zekrom ex",
    supertype: "Pokémon",
    subtypes: ["Basic", "ex"],
    hp: "230",
    types: ["Lightning"],
    rules: [
      "Pokémon ex rule: When your Pokémon ex is Knocked Out, your opponent takes 2 Prize cards.",
    ],
    attacks: [
      {
        name: "Slash",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "",
      },
      {
        name: "Voltage Burst",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "130+",
        text: "This attack does 50 more damage for each Prize card your opponent has taken. This Pokémon also does 30 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "34",
    nationalPokedexNumbers: [644],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/34.png",
      large: "https://images.pokemontcg.io/zsv10pt5/34_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-34",
        number: "34",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/34.png",
          large: "https://images.pokemontcg.io/zsv10pt5/34_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-158",
        number: "158",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/158.png",
          large: "https://images.pokemontcg.io/zsv10pt5/158_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/166.png",
          large: "https://images.pokemontcg.io/zsv10pt5/166_hires.png",
        },
        flavorText: "",
      },
      {
        id: "zsv10pt5-172",
        number: "172",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/172.png",
          large: "https://images.pokemontcg.io/zsv10pt5/172_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me55-57",
    name: "Zeraora",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "110",
    types: ["Lightning"],
    attacks: [
      {
        name: "Rapid Draw",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Draw a card.",
      },
      {
        name: "Electrobullet",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
        text: "This attack also does 20 damage to 1 of your opponent's Benched Pokémon. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    nationalPokedexNumbers: [807],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-57/small",
      large: "https://images.scrydex.com/pokemon/me55-57/large",
    },
    altArts: [
      {
        id: "me55-57",
        number: "57",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-57/small",
          large: "https://images.scrydex.com/pokemon/me55-57/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv10-78",
    name: "Zeraora",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "100",
    types: ["Lightning"],
    attacks: [
      {
        name: "Scratch",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "",
      },
      {
        name: "Thunder Raid",
        cost: ["Lightning", "Lightning", "Lightning"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Discard all Energy from this Pokémon, and this attack does 210 damage to 1 of your opponent's Benched Pokémon ex. (Don't apply Weakness and Resistance for Benched Pokémon.)",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "78",
    nationalPokedexNumbers: [807],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv10/78.png",
      large: "https://images.pokemontcg.io/sv10/78_hires.png",
    },
    altArts: [
      {
        id: "sv10-78",
        number: "78",
        images: {
          small: "https://images.pokemontcg.io/sv10/78.png",
          large: "https://images.pokemontcg.io/sv10/78_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-57",
    name: "Zeraora",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Shocking Knuckle",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "20",
        text: "Flip a coin. If heads, your opponent's Active Pokémon is now Paralyzed.",
      },
      {
        name: "Strong Volt",
        cost: ["Lightning", "Lightning", "Colorless"],
        convertedEnergyCost: 3,
        damage: "120",
        text: "Discard an Energy from this Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "57",
    flavorText:
      "It runs as fast as lightning strikes, shredding its opponents with its high-voltage claws.",
    nationalPokedexNumbers: [807],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/57.png",
      large: "https://images.pokemontcg.io/sv5/57_hires.png",
    },
    altArts: [
      {
        id: "sv5-57",
        number: "57",
        images: {
          small: "https://images.pokemontcg.io/sv5/57.png",
          large: "https://images.pokemontcg.io/sv5/57_hires.png",
        },
        flavorText:
          "It runs as fast as lightning strikes, shredding its opponents with its high-voltage claws.",
      },
    ],
  },
  {
    id: "sv7-55",
    name: "Zeraora",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "120",
    types: ["Lightning"],
    attacks: [
      {
        name: "Combat Thunder",
        cost: ["Lightning", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20+",
        text: "This attack does 20 more damage for each of your opponent's Benched Pokémon.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "55",
    nationalPokedexNumbers: [807],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv7/55.png",
      large: "https://images.pokemontcg.io/sv7/55_hires.png",
    },
    altArts: [
      {
        id: "sv7-55",
        number: "55",
        images: {
          small: "https://images.pokemontcg.io/sv7/55.png",
          large: "https://images.pokemontcg.io/sv7/55_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv7-151",
        number: "151",
        images: {
          small: "https://images.pokemontcg.io/sv7/151.png",
          large: "https://images.pokemontcg.io/sv7/151_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2-81",
    name: "Zigzagoon",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Colorless"],
    evolvesTo: ["Linoone"],
    attacks: [
      {
        name: "Surprise Attack",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "Flip a coin. If tails, this attack does nothing.",
      },
    ],
    weaknesses: [
      {
        type: "Fighting",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "81",
    flavorText:
      "A Pokémon with abundant curiosity. It shows an interest in everything, so it always zigzags.",
    nationalPokedexNumbers: [263],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/me2/81.png",
      large: "https://images.pokemontcg.io/me2/81_hires.png",
    },
    altArts: [
      {
        id: "me2-81",
        number: "81",
        images: {
          small: "https://images.pokemontcg.io/me2/81.png",
          large: "https://images.pokemontcg.io/me2/81_hires.png",
        },
        flavorText:
          "A Pokémon with abundant curiosity. It shows an interest in everything, so it always zigzags.",
      },
    ],
  },
  {
    id: "rsv10pt5-62",
    name: "Zoroark",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Zorua",
    attacks: [
      {
        name: "Mind Jack",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30×",
        text: "This attack does 30 damage for each of your opponent's Benched Pokémon.",
      },
      {
        name: "Foul Play",
        cost: ["Colorless", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "",
        text: "Choose 1 of your opponent's Active Pokémon's attacks and use it as this attack.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "62",
    flavorText:
      "Bonds between these Pokémon are very strong. It protects the safety of its pack by tricking its opponents.",
    nationalPokedexNumbers: [571],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/62.png",
      large: "https://images.pokemontcg.io/rsv10pt5/62_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-62",
        number: "62",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/62.png",
          large: "https://images.pokemontcg.io/rsv10pt5/62_hires.png",
        },
        flavorText:
          "Bonds between these Pokémon are very strong. It protects the safety of its pack by tricking its opponents.",
      },
      {
        id: "rsv10pt5-143",
        number: "143",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/143.png",
          large: "https://images.pokemontcg.io/rsv10pt5/143_hires.png",
        },
        flavorText:
          "Bonds between these Pokémon are very strong. It protects the safety of its pack by tricking its opponents.",
      },
    ],
  },
  {
    id: "me55-96",
    name: "Zoroark",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    abilities: [
      {
        name: "Nighttime Byway",
        text: "As long as this Pokémon is on your Bench, your Active Pokémon's Retreat Cost is 2 less.",
        type: "Ability",
      },
    ],
    attacks: [
      {
        name: "Slashing Claw",
        cost: ["Darkness", "Darkness", "Colorless"],
        convertedEnergyCost: 3,
        damage: "90",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "96",
    nationalPokedexNumbers: [571],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-96/small",
      large: "https://images.scrydex.com/pokemon/me55-96/large",
    },
    altArts: [
      {
        id: "me55-96",
        number: "96",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-96/small",
          large: "https://images.scrydex.com/pokemon/me55-96/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-32",
    name: "Zoroark",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "120",
    types: ["Darkness"],
    evolvesFrom: "Zorua",
    attacks: [
      {
        name: "Illusory Hijacking",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "60×",
        text: "This attack does 60 damage for each of your opponent's Pokémon ex and Pokémon V in play.",
      },
      {
        name: "Claw Slash",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "110",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "32",
    nationalPokedexNumbers: [571],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/32.png",
      large: "https://images.pokemontcg.io/sv6pt5/32_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-32",
        number: "32",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/32.png",
          large: "https://images.pokemontcg.io/sv6pt5/32_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-61",
    name: "Zorua",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Zoroark"],
    attacks: [
      {
        name: "Take Down",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "30",
        text: "This Pokémon also does 10 damage to itself.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "61",
    flavorText:
      "It changes into the forms of others to surprise them. Apparently, it often transforms into a silent child.",
    nationalPokedexNumbers: [570],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/61.png",
      large: "https://images.pokemontcg.io/rsv10pt5/61_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-61",
        number: "61",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/61.png",
          large: "https://images.pokemontcg.io/rsv10pt5/61_hires.png",
        },
        flavorText:
          "It changes into the forms of others to surprise them. Apparently, it often transforms into a silent child.",
      },
      {
        id: "rsv10pt5-142",
        number: "142",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/142.png",
          large: "https://images.pokemontcg.io/rsv10pt5/142_hires.png",
        },
        flavorText:
          "It changes into the forms of others to surprise them. Apparently, it often transforms into a silent child.",
      },
    ],
  },
  {
    id: "me55-95",
    name: "Zorua",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    attacks: [
      {
        name: "Darkness Fang",
        cost: ["Darkness", "Darkness"],
        convertedEnergyCost: 2,
        damage: "40",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "95",
    nationalPokedexNumbers: [570],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-95/small",
      large: "https://images.scrydex.com/pokemon/me55-95/large",
    },
    altArts: [
      {
        id: "me55-95",
        number: "95",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-95/small",
          large: "https://images.scrydex.com/pokemon/me55-95/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-31",
    name: "Zorua",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "70",
    types: ["Darkness"],
    evolvesTo: ["Zoroark"],
    attacks: [
      {
        name: "Stampede",
        cost: ["Colorless"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
      {
        name: "Double Scratch",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "20×",
        text: "Flip 2 coins. This attack does 20 damage for each heads.",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "31",
    nationalPokedexNumbers: [570],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/31.png",
      large: "https://images.pokemontcg.io/sv6pt5/31_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-31",
        number: "31",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/31.png",
          large: "https://images.pokemontcg.io/sv6pt5/31_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv6pt5-75",
        number: "75",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/75.png",
          large: "https://images.pokemontcg.io/sv6pt5/75_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-49",
    name: "Zubat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "40",
    types: ["Darkness"],
    attacks: [
      {
        name: "Supersonic",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Your opponent's Active Pokémon is now Confused.",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    number: "49",
    flavorText:
      "It emits ultrasonic waves from its mouth to check its surroundings. Even in tight caves, Zubat flies around with skill.",
    nationalPokedexNumbers: [41],
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-49/small",
      large: "https://images.scrydex.com/pokemon/me4-49/large",
    },
    altArts: [
      {
        id: "me4-49",
        number: "49",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-49/small",
          large: "https://images.scrydex.com/pokemon/me4-49/large",
        },
        flavorText:
          "It emits ultrasonic waves from its mouth to check its surroundings. Even in tight caves, Zubat flies around with skill.",
      },
    ],
  },
  {
    id: "sv6pt5-27",
    name: "Zubat",
    supertype: "Pokémon",
    subtypes: ["Basic"],
    hp: "50",
    types: ["Darkness"],
    evolvesTo: ["Golbat"],
    attacks: [
      {
        name: "Lead",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Search your deck for a Supporter card, reveal it, and put it into your hand. Then, shuffle your deck.",
      },
      {
        name: "Darkness Fang",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "10",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Lightning",
        value: "×2",
      },
    ],
    resistances: [
      {
        type: "Fighting",
        value: "-30",
      },
    ],
    retreatCost: ["Colorless"],
    convertedRetreatCost: 1,
    number: "27",
    nationalPokedexNumbers: [41],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/27.png",
      large: "https://images.pokemontcg.io/sv6pt5/27_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-27",
        number: "27",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/27.png",
          large: "https://images.pokemontcg.io/sv6pt5/27_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-66",
    name: "Zweilous",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "110",
    types: ["Darkness"],
    evolvesFrom: "Deino",
    evolvesTo: ["Hydreigon"],
    attacks: [
      {
        name: "Double Hit",
        cost: ["Colorless", "Colorless"],
        convertedEnergyCost: 2,
        damage: "40×",
        text: "Flip 2 coins. This attack does 40 damage for each heads.",
      },
      {
        name: "Pitch-Black Fangs",
        cost: ["Darkness", "Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 4,
        damage: "100",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless", "Colorless"],
    convertedRetreatCost: 3,
    number: "66",
    flavorText:
      "After it has eaten up all the food in its territory, it moves to another area. Its two heads do not get along.",
    nationalPokedexNumbers: [634],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/66.png",
      large: "https://images.pokemontcg.io/rsv10pt5/66_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-66",
        number: "66",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/66.png",
          large: "https://images.pokemontcg.io/rsv10pt5/66_hires.png",
        },
        flavorText:
          "After it has eaten up all the food in its territory, it moves to another area. Its two heads do not get along.",
      },
      {
        id: "rsv10pt5-147",
        number: "147",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/147.png",
          large: "https://images.pokemontcg.io/rsv10pt5/147_hires.png",
        },
        flavorText:
          "After it has eaten up all the food in its territory, it moves to another area. Its two heads do not get along.",
      },
    ],
  },
  {
    id: "me55-98",
    name: "Zweilous",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Deino",
    attacks: [
      {
        name: "Bite",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "20",
      },
      {
        name: "Hammer In",
        cost: ["Darkness", "Colorless"],
        convertedEnergyCost: 2,
        damage: "50",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "98",
    nationalPokedexNumbers: [634],
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me55-98/small",
      large: "https://images.scrydex.com/pokemon/me55-98/large",
    },
    altArts: [
      {
        id: "me55-98",
        number: "98",
        images: {
          small: "https://images.scrydex.com/pokemon/me55-98/small",
          large: "https://images.scrydex.com/pokemon/me55-98/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-118",
    name: "Zweilous",
    supertype: "Pokémon",
    subtypes: ["Stage 1"],
    hp: "100",
    types: ["Darkness"],
    evolvesFrom: "Deino",
    evolvesTo: ["Hydreigon"],
    attacks: [
      {
        name: "Stomp Off",
        cost: ["Darkness"],
        convertedEnergyCost: 1,
        damage: "",
        text: "Discard the top 2 cards of your opponent's deck.",
      },
      {
        name: "Darkness Fang",
        cost: ["Darkness", "Colorless", "Colorless"],
        convertedEnergyCost: 3,
        damage: "60",
        text: "",
      },
    ],
    weaknesses: [
      {
        type: "Grass",
        value: "×2",
      },
    ],
    retreatCost: ["Colorless", "Colorless"],
    convertedRetreatCost: 2,
    number: "118",
    nationalPokedexNumbers: [634],
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/118.png",
      large: "https://images.pokemontcg.io/sv8/118_hires.png",
    },
    altArts: [
      {
        id: "sv8-118",
        number: "118",
        images: {
          small: "https://images.pokemontcg.io/sv8/118.png",
          large: "https://images.pokemontcg.io/sv8/118_hires.png",
        },
        flavorText: "",
      },
    ],
  },
];

allStandardLegalPokemon.forEach((pokemon) => {
  pokemon.name = pokemon.name.replace("Pokémon", "Pokemon");
  if (!pokemon.subtypes) pokemon.subtypes = [];

  pokemon.attacks?.forEach((attack) => {
    attack.name = attack.name?.replace("Pokémon", "Pokemon");
    attack.text = attack.text?.replace("Pokémon", "Pokemon");
  });

  pokemon.abilities?.forEach((ability) => {
    ability.name = ability.name?.replace("Pokémon", "Pokemon");
    ability.text = ability.text?.replace("Pokémon", "Pokemon");
  });
  if (!pokemon.rules || !pokemon?.rules[0].includes("Prize cards")) {
    pokemon.subtypes.push("1 Prizer");
  }
  if (!pokemon.retreatCost) pokemon.subtypes.push("Free Retreat");
  if (pokemon.abilities) pokemon.subtypes.push("Ability");
});

export default allStandardLegalPokemon;
